webpackJsonp([0],[
/* 0 */
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// this module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate
    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(8);

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
    && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' ||
                                           navigator.product === 'NativeScript' ||
                                           navigator.product === 'NS')) {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = merge(result[key], val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Function equal to merge with the difference being that no reference
 * to original objects is kept.
 *
 * @see merge
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function deepMerge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = deepMerge(result[key], val);
    } else if (typeof val === 'object') {
      result[key] = deepMerge({}, val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  deepMerge: deepMerge,
  extend: extend,
  trim: trim
};


/***/ }),
/* 2 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, setImmediate) {/*!
 * Vue.js v2.6.12
 * (c) 2014-2020 Evan You
 * Released under the MIT License.
 */
/*  */

var emptyObject = Object.freeze({});

// These helpers produce better VM code in JS engines due to their
// explicitness and function inlining.
function isUndef (v) {
  return v === undefined || v === null
}

function isDef (v) {
  return v !== undefined && v !== null
}

function isTrue (v) {
  return v === true
}

function isFalse (v) {
  return v === false
}

/**
 * Check if value is primitive.
 */
function isPrimitive (value) {
  return (
    typeof value === 'string' ||
    typeof value === 'number' ||
    // $flow-disable-line
    typeof value === 'symbol' ||
    typeof value === 'boolean'
  )
}

/**
 * Quick object check - this is primarily used to tell
 * Objects from primitive values when we know the value
 * is a JSON-compliant type.
 */
function isObject (obj) {
  return obj !== null && typeof obj === 'object'
}

/**
 * Get the raw type string of a value, e.g., [object Object].
 */
var _toString = Object.prototype.toString;

function toRawType (value) {
  return _toString.call(value).slice(8, -1)
}

/**
 * Strict object type check. Only returns true
 * for plain JavaScript objects.
 */
function isPlainObject (obj) {
  return _toString.call(obj) === '[object Object]'
}

function isRegExp (v) {
  return _toString.call(v) === '[object RegExp]'
}

/**
 * Check if val is a valid array index.
 */
function isValidArrayIndex (val) {
  var n = parseFloat(String(val));
  return n >= 0 && Math.floor(n) === n && isFinite(val)
}

function isPromise (val) {
  return (
    isDef(val) &&
    typeof val.then === 'function' &&
    typeof val.catch === 'function'
  )
}

/**
 * Convert a value to a string that is actually rendered.
 */
function toString (val) {
  return val == null
    ? ''
    : Array.isArray(val) || (isPlainObject(val) && val.toString === _toString)
      ? JSON.stringify(val, null, 2)
      : String(val)
}

/**
 * Convert an input value to a number for persistence.
 * If the conversion fails, return original string.
 */
function toNumber (val) {
  var n = parseFloat(val);
  return isNaN(n) ? val : n
}

/**
 * Make a map and return a function for checking if a key
 * is in that map.
 */
function makeMap (
  str,
  expectsLowerCase
) {
  var map = Object.create(null);
  var list = str.split(',');
  for (var i = 0; i < list.length; i++) {
    map[list[i]] = true;
  }
  return expectsLowerCase
    ? function (val) { return map[val.toLowerCase()]; }
    : function (val) { return map[val]; }
}

/**
 * Check if a tag is a built-in tag.
 */
var isBuiltInTag = makeMap('slot,component', true);

/**
 * Check if an attribute is a reserved attribute.
 */
var isReservedAttribute = makeMap('key,ref,slot,slot-scope,is');

/**
 * Remove an item from an array.
 */
function remove (arr, item) {
  if (arr.length) {
    var index = arr.indexOf(item);
    if (index > -1) {
      return arr.splice(index, 1)
    }
  }
}

/**
 * Check whether an object has the property.
 */
var hasOwnProperty = Object.prototype.hasOwnProperty;
function hasOwn (obj, key) {
  return hasOwnProperty.call(obj, key)
}

/**
 * Create a cached version of a pure function.
 */
function cached (fn) {
  var cache = Object.create(null);
  return (function cachedFn (str) {
    var hit = cache[str];
    return hit || (cache[str] = fn(str))
  })
}

/**
 * Camelize a hyphen-delimited string.
 */
var camelizeRE = /-(\w)/g;
var camelize = cached(function (str) {
  return str.replace(camelizeRE, function (_, c) { return c ? c.toUpperCase() : ''; })
});

/**
 * Capitalize a string.
 */
var capitalize = cached(function (str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
});

/**
 * Hyphenate a camelCase string.
 */
var hyphenateRE = /\B([A-Z])/g;
var hyphenate = cached(function (str) {
  return str.replace(hyphenateRE, '-$1').toLowerCase()
});

/**
 * Simple bind polyfill for environments that do not support it,
 * e.g., PhantomJS 1.x. Technically, we don't need this anymore
 * since native bind is now performant enough in most browsers.
 * But removing it would mean breaking code that was able to run in
 * PhantomJS 1.x, so this must be kept for backward compatibility.
 */

/* istanbul ignore next */
function polyfillBind (fn, ctx) {
  function boundFn (a) {
    var l = arguments.length;
    return l
      ? l > 1
        ? fn.apply(ctx, arguments)
        : fn.call(ctx, a)
      : fn.call(ctx)
  }

  boundFn._length = fn.length;
  return boundFn
}

function nativeBind (fn, ctx) {
  return fn.bind(ctx)
}

var bind = Function.prototype.bind
  ? nativeBind
  : polyfillBind;

/**
 * Convert an Array-like object to a real Array.
 */
function toArray (list, start) {
  start = start || 0;
  var i = list.length - start;
  var ret = new Array(i);
  while (i--) {
    ret[i] = list[i + start];
  }
  return ret
}

/**
 * Mix properties into target object.
 */
function extend (to, _from) {
  for (var key in _from) {
    to[key] = _from[key];
  }
  return to
}

/**
 * Merge an Array of Objects into a single Object.
 */
function toObject (arr) {
  var res = {};
  for (var i = 0; i < arr.length; i++) {
    if (arr[i]) {
      extend(res, arr[i]);
    }
  }
  return res
}

/* eslint-disable no-unused-vars */

/**
 * Perform no operation.
 * Stubbing args to make Flow happy without leaving useless transpiled code
 * with ...rest (https://flow.org/blog/2017/05/07/Strict-Function-Call-Arity/).
 */
function noop (a, b, c) {}

/**
 * Always return false.
 */
var no = function (a, b, c) { return false; };

/* eslint-enable no-unused-vars */

/**
 * Return the same value.
 */
var identity = function (_) { return _; };

/**
 * Generate a string containing static keys from compiler modules.
 */
function genStaticKeys (modules) {
  return modules.reduce(function (keys, m) {
    return keys.concat(m.staticKeys || [])
  }, []).join(',')
}

/**
 * Check if two values are loosely equal - that is,
 * if they are plain objects, do they have the same shape?
 */
function looseEqual (a, b) {
  if (a === b) { return true }
  var isObjectA = isObject(a);
  var isObjectB = isObject(b);
  if (isObjectA && isObjectB) {
    try {
      var isArrayA = Array.isArray(a);
      var isArrayB = Array.isArray(b);
      if (isArrayA && isArrayB) {
        return a.length === b.length && a.every(function (e, i) {
          return looseEqual(e, b[i])
        })
      } else if (a instanceof Date && b instanceof Date) {
        return a.getTime() === b.getTime()
      } else if (!isArrayA && !isArrayB) {
        var keysA = Object.keys(a);
        var keysB = Object.keys(b);
        return keysA.length === keysB.length && keysA.every(function (key) {
          return looseEqual(a[key], b[key])
        })
      } else {
        /* istanbul ignore next */
        return false
      }
    } catch (e) {
      /* istanbul ignore next */
      return false
    }
  } else if (!isObjectA && !isObjectB) {
    return String(a) === String(b)
  } else {
    return false
  }
}

/**
 * Return the first index at which a loosely equal value can be
 * found in the array (if value is a plain object, the array must
 * contain an object of the same shape), or -1 if it is not present.
 */
function looseIndexOf (arr, val) {
  for (var i = 0; i < arr.length; i++) {
    if (looseEqual(arr[i], val)) { return i }
  }
  return -1
}

/**
 * Ensure a function is called only once.
 */
function once (fn) {
  var called = false;
  return function () {
    if (!called) {
      called = true;
      fn.apply(this, arguments);
    }
  }
}

var SSR_ATTR = 'data-server-rendered';

var ASSET_TYPES = [
  'component',
  'directive',
  'filter'
];

var LIFECYCLE_HOOKS = [
  'beforeCreate',
  'created',
  'beforeMount',
  'mounted',
  'beforeUpdate',
  'updated',
  'beforeDestroy',
  'destroyed',
  'activated',
  'deactivated',
  'errorCaptured',
  'serverPrefetch'
];

/*  */



var config = ({
  /**
   * Option merge strategies (used in core/util/options)
   */
  // $flow-disable-line
  optionMergeStrategies: Object.create(null),

  /**
   * Whether to suppress warnings.
   */
  silent: false,

  /**
   * Show production mode tip message on boot?
   */
  productionTip: "production" !== 'production',

  /**
   * Whether to enable devtools
   */
  devtools: "production" !== 'production',

  /**
   * Whether to record perf
   */
  performance: false,

  /**
   * Error handler for watcher errors
   */
  errorHandler: null,

  /**
   * Warn handler for watcher warns
   */
  warnHandler: null,

  /**
   * Ignore certain custom elements
   */
  ignoredElements: [],

  /**
   * Custom user key aliases for v-on
   */
  // $flow-disable-line
  keyCodes: Object.create(null),

  /**
   * Check if a tag is reserved so that it cannot be registered as a
   * component. This is platform-dependent and may be overwritten.
   */
  isReservedTag: no,

  /**
   * Check if an attribute is reserved so that it cannot be used as a component
   * prop. This is platform-dependent and may be overwritten.
   */
  isReservedAttr: no,

  /**
   * Check if a tag is an unknown element.
   * Platform-dependent.
   */
  isUnknownElement: no,

  /**
   * Get the namespace of an element
   */
  getTagNamespace: noop,

  /**
   * Parse the real tag name for the specific platform.
   */
  parsePlatformTagName: identity,

  /**
   * Check if an attribute must be bound using property, e.g. value
   * Platform-dependent.
   */
  mustUseProp: no,

  /**
   * Perform updates asynchronously. Intended to be used by Vue Test Utils
   * This will significantly reduce performance if set to false.
   */
  async: true,

  /**
   * Exposed for legacy reasons
   */
  _lifecycleHooks: LIFECYCLE_HOOKS
});

/*  */

/**
 * unicode letters used for parsing html tags, component names and property paths.
 * using https://www.w3.org/TR/html53/semantics-scripting.html#potentialcustomelementname
 * skipping \u10000-\uEFFFF due to it freezing up PhantomJS
 */
var unicodeRegExp = /a-zA-Z\u00B7\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u037D\u037F-\u1FFF\u200C-\u200D\u203F-\u2040\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD/;

/**
 * Check if a string starts with $ or _
 */
function isReserved (str) {
  var c = (str + '').charCodeAt(0);
  return c === 0x24 || c === 0x5F
}

/**
 * Define a property.
 */
function def (obj, key, val, enumerable) {
  Object.defineProperty(obj, key, {
    value: val,
    enumerable: !!enumerable,
    writable: true,
    configurable: true
  });
}

/**
 * Parse simple path.
 */
var bailRE = new RegExp(("[^" + (unicodeRegExp.source) + ".$_\\d]"));
function parsePath (path) {
  if (bailRE.test(path)) {
    return
  }
  var segments = path.split('.');
  return function (obj) {
    for (var i = 0; i < segments.length; i++) {
      if (!obj) { return }
      obj = obj[segments[i]];
    }
    return obj
  }
}

/*  */

// can we use __proto__?
var hasProto = '__proto__' in {};

// Browser environment sniffing
var inBrowser = typeof window !== 'undefined';
var inWeex = typeof WXEnvironment !== 'undefined' && !!WXEnvironment.platform;
var weexPlatform = inWeex && WXEnvironment.platform.toLowerCase();
var UA = inBrowser && window.navigator.userAgent.toLowerCase();
var isIE = UA && /msie|trident/.test(UA);
var isIE9 = UA && UA.indexOf('msie 9.0') > 0;
var isEdge = UA && UA.indexOf('edge/') > 0;
var isAndroid = (UA && UA.indexOf('android') > 0) || (weexPlatform === 'android');
var isIOS = (UA && /iphone|ipad|ipod|ios/.test(UA)) || (weexPlatform === 'ios');
var isChrome = UA && /chrome\/\d+/.test(UA) && !isEdge;
var isPhantomJS = UA && /phantomjs/.test(UA);
var isFF = UA && UA.match(/firefox\/(\d+)/);

// Firefox has a "watch" function on Object.prototype...
var nativeWatch = ({}).watch;

var supportsPassive = false;
if (inBrowser) {
  try {
    var opts = {};
    Object.defineProperty(opts, 'passive', ({
      get: function get () {
        /* istanbul ignore next */
        supportsPassive = true;
      }
    })); // https://github.com/facebook/flow/issues/285
    window.addEventListener('test-passive', null, opts);
  } catch (e) {}
}

// this needs to be lazy-evaled because vue may be required before
// vue-server-renderer can set VUE_ENV
var _isServer;
var isServerRendering = function () {
  if (_isServer === undefined) {
    /* istanbul ignore if */
    if (!inBrowser && !inWeex && typeof global !== 'undefined') {
      // detect presence of vue-server-renderer and avoid
      // Webpack shimming the process
      _isServer = global['process'] && global['process'].env.VUE_ENV === 'server';
    } else {
      _isServer = false;
    }
  }
  return _isServer
};

// detect devtools
var devtools = inBrowser && window.__VUE_DEVTOOLS_GLOBAL_HOOK__;

/* istanbul ignore next */
function isNative (Ctor) {
  return typeof Ctor === 'function' && /native code/.test(Ctor.toString())
}

var hasSymbol =
  typeof Symbol !== 'undefined' && isNative(Symbol) &&
  typeof Reflect !== 'undefined' && isNative(Reflect.ownKeys);

var _Set;
/* istanbul ignore if */ // $flow-disable-line
if (typeof Set !== 'undefined' && isNative(Set)) {
  // use native Set when available.
  _Set = Set;
} else {
  // a non-standard Set polyfill that only works with primitive keys.
  _Set = /*@__PURE__*/(function () {
    function Set () {
      this.set = Object.create(null);
    }
    Set.prototype.has = function has (key) {
      return this.set[key] === true
    };
    Set.prototype.add = function add (key) {
      this.set[key] = true;
    };
    Set.prototype.clear = function clear () {
      this.set = Object.create(null);
    };

    return Set;
  }());
}

/*  */

var warn = noop;
var tip = noop;
var generateComponentTrace = (noop); // work around flow check
var formatComponentName = (noop);

if (false) {
  var hasConsole = typeof console !== 'undefined';
  var classifyRE = /(?:^|[-_])(\w)/g;
  var classify = function (str) { return str
    .replace(classifyRE, function (c) { return c.toUpperCase(); })
    .replace(/[-_]/g, ''); };

  warn = function (msg, vm) {
    var trace = vm ? generateComponentTrace(vm) : '';

    if (config.warnHandler) {
      config.warnHandler.call(null, msg, vm, trace);
    } else if (hasConsole && (!config.silent)) {
      console.error(("[Vue warn]: " + msg + trace));
    }
  };

  tip = function (msg, vm) {
    if (hasConsole && (!config.silent)) {
      console.warn("[Vue tip]: " + msg + (
        vm ? generateComponentTrace(vm) : ''
      ));
    }
  };

  formatComponentName = function (vm, includeFile) {
    if (vm.$root === vm) {
      return '<Root>'
    }
    var options = typeof vm === 'function' && vm.cid != null
      ? vm.options
      : vm._isVue
        ? vm.$options || vm.constructor.options
        : vm;
    var name = options.name || options._componentTag;
    var file = options.__file;
    if (!name && file) {
      var match = file.match(/([^/\\]+)\.vue$/);
      name = match && match[1];
    }

    return (
      (name ? ("<" + (classify(name)) + ">") : "<Anonymous>") +
      (file && includeFile !== false ? (" at " + file) : '')
    )
  };

  var repeat = function (str, n) {
    var res = '';
    while (n) {
      if (n % 2 === 1) { res += str; }
      if (n > 1) { str += str; }
      n >>= 1;
    }
    return res
  };

  generateComponentTrace = function (vm) {
    if (vm._isVue && vm.$parent) {
      var tree = [];
      var currentRecursiveSequence = 0;
      while (vm) {
        if (tree.length > 0) {
          var last = tree[tree.length - 1];
          if (last.constructor === vm.constructor) {
            currentRecursiveSequence++;
            vm = vm.$parent;
            continue
          } else if (currentRecursiveSequence > 0) {
            tree[tree.length - 1] = [last, currentRecursiveSequence];
            currentRecursiveSequence = 0;
          }
        }
        tree.push(vm);
        vm = vm.$parent;
      }
      return '\n\nfound in\n\n' + tree
        .map(function (vm, i) { return ("" + (i === 0 ? '---> ' : repeat(' ', 5 + i * 2)) + (Array.isArray(vm)
            ? ((formatComponentName(vm[0])) + "... (" + (vm[1]) + " recursive calls)")
            : formatComponentName(vm))); })
        .join('\n')
    } else {
      return ("\n\n(found in " + (formatComponentName(vm)) + ")")
    }
  };
}

/*  */

var uid = 0;

/**
 * A dep is an observable that can have multiple
 * directives subscribing to it.
 */
var Dep = function Dep () {
  this.id = uid++;
  this.subs = [];
};

Dep.prototype.addSub = function addSub (sub) {
  this.subs.push(sub);
};

Dep.prototype.removeSub = function removeSub (sub) {
  remove(this.subs, sub);
};

Dep.prototype.depend = function depend () {
  if (Dep.target) {
    Dep.target.addDep(this);
  }
};

Dep.prototype.notify = function notify () {
  // stabilize the subscriber list first
  var subs = this.subs.slice();
  if (false) {
    // subs aren't sorted in scheduler if not running async
    // we need to sort them now to make sure they fire in correct
    // order
    subs.sort(function (a, b) { return a.id - b.id; });
  }
  for (var i = 0, l = subs.length; i < l; i++) {
    subs[i].update();
  }
};

// The current target watcher being evaluated.
// This is globally unique because only one watcher
// can be evaluated at a time.
Dep.target = null;
var targetStack = [];

function pushTarget (target) {
  targetStack.push(target);
  Dep.target = target;
}

function popTarget () {
  targetStack.pop();
  Dep.target = targetStack[targetStack.length - 1];
}

/*  */

var VNode = function VNode (
  tag,
  data,
  children,
  text,
  elm,
  context,
  componentOptions,
  asyncFactory
) {
  this.tag = tag;
  this.data = data;
  this.children = children;
  this.text = text;
  this.elm = elm;
  this.ns = undefined;
  this.context = context;
  this.fnContext = undefined;
  this.fnOptions = undefined;
  this.fnScopeId = undefined;
  this.key = data && data.key;
  this.componentOptions = componentOptions;
  this.componentInstance = undefined;
  this.parent = undefined;
  this.raw = false;
  this.isStatic = false;
  this.isRootInsert = true;
  this.isComment = false;
  this.isCloned = false;
  this.isOnce = false;
  this.asyncFactory = asyncFactory;
  this.asyncMeta = undefined;
  this.isAsyncPlaceholder = false;
};

var prototypeAccessors = { child: { configurable: true } };

// DEPRECATED: alias for componentInstance for backwards compat.
/* istanbul ignore next */
prototypeAccessors.child.get = function () {
  return this.componentInstance
};

Object.defineProperties( VNode.prototype, prototypeAccessors );

var createEmptyVNode = function (text) {
  if ( text === void 0 ) text = '';

  var node = new VNode();
  node.text = text;
  node.isComment = true;
  return node
};

function createTextVNode (val) {
  return new VNode(undefined, undefined, undefined, String(val))
}

// optimized shallow clone
// used for static nodes and slot nodes because they may be reused across
// multiple renders, cloning them avoids errors when DOM manipulations rely
// on their elm reference.
function cloneVNode (vnode) {
  var cloned = new VNode(
    vnode.tag,
    vnode.data,
    // #7975
    // clone children array to avoid mutating original in case of cloning
    // a child.
    vnode.children && vnode.children.slice(),
    vnode.text,
    vnode.elm,
    vnode.context,
    vnode.componentOptions,
    vnode.asyncFactory
  );
  cloned.ns = vnode.ns;
  cloned.isStatic = vnode.isStatic;
  cloned.key = vnode.key;
  cloned.isComment = vnode.isComment;
  cloned.fnContext = vnode.fnContext;
  cloned.fnOptions = vnode.fnOptions;
  cloned.fnScopeId = vnode.fnScopeId;
  cloned.asyncMeta = vnode.asyncMeta;
  cloned.isCloned = true;
  return cloned
}

/*
 * not type checking this file because flow doesn't play well with
 * dynamically accessing methods on Array prototype
 */

var arrayProto = Array.prototype;
var arrayMethods = Object.create(arrayProto);

var methodsToPatch = [
  'push',
  'pop',
  'shift',
  'unshift',
  'splice',
  'sort',
  'reverse'
];

/**
 * Intercept mutating methods and emit events
 */
methodsToPatch.forEach(function (method) {
  // cache original method
  var original = arrayProto[method];
  def(arrayMethods, method, function mutator () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    var result = original.apply(this, args);
    var ob = this.__ob__;
    var inserted;
    switch (method) {
      case 'push':
      case 'unshift':
        inserted = args;
        break
      case 'splice':
        inserted = args.slice(2);
        break
    }
    if (inserted) { ob.observeArray(inserted); }
    // notify change
    ob.dep.notify();
    return result
  });
});

/*  */

var arrayKeys = Object.getOwnPropertyNames(arrayMethods);

/**
 * In some cases we may want to disable observation inside a component's
 * update computation.
 */
var shouldObserve = true;

function toggleObserving (value) {
  shouldObserve = value;
}

/**
 * Observer class that is attached to each observed
 * object. Once attached, the observer converts the target
 * object's property keys into getter/setters that
 * collect dependencies and dispatch updates.
 */
var Observer = function Observer (value) {
  this.value = value;
  this.dep = new Dep();
  this.vmCount = 0;
  def(value, '__ob__', this);
  if (Array.isArray(value)) {
    if (hasProto) {
      protoAugment(value, arrayMethods);
    } else {
      copyAugment(value, arrayMethods, arrayKeys);
    }
    this.observeArray(value);
  } else {
    this.walk(value);
  }
};

/**
 * Walk through all properties and convert them into
 * getter/setters. This method should only be called when
 * value type is Object.
 */
Observer.prototype.walk = function walk (obj) {
  var keys = Object.keys(obj);
  for (var i = 0; i < keys.length; i++) {
    defineReactive$$1(obj, keys[i]);
  }
};

/**
 * Observe a list of Array items.
 */
Observer.prototype.observeArray = function observeArray (items) {
  for (var i = 0, l = items.length; i < l; i++) {
    observe(items[i]);
  }
};

// helpers

/**
 * Augment a target Object or Array by intercepting
 * the prototype chain using __proto__
 */
function protoAugment (target, src) {
  /* eslint-disable no-proto */
  target.__proto__ = src;
  /* eslint-enable no-proto */
}

/**
 * Augment a target Object or Array by defining
 * hidden properties.
 */
/* istanbul ignore next */
function copyAugment (target, src, keys) {
  for (var i = 0, l = keys.length; i < l; i++) {
    var key = keys[i];
    def(target, key, src[key]);
  }
}

/**
 * Attempt to create an observer instance for a value,
 * returns the new observer if successfully observed,
 * or the existing observer if the value already has one.
 */
function observe (value, asRootData) {
  if (!isObject(value) || value instanceof VNode) {
    return
  }
  var ob;
  if (hasOwn(value, '__ob__') && value.__ob__ instanceof Observer) {
    ob = value.__ob__;
  } else if (
    shouldObserve &&
    !isServerRendering() &&
    (Array.isArray(value) || isPlainObject(value)) &&
    Object.isExtensible(value) &&
    !value._isVue
  ) {
    ob = new Observer(value);
  }
  if (asRootData && ob) {
    ob.vmCount++;
  }
  return ob
}

/**
 * Define a reactive property on an Object.
 */
function defineReactive$$1 (
  obj,
  key,
  val,
  customSetter,
  shallow
) {
  var dep = new Dep();

  var property = Object.getOwnPropertyDescriptor(obj, key);
  if (property && property.configurable === false) {
    return
  }

  // cater for pre-defined getter/setters
  var getter = property && property.get;
  var setter = property && property.set;
  if ((!getter || setter) && arguments.length === 2) {
    val = obj[key];
  }

  var childOb = !shallow && observe(val);
  Object.defineProperty(obj, key, {
    enumerable: true,
    configurable: true,
    get: function reactiveGetter () {
      var value = getter ? getter.call(obj) : val;
      if (Dep.target) {
        dep.depend();
        if (childOb) {
          childOb.dep.depend();
          if (Array.isArray(value)) {
            dependArray(value);
          }
        }
      }
      return value
    },
    set: function reactiveSetter (newVal) {
      var value = getter ? getter.call(obj) : val;
      /* eslint-disable no-self-compare */
      if (newVal === value || (newVal !== newVal && value !== value)) {
        return
      }
      /* eslint-enable no-self-compare */
      if (false) {
        customSetter();
      }
      // #7981: for accessor properties without setter
      if (getter && !setter) { return }
      if (setter) {
        setter.call(obj, newVal);
      } else {
        val = newVal;
      }
      childOb = !shallow && observe(newVal);
      dep.notify();
    }
  });
}

/**
 * Set a property on an object. Adds the new property and
 * triggers change notification if the property doesn't
 * already exist.
 */
function set (target, key, val) {
  if (false
  ) {
    warn(("Cannot set reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.length = Math.max(target.length, key);
    target.splice(key, 1, val);
    return val
  }
  if (key in target && !(key in Object.prototype)) {
    target[key] = val;
    return val
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid adding reactive properties to a Vue instance or its root $data ' +
      'at runtime - declare it upfront in the data option.'
    );
    return val
  }
  if (!ob) {
    target[key] = val;
    return val
  }
  defineReactive$$1(ob.value, key, val);
  ob.dep.notify();
  return val
}

/**
 * Delete a property and trigger change if necessary.
 */
function del (target, key) {
  if (false
  ) {
    warn(("Cannot delete reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.splice(key, 1);
    return
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid deleting properties on a Vue instance or its root $data ' +
      '- just set it to null.'
    );
    return
  }
  if (!hasOwn(target, key)) {
    return
  }
  delete target[key];
  if (!ob) {
    return
  }
  ob.dep.notify();
}

/**
 * Collect dependencies on array elements when the array is touched, since
 * we cannot intercept array element access like property getters.
 */
function dependArray (value) {
  for (var e = (void 0), i = 0, l = value.length; i < l; i++) {
    e = value[i];
    e && e.__ob__ && e.__ob__.dep.depend();
    if (Array.isArray(e)) {
      dependArray(e);
    }
  }
}

/*  */

/**
 * Option overwriting strategies are functions that handle
 * how to merge a parent option value and a child option
 * value into the final value.
 */
var strats = config.optionMergeStrategies;

/**
 * Options with restrictions
 */
if (false) {
  strats.el = strats.propsData = function (parent, child, vm, key) {
    if (!vm) {
      warn(
        "option \"" + key + "\" can only be used during instance " +
        'creation with the `new` keyword.'
      );
    }
    return defaultStrat(parent, child)
  };
}

/**
 * Helper that recursively merges two data objects together.
 */
function mergeData (to, from) {
  if (!from) { return to }
  var key, toVal, fromVal;

  var keys = hasSymbol
    ? Reflect.ownKeys(from)
    : Object.keys(from);

  for (var i = 0; i < keys.length; i++) {
    key = keys[i];
    // in case the object is already observed...
    if (key === '__ob__') { continue }
    toVal = to[key];
    fromVal = from[key];
    if (!hasOwn(to, key)) {
      set(to, key, fromVal);
    } else if (
      toVal !== fromVal &&
      isPlainObject(toVal) &&
      isPlainObject(fromVal)
    ) {
      mergeData(toVal, fromVal);
    }
  }
  return to
}

/**
 * Data
 */
function mergeDataOrFn (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    // in a Vue.extend merge, both should be functions
    if (!childVal) {
      return parentVal
    }
    if (!parentVal) {
      return childVal
    }
    // when parentVal & childVal are both present,
    // we need to return a function that returns the
    // merged result of both functions... no need to
    // check if parentVal is a function here because
    // it has to be a function to pass previous merges.
    return function mergedDataFn () {
      return mergeData(
        typeof childVal === 'function' ? childVal.call(this, this) : childVal,
        typeof parentVal === 'function' ? parentVal.call(this, this) : parentVal
      )
    }
  } else {
    return function mergedInstanceDataFn () {
      // instance merge
      var instanceData = typeof childVal === 'function'
        ? childVal.call(vm, vm)
        : childVal;
      var defaultData = typeof parentVal === 'function'
        ? parentVal.call(vm, vm)
        : parentVal;
      if (instanceData) {
        return mergeData(instanceData, defaultData)
      } else {
        return defaultData
      }
    }
  }
}

strats.data = function (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    if (childVal && typeof childVal !== 'function') {
      "production" !== 'production' && warn(
        'The "data" option should be a function ' +
        'that returns a per-instance value in component ' +
        'definitions.',
        vm
      );

      return parentVal
    }
    return mergeDataOrFn(parentVal, childVal)
  }

  return mergeDataOrFn(parentVal, childVal, vm)
};

/**
 * Hooks and props are merged as arrays.
 */
function mergeHook (
  parentVal,
  childVal
) {
  var res = childVal
    ? parentVal
      ? parentVal.concat(childVal)
      : Array.isArray(childVal)
        ? childVal
        : [childVal]
    : parentVal;
  return res
    ? dedupeHooks(res)
    : res
}

function dedupeHooks (hooks) {
  var res = [];
  for (var i = 0; i < hooks.length; i++) {
    if (res.indexOf(hooks[i]) === -1) {
      res.push(hooks[i]);
    }
  }
  return res
}

LIFECYCLE_HOOKS.forEach(function (hook) {
  strats[hook] = mergeHook;
});

/**
 * Assets
 *
 * When a vm is present (instance creation), we need to do
 * a three-way merge between constructor options, instance
 * options and parent options.
 */
function mergeAssets (
  parentVal,
  childVal,
  vm,
  key
) {
  var res = Object.create(parentVal || null);
  if (childVal) {
    "production" !== 'production' && assertObjectType(key, childVal, vm);
    return extend(res, childVal)
  } else {
    return res
  }
}

ASSET_TYPES.forEach(function (type) {
  strats[type + 's'] = mergeAssets;
});

/**
 * Watchers.
 *
 * Watchers hashes should not overwrite one
 * another, so we merge them as arrays.
 */
strats.watch = function (
  parentVal,
  childVal,
  vm,
  key
) {
  // work around Firefox's Object.prototype.watch...
  if (parentVal === nativeWatch) { parentVal = undefined; }
  if (childVal === nativeWatch) { childVal = undefined; }
  /* istanbul ignore if */
  if (!childVal) { return Object.create(parentVal || null) }
  if (false) {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = {};
  extend(ret, parentVal);
  for (var key$1 in childVal) {
    var parent = ret[key$1];
    var child = childVal[key$1];
    if (parent && !Array.isArray(parent)) {
      parent = [parent];
    }
    ret[key$1] = parent
      ? parent.concat(child)
      : Array.isArray(child) ? child : [child];
  }
  return ret
};

/**
 * Other object hashes.
 */
strats.props =
strats.methods =
strats.inject =
strats.computed = function (
  parentVal,
  childVal,
  vm,
  key
) {
  if (childVal && "production" !== 'production') {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = Object.create(null);
  extend(ret, parentVal);
  if (childVal) { extend(ret, childVal); }
  return ret
};
strats.provide = mergeDataOrFn;

/**
 * Default strategy.
 */
var defaultStrat = function (parentVal, childVal) {
  return childVal === undefined
    ? parentVal
    : childVal
};

/**
 * Validate component names
 */
function checkComponents (options) {
  for (var key in options.components) {
    validateComponentName(key);
  }
}

function validateComponentName (name) {
  if (!new RegExp(("^[a-zA-Z][\\-\\.0-9_" + (unicodeRegExp.source) + "]*$")).test(name)) {
    warn(
      'Invalid component name: "' + name + '". Component names ' +
      'should conform to valid custom element name in html5 specification.'
    );
  }
  if (isBuiltInTag(name) || config.isReservedTag(name)) {
    warn(
      'Do not use built-in or reserved HTML elements as component ' +
      'id: ' + name
    );
  }
}

/**
 * Ensure all props option syntax are normalized into the
 * Object-based format.
 */
function normalizeProps (options, vm) {
  var props = options.props;
  if (!props) { return }
  var res = {};
  var i, val, name;
  if (Array.isArray(props)) {
    i = props.length;
    while (i--) {
      val = props[i];
      if (typeof val === 'string') {
        name = camelize(val);
        res[name] = { type: null };
      } else if (false) {
        warn('props must be strings when using array syntax.');
      }
    }
  } else if (isPlainObject(props)) {
    for (var key in props) {
      val = props[key];
      name = camelize(key);
      res[name] = isPlainObject(val)
        ? val
        : { type: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"props\": expected an Array or an Object, " +
      "but got " + (toRawType(props)) + ".",
      vm
    );
  }
  options.props = res;
}

/**
 * Normalize all injections into Object-based format
 */
function normalizeInject (options, vm) {
  var inject = options.inject;
  if (!inject) { return }
  var normalized = options.inject = {};
  if (Array.isArray(inject)) {
    for (var i = 0; i < inject.length; i++) {
      normalized[inject[i]] = { from: inject[i] };
    }
  } else if (isPlainObject(inject)) {
    for (var key in inject) {
      var val = inject[key];
      normalized[key] = isPlainObject(val)
        ? extend({ from: key }, val)
        : { from: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"inject\": expected an Array or an Object, " +
      "but got " + (toRawType(inject)) + ".",
      vm
    );
  }
}

/**
 * Normalize raw function directives into object format.
 */
function normalizeDirectives (options) {
  var dirs = options.directives;
  if (dirs) {
    for (var key in dirs) {
      var def$$1 = dirs[key];
      if (typeof def$$1 === 'function') {
        dirs[key] = { bind: def$$1, update: def$$1 };
      }
    }
  }
}

function assertObjectType (name, value, vm) {
  if (!isPlainObject(value)) {
    warn(
      "Invalid value for option \"" + name + "\": expected an Object, " +
      "but got " + (toRawType(value)) + ".",
      vm
    );
  }
}

/**
 * Merge two option objects into a new one.
 * Core utility used in both instantiation and inheritance.
 */
function mergeOptions (
  parent,
  child,
  vm
) {
  if (false) {
    checkComponents(child);
  }

  if (typeof child === 'function') {
    child = child.options;
  }

  normalizeProps(child, vm);
  normalizeInject(child, vm);
  normalizeDirectives(child);

  // Apply extends and mixins on the child options,
  // but only if it is a raw options object that isn't
  // the result of another mergeOptions call.
  // Only merged options has the _base property.
  if (!child._base) {
    if (child.extends) {
      parent = mergeOptions(parent, child.extends, vm);
    }
    if (child.mixins) {
      for (var i = 0, l = child.mixins.length; i < l; i++) {
        parent = mergeOptions(parent, child.mixins[i], vm);
      }
    }
  }

  var options = {};
  var key;
  for (key in parent) {
    mergeField(key);
  }
  for (key in child) {
    if (!hasOwn(parent, key)) {
      mergeField(key);
    }
  }
  function mergeField (key) {
    var strat = strats[key] || defaultStrat;
    options[key] = strat(parent[key], child[key], vm, key);
  }
  return options
}

/**
 * Resolve an asset.
 * This function is used because child instances need access
 * to assets defined in its ancestor chain.
 */
function resolveAsset (
  options,
  type,
  id,
  warnMissing
) {
  /* istanbul ignore if */
  if (typeof id !== 'string') {
    return
  }
  var assets = options[type];
  // check local registration variations first
  if (hasOwn(assets, id)) { return assets[id] }
  var camelizedId = camelize(id);
  if (hasOwn(assets, camelizedId)) { return assets[camelizedId] }
  var PascalCaseId = capitalize(camelizedId);
  if (hasOwn(assets, PascalCaseId)) { return assets[PascalCaseId] }
  // fallback to prototype chain
  var res = assets[id] || assets[camelizedId] || assets[PascalCaseId];
  if (false) {
    warn(
      'Failed to resolve ' + type.slice(0, -1) + ': ' + id,
      options
    );
  }
  return res
}

/*  */



function validateProp (
  key,
  propOptions,
  propsData,
  vm
) {
  var prop = propOptions[key];
  var absent = !hasOwn(propsData, key);
  var value = propsData[key];
  // boolean casting
  var booleanIndex = getTypeIndex(Boolean, prop.type);
  if (booleanIndex > -1) {
    if (absent && !hasOwn(prop, 'default')) {
      value = false;
    } else if (value === '' || value === hyphenate(key)) {
      // only cast empty string / same name to boolean if
      // boolean has higher priority
      var stringIndex = getTypeIndex(String, prop.type);
      if (stringIndex < 0 || booleanIndex < stringIndex) {
        value = true;
      }
    }
  }
  // check default value
  if (value === undefined) {
    value = getPropDefaultValue(vm, prop, key);
    // since the default value is a fresh copy,
    // make sure to observe it.
    var prevShouldObserve = shouldObserve;
    toggleObserving(true);
    observe(value);
    toggleObserving(prevShouldObserve);
  }
  if (
    false
  ) {
    assertProp(prop, key, value, vm, absent);
  }
  return value
}

/**
 * Get the default value of a prop.
 */
function getPropDefaultValue (vm, prop, key) {
  // no default, return undefined
  if (!hasOwn(prop, 'default')) {
    return undefined
  }
  var def = prop.default;
  // warn against non-factory defaults for Object & Array
  if (false) {
    warn(
      'Invalid default value for prop "' + key + '": ' +
      'Props with type Object/Array must use a factory function ' +
      'to return the default value.',
      vm
    );
  }
  // the raw prop value was also undefined from previous render,
  // return previous default value to avoid unnecessary watcher trigger
  if (vm && vm.$options.propsData &&
    vm.$options.propsData[key] === undefined &&
    vm._props[key] !== undefined
  ) {
    return vm._props[key]
  }
  // call factory function for non-Function types
  // a value is Function if its prototype is function even across different execution context
  return typeof def === 'function' && getType(prop.type) !== 'Function'
    ? def.call(vm)
    : def
}

/**
 * Assert whether a prop is valid.
 */
function assertProp (
  prop,
  name,
  value,
  vm,
  absent
) {
  if (prop.required && absent) {
    warn(
      'Missing required prop: "' + name + '"',
      vm
    );
    return
  }
  if (value == null && !prop.required) {
    return
  }
  var type = prop.type;
  var valid = !type || type === true;
  var expectedTypes = [];
  if (type) {
    if (!Array.isArray(type)) {
      type = [type];
    }
    for (var i = 0; i < type.length && !valid; i++) {
      var assertedType = assertType(value, type[i]);
      expectedTypes.push(assertedType.expectedType || '');
      valid = assertedType.valid;
    }
  }

  if (!valid) {
    warn(
      getInvalidTypeMessage(name, value, expectedTypes),
      vm
    );
    return
  }
  var validator = prop.validator;
  if (validator) {
    if (!validator(value)) {
      warn(
        'Invalid prop: custom validator check failed for prop "' + name + '".',
        vm
      );
    }
  }
}

var simpleCheckRE = /^(String|Number|Boolean|Function|Symbol)$/;

function assertType (value, type) {
  var valid;
  var expectedType = getType(type);
  if (simpleCheckRE.test(expectedType)) {
    var t = typeof value;
    valid = t === expectedType.toLowerCase();
    // for primitive wrapper objects
    if (!valid && t === 'object') {
      valid = value instanceof type;
    }
  } else if (expectedType === 'Object') {
    valid = isPlainObject(value);
  } else if (expectedType === 'Array') {
    valid = Array.isArray(value);
  } else {
    valid = value instanceof type;
  }
  return {
    valid: valid,
    expectedType: expectedType
  }
}

/**
 * Use function string name to check built-in types,
 * because a simple equality check will fail when running
 * across different vms / iframes.
 */
function getType (fn) {
  var match = fn && fn.toString().match(/^\s*function (\w+)/);
  return match ? match[1] : ''
}

function isSameType (a, b) {
  return getType(a) === getType(b)
}

function getTypeIndex (type, expectedTypes) {
  if (!Array.isArray(expectedTypes)) {
    return isSameType(expectedTypes, type) ? 0 : -1
  }
  for (var i = 0, len = expectedTypes.length; i < len; i++) {
    if (isSameType(expectedTypes[i], type)) {
      return i
    }
  }
  return -1
}

function getInvalidTypeMessage (name, value, expectedTypes) {
  var message = "Invalid prop: type check failed for prop \"" + name + "\"." +
    " Expected " + (expectedTypes.map(capitalize).join(', '));
  var expectedType = expectedTypes[0];
  var receivedType = toRawType(value);
  var expectedValue = styleValue(value, expectedType);
  var receivedValue = styleValue(value, receivedType);
  // check if we need to specify expected value
  if (expectedTypes.length === 1 &&
      isExplicable(expectedType) &&
      !isBoolean(expectedType, receivedType)) {
    message += " with value " + expectedValue;
  }
  message += ", got " + receivedType + " ";
  // check if we need to specify received value
  if (isExplicable(receivedType)) {
    message += "with value " + receivedValue + ".";
  }
  return message
}

function styleValue (value, type) {
  if (type === 'String') {
    return ("\"" + value + "\"")
  } else if (type === 'Number') {
    return ("" + (Number(value)))
  } else {
    return ("" + value)
  }
}

function isExplicable (value) {
  var explicitTypes = ['string', 'number', 'boolean'];
  return explicitTypes.some(function (elem) { return value.toLowerCase() === elem; })
}

function isBoolean () {
  var args = [], len = arguments.length;
  while ( len-- ) args[ len ] = arguments[ len ];

  return args.some(function (elem) { return elem.toLowerCase() === 'boolean'; })
}

/*  */

function handleError (err, vm, info) {
  // Deactivate deps tracking while processing error handler to avoid possible infinite rendering.
  // See: https://github.com/vuejs/vuex/issues/1505
  pushTarget();
  try {
    if (vm) {
      var cur = vm;
      while ((cur = cur.$parent)) {
        var hooks = cur.$options.errorCaptured;
        if (hooks) {
          for (var i = 0; i < hooks.length; i++) {
            try {
              var capture = hooks[i].call(cur, err, vm, info) === false;
              if (capture) { return }
            } catch (e) {
              globalHandleError(e, cur, 'errorCaptured hook');
            }
          }
        }
      }
    }
    globalHandleError(err, vm, info);
  } finally {
    popTarget();
  }
}

function invokeWithErrorHandling (
  handler,
  context,
  args,
  vm,
  info
) {
  var res;
  try {
    res = args ? handler.apply(context, args) : handler.call(context);
    if (res && !res._isVue && isPromise(res) && !res._handled) {
      res.catch(function (e) { return handleError(e, vm, info + " (Promise/async)"); });
      // issue #9511
      // avoid catch triggering multiple times when nested calls
      res._handled = true;
    }
  } catch (e) {
    handleError(e, vm, info);
  }
  return res
}

function globalHandleError (err, vm, info) {
  if (config.errorHandler) {
    try {
      return config.errorHandler.call(null, err, vm, info)
    } catch (e) {
      // if the user intentionally throws the original error in the handler,
      // do not log it twice
      if (e !== err) {
        logError(e, null, 'config.errorHandler');
      }
    }
  }
  logError(err, vm, info);
}

function logError (err, vm, info) {
  if (false) {
    warn(("Error in " + info + ": \"" + (err.toString()) + "\""), vm);
  }
  /* istanbul ignore else */
  if ((inBrowser || inWeex) && typeof console !== 'undefined') {
    console.error(err);
  } else {
    throw err
  }
}

/*  */

var isUsingMicroTask = false;

var callbacks = [];
var pending = false;

function flushCallbacks () {
  pending = false;
  var copies = callbacks.slice(0);
  callbacks.length = 0;
  for (var i = 0; i < copies.length; i++) {
    copies[i]();
  }
}

// Here we have async deferring wrappers using microtasks.
// In 2.5 we used (macro) tasks (in combination with microtasks).
// However, it has subtle problems when state is changed right before repaint
// (e.g. #6813, out-in transitions).
// Also, using (macro) tasks in event handler would cause some weird behaviors
// that cannot be circumvented (e.g. #7109, #7153, #7546, #7834, #8109).
// So we now use microtasks everywhere, again.
// A major drawback of this tradeoff is that there are some scenarios
// where microtasks have too high a priority and fire in between supposedly
// sequential events (e.g. #4521, #6690, which have workarounds)
// or even between bubbling of the same event (#6566).
var timerFunc;

// The nextTick behavior leverages the microtask queue, which can be accessed
// via either native Promise.then or MutationObserver.
// MutationObserver has wider support, however it is seriously bugged in
// UIWebView in iOS >= 9.3.3 when triggered in touch event handlers. It
// completely stops working after triggering a few times... so, if native
// Promise is available, we will use it:
/* istanbul ignore next, $flow-disable-line */
if (typeof Promise !== 'undefined' && isNative(Promise)) {
  var p = Promise.resolve();
  timerFunc = function () {
    p.then(flushCallbacks);
    // In problematic UIWebViews, Promise.then doesn't completely break, but
    // it can get stuck in a weird state where callbacks are pushed into the
    // microtask queue but the queue isn't being flushed, until the browser
    // needs to do some other work, e.g. handle a timer. Therefore we can
    // "force" the microtask queue to be flushed by adding an empty timer.
    if (isIOS) { setTimeout(noop); }
  };
  isUsingMicroTask = true;
} else if (!isIE && typeof MutationObserver !== 'undefined' && (
  isNative(MutationObserver) ||
  // PhantomJS and iOS 7.x
  MutationObserver.toString() === '[object MutationObserverConstructor]'
)) {
  // Use MutationObserver where native Promise is not available,
  // e.g. PhantomJS, iOS7, Android 4.4
  // (#6466 MutationObserver is unreliable in IE11)
  var counter = 1;
  var observer = new MutationObserver(flushCallbacks);
  var textNode = document.createTextNode(String(counter));
  observer.observe(textNode, {
    characterData: true
  });
  timerFunc = function () {
    counter = (counter + 1) % 2;
    textNode.data = String(counter);
  };
  isUsingMicroTask = true;
} else if (typeof setImmediate !== 'undefined' && isNative(setImmediate)) {
  // Fallback to setImmediate.
  // Technically it leverages the (macro) task queue,
  // but it is still a better choice than setTimeout.
  timerFunc = function () {
    setImmediate(flushCallbacks);
  };
} else {
  // Fallback to setTimeout.
  timerFunc = function () {
    setTimeout(flushCallbacks, 0);
  };
}

function nextTick (cb, ctx) {
  var _resolve;
  callbacks.push(function () {
    if (cb) {
      try {
        cb.call(ctx);
      } catch (e) {
        handleError(e, ctx, 'nextTick');
      }
    } else if (_resolve) {
      _resolve(ctx);
    }
  });
  if (!pending) {
    pending = true;
    timerFunc();
  }
  // $flow-disable-line
  if (!cb && typeof Promise !== 'undefined') {
    return new Promise(function (resolve) {
      _resolve = resolve;
    })
  }
}

/*  */

var mark;
var measure;

if (false) {
  var perf = inBrowser && window.performance;
  /* istanbul ignore if */
  if (
    perf &&
    perf.mark &&
    perf.measure &&
    perf.clearMarks &&
    perf.clearMeasures
  ) {
    mark = function (tag) { return perf.mark(tag); };
    measure = function (name, startTag, endTag) {
      perf.measure(name, startTag, endTag);
      perf.clearMarks(startTag);
      perf.clearMarks(endTag);
      // perf.clearMeasures(name)
    };
  }
}

/* not type checking this file because flow doesn't play well with Proxy */

var initProxy;

if (false) {
  var allowedGlobals = makeMap(
    'Infinity,undefined,NaN,isFinite,isNaN,' +
    'parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,' +
    'Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,' +
    'require' // for Webpack/Browserify
  );

  var warnNonPresent = function (target, key) {
    warn(
      "Property or method \"" + key + "\" is not defined on the instance but " +
      'referenced during render. Make sure that this property is reactive, ' +
      'either in the data option, or for class-based components, by ' +
      'initializing the property. ' +
      'See: https://vuejs.org/v2/guide/reactivity.html#Declaring-Reactive-Properties.',
      target
    );
  };

  var warnReservedPrefix = function (target, key) {
    warn(
      "Property \"" + key + "\" must be accessed with \"$data." + key + "\" because " +
      'properties starting with "$" or "_" are not proxied in the Vue instance to ' +
      'prevent conflicts with Vue internals. ' +
      'See: https://vuejs.org/v2/api/#data',
      target
    );
  };

  var hasProxy =
    typeof Proxy !== 'undefined' && isNative(Proxy);

  if (hasProxy) {
    var isBuiltInModifier = makeMap('stop,prevent,self,ctrl,shift,alt,meta,exact');
    config.keyCodes = new Proxy(config.keyCodes, {
      set: function set (target, key, value) {
        if (isBuiltInModifier(key)) {
          warn(("Avoid overwriting built-in modifier in config.keyCodes: ." + key));
          return false
        } else {
          target[key] = value;
          return true
        }
      }
    });
  }

  var hasHandler = {
    has: function has (target, key) {
      var has = key in target;
      var isAllowed = allowedGlobals(key) ||
        (typeof key === 'string' && key.charAt(0) === '_' && !(key in target.$data));
      if (!has && !isAllowed) {
        if (key in target.$data) { warnReservedPrefix(target, key); }
        else { warnNonPresent(target, key); }
      }
      return has || !isAllowed
    }
  };

  var getHandler = {
    get: function get (target, key) {
      if (typeof key === 'string' && !(key in target)) {
        if (key in target.$data) { warnReservedPrefix(target, key); }
        else { warnNonPresent(target, key); }
      }
      return target[key]
    }
  };

  initProxy = function initProxy (vm) {
    if (hasProxy) {
      // determine which proxy handler to use
      var options = vm.$options;
      var handlers = options.render && options.render._withStripped
        ? getHandler
        : hasHandler;
      vm._renderProxy = new Proxy(vm, handlers);
    } else {
      vm._renderProxy = vm;
    }
  };
}

/*  */

var seenObjects = new _Set();

/**
 * Recursively traverse an object to evoke all converted
 * getters, so that every nested property inside the object
 * is collected as a "deep" dependency.
 */
function traverse (val) {
  _traverse(val, seenObjects);
  seenObjects.clear();
}

function _traverse (val, seen) {
  var i, keys;
  var isA = Array.isArray(val);
  if ((!isA && !isObject(val)) || Object.isFrozen(val) || val instanceof VNode) {
    return
  }
  if (val.__ob__) {
    var depId = val.__ob__.dep.id;
    if (seen.has(depId)) {
      return
    }
    seen.add(depId);
  }
  if (isA) {
    i = val.length;
    while (i--) { _traverse(val[i], seen); }
  } else {
    keys = Object.keys(val);
    i = keys.length;
    while (i--) { _traverse(val[keys[i]], seen); }
  }
}

/*  */

var normalizeEvent = cached(function (name) {
  var passive = name.charAt(0) === '&';
  name = passive ? name.slice(1) : name;
  var once$$1 = name.charAt(0) === '~'; // Prefixed last, checked first
  name = once$$1 ? name.slice(1) : name;
  var capture = name.charAt(0) === '!';
  name = capture ? name.slice(1) : name;
  return {
    name: name,
    once: once$$1,
    capture: capture,
    passive: passive
  }
});

function createFnInvoker (fns, vm) {
  function invoker () {
    var arguments$1 = arguments;

    var fns = invoker.fns;
    if (Array.isArray(fns)) {
      var cloned = fns.slice();
      for (var i = 0; i < cloned.length; i++) {
        invokeWithErrorHandling(cloned[i], null, arguments$1, vm, "v-on handler");
      }
    } else {
      // return handler return value for single handlers
      return invokeWithErrorHandling(fns, null, arguments, vm, "v-on handler")
    }
  }
  invoker.fns = fns;
  return invoker
}

function updateListeners (
  on,
  oldOn,
  add,
  remove$$1,
  createOnceHandler,
  vm
) {
  var name, def$$1, cur, old, event;
  for (name in on) {
    def$$1 = cur = on[name];
    old = oldOn[name];
    event = normalizeEvent(name);
    if (isUndef(cur)) {
      "production" !== 'production' && warn(
        "Invalid handler for event \"" + (event.name) + "\": got " + String(cur),
        vm
      );
    } else if (isUndef(old)) {
      if (isUndef(cur.fns)) {
        cur = on[name] = createFnInvoker(cur, vm);
      }
      if (isTrue(event.once)) {
        cur = on[name] = createOnceHandler(event.name, cur, event.capture);
      }
      add(event.name, cur, event.capture, event.passive, event.params);
    } else if (cur !== old) {
      old.fns = cur;
      on[name] = old;
    }
  }
  for (name in oldOn) {
    if (isUndef(on[name])) {
      event = normalizeEvent(name);
      remove$$1(event.name, oldOn[name], event.capture);
    }
  }
}

/*  */

function mergeVNodeHook (def, hookKey, hook) {
  if (def instanceof VNode) {
    def = def.data.hook || (def.data.hook = {});
  }
  var invoker;
  var oldHook = def[hookKey];

  function wrappedHook () {
    hook.apply(this, arguments);
    // important: remove merged hook to ensure it's called only once
    // and prevent memory leak
    remove(invoker.fns, wrappedHook);
  }

  if (isUndef(oldHook)) {
    // no existing hook
    invoker = createFnInvoker([wrappedHook]);
  } else {
    /* istanbul ignore if */
    if (isDef(oldHook.fns) && isTrue(oldHook.merged)) {
      // already a merged invoker
      invoker = oldHook;
      invoker.fns.push(wrappedHook);
    } else {
      // existing plain hook
      invoker = createFnInvoker([oldHook, wrappedHook]);
    }
  }

  invoker.merged = true;
  def[hookKey] = invoker;
}

/*  */

function extractPropsFromVNodeData (
  data,
  Ctor,
  tag
) {
  // we are only extracting raw values here.
  // validation and default values are handled in the child
  // component itself.
  var propOptions = Ctor.options.props;
  if (isUndef(propOptions)) {
    return
  }
  var res = {};
  var attrs = data.attrs;
  var props = data.props;
  if (isDef(attrs) || isDef(props)) {
    for (var key in propOptions) {
      var altKey = hyphenate(key);
      if (false) {
        var keyInLowerCase = key.toLowerCase();
        if (
          key !== keyInLowerCase &&
          attrs && hasOwn(attrs, keyInLowerCase)
        ) {
          tip(
            "Prop \"" + keyInLowerCase + "\" is passed to component " +
            (formatComponentName(tag || Ctor)) + ", but the declared prop name is" +
            " \"" + key + "\". " +
            "Note that HTML attributes are case-insensitive and camelCased " +
            "props need to use their kebab-case equivalents when using in-DOM " +
            "templates. You should probably use \"" + altKey + "\" instead of \"" + key + "\"."
          );
        }
      }
      checkProp(res, props, key, altKey, true) ||
      checkProp(res, attrs, key, altKey, false);
    }
  }
  return res
}

function checkProp (
  res,
  hash,
  key,
  altKey,
  preserve
) {
  if (isDef(hash)) {
    if (hasOwn(hash, key)) {
      res[key] = hash[key];
      if (!preserve) {
        delete hash[key];
      }
      return true
    } else if (hasOwn(hash, altKey)) {
      res[key] = hash[altKey];
      if (!preserve) {
        delete hash[altKey];
      }
      return true
    }
  }
  return false
}

/*  */

// The template compiler attempts to minimize the need for normalization by
// statically analyzing the template at compile time.
//
// For plain HTML markup, normalization can be completely skipped because the
// generated render function is guaranteed to return Array<VNode>. There are
// two cases where extra normalization is needed:

// 1. When the children contains components - because a functional component
// may return an Array instead of a single root. In this case, just a simple
// normalization is needed - if any child is an Array, we flatten the whole
// thing with Array.prototype.concat. It is guaranteed to be only 1-level deep
// because functional components already normalize their own children.
function simpleNormalizeChildren (children) {
  for (var i = 0; i < children.length; i++) {
    if (Array.isArray(children[i])) {
      return Array.prototype.concat.apply([], children)
    }
  }
  return children
}

// 2. When the children contains constructs that always generated nested Arrays,
// e.g. <template>, <slot>, v-for, or when the children is provided by user
// with hand-written render functions / JSX. In such cases a full normalization
// is needed to cater to all possible types of children values.
function normalizeChildren (children) {
  return isPrimitive(children)
    ? [createTextVNode(children)]
    : Array.isArray(children)
      ? normalizeArrayChildren(children)
      : undefined
}

function isTextNode (node) {
  return isDef(node) && isDef(node.text) && isFalse(node.isComment)
}

function normalizeArrayChildren (children, nestedIndex) {
  var res = [];
  var i, c, lastIndex, last;
  for (i = 0; i < children.length; i++) {
    c = children[i];
    if (isUndef(c) || typeof c === 'boolean') { continue }
    lastIndex = res.length - 1;
    last = res[lastIndex];
    //  nested
    if (Array.isArray(c)) {
      if (c.length > 0) {
        c = normalizeArrayChildren(c, ((nestedIndex || '') + "_" + i));
        // merge adjacent text nodes
        if (isTextNode(c[0]) && isTextNode(last)) {
          res[lastIndex] = createTextVNode(last.text + (c[0]).text);
          c.shift();
        }
        res.push.apply(res, c);
      }
    } else if (isPrimitive(c)) {
      if (isTextNode(last)) {
        // merge adjacent text nodes
        // this is necessary for SSR hydration because text nodes are
        // essentially merged when rendered to HTML strings
        res[lastIndex] = createTextVNode(last.text + c);
      } else if (c !== '') {
        // convert primitive to vnode
        res.push(createTextVNode(c));
      }
    } else {
      if (isTextNode(c) && isTextNode(last)) {
        // merge adjacent text nodes
        res[lastIndex] = createTextVNode(last.text + c.text);
      } else {
        // default key for nested array children (likely generated by v-for)
        if (isTrue(children._isVList) &&
          isDef(c.tag) &&
          isUndef(c.key) &&
          isDef(nestedIndex)) {
          c.key = "__vlist" + nestedIndex + "_" + i + "__";
        }
        res.push(c);
      }
    }
  }
  return res
}

/*  */

function initProvide (vm) {
  var provide = vm.$options.provide;
  if (provide) {
    vm._provided = typeof provide === 'function'
      ? provide.call(vm)
      : provide;
  }
}

function initInjections (vm) {
  var result = resolveInject(vm.$options.inject, vm);
  if (result) {
    toggleObserving(false);
    Object.keys(result).forEach(function (key) {
      /* istanbul ignore else */
      if (false) {
        defineReactive$$1(vm, key, result[key], function () {
          warn(
            "Avoid mutating an injected value directly since the changes will be " +
            "overwritten whenever the provided component re-renders. " +
            "injection being mutated: \"" + key + "\"",
            vm
          );
        });
      } else {
        defineReactive$$1(vm, key, result[key]);
      }
    });
    toggleObserving(true);
  }
}

function resolveInject (inject, vm) {
  if (inject) {
    // inject is :any because flow is not smart enough to figure out cached
    var result = Object.create(null);
    var keys = hasSymbol
      ? Reflect.ownKeys(inject)
      : Object.keys(inject);

    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      // #6574 in case the inject object is observed...
      if (key === '__ob__') { continue }
      var provideKey = inject[key].from;
      var source = vm;
      while (source) {
        if (source._provided && hasOwn(source._provided, provideKey)) {
          result[key] = source._provided[provideKey];
          break
        }
        source = source.$parent;
      }
      if (!source) {
        if ('default' in inject[key]) {
          var provideDefault = inject[key].default;
          result[key] = typeof provideDefault === 'function'
            ? provideDefault.call(vm)
            : provideDefault;
        } else if (false) {
          warn(("Injection \"" + key + "\" not found"), vm);
        }
      }
    }
    return result
  }
}

/*  */



/**
 * Runtime helper for resolving raw children VNodes into a slot object.
 */
function resolveSlots (
  children,
  context
) {
  if (!children || !children.length) {
    return {}
  }
  var slots = {};
  for (var i = 0, l = children.length; i < l; i++) {
    var child = children[i];
    var data = child.data;
    // remove slot attribute if the node is resolved as a Vue slot node
    if (data && data.attrs && data.attrs.slot) {
      delete data.attrs.slot;
    }
    // named slots should only be respected if the vnode was rendered in the
    // same context.
    if ((child.context === context || child.fnContext === context) &&
      data && data.slot != null
    ) {
      var name = data.slot;
      var slot = (slots[name] || (slots[name] = []));
      if (child.tag === 'template') {
        slot.push.apply(slot, child.children || []);
      } else {
        slot.push(child);
      }
    } else {
      (slots.default || (slots.default = [])).push(child);
    }
  }
  // ignore slots that contains only whitespace
  for (var name$1 in slots) {
    if (slots[name$1].every(isWhitespace)) {
      delete slots[name$1];
    }
  }
  return slots
}

function isWhitespace (node) {
  return (node.isComment && !node.asyncFactory) || node.text === ' '
}

/*  */

function normalizeScopedSlots (
  slots,
  normalSlots,
  prevSlots
) {
  var res;
  var hasNormalSlots = Object.keys(normalSlots).length > 0;
  var isStable = slots ? !!slots.$stable : !hasNormalSlots;
  var key = slots && slots.$key;
  if (!slots) {
    res = {};
  } else if (slots._normalized) {
    // fast path 1: child component re-render only, parent did not change
    return slots._normalized
  } else if (
    isStable &&
    prevSlots &&
    prevSlots !== emptyObject &&
    key === prevSlots.$key &&
    !hasNormalSlots &&
    !prevSlots.$hasNormal
  ) {
    // fast path 2: stable scoped slots w/ no normal slots to proxy,
    // only need to normalize once
    return prevSlots
  } else {
    res = {};
    for (var key$1 in slots) {
      if (slots[key$1] && key$1[0] !== '$') {
        res[key$1] = normalizeScopedSlot(normalSlots, key$1, slots[key$1]);
      }
    }
  }
  // expose normal slots on scopedSlots
  for (var key$2 in normalSlots) {
    if (!(key$2 in res)) {
      res[key$2] = proxyNormalSlot(normalSlots, key$2);
    }
  }
  // avoriaz seems to mock a non-extensible $scopedSlots object
  // and when that is passed down this would cause an error
  if (slots && Object.isExtensible(slots)) {
    (slots)._normalized = res;
  }
  def(res, '$stable', isStable);
  def(res, '$key', key);
  def(res, '$hasNormal', hasNormalSlots);
  return res
}

function normalizeScopedSlot(normalSlots, key, fn) {
  var normalized = function () {
    var res = arguments.length ? fn.apply(null, arguments) : fn({});
    res = res && typeof res === 'object' && !Array.isArray(res)
      ? [res] // single vnode
      : normalizeChildren(res);
    return res && (
      res.length === 0 ||
      (res.length === 1 && res[0].isComment) // #9658
    ) ? undefined
      : res
  };
  // this is a slot using the new v-slot syntax without scope. although it is
  // compiled as a scoped slot, render fn users would expect it to be present
  // on this.$slots because the usage is semantically a normal slot.
  if (fn.proxy) {
    Object.defineProperty(normalSlots, key, {
      get: normalized,
      enumerable: true,
      configurable: true
    });
  }
  return normalized
}

function proxyNormalSlot(slots, key) {
  return function () { return slots[key]; }
}

/*  */

/**
 * Runtime helper for rendering v-for lists.
 */
function renderList (
  val,
  render
) {
  var ret, i, l, keys, key;
  if (Array.isArray(val) || typeof val === 'string') {
    ret = new Array(val.length);
    for (i = 0, l = val.length; i < l; i++) {
      ret[i] = render(val[i], i);
    }
  } else if (typeof val === 'number') {
    ret = new Array(val);
    for (i = 0; i < val; i++) {
      ret[i] = render(i + 1, i);
    }
  } else if (isObject(val)) {
    if (hasSymbol && val[Symbol.iterator]) {
      ret = [];
      var iterator = val[Symbol.iterator]();
      var result = iterator.next();
      while (!result.done) {
        ret.push(render(result.value, ret.length));
        result = iterator.next();
      }
    } else {
      keys = Object.keys(val);
      ret = new Array(keys.length);
      for (i = 0, l = keys.length; i < l; i++) {
        key = keys[i];
        ret[i] = render(val[key], key, i);
      }
    }
  }
  if (!isDef(ret)) {
    ret = [];
  }
  (ret)._isVList = true;
  return ret
}

/*  */

/**
 * Runtime helper for rendering <slot>
 */
function renderSlot (
  name,
  fallback,
  props,
  bindObject
) {
  var scopedSlotFn = this.$scopedSlots[name];
  var nodes;
  if (scopedSlotFn) { // scoped slot
    props = props || {};
    if (bindObject) {
      if (false) {
        warn(
          'slot v-bind without argument expects an Object',
          this
        );
      }
      props = extend(extend({}, bindObject), props);
    }
    nodes = scopedSlotFn(props) || fallback;
  } else {
    nodes = this.$slots[name] || fallback;
  }

  var target = props && props.slot;
  if (target) {
    return this.$createElement('template', { slot: target }, nodes)
  } else {
    return nodes
  }
}

/*  */

/**
 * Runtime helper for resolving filters
 */
function resolveFilter (id) {
  return resolveAsset(this.$options, 'filters', id, true) || identity
}

/*  */

function isKeyNotMatch (expect, actual) {
  if (Array.isArray(expect)) {
    return expect.indexOf(actual) === -1
  } else {
    return expect !== actual
  }
}

/**
 * Runtime helper for checking keyCodes from config.
 * exposed as Vue.prototype._k
 * passing in eventKeyName as last argument separately for backwards compat
 */
function checkKeyCodes (
  eventKeyCode,
  key,
  builtInKeyCode,
  eventKeyName,
  builtInKeyName
) {
  var mappedKeyCode = config.keyCodes[key] || builtInKeyCode;
  if (builtInKeyName && eventKeyName && !config.keyCodes[key]) {
    return isKeyNotMatch(builtInKeyName, eventKeyName)
  } else if (mappedKeyCode) {
    return isKeyNotMatch(mappedKeyCode, eventKeyCode)
  } else if (eventKeyName) {
    return hyphenate(eventKeyName) !== key
  }
}

/*  */

/**
 * Runtime helper for merging v-bind="object" into a VNode's data.
 */
function bindObjectProps (
  data,
  tag,
  value,
  asProp,
  isSync
) {
  if (value) {
    if (!isObject(value)) {
      "production" !== 'production' && warn(
        'v-bind without argument expects an Object or Array value',
        this
      );
    } else {
      if (Array.isArray(value)) {
        value = toObject(value);
      }
      var hash;
      var loop = function ( key ) {
        if (
          key === 'class' ||
          key === 'style' ||
          isReservedAttribute(key)
        ) {
          hash = data;
        } else {
          var type = data.attrs && data.attrs.type;
          hash = asProp || config.mustUseProp(tag, type, key)
            ? data.domProps || (data.domProps = {})
            : data.attrs || (data.attrs = {});
        }
        var camelizedKey = camelize(key);
        var hyphenatedKey = hyphenate(key);
        if (!(camelizedKey in hash) && !(hyphenatedKey in hash)) {
          hash[key] = value[key];

          if (isSync) {
            var on = data.on || (data.on = {});
            on[("update:" + key)] = function ($event) {
              value[key] = $event;
            };
          }
        }
      };

      for (var key in value) loop( key );
    }
  }
  return data
}

/*  */

/**
 * Runtime helper for rendering static trees.
 */
function renderStatic (
  index,
  isInFor
) {
  var cached = this._staticTrees || (this._staticTrees = []);
  var tree = cached[index];
  // if has already-rendered static tree and not inside v-for,
  // we can reuse the same tree.
  if (tree && !isInFor) {
    return tree
  }
  // otherwise, render a fresh tree.
  tree = cached[index] = this.$options.staticRenderFns[index].call(
    this._renderProxy,
    null,
    this // for render fns generated for functional component templates
  );
  markStatic(tree, ("__static__" + index), false);
  return tree
}

/**
 * Runtime helper for v-once.
 * Effectively it means marking the node as static with a unique key.
 */
function markOnce (
  tree,
  index,
  key
) {
  markStatic(tree, ("__once__" + index + (key ? ("_" + key) : "")), true);
  return tree
}

function markStatic (
  tree,
  key,
  isOnce
) {
  if (Array.isArray(tree)) {
    for (var i = 0; i < tree.length; i++) {
      if (tree[i] && typeof tree[i] !== 'string') {
        markStaticNode(tree[i], (key + "_" + i), isOnce);
      }
    }
  } else {
    markStaticNode(tree, key, isOnce);
  }
}

function markStaticNode (node, key, isOnce) {
  node.isStatic = true;
  node.key = key;
  node.isOnce = isOnce;
}

/*  */

function bindObjectListeners (data, value) {
  if (value) {
    if (!isPlainObject(value)) {
      "production" !== 'production' && warn(
        'v-on without argument expects an Object value',
        this
      );
    } else {
      var on = data.on = data.on ? extend({}, data.on) : {};
      for (var key in value) {
        var existing = on[key];
        var ours = value[key];
        on[key] = existing ? [].concat(existing, ours) : ours;
      }
    }
  }
  return data
}

/*  */

function resolveScopedSlots (
  fns, // see flow/vnode
  res,
  // the following are added in 2.6
  hasDynamicKeys,
  contentHashKey
) {
  res = res || { $stable: !hasDynamicKeys };
  for (var i = 0; i < fns.length; i++) {
    var slot = fns[i];
    if (Array.isArray(slot)) {
      resolveScopedSlots(slot, res, hasDynamicKeys);
    } else if (slot) {
      // marker for reverse proxying v-slot without scope on this.$slots
      if (slot.proxy) {
        slot.fn.proxy = true;
      }
      res[slot.key] = slot.fn;
    }
  }
  if (contentHashKey) {
    (res).$key = contentHashKey;
  }
  return res
}

/*  */

function bindDynamicKeys (baseObj, values) {
  for (var i = 0; i < values.length; i += 2) {
    var key = values[i];
    if (typeof key === 'string' && key) {
      baseObj[values[i]] = values[i + 1];
    } else if (false) {
      // null is a special value for explicitly removing a binding
      warn(
        ("Invalid value for dynamic directive argument (expected string or null): " + key),
        this
      );
    }
  }
  return baseObj
}

// helper to dynamically append modifier runtime markers to event names.
// ensure only append when value is already string, otherwise it will be cast
// to string and cause the type check to miss.
function prependModifier (value, symbol) {
  return typeof value === 'string' ? symbol + value : value
}

/*  */

function installRenderHelpers (target) {
  target._o = markOnce;
  target._n = toNumber;
  target._s = toString;
  target._l = renderList;
  target._t = renderSlot;
  target._q = looseEqual;
  target._i = looseIndexOf;
  target._m = renderStatic;
  target._f = resolveFilter;
  target._k = checkKeyCodes;
  target._b = bindObjectProps;
  target._v = createTextVNode;
  target._e = createEmptyVNode;
  target._u = resolveScopedSlots;
  target._g = bindObjectListeners;
  target._d = bindDynamicKeys;
  target._p = prependModifier;
}

/*  */

function FunctionalRenderContext (
  data,
  props,
  children,
  parent,
  Ctor
) {
  var this$1 = this;

  var options = Ctor.options;
  // ensure the createElement function in functional components
  // gets a unique context - this is necessary for correct named slot check
  var contextVm;
  if (hasOwn(parent, '_uid')) {
    contextVm = Object.create(parent);
    // $flow-disable-line
    contextVm._original = parent;
  } else {
    // the context vm passed in is a functional context as well.
    // in this case we want to make sure we are able to get a hold to the
    // real context instance.
    contextVm = parent;
    // $flow-disable-line
    parent = parent._original;
  }
  var isCompiled = isTrue(options._compiled);
  var needNormalization = !isCompiled;

  this.data = data;
  this.props = props;
  this.children = children;
  this.parent = parent;
  this.listeners = data.on || emptyObject;
  this.injections = resolveInject(options.inject, parent);
  this.slots = function () {
    if (!this$1.$slots) {
      normalizeScopedSlots(
        data.scopedSlots,
        this$1.$slots = resolveSlots(children, parent)
      );
    }
    return this$1.$slots
  };

  Object.defineProperty(this, 'scopedSlots', ({
    enumerable: true,
    get: function get () {
      return normalizeScopedSlots(data.scopedSlots, this.slots())
    }
  }));

  // support for compiled functional template
  if (isCompiled) {
    // exposing $options for renderStatic()
    this.$options = options;
    // pre-resolve slots for renderSlot()
    this.$slots = this.slots();
    this.$scopedSlots = normalizeScopedSlots(data.scopedSlots, this.$slots);
  }

  if (options._scopeId) {
    this._c = function (a, b, c, d) {
      var vnode = createElement(contextVm, a, b, c, d, needNormalization);
      if (vnode && !Array.isArray(vnode)) {
        vnode.fnScopeId = options._scopeId;
        vnode.fnContext = parent;
      }
      return vnode
    };
  } else {
    this._c = function (a, b, c, d) { return createElement(contextVm, a, b, c, d, needNormalization); };
  }
}

installRenderHelpers(FunctionalRenderContext.prototype);

function createFunctionalComponent (
  Ctor,
  propsData,
  data,
  contextVm,
  children
) {
  var options = Ctor.options;
  var props = {};
  var propOptions = options.props;
  if (isDef(propOptions)) {
    for (var key in propOptions) {
      props[key] = validateProp(key, propOptions, propsData || emptyObject);
    }
  } else {
    if (isDef(data.attrs)) { mergeProps(props, data.attrs); }
    if (isDef(data.props)) { mergeProps(props, data.props); }
  }

  var renderContext = new FunctionalRenderContext(
    data,
    props,
    children,
    contextVm,
    Ctor
  );

  var vnode = options.render.call(null, renderContext._c, renderContext);

  if (vnode instanceof VNode) {
    return cloneAndMarkFunctionalResult(vnode, data, renderContext.parent, options, renderContext)
  } else if (Array.isArray(vnode)) {
    var vnodes = normalizeChildren(vnode) || [];
    var res = new Array(vnodes.length);
    for (var i = 0; i < vnodes.length; i++) {
      res[i] = cloneAndMarkFunctionalResult(vnodes[i], data, renderContext.parent, options, renderContext);
    }
    return res
  }
}

function cloneAndMarkFunctionalResult (vnode, data, contextVm, options, renderContext) {
  // #7817 clone node before setting fnContext, otherwise if the node is reused
  // (e.g. it was from a cached normal slot) the fnContext causes named slots
  // that should not be matched to match.
  var clone = cloneVNode(vnode);
  clone.fnContext = contextVm;
  clone.fnOptions = options;
  if (false) {
    (clone.devtoolsMeta = clone.devtoolsMeta || {}).renderContext = renderContext;
  }
  if (data.slot) {
    (clone.data || (clone.data = {})).slot = data.slot;
  }
  return clone
}

function mergeProps (to, from) {
  for (var key in from) {
    to[camelize(key)] = from[key];
  }
}

/*  */

/*  */

/*  */

/*  */

// inline hooks to be invoked on component VNodes during patch
var componentVNodeHooks = {
  init: function init (vnode, hydrating) {
    if (
      vnode.componentInstance &&
      !vnode.componentInstance._isDestroyed &&
      vnode.data.keepAlive
    ) {
      // kept-alive components, treat as a patch
      var mountedNode = vnode; // work around flow
      componentVNodeHooks.prepatch(mountedNode, mountedNode);
    } else {
      var child = vnode.componentInstance = createComponentInstanceForVnode(
        vnode,
        activeInstance
      );
      child.$mount(hydrating ? vnode.elm : undefined, hydrating);
    }
  },

  prepatch: function prepatch (oldVnode, vnode) {
    var options = vnode.componentOptions;
    var child = vnode.componentInstance = oldVnode.componentInstance;
    updateChildComponent(
      child,
      options.propsData, // updated props
      options.listeners, // updated listeners
      vnode, // new parent vnode
      options.children // new children
    );
  },

  insert: function insert (vnode) {
    var context = vnode.context;
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isMounted) {
      componentInstance._isMounted = true;
      callHook(componentInstance, 'mounted');
    }
    if (vnode.data.keepAlive) {
      if (context._isMounted) {
        // vue-router#1212
        // During updates, a kept-alive component's child components may
        // change, so directly walking the tree here may call activated hooks
        // on incorrect children. Instead we push them into a queue which will
        // be processed after the whole patch process ended.
        queueActivatedComponent(componentInstance);
      } else {
        activateChildComponent(componentInstance, true /* direct */);
      }
    }
  },

  destroy: function destroy (vnode) {
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isDestroyed) {
      if (!vnode.data.keepAlive) {
        componentInstance.$destroy();
      } else {
        deactivateChildComponent(componentInstance, true /* direct */);
      }
    }
  }
};

var hooksToMerge = Object.keys(componentVNodeHooks);

function createComponent (
  Ctor,
  data,
  context,
  children,
  tag
) {
  if (isUndef(Ctor)) {
    return
  }

  var baseCtor = context.$options._base;

  // plain options object: turn it into a constructor
  if (isObject(Ctor)) {
    Ctor = baseCtor.extend(Ctor);
  }

  // if at this stage it's not a constructor or an async component factory,
  // reject.
  if (typeof Ctor !== 'function') {
    if (false) {
      warn(("Invalid Component definition: " + (String(Ctor))), context);
    }
    return
  }

  // async component
  var asyncFactory;
  if (isUndef(Ctor.cid)) {
    asyncFactory = Ctor;
    Ctor = resolveAsyncComponent(asyncFactory, baseCtor);
    if (Ctor === undefined) {
      // return a placeholder node for async component, which is rendered
      // as a comment node but preserves all the raw information for the node.
      // the information will be used for async server-rendering and hydration.
      return createAsyncPlaceholder(
        asyncFactory,
        data,
        context,
        children,
        tag
      )
    }
  }

  data = data || {};

  // resolve constructor options in case global mixins are applied after
  // component constructor creation
  resolveConstructorOptions(Ctor);

  // transform component v-model data into props & events
  if (isDef(data.model)) {
    transformModel(Ctor.options, data);
  }

  // extract props
  var propsData = extractPropsFromVNodeData(data, Ctor, tag);

  // functional component
  if (isTrue(Ctor.options.functional)) {
    return createFunctionalComponent(Ctor, propsData, data, context, children)
  }

  // extract listeners, since these needs to be treated as
  // child component listeners instead of DOM listeners
  var listeners = data.on;
  // replace with listeners with .native modifier
  // so it gets processed during parent component patch.
  data.on = data.nativeOn;

  if (isTrue(Ctor.options.abstract)) {
    // abstract components do not keep anything
    // other than props & listeners & slot

    // work around flow
    var slot = data.slot;
    data = {};
    if (slot) {
      data.slot = slot;
    }
  }

  // install component management hooks onto the placeholder node
  installComponentHooks(data);

  // return a placeholder vnode
  var name = Ctor.options.name || tag;
  var vnode = new VNode(
    ("vue-component-" + (Ctor.cid) + (name ? ("-" + name) : '')),
    data, undefined, undefined, undefined, context,
    { Ctor: Ctor, propsData: propsData, listeners: listeners, tag: tag, children: children },
    asyncFactory
  );

  return vnode
}

function createComponentInstanceForVnode (
  vnode, // we know it's MountedComponentVNode but flow doesn't
  parent // activeInstance in lifecycle state
) {
  var options = {
    _isComponent: true,
    _parentVnode: vnode,
    parent: parent
  };
  // check inline-template render functions
  var inlineTemplate = vnode.data.inlineTemplate;
  if (isDef(inlineTemplate)) {
    options.render = inlineTemplate.render;
    options.staticRenderFns = inlineTemplate.staticRenderFns;
  }
  return new vnode.componentOptions.Ctor(options)
}

function installComponentHooks (data) {
  var hooks = data.hook || (data.hook = {});
  for (var i = 0; i < hooksToMerge.length; i++) {
    var key = hooksToMerge[i];
    var existing = hooks[key];
    var toMerge = componentVNodeHooks[key];
    if (existing !== toMerge && !(existing && existing._merged)) {
      hooks[key] = existing ? mergeHook$1(toMerge, existing) : toMerge;
    }
  }
}

function mergeHook$1 (f1, f2) {
  var merged = function (a, b) {
    // flow complains about extra args which is why we use any
    f1(a, b);
    f2(a, b);
  };
  merged._merged = true;
  return merged
}

// transform component v-model info (value and callback) into
// prop and event handler respectively.
function transformModel (options, data) {
  var prop = (options.model && options.model.prop) || 'value';
  var event = (options.model && options.model.event) || 'input'
  ;(data.attrs || (data.attrs = {}))[prop] = data.model.value;
  var on = data.on || (data.on = {});
  var existing = on[event];
  var callback = data.model.callback;
  if (isDef(existing)) {
    if (
      Array.isArray(existing)
        ? existing.indexOf(callback) === -1
        : existing !== callback
    ) {
      on[event] = [callback].concat(existing);
    }
  } else {
    on[event] = callback;
  }
}

/*  */

var SIMPLE_NORMALIZE = 1;
var ALWAYS_NORMALIZE = 2;

// wrapper function for providing a more flexible interface
// without getting yelled at by flow
function createElement (
  context,
  tag,
  data,
  children,
  normalizationType,
  alwaysNormalize
) {
  if (Array.isArray(data) || isPrimitive(data)) {
    normalizationType = children;
    children = data;
    data = undefined;
  }
  if (isTrue(alwaysNormalize)) {
    normalizationType = ALWAYS_NORMALIZE;
  }
  return _createElement(context, tag, data, children, normalizationType)
}

function _createElement (
  context,
  tag,
  data,
  children,
  normalizationType
) {
  if (isDef(data) && isDef((data).__ob__)) {
    "production" !== 'production' && warn(
      "Avoid using observed data object as vnode data: " + (JSON.stringify(data)) + "\n" +
      'Always create fresh vnode data objects in each render!',
      context
    );
    return createEmptyVNode()
  }
  // object syntax in v-bind
  if (isDef(data) && isDef(data.is)) {
    tag = data.is;
  }
  if (!tag) {
    // in case of component :is set to falsy value
    return createEmptyVNode()
  }
  // warn against non-primitive key
  if (false
  ) {
    {
      warn(
        'Avoid using non-primitive value as key, ' +
        'use string/number value instead.',
        context
      );
    }
  }
  // support single function children as default scoped slot
  if (Array.isArray(children) &&
    typeof children[0] === 'function'
  ) {
    data = data || {};
    data.scopedSlots = { default: children[0] };
    children.length = 0;
  }
  if (normalizationType === ALWAYS_NORMALIZE) {
    children = normalizeChildren(children);
  } else if (normalizationType === SIMPLE_NORMALIZE) {
    children = simpleNormalizeChildren(children);
  }
  var vnode, ns;
  if (typeof tag === 'string') {
    var Ctor;
    ns = (context.$vnode && context.$vnode.ns) || config.getTagNamespace(tag);
    if (config.isReservedTag(tag)) {
      // platform built-in elements
      if (false) {
        warn(
          ("The .native modifier for v-on is only valid on components but it was used on <" + tag + ">."),
          context
        );
      }
      vnode = new VNode(
        config.parsePlatformTagName(tag), data, children,
        undefined, undefined, context
      );
    } else if ((!data || !data.pre) && isDef(Ctor = resolveAsset(context.$options, 'components', tag))) {
      // component
      vnode = createComponent(Ctor, data, context, children, tag);
    } else {
      // unknown or unlisted namespaced elements
      // check at runtime because it may get assigned a namespace when its
      // parent normalizes children
      vnode = new VNode(
        tag, data, children,
        undefined, undefined, context
      );
    }
  } else {
    // direct component options / constructor
    vnode = createComponent(tag, data, context, children);
  }
  if (Array.isArray(vnode)) {
    return vnode
  } else if (isDef(vnode)) {
    if (isDef(ns)) { applyNS(vnode, ns); }
    if (isDef(data)) { registerDeepBindings(data); }
    return vnode
  } else {
    return createEmptyVNode()
  }
}

function applyNS (vnode, ns, force) {
  vnode.ns = ns;
  if (vnode.tag === 'foreignObject') {
    // use default namespace inside foreignObject
    ns = undefined;
    force = true;
  }
  if (isDef(vnode.children)) {
    for (var i = 0, l = vnode.children.length; i < l; i++) {
      var child = vnode.children[i];
      if (isDef(child.tag) && (
        isUndef(child.ns) || (isTrue(force) && child.tag !== 'svg'))) {
        applyNS(child, ns, force);
      }
    }
  }
}

// ref #5318
// necessary to ensure parent re-render when deep bindings like :style and
// :class are used on slot nodes
function registerDeepBindings (data) {
  if (isObject(data.style)) {
    traverse(data.style);
  }
  if (isObject(data.class)) {
    traverse(data.class);
  }
}

/*  */

function initRender (vm) {
  vm._vnode = null; // the root of the child tree
  vm._staticTrees = null; // v-once cached trees
  var options = vm.$options;
  var parentVnode = vm.$vnode = options._parentVnode; // the placeholder node in parent tree
  var renderContext = parentVnode && parentVnode.context;
  vm.$slots = resolveSlots(options._renderChildren, renderContext);
  vm.$scopedSlots = emptyObject;
  // bind the createElement fn to this instance
  // so that we get proper render context inside it.
  // args order: tag, data, children, normalizationType, alwaysNormalize
  // internal version is used by render functions compiled from templates
  vm._c = function (a, b, c, d) { return createElement(vm, a, b, c, d, false); };
  // normalization is always applied for the public version, used in
  // user-written render functions.
  vm.$createElement = function (a, b, c, d) { return createElement(vm, a, b, c, d, true); };

  // $attrs & $listeners are exposed for easier HOC creation.
  // they need to be reactive so that HOCs using them are always updated
  var parentData = parentVnode && parentVnode.data;

  /* istanbul ignore else */
  if (false) {
    defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, function () {
      !isUpdatingChildComponent && warn("$attrs is readonly.", vm);
    }, true);
    defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, function () {
      !isUpdatingChildComponent && warn("$listeners is readonly.", vm);
    }, true);
  } else {
    defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, null, true);
    defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, null, true);
  }
}

var currentRenderingInstance = null;

function renderMixin (Vue) {
  // install runtime convenience helpers
  installRenderHelpers(Vue.prototype);

  Vue.prototype.$nextTick = function (fn) {
    return nextTick(fn, this)
  };

  Vue.prototype._render = function () {
    var vm = this;
    var ref = vm.$options;
    var render = ref.render;
    var _parentVnode = ref._parentVnode;

    if (_parentVnode) {
      vm.$scopedSlots = normalizeScopedSlots(
        _parentVnode.data.scopedSlots,
        vm.$slots,
        vm.$scopedSlots
      );
    }

    // set parent vnode. this allows render functions to have access
    // to the data on the placeholder node.
    vm.$vnode = _parentVnode;
    // render self
    var vnode;
    try {
      // There's no need to maintain a stack because all render fns are called
      // separately from one another. Nested component's render fns are called
      // when parent component is patched.
      currentRenderingInstance = vm;
      vnode = render.call(vm._renderProxy, vm.$createElement);
    } catch (e) {
      handleError(e, vm, "render");
      // return error render result,
      // or previous vnode to prevent render error causing blank component
      /* istanbul ignore else */
      if (false) {
        try {
          vnode = vm.$options.renderError.call(vm._renderProxy, vm.$createElement, e);
        } catch (e) {
          handleError(e, vm, "renderError");
          vnode = vm._vnode;
        }
      } else {
        vnode = vm._vnode;
      }
    } finally {
      currentRenderingInstance = null;
    }
    // if the returned array contains only a single node, allow it
    if (Array.isArray(vnode) && vnode.length === 1) {
      vnode = vnode[0];
    }
    // return empty vnode in case the render function errored out
    if (!(vnode instanceof VNode)) {
      if (false) {
        warn(
          'Multiple root nodes returned from render function. Render function ' +
          'should return a single root node.',
          vm
        );
      }
      vnode = createEmptyVNode();
    }
    // set parent
    vnode.parent = _parentVnode;
    return vnode
  };
}

/*  */

function ensureCtor (comp, base) {
  if (
    comp.__esModule ||
    (hasSymbol && comp[Symbol.toStringTag] === 'Module')
  ) {
    comp = comp.default;
  }
  return isObject(comp)
    ? base.extend(comp)
    : comp
}

function createAsyncPlaceholder (
  factory,
  data,
  context,
  children,
  tag
) {
  var node = createEmptyVNode();
  node.asyncFactory = factory;
  node.asyncMeta = { data: data, context: context, children: children, tag: tag };
  return node
}

function resolveAsyncComponent (
  factory,
  baseCtor
) {
  if (isTrue(factory.error) && isDef(factory.errorComp)) {
    return factory.errorComp
  }

  if (isDef(factory.resolved)) {
    return factory.resolved
  }

  var owner = currentRenderingInstance;
  if (owner && isDef(factory.owners) && factory.owners.indexOf(owner) === -1) {
    // already pending
    factory.owners.push(owner);
  }

  if (isTrue(factory.loading) && isDef(factory.loadingComp)) {
    return factory.loadingComp
  }

  if (owner && !isDef(factory.owners)) {
    var owners = factory.owners = [owner];
    var sync = true;
    var timerLoading = null;
    var timerTimeout = null

    ;(owner).$on('hook:destroyed', function () { return remove(owners, owner); });

    var forceRender = function (renderCompleted) {
      for (var i = 0, l = owners.length; i < l; i++) {
        (owners[i]).$forceUpdate();
      }

      if (renderCompleted) {
        owners.length = 0;
        if (timerLoading !== null) {
          clearTimeout(timerLoading);
          timerLoading = null;
        }
        if (timerTimeout !== null) {
          clearTimeout(timerTimeout);
          timerTimeout = null;
        }
      }
    };

    var resolve = once(function (res) {
      // cache resolved
      factory.resolved = ensureCtor(res, baseCtor);
      // invoke callbacks only if this is not a synchronous resolve
      // (async resolves are shimmed as synchronous during SSR)
      if (!sync) {
        forceRender(true);
      } else {
        owners.length = 0;
      }
    });

    var reject = once(function (reason) {
      "production" !== 'production' && warn(
        "Failed to resolve async component: " + (String(factory)) +
        (reason ? ("\nReason: " + reason) : '')
      );
      if (isDef(factory.errorComp)) {
        factory.error = true;
        forceRender(true);
      }
    });

    var res = factory(resolve, reject);

    if (isObject(res)) {
      if (isPromise(res)) {
        // () => Promise
        if (isUndef(factory.resolved)) {
          res.then(resolve, reject);
        }
      } else if (isPromise(res.component)) {
        res.component.then(resolve, reject);

        if (isDef(res.error)) {
          factory.errorComp = ensureCtor(res.error, baseCtor);
        }

        if (isDef(res.loading)) {
          factory.loadingComp = ensureCtor(res.loading, baseCtor);
          if (res.delay === 0) {
            factory.loading = true;
          } else {
            timerLoading = setTimeout(function () {
              timerLoading = null;
              if (isUndef(factory.resolved) && isUndef(factory.error)) {
                factory.loading = true;
                forceRender(false);
              }
            }, res.delay || 200);
          }
        }

        if (isDef(res.timeout)) {
          timerTimeout = setTimeout(function () {
            timerTimeout = null;
            if (isUndef(factory.resolved)) {
              reject(
                 false
                  ? ("timeout (" + (res.timeout) + "ms)")
                  : null
              );
            }
          }, res.timeout);
        }
      }
    }

    sync = false;
    // return in case resolved synchronously
    return factory.loading
      ? factory.loadingComp
      : factory.resolved
  }
}

/*  */

function isAsyncPlaceholder (node) {
  return node.isComment && node.asyncFactory
}

/*  */

function getFirstComponentChild (children) {
  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      var c = children[i];
      if (isDef(c) && (isDef(c.componentOptions) || isAsyncPlaceholder(c))) {
        return c
      }
    }
  }
}

/*  */

/*  */

function initEvents (vm) {
  vm._events = Object.create(null);
  vm._hasHookEvent = false;
  // init parent attached events
  var listeners = vm.$options._parentListeners;
  if (listeners) {
    updateComponentListeners(vm, listeners);
  }
}

var target;

function add (event, fn) {
  target.$on(event, fn);
}

function remove$1 (event, fn) {
  target.$off(event, fn);
}

function createOnceHandler (event, fn) {
  var _target = target;
  return function onceHandler () {
    var res = fn.apply(null, arguments);
    if (res !== null) {
      _target.$off(event, onceHandler);
    }
  }
}

function updateComponentListeners (
  vm,
  listeners,
  oldListeners
) {
  target = vm;
  updateListeners(listeners, oldListeners || {}, add, remove$1, createOnceHandler, vm);
  target = undefined;
}

function eventsMixin (Vue) {
  var hookRE = /^hook:/;
  Vue.prototype.$on = function (event, fn) {
    var vm = this;
    if (Array.isArray(event)) {
      for (var i = 0, l = event.length; i < l; i++) {
        vm.$on(event[i], fn);
      }
    } else {
      (vm._events[event] || (vm._events[event] = [])).push(fn);
      // optimize hook:event cost by using a boolean flag marked at registration
      // instead of a hash lookup
      if (hookRE.test(event)) {
        vm._hasHookEvent = true;
      }
    }
    return vm
  };

  Vue.prototype.$once = function (event, fn) {
    var vm = this;
    function on () {
      vm.$off(event, on);
      fn.apply(vm, arguments);
    }
    on.fn = fn;
    vm.$on(event, on);
    return vm
  };

  Vue.prototype.$off = function (event, fn) {
    var vm = this;
    // all
    if (!arguments.length) {
      vm._events = Object.create(null);
      return vm
    }
    // array of events
    if (Array.isArray(event)) {
      for (var i$1 = 0, l = event.length; i$1 < l; i$1++) {
        vm.$off(event[i$1], fn);
      }
      return vm
    }
    // specific event
    var cbs = vm._events[event];
    if (!cbs) {
      return vm
    }
    if (!fn) {
      vm._events[event] = null;
      return vm
    }
    // specific handler
    var cb;
    var i = cbs.length;
    while (i--) {
      cb = cbs[i];
      if (cb === fn || cb.fn === fn) {
        cbs.splice(i, 1);
        break
      }
    }
    return vm
  };

  Vue.prototype.$emit = function (event) {
    var vm = this;
    if (false) {
      var lowerCaseEvent = event.toLowerCase();
      if (lowerCaseEvent !== event && vm._events[lowerCaseEvent]) {
        tip(
          "Event \"" + lowerCaseEvent + "\" is emitted in component " +
          (formatComponentName(vm)) + " but the handler is registered for \"" + event + "\". " +
          "Note that HTML attributes are case-insensitive and you cannot use " +
          "v-on to listen to camelCase events when using in-DOM templates. " +
          "You should probably use \"" + (hyphenate(event)) + "\" instead of \"" + event + "\"."
        );
      }
    }
    var cbs = vm._events[event];
    if (cbs) {
      cbs = cbs.length > 1 ? toArray(cbs) : cbs;
      var args = toArray(arguments, 1);
      var info = "event handler for \"" + event + "\"";
      for (var i = 0, l = cbs.length; i < l; i++) {
        invokeWithErrorHandling(cbs[i], vm, args, vm, info);
      }
    }
    return vm
  };
}

/*  */

var activeInstance = null;
var isUpdatingChildComponent = false;

function setActiveInstance(vm) {
  var prevActiveInstance = activeInstance;
  activeInstance = vm;
  return function () {
    activeInstance = prevActiveInstance;
  }
}

function initLifecycle (vm) {
  var options = vm.$options;

  // locate first non-abstract parent
  var parent = options.parent;
  if (parent && !options.abstract) {
    while (parent.$options.abstract && parent.$parent) {
      parent = parent.$parent;
    }
    parent.$children.push(vm);
  }

  vm.$parent = parent;
  vm.$root = parent ? parent.$root : vm;

  vm.$children = [];
  vm.$refs = {};

  vm._watcher = null;
  vm._inactive = null;
  vm._directInactive = false;
  vm._isMounted = false;
  vm._isDestroyed = false;
  vm._isBeingDestroyed = false;
}

function lifecycleMixin (Vue) {
  Vue.prototype._update = function (vnode, hydrating) {
    var vm = this;
    var prevEl = vm.$el;
    var prevVnode = vm._vnode;
    var restoreActiveInstance = setActiveInstance(vm);
    vm._vnode = vnode;
    // Vue.prototype.__patch__ is injected in entry points
    // based on the rendering backend used.
    if (!prevVnode) {
      // initial render
      vm.$el = vm.__patch__(vm.$el, vnode, hydrating, false /* removeOnly */);
    } else {
      // updates
      vm.$el = vm.__patch__(prevVnode, vnode);
    }
    restoreActiveInstance();
    // update __vue__ reference
    if (prevEl) {
      prevEl.__vue__ = null;
    }
    if (vm.$el) {
      vm.$el.__vue__ = vm;
    }
    // if parent is an HOC, update its $el as well
    if (vm.$vnode && vm.$parent && vm.$vnode === vm.$parent._vnode) {
      vm.$parent.$el = vm.$el;
    }
    // updated hook is called by the scheduler to ensure that children are
    // updated in a parent's updated hook.
  };

  Vue.prototype.$forceUpdate = function () {
    var vm = this;
    if (vm._watcher) {
      vm._watcher.update();
    }
  };

  Vue.prototype.$destroy = function () {
    var vm = this;
    if (vm._isBeingDestroyed) {
      return
    }
    callHook(vm, 'beforeDestroy');
    vm._isBeingDestroyed = true;
    // remove self from parent
    var parent = vm.$parent;
    if (parent && !parent._isBeingDestroyed && !vm.$options.abstract) {
      remove(parent.$children, vm);
    }
    // teardown watchers
    if (vm._watcher) {
      vm._watcher.teardown();
    }
    var i = vm._watchers.length;
    while (i--) {
      vm._watchers[i].teardown();
    }
    // remove reference from data ob
    // frozen object may not have observer.
    if (vm._data.__ob__) {
      vm._data.__ob__.vmCount--;
    }
    // call the last hook...
    vm._isDestroyed = true;
    // invoke destroy hooks on current rendered tree
    vm.__patch__(vm._vnode, null);
    // fire destroyed hook
    callHook(vm, 'destroyed');
    // turn off all instance listeners.
    vm.$off();
    // remove __vue__ reference
    if (vm.$el) {
      vm.$el.__vue__ = null;
    }
    // release circular reference (#6759)
    if (vm.$vnode) {
      vm.$vnode.parent = null;
    }
  };
}

function mountComponent (
  vm,
  el,
  hydrating
) {
  vm.$el = el;
  if (!vm.$options.render) {
    vm.$options.render = createEmptyVNode;
    if (false) {
      /* istanbul ignore if */
      if ((vm.$options.template && vm.$options.template.charAt(0) !== '#') ||
        vm.$options.el || el) {
        warn(
          'You are using the runtime-only build of Vue where the template ' +
          'compiler is not available. Either pre-compile the templates into ' +
          'render functions, or use the compiler-included build.',
          vm
        );
      } else {
        warn(
          'Failed to mount component: template or render function not defined.',
          vm
        );
      }
    }
  }
  callHook(vm, 'beforeMount');

  var updateComponent;
  /* istanbul ignore if */
  if (false) {
    updateComponent = function () {
      var name = vm._name;
      var id = vm._uid;
      var startTag = "vue-perf-start:" + id;
      var endTag = "vue-perf-end:" + id;

      mark(startTag);
      var vnode = vm._render();
      mark(endTag);
      measure(("vue " + name + " render"), startTag, endTag);

      mark(startTag);
      vm._update(vnode, hydrating);
      mark(endTag);
      measure(("vue " + name + " patch"), startTag, endTag);
    };
  } else {
    updateComponent = function () {
      vm._update(vm._render(), hydrating);
    };
  }

  // we set this to vm._watcher inside the watcher's constructor
  // since the watcher's initial patch may call $forceUpdate (e.g. inside child
  // component's mounted hook), which relies on vm._watcher being already defined
  new Watcher(vm, updateComponent, noop, {
    before: function before () {
      if (vm._isMounted && !vm._isDestroyed) {
        callHook(vm, 'beforeUpdate');
      }
    }
  }, true /* isRenderWatcher */);
  hydrating = false;

  // manually mounted instance, call mounted on self
  // mounted is called for render-created child components in its inserted hook
  if (vm.$vnode == null) {
    vm._isMounted = true;
    callHook(vm, 'mounted');
  }
  return vm
}

function updateChildComponent (
  vm,
  propsData,
  listeners,
  parentVnode,
  renderChildren
) {
  if (false) {
    isUpdatingChildComponent = true;
  }

  // determine whether component has slot children
  // we need to do this before overwriting $options._renderChildren.

  // check if there are dynamic scopedSlots (hand-written or compiled but with
  // dynamic slot names). Static scoped slots compiled from template has the
  // "$stable" marker.
  var newScopedSlots = parentVnode.data.scopedSlots;
  var oldScopedSlots = vm.$scopedSlots;
  var hasDynamicScopedSlot = !!(
    (newScopedSlots && !newScopedSlots.$stable) ||
    (oldScopedSlots !== emptyObject && !oldScopedSlots.$stable) ||
    (newScopedSlots && vm.$scopedSlots.$key !== newScopedSlots.$key)
  );

  // Any static slot children from the parent may have changed during parent's
  // update. Dynamic scoped slots may also have changed. In such cases, a forced
  // update is necessary to ensure correctness.
  var needsForceUpdate = !!(
    renderChildren ||               // has new static slots
    vm.$options._renderChildren ||  // has old static slots
    hasDynamicScopedSlot
  );

  vm.$options._parentVnode = parentVnode;
  vm.$vnode = parentVnode; // update vm's placeholder node without re-render

  if (vm._vnode) { // update child tree's parent
    vm._vnode.parent = parentVnode;
  }
  vm.$options._renderChildren = renderChildren;

  // update $attrs and $listeners hash
  // these are also reactive so they may trigger child update if the child
  // used them during render
  vm.$attrs = parentVnode.data.attrs || emptyObject;
  vm.$listeners = listeners || emptyObject;

  // update props
  if (propsData && vm.$options.props) {
    toggleObserving(false);
    var props = vm._props;
    var propKeys = vm.$options._propKeys || [];
    for (var i = 0; i < propKeys.length; i++) {
      var key = propKeys[i];
      var propOptions = vm.$options.props; // wtf flow?
      props[key] = validateProp(key, propOptions, propsData, vm);
    }
    toggleObserving(true);
    // keep a copy of raw propsData
    vm.$options.propsData = propsData;
  }

  // update listeners
  listeners = listeners || emptyObject;
  var oldListeners = vm.$options._parentListeners;
  vm.$options._parentListeners = listeners;
  updateComponentListeners(vm, listeners, oldListeners);

  // resolve slots + force update if has children
  if (needsForceUpdate) {
    vm.$slots = resolveSlots(renderChildren, parentVnode.context);
    vm.$forceUpdate();
  }

  if (false) {
    isUpdatingChildComponent = false;
  }
}

function isInInactiveTree (vm) {
  while (vm && (vm = vm.$parent)) {
    if (vm._inactive) { return true }
  }
  return false
}

function activateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = false;
    if (isInInactiveTree(vm)) {
      return
    }
  } else if (vm._directInactive) {
    return
  }
  if (vm._inactive || vm._inactive === null) {
    vm._inactive = false;
    for (var i = 0; i < vm.$children.length; i++) {
      activateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'activated');
  }
}

function deactivateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = true;
    if (isInInactiveTree(vm)) {
      return
    }
  }
  if (!vm._inactive) {
    vm._inactive = true;
    for (var i = 0; i < vm.$children.length; i++) {
      deactivateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'deactivated');
  }
}

function callHook (vm, hook) {
  // #7573 disable dep collection when invoking lifecycle hooks
  pushTarget();
  var handlers = vm.$options[hook];
  var info = hook + " hook";
  if (handlers) {
    for (var i = 0, j = handlers.length; i < j; i++) {
      invokeWithErrorHandling(handlers[i], vm, null, vm, info);
    }
  }
  if (vm._hasHookEvent) {
    vm.$emit('hook:' + hook);
  }
  popTarget();
}

/*  */

var MAX_UPDATE_COUNT = 100;

var queue = [];
var activatedChildren = [];
var has = {};
var circular = {};
var waiting = false;
var flushing = false;
var index = 0;

/**
 * Reset the scheduler's state.
 */
function resetSchedulerState () {
  index = queue.length = activatedChildren.length = 0;
  has = {};
  if (false) {
    circular = {};
  }
  waiting = flushing = false;
}

// Async edge case #6566 requires saving the timestamp when event listeners are
// attached. However, calling performance.now() has a perf overhead especially
// if the page has thousands of event listeners. Instead, we take a timestamp
// every time the scheduler flushes and use that for all event listeners
// attached during that flush.
var currentFlushTimestamp = 0;

// Async edge case fix requires storing an event listener's attach timestamp.
var getNow = Date.now;

// Determine what event timestamp the browser is using. Annoyingly, the
// timestamp can either be hi-res (relative to page load) or low-res
// (relative to UNIX epoch), so in order to compare time we have to use the
// same timestamp type when saving the flush timestamp.
// All IE versions use low-res event timestamps, and have problematic clock
// implementations (#9632)
if (inBrowser && !isIE) {
  var performance = window.performance;
  if (
    performance &&
    typeof performance.now === 'function' &&
    getNow() > document.createEvent('Event').timeStamp
  ) {
    // if the event timestamp, although evaluated AFTER the Date.now(), is
    // smaller than it, it means the event is using a hi-res timestamp,
    // and we need to use the hi-res version for event listener timestamps as
    // well.
    getNow = function () { return performance.now(); };
  }
}

/**
 * Flush both queues and run the watchers.
 */
function flushSchedulerQueue () {
  currentFlushTimestamp = getNow();
  flushing = true;
  var watcher, id;

  // Sort queue before flush.
  // This ensures that:
  // 1. Components are updated from parent to child. (because parent is always
  //    created before the child)
  // 2. A component's user watchers are run before its render watcher (because
  //    user watchers are created before the render watcher)
  // 3. If a component is destroyed during a parent component's watcher run,
  //    its watchers can be skipped.
  queue.sort(function (a, b) { return a.id - b.id; });

  // do not cache length because more watchers might be pushed
  // as we run existing watchers
  for (index = 0; index < queue.length; index++) {
    watcher = queue[index];
    if (watcher.before) {
      watcher.before();
    }
    id = watcher.id;
    has[id] = null;
    watcher.run();
    // in dev build, check and stop circular updates.
    if (false) {
      circular[id] = (circular[id] || 0) + 1;
      if (circular[id] > MAX_UPDATE_COUNT) {
        warn(
          'You may have an infinite update loop ' + (
            watcher.user
              ? ("in watcher with expression \"" + (watcher.expression) + "\"")
              : "in a component render function."
          ),
          watcher.vm
        );
        break
      }
    }
  }

  // keep copies of post queues before resetting state
  var activatedQueue = activatedChildren.slice();
  var updatedQueue = queue.slice();

  resetSchedulerState();

  // call component updated and activated hooks
  callActivatedHooks(activatedQueue);
  callUpdatedHooks(updatedQueue);

  // devtool hook
  /* istanbul ignore if */
  if (devtools && config.devtools) {
    devtools.emit('flush');
  }
}

function callUpdatedHooks (queue) {
  var i = queue.length;
  while (i--) {
    var watcher = queue[i];
    var vm = watcher.vm;
    if (vm._watcher === watcher && vm._isMounted && !vm._isDestroyed) {
      callHook(vm, 'updated');
    }
  }
}

/**
 * Queue a kept-alive component that was activated during patch.
 * The queue will be processed after the entire tree has been patched.
 */
function queueActivatedComponent (vm) {
  // setting _inactive to false here so that a render function can
  // rely on checking whether it's in an inactive tree (e.g. router-view)
  vm._inactive = false;
  activatedChildren.push(vm);
}

function callActivatedHooks (queue) {
  for (var i = 0; i < queue.length; i++) {
    queue[i]._inactive = true;
    activateChildComponent(queue[i], true /* true */);
  }
}

/**
 * Push a watcher into the watcher queue.
 * Jobs with duplicate IDs will be skipped unless it's
 * pushed when the queue is being flushed.
 */
function queueWatcher (watcher) {
  var id = watcher.id;
  if (has[id] == null) {
    has[id] = true;
    if (!flushing) {
      queue.push(watcher);
    } else {
      // if already flushing, splice the watcher based on its id
      // if already past its id, it will be run next immediately.
      var i = queue.length - 1;
      while (i > index && queue[i].id > watcher.id) {
        i--;
      }
      queue.splice(i + 1, 0, watcher);
    }
    // queue the flush
    if (!waiting) {
      waiting = true;

      if (false) {
        flushSchedulerQueue();
        return
      }
      nextTick(flushSchedulerQueue);
    }
  }
}

/*  */



var uid$2 = 0;

/**
 * A watcher parses an expression, collects dependencies,
 * and fires callback when the expression value changes.
 * This is used for both the $watch() api and directives.
 */
var Watcher = function Watcher (
  vm,
  expOrFn,
  cb,
  options,
  isRenderWatcher
) {
  this.vm = vm;
  if (isRenderWatcher) {
    vm._watcher = this;
  }
  vm._watchers.push(this);
  // options
  if (options) {
    this.deep = !!options.deep;
    this.user = !!options.user;
    this.lazy = !!options.lazy;
    this.sync = !!options.sync;
    this.before = options.before;
  } else {
    this.deep = this.user = this.lazy = this.sync = false;
  }
  this.cb = cb;
  this.id = ++uid$2; // uid for batching
  this.active = true;
  this.dirty = this.lazy; // for lazy watchers
  this.deps = [];
  this.newDeps = [];
  this.depIds = new _Set();
  this.newDepIds = new _Set();
  this.expression =  false
    ? expOrFn.toString()
    : '';
  // parse expression for getter
  if (typeof expOrFn === 'function') {
    this.getter = expOrFn;
  } else {
    this.getter = parsePath(expOrFn);
    if (!this.getter) {
      this.getter = noop;
      "production" !== 'production' && warn(
        "Failed watching path: \"" + expOrFn + "\" " +
        'Watcher only accepts simple dot-delimited paths. ' +
        'For full control, use a function instead.',
        vm
      );
    }
  }
  this.value = this.lazy
    ? undefined
    : this.get();
};

/**
 * Evaluate the getter, and re-collect dependencies.
 */
Watcher.prototype.get = function get () {
  pushTarget(this);
  var value;
  var vm = this.vm;
  try {
    value = this.getter.call(vm, vm);
  } catch (e) {
    if (this.user) {
      handleError(e, vm, ("getter for watcher \"" + (this.expression) + "\""));
    } else {
      throw e
    }
  } finally {
    // "touch" every property so they are all tracked as
    // dependencies for deep watching
    if (this.deep) {
      traverse(value);
    }
    popTarget();
    this.cleanupDeps();
  }
  return value
};

/**
 * Add a dependency to this directive.
 */
Watcher.prototype.addDep = function addDep (dep) {
  var id = dep.id;
  if (!this.newDepIds.has(id)) {
    this.newDepIds.add(id);
    this.newDeps.push(dep);
    if (!this.depIds.has(id)) {
      dep.addSub(this);
    }
  }
};

/**
 * Clean up for dependency collection.
 */
Watcher.prototype.cleanupDeps = function cleanupDeps () {
  var i = this.deps.length;
  while (i--) {
    var dep = this.deps[i];
    if (!this.newDepIds.has(dep.id)) {
      dep.removeSub(this);
    }
  }
  var tmp = this.depIds;
  this.depIds = this.newDepIds;
  this.newDepIds = tmp;
  this.newDepIds.clear();
  tmp = this.deps;
  this.deps = this.newDeps;
  this.newDeps = tmp;
  this.newDeps.length = 0;
};

/**
 * Subscriber interface.
 * Will be called when a dependency changes.
 */
Watcher.prototype.update = function update () {
  /* istanbul ignore else */
  if (this.lazy) {
    this.dirty = true;
  } else if (this.sync) {
    this.run();
  } else {
    queueWatcher(this);
  }
};

/**
 * Scheduler job interface.
 * Will be called by the scheduler.
 */
Watcher.prototype.run = function run () {
  if (this.active) {
    var value = this.get();
    if (
      value !== this.value ||
      // Deep watchers and watchers on Object/Arrays should fire even
      // when the value is the same, because the value may
      // have mutated.
      isObject(value) ||
      this.deep
    ) {
      // set new value
      var oldValue = this.value;
      this.value = value;
      if (this.user) {
        try {
          this.cb.call(this.vm, value, oldValue);
        } catch (e) {
          handleError(e, this.vm, ("callback for watcher \"" + (this.expression) + "\""));
        }
      } else {
        this.cb.call(this.vm, value, oldValue);
      }
    }
  }
};

/**
 * Evaluate the value of the watcher.
 * This only gets called for lazy watchers.
 */
Watcher.prototype.evaluate = function evaluate () {
  this.value = this.get();
  this.dirty = false;
};

/**
 * Depend on all deps collected by this watcher.
 */
Watcher.prototype.depend = function depend () {
  var i = this.deps.length;
  while (i--) {
    this.deps[i].depend();
  }
};

/**
 * Remove self from all dependencies' subscriber list.
 */
Watcher.prototype.teardown = function teardown () {
  if (this.active) {
    // remove self from vm's watcher list
    // this is a somewhat expensive operation so we skip it
    // if the vm is being destroyed.
    if (!this.vm._isBeingDestroyed) {
      remove(this.vm._watchers, this);
    }
    var i = this.deps.length;
    while (i--) {
      this.deps[i].removeSub(this);
    }
    this.active = false;
  }
};

/*  */

var sharedPropertyDefinition = {
  enumerable: true,
  configurable: true,
  get: noop,
  set: noop
};

function proxy (target, sourceKey, key) {
  sharedPropertyDefinition.get = function proxyGetter () {
    return this[sourceKey][key]
  };
  sharedPropertyDefinition.set = function proxySetter (val) {
    this[sourceKey][key] = val;
  };
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function initState (vm) {
  vm._watchers = [];
  var opts = vm.$options;
  if (opts.props) { initProps(vm, opts.props); }
  if (opts.methods) { initMethods(vm, opts.methods); }
  if (opts.data) {
    initData(vm);
  } else {
    observe(vm._data = {}, true /* asRootData */);
  }
  if (opts.computed) { initComputed(vm, opts.computed); }
  if (opts.watch && opts.watch !== nativeWatch) {
    initWatch(vm, opts.watch);
  }
}

function initProps (vm, propsOptions) {
  var propsData = vm.$options.propsData || {};
  var props = vm._props = {};
  // cache prop keys so that future props updates can iterate using Array
  // instead of dynamic object key enumeration.
  var keys = vm.$options._propKeys = [];
  var isRoot = !vm.$parent;
  // root instance props should be converted
  if (!isRoot) {
    toggleObserving(false);
  }
  var loop = function ( key ) {
    keys.push(key);
    var value = validateProp(key, propsOptions, propsData, vm);
    /* istanbul ignore else */
    if (false) {
      var hyphenatedKey = hyphenate(key);
      if (isReservedAttribute(hyphenatedKey) ||
          config.isReservedAttr(hyphenatedKey)) {
        warn(
          ("\"" + hyphenatedKey + "\" is a reserved attribute and cannot be used as component prop."),
          vm
        );
      }
      defineReactive$$1(props, key, value, function () {
        if (!isRoot && !isUpdatingChildComponent) {
          warn(
            "Avoid mutating a prop directly since the value will be " +
            "overwritten whenever the parent component re-renders. " +
            "Instead, use a data or computed property based on the prop's " +
            "value. Prop being mutated: \"" + key + "\"",
            vm
          );
        }
      });
    } else {
      defineReactive$$1(props, key, value);
    }
    // static props are already proxied on the component's prototype
    // during Vue.extend(). We only need to proxy props defined at
    // instantiation here.
    if (!(key in vm)) {
      proxy(vm, "_props", key);
    }
  };

  for (var key in propsOptions) loop( key );
  toggleObserving(true);
}

function initData (vm) {
  var data = vm.$options.data;
  data = vm._data = typeof data === 'function'
    ? getData(data, vm)
    : data || {};
  if (!isPlainObject(data)) {
    data = {};
    "production" !== 'production' && warn(
      'data functions should return an object:\n' +
      'https://vuejs.org/v2/guide/components.html#data-Must-Be-a-Function',
      vm
    );
  }
  // proxy data on instance
  var keys = Object.keys(data);
  var props = vm.$options.props;
  var methods = vm.$options.methods;
  var i = keys.length;
  while (i--) {
    var key = keys[i];
    if (false) {
      if (methods && hasOwn(methods, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a data property."),
          vm
        );
      }
    }
    if (props && hasOwn(props, key)) {
      "production" !== 'production' && warn(
        "The data property \"" + key + "\" is already declared as a prop. " +
        "Use prop default value instead.",
        vm
      );
    } else if (!isReserved(key)) {
      proxy(vm, "_data", key);
    }
  }
  // observe data
  observe(data, true /* asRootData */);
}

function getData (data, vm) {
  // #7573 disable dep collection when invoking data getters
  pushTarget();
  try {
    return data.call(vm, vm)
  } catch (e) {
    handleError(e, vm, "data()");
    return {}
  } finally {
    popTarget();
  }
}

var computedWatcherOptions = { lazy: true };

function initComputed (vm, computed) {
  // $flow-disable-line
  var watchers = vm._computedWatchers = Object.create(null);
  // computed properties are just getters during SSR
  var isSSR = isServerRendering();

  for (var key in computed) {
    var userDef = computed[key];
    var getter = typeof userDef === 'function' ? userDef : userDef.get;
    if (false) {
      warn(
        ("Getter is missing for computed property \"" + key + "\"."),
        vm
      );
    }

    if (!isSSR) {
      // create internal watcher for the computed property.
      watchers[key] = new Watcher(
        vm,
        getter || noop,
        noop,
        computedWatcherOptions
      );
    }

    // component-defined computed properties are already defined on the
    // component prototype. We only need to define computed properties defined
    // at instantiation here.
    if (!(key in vm)) {
      defineComputed(vm, key, userDef);
    } else if (false) {
      if (key in vm.$data) {
        warn(("The computed property \"" + key + "\" is already defined in data."), vm);
      } else if (vm.$options.props && key in vm.$options.props) {
        warn(("The computed property \"" + key + "\" is already defined as a prop."), vm);
      }
    }
  }
}

function defineComputed (
  target,
  key,
  userDef
) {
  var shouldCache = !isServerRendering();
  if (typeof userDef === 'function') {
    sharedPropertyDefinition.get = shouldCache
      ? createComputedGetter(key)
      : createGetterInvoker(userDef);
    sharedPropertyDefinition.set = noop;
  } else {
    sharedPropertyDefinition.get = userDef.get
      ? shouldCache && userDef.cache !== false
        ? createComputedGetter(key)
        : createGetterInvoker(userDef.get)
      : noop;
    sharedPropertyDefinition.set = userDef.set || noop;
  }
  if (false) {
    sharedPropertyDefinition.set = function () {
      warn(
        ("Computed property \"" + key + "\" was assigned to but it has no setter."),
        this
      );
    };
  }
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function createComputedGetter (key) {
  return function computedGetter () {
    var watcher = this._computedWatchers && this._computedWatchers[key];
    if (watcher) {
      if (watcher.dirty) {
        watcher.evaluate();
      }
      if (Dep.target) {
        watcher.depend();
      }
      return watcher.value
    }
  }
}

function createGetterInvoker(fn) {
  return function computedGetter () {
    return fn.call(this, this)
  }
}

function initMethods (vm, methods) {
  var props = vm.$options.props;
  for (var key in methods) {
    if (false) {
      if (typeof methods[key] !== 'function') {
        warn(
          "Method \"" + key + "\" has type \"" + (typeof methods[key]) + "\" in the component definition. " +
          "Did you reference the function correctly?",
          vm
        );
      }
      if (props && hasOwn(props, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a prop."),
          vm
        );
      }
      if ((key in vm) && isReserved(key)) {
        warn(
          "Method \"" + key + "\" conflicts with an existing Vue instance method. " +
          "Avoid defining component methods that start with _ or $."
        );
      }
    }
    vm[key] = typeof methods[key] !== 'function' ? noop : bind(methods[key], vm);
  }
}

function initWatch (vm, watch) {
  for (var key in watch) {
    var handler = watch[key];
    if (Array.isArray(handler)) {
      for (var i = 0; i < handler.length; i++) {
        createWatcher(vm, key, handler[i]);
      }
    } else {
      createWatcher(vm, key, handler);
    }
  }
}

function createWatcher (
  vm,
  expOrFn,
  handler,
  options
) {
  if (isPlainObject(handler)) {
    options = handler;
    handler = handler.handler;
  }
  if (typeof handler === 'string') {
    handler = vm[handler];
  }
  return vm.$watch(expOrFn, handler, options)
}

function stateMixin (Vue) {
  // flow somehow has problems with directly declared definition object
  // when using Object.defineProperty, so we have to procedurally build up
  // the object here.
  var dataDef = {};
  dataDef.get = function () { return this._data };
  var propsDef = {};
  propsDef.get = function () { return this._props };
  if (false) {
    dataDef.set = function () {
      warn(
        'Avoid replacing instance root $data. ' +
        'Use nested data properties instead.',
        this
      );
    };
    propsDef.set = function () {
      warn("$props is readonly.", this);
    };
  }
  Object.defineProperty(Vue.prototype, '$data', dataDef);
  Object.defineProperty(Vue.prototype, '$props', propsDef);

  Vue.prototype.$set = set;
  Vue.prototype.$delete = del;

  Vue.prototype.$watch = function (
    expOrFn,
    cb,
    options
  ) {
    var vm = this;
    if (isPlainObject(cb)) {
      return createWatcher(vm, expOrFn, cb, options)
    }
    options = options || {};
    options.user = true;
    var watcher = new Watcher(vm, expOrFn, cb, options);
    if (options.immediate) {
      try {
        cb.call(vm, watcher.value);
      } catch (error) {
        handleError(error, vm, ("callback for immediate watcher \"" + (watcher.expression) + "\""));
      }
    }
    return function unwatchFn () {
      watcher.teardown();
    }
  };
}

/*  */

var uid$3 = 0;

function initMixin (Vue) {
  Vue.prototype._init = function (options) {
    var vm = this;
    // a uid
    vm._uid = uid$3++;

    var startTag, endTag;
    /* istanbul ignore if */
    if (false) {
      startTag = "vue-perf-start:" + (vm._uid);
      endTag = "vue-perf-end:" + (vm._uid);
      mark(startTag);
    }

    // a flag to avoid this being observed
    vm._isVue = true;
    // merge options
    if (options && options._isComponent) {
      // optimize internal component instantiation
      // since dynamic options merging is pretty slow, and none of the
      // internal component options needs special treatment.
      initInternalComponent(vm, options);
    } else {
      vm.$options = mergeOptions(
        resolveConstructorOptions(vm.constructor),
        options || {},
        vm
      );
    }
    /* istanbul ignore else */
    if (false) {
      initProxy(vm);
    } else {
      vm._renderProxy = vm;
    }
    // expose real self
    vm._self = vm;
    initLifecycle(vm);
    initEvents(vm);
    initRender(vm);
    callHook(vm, 'beforeCreate');
    initInjections(vm); // resolve injections before data/props
    initState(vm);
    initProvide(vm); // resolve provide after data/props
    callHook(vm, 'created');

    /* istanbul ignore if */
    if (false) {
      vm._name = formatComponentName(vm, false);
      mark(endTag);
      measure(("vue " + (vm._name) + " init"), startTag, endTag);
    }

    if (vm.$options.el) {
      vm.$mount(vm.$options.el);
    }
  };
}

function initInternalComponent (vm, options) {
  var opts = vm.$options = Object.create(vm.constructor.options);
  // doing this because it's faster than dynamic enumeration.
  var parentVnode = options._parentVnode;
  opts.parent = options.parent;
  opts._parentVnode = parentVnode;

  var vnodeComponentOptions = parentVnode.componentOptions;
  opts.propsData = vnodeComponentOptions.propsData;
  opts._parentListeners = vnodeComponentOptions.listeners;
  opts._renderChildren = vnodeComponentOptions.children;
  opts._componentTag = vnodeComponentOptions.tag;

  if (options.render) {
    opts.render = options.render;
    opts.staticRenderFns = options.staticRenderFns;
  }
}

function resolveConstructorOptions (Ctor) {
  var options = Ctor.options;
  if (Ctor.super) {
    var superOptions = resolveConstructorOptions(Ctor.super);
    var cachedSuperOptions = Ctor.superOptions;
    if (superOptions !== cachedSuperOptions) {
      // super option changed,
      // need to resolve new options.
      Ctor.superOptions = superOptions;
      // check if there are any late-modified/attached options (#4976)
      var modifiedOptions = resolveModifiedOptions(Ctor);
      // update base extend options
      if (modifiedOptions) {
        extend(Ctor.extendOptions, modifiedOptions);
      }
      options = Ctor.options = mergeOptions(superOptions, Ctor.extendOptions);
      if (options.name) {
        options.components[options.name] = Ctor;
      }
    }
  }
  return options
}

function resolveModifiedOptions (Ctor) {
  var modified;
  var latest = Ctor.options;
  var sealed = Ctor.sealedOptions;
  for (var key in latest) {
    if (latest[key] !== sealed[key]) {
      if (!modified) { modified = {}; }
      modified[key] = latest[key];
    }
  }
  return modified
}

function Vue (options) {
  if (false
  ) {
    warn('Vue is a constructor and should be called with the `new` keyword');
  }
  this._init(options);
}

initMixin(Vue);
stateMixin(Vue);
eventsMixin(Vue);
lifecycleMixin(Vue);
renderMixin(Vue);

/*  */

function initUse (Vue) {
  Vue.use = function (plugin) {
    var installedPlugins = (this._installedPlugins || (this._installedPlugins = []));
    if (installedPlugins.indexOf(plugin) > -1) {
      return this
    }

    // additional parameters
    var args = toArray(arguments, 1);
    args.unshift(this);
    if (typeof plugin.install === 'function') {
      plugin.install.apply(plugin, args);
    } else if (typeof plugin === 'function') {
      plugin.apply(null, args);
    }
    installedPlugins.push(plugin);
    return this
  };
}

/*  */

function initMixin$1 (Vue) {
  Vue.mixin = function (mixin) {
    this.options = mergeOptions(this.options, mixin);
    return this
  };
}

/*  */

function initExtend (Vue) {
  /**
   * Each instance constructor, including Vue, has a unique
   * cid. This enables us to create wrapped "child
   * constructors" for prototypal inheritance and cache them.
   */
  Vue.cid = 0;
  var cid = 1;

  /**
   * Class inheritance
   */
  Vue.extend = function (extendOptions) {
    extendOptions = extendOptions || {};
    var Super = this;
    var SuperId = Super.cid;
    var cachedCtors = extendOptions._Ctor || (extendOptions._Ctor = {});
    if (cachedCtors[SuperId]) {
      return cachedCtors[SuperId]
    }

    var name = extendOptions.name || Super.options.name;
    if (false) {
      validateComponentName(name);
    }

    var Sub = function VueComponent (options) {
      this._init(options);
    };
    Sub.prototype = Object.create(Super.prototype);
    Sub.prototype.constructor = Sub;
    Sub.cid = cid++;
    Sub.options = mergeOptions(
      Super.options,
      extendOptions
    );
    Sub['super'] = Super;

    // For props and computed properties, we define the proxy getters on
    // the Vue instances at extension time, on the extended prototype. This
    // avoids Object.defineProperty calls for each instance created.
    if (Sub.options.props) {
      initProps$1(Sub);
    }
    if (Sub.options.computed) {
      initComputed$1(Sub);
    }

    // allow further extension/mixin/plugin usage
    Sub.extend = Super.extend;
    Sub.mixin = Super.mixin;
    Sub.use = Super.use;

    // create asset registers, so extended classes
    // can have their private assets too.
    ASSET_TYPES.forEach(function (type) {
      Sub[type] = Super[type];
    });
    // enable recursive self-lookup
    if (name) {
      Sub.options.components[name] = Sub;
    }

    // keep a reference to the super options at extension time.
    // later at instantiation we can check if Super's options have
    // been updated.
    Sub.superOptions = Super.options;
    Sub.extendOptions = extendOptions;
    Sub.sealedOptions = extend({}, Sub.options);

    // cache constructor
    cachedCtors[SuperId] = Sub;
    return Sub
  };
}

function initProps$1 (Comp) {
  var props = Comp.options.props;
  for (var key in props) {
    proxy(Comp.prototype, "_props", key);
  }
}

function initComputed$1 (Comp) {
  var computed = Comp.options.computed;
  for (var key in computed) {
    defineComputed(Comp.prototype, key, computed[key]);
  }
}

/*  */

function initAssetRegisters (Vue) {
  /**
   * Create asset registration methods.
   */
  ASSET_TYPES.forEach(function (type) {
    Vue[type] = function (
      id,
      definition
    ) {
      if (!definition) {
        return this.options[type + 's'][id]
      } else {
        /* istanbul ignore if */
        if (false) {
          validateComponentName(id);
        }
        if (type === 'component' && isPlainObject(definition)) {
          definition.name = definition.name || id;
          definition = this.options._base.extend(definition);
        }
        if (type === 'directive' && typeof definition === 'function') {
          definition = { bind: definition, update: definition };
        }
        this.options[type + 's'][id] = definition;
        return definition
      }
    };
  });
}

/*  */



function getComponentName (opts) {
  return opts && (opts.Ctor.options.name || opts.tag)
}

function matches (pattern, name) {
  if (Array.isArray(pattern)) {
    return pattern.indexOf(name) > -1
  } else if (typeof pattern === 'string') {
    return pattern.split(',').indexOf(name) > -1
  } else if (isRegExp(pattern)) {
    return pattern.test(name)
  }
  /* istanbul ignore next */
  return false
}

function pruneCache (keepAliveInstance, filter) {
  var cache = keepAliveInstance.cache;
  var keys = keepAliveInstance.keys;
  var _vnode = keepAliveInstance._vnode;
  for (var key in cache) {
    var cachedNode = cache[key];
    if (cachedNode) {
      var name = getComponentName(cachedNode.componentOptions);
      if (name && !filter(name)) {
        pruneCacheEntry(cache, key, keys, _vnode);
      }
    }
  }
}

function pruneCacheEntry (
  cache,
  key,
  keys,
  current
) {
  var cached$$1 = cache[key];
  if (cached$$1 && (!current || cached$$1.tag !== current.tag)) {
    cached$$1.componentInstance.$destroy();
  }
  cache[key] = null;
  remove(keys, key);
}

var patternTypes = [String, RegExp, Array];

var KeepAlive = {
  name: 'keep-alive',
  abstract: true,

  props: {
    include: patternTypes,
    exclude: patternTypes,
    max: [String, Number]
  },

  created: function created () {
    this.cache = Object.create(null);
    this.keys = [];
  },

  destroyed: function destroyed () {
    for (var key in this.cache) {
      pruneCacheEntry(this.cache, key, this.keys);
    }
  },

  mounted: function mounted () {
    var this$1 = this;

    this.$watch('include', function (val) {
      pruneCache(this$1, function (name) { return matches(val, name); });
    });
    this.$watch('exclude', function (val) {
      pruneCache(this$1, function (name) { return !matches(val, name); });
    });
  },

  render: function render () {
    var slot = this.$slots.default;
    var vnode = getFirstComponentChild(slot);
    var componentOptions = vnode && vnode.componentOptions;
    if (componentOptions) {
      // check pattern
      var name = getComponentName(componentOptions);
      var ref = this;
      var include = ref.include;
      var exclude = ref.exclude;
      if (
        // not included
        (include && (!name || !matches(include, name))) ||
        // excluded
        (exclude && name && matches(exclude, name))
      ) {
        return vnode
      }

      var ref$1 = this;
      var cache = ref$1.cache;
      var keys = ref$1.keys;
      var key = vnode.key == null
        // same constructor may get registered as different local components
        // so cid alone is not enough (#3269)
        ? componentOptions.Ctor.cid + (componentOptions.tag ? ("::" + (componentOptions.tag)) : '')
        : vnode.key;
      if (cache[key]) {
        vnode.componentInstance = cache[key].componentInstance;
        // make current key freshest
        remove(keys, key);
        keys.push(key);
      } else {
        cache[key] = vnode;
        keys.push(key);
        // prune oldest entry
        if (this.max && keys.length > parseInt(this.max)) {
          pruneCacheEntry(cache, keys[0], keys, this._vnode);
        }
      }

      vnode.data.keepAlive = true;
    }
    return vnode || (slot && slot[0])
  }
};

var builtInComponents = {
  KeepAlive: KeepAlive
};

/*  */

function initGlobalAPI (Vue) {
  // config
  var configDef = {};
  configDef.get = function () { return config; };
  if (false) {
    configDef.set = function () {
      warn(
        'Do not replace the Vue.config object, set individual fields instead.'
      );
    };
  }
  Object.defineProperty(Vue, 'config', configDef);

  // exposed util methods.
  // NOTE: these are not considered part of the public API - avoid relying on
  // them unless you are aware of the risk.
  Vue.util = {
    warn: warn,
    extend: extend,
    mergeOptions: mergeOptions,
    defineReactive: defineReactive$$1
  };

  Vue.set = set;
  Vue.delete = del;
  Vue.nextTick = nextTick;

  // 2.6 explicit observable API
  Vue.observable = function (obj) {
    observe(obj);
    return obj
  };

  Vue.options = Object.create(null);
  ASSET_TYPES.forEach(function (type) {
    Vue.options[type + 's'] = Object.create(null);
  });

  // this is used to identify the "base" constructor to extend all plain-object
  // components with in Weex's multi-instance scenarios.
  Vue.options._base = Vue;

  extend(Vue.options.components, builtInComponents);

  initUse(Vue);
  initMixin$1(Vue);
  initExtend(Vue);
  initAssetRegisters(Vue);
}

initGlobalAPI(Vue);

Object.defineProperty(Vue.prototype, '$isServer', {
  get: isServerRendering
});

Object.defineProperty(Vue.prototype, '$ssrContext', {
  get: function get () {
    /* istanbul ignore next */
    return this.$vnode && this.$vnode.ssrContext
  }
});

// expose FunctionalRenderContext for ssr runtime helper installation
Object.defineProperty(Vue, 'FunctionalRenderContext', {
  value: FunctionalRenderContext
});

Vue.version = '2.6.12';

/*  */

// these are reserved for web because they are directly compiled away
// during template compilation
var isReservedAttr = makeMap('style,class');

// attributes that should be using props for binding
var acceptValue = makeMap('input,textarea,option,select,progress');
var mustUseProp = function (tag, type, attr) {
  return (
    (attr === 'value' && acceptValue(tag)) && type !== 'button' ||
    (attr === 'selected' && tag === 'option') ||
    (attr === 'checked' && tag === 'input') ||
    (attr === 'muted' && tag === 'video')
  )
};

var isEnumeratedAttr = makeMap('contenteditable,draggable,spellcheck');

var isValidContentEditableValue = makeMap('events,caret,typing,plaintext-only');

var convertEnumeratedValue = function (key, value) {
  return isFalsyAttrValue(value) || value === 'false'
    ? 'false'
    // allow arbitrary string value for contenteditable
    : key === 'contenteditable' && isValidContentEditableValue(value)
      ? value
      : 'true'
};

var isBooleanAttr = makeMap(
  'allowfullscreen,async,autofocus,autoplay,checked,compact,controls,declare,' +
  'default,defaultchecked,defaultmuted,defaultselected,defer,disabled,' +
  'enabled,formnovalidate,hidden,indeterminate,inert,ismap,itemscope,loop,multiple,' +
  'muted,nohref,noresize,noshade,novalidate,nowrap,open,pauseonexit,readonly,' +
  'required,reversed,scoped,seamless,selected,sortable,translate,' +
  'truespeed,typemustmatch,visible'
);

var xlinkNS = 'http://www.w3.org/1999/xlink';

var isXlink = function (name) {
  return name.charAt(5) === ':' && name.slice(0, 5) === 'xlink'
};

var getXlinkProp = function (name) {
  return isXlink(name) ? name.slice(6, name.length) : ''
};

var isFalsyAttrValue = function (val) {
  return val == null || val === false
};

/*  */

function genClassForVnode (vnode) {
  var data = vnode.data;
  var parentNode = vnode;
  var childNode = vnode;
  while (isDef(childNode.componentInstance)) {
    childNode = childNode.componentInstance._vnode;
    if (childNode && childNode.data) {
      data = mergeClassData(childNode.data, data);
    }
  }
  while (isDef(parentNode = parentNode.parent)) {
    if (parentNode && parentNode.data) {
      data = mergeClassData(data, parentNode.data);
    }
  }
  return renderClass(data.staticClass, data.class)
}

function mergeClassData (child, parent) {
  return {
    staticClass: concat(child.staticClass, parent.staticClass),
    class: isDef(child.class)
      ? [child.class, parent.class]
      : parent.class
  }
}

function renderClass (
  staticClass,
  dynamicClass
) {
  if (isDef(staticClass) || isDef(dynamicClass)) {
    return concat(staticClass, stringifyClass(dynamicClass))
  }
  /* istanbul ignore next */
  return ''
}

function concat (a, b) {
  return a ? b ? (a + ' ' + b) : a : (b || '')
}

function stringifyClass (value) {
  if (Array.isArray(value)) {
    return stringifyArray(value)
  }
  if (isObject(value)) {
    return stringifyObject(value)
  }
  if (typeof value === 'string') {
    return value
  }
  /* istanbul ignore next */
  return ''
}

function stringifyArray (value) {
  var res = '';
  var stringified;
  for (var i = 0, l = value.length; i < l; i++) {
    if (isDef(stringified = stringifyClass(value[i])) && stringified !== '') {
      if (res) { res += ' '; }
      res += stringified;
    }
  }
  return res
}

function stringifyObject (value) {
  var res = '';
  for (var key in value) {
    if (value[key]) {
      if (res) { res += ' '; }
      res += key;
    }
  }
  return res
}

/*  */

var namespaceMap = {
  svg: 'http://www.w3.org/2000/svg',
  math: 'http://www.w3.org/1998/Math/MathML'
};

var isHTMLTag = makeMap(
  'html,body,base,head,link,meta,style,title,' +
  'address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,hgroup,nav,section,' +
  'div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,' +
  'a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,rtc,ruby,' +
  's,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,' +
  'embed,object,param,source,canvas,script,noscript,del,ins,' +
  'caption,col,colgroup,table,thead,tbody,td,th,tr,' +
  'button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,' +
  'output,progress,select,textarea,' +
  'details,dialog,menu,menuitem,summary,' +
  'content,element,shadow,template,blockquote,iframe,tfoot'
);

// this map is intentionally selective, only covering SVG elements that may
// contain child elements.
var isSVG = makeMap(
  'svg,animate,circle,clippath,cursor,defs,desc,ellipse,filter,font-face,' +
  'foreignObject,g,glyph,image,line,marker,mask,missing-glyph,path,pattern,' +
  'polygon,polyline,rect,switch,symbol,text,textpath,tspan,use,view',
  true
);

var isPreTag = function (tag) { return tag === 'pre'; };

var isReservedTag = function (tag) {
  return isHTMLTag(tag) || isSVG(tag)
};

function getTagNamespace (tag) {
  if (isSVG(tag)) {
    return 'svg'
  }
  // basic support for MathML
  // note it doesn't support other MathML elements being component roots
  if (tag === 'math') {
    return 'math'
  }
}

var unknownElementCache = Object.create(null);
function isUnknownElement (tag) {
  /* istanbul ignore if */
  if (!inBrowser) {
    return true
  }
  if (isReservedTag(tag)) {
    return false
  }
  tag = tag.toLowerCase();
  /* istanbul ignore if */
  if (unknownElementCache[tag] != null) {
    return unknownElementCache[tag]
  }
  var el = document.createElement(tag);
  if (tag.indexOf('-') > -1) {
    // http://stackoverflow.com/a/28210364/1070244
    return (unknownElementCache[tag] = (
      el.constructor === window.HTMLUnknownElement ||
      el.constructor === window.HTMLElement
    ))
  } else {
    return (unknownElementCache[tag] = /HTMLUnknownElement/.test(el.toString()))
  }
}

var isTextInputType = makeMap('text,number,password,search,email,tel,url');

/*  */

/**
 * Query an element selector if it's not an element already.
 */
function query (el) {
  if (typeof el === 'string') {
    var selected = document.querySelector(el);
    if (!selected) {
      "production" !== 'production' && warn(
        'Cannot find element: ' + el
      );
      return document.createElement('div')
    }
    return selected
  } else {
    return el
  }
}

/*  */

function createElement$1 (tagName, vnode) {
  var elm = document.createElement(tagName);
  if (tagName !== 'select') {
    return elm
  }
  // false or null will remove the attribute but undefined will not
  if (vnode.data && vnode.data.attrs && vnode.data.attrs.multiple !== undefined) {
    elm.setAttribute('multiple', 'multiple');
  }
  return elm
}

function createElementNS (namespace, tagName) {
  return document.createElementNS(namespaceMap[namespace], tagName)
}

function createTextNode (text) {
  return document.createTextNode(text)
}

function createComment (text) {
  return document.createComment(text)
}

function insertBefore (parentNode, newNode, referenceNode) {
  parentNode.insertBefore(newNode, referenceNode);
}

function removeChild (node, child) {
  node.removeChild(child);
}

function appendChild (node, child) {
  node.appendChild(child);
}

function parentNode (node) {
  return node.parentNode
}

function nextSibling (node) {
  return node.nextSibling
}

function tagName (node) {
  return node.tagName
}

function setTextContent (node, text) {
  node.textContent = text;
}

function setStyleScope (node, scopeId) {
  node.setAttribute(scopeId, '');
}

var nodeOps = /*#__PURE__*/Object.freeze({
  createElement: createElement$1,
  createElementNS: createElementNS,
  createTextNode: createTextNode,
  createComment: createComment,
  insertBefore: insertBefore,
  removeChild: removeChild,
  appendChild: appendChild,
  parentNode: parentNode,
  nextSibling: nextSibling,
  tagName: tagName,
  setTextContent: setTextContent,
  setStyleScope: setStyleScope
});

/*  */

var ref = {
  create: function create (_, vnode) {
    registerRef(vnode);
  },
  update: function update (oldVnode, vnode) {
    if (oldVnode.data.ref !== vnode.data.ref) {
      registerRef(oldVnode, true);
      registerRef(vnode);
    }
  },
  destroy: function destroy (vnode) {
    registerRef(vnode, true);
  }
};

function registerRef (vnode, isRemoval) {
  var key = vnode.data.ref;
  if (!isDef(key)) { return }

  var vm = vnode.context;
  var ref = vnode.componentInstance || vnode.elm;
  var refs = vm.$refs;
  if (isRemoval) {
    if (Array.isArray(refs[key])) {
      remove(refs[key], ref);
    } else if (refs[key] === ref) {
      refs[key] = undefined;
    }
  } else {
    if (vnode.data.refInFor) {
      if (!Array.isArray(refs[key])) {
        refs[key] = [ref];
      } else if (refs[key].indexOf(ref) < 0) {
        // $flow-disable-line
        refs[key].push(ref);
      }
    } else {
      refs[key] = ref;
    }
  }
}

/**
 * Virtual DOM patching algorithm based on Snabbdom by
 * Simon Friis Vindum (@paldepind)
 * Licensed under the MIT License
 * https://github.com/paldepind/snabbdom/blob/master/LICENSE
 *
 * modified by Evan You (@yyx990803)
 *
 * Not type-checking this because this file is perf-critical and the cost
 * of making flow understand it is not worth it.
 */

var emptyNode = new VNode('', {}, []);

var hooks = ['create', 'activate', 'update', 'remove', 'destroy'];

function sameVnode (a, b) {
  return (
    a.key === b.key && (
      (
        a.tag === b.tag &&
        a.isComment === b.isComment &&
        isDef(a.data) === isDef(b.data) &&
        sameInputType(a, b)
      ) || (
        isTrue(a.isAsyncPlaceholder) &&
        a.asyncFactory === b.asyncFactory &&
        isUndef(b.asyncFactory.error)
      )
    )
  )
}

function sameInputType (a, b) {
  if (a.tag !== 'input') { return true }
  var i;
  var typeA = isDef(i = a.data) && isDef(i = i.attrs) && i.type;
  var typeB = isDef(i = b.data) && isDef(i = i.attrs) && i.type;
  return typeA === typeB || isTextInputType(typeA) && isTextInputType(typeB)
}

function createKeyToOldIdx (children, beginIdx, endIdx) {
  var i, key;
  var map = {};
  for (i = beginIdx; i <= endIdx; ++i) {
    key = children[i].key;
    if (isDef(key)) { map[key] = i; }
  }
  return map
}

function createPatchFunction (backend) {
  var i, j;
  var cbs = {};

  var modules = backend.modules;
  var nodeOps = backend.nodeOps;

  for (i = 0; i < hooks.length; ++i) {
    cbs[hooks[i]] = [];
    for (j = 0; j < modules.length; ++j) {
      if (isDef(modules[j][hooks[i]])) {
        cbs[hooks[i]].push(modules[j][hooks[i]]);
      }
    }
  }

  function emptyNodeAt (elm) {
    return new VNode(nodeOps.tagName(elm).toLowerCase(), {}, [], undefined, elm)
  }

  function createRmCb (childElm, listeners) {
    function remove$$1 () {
      if (--remove$$1.listeners === 0) {
        removeNode(childElm);
      }
    }
    remove$$1.listeners = listeners;
    return remove$$1
  }

  function removeNode (el) {
    var parent = nodeOps.parentNode(el);
    // element may have already been removed due to v-html / v-text
    if (isDef(parent)) {
      nodeOps.removeChild(parent, el);
    }
  }

  function isUnknownElement$$1 (vnode, inVPre) {
    return (
      !inVPre &&
      !vnode.ns &&
      !(
        config.ignoredElements.length &&
        config.ignoredElements.some(function (ignore) {
          return isRegExp(ignore)
            ? ignore.test(vnode.tag)
            : ignore === vnode.tag
        })
      ) &&
      config.isUnknownElement(vnode.tag)
    )
  }

  var creatingElmInVPre = 0;

  function createElm (
    vnode,
    insertedVnodeQueue,
    parentElm,
    refElm,
    nested,
    ownerArray,
    index
  ) {
    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // This vnode was used in a previous render!
      // now it's used as a new node, overwriting its elm would cause
      // potential patch errors down the road when it's used as an insertion
      // reference node. Instead, we clone the node on-demand before creating
      // associated DOM element for it.
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    vnode.isRootInsert = !nested; // for transition enter check
    if (createComponent(vnode, insertedVnodeQueue, parentElm, refElm)) {
      return
    }

    var data = vnode.data;
    var children = vnode.children;
    var tag = vnode.tag;
    if (isDef(tag)) {
      if (false) {
        if (data && data.pre) {
          creatingElmInVPre++;
        }
        if (isUnknownElement$$1(vnode, creatingElmInVPre)) {
          warn(
            'Unknown custom element: <' + tag + '> - did you ' +
            'register the component correctly? For recursive components, ' +
            'make sure to provide the "name" option.',
            vnode.context
          );
        }
      }

      vnode.elm = vnode.ns
        ? nodeOps.createElementNS(vnode.ns, tag)
        : nodeOps.createElement(tag, vnode);
      setScope(vnode);

      /* istanbul ignore if */
      {
        createChildren(vnode, children, insertedVnodeQueue);
        if (isDef(data)) {
          invokeCreateHooks(vnode, insertedVnodeQueue);
        }
        insert(parentElm, vnode.elm, refElm);
      }

      if (false) {
        creatingElmInVPre--;
      }
    } else if (isTrue(vnode.isComment)) {
      vnode.elm = nodeOps.createComment(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    } else {
      vnode.elm = nodeOps.createTextNode(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    }
  }

  function createComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i = vnode.data;
    if (isDef(i)) {
      var isReactivated = isDef(vnode.componentInstance) && i.keepAlive;
      if (isDef(i = i.hook) && isDef(i = i.init)) {
        i(vnode, false /* hydrating */);
      }
      // after calling the init hook, if the vnode is a child component
      // it should've created a child instance and mounted it. the child
      // component also has set the placeholder vnode's elm.
      // in that case we can just return the element and be done.
      if (isDef(vnode.componentInstance)) {
        initComponent(vnode, insertedVnodeQueue);
        insert(parentElm, vnode.elm, refElm);
        if (isTrue(isReactivated)) {
          reactivateComponent(vnode, insertedVnodeQueue, parentElm, refElm);
        }
        return true
      }
    }
  }

  function initComponent (vnode, insertedVnodeQueue) {
    if (isDef(vnode.data.pendingInsert)) {
      insertedVnodeQueue.push.apply(insertedVnodeQueue, vnode.data.pendingInsert);
      vnode.data.pendingInsert = null;
    }
    vnode.elm = vnode.componentInstance.$el;
    if (isPatchable(vnode)) {
      invokeCreateHooks(vnode, insertedVnodeQueue);
      setScope(vnode);
    } else {
      // empty component root.
      // skip all element-related modules except for ref (#3455)
      registerRef(vnode);
      // make sure to invoke the insert hook
      insertedVnodeQueue.push(vnode);
    }
  }

  function reactivateComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i;
    // hack for #4339: a reactivated component with inner transition
    // does not trigger because the inner node's created hooks are not called
    // again. It's not ideal to involve module-specific logic in here but
    // there doesn't seem to be a better way to do it.
    var innerNode = vnode;
    while (innerNode.componentInstance) {
      innerNode = innerNode.componentInstance._vnode;
      if (isDef(i = innerNode.data) && isDef(i = i.transition)) {
        for (i = 0; i < cbs.activate.length; ++i) {
          cbs.activate[i](emptyNode, innerNode);
        }
        insertedVnodeQueue.push(innerNode);
        break
      }
    }
    // unlike a newly created component,
    // a reactivated keep-alive component doesn't insert itself
    insert(parentElm, vnode.elm, refElm);
  }

  function insert (parent, elm, ref$$1) {
    if (isDef(parent)) {
      if (isDef(ref$$1)) {
        if (nodeOps.parentNode(ref$$1) === parent) {
          nodeOps.insertBefore(parent, elm, ref$$1);
        }
      } else {
        nodeOps.appendChild(parent, elm);
      }
    }
  }

  function createChildren (vnode, children, insertedVnodeQueue) {
    if (Array.isArray(children)) {
      if (false) {
        checkDuplicateKeys(children);
      }
      for (var i = 0; i < children.length; ++i) {
        createElm(children[i], insertedVnodeQueue, vnode.elm, null, true, children, i);
      }
    } else if (isPrimitive(vnode.text)) {
      nodeOps.appendChild(vnode.elm, nodeOps.createTextNode(String(vnode.text)));
    }
  }

  function isPatchable (vnode) {
    while (vnode.componentInstance) {
      vnode = vnode.componentInstance._vnode;
    }
    return isDef(vnode.tag)
  }

  function invokeCreateHooks (vnode, insertedVnodeQueue) {
    for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
      cbs.create[i$1](emptyNode, vnode);
    }
    i = vnode.data.hook; // Reuse variable
    if (isDef(i)) {
      if (isDef(i.create)) { i.create(emptyNode, vnode); }
      if (isDef(i.insert)) { insertedVnodeQueue.push(vnode); }
    }
  }

  // set scope id attribute for scoped CSS.
  // this is implemented as a special case to avoid the overhead
  // of going through the normal attribute patching process.
  function setScope (vnode) {
    var i;
    if (isDef(i = vnode.fnScopeId)) {
      nodeOps.setStyleScope(vnode.elm, i);
    } else {
      var ancestor = vnode;
      while (ancestor) {
        if (isDef(i = ancestor.context) && isDef(i = i.$options._scopeId)) {
          nodeOps.setStyleScope(vnode.elm, i);
        }
        ancestor = ancestor.parent;
      }
    }
    // for slot content they should also get the scopeId from the host instance.
    if (isDef(i = activeInstance) &&
      i !== vnode.context &&
      i !== vnode.fnContext &&
      isDef(i = i.$options._scopeId)
    ) {
      nodeOps.setStyleScope(vnode.elm, i);
    }
  }

  function addVnodes (parentElm, refElm, vnodes, startIdx, endIdx, insertedVnodeQueue) {
    for (; startIdx <= endIdx; ++startIdx) {
      createElm(vnodes[startIdx], insertedVnodeQueue, parentElm, refElm, false, vnodes, startIdx);
    }
  }

  function invokeDestroyHook (vnode) {
    var i, j;
    var data = vnode.data;
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.destroy)) { i(vnode); }
      for (i = 0; i < cbs.destroy.length; ++i) { cbs.destroy[i](vnode); }
    }
    if (isDef(i = vnode.children)) {
      for (j = 0; j < vnode.children.length; ++j) {
        invokeDestroyHook(vnode.children[j]);
      }
    }
  }

  function removeVnodes (vnodes, startIdx, endIdx) {
    for (; startIdx <= endIdx; ++startIdx) {
      var ch = vnodes[startIdx];
      if (isDef(ch)) {
        if (isDef(ch.tag)) {
          removeAndInvokeRemoveHook(ch);
          invokeDestroyHook(ch);
        } else { // Text node
          removeNode(ch.elm);
        }
      }
    }
  }

  function removeAndInvokeRemoveHook (vnode, rm) {
    if (isDef(rm) || isDef(vnode.data)) {
      var i;
      var listeners = cbs.remove.length + 1;
      if (isDef(rm)) {
        // we have a recursively passed down rm callback
        // increase the listeners count
        rm.listeners += listeners;
      } else {
        // directly removing
        rm = createRmCb(vnode.elm, listeners);
      }
      // recursively invoke hooks on child component root node
      if (isDef(i = vnode.componentInstance) && isDef(i = i._vnode) && isDef(i.data)) {
        removeAndInvokeRemoveHook(i, rm);
      }
      for (i = 0; i < cbs.remove.length; ++i) {
        cbs.remove[i](vnode, rm);
      }
      if (isDef(i = vnode.data.hook) && isDef(i = i.remove)) {
        i(vnode, rm);
      } else {
        rm();
      }
    } else {
      removeNode(vnode.elm);
    }
  }

  function updateChildren (parentElm, oldCh, newCh, insertedVnodeQueue, removeOnly) {
    var oldStartIdx = 0;
    var newStartIdx = 0;
    var oldEndIdx = oldCh.length - 1;
    var oldStartVnode = oldCh[0];
    var oldEndVnode = oldCh[oldEndIdx];
    var newEndIdx = newCh.length - 1;
    var newStartVnode = newCh[0];
    var newEndVnode = newCh[newEndIdx];
    var oldKeyToIdx, idxInOld, vnodeToMove, refElm;

    // removeOnly is a special flag used only by <transition-group>
    // to ensure removed elements stay in correct relative positions
    // during leaving transitions
    var canMove = !removeOnly;

    if (false) {
      checkDuplicateKeys(newCh);
    }

    while (oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx) {
      if (isUndef(oldStartVnode)) {
        oldStartVnode = oldCh[++oldStartIdx]; // Vnode has been moved left
      } else if (isUndef(oldEndVnode)) {
        oldEndVnode = oldCh[--oldEndIdx];
      } else if (sameVnode(oldStartVnode, newStartVnode)) {
        patchVnode(oldStartVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        oldStartVnode = oldCh[++oldStartIdx];
        newStartVnode = newCh[++newStartIdx];
      } else if (sameVnode(oldEndVnode, newEndVnode)) {
        patchVnode(oldEndVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        oldEndVnode = oldCh[--oldEndIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldStartVnode, newEndVnode)) { // Vnode moved right
        patchVnode(oldStartVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        canMove && nodeOps.insertBefore(parentElm, oldStartVnode.elm, nodeOps.nextSibling(oldEndVnode.elm));
        oldStartVnode = oldCh[++oldStartIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldEndVnode, newStartVnode)) { // Vnode moved left
        patchVnode(oldEndVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        canMove && nodeOps.insertBefore(parentElm, oldEndVnode.elm, oldStartVnode.elm);
        oldEndVnode = oldCh[--oldEndIdx];
        newStartVnode = newCh[++newStartIdx];
      } else {
        if (isUndef(oldKeyToIdx)) { oldKeyToIdx = createKeyToOldIdx(oldCh, oldStartIdx, oldEndIdx); }
        idxInOld = isDef(newStartVnode.key)
          ? oldKeyToIdx[newStartVnode.key]
          : findIdxInOld(newStartVnode, oldCh, oldStartIdx, oldEndIdx);
        if (isUndef(idxInOld)) { // New element
          createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
        } else {
          vnodeToMove = oldCh[idxInOld];
          if (sameVnode(vnodeToMove, newStartVnode)) {
            patchVnode(vnodeToMove, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
            oldCh[idxInOld] = undefined;
            canMove && nodeOps.insertBefore(parentElm, vnodeToMove.elm, oldStartVnode.elm);
          } else {
            // same key but different element. treat as new element
            createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
          }
        }
        newStartVnode = newCh[++newStartIdx];
      }
    }
    if (oldStartIdx > oldEndIdx) {
      refElm = isUndef(newCh[newEndIdx + 1]) ? null : newCh[newEndIdx + 1].elm;
      addVnodes(parentElm, refElm, newCh, newStartIdx, newEndIdx, insertedVnodeQueue);
    } else if (newStartIdx > newEndIdx) {
      removeVnodes(oldCh, oldStartIdx, oldEndIdx);
    }
  }

  function checkDuplicateKeys (children) {
    var seenKeys = {};
    for (var i = 0; i < children.length; i++) {
      var vnode = children[i];
      var key = vnode.key;
      if (isDef(key)) {
        if (seenKeys[key]) {
          warn(
            ("Duplicate keys detected: '" + key + "'. This may cause an update error."),
            vnode.context
          );
        } else {
          seenKeys[key] = true;
        }
      }
    }
  }

  function findIdxInOld (node, oldCh, start, end) {
    for (var i = start; i < end; i++) {
      var c = oldCh[i];
      if (isDef(c) && sameVnode(node, c)) { return i }
    }
  }

  function patchVnode (
    oldVnode,
    vnode,
    insertedVnodeQueue,
    ownerArray,
    index,
    removeOnly
  ) {
    if (oldVnode === vnode) {
      return
    }

    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // clone reused vnode
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    var elm = vnode.elm = oldVnode.elm;

    if (isTrue(oldVnode.isAsyncPlaceholder)) {
      if (isDef(vnode.asyncFactory.resolved)) {
        hydrate(oldVnode.elm, vnode, insertedVnodeQueue);
      } else {
        vnode.isAsyncPlaceholder = true;
      }
      return
    }

    // reuse element for static trees.
    // note we only do this if the vnode is cloned -
    // if the new node is not cloned it means the render functions have been
    // reset by the hot-reload-api and we need to do a proper re-render.
    if (isTrue(vnode.isStatic) &&
      isTrue(oldVnode.isStatic) &&
      vnode.key === oldVnode.key &&
      (isTrue(vnode.isCloned) || isTrue(vnode.isOnce))
    ) {
      vnode.componentInstance = oldVnode.componentInstance;
      return
    }

    var i;
    var data = vnode.data;
    if (isDef(data) && isDef(i = data.hook) && isDef(i = i.prepatch)) {
      i(oldVnode, vnode);
    }

    var oldCh = oldVnode.children;
    var ch = vnode.children;
    if (isDef(data) && isPatchable(vnode)) {
      for (i = 0; i < cbs.update.length; ++i) { cbs.update[i](oldVnode, vnode); }
      if (isDef(i = data.hook) && isDef(i = i.update)) { i(oldVnode, vnode); }
    }
    if (isUndef(vnode.text)) {
      if (isDef(oldCh) && isDef(ch)) {
        if (oldCh !== ch) { updateChildren(elm, oldCh, ch, insertedVnodeQueue, removeOnly); }
      } else if (isDef(ch)) {
        if (false) {
          checkDuplicateKeys(ch);
        }
        if (isDef(oldVnode.text)) { nodeOps.setTextContent(elm, ''); }
        addVnodes(elm, null, ch, 0, ch.length - 1, insertedVnodeQueue);
      } else if (isDef(oldCh)) {
        removeVnodes(oldCh, 0, oldCh.length - 1);
      } else if (isDef(oldVnode.text)) {
        nodeOps.setTextContent(elm, '');
      }
    } else if (oldVnode.text !== vnode.text) {
      nodeOps.setTextContent(elm, vnode.text);
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.postpatch)) { i(oldVnode, vnode); }
    }
  }

  function invokeInsertHook (vnode, queue, initial) {
    // delay insert hooks for component root nodes, invoke them after the
    // element is really inserted
    if (isTrue(initial) && isDef(vnode.parent)) {
      vnode.parent.data.pendingInsert = queue;
    } else {
      for (var i = 0; i < queue.length; ++i) {
        queue[i].data.hook.insert(queue[i]);
      }
    }
  }

  var hydrationBailed = false;
  // list of modules that can skip create hook during hydration because they
  // are already rendered on the client or has no need for initialization
  // Note: style is excluded because it relies on initial clone for future
  // deep updates (#7063).
  var isRenderedModule = makeMap('attrs,class,staticClass,staticStyle,key');

  // Note: this is a browser-only function so we can assume elms are DOM nodes.
  function hydrate (elm, vnode, insertedVnodeQueue, inVPre) {
    var i;
    var tag = vnode.tag;
    var data = vnode.data;
    var children = vnode.children;
    inVPre = inVPre || (data && data.pre);
    vnode.elm = elm;

    if (isTrue(vnode.isComment) && isDef(vnode.asyncFactory)) {
      vnode.isAsyncPlaceholder = true;
      return true
    }
    // assert node match
    if (false) {
      if (!assertNodeMatch(elm, vnode, inVPre)) {
        return false
      }
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.init)) { i(vnode, true /* hydrating */); }
      if (isDef(i = vnode.componentInstance)) {
        // child component. it should have hydrated its own tree.
        initComponent(vnode, insertedVnodeQueue);
        return true
      }
    }
    if (isDef(tag)) {
      if (isDef(children)) {
        // empty element, allow client to pick up and populate children
        if (!elm.hasChildNodes()) {
          createChildren(vnode, children, insertedVnodeQueue);
        } else {
          // v-html and domProps: innerHTML
          if (isDef(i = data) && isDef(i = i.domProps) && isDef(i = i.innerHTML)) {
            if (i !== elm.innerHTML) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('server innerHTML: ', i);
                console.warn('client innerHTML: ', elm.innerHTML);
              }
              return false
            }
          } else {
            // iterate and compare children lists
            var childrenMatch = true;
            var childNode = elm.firstChild;
            for (var i$1 = 0; i$1 < children.length; i$1++) {
              if (!childNode || !hydrate(childNode, children[i$1], insertedVnodeQueue, inVPre)) {
                childrenMatch = false;
                break
              }
              childNode = childNode.nextSibling;
            }
            // if childNode is not null, it means the actual childNodes list is
            // longer than the virtual children list.
            if (!childrenMatch || childNode) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('Mismatching childNodes vs. VNodes: ', elm.childNodes, children);
              }
              return false
            }
          }
        }
      }
      if (isDef(data)) {
        var fullInvoke = false;
        for (var key in data) {
          if (!isRenderedModule(key)) {
            fullInvoke = true;
            invokeCreateHooks(vnode, insertedVnodeQueue);
            break
          }
        }
        if (!fullInvoke && data['class']) {
          // ensure collecting deps for deep class bindings for future updates
          traverse(data['class']);
        }
      }
    } else if (elm.data !== vnode.text) {
      elm.data = vnode.text;
    }
    return true
  }

  function assertNodeMatch (node, vnode, inVPre) {
    if (isDef(vnode.tag)) {
      return vnode.tag.indexOf('vue-component') === 0 || (
        !isUnknownElement$$1(vnode, inVPre) &&
        vnode.tag.toLowerCase() === (node.tagName && node.tagName.toLowerCase())
      )
    } else {
      return node.nodeType === (vnode.isComment ? 8 : 3)
    }
  }

  return function patch (oldVnode, vnode, hydrating, removeOnly) {
    if (isUndef(vnode)) {
      if (isDef(oldVnode)) { invokeDestroyHook(oldVnode); }
      return
    }

    var isInitialPatch = false;
    var insertedVnodeQueue = [];

    if (isUndef(oldVnode)) {
      // empty mount (likely as component), create new root element
      isInitialPatch = true;
      createElm(vnode, insertedVnodeQueue);
    } else {
      var isRealElement = isDef(oldVnode.nodeType);
      if (!isRealElement && sameVnode(oldVnode, vnode)) {
        // patch existing root node
        patchVnode(oldVnode, vnode, insertedVnodeQueue, null, null, removeOnly);
      } else {
        if (isRealElement) {
          // mounting to a real element
          // check if this is server-rendered content and if we can perform
          // a successful hydration.
          if (oldVnode.nodeType === 1 && oldVnode.hasAttribute(SSR_ATTR)) {
            oldVnode.removeAttribute(SSR_ATTR);
            hydrating = true;
          }
          if (isTrue(hydrating)) {
            if (hydrate(oldVnode, vnode, insertedVnodeQueue)) {
              invokeInsertHook(vnode, insertedVnodeQueue, true);
              return oldVnode
            } else if (false) {
              warn(
                'The client-side rendered virtual DOM tree is not matching ' +
                'server-rendered content. This is likely caused by incorrect ' +
                'HTML markup, for example nesting block-level elements inside ' +
                '<p>, or missing <tbody>. Bailing hydration and performing ' +
                'full client-side render.'
              );
            }
          }
          // either not server-rendered, or hydration failed.
          // create an empty node and replace it
          oldVnode = emptyNodeAt(oldVnode);
        }

        // replacing existing element
        var oldElm = oldVnode.elm;
        var parentElm = nodeOps.parentNode(oldElm);

        // create new node
        createElm(
          vnode,
          insertedVnodeQueue,
          // extremely rare edge case: do not insert if old element is in a
          // leaving transition. Only happens when combining transition +
          // keep-alive + HOCs. (#4590)
          oldElm._leaveCb ? null : parentElm,
          nodeOps.nextSibling(oldElm)
        );

        // update parent placeholder node element, recursively
        if (isDef(vnode.parent)) {
          var ancestor = vnode.parent;
          var patchable = isPatchable(vnode);
          while (ancestor) {
            for (var i = 0; i < cbs.destroy.length; ++i) {
              cbs.destroy[i](ancestor);
            }
            ancestor.elm = vnode.elm;
            if (patchable) {
              for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
                cbs.create[i$1](emptyNode, ancestor);
              }
              // #6513
              // invoke insert hooks that may have been merged by create hooks.
              // e.g. for directives that uses the "inserted" hook.
              var insert = ancestor.data.hook.insert;
              if (insert.merged) {
                // start at index 1 to avoid re-invoking component mounted hook
                for (var i$2 = 1; i$2 < insert.fns.length; i$2++) {
                  insert.fns[i$2]();
                }
              }
            } else {
              registerRef(ancestor);
            }
            ancestor = ancestor.parent;
          }
        }

        // destroy old node
        if (isDef(parentElm)) {
          removeVnodes([oldVnode], 0, 0);
        } else if (isDef(oldVnode.tag)) {
          invokeDestroyHook(oldVnode);
        }
      }
    }

    invokeInsertHook(vnode, insertedVnodeQueue, isInitialPatch);
    return vnode.elm
  }
}

/*  */

var directives = {
  create: updateDirectives,
  update: updateDirectives,
  destroy: function unbindDirectives (vnode) {
    updateDirectives(vnode, emptyNode);
  }
};

function updateDirectives (oldVnode, vnode) {
  if (oldVnode.data.directives || vnode.data.directives) {
    _update(oldVnode, vnode);
  }
}

function _update (oldVnode, vnode) {
  var isCreate = oldVnode === emptyNode;
  var isDestroy = vnode === emptyNode;
  var oldDirs = normalizeDirectives$1(oldVnode.data.directives, oldVnode.context);
  var newDirs = normalizeDirectives$1(vnode.data.directives, vnode.context);

  var dirsWithInsert = [];
  var dirsWithPostpatch = [];

  var key, oldDir, dir;
  for (key in newDirs) {
    oldDir = oldDirs[key];
    dir = newDirs[key];
    if (!oldDir) {
      // new directive, bind
      callHook$1(dir, 'bind', vnode, oldVnode);
      if (dir.def && dir.def.inserted) {
        dirsWithInsert.push(dir);
      }
    } else {
      // existing directive, update
      dir.oldValue = oldDir.value;
      dir.oldArg = oldDir.arg;
      callHook$1(dir, 'update', vnode, oldVnode);
      if (dir.def && dir.def.componentUpdated) {
        dirsWithPostpatch.push(dir);
      }
    }
  }

  if (dirsWithInsert.length) {
    var callInsert = function () {
      for (var i = 0; i < dirsWithInsert.length; i++) {
        callHook$1(dirsWithInsert[i], 'inserted', vnode, oldVnode);
      }
    };
    if (isCreate) {
      mergeVNodeHook(vnode, 'insert', callInsert);
    } else {
      callInsert();
    }
  }

  if (dirsWithPostpatch.length) {
    mergeVNodeHook(vnode, 'postpatch', function () {
      for (var i = 0; i < dirsWithPostpatch.length; i++) {
        callHook$1(dirsWithPostpatch[i], 'componentUpdated', vnode, oldVnode);
      }
    });
  }

  if (!isCreate) {
    for (key in oldDirs) {
      if (!newDirs[key]) {
        // no longer present, unbind
        callHook$1(oldDirs[key], 'unbind', oldVnode, oldVnode, isDestroy);
      }
    }
  }
}

var emptyModifiers = Object.create(null);

function normalizeDirectives$1 (
  dirs,
  vm
) {
  var res = Object.create(null);
  if (!dirs) {
    // $flow-disable-line
    return res
  }
  var i, dir;
  for (i = 0; i < dirs.length; i++) {
    dir = dirs[i];
    if (!dir.modifiers) {
      // $flow-disable-line
      dir.modifiers = emptyModifiers;
    }
    res[getRawDirName(dir)] = dir;
    dir.def = resolveAsset(vm.$options, 'directives', dir.name, true);
  }
  // $flow-disable-line
  return res
}

function getRawDirName (dir) {
  return dir.rawName || ((dir.name) + "." + (Object.keys(dir.modifiers || {}).join('.')))
}

function callHook$1 (dir, hook, vnode, oldVnode, isDestroy) {
  var fn = dir.def && dir.def[hook];
  if (fn) {
    try {
      fn(vnode.elm, dir, vnode, oldVnode, isDestroy);
    } catch (e) {
      handleError(e, vnode.context, ("directive " + (dir.name) + " " + hook + " hook"));
    }
  }
}

var baseModules = [
  ref,
  directives
];

/*  */

function updateAttrs (oldVnode, vnode) {
  var opts = vnode.componentOptions;
  if (isDef(opts) && opts.Ctor.options.inheritAttrs === false) {
    return
  }
  if (isUndef(oldVnode.data.attrs) && isUndef(vnode.data.attrs)) {
    return
  }
  var key, cur, old;
  var elm = vnode.elm;
  var oldAttrs = oldVnode.data.attrs || {};
  var attrs = vnode.data.attrs || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(attrs.__ob__)) {
    attrs = vnode.data.attrs = extend({}, attrs);
  }

  for (key in attrs) {
    cur = attrs[key];
    old = oldAttrs[key];
    if (old !== cur) {
      setAttr(elm, key, cur);
    }
  }
  // #4391: in IE9, setting type can reset value for input[type=radio]
  // #6666: IE/Edge forces progress value down to 1 before setting a max
  /* istanbul ignore if */
  if ((isIE || isEdge) && attrs.value !== oldAttrs.value) {
    setAttr(elm, 'value', attrs.value);
  }
  for (key in oldAttrs) {
    if (isUndef(attrs[key])) {
      if (isXlink(key)) {
        elm.removeAttributeNS(xlinkNS, getXlinkProp(key));
      } else if (!isEnumeratedAttr(key)) {
        elm.removeAttribute(key);
      }
    }
  }
}

function setAttr (el, key, value) {
  if (el.tagName.indexOf('-') > -1) {
    baseSetAttr(el, key, value);
  } else if (isBooleanAttr(key)) {
    // set attribute for blank value
    // e.g. <option disabled>Select one</option>
    if (isFalsyAttrValue(value)) {
      el.removeAttribute(key);
    } else {
      // technically allowfullscreen is a boolean attribute for <iframe>,
      // but Flash expects a value of "true" when used on <embed> tag
      value = key === 'allowfullscreen' && el.tagName === 'EMBED'
        ? 'true'
        : key;
      el.setAttribute(key, value);
    }
  } else if (isEnumeratedAttr(key)) {
    el.setAttribute(key, convertEnumeratedValue(key, value));
  } else if (isXlink(key)) {
    if (isFalsyAttrValue(value)) {
      el.removeAttributeNS(xlinkNS, getXlinkProp(key));
    } else {
      el.setAttributeNS(xlinkNS, key, value);
    }
  } else {
    baseSetAttr(el, key, value);
  }
}

function baseSetAttr (el, key, value) {
  if (isFalsyAttrValue(value)) {
    el.removeAttribute(key);
  } else {
    // #7138: IE10 & 11 fires input event when setting placeholder on
    // <textarea>... block the first input event and remove the blocker
    // immediately.
    /* istanbul ignore if */
    if (
      isIE && !isIE9 &&
      el.tagName === 'TEXTAREA' &&
      key === 'placeholder' && value !== '' && !el.__ieph
    ) {
      var blocker = function (e) {
        e.stopImmediatePropagation();
        el.removeEventListener('input', blocker);
      };
      el.addEventListener('input', blocker);
      // $flow-disable-line
      el.__ieph = true; /* IE placeholder patched */
    }
    el.setAttribute(key, value);
  }
}

var attrs = {
  create: updateAttrs,
  update: updateAttrs
};

/*  */

function updateClass (oldVnode, vnode) {
  var el = vnode.elm;
  var data = vnode.data;
  var oldData = oldVnode.data;
  if (
    isUndef(data.staticClass) &&
    isUndef(data.class) && (
      isUndef(oldData) || (
        isUndef(oldData.staticClass) &&
        isUndef(oldData.class)
      )
    )
  ) {
    return
  }

  var cls = genClassForVnode(vnode);

  // handle transition classes
  var transitionClass = el._transitionClasses;
  if (isDef(transitionClass)) {
    cls = concat(cls, stringifyClass(transitionClass));
  }

  // set the class
  if (cls !== el._prevClass) {
    el.setAttribute('class', cls);
    el._prevClass = cls;
  }
}

var klass = {
  create: updateClass,
  update: updateClass
};

/*  */

var validDivisionCharRE = /[\w).+\-_$\]]/;

function parseFilters (exp) {
  var inSingle = false;
  var inDouble = false;
  var inTemplateString = false;
  var inRegex = false;
  var curly = 0;
  var square = 0;
  var paren = 0;
  var lastFilterIndex = 0;
  var c, prev, i, expression, filters;

  for (i = 0; i < exp.length; i++) {
    prev = c;
    c = exp.charCodeAt(i);
    if (inSingle) {
      if (c === 0x27 && prev !== 0x5C) { inSingle = false; }
    } else if (inDouble) {
      if (c === 0x22 && prev !== 0x5C) { inDouble = false; }
    } else if (inTemplateString) {
      if (c === 0x60 && prev !== 0x5C) { inTemplateString = false; }
    } else if (inRegex) {
      if (c === 0x2f && prev !== 0x5C) { inRegex = false; }
    } else if (
      c === 0x7C && // pipe
      exp.charCodeAt(i + 1) !== 0x7C &&
      exp.charCodeAt(i - 1) !== 0x7C &&
      !curly && !square && !paren
    ) {
      if (expression === undefined) {
        // first filter, end of expression
        lastFilterIndex = i + 1;
        expression = exp.slice(0, i).trim();
      } else {
        pushFilter();
      }
    } else {
      switch (c) {
        case 0x22: inDouble = true; break         // "
        case 0x27: inSingle = true; break         // '
        case 0x60: inTemplateString = true; break // `
        case 0x28: paren++; break                 // (
        case 0x29: paren--; break                 // )
        case 0x5B: square++; break                // [
        case 0x5D: square--; break                // ]
        case 0x7B: curly++; break                 // {
        case 0x7D: curly--; break                 // }
      }
      if (c === 0x2f) { // /
        var j = i - 1;
        var p = (void 0);
        // find first non-whitespace prev char
        for (; j >= 0; j--) {
          p = exp.charAt(j);
          if (p !== ' ') { break }
        }
        if (!p || !validDivisionCharRE.test(p)) {
          inRegex = true;
        }
      }
    }
  }

  if (expression === undefined) {
    expression = exp.slice(0, i).trim();
  } else if (lastFilterIndex !== 0) {
    pushFilter();
  }

  function pushFilter () {
    (filters || (filters = [])).push(exp.slice(lastFilterIndex, i).trim());
    lastFilterIndex = i + 1;
  }

  if (filters) {
    for (i = 0; i < filters.length; i++) {
      expression = wrapFilter(expression, filters[i]);
    }
  }

  return expression
}

function wrapFilter (exp, filter) {
  var i = filter.indexOf('(');
  if (i < 0) {
    // _f: resolveFilter
    return ("_f(\"" + filter + "\")(" + exp + ")")
  } else {
    var name = filter.slice(0, i);
    var args = filter.slice(i + 1);
    return ("_f(\"" + name + "\")(" + exp + (args !== ')' ? ',' + args : args))
  }
}

/*  */



/* eslint-disable no-unused-vars */
function baseWarn (msg, range) {
  console.error(("[Vue compiler]: " + msg));
}
/* eslint-enable no-unused-vars */

function pluckModuleFunction (
  modules,
  key
) {
  return modules
    ? modules.map(function (m) { return m[key]; }).filter(function (_) { return _; })
    : []
}

function addProp (el, name, value, range, dynamic) {
  (el.props || (el.props = [])).push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
  el.plain = false;
}

function addAttr (el, name, value, range, dynamic) {
  var attrs = dynamic
    ? (el.dynamicAttrs || (el.dynamicAttrs = []))
    : (el.attrs || (el.attrs = []));
  attrs.push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
  el.plain = false;
}

// add a raw attr (use this in preTransforms)
function addRawAttr (el, name, value, range) {
  el.attrsMap[name] = value;
  el.attrsList.push(rangeSetItem({ name: name, value: value }, range));
}

function addDirective (
  el,
  name,
  rawName,
  value,
  arg,
  isDynamicArg,
  modifiers,
  range
) {
  (el.directives || (el.directives = [])).push(rangeSetItem({
    name: name,
    rawName: rawName,
    value: value,
    arg: arg,
    isDynamicArg: isDynamicArg,
    modifiers: modifiers
  }, range));
  el.plain = false;
}

function prependModifierMarker (symbol, name, dynamic) {
  return dynamic
    ? ("_p(" + name + ",\"" + symbol + "\")")
    : symbol + name // mark the event as captured
}

function addHandler (
  el,
  name,
  value,
  modifiers,
  important,
  warn,
  range,
  dynamic
) {
  modifiers = modifiers || emptyObject;
  // warn prevent and passive modifier
  /* istanbul ignore if */
  if (
    false
  ) {
    warn(
      'passive and prevent can\'t be used together. ' +
      'Passive handler can\'t prevent default event.',
      range
    );
  }

  // normalize click.right and click.middle since they don't actually fire
  // this is technically browser-specific, but at least for now browsers are
  // the only target envs that have right/middle clicks.
  if (modifiers.right) {
    if (dynamic) {
      name = "(" + name + ")==='click'?'contextmenu':(" + name + ")";
    } else if (name === 'click') {
      name = 'contextmenu';
      delete modifiers.right;
    }
  } else if (modifiers.middle) {
    if (dynamic) {
      name = "(" + name + ")==='click'?'mouseup':(" + name + ")";
    } else if (name === 'click') {
      name = 'mouseup';
    }
  }

  // check capture modifier
  if (modifiers.capture) {
    delete modifiers.capture;
    name = prependModifierMarker('!', name, dynamic);
  }
  if (modifiers.once) {
    delete modifiers.once;
    name = prependModifierMarker('~', name, dynamic);
  }
  /* istanbul ignore if */
  if (modifiers.passive) {
    delete modifiers.passive;
    name = prependModifierMarker('&', name, dynamic);
  }

  var events;
  if (modifiers.native) {
    delete modifiers.native;
    events = el.nativeEvents || (el.nativeEvents = {});
  } else {
    events = el.events || (el.events = {});
  }

  var newHandler = rangeSetItem({ value: value.trim(), dynamic: dynamic }, range);
  if (modifiers !== emptyObject) {
    newHandler.modifiers = modifiers;
  }

  var handlers = events[name];
  /* istanbul ignore if */
  if (Array.isArray(handlers)) {
    important ? handlers.unshift(newHandler) : handlers.push(newHandler);
  } else if (handlers) {
    events[name] = important ? [newHandler, handlers] : [handlers, newHandler];
  } else {
    events[name] = newHandler;
  }

  el.plain = false;
}

function getRawBindingAttr (
  el,
  name
) {
  return el.rawAttrsMap[':' + name] ||
    el.rawAttrsMap['v-bind:' + name] ||
    el.rawAttrsMap[name]
}

function getBindingAttr (
  el,
  name,
  getStatic
) {
  var dynamicValue =
    getAndRemoveAttr(el, ':' + name) ||
    getAndRemoveAttr(el, 'v-bind:' + name);
  if (dynamicValue != null) {
    return parseFilters(dynamicValue)
  } else if (getStatic !== false) {
    var staticValue = getAndRemoveAttr(el, name);
    if (staticValue != null) {
      return JSON.stringify(staticValue)
    }
  }
}

// note: this only removes the attr from the Array (attrsList) so that it
// doesn't get processed by processAttrs.
// By default it does NOT remove it from the map (attrsMap) because the map is
// needed during codegen.
function getAndRemoveAttr (
  el,
  name,
  removeFromMap
) {
  var val;
  if ((val = el.attrsMap[name]) != null) {
    var list = el.attrsList;
    for (var i = 0, l = list.length; i < l; i++) {
      if (list[i].name === name) {
        list.splice(i, 1);
        break
      }
    }
  }
  if (removeFromMap) {
    delete el.attrsMap[name];
  }
  return val
}

function getAndRemoveAttrByRegex (
  el,
  name
) {
  var list = el.attrsList;
  for (var i = 0, l = list.length; i < l; i++) {
    var attr = list[i];
    if (name.test(attr.name)) {
      list.splice(i, 1);
      return attr
    }
  }
}

function rangeSetItem (
  item,
  range
) {
  if (range) {
    if (range.start != null) {
      item.start = range.start;
    }
    if (range.end != null) {
      item.end = range.end;
    }
  }
  return item
}

/*  */

/**
 * Cross-platform code generation for component v-model
 */
function genComponentModel (
  el,
  value,
  modifiers
) {
  var ref = modifiers || {};
  var number = ref.number;
  var trim = ref.trim;

  var baseValueExpression = '$$v';
  var valueExpression = baseValueExpression;
  if (trim) {
    valueExpression =
      "(typeof " + baseValueExpression + " === 'string'" +
      "? " + baseValueExpression + ".trim()" +
      ": " + baseValueExpression + ")";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }
  var assignment = genAssignmentCode(value, valueExpression);

  el.model = {
    value: ("(" + value + ")"),
    expression: JSON.stringify(value),
    callback: ("function (" + baseValueExpression + ") {" + assignment + "}")
  };
}

/**
 * Cross-platform codegen helper for generating v-model value assignment code.
 */
function genAssignmentCode (
  value,
  assignment
) {
  var res = parseModel(value);
  if (res.key === null) {
    return (value + "=" + assignment)
  } else {
    return ("$set(" + (res.exp) + ", " + (res.key) + ", " + assignment + ")")
  }
}

/**
 * Parse a v-model expression into a base path and a final key segment.
 * Handles both dot-path and possible square brackets.
 *
 * Possible cases:
 *
 * - test
 * - test[key]
 * - test[test1[key]]
 * - test["a"][key]
 * - xxx.test[a[a].test1[key]]
 * - test.xxx.a["asa"][test1[key]]
 *
 */

var len, str, chr, index$1, expressionPos, expressionEndPos;



function parseModel (val) {
  // Fix https://github.com/vuejs/vue/pull/7730
  // allow v-model="obj.val " (trailing whitespace)
  val = val.trim();
  len = val.length;

  if (val.indexOf('[') < 0 || val.lastIndexOf(']') < len - 1) {
    index$1 = val.lastIndexOf('.');
    if (index$1 > -1) {
      return {
        exp: val.slice(0, index$1),
        key: '"' + val.slice(index$1 + 1) + '"'
      }
    } else {
      return {
        exp: val,
        key: null
      }
    }
  }

  str = val;
  index$1 = expressionPos = expressionEndPos = 0;

  while (!eof()) {
    chr = next();
    /* istanbul ignore if */
    if (isStringStart(chr)) {
      parseString(chr);
    } else if (chr === 0x5B) {
      parseBracket(chr);
    }
  }

  return {
    exp: val.slice(0, expressionPos),
    key: val.slice(expressionPos + 1, expressionEndPos)
  }
}

function next () {
  return str.charCodeAt(++index$1)
}

function eof () {
  return index$1 >= len
}

function isStringStart (chr) {
  return chr === 0x22 || chr === 0x27
}

function parseBracket (chr) {
  var inBracket = 1;
  expressionPos = index$1;
  while (!eof()) {
    chr = next();
    if (isStringStart(chr)) {
      parseString(chr);
      continue
    }
    if (chr === 0x5B) { inBracket++; }
    if (chr === 0x5D) { inBracket--; }
    if (inBracket === 0) {
      expressionEndPos = index$1;
      break
    }
  }
}

function parseString (chr) {
  var stringQuote = chr;
  while (!eof()) {
    chr = next();
    if (chr === stringQuote) {
      break
    }
  }
}

/*  */

var warn$1;

// in some cases, the event used has to be determined at runtime
// so we used some reserved tokens during compile.
var RANGE_TOKEN = '__r';
var CHECKBOX_RADIO_TOKEN = '__c';

function model (
  el,
  dir,
  _warn
) {
  warn$1 = _warn;
  var value = dir.value;
  var modifiers = dir.modifiers;
  var tag = el.tag;
  var type = el.attrsMap.type;

  if (false) {
    // inputs with type="file" are read only and setting the input's
    // value will throw an error.
    if (tag === 'input' && type === 'file') {
      warn$1(
        "<" + (el.tag) + " v-model=\"" + value + "\" type=\"file\">:\n" +
        "File inputs are read only. Use a v-on:change listener instead.",
        el.rawAttrsMap['v-model']
      );
    }
  }

  if (el.component) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (tag === 'select') {
    genSelect(el, value, modifiers);
  } else if (tag === 'input' && type === 'checkbox') {
    genCheckboxModel(el, value, modifiers);
  } else if (tag === 'input' && type === 'radio') {
    genRadioModel(el, value, modifiers);
  } else if (tag === 'input' || tag === 'textarea') {
    genDefaultModel(el, value, modifiers);
  } else if (!config.isReservedTag(tag)) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (false) {
    warn$1(
      "<" + (el.tag) + " v-model=\"" + value + "\">: " +
      "v-model is not supported on this element type. " +
      'If you are working with contenteditable, it\'s recommended to ' +
      'wrap a library dedicated for that purpose inside a custom component.',
      el.rawAttrsMap['v-model']
    );
  }

  // ensure runtime directive metadata
  return true
}

function genCheckboxModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  var trueValueBinding = getBindingAttr(el, 'true-value') || 'true';
  var falseValueBinding = getBindingAttr(el, 'false-value') || 'false';
  addProp(el, 'checked',
    "Array.isArray(" + value + ")" +
    "?_i(" + value + "," + valueBinding + ")>-1" + (
      trueValueBinding === 'true'
        ? (":(" + value + ")")
        : (":_q(" + value + "," + trueValueBinding + ")")
    )
  );
  addHandler(el, 'change',
    "var $$a=" + value + "," +
        '$$el=$event.target,' +
        "$$c=$$el.checked?(" + trueValueBinding + "):(" + falseValueBinding + ");" +
    'if(Array.isArray($$a)){' +
      "var $$v=" + (number ? '_n(' + valueBinding + ')' : valueBinding) + "," +
          '$$i=_i($$a,$$v);' +
      "if($$el.checked){$$i<0&&(" + (genAssignmentCode(value, '$$a.concat([$$v])')) + ")}" +
      "else{$$i>-1&&(" + (genAssignmentCode(value, '$$a.slice(0,$$i).concat($$a.slice($$i+1))')) + ")}" +
    "}else{" + (genAssignmentCode(value, '$$c')) + "}",
    null, true
  );
}

function genRadioModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  valueBinding = number ? ("_n(" + valueBinding + ")") : valueBinding;
  addProp(el, 'checked', ("_q(" + value + "," + valueBinding + ")"));
  addHandler(el, 'change', genAssignmentCode(value, valueBinding), null, true);
}

function genSelect (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var selectedVal = "Array.prototype.filter" +
    ".call($event.target.options,function(o){return o.selected})" +
    ".map(function(o){var val = \"_value\" in o ? o._value : o.value;" +
    "return " + (number ? '_n(val)' : 'val') + "})";

  var assignment = '$event.target.multiple ? $$selectedVal : $$selectedVal[0]';
  var code = "var $$selectedVal = " + selectedVal + ";";
  code = code + " " + (genAssignmentCode(value, assignment));
  addHandler(el, 'change', code, null, true);
}

function genDefaultModel (
  el,
  value,
  modifiers
) {
  var type = el.attrsMap.type;

  // warn if v-bind:value conflicts with v-model
  // except for inputs with v-bind:type
  if (false) {
    var value$1 = el.attrsMap['v-bind:value'] || el.attrsMap[':value'];
    var typeBinding = el.attrsMap['v-bind:type'] || el.attrsMap[':type'];
    if (value$1 && !typeBinding) {
      var binding = el.attrsMap['v-bind:value'] ? 'v-bind:value' : ':value';
      warn$1(
        binding + "=\"" + value$1 + "\" conflicts with v-model on the same element " +
        'because the latter already expands to a value binding internally',
        el.rawAttrsMap[binding]
      );
    }
  }

  var ref = modifiers || {};
  var lazy = ref.lazy;
  var number = ref.number;
  var trim = ref.trim;
  var needCompositionGuard = !lazy && type !== 'range';
  var event = lazy
    ? 'change'
    : type === 'range'
      ? RANGE_TOKEN
      : 'input';

  var valueExpression = '$event.target.value';
  if (trim) {
    valueExpression = "$event.target.value.trim()";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }

  var code = genAssignmentCode(value, valueExpression);
  if (needCompositionGuard) {
    code = "if($event.target.composing)return;" + code;
  }

  addProp(el, 'value', ("(" + value + ")"));
  addHandler(el, event, code, null, true);
  if (trim || number) {
    addHandler(el, 'blur', '$forceUpdate()');
  }
}

/*  */

// normalize v-model event tokens that can only be determined at runtime.
// it's important to place the event as the first in the array because
// the whole point is ensuring the v-model callback gets called before
// user-attached handlers.
function normalizeEvents (on) {
  /* istanbul ignore if */
  if (isDef(on[RANGE_TOKEN])) {
    // IE input[type=range] only supports `change` event
    var event = isIE ? 'change' : 'input';
    on[event] = [].concat(on[RANGE_TOKEN], on[event] || []);
    delete on[RANGE_TOKEN];
  }
  // This was originally intended to fix #4521 but no longer necessary
  // after 2.5. Keeping it for backwards compat with generated code from < 2.4
  /* istanbul ignore if */
  if (isDef(on[CHECKBOX_RADIO_TOKEN])) {
    on.change = [].concat(on[CHECKBOX_RADIO_TOKEN], on.change || []);
    delete on[CHECKBOX_RADIO_TOKEN];
  }
}

var target$1;

function createOnceHandler$1 (event, handler, capture) {
  var _target = target$1; // save current target element in closure
  return function onceHandler () {
    var res = handler.apply(null, arguments);
    if (res !== null) {
      remove$2(event, onceHandler, capture, _target);
    }
  }
}

// #9446: Firefox <= 53 (in particular, ESR 52) has incorrect Event.timeStamp
// implementation and does not fire microtasks in between event propagation, so
// safe to exclude.
var useMicrotaskFix = isUsingMicroTask && !(isFF && Number(isFF[1]) <= 53);

function add$1 (
  name,
  handler,
  capture,
  passive
) {
  // async edge case #6566: inner click event triggers patch, event handler
  // attached to outer element during patch, and triggered again. This
  // happens because browsers fire microtask ticks between event propagation.
  // the solution is simple: we save the timestamp when a handler is attached,
  // and the handler would only fire if the event passed to it was fired
  // AFTER it was attached.
  if (useMicrotaskFix) {
    var attachedTimestamp = currentFlushTimestamp;
    var original = handler;
    handler = original._wrapper = function (e) {
      if (
        // no bubbling, should always fire.
        // this is just a safety net in case event.timeStamp is unreliable in
        // certain weird environments...
        e.target === e.currentTarget ||
        // event is fired after handler attachment
        e.timeStamp >= attachedTimestamp ||
        // bail for environments that have buggy event.timeStamp implementations
        // #9462 iOS 9 bug: event.timeStamp is 0 after history.pushState
        // #9681 QtWebEngine event.timeStamp is negative value
        e.timeStamp <= 0 ||
        // #9448 bail if event is fired in another document in a multi-page
        // electron/nw.js app, since event.timeStamp will be using a different
        // starting reference
        e.target.ownerDocument !== document
      ) {
        return original.apply(this, arguments)
      }
    };
  }
  target$1.addEventListener(
    name,
    handler,
    supportsPassive
      ? { capture: capture, passive: passive }
      : capture
  );
}

function remove$2 (
  name,
  handler,
  capture,
  _target
) {
  (_target || target$1).removeEventListener(
    name,
    handler._wrapper || handler,
    capture
  );
}

function updateDOMListeners (oldVnode, vnode) {
  if (isUndef(oldVnode.data.on) && isUndef(vnode.data.on)) {
    return
  }
  var on = vnode.data.on || {};
  var oldOn = oldVnode.data.on || {};
  target$1 = vnode.elm;
  normalizeEvents(on);
  updateListeners(on, oldOn, add$1, remove$2, createOnceHandler$1, vnode.context);
  target$1 = undefined;
}

var events = {
  create: updateDOMListeners,
  update: updateDOMListeners
};

/*  */

var svgContainer;

function updateDOMProps (oldVnode, vnode) {
  if (isUndef(oldVnode.data.domProps) && isUndef(vnode.data.domProps)) {
    return
  }
  var key, cur;
  var elm = vnode.elm;
  var oldProps = oldVnode.data.domProps || {};
  var props = vnode.data.domProps || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(props.__ob__)) {
    props = vnode.data.domProps = extend({}, props);
  }

  for (key in oldProps) {
    if (!(key in props)) {
      elm[key] = '';
    }
  }

  for (key in props) {
    cur = props[key];
    // ignore children if the node has textContent or innerHTML,
    // as these will throw away existing DOM nodes and cause removal errors
    // on subsequent patches (#3360)
    if (key === 'textContent' || key === 'innerHTML') {
      if (vnode.children) { vnode.children.length = 0; }
      if (cur === oldProps[key]) { continue }
      // #6601 work around Chrome version <= 55 bug where single textNode
      // replaced by innerHTML/textContent retains its parentNode property
      if (elm.childNodes.length === 1) {
        elm.removeChild(elm.childNodes[0]);
      }
    }

    if (key === 'value' && elm.tagName !== 'PROGRESS') {
      // store value as _value as well since
      // non-string values will be stringified
      elm._value = cur;
      // avoid resetting cursor position when value is the same
      var strCur = isUndef(cur) ? '' : String(cur);
      if (shouldUpdateValue(elm, strCur)) {
        elm.value = strCur;
      }
    } else if (key === 'innerHTML' && isSVG(elm.tagName) && isUndef(elm.innerHTML)) {
      // IE doesn't support innerHTML for SVG elements
      svgContainer = svgContainer || document.createElement('div');
      svgContainer.innerHTML = "<svg>" + cur + "</svg>";
      var svg = svgContainer.firstChild;
      while (elm.firstChild) {
        elm.removeChild(elm.firstChild);
      }
      while (svg.firstChild) {
        elm.appendChild(svg.firstChild);
      }
    } else if (
      // skip the update if old and new VDOM state is the same.
      // `value` is handled separately because the DOM value may be temporarily
      // out of sync with VDOM state due to focus, composition and modifiers.
      // This  #4521 by skipping the unnecessary `checked` update.
      cur !== oldProps[key]
    ) {
      // some property updates can throw
      // e.g. `value` on <progress> w/ non-finite value
      try {
        elm[key] = cur;
      } catch (e) {}
    }
  }
}

// check platforms/web/util/attrs.js acceptValue


function shouldUpdateValue (elm, checkVal) {
  return (!elm.composing && (
    elm.tagName === 'OPTION' ||
    isNotInFocusAndDirty(elm, checkVal) ||
    isDirtyWithModifiers(elm, checkVal)
  ))
}

function isNotInFocusAndDirty (elm, checkVal) {
  // return true when textbox (.number and .trim) loses focus and its value is
  // not equal to the updated value
  var notInFocus = true;
  // #6157
  // work around IE bug when accessing document.activeElement in an iframe
  try { notInFocus = document.activeElement !== elm; } catch (e) {}
  return notInFocus && elm.value !== checkVal
}

function isDirtyWithModifiers (elm, newVal) {
  var value = elm.value;
  var modifiers = elm._vModifiers; // injected by v-model runtime
  if (isDef(modifiers)) {
    if (modifiers.number) {
      return toNumber(value) !== toNumber(newVal)
    }
    if (modifiers.trim) {
      return value.trim() !== newVal.trim()
    }
  }
  return value !== newVal
}

var domProps = {
  create: updateDOMProps,
  update: updateDOMProps
};

/*  */

var parseStyleText = cached(function (cssText) {
  var res = {};
  var listDelimiter = /;(?![^(]*\))/g;
  var propertyDelimiter = /:(.+)/;
  cssText.split(listDelimiter).forEach(function (item) {
    if (item) {
      var tmp = item.split(propertyDelimiter);
      tmp.length > 1 && (res[tmp[0].trim()] = tmp[1].trim());
    }
  });
  return res
});

// merge static and dynamic style data on the same vnode
function normalizeStyleData (data) {
  var style = normalizeStyleBinding(data.style);
  // static style is pre-processed into an object during compilation
  // and is always a fresh object, so it's safe to merge into it
  return data.staticStyle
    ? extend(data.staticStyle, style)
    : style
}

// normalize possible array / string values into Object
function normalizeStyleBinding (bindingStyle) {
  if (Array.isArray(bindingStyle)) {
    return toObject(bindingStyle)
  }
  if (typeof bindingStyle === 'string') {
    return parseStyleText(bindingStyle)
  }
  return bindingStyle
}

/**
 * parent component style should be after child's
 * so that parent component's style could override it
 */
function getStyle (vnode, checkChild) {
  var res = {};
  var styleData;

  if (checkChild) {
    var childNode = vnode;
    while (childNode.componentInstance) {
      childNode = childNode.componentInstance._vnode;
      if (
        childNode && childNode.data &&
        (styleData = normalizeStyleData(childNode.data))
      ) {
        extend(res, styleData);
      }
    }
  }

  if ((styleData = normalizeStyleData(vnode.data))) {
    extend(res, styleData);
  }

  var parentNode = vnode;
  while ((parentNode = parentNode.parent)) {
    if (parentNode.data && (styleData = normalizeStyleData(parentNode.data))) {
      extend(res, styleData);
    }
  }
  return res
}

/*  */

var cssVarRE = /^--/;
var importantRE = /\s*!important$/;
var setProp = function (el, name, val) {
  /* istanbul ignore if */
  if (cssVarRE.test(name)) {
    el.style.setProperty(name, val);
  } else if (importantRE.test(val)) {
    el.style.setProperty(hyphenate(name), val.replace(importantRE, ''), 'important');
  } else {
    var normalizedName = normalize(name);
    if (Array.isArray(val)) {
      // Support values array created by autoprefixer, e.g.
      // {display: ["-webkit-box", "-ms-flexbox", "flex"]}
      // Set them one by one, and the browser will only set those it can recognize
      for (var i = 0, len = val.length; i < len; i++) {
        el.style[normalizedName] = val[i];
      }
    } else {
      el.style[normalizedName] = val;
    }
  }
};

var vendorNames = ['Webkit', 'Moz', 'ms'];

var emptyStyle;
var normalize = cached(function (prop) {
  emptyStyle = emptyStyle || document.createElement('div').style;
  prop = camelize(prop);
  if (prop !== 'filter' && (prop in emptyStyle)) {
    return prop
  }
  var capName = prop.charAt(0).toUpperCase() + prop.slice(1);
  for (var i = 0; i < vendorNames.length; i++) {
    var name = vendorNames[i] + capName;
    if (name in emptyStyle) {
      return name
    }
  }
});

function updateStyle (oldVnode, vnode) {
  var data = vnode.data;
  var oldData = oldVnode.data;

  if (isUndef(data.staticStyle) && isUndef(data.style) &&
    isUndef(oldData.staticStyle) && isUndef(oldData.style)
  ) {
    return
  }

  var cur, name;
  var el = vnode.elm;
  var oldStaticStyle = oldData.staticStyle;
  var oldStyleBinding = oldData.normalizedStyle || oldData.style || {};

  // if static style exists, stylebinding already merged into it when doing normalizeStyleData
  var oldStyle = oldStaticStyle || oldStyleBinding;

  var style = normalizeStyleBinding(vnode.data.style) || {};

  // store normalized style under a different key for next diff
  // make sure to clone it if it's reactive, since the user likely wants
  // to mutate it.
  vnode.data.normalizedStyle = isDef(style.__ob__)
    ? extend({}, style)
    : style;

  var newStyle = getStyle(vnode, true);

  for (name in oldStyle) {
    if (isUndef(newStyle[name])) {
      setProp(el, name, '');
    }
  }
  for (name in newStyle) {
    cur = newStyle[name];
    if (cur !== oldStyle[name]) {
      // ie9 setting to null has no effect, must use empty string
      setProp(el, name, cur == null ? '' : cur);
    }
  }
}

var style = {
  create: updateStyle,
  update: updateStyle
};

/*  */

var whitespaceRE = /\s+/;

/**
 * Add class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function addClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(whitespaceRE).forEach(function (c) { return el.classList.add(c); });
    } else {
      el.classList.add(cls);
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    if (cur.indexOf(' ' + cls + ' ') < 0) {
      el.setAttribute('class', (cur + cls).trim());
    }
  }
}

/**
 * Remove class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function removeClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(whitespaceRE).forEach(function (c) { return el.classList.remove(c); });
    } else {
      el.classList.remove(cls);
    }
    if (!el.classList.length) {
      el.removeAttribute('class');
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    var tar = ' ' + cls + ' ';
    while (cur.indexOf(tar) >= 0) {
      cur = cur.replace(tar, ' ');
    }
    cur = cur.trim();
    if (cur) {
      el.setAttribute('class', cur);
    } else {
      el.removeAttribute('class');
    }
  }
}

/*  */

function resolveTransition (def$$1) {
  if (!def$$1) {
    return
  }
  /* istanbul ignore else */
  if (typeof def$$1 === 'object') {
    var res = {};
    if (def$$1.css !== false) {
      extend(res, autoCssTransition(def$$1.name || 'v'));
    }
    extend(res, def$$1);
    return res
  } else if (typeof def$$1 === 'string') {
    return autoCssTransition(def$$1)
  }
}

var autoCssTransition = cached(function (name) {
  return {
    enterClass: (name + "-enter"),
    enterToClass: (name + "-enter-to"),
    enterActiveClass: (name + "-enter-active"),
    leaveClass: (name + "-leave"),
    leaveToClass: (name + "-leave-to"),
    leaveActiveClass: (name + "-leave-active")
  }
});

var hasTransition = inBrowser && !isIE9;
var TRANSITION = 'transition';
var ANIMATION = 'animation';

// Transition property/event sniffing
var transitionProp = 'transition';
var transitionEndEvent = 'transitionend';
var animationProp = 'animation';
var animationEndEvent = 'animationend';
if (hasTransition) {
  /* istanbul ignore if */
  if (window.ontransitionend === undefined &&
    window.onwebkittransitionend !== undefined
  ) {
    transitionProp = 'WebkitTransition';
    transitionEndEvent = 'webkitTransitionEnd';
  }
  if (window.onanimationend === undefined &&
    window.onwebkitanimationend !== undefined
  ) {
    animationProp = 'WebkitAnimation';
    animationEndEvent = 'webkitAnimationEnd';
  }
}

// binding to window is necessary to make hot reload work in IE in strict mode
var raf = inBrowser
  ? window.requestAnimationFrame
    ? window.requestAnimationFrame.bind(window)
    : setTimeout
  : /* istanbul ignore next */ function (fn) { return fn(); };

function nextFrame (fn) {
  raf(function () {
    raf(fn);
  });
}

function addTransitionClass (el, cls) {
  var transitionClasses = el._transitionClasses || (el._transitionClasses = []);
  if (transitionClasses.indexOf(cls) < 0) {
    transitionClasses.push(cls);
    addClass(el, cls);
  }
}

function removeTransitionClass (el, cls) {
  if (el._transitionClasses) {
    remove(el._transitionClasses, cls);
  }
  removeClass(el, cls);
}

function whenTransitionEnds (
  el,
  expectedType,
  cb
) {
  var ref = getTransitionInfo(el, expectedType);
  var type = ref.type;
  var timeout = ref.timeout;
  var propCount = ref.propCount;
  if (!type) { return cb() }
  var event = type === TRANSITION ? transitionEndEvent : animationEndEvent;
  var ended = 0;
  var end = function () {
    el.removeEventListener(event, onEnd);
    cb();
  };
  var onEnd = function (e) {
    if (e.target === el) {
      if (++ended >= propCount) {
        end();
      }
    }
  };
  setTimeout(function () {
    if (ended < propCount) {
      end();
    }
  }, timeout + 1);
  el.addEventListener(event, onEnd);
}

var transformRE = /\b(transform|all)(,|$)/;

function getTransitionInfo (el, expectedType) {
  var styles = window.getComputedStyle(el);
  // JSDOM may return undefined for transition properties
  var transitionDelays = (styles[transitionProp + 'Delay'] || '').split(', ');
  var transitionDurations = (styles[transitionProp + 'Duration'] || '').split(', ');
  var transitionTimeout = getTimeout(transitionDelays, transitionDurations);
  var animationDelays = (styles[animationProp + 'Delay'] || '').split(', ');
  var animationDurations = (styles[animationProp + 'Duration'] || '').split(', ');
  var animationTimeout = getTimeout(animationDelays, animationDurations);

  var type;
  var timeout = 0;
  var propCount = 0;
  /* istanbul ignore if */
  if (expectedType === TRANSITION) {
    if (transitionTimeout > 0) {
      type = TRANSITION;
      timeout = transitionTimeout;
      propCount = transitionDurations.length;
    }
  } else if (expectedType === ANIMATION) {
    if (animationTimeout > 0) {
      type = ANIMATION;
      timeout = animationTimeout;
      propCount = animationDurations.length;
    }
  } else {
    timeout = Math.max(transitionTimeout, animationTimeout);
    type = timeout > 0
      ? transitionTimeout > animationTimeout
        ? TRANSITION
        : ANIMATION
      : null;
    propCount = type
      ? type === TRANSITION
        ? transitionDurations.length
        : animationDurations.length
      : 0;
  }
  var hasTransform =
    type === TRANSITION &&
    transformRE.test(styles[transitionProp + 'Property']);
  return {
    type: type,
    timeout: timeout,
    propCount: propCount,
    hasTransform: hasTransform
  }
}

function getTimeout (delays, durations) {
  /* istanbul ignore next */
  while (delays.length < durations.length) {
    delays = delays.concat(delays);
  }

  return Math.max.apply(null, durations.map(function (d, i) {
    return toMs(d) + toMs(delays[i])
  }))
}

// Old versions of Chromium (below 61.0.3163.100) formats floating pointer numbers
// in a locale-dependent way, using a comma instead of a dot.
// If comma is not replaced with a dot, the input will be rounded down (i.e. acting
// as a floor function) causing unexpected behaviors
function toMs (s) {
  return Number(s.slice(0, -1).replace(',', '.')) * 1000
}

/*  */

function enter (vnode, toggleDisplay) {
  var el = vnode.elm;

  // call leave callback now
  if (isDef(el._leaveCb)) {
    el._leaveCb.cancelled = true;
    el._leaveCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data)) {
    return
  }

  /* istanbul ignore if */
  if (isDef(el._enterCb) || el.nodeType !== 1) {
    return
  }

  var css = data.css;
  var type = data.type;
  var enterClass = data.enterClass;
  var enterToClass = data.enterToClass;
  var enterActiveClass = data.enterActiveClass;
  var appearClass = data.appearClass;
  var appearToClass = data.appearToClass;
  var appearActiveClass = data.appearActiveClass;
  var beforeEnter = data.beforeEnter;
  var enter = data.enter;
  var afterEnter = data.afterEnter;
  var enterCancelled = data.enterCancelled;
  var beforeAppear = data.beforeAppear;
  var appear = data.appear;
  var afterAppear = data.afterAppear;
  var appearCancelled = data.appearCancelled;
  var duration = data.duration;

  // activeInstance will always be the <transition> component managing this
  // transition. One edge case to check is when the <transition> is placed
  // as the root node of a child component. In that case we need to check
  // <transition>'s parent for appear check.
  var context = activeInstance;
  var transitionNode = activeInstance.$vnode;
  while (transitionNode && transitionNode.parent) {
    context = transitionNode.context;
    transitionNode = transitionNode.parent;
  }

  var isAppear = !context._isMounted || !vnode.isRootInsert;

  if (isAppear && !appear && appear !== '') {
    return
  }

  var startClass = isAppear && appearClass
    ? appearClass
    : enterClass;
  var activeClass = isAppear && appearActiveClass
    ? appearActiveClass
    : enterActiveClass;
  var toClass = isAppear && appearToClass
    ? appearToClass
    : enterToClass;

  var beforeEnterHook = isAppear
    ? (beforeAppear || beforeEnter)
    : beforeEnter;
  var enterHook = isAppear
    ? (typeof appear === 'function' ? appear : enter)
    : enter;
  var afterEnterHook = isAppear
    ? (afterAppear || afterEnter)
    : afterEnter;
  var enterCancelledHook = isAppear
    ? (appearCancelled || enterCancelled)
    : enterCancelled;

  var explicitEnterDuration = toNumber(
    isObject(duration)
      ? duration.enter
      : duration
  );

  if (false) {
    checkDuration(explicitEnterDuration, 'enter', vnode);
  }

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(enterHook);

  var cb = el._enterCb = once(function () {
    if (expectsCSS) {
      removeTransitionClass(el, toClass);
      removeTransitionClass(el, activeClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, startClass);
      }
      enterCancelledHook && enterCancelledHook(el);
    } else {
      afterEnterHook && afterEnterHook(el);
    }
    el._enterCb = null;
  });

  if (!vnode.data.show) {
    // remove pending leave element on enter by injecting an insert hook
    mergeVNodeHook(vnode, 'insert', function () {
      var parent = el.parentNode;
      var pendingNode = parent && parent._pending && parent._pending[vnode.key];
      if (pendingNode &&
        pendingNode.tag === vnode.tag &&
        pendingNode.elm._leaveCb
      ) {
        pendingNode.elm._leaveCb();
      }
      enterHook && enterHook(el, cb);
    });
  }

  // start enter transition
  beforeEnterHook && beforeEnterHook(el);
  if (expectsCSS) {
    addTransitionClass(el, startClass);
    addTransitionClass(el, activeClass);
    nextFrame(function () {
      removeTransitionClass(el, startClass);
      if (!cb.cancelled) {
        addTransitionClass(el, toClass);
        if (!userWantsControl) {
          if (isValidDuration(explicitEnterDuration)) {
            setTimeout(cb, explicitEnterDuration);
          } else {
            whenTransitionEnds(el, type, cb);
          }
        }
      }
    });
  }

  if (vnode.data.show) {
    toggleDisplay && toggleDisplay();
    enterHook && enterHook(el, cb);
  }

  if (!expectsCSS && !userWantsControl) {
    cb();
  }
}

function leave (vnode, rm) {
  var el = vnode.elm;

  // call enter callback now
  if (isDef(el._enterCb)) {
    el._enterCb.cancelled = true;
    el._enterCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data) || el.nodeType !== 1) {
    return rm()
  }

  /* istanbul ignore if */
  if (isDef(el._leaveCb)) {
    return
  }

  var css = data.css;
  var type = data.type;
  var leaveClass = data.leaveClass;
  var leaveToClass = data.leaveToClass;
  var leaveActiveClass = data.leaveActiveClass;
  var beforeLeave = data.beforeLeave;
  var leave = data.leave;
  var afterLeave = data.afterLeave;
  var leaveCancelled = data.leaveCancelled;
  var delayLeave = data.delayLeave;
  var duration = data.duration;

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(leave);

  var explicitLeaveDuration = toNumber(
    isObject(duration)
      ? duration.leave
      : duration
  );

  if (false) {
    checkDuration(explicitLeaveDuration, 'leave', vnode);
  }

  var cb = el._leaveCb = once(function () {
    if (el.parentNode && el.parentNode._pending) {
      el.parentNode._pending[vnode.key] = null;
    }
    if (expectsCSS) {
      removeTransitionClass(el, leaveToClass);
      removeTransitionClass(el, leaveActiveClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, leaveClass);
      }
      leaveCancelled && leaveCancelled(el);
    } else {
      rm();
      afterLeave && afterLeave(el);
    }
    el._leaveCb = null;
  });

  if (delayLeave) {
    delayLeave(performLeave);
  } else {
    performLeave();
  }

  function performLeave () {
    // the delayed leave may have already been cancelled
    if (cb.cancelled) {
      return
    }
    // record leaving element
    if (!vnode.data.show && el.parentNode) {
      (el.parentNode._pending || (el.parentNode._pending = {}))[(vnode.key)] = vnode;
    }
    beforeLeave && beforeLeave(el);
    if (expectsCSS) {
      addTransitionClass(el, leaveClass);
      addTransitionClass(el, leaveActiveClass);
      nextFrame(function () {
        removeTransitionClass(el, leaveClass);
        if (!cb.cancelled) {
          addTransitionClass(el, leaveToClass);
          if (!userWantsControl) {
            if (isValidDuration(explicitLeaveDuration)) {
              setTimeout(cb, explicitLeaveDuration);
            } else {
              whenTransitionEnds(el, type, cb);
            }
          }
        }
      });
    }
    leave && leave(el, cb);
    if (!expectsCSS && !userWantsControl) {
      cb();
    }
  }
}

// only used in dev mode
function checkDuration (val, name, vnode) {
  if (typeof val !== 'number') {
    warn(
      "<transition> explicit " + name + " duration is not a valid number - " +
      "got " + (JSON.stringify(val)) + ".",
      vnode.context
    );
  } else if (isNaN(val)) {
    warn(
      "<transition> explicit " + name + " duration is NaN - " +
      'the duration expression might be incorrect.',
      vnode.context
    );
  }
}

function isValidDuration (val) {
  return typeof val === 'number' && !isNaN(val)
}

/**
 * Normalize a transition hook's argument length. The hook may be:
 * - a merged hook (invoker) with the original in .fns
 * - a wrapped component method (check ._length)
 * - a plain function (.length)
 */
function getHookArgumentsLength (fn) {
  if (isUndef(fn)) {
    return false
  }
  var invokerFns = fn.fns;
  if (isDef(invokerFns)) {
    // invoker
    return getHookArgumentsLength(
      Array.isArray(invokerFns)
        ? invokerFns[0]
        : invokerFns
    )
  } else {
    return (fn._length || fn.length) > 1
  }
}

function _enter (_, vnode) {
  if (vnode.data.show !== true) {
    enter(vnode);
  }
}

var transition = inBrowser ? {
  create: _enter,
  activate: _enter,
  remove: function remove$$1 (vnode, rm) {
    /* istanbul ignore else */
    if (vnode.data.show !== true) {
      leave(vnode, rm);
    } else {
      rm();
    }
  }
} : {};

var platformModules = [
  attrs,
  klass,
  events,
  domProps,
  style,
  transition
];

/*  */

// the directive module should be applied last, after all
// built-in modules have been applied.
var modules = platformModules.concat(baseModules);

var patch = createPatchFunction({ nodeOps: nodeOps, modules: modules });

/**
 * Not type checking this file because flow doesn't like attaching
 * properties to Elements.
 */

/* istanbul ignore if */
if (isIE9) {
  // http://www.matts411.com/post/internet-explorer-9-oninput/
  document.addEventListener('selectionchange', function () {
    var el = document.activeElement;
    if (el && el.vmodel) {
      trigger(el, 'input');
    }
  });
}

var directive = {
  inserted: function inserted (el, binding, vnode, oldVnode) {
    if (vnode.tag === 'select') {
      // #6903
      if (oldVnode.elm && !oldVnode.elm._vOptions) {
        mergeVNodeHook(vnode, 'postpatch', function () {
          directive.componentUpdated(el, binding, vnode);
        });
      } else {
        setSelected(el, binding, vnode.context);
      }
      el._vOptions = [].map.call(el.options, getValue);
    } else if (vnode.tag === 'textarea' || isTextInputType(el.type)) {
      el._vModifiers = binding.modifiers;
      if (!binding.modifiers.lazy) {
        el.addEventListener('compositionstart', onCompositionStart);
        el.addEventListener('compositionend', onCompositionEnd);
        // Safari < 10.2 & UIWebView doesn't fire compositionend when
        // switching focus before confirming composition choice
        // this also fixes the issue where some browsers e.g. iOS Chrome
        // fires "change" instead of "input" on autocomplete.
        el.addEventListener('change', onCompositionEnd);
        /* istanbul ignore if */
        if (isIE9) {
          el.vmodel = true;
        }
      }
    }
  },

  componentUpdated: function componentUpdated (el, binding, vnode) {
    if (vnode.tag === 'select') {
      setSelected(el, binding, vnode.context);
      // in case the options rendered by v-for have changed,
      // it's possible that the value is out-of-sync with the rendered options.
      // detect such cases and filter out values that no longer has a matching
      // option in the DOM.
      var prevOptions = el._vOptions;
      var curOptions = el._vOptions = [].map.call(el.options, getValue);
      if (curOptions.some(function (o, i) { return !looseEqual(o, prevOptions[i]); })) {
        // trigger change event if
        // no matching option found for at least one value
        var needReset = el.multiple
          ? binding.value.some(function (v) { return hasNoMatchingOption(v, curOptions); })
          : binding.value !== binding.oldValue && hasNoMatchingOption(binding.value, curOptions);
        if (needReset) {
          trigger(el, 'change');
        }
      }
    }
  }
};

function setSelected (el, binding, vm) {
  actuallySetSelected(el, binding, vm);
  /* istanbul ignore if */
  if (isIE || isEdge) {
    setTimeout(function () {
      actuallySetSelected(el, binding, vm);
    }, 0);
  }
}

function actuallySetSelected (el, binding, vm) {
  var value = binding.value;
  var isMultiple = el.multiple;
  if (isMultiple && !Array.isArray(value)) {
    "production" !== 'production' && warn(
      "<select multiple v-model=\"" + (binding.expression) + "\"> " +
      "expects an Array value for its binding, but got " + (Object.prototype.toString.call(value).slice(8, -1)),
      vm
    );
    return
  }
  var selected, option;
  for (var i = 0, l = el.options.length; i < l; i++) {
    option = el.options[i];
    if (isMultiple) {
      selected = looseIndexOf(value, getValue(option)) > -1;
      if (option.selected !== selected) {
        option.selected = selected;
      }
    } else {
      if (looseEqual(getValue(option), value)) {
        if (el.selectedIndex !== i) {
          el.selectedIndex = i;
        }
        return
      }
    }
  }
  if (!isMultiple) {
    el.selectedIndex = -1;
  }
}

function hasNoMatchingOption (value, options) {
  return options.every(function (o) { return !looseEqual(o, value); })
}

function getValue (option) {
  return '_value' in option
    ? option._value
    : option.value
}

function onCompositionStart (e) {
  e.target.composing = true;
}

function onCompositionEnd (e) {
  // prevent triggering an input event for no reason
  if (!e.target.composing) { return }
  e.target.composing = false;
  trigger(e.target, 'input');
}

function trigger (el, type) {
  var e = document.createEvent('HTMLEvents');
  e.initEvent(type, true, true);
  el.dispatchEvent(e);
}

/*  */

// recursively search for possible transition defined inside the component root
function locateNode (vnode) {
  return vnode.componentInstance && (!vnode.data || !vnode.data.transition)
    ? locateNode(vnode.componentInstance._vnode)
    : vnode
}

var show = {
  bind: function bind (el, ref, vnode) {
    var value = ref.value;

    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    var originalDisplay = el.__vOriginalDisplay =
      el.style.display === 'none' ? '' : el.style.display;
    if (value && transition$$1) {
      vnode.data.show = true;
      enter(vnode, function () {
        el.style.display = originalDisplay;
      });
    } else {
      el.style.display = value ? originalDisplay : 'none';
    }
  },

  update: function update (el, ref, vnode) {
    var value = ref.value;
    var oldValue = ref.oldValue;

    /* istanbul ignore if */
    if (!value === !oldValue) { return }
    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    if (transition$$1) {
      vnode.data.show = true;
      if (value) {
        enter(vnode, function () {
          el.style.display = el.__vOriginalDisplay;
        });
      } else {
        leave(vnode, function () {
          el.style.display = 'none';
        });
      }
    } else {
      el.style.display = value ? el.__vOriginalDisplay : 'none';
    }
  },

  unbind: function unbind (
    el,
    binding,
    vnode,
    oldVnode,
    isDestroy
  ) {
    if (!isDestroy) {
      el.style.display = el.__vOriginalDisplay;
    }
  }
};

var platformDirectives = {
  model: directive,
  show: show
};

/*  */

var transitionProps = {
  name: String,
  appear: Boolean,
  css: Boolean,
  mode: String,
  type: String,
  enterClass: String,
  leaveClass: String,
  enterToClass: String,
  leaveToClass: String,
  enterActiveClass: String,
  leaveActiveClass: String,
  appearClass: String,
  appearActiveClass: String,
  appearToClass: String,
  duration: [Number, String, Object]
};

// in case the child is also an abstract component, e.g. <keep-alive>
// we want to recursively retrieve the real component to be rendered
function getRealChild (vnode) {
  var compOptions = vnode && vnode.componentOptions;
  if (compOptions && compOptions.Ctor.options.abstract) {
    return getRealChild(getFirstComponentChild(compOptions.children))
  } else {
    return vnode
  }
}

function extractTransitionData (comp) {
  var data = {};
  var options = comp.$options;
  // props
  for (var key in options.propsData) {
    data[key] = comp[key];
  }
  // events.
  // extract listeners and pass them directly to the transition methods
  var listeners = options._parentListeners;
  for (var key$1 in listeners) {
    data[camelize(key$1)] = listeners[key$1];
  }
  return data
}

function placeholder (h, rawChild) {
  if (/\d-keep-alive$/.test(rawChild.tag)) {
    return h('keep-alive', {
      props: rawChild.componentOptions.propsData
    })
  }
}

function hasParentTransition (vnode) {
  while ((vnode = vnode.parent)) {
    if (vnode.data.transition) {
      return true
    }
  }
}

function isSameChild (child, oldChild) {
  return oldChild.key === child.key && oldChild.tag === child.tag
}

var isNotTextNode = function (c) { return c.tag || isAsyncPlaceholder(c); };

var isVShowDirective = function (d) { return d.name === 'show'; };

var Transition = {
  name: 'transition',
  props: transitionProps,
  abstract: true,

  render: function render (h) {
    var this$1 = this;

    var children = this.$slots.default;
    if (!children) {
      return
    }

    // filter out text nodes (possible whitespaces)
    children = children.filter(isNotTextNode);
    /* istanbul ignore if */
    if (!children.length) {
      return
    }

    // warn multiple elements
    if (false) {
      warn(
        '<transition> can only be used on a single element. Use ' +
        '<transition-group> for lists.',
        this.$parent
      );
    }

    var mode = this.mode;

    // warn invalid mode
    if (false
    ) {
      warn(
        'invalid <transition> mode: ' + mode,
        this.$parent
      );
    }

    var rawChild = children[0];

    // if this is a component root node and the component's
    // parent container node also has transition, skip.
    if (hasParentTransition(this.$vnode)) {
      return rawChild
    }

    // apply transition data to child
    // use getRealChild() to ignore abstract components e.g. keep-alive
    var child = getRealChild(rawChild);
    /* istanbul ignore if */
    if (!child) {
      return rawChild
    }

    if (this._leaving) {
      return placeholder(h, rawChild)
    }

    // ensure a key that is unique to the vnode type and to this transition
    // component instance. This key will be used to remove pending leaving nodes
    // during entering.
    var id = "__transition-" + (this._uid) + "-";
    child.key = child.key == null
      ? child.isComment
        ? id + 'comment'
        : id + child.tag
      : isPrimitive(child.key)
        ? (String(child.key).indexOf(id) === 0 ? child.key : id + child.key)
        : child.key;

    var data = (child.data || (child.data = {})).transition = extractTransitionData(this);
    var oldRawChild = this._vnode;
    var oldChild = getRealChild(oldRawChild);

    // mark v-show
    // so that the transition module can hand over the control to the directive
    if (child.data.directives && child.data.directives.some(isVShowDirective)) {
      child.data.show = true;
    }

    if (
      oldChild &&
      oldChild.data &&
      !isSameChild(child, oldChild) &&
      !isAsyncPlaceholder(oldChild) &&
      // #6687 component root is a comment node
      !(oldChild.componentInstance && oldChild.componentInstance._vnode.isComment)
    ) {
      // replace old child transition data with fresh one
      // important for dynamic transitions!
      var oldData = oldChild.data.transition = extend({}, data);
      // handle transition mode
      if (mode === 'out-in') {
        // return placeholder node and queue update when leave finishes
        this._leaving = true;
        mergeVNodeHook(oldData, 'afterLeave', function () {
          this$1._leaving = false;
          this$1.$forceUpdate();
        });
        return placeholder(h, rawChild)
      } else if (mode === 'in-out') {
        if (isAsyncPlaceholder(child)) {
          return oldRawChild
        }
        var delayedLeave;
        var performLeave = function () { delayedLeave(); };
        mergeVNodeHook(data, 'afterEnter', performLeave);
        mergeVNodeHook(data, 'enterCancelled', performLeave);
        mergeVNodeHook(oldData, 'delayLeave', function (leave) { delayedLeave = leave; });
      }
    }

    return rawChild
  }
};

/*  */

var props = extend({
  tag: String,
  moveClass: String
}, transitionProps);

delete props.mode;

var TransitionGroup = {
  props: props,

  beforeMount: function beforeMount () {
    var this$1 = this;

    var update = this._update;
    this._update = function (vnode, hydrating) {
      var restoreActiveInstance = setActiveInstance(this$1);
      // force removing pass
      this$1.__patch__(
        this$1._vnode,
        this$1.kept,
        false, // hydrating
        true // removeOnly (!important, avoids unnecessary moves)
      );
      this$1._vnode = this$1.kept;
      restoreActiveInstance();
      update.call(this$1, vnode, hydrating);
    };
  },

  render: function render (h) {
    var tag = this.tag || this.$vnode.data.tag || 'span';
    var map = Object.create(null);
    var prevChildren = this.prevChildren = this.children;
    var rawChildren = this.$slots.default || [];
    var children = this.children = [];
    var transitionData = extractTransitionData(this);

    for (var i = 0; i < rawChildren.length; i++) {
      var c = rawChildren[i];
      if (c.tag) {
        if (c.key != null && String(c.key).indexOf('__vlist') !== 0) {
          children.push(c);
          map[c.key] = c
          ;(c.data || (c.data = {})).transition = transitionData;
        } else if (false) {
          var opts = c.componentOptions;
          var name = opts ? (opts.Ctor.options.name || opts.tag || '') : c.tag;
          warn(("<transition-group> children must be keyed: <" + name + ">"));
        }
      }
    }

    if (prevChildren) {
      var kept = [];
      var removed = [];
      for (var i$1 = 0; i$1 < prevChildren.length; i$1++) {
        var c$1 = prevChildren[i$1];
        c$1.data.transition = transitionData;
        c$1.data.pos = c$1.elm.getBoundingClientRect();
        if (map[c$1.key]) {
          kept.push(c$1);
        } else {
          removed.push(c$1);
        }
      }
      this.kept = h(tag, null, kept);
      this.removed = removed;
    }

    return h(tag, null, children)
  },

  updated: function updated () {
    var children = this.prevChildren;
    var moveClass = this.moveClass || ((this.name || 'v') + '-move');
    if (!children.length || !this.hasMove(children[0].elm, moveClass)) {
      return
    }

    // we divide the work into three loops to avoid mixing DOM reads and writes
    // in each iteration - which helps prevent layout thrashing.
    children.forEach(callPendingCbs);
    children.forEach(recordPosition);
    children.forEach(applyTranslation);

    // force reflow to put everything in position
    // assign to this to avoid being removed in tree-shaking
    // $flow-disable-line
    this._reflow = document.body.offsetHeight;

    children.forEach(function (c) {
      if (c.data.moved) {
        var el = c.elm;
        var s = el.style;
        addTransitionClass(el, moveClass);
        s.transform = s.WebkitTransform = s.transitionDuration = '';
        el.addEventListener(transitionEndEvent, el._moveCb = function cb (e) {
          if (e && e.target !== el) {
            return
          }
          if (!e || /transform$/.test(e.propertyName)) {
            el.removeEventListener(transitionEndEvent, cb);
            el._moveCb = null;
            removeTransitionClass(el, moveClass);
          }
        });
      }
    });
  },

  methods: {
    hasMove: function hasMove (el, moveClass) {
      /* istanbul ignore if */
      if (!hasTransition) {
        return false
      }
      /* istanbul ignore if */
      if (this._hasMove) {
        return this._hasMove
      }
      // Detect whether an element with the move class applied has
      // CSS transitions. Since the element may be inside an entering
      // transition at this very moment, we make a clone of it and remove
      // all other transition classes applied to ensure only the move class
      // is applied.
      var clone = el.cloneNode();
      if (el._transitionClasses) {
        el._transitionClasses.forEach(function (cls) { removeClass(clone, cls); });
      }
      addClass(clone, moveClass);
      clone.style.display = 'none';
      this.$el.appendChild(clone);
      var info = getTransitionInfo(clone);
      this.$el.removeChild(clone);
      return (this._hasMove = info.hasTransform)
    }
  }
};

function callPendingCbs (c) {
  /* istanbul ignore if */
  if (c.elm._moveCb) {
    c.elm._moveCb();
  }
  /* istanbul ignore if */
  if (c.elm._enterCb) {
    c.elm._enterCb();
  }
}

function recordPosition (c) {
  c.data.newPos = c.elm.getBoundingClientRect();
}

function applyTranslation (c) {
  var oldPos = c.data.pos;
  var newPos = c.data.newPos;
  var dx = oldPos.left - newPos.left;
  var dy = oldPos.top - newPos.top;
  if (dx || dy) {
    c.data.moved = true;
    var s = c.elm.style;
    s.transform = s.WebkitTransform = "translate(" + dx + "px," + dy + "px)";
    s.transitionDuration = '0s';
  }
}

var platformComponents = {
  Transition: Transition,
  TransitionGroup: TransitionGroup
};

/*  */

// install platform specific utils
Vue.config.mustUseProp = mustUseProp;
Vue.config.isReservedTag = isReservedTag;
Vue.config.isReservedAttr = isReservedAttr;
Vue.config.getTagNamespace = getTagNamespace;
Vue.config.isUnknownElement = isUnknownElement;

// install platform runtime directives & components
extend(Vue.options.directives, platformDirectives);
extend(Vue.options.components, platformComponents);

// install platform patch function
Vue.prototype.__patch__ = inBrowser ? patch : noop;

// public mount method
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && inBrowser ? query(el) : undefined;
  return mountComponent(this, el, hydrating)
};

// devtools global hook
/* istanbul ignore next */
if (inBrowser) {
  setTimeout(function () {
    if (config.devtools) {
      if (devtools) {
        devtools.emit('init', Vue);
      } else if (
        false
      ) {
        console[console.info ? 'info' : 'log'](
          'Download the Vue Devtools extension for a better development experience:\n' +
          'https://github.com/vuejs/vue-devtools'
        );
      }
    }
    if (false
    ) {
      console[console.info ? 'info' : 'log'](
        "You are running Vue in development mode.\n" +
        "Make sure to turn on production mode when deploying for production.\n" +
        "See more tips at https://vuejs.org/guide/deployment.html"
      );
    }
  }, 0);
}

/*  */

var defaultTagRE = /\{\{((?:.|\r?\n)+?)\}\}/g;
var regexEscapeRE = /[-.*+?^${}()|[\]\/\\]/g;

var buildRegex = cached(function (delimiters) {
  var open = delimiters[0].replace(regexEscapeRE, '\\$&');
  var close = delimiters[1].replace(regexEscapeRE, '\\$&');
  return new RegExp(open + '((?:.|\\n)+?)' + close, 'g')
});



function parseText (
  text,
  delimiters
) {
  var tagRE = delimiters ? buildRegex(delimiters) : defaultTagRE;
  if (!tagRE.test(text)) {
    return
  }
  var tokens = [];
  var rawTokens = [];
  var lastIndex = tagRE.lastIndex = 0;
  var match, index, tokenValue;
  while ((match = tagRE.exec(text))) {
    index = match.index;
    // push text token
    if (index > lastIndex) {
      rawTokens.push(tokenValue = text.slice(lastIndex, index));
      tokens.push(JSON.stringify(tokenValue));
    }
    // tag token
    var exp = parseFilters(match[1].trim());
    tokens.push(("_s(" + exp + ")"));
    rawTokens.push({ '@binding': exp });
    lastIndex = index + match[0].length;
  }
  if (lastIndex < text.length) {
    rawTokens.push(tokenValue = text.slice(lastIndex));
    tokens.push(JSON.stringify(tokenValue));
  }
  return {
    expression: tokens.join('+'),
    tokens: rawTokens
  }
}

/*  */

function transformNode (el, options) {
  var warn = options.warn || baseWarn;
  var staticClass = getAndRemoveAttr(el, 'class');
  if (false) {
    var res = parseText(staticClass, options.delimiters);
    if (res) {
      warn(
        "class=\"" + staticClass + "\": " +
        'Interpolation inside attributes has been removed. ' +
        'Use v-bind or the colon shorthand instead. For example, ' +
        'instead of <div class="{{ val }}">, use <div :class="val">.',
        el.rawAttrsMap['class']
      );
    }
  }
  if (staticClass) {
    el.staticClass = JSON.stringify(staticClass);
  }
  var classBinding = getBindingAttr(el, 'class', false /* getStatic */);
  if (classBinding) {
    el.classBinding = classBinding;
  }
}

function genData (el) {
  var data = '';
  if (el.staticClass) {
    data += "staticClass:" + (el.staticClass) + ",";
  }
  if (el.classBinding) {
    data += "class:" + (el.classBinding) + ",";
  }
  return data
}

var klass$1 = {
  staticKeys: ['staticClass'],
  transformNode: transformNode,
  genData: genData
};

/*  */

function transformNode$1 (el, options) {
  var warn = options.warn || baseWarn;
  var staticStyle = getAndRemoveAttr(el, 'style');
  if (staticStyle) {
    /* istanbul ignore if */
    if (false) {
      var res = parseText(staticStyle, options.delimiters);
      if (res) {
        warn(
          "style=\"" + staticStyle + "\": " +
          'Interpolation inside attributes has been removed. ' +
          'Use v-bind or the colon shorthand instead. For example, ' +
          'instead of <div style="{{ val }}">, use <div :style="val">.',
          el.rawAttrsMap['style']
        );
      }
    }
    el.staticStyle = JSON.stringify(parseStyleText(staticStyle));
  }

  var styleBinding = getBindingAttr(el, 'style', false /* getStatic */);
  if (styleBinding) {
    el.styleBinding = styleBinding;
  }
}

function genData$1 (el) {
  var data = '';
  if (el.staticStyle) {
    data += "staticStyle:" + (el.staticStyle) + ",";
  }
  if (el.styleBinding) {
    data += "style:(" + (el.styleBinding) + "),";
  }
  return data
}

var style$1 = {
  staticKeys: ['staticStyle'],
  transformNode: transformNode$1,
  genData: genData$1
};

/*  */

var decoder;

var he = {
  decode: function decode (html) {
    decoder = decoder || document.createElement('div');
    decoder.innerHTML = html;
    return decoder.textContent
  }
};

/*  */

var isUnaryTag = makeMap(
  'area,base,br,col,embed,frame,hr,img,input,isindex,keygen,' +
  'link,meta,param,source,track,wbr'
);

// Elements that you can, intentionally, leave open
// (and which close themselves)
var canBeLeftOpenTag = makeMap(
  'colgroup,dd,dt,li,options,p,td,tfoot,th,thead,tr,source'
);

// HTML5 tags https://html.spec.whatwg.org/multipage/indices.html#elements-3
// Phrasing Content https://html.spec.whatwg.org/multipage/dom.html#phrasing-content
var isNonPhrasingTag = makeMap(
  'address,article,aside,base,blockquote,body,caption,col,colgroup,dd,' +
  'details,dialog,div,dl,dt,fieldset,figcaption,figure,footer,form,' +
  'h1,h2,h3,h4,h5,h6,head,header,hgroup,hr,html,legend,li,menuitem,meta,' +
  'optgroup,option,param,rp,rt,source,style,summary,tbody,td,tfoot,th,thead,' +
  'title,tr,track'
);

/**
 * Not type-checking this file because it's mostly vendor code.
 */

// Regular Expressions for parsing tags and attributes
var attribute = /^\s*([^\s"'<>\/=]+)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var dynamicArgAttribute = /^\s*((?:v-[\w-]+:|@|:|#)\[[^=]+\][^\s"'<>\/=]*)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var ncname = "[a-zA-Z_][\\-\\.0-9_a-zA-Z" + (unicodeRegExp.source) + "]*";
var qnameCapture = "((?:" + ncname + "\\:)?" + ncname + ")";
var startTagOpen = new RegExp(("^<" + qnameCapture));
var startTagClose = /^\s*(\/?)>/;
var endTag = new RegExp(("^<\\/" + qnameCapture + "[^>]*>"));
var doctype = /^<!DOCTYPE [^>]+>/i;
// #7298: escape - to avoid being passed as HTML comment when inlined in page
var comment = /^<!\--/;
var conditionalComment = /^<!\[/;

// Special Elements (can contain anything)
var isPlainTextElement = makeMap('script,style,textarea', true);
var reCache = {};

var decodingMap = {
  '&lt;': '<',
  '&gt;': '>',
  '&quot;': '"',
  '&amp;': '&',
  '&#10;': '\n',
  '&#9;': '\t',
  '&#39;': "'"
};
var encodedAttr = /&(?:lt|gt|quot|amp|#39);/g;
var encodedAttrWithNewLines = /&(?:lt|gt|quot|amp|#39|#10|#9);/g;

// #5992
var isIgnoreNewlineTag = makeMap('pre,textarea', true);
var shouldIgnoreFirstNewline = function (tag, html) { return tag && isIgnoreNewlineTag(tag) && html[0] === '\n'; };

function decodeAttr (value, shouldDecodeNewlines) {
  var re = shouldDecodeNewlines ? encodedAttrWithNewLines : encodedAttr;
  return value.replace(re, function (match) { return decodingMap[match]; })
}

function parseHTML (html, options) {
  var stack = [];
  var expectHTML = options.expectHTML;
  var isUnaryTag$$1 = options.isUnaryTag || no;
  var canBeLeftOpenTag$$1 = options.canBeLeftOpenTag || no;
  var index = 0;
  var last, lastTag;
  while (html) {
    last = html;
    // Make sure we're not in a plaintext content element like script/style
    if (!lastTag || !isPlainTextElement(lastTag)) {
      var textEnd = html.indexOf('<');
      if (textEnd === 0) {
        // Comment:
        if (comment.test(html)) {
          var commentEnd = html.indexOf('-->');

          if (commentEnd >= 0) {
            if (options.shouldKeepComment) {
              options.comment(html.substring(4, commentEnd), index, index + commentEnd + 3);
            }
            advance(commentEnd + 3);
            continue
          }
        }

        // http://en.wikipedia.org/wiki/Conditional_comment#Downlevel-revealed_conditional_comment
        if (conditionalComment.test(html)) {
          var conditionalEnd = html.indexOf(']>');

          if (conditionalEnd >= 0) {
            advance(conditionalEnd + 2);
            continue
          }
        }

        // Doctype:
        var doctypeMatch = html.match(doctype);
        if (doctypeMatch) {
          advance(doctypeMatch[0].length);
          continue
        }

        // End tag:
        var endTagMatch = html.match(endTag);
        if (endTagMatch) {
          var curIndex = index;
          advance(endTagMatch[0].length);
          parseEndTag(endTagMatch[1], curIndex, index);
          continue
        }

        // Start tag:
        var startTagMatch = parseStartTag();
        if (startTagMatch) {
          handleStartTag(startTagMatch);
          if (shouldIgnoreFirstNewline(startTagMatch.tagName, html)) {
            advance(1);
          }
          continue
        }
      }

      var text = (void 0), rest = (void 0), next = (void 0);
      if (textEnd >= 0) {
        rest = html.slice(textEnd);
        while (
          !endTag.test(rest) &&
          !startTagOpen.test(rest) &&
          !comment.test(rest) &&
          !conditionalComment.test(rest)
        ) {
          // < in plain text, be forgiving and treat it as text
          next = rest.indexOf('<', 1);
          if (next < 0) { break }
          textEnd += next;
          rest = html.slice(textEnd);
        }
        text = html.substring(0, textEnd);
      }

      if (textEnd < 0) {
        text = html;
      }

      if (text) {
        advance(text.length);
      }

      if (options.chars && text) {
        options.chars(text, index - text.length, index);
      }
    } else {
      var endTagLength = 0;
      var stackedTag = lastTag.toLowerCase();
      var reStackedTag = reCache[stackedTag] || (reCache[stackedTag] = new RegExp('([\\s\\S]*?)(</' + stackedTag + '[^>]*>)', 'i'));
      var rest$1 = html.replace(reStackedTag, function (all, text, endTag) {
        endTagLength = endTag.length;
        if (!isPlainTextElement(stackedTag) && stackedTag !== 'noscript') {
          text = text
            .replace(/<!\--([\s\S]*?)-->/g, '$1') // #7298
            .replace(/<!\[CDATA\[([\s\S]*?)]]>/g, '$1');
        }
        if (shouldIgnoreFirstNewline(stackedTag, text)) {
          text = text.slice(1);
        }
        if (options.chars) {
          options.chars(text);
        }
        return ''
      });
      index += html.length - rest$1.length;
      html = rest$1;
      parseEndTag(stackedTag, index - endTagLength, index);
    }

    if (html === last) {
      options.chars && options.chars(html);
      if (false) {
        options.warn(("Mal-formatted tag at end of template: \"" + html + "\""), { start: index + html.length });
      }
      break
    }
  }

  // Clean up any remaining tags
  parseEndTag();

  function advance (n) {
    index += n;
    html = html.substring(n);
  }

  function parseStartTag () {
    var start = html.match(startTagOpen);
    if (start) {
      var match = {
        tagName: start[1],
        attrs: [],
        start: index
      };
      advance(start[0].length);
      var end, attr;
      while (!(end = html.match(startTagClose)) && (attr = html.match(dynamicArgAttribute) || html.match(attribute))) {
        attr.start = index;
        advance(attr[0].length);
        attr.end = index;
        match.attrs.push(attr);
      }
      if (end) {
        match.unarySlash = end[1];
        advance(end[0].length);
        match.end = index;
        return match
      }
    }
  }

  function handleStartTag (match) {
    var tagName = match.tagName;
    var unarySlash = match.unarySlash;

    if (expectHTML) {
      if (lastTag === 'p' && isNonPhrasingTag(tagName)) {
        parseEndTag(lastTag);
      }
      if (canBeLeftOpenTag$$1(tagName) && lastTag === tagName) {
        parseEndTag(tagName);
      }
    }

    var unary = isUnaryTag$$1(tagName) || !!unarySlash;

    var l = match.attrs.length;
    var attrs = new Array(l);
    for (var i = 0; i < l; i++) {
      var args = match.attrs[i];
      var value = args[3] || args[4] || args[5] || '';
      var shouldDecodeNewlines = tagName === 'a' && args[1] === 'href'
        ? options.shouldDecodeNewlinesForHref
        : options.shouldDecodeNewlines;
      attrs[i] = {
        name: args[1],
        value: decodeAttr(value, shouldDecodeNewlines)
      };
      if (false) {
        attrs[i].start = args.start + args[0].match(/^\s*/).length;
        attrs[i].end = args.end;
      }
    }

    if (!unary) {
      stack.push({ tag: tagName, lowerCasedTag: tagName.toLowerCase(), attrs: attrs, start: match.start, end: match.end });
      lastTag = tagName;
    }

    if (options.start) {
      options.start(tagName, attrs, unary, match.start, match.end);
    }
  }

  function parseEndTag (tagName, start, end) {
    var pos, lowerCasedTagName;
    if (start == null) { start = index; }
    if (end == null) { end = index; }

    // Find the closest opened tag of the same type
    if (tagName) {
      lowerCasedTagName = tagName.toLowerCase();
      for (pos = stack.length - 1; pos >= 0; pos--) {
        if (stack[pos].lowerCasedTag === lowerCasedTagName) {
          break
        }
      }
    } else {
      // If no tag name is provided, clean shop
      pos = 0;
    }

    if (pos >= 0) {
      // Close all the open elements, up the stack
      for (var i = stack.length - 1; i >= pos; i--) {
        if (false
        ) {
          options.warn(
            ("tag <" + (stack[i].tag) + "> has no matching end tag."),
            { start: stack[i].start, end: stack[i].end }
          );
        }
        if (options.end) {
          options.end(stack[i].tag, start, end);
        }
      }

      // Remove the open elements from the stack
      stack.length = pos;
      lastTag = pos && stack[pos - 1].tag;
    } else if (lowerCasedTagName === 'br') {
      if (options.start) {
        options.start(tagName, [], true, start, end);
      }
    } else if (lowerCasedTagName === 'p') {
      if (options.start) {
        options.start(tagName, [], false, start, end);
      }
      if (options.end) {
        options.end(tagName, start, end);
      }
    }
  }
}

/*  */

var onRE = /^@|^v-on:/;
var dirRE = /^v-|^@|^:|^#/;
var forAliasRE = /([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/;
var forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
var stripParensRE = /^\(|\)$/g;
var dynamicArgRE = /^\[.*\]$/;

var argRE = /:(.*)$/;
var bindRE = /^:|^\.|^v-bind:/;
var modifierRE = /\.[^.\]]+(?=[^\]]*$)/g;

var slotRE = /^v-slot(:|$)|^#/;

var lineBreakRE = /[\r\n]/;
var whitespaceRE$1 = /\s+/g;

var invalidAttributeRE = /[\s"'<>\/=]/;

var decodeHTMLCached = cached(he.decode);

var emptySlotScopeToken = "_empty_";

// configurable state
var warn$2;
var delimiters;
var transforms;
var preTransforms;
var postTransforms;
var platformIsPreTag;
var platformMustUseProp;
var platformGetTagNamespace;
var maybeComponent;

function createASTElement (
  tag,
  attrs,
  parent
) {
  return {
    type: 1,
    tag: tag,
    attrsList: attrs,
    attrsMap: makeAttrsMap(attrs),
    rawAttrsMap: {},
    parent: parent,
    children: []
  }
}

/**
 * Convert HTML string to AST.
 */
function parse (
  template,
  options
) {
  warn$2 = options.warn || baseWarn;

  platformIsPreTag = options.isPreTag || no;
  platformMustUseProp = options.mustUseProp || no;
  platformGetTagNamespace = options.getTagNamespace || no;
  var isReservedTag = options.isReservedTag || no;
  maybeComponent = function (el) { return !!el.component || !isReservedTag(el.tag); };

  transforms = pluckModuleFunction(options.modules, 'transformNode');
  preTransforms = pluckModuleFunction(options.modules, 'preTransformNode');
  postTransforms = pluckModuleFunction(options.modules, 'postTransformNode');

  delimiters = options.delimiters;

  var stack = [];
  var preserveWhitespace = options.preserveWhitespace !== false;
  var whitespaceOption = options.whitespace;
  var root;
  var currentParent;
  var inVPre = false;
  var inPre = false;
  var warned = false;

  function warnOnce (msg, range) {
    if (!warned) {
      warned = true;
      warn$2(msg, range);
    }
  }

  function closeElement (element) {
    trimEndingWhitespace(element);
    if (!inVPre && !element.processed) {
      element = processElement(element, options);
    }
    // tree management
    if (!stack.length && element !== root) {
      // allow root elements with v-if, v-else-if and v-else
      if (root.if && (element.elseif || element.else)) {
        if (false) {
          checkRootConstraints(element);
        }
        addIfCondition(root, {
          exp: element.elseif,
          block: element
        });
      } else if (false) {
        warnOnce(
          "Component template should contain exactly one root element. " +
          "If you are using v-if on multiple elements, " +
          "use v-else-if to chain them instead.",
          { start: element.start }
        );
      }
    }
    if (currentParent && !element.forbidden) {
      if (element.elseif || element.else) {
        processIfConditions(element, currentParent);
      } else {
        if (element.slotScope) {
          // scoped slot
          // keep it in the children list so that v-else(-if) conditions can
          // find it as the prev node.
          var name = element.slotTarget || '"default"'
          ;(currentParent.scopedSlots || (currentParent.scopedSlots = {}))[name] = element;
        }
        currentParent.children.push(element);
        element.parent = currentParent;
      }
    }

    // final children cleanup
    // filter out scoped slots
    element.children = element.children.filter(function (c) { return !(c).slotScope; });
    // remove trailing whitespace node again
    trimEndingWhitespace(element);

    // check pre state
    if (element.pre) {
      inVPre = false;
    }
    if (platformIsPreTag(element.tag)) {
      inPre = false;
    }
    // apply post-transforms
    for (var i = 0; i < postTransforms.length; i++) {
      postTransforms[i](element, options);
    }
  }

  function trimEndingWhitespace (el) {
    // remove trailing whitespace node
    if (!inPre) {
      var lastNode;
      while (
        (lastNode = el.children[el.children.length - 1]) &&
        lastNode.type === 3 &&
        lastNode.text === ' '
      ) {
        el.children.pop();
      }
    }
  }

  function checkRootConstraints (el) {
    if (el.tag === 'slot' || el.tag === 'template') {
      warnOnce(
        "Cannot use <" + (el.tag) + "> as component root element because it may " +
        'contain multiple nodes.',
        { start: el.start }
      );
    }
    if (el.attrsMap.hasOwnProperty('v-for')) {
      warnOnce(
        'Cannot use v-for on stateful component root element because ' +
        'it renders multiple elements.',
        el.rawAttrsMap['v-for']
      );
    }
  }

  parseHTML(template, {
    warn: warn$2,
    expectHTML: options.expectHTML,
    isUnaryTag: options.isUnaryTag,
    canBeLeftOpenTag: options.canBeLeftOpenTag,
    shouldDecodeNewlines: options.shouldDecodeNewlines,
    shouldDecodeNewlinesForHref: options.shouldDecodeNewlinesForHref,
    shouldKeepComment: options.comments,
    outputSourceRange: options.outputSourceRange,
    start: function start (tag, attrs, unary, start$1, end) {
      // check namespace.
      // inherit parent ns if there is one
      var ns = (currentParent && currentParent.ns) || platformGetTagNamespace(tag);

      // handle IE svg bug
      /* istanbul ignore if */
      if (isIE && ns === 'svg') {
        attrs = guardIESVGBug(attrs);
      }

      var element = createASTElement(tag, attrs, currentParent);
      if (ns) {
        element.ns = ns;
      }

      if (false) {
        if (options.outputSourceRange) {
          element.start = start$1;
          element.end = end;
          element.rawAttrsMap = element.attrsList.reduce(function (cumulated, attr) {
            cumulated[attr.name] = attr;
            return cumulated
          }, {});
        }
        attrs.forEach(function (attr) {
          if (invalidAttributeRE.test(attr.name)) {
            warn$2(
              "Invalid dynamic argument expression: attribute names cannot contain " +
              "spaces, quotes, <, >, / or =.",
              {
                start: attr.start + attr.name.indexOf("["),
                end: attr.start + attr.name.length
              }
            );
          }
        });
      }

      if (isForbiddenTag(element) && !isServerRendering()) {
        element.forbidden = true;
        "production" !== 'production' && warn$2(
          'Templates should only be responsible for mapping the state to the ' +
          'UI. Avoid placing tags with side-effects in your templates, such as ' +
          "<" + tag + ">" + ', as they will not be parsed.',
          { start: element.start }
        );
      }

      // apply pre-transforms
      for (var i = 0; i < preTransforms.length; i++) {
        element = preTransforms[i](element, options) || element;
      }

      if (!inVPre) {
        processPre(element);
        if (element.pre) {
          inVPre = true;
        }
      }
      if (platformIsPreTag(element.tag)) {
        inPre = true;
      }
      if (inVPre) {
        processRawAttrs(element);
      } else if (!element.processed) {
        // structural directives
        processFor(element);
        processIf(element);
        processOnce(element);
      }

      if (!root) {
        root = element;
        if (false) {
          checkRootConstraints(root);
        }
      }

      if (!unary) {
        currentParent = element;
        stack.push(element);
      } else {
        closeElement(element);
      }
    },

    end: function end (tag, start, end$1) {
      var element = stack[stack.length - 1];
      // pop stack
      stack.length -= 1;
      currentParent = stack[stack.length - 1];
      if (false) {
        element.end = end$1;
      }
      closeElement(element);
    },

    chars: function chars (text, start, end) {
      if (!currentParent) {
        if (false) {
          if (text === template) {
            warnOnce(
              'Component template requires a root element, rather than just text.',
              { start: start }
            );
          } else if ((text = text.trim())) {
            warnOnce(
              ("text \"" + text + "\" outside root element will be ignored."),
              { start: start }
            );
          }
        }
        return
      }
      // IE textarea placeholder bug
      /* istanbul ignore if */
      if (isIE &&
        currentParent.tag === 'textarea' &&
        currentParent.attrsMap.placeholder === text
      ) {
        return
      }
      var children = currentParent.children;
      if (inPre || text.trim()) {
        text = isTextTag(currentParent) ? text : decodeHTMLCached(text);
      } else if (!children.length) {
        // remove the whitespace-only node right after an opening tag
        text = '';
      } else if (whitespaceOption) {
        if (whitespaceOption === 'condense') {
          // in condense mode, remove the whitespace node if it contains
          // line break, otherwise condense to a single space
          text = lineBreakRE.test(text) ? '' : ' ';
        } else {
          text = ' ';
        }
      } else {
        text = preserveWhitespace ? ' ' : '';
      }
      if (text) {
        if (!inPre && whitespaceOption === 'condense') {
          // condense consecutive whitespaces into single space
          text = text.replace(whitespaceRE$1, ' ');
        }
        var res;
        var child;
        if (!inVPre && text !== ' ' && (res = parseText(text, delimiters))) {
          child = {
            type: 2,
            expression: res.expression,
            tokens: res.tokens,
            text: text
          };
        } else if (text !== ' ' || !children.length || children[children.length - 1].text !== ' ') {
          child = {
            type: 3,
            text: text
          };
        }
        if (child) {
          if (false) {
            child.start = start;
            child.end = end;
          }
          children.push(child);
        }
      }
    },
    comment: function comment (text, start, end) {
      // adding anything as a sibling to the root node is forbidden
      // comments should still be allowed, but ignored
      if (currentParent) {
        var child = {
          type: 3,
          text: text,
          isComment: true
        };
        if (false) {
          child.start = start;
          child.end = end;
        }
        currentParent.children.push(child);
      }
    }
  });
  return root
}

function processPre (el) {
  if (getAndRemoveAttr(el, 'v-pre') != null) {
    el.pre = true;
  }
}

function processRawAttrs (el) {
  var list = el.attrsList;
  var len = list.length;
  if (len) {
    var attrs = el.attrs = new Array(len);
    for (var i = 0; i < len; i++) {
      attrs[i] = {
        name: list[i].name,
        value: JSON.stringify(list[i].value)
      };
      if (list[i].start != null) {
        attrs[i].start = list[i].start;
        attrs[i].end = list[i].end;
      }
    }
  } else if (!el.pre) {
    // non root node in pre blocks with no attributes
    el.plain = true;
  }
}

function processElement (
  element,
  options
) {
  processKey(element);

  // determine whether this is a plain element after
  // removing structural attributes
  element.plain = (
    !element.key &&
    !element.scopedSlots &&
    !element.attrsList.length
  );

  processRef(element);
  processSlotContent(element);
  processSlotOutlet(element);
  processComponent(element);
  for (var i = 0; i < transforms.length; i++) {
    element = transforms[i](element, options) || element;
  }
  processAttrs(element);
  return element
}

function processKey (el) {
  var exp = getBindingAttr(el, 'key');
  if (exp) {
    if (false) {
      if (el.tag === 'template') {
        warn$2(
          "<template> cannot be keyed. Place the key on real elements instead.",
          getRawBindingAttr(el, 'key')
        );
      }
      if (el.for) {
        var iterator = el.iterator2 || el.iterator1;
        var parent = el.parent;
        if (iterator && iterator === exp && parent && parent.tag === 'transition-group') {
          warn$2(
            "Do not use v-for index as key on <transition-group> children, " +
            "this is the same as not using keys.",
            getRawBindingAttr(el, 'key'),
            true /* tip */
          );
        }
      }
    }
    el.key = exp;
  }
}

function processRef (el) {
  var ref = getBindingAttr(el, 'ref');
  if (ref) {
    el.ref = ref;
    el.refInFor = checkInFor(el);
  }
}

function processFor (el) {
  var exp;
  if ((exp = getAndRemoveAttr(el, 'v-for'))) {
    var res = parseFor(exp);
    if (res) {
      extend(el, res);
    } else if (false) {
      warn$2(
        ("Invalid v-for expression: " + exp),
        el.rawAttrsMap['v-for']
      );
    }
  }
}



function parseFor (exp) {
  var inMatch = exp.match(forAliasRE);
  if (!inMatch) { return }
  var res = {};
  res.for = inMatch[2].trim();
  var alias = inMatch[1].trim().replace(stripParensRE, '');
  var iteratorMatch = alias.match(forIteratorRE);
  if (iteratorMatch) {
    res.alias = alias.replace(forIteratorRE, '').trim();
    res.iterator1 = iteratorMatch[1].trim();
    if (iteratorMatch[2]) {
      res.iterator2 = iteratorMatch[2].trim();
    }
  } else {
    res.alias = alias;
  }
  return res
}

function processIf (el) {
  var exp = getAndRemoveAttr(el, 'v-if');
  if (exp) {
    el.if = exp;
    addIfCondition(el, {
      exp: exp,
      block: el
    });
  } else {
    if (getAndRemoveAttr(el, 'v-else') != null) {
      el.else = true;
    }
    var elseif = getAndRemoveAttr(el, 'v-else-if');
    if (elseif) {
      el.elseif = elseif;
    }
  }
}

function processIfConditions (el, parent) {
  var prev = findPrevElement(parent.children);
  if (prev && prev.if) {
    addIfCondition(prev, {
      exp: el.elseif,
      block: el
    });
  } else if (false) {
    warn$2(
      "v-" + (el.elseif ? ('else-if="' + el.elseif + '"') : 'else') + " " +
      "used on element <" + (el.tag) + "> without corresponding v-if.",
      el.rawAttrsMap[el.elseif ? 'v-else-if' : 'v-else']
    );
  }
}

function findPrevElement (children) {
  var i = children.length;
  while (i--) {
    if (children[i].type === 1) {
      return children[i]
    } else {
      if (false) {
        warn$2(
          "text \"" + (children[i].text.trim()) + "\" between v-if and v-else(-if) " +
          "will be ignored.",
          children[i]
        );
      }
      children.pop();
    }
  }
}

function addIfCondition (el, condition) {
  if (!el.ifConditions) {
    el.ifConditions = [];
  }
  el.ifConditions.push(condition);
}

function processOnce (el) {
  var once$$1 = getAndRemoveAttr(el, 'v-once');
  if (once$$1 != null) {
    el.once = true;
  }
}

// handle content being passed to a component as slot,
// e.g. <template slot="xxx">, <div slot-scope="xxx">
function processSlotContent (el) {
  var slotScope;
  if (el.tag === 'template') {
    slotScope = getAndRemoveAttr(el, 'scope');
    /* istanbul ignore if */
    if (false) {
      warn$2(
        "the \"scope\" attribute for scoped slots have been deprecated and " +
        "replaced by \"slot-scope\" since 2.5. The new \"slot-scope\" attribute " +
        "can also be used on plain elements in addition to <template> to " +
        "denote scoped slots.",
        el.rawAttrsMap['scope'],
        true
      );
    }
    el.slotScope = slotScope || getAndRemoveAttr(el, 'slot-scope');
  } else if ((slotScope = getAndRemoveAttr(el, 'slot-scope'))) {
    /* istanbul ignore if */
    if (false) {
      warn$2(
        "Ambiguous combined usage of slot-scope and v-for on <" + (el.tag) + "> " +
        "(v-for takes higher priority). Use a wrapper <template> for the " +
        "scoped slot to make it clearer.",
        el.rawAttrsMap['slot-scope'],
        true
      );
    }
    el.slotScope = slotScope;
  }

  // slot="xxx"
  var slotTarget = getBindingAttr(el, 'slot');
  if (slotTarget) {
    el.slotTarget = slotTarget === '""' ? '"default"' : slotTarget;
    el.slotTargetDynamic = !!(el.attrsMap[':slot'] || el.attrsMap['v-bind:slot']);
    // preserve slot as an attribute for native shadow DOM compat
    // only for non-scoped slots.
    if (el.tag !== 'template' && !el.slotScope) {
      addAttr(el, 'slot', slotTarget, getRawBindingAttr(el, 'slot'));
    }
  }

  // 2.6 v-slot syntax
  {
    if (el.tag === 'template') {
      // v-slot on <template>
      var slotBinding = getAndRemoveAttrByRegex(el, slotRE);
      if (slotBinding) {
        if (false) {
          if (el.slotTarget || el.slotScope) {
            warn$2(
              "Unexpected mixed usage of different slot syntaxes.",
              el
            );
          }
          if (el.parent && !maybeComponent(el.parent)) {
            warn$2(
              "<template v-slot> can only appear at the root level inside " +
              "the receiving component",
              el
            );
          }
        }
        var ref = getSlotName(slotBinding);
        var name = ref.name;
        var dynamic = ref.dynamic;
        el.slotTarget = name;
        el.slotTargetDynamic = dynamic;
        el.slotScope = slotBinding.value || emptySlotScopeToken; // force it into a scoped slot for perf
      }
    } else {
      // v-slot on component, denotes default slot
      var slotBinding$1 = getAndRemoveAttrByRegex(el, slotRE);
      if (slotBinding$1) {
        if (false) {
          if (!maybeComponent(el)) {
            warn$2(
              "v-slot can only be used on components or <template>.",
              slotBinding$1
            );
          }
          if (el.slotScope || el.slotTarget) {
            warn$2(
              "Unexpected mixed usage of different slot syntaxes.",
              el
            );
          }
          if (el.scopedSlots) {
            warn$2(
              "To avoid scope ambiguity, the default slot should also use " +
              "<template> syntax when there are other named slots.",
              slotBinding$1
            );
          }
        }
        // add the component's children to its default slot
        var slots = el.scopedSlots || (el.scopedSlots = {});
        var ref$1 = getSlotName(slotBinding$1);
        var name$1 = ref$1.name;
        var dynamic$1 = ref$1.dynamic;
        var slotContainer = slots[name$1] = createASTElement('template', [], el);
        slotContainer.slotTarget = name$1;
        slotContainer.slotTargetDynamic = dynamic$1;
        slotContainer.children = el.children.filter(function (c) {
          if (!c.slotScope) {
            c.parent = slotContainer;
            return true
          }
        });
        slotContainer.slotScope = slotBinding$1.value || emptySlotScopeToken;
        // remove children as they are returned from scopedSlots now
        el.children = [];
        // mark el non-plain so data gets generated
        el.plain = false;
      }
    }
  }
}

function getSlotName (binding) {
  var name = binding.name.replace(slotRE, '');
  if (!name) {
    if (binding.name[0] !== '#') {
      name = 'default';
    } else if (false) {
      warn$2(
        "v-slot shorthand syntax requires a slot name.",
        binding
      );
    }
  }
  return dynamicArgRE.test(name)
    // dynamic [name]
    ? { name: name.slice(1, -1), dynamic: true }
    // static name
    : { name: ("\"" + name + "\""), dynamic: false }
}

// handle <slot/> outlets
function processSlotOutlet (el) {
  if (el.tag === 'slot') {
    el.slotName = getBindingAttr(el, 'name');
    if (false) {
      warn$2(
        "`key` does not work on <slot> because slots are abstract outlets " +
        "and can possibly expand into multiple elements. " +
        "Use the key on a wrapping element instead.",
        getRawBindingAttr(el, 'key')
      );
    }
  }
}

function processComponent (el) {
  var binding;
  if ((binding = getBindingAttr(el, 'is'))) {
    el.component = binding;
  }
  if (getAndRemoveAttr(el, 'inline-template') != null) {
    el.inlineTemplate = true;
  }
}

function processAttrs (el) {
  var list = el.attrsList;
  var i, l, name, rawName, value, modifiers, syncGen, isDynamic;
  for (i = 0, l = list.length; i < l; i++) {
    name = rawName = list[i].name;
    value = list[i].value;
    if (dirRE.test(name)) {
      // mark element as dynamic
      el.hasBindings = true;
      // modifiers
      modifiers = parseModifiers(name.replace(dirRE, ''));
      // support .foo shorthand syntax for the .prop modifier
      if (modifiers) {
        name = name.replace(modifierRE, '');
      }
      if (bindRE.test(name)) { // v-bind
        name = name.replace(bindRE, '');
        value = parseFilters(value);
        isDynamic = dynamicArgRE.test(name);
        if (isDynamic) {
          name = name.slice(1, -1);
        }
        if (
          false
        ) {
          warn$2(
            ("The value for a v-bind expression cannot be empty. Found in \"v-bind:" + name + "\"")
          );
        }
        if (modifiers) {
          if (modifiers.prop && !isDynamic) {
            name = camelize(name);
            if (name === 'innerHtml') { name = 'innerHTML'; }
          }
          if (modifiers.camel && !isDynamic) {
            name = camelize(name);
          }
          if (modifiers.sync) {
            syncGen = genAssignmentCode(value, "$event");
            if (!isDynamic) {
              addHandler(
                el,
                ("update:" + (camelize(name))),
                syncGen,
                null,
                false,
                warn$2,
                list[i]
              );
              if (hyphenate(name) !== camelize(name)) {
                addHandler(
                  el,
                  ("update:" + (hyphenate(name))),
                  syncGen,
                  null,
                  false,
                  warn$2,
                  list[i]
                );
              }
            } else {
              // handler w/ dynamic event name
              addHandler(
                el,
                ("\"update:\"+(" + name + ")"),
                syncGen,
                null,
                false,
                warn$2,
                list[i],
                true // dynamic
              );
            }
          }
        }
        if ((modifiers && modifiers.prop) || (
          !el.component && platformMustUseProp(el.tag, el.attrsMap.type, name)
        )) {
          addProp(el, name, value, list[i], isDynamic);
        } else {
          addAttr(el, name, value, list[i], isDynamic);
        }
      } else if (onRE.test(name)) { // v-on
        name = name.replace(onRE, '');
        isDynamic = dynamicArgRE.test(name);
        if (isDynamic) {
          name = name.slice(1, -1);
        }
        addHandler(el, name, value, modifiers, false, warn$2, list[i], isDynamic);
      } else { // normal directives
        name = name.replace(dirRE, '');
        // parse arg
        var argMatch = name.match(argRE);
        var arg = argMatch && argMatch[1];
        isDynamic = false;
        if (arg) {
          name = name.slice(0, -(arg.length + 1));
          if (dynamicArgRE.test(arg)) {
            arg = arg.slice(1, -1);
            isDynamic = true;
          }
        }
        addDirective(el, name, rawName, value, arg, isDynamic, modifiers, list[i]);
        if (false) {
          checkForAliasModel(el, value);
        }
      }
    } else {
      // literal attribute
      if (false) {
        var res = parseText(value, delimiters);
        if (res) {
          warn$2(
            name + "=\"" + value + "\": " +
            'Interpolation inside attributes has been removed. ' +
            'Use v-bind or the colon shorthand instead. For example, ' +
            'instead of <div id="{{ val }}">, use <div :id="val">.',
            list[i]
          );
        }
      }
      addAttr(el, name, JSON.stringify(value), list[i]);
      // #6887 firefox doesn't update muted state if set via attribute
      // even immediately after element creation
      if (!el.component &&
          name === 'muted' &&
          platformMustUseProp(el.tag, el.attrsMap.type, name)) {
        addProp(el, name, 'true', list[i]);
      }
    }
  }
}

function checkInFor (el) {
  var parent = el;
  while (parent) {
    if (parent.for !== undefined) {
      return true
    }
    parent = parent.parent;
  }
  return false
}

function parseModifiers (name) {
  var match = name.match(modifierRE);
  if (match) {
    var ret = {};
    match.forEach(function (m) { ret[m.slice(1)] = true; });
    return ret
  }
}

function makeAttrsMap (attrs) {
  var map = {};
  for (var i = 0, l = attrs.length; i < l; i++) {
    if (
      false
    ) {
      warn$2('duplicate attribute: ' + attrs[i].name, attrs[i]);
    }
    map[attrs[i].name] = attrs[i].value;
  }
  return map
}

// for script (e.g. type="x/template") or style, do not decode content
function isTextTag (el) {
  return el.tag === 'script' || el.tag === 'style'
}

function isForbiddenTag (el) {
  return (
    el.tag === 'style' ||
    (el.tag === 'script' && (
      !el.attrsMap.type ||
      el.attrsMap.type === 'text/javascript'
    ))
  )
}

var ieNSBug = /^xmlns:NS\d+/;
var ieNSPrefix = /^NS\d+:/;

/* istanbul ignore next */
function guardIESVGBug (attrs) {
  var res = [];
  for (var i = 0; i < attrs.length; i++) {
    var attr = attrs[i];
    if (!ieNSBug.test(attr.name)) {
      attr.name = attr.name.replace(ieNSPrefix, '');
      res.push(attr);
    }
  }
  return res
}

function checkForAliasModel (el, value) {
  var _el = el;
  while (_el) {
    if (_el.for && _el.alias === value) {
      warn$2(
        "<" + (el.tag) + " v-model=\"" + value + "\">: " +
        "You are binding v-model directly to a v-for iteration alias. " +
        "This will not be able to modify the v-for source array because " +
        "writing to the alias is like modifying a function local variable. " +
        "Consider using an array of objects and use v-model on an object property instead.",
        el.rawAttrsMap['v-model']
      );
    }
    _el = _el.parent;
  }
}

/*  */

function preTransformNode (el, options) {
  if (el.tag === 'input') {
    var map = el.attrsMap;
    if (!map['v-model']) {
      return
    }

    var typeBinding;
    if (map[':type'] || map['v-bind:type']) {
      typeBinding = getBindingAttr(el, 'type');
    }
    if (!map.type && !typeBinding && map['v-bind']) {
      typeBinding = "(" + (map['v-bind']) + ").type";
    }

    if (typeBinding) {
      var ifCondition = getAndRemoveAttr(el, 'v-if', true);
      var ifConditionExtra = ifCondition ? ("&&(" + ifCondition + ")") : "";
      var hasElse = getAndRemoveAttr(el, 'v-else', true) != null;
      var elseIfCondition = getAndRemoveAttr(el, 'v-else-if', true);
      // 1. checkbox
      var branch0 = cloneASTElement(el);
      // process for on the main node
      processFor(branch0);
      addRawAttr(branch0, 'type', 'checkbox');
      processElement(branch0, options);
      branch0.processed = true; // prevent it from double-processed
      branch0.if = "(" + typeBinding + ")==='checkbox'" + ifConditionExtra;
      addIfCondition(branch0, {
        exp: branch0.if,
        block: branch0
      });
      // 2. add radio else-if condition
      var branch1 = cloneASTElement(el);
      getAndRemoveAttr(branch1, 'v-for', true);
      addRawAttr(branch1, 'type', 'radio');
      processElement(branch1, options);
      addIfCondition(branch0, {
        exp: "(" + typeBinding + ")==='radio'" + ifConditionExtra,
        block: branch1
      });
      // 3. other
      var branch2 = cloneASTElement(el);
      getAndRemoveAttr(branch2, 'v-for', true);
      addRawAttr(branch2, ':type', typeBinding);
      processElement(branch2, options);
      addIfCondition(branch0, {
        exp: ifCondition,
        block: branch2
      });

      if (hasElse) {
        branch0.else = true;
      } else if (elseIfCondition) {
        branch0.elseif = elseIfCondition;
      }

      return branch0
    }
  }
}

function cloneASTElement (el) {
  return createASTElement(el.tag, el.attrsList.slice(), el.parent)
}

var model$1 = {
  preTransformNode: preTransformNode
};

var modules$1 = [
  klass$1,
  style$1,
  model$1
];

/*  */

function text (el, dir) {
  if (dir.value) {
    addProp(el, 'textContent', ("_s(" + (dir.value) + ")"), dir);
  }
}

/*  */

function html (el, dir) {
  if (dir.value) {
    addProp(el, 'innerHTML', ("_s(" + (dir.value) + ")"), dir);
  }
}

var directives$1 = {
  model: model,
  text: text,
  html: html
};

/*  */

var baseOptions = {
  expectHTML: true,
  modules: modules$1,
  directives: directives$1,
  isPreTag: isPreTag,
  isUnaryTag: isUnaryTag,
  mustUseProp: mustUseProp,
  canBeLeftOpenTag: canBeLeftOpenTag,
  isReservedTag: isReservedTag,
  getTagNamespace: getTagNamespace,
  staticKeys: genStaticKeys(modules$1)
};

/*  */

var isStaticKey;
var isPlatformReservedTag;

var genStaticKeysCached = cached(genStaticKeys$1);

/**
 * Goal of the optimizer: walk the generated template AST tree
 * and detect sub-trees that are purely static, i.e. parts of
 * the DOM that never needs to change.
 *
 * Once we detect these sub-trees, we can:
 *
 * 1. Hoist them into constants, so that we no longer need to
 *    create fresh nodes for them on each re-render;
 * 2. Completely skip them in the patching process.
 */
function optimize (root, options) {
  if (!root) { return }
  isStaticKey = genStaticKeysCached(options.staticKeys || '');
  isPlatformReservedTag = options.isReservedTag || no;
  // first pass: mark all non-static nodes.
  markStatic$1(root);
  // second pass: mark static roots.
  markStaticRoots(root, false);
}

function genStaticKeys$1 (keys) {
  return makeMap(
    'type,tag,attrsList,attrsMap,plain,parent,children,attrs,start,end,rawAttrsMap' +
    (keys ? ',' + keys : '')
  )
}

function markStatic$1 (node) {
  node.static = isStatic(node);
  if (node.type === 1) {
    // do not make component slot content static. this avoids
    // 1. components not able to mutate slot nodes
    // 2. static slot content fails for hot-reloading
    if (
      !isPlatformReservedTag(node.tag) &&
      node.tag !== 'slot' &&
      node.attrsMap['inline-template'] == null
    ) {
      return
    }
    for (var i = 0, l = node.children.length; i < l; i++) {
      var child = node.children[i];
      markStatic$1(child);
      if (!child.static) {
        node.static = false;
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        var block = node.ifConditions[i$1].block;
        markStatic$1(block);
        if (!block.static) {
          node.static = false;
        }
      }
    }
  }
}

function markStaticRoots (node, isInFor) {
  if (node.type === 1) {
    if (node.static || node.once) {
      node.staticInFor = isInFor;
    }
    // For a node to qualify as a static root, it should have children that
    // are not just static text. Otherwise the cost of hoisting out will
    // outweigh the benefits and it's better off to just always render it fresh.
    if (node.static && node.children.length && !(
      node.children.length === 1 &&
      node.children[0].type === 3
    )) {
      node.staticRoot = true;
      return
    } else {
      node.staticRoot = false;
    }
    if (node.children) {
      for (var i = 0, l = node.children.length; i < l; i++) {
        markStaticRoots(node.children[i], isInFor || !!node.for);
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        markStaticRoots(node.ifConditions[i$1].block, isInFor);
      }
    }
  }
}

function isStatic (node) {
  if (node.type === 2) { // expression
    return false
  }
  if (node.type === 3) { // text
    return true
  }
  return !!(node.pre || (
    !node.hasBindings && // no dynamic bindings
    !node.if && !node.for && // not v-if or v-for or v-else
    !isBuiltInTag(node.tag) && // not a built-in
    isPlatformReservedTag(node.tag) && // not a component
    !isDirectChildOfTemplateFor(node) &&
    Object.keys(node).every(isStaticKey)
  ))
}

function isDirectChildOfTemplateFor (node) {
  while (node.parent) {
    node = node.parent;
    if (node.tag !== 'template') {
      return false
    }
    if (node.for) {
      return true
    }
  }
  return false
}

/*  */

var fnExpRE = /^([\w$_]+|\([^)]*?\))\s*=>|^function(?:\s+[\w$]+)?\s*\(/;
var fnInvokeRE = /\([^)]*?\);*$/;
var simplePathRE = /^[A-Za-z_$][\w$]*(?:\.[A-Za-z_$][\w$]*|\['[^']*?']|\["[^"]*?"]|\[\d+]|\[[A-Za-z_$][\w$]*])*$/;

// KeyboardEvent.keyCode aliases
var keyCodes = {
  esc: 27,
  tab: 9,
  enter: 13,
  space: 32,
  up: 38,
  left: 37,
  right: 39,
  down: 40,
  'delete': [8, 46]
};

// KeyboardEvent.key aliases
var keyNames = {
  // #7880: IE11 and Edge use `Esc` for Escape key name.
  esc: ['Esc', 'Escape'],
  tab: 'Tab',
  enter: 'Enter',
  // #9112: IE11 uses `Spacebar` for Space key name.
  space: [' ', 'Spacebar'],
  // #7806: IE11 uses key names without `Arrow` prefix for arrow keys.
  up: ['Up', 'ArrowUp'],
  left: ['Left', 'ArrowLeft'],
  right: ['Right', 'ArrowRight'],
  down: ['Down', 'ArrowDown'],
  // #9112: IE11 uses `Del` for Delete key name.
  'delete': ['Backspace', 'Delete', 'Del']
};

// #4868: modifiers that prevent the execution of the listener
// need to explicitly return null so that we can determine whether to remove
// the listener for .once
var genGuard = function (condition) { return ("if(" + condition + ")return null;"); };

var modifierCode = {
  stop: '$event.stopPropagation();',
  prevent: '$event.preventDefault();',
  self: genGuard("$event.target !== $event.currentTarget"),
  ctrl: genGuard("!$event.ctrlKey"),
  shift: genGuard("!$event.shiftKey"),
  alt: genGuard("!$event.altKey"),
  meta: genGuard("!$event.metaKey"),
  left: genGuard("'button' in $event && $event.button !== 0"),
  middle: genGuard("'button' in $event && $event.button !== 1"),
  right: genGuard("'button' in $event && $event.button !== 2")
};

function genHandlers (
  events,
  isNative
) {
  var prefix = isNative ? 'nativeOn:' : 'on:';
  var staticHandlers = "";
  var dynamicHandlers = "";
  for (var name in events) {
    var handlerCode = genHandler(events[name]);
    if (events[name] && events[name].dynamic) {
      dynamicHandlers += name + "," + handlerCode + ",";
    } else {
      staticHandlers += "\"" + name + "\":" + handlerCode + ",";
    }
  }
  staticHandlers = "{" + (staticHandlers.slice(0, -1)) + "}";
  if (dynamicHandlers) {
    return prefix + "_d(" + staticHandlers + ",[" + (dynamicHandlers.slice(0, -1)) + "])"
  } else {
    return prefix + staticHandlers
  }
}

function genHandler (handler) {
  if (!handler) {
    return 'function(){}'
  }

  if (Array.isArray(handler)) {
    return ("[" + (handler.map(function (handler) { return genHandler(handler); }).join(',')) + "]")
  }

  var isMethodPath = simplePathRE.test(handler.value);
  var isFunctionExpression = fnExpRE.test(handler.value);
  var isFunctionInvocation = simplePathRE.test(handler.value.replace(fnInvokeRE, ''));

  if (!handler.modifiers) {
    if (isMethodPath || isFunctionExpression) {
      return handler.value
    }
    return ("function($event){" + (isFunctionInvocation ? ("return " + (handler.value)) : handler.value) + "}") // inline statement
  } else {
    var code = '';
    var genModifierCode = '';
    var keys = [];
    for (var key in handler.modifiers) {
      if (modifierCode[key]) {
        genModifierCode += modifierCode[key];
        // left/right
        if (keyCodes[key]) {
          keys.push(key);
        }
      } else if (key === 'exact') {
        var modifiers = (handler.modifiers);
        genModifierCode += genGuard(
          ['ctrl', 'shift', 'alt', 'meta']
            .filter(function (keyModifier) { return !modifiers[keyModifier]; })
            .map(function (keyModifier) { return ("$event." + keyModifier + "Key"); })
            .join('||')
        );
      } else {
        keys.push(key);
      }
    }
    if (keys.length) {
      code += genKeyFilter(keys);
    }
    // Make sure modifiers like prevent and stop get executed after key filtering
    if (genModifierCode) {
      code += genModifierCode;
    }
    var handlerCode = isMethodPath
      ? ("return " + (handler.value) + "($event)")
      : isFunctionExpression
        ? ("return (" + (handler.value) + ")($event)")
        : isFunctionInvocation
          ? ("return " + (handler.value))
          : handler.value;
    return ("function($event){" + code + handlerCode + "}")
  }
}

function genKeyFilter (keys) {
  return (
    // make sure the key filters only apply to KeyboardEvents
    // #9441: can't use 'keyCode' in $event because Chrome autofill fires fake
    // key events that do not have keyCode property...
    "if(!$event.type.indexOf('key')&&" +
    (keys.map(genFilterCode).join('&&')) + ")return null;"
  )
}

function genFilterCode (key) {
  var keyVal = parseInt(key, 10);
  if (keyVal) {
    return ("$event.keyCode!==" + keyVal)
  }
  var keyCode = keyCodes[key];
  var keyName = keyNames[key];
  return (
    "_k($event.keyCode," +
    (JSON.stringify(key)) + "," +
    (JSON.stringify(keyCode)) + "," +
    "$event.key," +
    "" + (JSON.stringify(keyName)) +
    ")"
  )
}

/*  */

function on (el, dir) {
  if (false) {
    warn("v-on without argument does not support modifiers.");
  }
  el.wrapListeners = function (code) { return ("_g(" + code + "," + (dir.value) + ")"); };
}

/*  */

function bind$1 (el, dir) {
  el.wrapData = function (code) {
    return ("_b(" + code + ",'" + (el.tag) + "'," + (dir.value) + "," + (dir.modifiers && dir.modifiers.prop ? 'true' : 'false') + (dir.modifiers && dir.modifiers.sync ? ',true' : '') + ")")
  };
}

/*  */

var baseDirectives = {
  on: on,
  bind: bind$1,
  cloak: noop
};

/*  */





var CodegenState = function CodegenState (options) {
  this.options = options;
  this.warn = options.warn || baseWarn;
  this.transforms = pluckModuleFunction(options.modules, 'transformCode');
  this.dataGenFns = pluckModuleFunction(options.modules, 'genData');
  this.directives = extend(extend({}, baseDirectives), options.directives);
  var isReservedTag = options.isReservedTag || no;
  this.maybeComponent = function (el) { return !!el.component || !isReservedTag(el.tag); };
  this.onceId = 0;
  this.staticRenderFns = [];
  this.pre = false;
};



function generate (
  ast,
  options
) {
  var state = new CodegenState(options);
  var code = ast ? genElement(ast, state) : '_c("div")';
  return {
    render: ("with(this){return " + code + "}"),
    staticRenderFns: state.staticRenderFns
  }
}

function genElement (el, state) {
  if (el.parent) {
    el.pre = el.pre || el.parent.pre;
  }

  if (el.staticRoot && !el.staticProcessed) {
    return genStatic(el, state)
  } else if (el.once && !el.onceProcessed) {
    return genOnce(el, state)
  } else if (el.for && !el.forProcessed) {
    return genFor(el, state)
  } else if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.tag === 'template' && !el.slotTarget && !state.pre) {
    return genChildren(el, state) || 'void 0'
  } else if (el.tag === 'slot') {
    return genSlot(el, state)
  } else {
    // component or element
    var code;
    if (el.component) {
      code = genComponent(el.component, el, state);
    } else {
      var data;
      if (!el.plain || (el.pre && state.maybeComponent(el))) {
        data = genData$2(el, state);
      }

      var children = el.inlineTemplate ? null : genChildren(el, state, true);
      code = "_c('" + (el.tag) + "'" + (data ? ("," + data) : '') + (children ? ("," + children) : '') + ")";
    }
    // module transforms
    for (var i = 0; i < state.transforms.length; i++) {
      code = state.transforms[i](el, code);
    }
    return code
  }
}

// hoist static sub-trees out
function genStatic (el, state) {
  el.staticProcessed = true;
  // Some elements (templates) need to behave differently inside of a v-pre
  // node.  All pre nodes are static roots, so we can use this as a location to
  // wrap a state change and reset it upon exiting the pre node.
  var originalPreState = state.pre;
  if (el.pre) {
    state.pre = el.pre;
  }
  state.staticRenderFns.push(("with(this){return " + (genElement(el, state)) + "}"));
  state.pre = originalPreState;
  return ("_m(" + (state.staticRenderFns.length - 1) + (el.staticInFor ? ',true' : '') + ")")
}

// v-once
function genOnce (el, state) {
  el.onceProcessed = true;
  if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.staticInFor) {
    var key = '';
    var parent = el.parent;
    while (parent) {
      if (parent.for) {
        key = parent.key;
        break
      }
      parent = parent.parent;
    }
    if (!key) {
      "production" !== 'production' && state.warn(
        "v-once can only be used inside v-for that is keyed. ",
        el.rawAttrsMap['v-once']
      );
      return genElement(el, state)
    }
    return ("_o(" + (genElement(el, state)) + "," + (state.onceId++) + "," + key + ")")
  } else {
    return genStatic(el, state)
  }
}

function genIf (
  el,
  state,
  altGen,
  altEmpty
) {
  el.ifProcessed = true; // avoid recursion
  return genIfConditions(el.ifConditions.slice(), state, altGen, altEmpty)
}

function genIfConditions (
  conditions,
  state,
  altGen,
  altEmpty
) {
  if (!conditions.length) {
    return altEmpty || '_e()'
  }

  var condition = conditions.shift();
  if (condition.exp) {
    return ("(" + (condition.exp) + ")?" + (genTernaryExp(condition.block)) + ":" + (genIfConditions(conditions, state, altGen, altEmpty)))
  } else {
    return ("" + (genTernaryExp(condition.block)))
  }

  // v-if with v-once should generate code like (a)?_m(0):_m(1)
  function genTernaryExp (el) {
    return altGen
      ? altGen(el, state)
      : el.once
        ? genOnce(el, state)
        : genElement(el, state)
  }
}

function genFor (
  el,
  state,
  altGen,
  altHelper
) {
  var exp = el.for;
  var alias = el.alias;
  var iterator1 = el.iterator1 ? ("," + (el.iterator1)) : '';
  var iterator2 = el.iterator2 ? ("," + (el.iterator2)) : '';

  if (false
  ) {
    state.warn(
      "<" + (el.tag) + " v-for=\"" + alias + " in " + exp + "\">: component lists rendered with " +
      "v-for should have explicit keys. " +
      "See https://vuejs.org/guide/list.html#key for more info.",
      el.rawAttrsMap['v-for'],
      true /* tip */
    );
  }

  el.forProcessed = true; // avoid recursion
  return (altHelper || '_l') + "((" + exp + ")," +
    "function(" + alias + iterator1 + iterator2 + "){" +
      "return " + ((altGen || genElement)(el, state)) +
    '})'
}

function genData$2 (el, state) {
  var data = '{';

  // directives first.
  // directives may mutate the el's other properties before they are generated.
  var dirs = genDirectives(el, state);
  if (dirs) { data += dirs + ','; }

  // key
  if (el.key) {
    data += "key:" + (el.key) + ",";
  }
  // ref
  if (el.ref) {
    data += "ref:" + (el.ref) + ",";
  }
  if (el.refInFor) {
    data += "refInFor:true,";
  }
  // pre
  if (el.pre) {
    data += "pre:true,";
  }
  // record original tag name for components using "is" attribute
  if (el.component) {
    data += "tag:\"" + (el.tag) + "\",";
  }
  // module data generation functions
  for (var i = 0; i < state.dataGenFns.length; i++) {
    data += state.dataGenFns[i](el);
  }
  // attributes
  if (el.attrs) {
    data += "attrs:" + (genProps(el.attrs)) + ",";
  }
  // DOM props
  if (el.props) {
    data += "domProps:" + (genProps(el.props)) + ",";
  }
  // event handlers
  if (el.events) {
    data += (genHandlers(el.events, false)) + ",";
  }
  if (el.nativeEvents) {
    data += (genHandlers(el.nativeEvents, true)) + ",";
  }
  // slot target
  // only for non-scoped slots
  if (el.slotTarget && !el.slotScope) {
    data += "slot:" + (el.slotTarget) + ",";
  }
  // scoped slots
  if (el.scopedSlots) {
    data += (genScopedSlots(el, el.scopedSlots, state)) + ",";
  }
  // component v-model
  if (el.model) {
    data += "model:{value:" + (el.model.value) + ",callback:" + (el.model.callback) + ",expression:" + (el.model.expression) + "},";
  }
  // inline-template
  if (el.inlineTemplate) {
    var inlineTemplate = genInlineTemplate(el, state);
    if (inlineTemplate) {
      data += inlineTemplate + ",";
    }
  }
  data = data.replace(/,$/, '') + '}';
  // v-bind dynamic argument wrap
  // v-bind with dynamic arguments must be applied using the same v-bind object
  // merge helper so that class/style/mustUseProp attrs are handled correctly.
  if (el.dynamicAttrs) {
    data = "_b(" + data + ",\"" + (el.tag) + "\"," + (genProps(el.dynamicAttrs)) + ")";
  }
  // v-bind data wrap
  if (el.wrapData) {
    data = el.wrapData(data);
  }
  // v-on data wrap
  if (el.wrapListeners) {
    data = el.wrapListeners(data);
  }
  return data
}

function genDirectives (el, state) {
  var dirs = el.directives;
  if (!dirs) { return }
  var res = 'directives:[';
  var hasRuntime = false;
  var i, l, dir, needRuntime;
  for (i = 0, l = dirs.length; i < l; i++) {
    dir = dirs[i];
    needRuntime = true;
    var gen = state.directives[dir.name];
    if (gen) {
      // compile-time directive that manipulates AST.
      // returns true if it also needs a runtime counterpart.
      needRuntime = !!gen(el, dir, state.warn);
    }
    if (needRuntime) {
      hasRuntime = true;
      res += "{name:\"" + (dir.name) + "\",rawName:\"" + (dir.rawName) + "\"" + (dir.value ? (",value:(" + (dir.value) + "),expression:" + (JSON.stringify(dir.value))) : '') + (dir.arg ? (",arg:" + (dir.isDynamicArg ? dir.arg : ("\"" + (dir.arg) + "\""))) : '') + (dir.modifiers ? (",modifiers:" + (JSON.stringify(dir.modifiers))) : '') + "},";
    }
  }
  if (hasRuntime) {
    return res.slice(0, -1) + ']'
  }
}

function genInlineTemplate (el, state) {
  var ast = el.children[0];
  if (false) {
    state.warn(
      'Inline-template components must have exactly one child element.',
      { start: el.start }
    );
  }
  if (ast && ast.type === 1) {
    var inlineRenderFns = generate(ast, state.options);
    return ("inlineTemplate:{render:function(){" + (inlineRenderFns.render) + "},staticRenderFns:[" + (inlineRenderFns.staticRenderFns.map(function (code) { return ("function(){" + code + "}"); }).join(',')) + "]}")
  }
}

function genScopedSlots (
  el,
  slots,
  state
) {
  // by default scoped slots are considered "stable", this allows child
  // components with only scoped slots to skip forced updates from parent.
  // but in some cases we have to bail-out of this optimization
  // for example if the slot contains dynamic names, has v-if or v-for on them...
  var needsForceUpdate = el.for || Object.keys(slots).some(function (key) {
    var slot = slots[key];
    return (
      slot.slotTargetDynamic ||
      slot.if ||
      slot.for ||
      containsSlotChild(slot) // is passing down slot from parent which may be dynamic
    )
  });

  // #9534: if a component with scoped slots is inside a conditional branch,
  // it's possible for the same component to be reused but with different
  // compiled slot content. To avoid that, we generate a unique key based on
  // the generated code of all the slot contents.
  var needsKey = !!el.if;

  // OR when it is inside another scoped slot or v-for (the reactivity may be
  // disconnected due to the intermediate scope variable)
  // #9438, #9506
  // TODO: this can be further optimized by properly analyzing in-scope bindings
  // and skip force updating ones that do not actually use scope variables.
  if (!needsForceUpdate) {
    var parent = el.parent;
    while (parent) {
      if (
        (parent.slotScope && parent.slotScope !== emptySlotScopeToken) ||
        parent.for
      ) {
        needsForceUpdate = true;
        break
      }
      if (parent.if) {
        needsKey = true;
      }
      parent = parent.parent;
    }
  }

  var generatedSlots = Object.keys(slots)
    .map(function (key) { return genScopedSlot(slots[key], state); })
    .join(',');

  return ("scopedSlots:_u([" + generatedSlots + "]" + (needsForceUpdate ? ",null,true" : "") + (!needsForceUpdate && needsKey ? (",null,false," + (hash(generatedSlots))) : "") + ")")
}

function hash(str) {
  var hash = 5381;
  var i = str.length;
  while(i) {
    hash = (hash * 33) ^ str.charCodeAt(--i);
  }
  return hash >>> 0
}

function containsSlotChild (el) {
  if (el.type === 1) {
    if (el.tag === 'slot') {
      return true
    }
    return el.children.some(containsSlotChild)
  }
  return false
}

function genScopedSlot (
  el,
  state
) {
  var isLegacySyntax = el.attrsMap['slot-scope'];
  if (el.if && !el.ifProcessed && !isLegacySyntax) {
    return genIf(el, state, genScopedSlot, "null")
  }
  if (el.for && !el.forProcessed) {
    return genFor(el, state, genScopedSlot)
  }
  var slotScope = el.slotScope === emptySlotScopeToken
    ? ""
    : String(el.slotScope);
  var fn = "function(" + slotScope + "){" +
    "return " + (el.tag === 'template'
      ? el.if && isLegacySyntax
        ? ("(" + (el.if) + ")?" + (genChildren(el, state) || 'undefined') + ":undefined")
        : genChildren(el, state) || 'undefined'
      : genElement(el, state)) + "}";
  // reverse proxy v-slot without scope on this.$slots
  var reverseProxy = slotScope ? "" : ",proxy:true";
  return ("{key:" + (el.slotTarget || "\"default\"") + ",fn:" + fn + reverseProxy + "}")
}

function genChildren (
  el,
  state,
  checkSkip,
  altGenElement,
  altGenNode
) {
  var children = el.children;
  if (children.length) {
    var el$1 = children[0];
    // optimize single v-for
    if (children.length === 1 &&
      el$1.for &&
      el$1.tag !== 'template' &&
      el$1.tag !== 'slot'
    ) {
      var normalizationType = checkSkip
        ? state.maybeComponent(el$1) ? ",1" : ",0"
        : "";
      return ("" + ((altGenElement || genElement)(el$1, state)) + normalizationType)
    }
    var normalizationType$1 = checkSkip
      ? getNormalizationType(children, state.maybeComponent)
      : 0;
    var gen = altGenNode || genNode;
    return ("[" + (children.map(function (c) { return gen(c, state); }).join(',')) + "]" + (normalizationType$1 ? ("," + normalizationType$1) : ''))
  }
}

// determine the normalization needed for the children array.
// 0: no normalization needed
// 1: simple normalization needed (possible 1-level deep nested array)
// 2: full normalization needed
function getNormalizationType (
  children,
  maybeComponent
) {
  var res = 0;
  for (var i = 0; i < children.length; i++) {
    var el = children[i];
    if (el.type !== 1) {
      continue
    }
    if (needsNormalization(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return needsNormalization(c.block); }))) {
      res = 2;
      break
    }
    if (maybeComponent(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return maybeComponent(c.block); }))) {
      res = 1;
    }
  }
  return res
}

function needsNormalization (el) {
  return el.for !== undefined || el.tag === 'template' || el.tag === 'slot'
}

function genNode (node, state) {
  if (node.type === 1) {
    return genElement(node, state)
  } else if (node.type === 3 && node.isComment) {
    return genComment(node)
  } else {
    return genText(node)
  }
}

function genText (text) {
  return ("_v(" + (text.type === 2
    ? text.expression // no need for () because already wrapped in _s()
    : transformSpecialNewlines(JSON.stringify(text.text))) + ")")
}

function genComment (comment) {
  return ("_e(" + (JSON.stringify(comment.text)) + ")")
}

function genSlot (el, state) {
  var slotName = el.slotName || '"default"';
  var children = genChildren(el, state);
  var res = "_t(" + slotName + (children ? ("," + children) : '');
  var attrs = el.attrs || el.dynamicAttrs
    ? genProps((el.attrs || []).concat(el.dynamicAttrs || []).map(function (attr) { return ({
        // slot props are camelized
        name: camelize(attr.name),
        value: attr.value,
        dynamic: attr.dynamic
      }); }))
    : null;
  var bind$$1 = el.attrsMap['v-bind'];
  if ((attrs || bind$$1) && !children) {
    res += ",null";
  }
  if (attrs) {
    res += "," + attrs;
  }
  if (bind$$1) {
    res += (attrs ? '' : ',null') + "," + bind$$1;
  }
  return res + ')'
}

// componentName is el.component, take it as argument to shun flow's pessimistic refinement
function genComponent (
  componentName,
  el,
  state
) {
  var children = el.inlineTemplate ? null : genChildren(el, state, true);
  return ("_c(" + componentName + "," + (genData$2(el, state)) + (children ? ("," + children) : '') + ")")
}

function genProps (props) {
  var staticProps = "";
  var dynamicProps = "";
  for (var i = 0; i < props.length; i++) {
    var prop = props[i];
    var value = transformSpecialNewlines(prop.value);
    if (prop.dynamic) {
      dynamicProps += (prop.name) + "," + value + ",";
    } else {
      staticProps += "\"" + (prop.name) + "\":" + value + ",";
    }
  }
  staticProps = "{" + (staticProps.slice(0, -1)) + "}";
  if (dynamicProps) {
    return ("_d(" + staticProps + ",[" + (dynamicProps.slice(0, -1)) + "])")
  } else {
    return staticProps
  }
}

// #3895, #4268
function transformSpecialNewlines (text) {
  return text
    .replace(/\u2028/g, '\\u2028')
    .replace(/\u2029/g, '\\u2029')
}

/*  */



// these keywords should not appear inside expressions, but operators like
// typeof, instanceof and in are allowed
var prohibitedKeywordRE = new RegExp('\\b' + (
  'do,if,for,let,new,try,var,case,else,with,await,break,catch,class,const,' +
  'super,throw,while,yield,delete,export,import,return,switch,default,' +
  'extends,finally,continue,debugger,function,arguments'
).split(',').join('\\b|\\b') + '\\b');

// these unary operators should not be used as property/method names
var unaryOperatorsRE = new RegExp('\\b' + (
  'delete,typeof,void'
).split(',').join('\\s*\\([^\\)]*\\)|\\b') + '\\s*\\([^\\)]*\\)');

// strip strings in expressions
var stripStringRE = /'(?:[^'\\]|\\.)*'|"(?:[^"\\]|\\.)*"|`(?:[^`\\]|\\.)*\$\{|\}(?:[^`\\]|\\.)*`|`(?:[^`\\]|\\.)*`/g;

// detect problematic expressions in a template
function detectErrors (ast, warn) {
  if (ast) {
    checkNode(ast, warn);
  }
}

function checkNode (node, warn) {
  if (node.type === 1) {
    for (var name in node.attrsMap) {
      if (dirRE.test(name)) {
        var value = node.attrsMap[name];
        if (value) {
          var range = node.rawAttrsMap[name];
          if (name === 'v-for') {
            checkFor(node, ("v-for=\"" + value + "\""), warn, range);
          } else if (name === 'v-slot' || name[0] === '#') {
            checkFunctionParameterExpression(value, (name + "=\"" + value + "\""), warn, range);
          } else if (onRE.test(name)) {
            checkEvent(value, (name + "=\"" + value + "\""), warn, range);
          } else {
            checkExpression(value, (name + "=\"" + value + "\""), warn, range);
          }
        }
      }
    }
    if (node.children) {
      for (var i = 0; i < node.children.length; i++) {
        checkNode(node.children[i], warn);
      }
    }
  } else if (node.type === 2) {
    checkExpression(node.expression, node.text, warn, node);
  }
}

function checkEvent (exp, text, warn, range) {
  var stripped = exp.replace(stripStringRE, '');
  var keywordMatch = stripped.match(unaryOperatorsRE);
  if (keywordMatch && stripped.charAt(keywordMatch.index - 1) !== '$') {
    warn(
      "avoid using JavaScript unary operator as property name: " +
      "\"" + (keywordMatch[0]) + "\" in expression " + (text.trim()),
      range
    );
  }
  checkExpression(exp, text, warn, range);
}

function checkFor (node, text, warn, range) {
  checkExpression(node.for || '', text, warn, range);
  checkIdentifier(node.alias, 'v-for alias', text, warn, range);
  checkIdentifier(node.iterator1, 'v-for iterator', text, warn, range);
  checkIdentifier(node.iterator2, 'v-for iterator', text, warn, range);
}

function checkIdentifier (
  ident,
  type,
  text,
  warn,
  range
) {
  if (typeof ident === 'string') {
    try {
      new Function(("var " + ident + "=_"));
    } catch (e) {
      warn(("invalid " + type + " \"" + ident + "\" in expression: " + (text.trim())), range);
    }
  }
}

function checkExpression (exp, text, warn, range) {
  try {
    new Function(("return " + exp));
  } catch (e) {
    var keywordMatch = exp.replace(stripStringRE, '').match(prohibitedKeywordRE);
    if (keywordMatch) {
      warn(
        "avoid using JavaScript keyword as property name: " +
        "\"" + (keywordMatch[0]) + "\"\n  Raw expression: " + (text.trim()),
        range
      );
    } else {
      warn(
        "invalid expression: " + (e.message) + " in\n\n" +
        "    " + exp + "\n\n" +
        "  Raw expression: " + (text.trim()) + "\n",
        range
      );
    }
  }
}

function checkFunctionParameterExpression (exp, text, warn, range) {
  try {
    new Function(exp, '');
  } catch (e) {
    warn(
      "invalid function parameter expression: " + (e.message) + " in\n\n" +
      "    " + exp + "\n\n" +
      "  Raw expression: " + (text.trim()) + "\n",
      range
    );
  }
}

/*  */

var range = 2;

function generateCodeFrame (
  source,
  start,
  end
) {
  if ( start === void 0 ) start = 0;
  if ( end === void 0 ) end = source.length;

  var lines = source.split(/\r?\n/);
  var count = 0;
  var res = [];
  for (var i = 0; i < lines.length; i++) {
    count += lines[i].length + 1;
    if (count >= start) {
      for (var j = i - range; j <= i + range || end > count; j++) {
        if (j < 0 || j >= lines.length) { continue }
        res.push(("" + (j + 1) + (repeat$1(" ", 3 - String(j + 1).length)) + "|  " + (lines[j])));
        var lineLength = lines[j].length;
        if (j === i) {
          // push underline
          var pad = start - (count - lineLength) + 1;
          var length = end > count ? lineLength - pad : end - start;
          res.push("   |  " + repeat$1(" ", pad) + repeat$1("^", length));
        } else if (j > i) {
          if (end > count) {
            var length$1 = Math.min(end - count, lineLength);
            res.push("   |  " + repeat$1("^", length$1));
          }
          count += lineLength + 1;
        }
      }
      break
    }
  }
  return res.join('\n')
}

function repeat$1 (str, n) {
  var result = '';
  if (n > 0) {
    while (true) { // eslint-disable-line
      if (n & 1) { result += str; }
      n >>>= 1;
      if (n <= 0) { break }
      str += str;
    }
  }
  return result
}

/*  */



function createFunction (code, errors) {
  try {
    return new Function(code)
  } catch (err) {
    errors.push({ err: err, code: code });
    return noop
  }
}

function createCompileToFunctionFn (compile) {
  var cache = Object.create(null);

  return function compileToFunctions (
    template,
    options,
    vm
  ) {
    options = extend({}, options);
    var warn$$1 = options.warn || warn;
    delete options.warn;

    /* istanbul ignore if */
    if (false) {
      // detect possible CSP restriction
      try {
        new Function('return 1');
      } catch (e) {
        if (e.toString().match(/unsafe-eval|CSP/)) {
          warn$$1(
            'It seems you are using the standalone build of Vue.js in an ' +
            'environment with Content Security Policy that prohibits unsafe-eval. ' +
            'The template compiler cannot work in this environment. Consider ' +
            'relaxing the policy to allow unsafe-eval or pre-compiling your ' +
            'templates into render functions.'
          );
        }
      }
    }

    // check cache
    var key = options.delimiters
      ? String(options.delimiters) + template
      : template;
    if (cache[key]) {
      return cache[key]
    }

    // compile
    var compiled = compile(template, options);

    // check compilation errors/tips
    if (false) {
      if (compiled.errors && compiled.errors.length) {
        if (options.outputSourceRange) {
          compiled.errors.forEach(function (e) {
            warn$$1(
              "Error compiling template:\n\n" + (e.msg) + "\n\n" +
              generateCodeFrame(template, e.start, e.end),
              vm
            );
          });
        } else {
          warn$$1(
            "Error compiling template:\n\n" + template + "\n\n" +
            compiled.errors.map(function (e) { return ("- " + e); }).join('\n') + '\n',
            vm
          );
        }
      }
      if (compiled.tips && compiled.tips.length) {
        if (options.outputSourceRange) {
          compiled.tips.forEach(function (e) { return tip(e.msg, vm); });
        } else {
          compiled.tips.forEach(function (msg) { return tip(msg, vm); });
        }
      }
    }

    // turn code into functions
    var res = {};
    var fnGenErrors = [];
    res.render = createFunction(compiled.render, fnGenErrors);
    res.staticRenderFns = compiled.staticRenderFns.map(function (code) {
      return createFunction(code, fnGenErrors)
    });

    // check function generation errors.
    // this should only happen if there is a bug in the compiler itself.
    // mostly for codegen development use
    /* istanbul ignore if */
    if (false) {
      if ((!compiled.errors || !compiled.errors.length) && fnGenErrors.length) {
        warn$$1(
          "Failed to generate render function:\n\n" +
          fnGenErrors.map(function (ref) {
            var err = ref.err;
            var code = ref.code;

            return ((err.toString()) + " in\n\n" + code + "\n");
        }).join('\n'),
          vm
        );
      }
    }

    return (cache[key] = res)
  }
}

/*  */

function createCompilerCreator (baseCompile) {
  return function createCompiler (baseOptions) {
    function compile (
      template,
      options
    ) {
      var finalOptions = Object.create(baseOptions);
      var errors = [];
      var tips = [];

      var warn = function (msg, range, tip) {
        (tip ? tips : errors).push(msg);
      };

      if (options) {
        if (false) {
          // $flow-disable-line
          var leadingSpaceLength = template.match(/^\s*/)[0].length;

          warn = function (msg, range, tip) {
            var data = { msg: msg };
            if (range) {
              if (range.start != null) {
                data.start = range.start + leadingSpaceLength;
              }
              if (range.end != null) {
                data.end = range.end + leadingSpaceLength;
              }
            }
            (tip ? tips : errors).push(data);
          };
        }
        // merge custom modules
        if (options.modules) {
          finalOptions.modules =
            (baseOptions.modules || []).concat(options.modules);
        }
        // merge custom directives
        if (options.directives) {
          finalOptions.directives = extend(
            Object.create(baseOptions.directives || null),
            options.directives
          );
        }
        // copy other options
        for (var key in options) {
          if (key !== 'modules' && key !== 'directives') {
            finalOptions[key] = options[key];
          }
        }
      }

      finalOptions.warn = warn;

      var compiled = baseCompile(template.trim(), finalOptions);
      if (false) {
        detectErrors(compiled.ast, warn);
      }
      compiled.errors = errors;
      compiled.tips = tips;
      return compiled
    }

    return {
      compile: compile,
      compileToFunctions: createCompileToFunctionFn(compile)
    }
  }
}

/*  */

// `createCompilerCreator` allows creating compilers that use alternative
// parser/optimizer/codegen, e.g the SSR optimizing compiler.
// Here we just export a default compiler using the default parts.
var createCompiler = createCompilerCreator(function baseCompile (
  template,
  options
) {
  var ast = parse(template.trim(), options);
  if (options.optimize !== false) {
    optimize(ast, options);
  }
  var code = generate(ast, options);
  return {
    ast: ast,
    render: code.render,
    staticRenderFns: code.staticRenderFns
  }
});

/*  */

var ref$1 = createCompiler(baseOptions);
var compile = ref$1.compile;
var compileToFunctions = ref$1.compileToFunctions;

/*  */

// check whether current browser encodes a char inside attribute values
var div;
function getShouldDecode (href) {
  div = div || document.createElement('div');
  div.innerHTML = href ? "<a href=\"\n\"/>" : "<div a=\"\n\"/>";
  return div.innerHTML.indexOf('&#10;') > 0
}

// #3663: IE encodes newlines inside attribute values while other browsers don't
var shouldDecodeNewlines = inBrowser ? getShouldDecode(false) : false;
// #6828: chrome encodes content in a[href]
var shouldDecodeNewlinesForHref = inBrowser ? getShouldDecode(true) : false;

/*  */

var idToTemplate = cached(function (id) {
  var el = query(id);
  return el && el.innerHTML
});

var mount = Vue.prototype.$mount;
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && query(el);

  /* istanbul ignore if */
  if (el === document.body || el === document.documentElement) {
    "production" !== 'production' && warn(
      "Do not mount Vue to <html> or <body> - mount to normal elements instead."
    );
    return this
  }

  var options = this.$options;
  // resolve template/el and convert to render function
  if (!options.render) {
    var template = options.template;
    if (template) {
      if (typeof template === 'string') {
        if (template.charAt(0) === '#') {
          template = idToTemplate(template);
          /* istanbul ignore if */
          if (false) {
            warn(
              ("Template element not found or is empty: " + (options.template)),
              this
            );
          }
        }
      } else if (template.nodeType) {
        template = template.innerHTML;
      } else {
        if (false) {
          warn('invalid template option:' + template, this);
        }
        return this
      }
    } else if (el) {
      template = getOuterHTML(el);
    }
    if (template) {
      /* istanbul ignore if */
      if (false) {
        mark('compile');
      }

      var ref = compileToFunctions(template, {
        outputSourceRange: "production" !== 'production',
        shouldDecodeNewlines: shouldDecodeNewlines,
        shouldDecodeNewlinesForHref: shouldDecodeNewlinesForHref,
        delimiters: options.delimiters,
        comments: options.comments
      }, this);
      var render = ref.render;
      var staticRenderFns = ref.staticRenderFns;
      options.render = render;
      options.staticRenderFns = staticRenderFns;

      /* istanbul ignore if */
      if (false) {
        mark('compile end');
        measure(("vue " + (this._name) + " compile"), 'compile', 'compile end');
      }
    }
  }
  return mount.call(this, el, hydrating)
};

/**
 * Get outerHTML of elements, taking care
 * of SVG elements in IE as well.
 */
function getOuterHTML (el) {
  if (el.outerHTML) {
    return el.outerHTML
  } else {
    var container = document.createElement('div');
    container.appendChild(el.cloneNode(true));
    return container.innerHTML
  }
}

Vue.compile = compileToFunctions;

/* harmony default export */ __webpack_exports__["a"] = (Vue);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4), __webpack_require__(18).setImmediate))

/***/ }),
/* 4 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]());

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(25),
  /* template */
  __webpack_require__(28),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(26),
  /* template */
  __webpack_require__(27),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

function encode(val) {
  return encodeURIComponent(val).
    replace(/%40/gi, '@').
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    var hashmarkIndex = url.indexOf('#');
    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }

    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var utils = __webpack_require__(1);
var normalizeHeaderName = __webpack_require__(35);

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(12);
  } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
    // For node use HTTP adapter
    adapter = __webpack_require__(12);
  }
  return adapter;
}

var defaults = {
  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Accept');
    normalizeHeaderName(headers, 'Content-Type');
    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) { /* Ignore */ }
    }
    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);
var settle = __webpack_require__(36);
var buildURL = __webpack_require__(9);
var buildFullPath = __webpack_require__(38);
var parseHeaders = __webpack_require__(41);
var isURLSameOrigin = __webpack_require__(42);
var createError = __webpack_require__(13);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password || '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    var fullPath = buildFullPath(config.baseURL, config.url);
    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request.onreadystatechange = function handleLoad() {
      if (!request || request.readyState !== 4) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(createError('Request aborted', config, 'ECONNABORTED', request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      var timeoutErrorMessage = 'timeout of ' + config.timeout + 'ms exceeded';
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(createError(timeoutErrorMessage, config, 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      var cookies = __webpack_require__(43);

      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ?
        cookies.read(config.xsrfCookieName) :
        undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (!utils.isUndefined(config.withCredentials)) {
      request.withCredentials = !!config.withCredentials;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
        if (config.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (requestData === undefined) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__(37);

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */
module.exports = function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  var config = {};

  var valueFromConfig2Keys = ['url', 'method', 'params', 'data'];
  var mergeDeepPropertiesKeys = ['headers', 'auth', 'proxy'];
  var defaultToConfig2Keys = [
    'baseURL', 'url', 'transformRequest', 'transformResponse', 'paramsSerializer',
    'timeout', 'withCredentials', 'adapter', 'responseType', 'xsrfCookieName',
    'xsrfHeaderName', 'onUploadProgress', 'onDownloadProgress',
    'maxContentLength', 'validateStatus', 'maxRedirects', 'httpAgent',
    'httpsAgent', 'cancelToken', 'socketPath'
  ];

  utils.forEach(valueFromConfig2Keys, function valueFromConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    }
  });

  utils.forEach(mergeDeepPropertiesKeys, function mergeDeepProperties(prop) {
    if (utils.isObject(config2[prop])) {
      config[prop] = utils.deepMerge(config1[prop], config2[prop]);
    } else if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (utils.isObject(config1[prop])) {
      config[prop] = utils.deepMerge(config1[prop]);
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  utils.forEach(defaultToConfig2Keys, function defaultToConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  var axiosKeys = valueFromConfig2Keys
    .concat(mergeDeepPropertiesKeys)
    .concat(defaultToConfig2Keys);

  var otherKeys = Object
    .keys(config2)
    .filter(function filterAxiosKeys(key) {
      return axiosKeys.indexOf(key) === -1;
    });

  utils.forEach(otherKeys, function otherKeysDefaultToConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  return config;
};


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_shortkey__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_shortkey___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_shortkey__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_touch__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_touch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_touch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_resource__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_analytics__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_analytics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_analytics__);
/*jshint esversion: 6 */
/* The Vue build version to load with the `import` command
(runtime-only or standalone) has been set in webpack.base.conf with an alias. */

var path = __webpack_require__(17);










__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vuetify___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vue_shortkey___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_6_vue_resource__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_5_vue_touch___default.a.config.swipe = {
  direction: 'horizontal',
  threshold: 10,
  velocity: 0.3,
  pointers: 1
};

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_vue_touch___default.a, { name: 'v-touch' });

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_7_vue_analytics___default.a, {
  id: ['UA-137347938-1', 'UA-64435914-1'],
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  autoTracking: {
    pageviewTemplate: function pageviewTemplate(route) {
      return {
        page: path.join(window.location.pathname, route.path),
        title: document.title,
        location: window.location.href
      };
    }
  },
  debug: {
    enabled: false
  }
});

var app = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  data: {},
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_1__App___default.a);
  }
}).$mount('#app');

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// .dirname, .basename, and .extname methods are extracted from Node.js v8.11.1,
// backported and transplited with Babel, with backwards-compat fixes

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// resolves . and .. elements in a path array with directory names there
// must be no slashes, empty elements, or device names (c:\) in the array
// (so also no leading and trailing slashes - it does not distinguish
// relative and absolute paths)
function normalizeArray(parts, allowAboveRoot) {
  // if the path tries to go above the root, `up` ends up > 0
  var up = 0;
  for (var i = parts.length - 1; i >= 0; i--) {
    var last = parts[i];
    if (last === '.') {
      parts.splice(i, 1);
    } else if (last === '..') {
      parts.splice(i, 1);
      up++;
    } else if (up) {
      parts.splice(i, 1);
      up--;
    }
  }

  // if the path is allowed to go above the root, restore leading ..s
  if (allowAboveRoot) {
    for (; up--; up) {
      parts.unshift('..');
    }
  }

  return parts;
}

// path.resolve([from ...], to)
// posix version
exports.resolve = function() {
  var resolvedPath = '',
      resolvedAbsolute = false;

  for (var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--) {
    var path = (i >= 0) ? arguments[i] : process.cwd();

    // Skip empty and invalid entries
    if (typeof path !== 'string') {
      throw new TypeError('Arguments to path.resolve must be strings');
    } else if (!path) {
      continue;
    }

    resolvedPath = path + '/' + resolvedPath;
    resolvedAbsolute = path.charAt(0) === '/';
  }

  // At this point the path should be resolved to a full absolute path, but
  // handle relative paths to be safe (might happen when process.cwd() fails)

  // Normalize the path
  resolvedPath = normalizeArray(filter(resolvedPath.split('/'), function(p) {
    return !!p;
  }), !resolvedAbsolute).join('/');

  return ((resolvedAbsolute ? '/' : '') + resolvedPath) || '.';
};

// path.normalize(path)
// posix version
exports.normalize = function(path) {
  var isAbsolute = exports.isAbsolute(path),
      trailingSlash = substr(path, -1) === '/';

  // Normalize the path
  path = normalizeArray(filter(path.split('/'), function(p) {
    return !!p;
  }), !isAbsolute).join('/');

  if (!path && !isAbsolute) {
    path = '.';
  }
  if (path && trailingSlash) {
    path += '/';
  }

  return (isAbsolute ? '/' : '') + path;
};

// posix version
exports.isAbsolute = function(path) {
  return path.charAt(0) === '/';
};

// posix version
exports.join = function() {
  var paths = Array.prototype.slice.call(arguments, 0);
  return exports.normalize(filter(paths, function(p, index) {
    if (typeof p !== 'string') {
      throw new TypeError('Arguments to path.join must be strings');
    }
    return p;
  }).join('/'));
};


// path.relative(from, to)
// posix version
exports.relative = function(from, to) {
  from = exports.resolve(from).substr(1);
  to = exports.resolve(to).substr(1);

  function trim(arr) {
    var start = 0;
    for (; start < arr.length; start++) {
      if (arr[start] !== '') break;
    }

    var end = arr.length - 1;
    for (; end >= 0; end--) {
      if (arr[end] !== '') break;
    }

    if (start > end) return [];
    return arr.slice(start, end - start + 1);
  }

  var fromParts = trim(from.split('/'));
  var toParts = trim(to.split('/'));

  var length = Math.min(fromParts.length, toParts.length);
  var samePartsLength = length;
  for (var i = 0; i < length; i++) {
    if (fromParts[i] !== toParts[i]) {
      samePartsLength = i;
      break;
    }
  }

  var outputParts = [];
  for (var i = samePartsLength; i < fromParts.length; i++) {
    outputParts.push('..');
  }

  outputParts = outputParts.concat(toParts.slice(samePartsLength));

  return outputParts.join('/');
};

exports.sep = '/';
exports.delimiter = ':';

exports.dirname = function (path) {
  if (typeof path !== 'string') path = path + '';
  if (path.length === 0) return '.';
  var code = path.charCodeAt(0);
  var hasRoot = code === 47 /*/*/;
  var end = -1;
  var matchedSlash = true;
  for (var i = path.length - 1; i >= 1; --i) {
    code = path.charCodeAt(i);
    if (code === 47 /*/*/) {
        if (!matchedSlash) {
          end = i;
          break;
        }
      } else {
      // We saw the first non-path separator
      matchedSlash = false;
    }
  }

  if (end === -1) return hasRoot ? '/' : '.';
  if (hasRoot && end === 1) {
    // return '//';
    // Backwards-compat fix:
    return '/';
  }
  return path.slice(0, end);
};

function basename(path) {
  if (typeof path !== 'string') path = path + '';

  var start = 0;
  var end = -1;
  var matchedSlash = true;
  var i;

  for (i = path.length - 1; i >= 0; --i) {
    if (path.charCodeAt(i) === 47 /*/*/) {
        // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now
        if (!matchedSlash) {
          start = i + 1;
          break;
        }
      } else if (end === -1) {
      // We saw the first non-path separator, mark this as the end of our
      // path component
      matchedSlash = false;
      end = i + 1;
    }
  }

  if (end === -1) return '';
  return path.slice(start, end);
}

// Uses a mixed approach for backwards-compatibility, as ext behavior changed
// in new Node.js versions, so only basename() above is backported here
exports.basename = function (path, ext) {
  var f = basename(path);
  if (ext && f.substr(-1 * ext.length) === ext) {
    f = f.substr(0, f.length - ext.length);
  }
  return f;
};

exports.extname = function (path) {
  if (typeof path !== 'string') path = path + '';
  var startDot = -1;
  var startPart = 0;
  var end = -1;
  var matchedSlash = true;
  // Track the state of characters (if any) we see before our first dot and
  // after any path separator we find
  var preDotState = 0;
  for (var i = path.length - 1; i >= 0; --i) {
    var code = path.charCodeAt(i);
    if (code === 47 /*/*/) {
        // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now
        if (!matchedSlash) {
          startPart = i + 1;
          break;
        }
        continue;
      }
    if (end === -1) {
      // We saw the first non-path separator, mark this as the end of our
      // extension
      matchedSlash = false;
      end = i + 1;
    }
    if (code === 46 /*.*/) {
        // If this is our first dot, mark it as the start of our extension
        if (startDot === -1)
          startDot = i;
        else if (preDotState !== 1)
          preDotState = 1;
    } else if (startDot !== -1) {
      // We saw a non-dot and non-path separator before our dot, so we should
      // have a good chance at having a non-empty extension
      preDotState = -1;
    }
  }

  if (startDot === -1 || end === -1 ||
      // We saw a non-dot character immediately before the dot
      preDotState === 0 ||
      // The (right-most) trimmed path component is exactly '..'
      preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) {
    return '';
  }
  return path.slice(startDot, end);
};

function filter (xs, f) {
    if (xs.filter) return xs.filter(f);
    var res = [];
    for (var i = 0; i < xs.length; i++) {
        if (f(xs[i], i, xs)) res.push(xs[i]);
    }
    return res;
}

// String.prototype.substr - negative index don't work in IE8
var substr = 'ab'.substr(-1) === 'b'
    ? function (str, start, len) { return str.substr(start, len) }
    : function (str, start, len) {
        if (start < 0) start = str.length + start;
        return str.substr(start, len);
    }
;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(19);
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4), __webpack_require__(2)))

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(21)
  __webpack_require__(22)
  __webpack_require__(23)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(24),
  /* template */
  __webpack_require__(46),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 21 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 22 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 23 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Reader_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Reader_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Reader_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Settings_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Settings_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Settings_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__event_hub_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    pageNum: {
      type: Number,
      default: 0
    },
    ttlPages: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      pageNumber: this.pageNum,
      totalPages: this.ttlPages,
      info: false,
      buyBar: true,
      buyMenu: false,
      socialMenu: false,
      otherBooks: false,
      focused: false,
      dialogBuy: false,
      dialogShare: false,
      notifications: false,
      sound: true,
      widgets: false,
      show: false,
      iSize: 50,
      selectBook: "Books",
      home: this.$route.path,
      drawer: false,
      drawerRight: false,
      items: [],
      books: [],
      booksChanged: '',
      socials: [{
        title: "LinkedIn",
        img: "static/img/linkedin-logo.svg",
        url: "https://www.linkedin.com/shareArticle?mini=true&url=https://textcafe.co/books/StGuaV/%3F1730408926764&title=New%20Testament%20Apocrypha%2C%20vol.%203&summary=An%20expansive%20compilation%20of%20New%20Testament%20apocrypha%20in%20English%20translation%2C%20featuring%20fascinating%20but%20heretofore%20unpublished%20texts.%26%23160%3B%26%23160%3BNew%20Testament%20Apocrypha%2C%20vol.%203%2C%20continues%20the%20More%20New%20Testament%20Apocrypha%20series%26rsq&source=LinkedIn",
        icon: "ion-social-linkedin"
      }, {
        title: "Facebook",
        img: "static/img/facebook-logo.svg",
        url: "https://www.facebook.com/sharer/sharer.php?u=https://textcafe.co/books/StGuaV/%3F1730408926764",
        icon: "ion-social-facebook"
      }, {
        title: "Twitter",
        img: "static/img/twitter-logo-silhouette.svg",
        url: "https://twitter.com/intent/tweet?text=An%20expansive%20compilation%20of%20New%20Testament%20apocrypha%20in%20English%20translation%2C%20featuring%20fascinating%20but%20heretofore%20unpublished%20texts.%26%23160%3B%0Dhttps://textcafe.co/books/StGuaV/%3F1730408926764&amp;via=textcafecom",
        icon: "ion-social-twitter"
      }, {
        title: "Tumblr",
        img: "static/img/tumblr-letter-logo.svg",
        url: "https://www.tumblr.com/widgets/share/tool?canonicalUrl=https://textcafe.co/books/StGuaV/%3F1730408926764&posttype=link&caption=An%20expansive%20compilation%20of%20New%20Testament%20apocrypha%20in%20English%20translation%2C%20featuring%20fascinating%20but%20heretofore%20unpublished%20texts.%26%23160%3B%26%23160%3BNew%20Testament%20Apocrypha%2C%20vol.%203%2C%20continues%20the%20More%20New%20Testament%20Apocrypha%20series%26rsq",
        icon: "ion-social-tumblr"
      }, {
        title: "Pinterest",
        img: "static/img/pinterest-logo.svg",
        url: "http://www.pinterest.com/pin/create/button/?url=https://textcafe.co/books/StGuaV/%3F1730408926764&description=An%20expansive%20compilation%20of%20New%20Testament%20apocrypha%20in%20English%20translation%2C%20featuring%20fascinating%20but%20heretofore%20unpublished%20texts.%26%23160%3B%26%23160%3BNew%20Testament%20Apocrypha%2C%20vol.%203%2C%20continues%20the%20More%20New%20Testament%20Apocrypha%20series%26rsq&media=https://textcafe.co/books/StGuaV/tc-custom/9781467466844.jpg",
        icon: "ion-social-pinterest"
      }],
      buys: [{
        title: 'Amazon US',
        img: 'https://textcafe.co/domain-icons/Amazon.com_A_Smile.svg',
        url: 'https://www.amazon.com/dp/B0B82ZZPCF?tag=mobilebookcom-20&ref=nosim',
        alt: 'None'
      }, {
        title: 'Google Play',
        img: 'https://textcafe.co/global-css/img/Google_Play_symbol.svg',
        url: 'https://play.google.com/store/books/details?id=K1l-EAAAQBAJ&amp;rdid=book-K1l-EAAAQBAJ&amp;rdot=1&amp;source=gbs_atb&amp;pcampaignid=books_booksearch_atb&gl=us',
        alt: 'None'
      }],
      right: null,
      left: null
    };
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('https://www.textcafe.com/widget/get-samples.json?related=9781467466844').then(function (response) {
      return _this.books = response.data.map(function (item) {
        return {
          title: item.title,
          img: item.coverImagePath,
          url: item.socialUrl,
          alt: "This image is the cover for the book " + item.title
        };
      });
    }).catch(function (error) {
      return (
        // handle error
        console.log(error)
      );
    });
  },

  created: function created() {
    var _this2 = this;

    this.$router.options.routes.forEach(function (route) {
      _this2.items.push({
        path: route.path,
        name: route.name,
        component: route.component,
        //image: "static/img/ilG6Mf.jpg"
        image: '/books/StGuaV/tc-custom/9781467466844.jpg?1730408926764',
        alt: 'New Testament Apocrypha, vol. 3'
      });
    });
    __WEBPACK_IMPORTED_MODULE_2__event_hub_js__["a" /* default */].$on("pageNum", function (newValue) {
      _this2.pageNum = newValue;
    });
    __WEBPACK_IMPORTED_MODULE_2__event_hub_js__["a" /* default */].$on("ttlPages", function (newValue) {
      _this2.ttlPages = newValue;
    });
  },
  watch: {
    $route: function $route(to, from) {
      if (to.path === "/") {
        this.home = this.$route.path;
      } else {
        this.home = null;
      }
    },

    iSize: function iSize(newValue) {
      __WEBPACK_IMPORTED_MODULE_2__event_hub_js__["a" /* default */].$emit("iSizeChanged", newValue);
    },
    books: function books(newValue) {
      __WEBPACK_IMPORTED_MODULE_2__event_hub_js__["a" /* default */].$emit("booksChanged", Date.now());
    }
  },
  methods: {
    resetScroll: function resetScroll() {
      var page = this.$el.querySelector(".book-page");
      page.scrollLeft = 0;
    },
    onBlur: function onBlur() {
      if (this.show === true) {
        this.show = false;
        this.$emit("blur");
      }
    },
    onFocus: function onFocus() {
      if (this.show === false) {
        this.show = true;
        this.$el.querySelector(".book-page").$emit("focus");
      }
    },
    buyClick: function buyClick(url) {
      //const url = '/foo/bar'
      // this.$ga.query('send', 'event', 'outbound', 'click', url, {
      //     transport: 'beacon',
      //     hitCallback () {
      //        //document.location = url
      //     }
      // })
      this.$ga.event({
        eventCategory: 'purchase',
        eventAction: 'click',
        eventLabel: url
        // eventValue: 123
      });
    },
    shareClick: function shareClick(network) {
      this.$ga.event({
        eventCategory: 'share',
        eventAction: 'click',
        eventLabel: network
        // eventValue: 123
      });
    }
  },
  components: {
    settings: __WEBPACK_IMPORTED_MODULE_1__components_Settings_vue___default.a,
    reader: __WEBPACK_IMPORTED_MODULE_0__components_Reader_vue___default.a
  }
});

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__event_hub_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Settings__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Settings___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Settings__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var SLIDE_TIME = document.documentElement.clientWidth > 480 ? 500 : 300;

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "reader",
  props: {
    value1: {
      type: Number,
      default: 22
    },
    selected: {
      type: String
    },
    ex8: {
      type: String,
      default: "Auto"
    },
    value2: {
      type: Number
    },
    value3: {
      type: Number,
      default: 100
    }
  },
  data: function data() {
    return {
      pageNum: 0,
      pageNumber: 1,
      ttlPages: 0,
      totalPages: 0,
      home: false,
      div: 0,
      prevX: null,
      xDownEnd: null,
      fontSize: this.value1,
      fontFamily: this.selected,
      columns: this.ex8,
      widthSize: this.value2,
      brightness: this.value3,
      currentColor: "#f3f3f3",
      cols: "2 220px",
      position: { scrollTop: 0, scrollLeft: 0 },
      offset: null,
      height: 0,
      isOver: false,
      routeNames: ["home", "005_Contents", "006_Preface", "007_Introduction", "008_Abbreviations", "009_Part01", "010_Chapter01", "011_Chapter02", "012_Chapter03", "last"],
      routeTransition: "slide-left",
      rest: true,
      selectedView: "Book1",
      progress: 0,
      hiddenEl: false,
      brandReaderUrl: "",
      brandLogoUrl: "",
      currentUrl: "https://textcafe.co/books/StGuaV/",
      waiting: false
    };
  },

  created: function created() {
    var _this = this;

    document.addEventListener("mousewheel", this.onScroll, false);
    window.addEventListener('resize', this.resize);
    this.resize();
    this.getTtlPages();

    if (document.documentElement.offsetWidth >= 768) {
      this.hiddenEl = true;
    } else {
      this.hiddenEl = false;
    }

    this.$router.options.routes.forEach(function (route) {
      _this.routeNames.push(route.name);
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("fontSizeChanged", function (newValue) {
      _this.fontSize = newValue;
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("fontFamilyChanged", function (newValue) {
      _this.fontFamily = newValue;
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("columnsCountChanged", function (newValue) {
      _this.columns = newValue;
      if (_this.columns === "Single") {
        _this.cols = "1 auto";
      } else if (_this.columns === "Auto") {
        _this.cols = "2 220px";
      }
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("widthChanged", function (newValue) {
      _this.widthSize = newValue;
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("brightnessChanged", function (newValue) {
      _this.brightness = newValue;
    });
  },

  destroyed: function destroyed() {
    document.removeEventListener("mousewheel", this.onScroll, false);
    document.removeEventListener("resize", this.resize, false);
  },
  updated: function updated() {
    this.getTtlPages();
    this.resize();
    var links = document.getElementsByTagName("a");
    for (var i = 0; i < links.length; i++) {
      var that = this;
      var url = "/" + document.location.hash.split("#/")[1];
      if (links[i].href.split("#")[1] === url) {
        links[i].style.textDecoration = "underline";
        links[i].style.textDecorationStyle = "dotted";
        links[i].onclick = function (e) {
          e.preventDefault();
          var refr = this.href.split("#")[2];
          that.linkTo(refr);
        };
      };
    };
  },
  mounted: function mounted() {
    this.resize();

    var links = document.getElementsByTagName("a");
    for (var i = 0; i < links.length; i++) {
      var that = this;
      var url = "/" + document.location.hash.split("#/")[1];
      if (links[i].href.split("#")[1] === url) {
        links[i].style.textDecoration = "underline";
        links[i].style.textDecorationStyle = "dotted";
        links[i].onclick = function (e) {
          e.preventDefault();
          var refr = this.href.split("#")[2];
          that.linkTo(refr);
        };
      };
    };

    this.getTtlPages();

    var bgColor = document.getElementsByClassName("book-content")[0].style.backgroundColor,
        hexDigits = new Array("0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "a", "b", "c", "d", "e", "f");
    function rgb2hex(rgb) {
      rgb = rgb.match(/^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/);
      return "#" + hex(rgb[1]) + hex(rgb[2]) + hex(rgb[3]);
    }
    function hex(x) {
      return isNaN(x) ? "00" : hexDigits[(x - x % 16) / 16] + hexDigits[x % 16];
    }
    this.currentColor = rgb2hex(bgColor);
  },

  watch: {
    $route: function $route(to, from, next) {
      var toDepth = this.routeNames.indexOf(to.name);
      var fromDepth = this.routeNames.indexOf(from.name);
      this.routeTransition = toDepth < fromDepth ? "slide-right" : "slide-left";

      this.progress = 0;
      this.pageNumber = 1;
    },

    pageNum: function pageNum(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("pageNum", newValue);
    },
    ttlPages: function ttlPages(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("ttlPages", newValue);
    }
  },
  methods: {
    resize: function resize() {
      this.height = document.documentElement.clientHeight;
    },
    linkTo: function linkTo(refName) {
      var element = document.getElementById(refName);
      var elementOffset = Math.ceil(element.offsetLeft);
      var page = this.$el.querySelector(".book-page");
      var gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10);
      var onStart = Math.ceil(page.scrollLeft);
      var destinationOffset = Math.floor(elementOffset / (page.offsetWidth + gap));
      var target = destinationOffset * (page.offsetWidth + gap) - onStart;
      if (destinationOffset + 1 !== this.pageNumber) {
        this.scrollIt(target, 300, "easeOutQuad", false);
        var scrollArea = page.scrollWidth - page.offsetWidth;
        var pctScrolled = Math.floor(destinationOffset * (page.offsetWidth + gap) / scrollArea * 100);
        this.progress = pctScrolled;
        this.pageNumber = destinationOffset + 1;
      }
    },
    getTtlPages: function getTtlPages() {
      this.$nextTick(function () {
        var page = this.$el.querySelector(".book-page");

        var gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10);

        var scrollArea = page.scrollWidth - page.offsetWidth;
        var ttlPages = Math.round(scrollArea / (page.offsetWidth + gap));
        this.ttlPages = ttlPages;
        this.totalPages = this.ttlPages + 1;
      });
    },
    tapped: function tapped() {
      var el = this.$el.querySelector(".touch-swipe");
      this.hiddenEl = !this.hiddenEl;
    },
    tappedIn: function tappedIn() {
      var el = this.$el.querySelector(".touch-swipe");
      this.hiddenEl = !this.hiddenEl;
    },
    scrollIt: function scrollIt(destination) {
      var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 200;

      var _this2 = this;

      var easing = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "easeInOutQuart";
      var callback = arguments[3];

      var easings = {
        linear: function linear(t) {
          return t;
        },
        easeInQuad: function easeInQuad(t) {
          return t * t;
        },
        easeOutQuad: function easeOutQuad(t) {
          return t * (2 - t);
        },
        easeInOutQuad: function easeInOutQuad(t) {
          return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
        },
        easeInCubic: function easeInCubic(t) {
          return t * t * t;
        },
        easeOutCubic: function easeOutCubic(t) {
          return --t * t * t + 1;
        },
        easeInOutCubic: function easeInOutCubic(t) {
          return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
        },
        easeInQuart: function easeInQuart(t) {
          return t * t * t * t;
        },
        easeOutQuart: function easeOutQuart(t) {
          return 1 - --t * t * t * t;
        },
        easeInOutQuart: function easeInOutQuart(t) {
          return t < 0.5 ? 8 * t * t * t * t : 1 - 8 * --t * t * t * t;
        },
        easeInQuint: function easeInQuint(t) {
          return t * t * t * t * t;
        },
        easeOutQuint: function easeOutQuint(t) {
          return 1 + --t * t * t * t * t;
        },
        easeInOutQuint: function easeInOutQuint(t) {
          return t < 0.5 ? 16 * t * t * t * t * t : 1 + 16 * --t * t * t * t * t;
        }
      };

      var page = this.$el.querySelector(".book-page");
      var gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10),
          offset = page.offsetWidth + gap;

      var start = Math.ceil(page.scrollLeft);

      var startTime = "now" in window.performance ? performance.now() : new Date().getTime();

      var documentWidth = Math.max(page.scrollWidth || page.offsetWidth || page.clientWidth);

      var windowWidth = window.innerWidth || window.clientWidth;

      var destinationOffsetToScroll = start + destination;

      function scroll() {
        var now = "now" in window.performance ? performance.now() : new Date().getTime();
        var time = Math.min(1, (now - startTime) / duration);
        var timeFunction = easings[easing](time);
        page.scroll(Math.ceil(timeFunction * (destinationOffsetToScroll - start) + start), 0);
        if (timeFunction === 1 || start === destinationOffsetToScroll) {
          if (callback) {
            callback();
          }
          return;
        }
        requestAnimationFrame(scroll);
      }
      scroll();
      setTimeout(function () {
        _this2.waiting = false;
      }, 250);
    },


    next: function next(e) {
      var el = this.$el.querySelector(".touch-swipe");
      if (el) el.style.pointerEvents = "auto";
      var book = this.$el.querySelector(".book-content");
      var page = this.$el.querySelector(".book-page"),
          gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10),
          offset = page.offsetWidth + gap,
          index = this.routeNames.indexOf(this.$route.name);

      var scrollArea = page.scrollWidth - page.offsetWidth;
      var windowWidth = window.innerWidth || window.clientWidth;
      var trackLength = scrollArea - (page.offsetWidth + gap);

      // var pageNum = Math.floor(page.scrollLeft / (page.offsetWidth + gap));
      var scrollLeft = Math.ceil(page.scrollLeft);
      var pageNum = Math.floor(scrollLeft / (page.offsetWidth + gap));

      this.pageNum = pageNum;

      pageNum += 1;

      this.pageNumber += 1;

      if (page.scrollWidth - (scrollLeft + page.offsetWidth) !== 0 && pctScrolled !== 100) {
        var currentPage = Math.floor(pageNum * (page.offsetWidth + gap));

        var nextPage = Math.floor(pageNum * (page.offsetWidth + gap));

        var destination = nextPage - scrollLeft;

        this.scrollIt(destination, 300, "easeOutQuad", false);
      } else {
        this.$router.push({ name: this.routeNames[index + 1] });

        this.pageNumber = 1;
        pageNum = 0;
        var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
        this.progress = pctScrolled;
      }
      var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
      this.progress = pctScrolled;
    },
    prev: function prev(e) {
      var el = this.$el.querySelector(".touch-swipe");
      if (el) el.style.pointerEvents = "auto";

      var page = this.$el.querySelector(".book-page"),
          gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10),
          offset = page.offsetWidth + gap,
          index = this.routeNames.indexOf(this.$route.name);

      var scrollArea = page.scrollWidth - page.offsetWidth;

      var scrollLeft = Math.ceil(page.scrollLeft);
      var pageNum = Math.round(scrollLeft / (page.offsetWidth + gap));
      var ttlPages = Math.round(scrollArea / (page.offsetWidth + gap));

      this.pageNum = pageNum;

      this.pageNumber -= 1;

      var currentPage = Math.floor(pageNum * (page.offsetWidth + gap));

      if (scrollLeft !== 0 && pageNum !== 0) {
        var pageNum = Math.round(scrollLeft / (page.offsetWidth + gap));
        var pageNumber = Math.floor(scrollLeft / (page.offsetWidth + gap));

        pageNum -= 1;
        var prevPage = Math.floor(pageNum * (page.offsetWidth + gap));

        var destination = -1 * (scrollLeft - prevPage);

        this.scrollIt(destination, 300, "easeOutQuad", false);
      } else {
        this.$router.push({ name: this.routeNames[index - 1] });

        this.pageNumber = 1;

        pageNum = 0;
        var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
        this.progress = pctScrolled;
      }
      var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
      this.progress = pctScrolled;
    },
    over: function over() {
      this.isOver = true;
    },
    out: function out() {
      this.isOver = false;
    },
    onScroll: function onScroll(e, position) {
      this.position = position;
      if (this.isOver === true) {
        var page = this.$el.querySelector(".book-page"),
            gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10),
            deltaX = Math.max(-1, Math.min(1, e.wheelDelta || -e.detail)),
            end = page.scrollWidth - (page.scrollLeft + page.offsetWidth),
            offset = page.offsetWidth + gap;

        var scrollArea = page.scrollWidth - page.offsetWidth;
        var pageNum = Math.round(page.scrollLeft / (page.offsetWidth + gap));

        var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
        this.progress = pctScrolled;

        if (deltaX === 1) {
          if (page.scrollLeft !== 0) {
            if (this.waiting) {
              return;
            }
            this.waiting = true;

            pageNum -= 1;

            this.pageNumber -= 1;
            var prevPage = Math.floor(pageNum * (page.offsetWidth + gap));

            var destination = -1 * (page.scrollLeft - prevPage);

            this.scrollIt(destination, 300, "easeOutQuad", false);

            var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
            this.progress = pctScrolled;
          }
        } else if (deltaX === -1) {
          if (page.scrollWidth - (page.scrollLeft + page.offsetWidth) !== 0) {
            if (this.waiting) {
              return;
            }
            this.waiting = true;

            pageNum += 1;

            this.pageNumber += 1;
            var nextPage = Math.floor(pageNum * (page.offsetWidth + gap));

            var destination = nextPage - page.scrollLeft;

            this.scrollIt(destination, 300, "easeOutQuad", false);

            var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
            this.progress = pctScrolled;
          }
        }
      } else {
        return;
      }
    },
    fadeIn: function fadeIn() {
      var page = this.$el.querySelector(".book-page");
      page.style.opacity = 0;
      var last = +new Date();
      var tick = function tick() {
        page.style.opacity = +page.style.opacity + (new Date() - last) / 400;
        last = +new Date();
        if (+page.style.opacity < 1) {
          window.requestAnimationFrame && requestAnimationFrame(tick) || setTimeout(tick, 16);
        }
      };
      tick();
    },

    resetScroll: function resetScroll() {
      var page = this.$el.querySelector(".book-page");
      page.scrollLeft = 0;
    }
  },
  computed: {
    isMobile: function isMobile() {
      var check = false;
      (function (a) {
        if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true;
      })(navigator.userAgent || navigator.vendor || window.opera);
      return check;
    }
  },
  components: {
    Settings: __WEBPACK_IMPORTED_MODULE_1__components_Settings___default.a
  }
});

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__event_hub_js__ = __webpack_require__(5);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: "settings",
  data: function data() {
    return {
      events: [],
      value1: 22,
      value2: 70,
      value3: 100,
      ex8: "Auto",
      selected: "Old-Cabin",
      fonts: ["Old-Cabin", "Raleway-Bitter", "Ubuntu-Abel", "Droid-Abril", "Garamond-Clicker", "Alice-Playfair", "Judson-Quando"],
      classes: ["white", "black", "sepia"]
    };
  },

  watch: {
    value1: function value1(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("fontSizeChanged", newValue);
    },
    selected: function selected(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("fontFamilyChanged", newValue);
    },
    ex8: function ex8(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("columnsCountChanged", newValue);
    },
    value2: function value2(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("widthChanged", newValue);
    },
    value3: function value3(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("brightnessChanged", newValue);
    }
  },
  methods: {
    reloadBook: function reloadBook() {
      window.location.reload(true);
    },
    changeClassWhite: function changeClassWhite() {
      var el = document.getElementsByClassName("book-content")[0];
      var el2 = document.getElementsByClassName("nav-btn")[0];
      var el3 = document.getElementsByClassName("nav-btn")[1];
      var el4 = document.getElementsByTagName("footer")[0];
      console.log(document.getElementsByTagName("footer")[0]);
      if (el.classList && el2.classList && el3.classList && el4.classList) {
        el.classList.remove("black");
        el2.classList.remove("black");
        el3.classList.remove("black");
        el4.classList.remove("black");
        el.classList.remove("sepia");
        el2.classList.remove("sepia");
        el3.classList.remove("sepia");
        el4.classList.remove("sepia");
        el.classList.add("white");
        el2.classList.add("white");
        el3.classList.add("white");
        el4.classList.add("white");
      } else {
        el.className += " white";
        el2.className += " white";
        el3.className += " white";
        el4.className += " white";
      }
    },
    changeClassBlack: function changeClassBlack() {
      var el = document.getElementsByClassName("book-content")[0];
      var el2 = document.getElementsByClassName("nav-btn")[0];
      var el3 = document.getElementsByClassName("nav-btn")[1];
      var el4 = document.getElementsByTagName("footer")[0];
      if (el.classList && el2.classList && el3.classList && el4.classList) {
        el.classList.remove("white");
        el2.classList.remove("white");
        el3.classList.remove("white");
        el4.classList.remove("white");
        el.classList.remove("sepia");
        el2.classList.remove("sepia");
        el3.classList.remove("sepia");
        el4.classList.remove("sepia");
        el.classList.add("black");
        el2.classList.add("black");
        el3.classList.add("black");
        el4.classList.add("black");
      } else {
        el.className += " black";
        el2.className += " black";
        el3.className += " black";
        el4.className += " black";
      }
    },
    changeClassSepia: function changeClassSepia() {
      var el = document.getElementsByClassName("book-content")[0];
      var el2 = document.getElementsByClassName("nav-btn")[0];
      var el3 = document.getElementsByClassName("nav-btn")[1];
      var el4 = document.getElementsByTagName("footer")[0];
      if (el.classList && el2.classList && el3.classList && el4.classList) {
        el.classList.remove("black");
        el2.classList.remove("black");
        el3.classList.remove("black");
        el4.classList.remove("black");
        el.classList.remove("white");
        el2.classList.remove("white");
        el3.classList.remove("white");
        el4.classList.remove("white");
        el.classList.add("sepia");
        el2.classList.add("sepia");
        el3.classList.add("sepia");
        el4.classList.add("sepia");
      } else {
        el.className += " sepia";
        el2.className += " sepia";
        el3.className += " sepia";
        el4.className += " sepia";
      }
    }
  }
});

/***/ }),
/* 27 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "settings"
  }, [_c('ul', {
    staticClass: "settings-list"
  }, [_c('li', [_c('span', [_vm._v("Reload book: ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "id": "reloadBookBtn",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.reloadBook()
      }
    }
  }, [_c('v-icon', [_vm._v("ion-ios-loop-strong")])], 1)], 1), _vm._v(" "), _c('li', [_c('span', [_vm._v("Font:")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "items": _vm.fonts,
      "overflow": "",
      "single-line": "",
      "return-objectauto": "",
      "append-icon": "ion-ios-arrow-down",
      "hide-details": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawerRight = true
      }
    },
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  })], 1), _vm._v(" "), _c('li', [_c('span', [_vm._v("Font size:")]), _vm._v(" "), _c('p', {
    staticClass: "bold-font",
    domProps: {
      "innerHTML": _vm._s(_vm.value1 + 'px' || null)
    }
  }), _vm._v(" "), _c('v-slider', {
    attrs: {
      "min": 17,
      "max": 27,
      "step": 1
    },
    model: {
      value: (_vm.value1),
      callback: function($$v) {
        _vm.value1 = $$v
      },
      expression: "value1"
    }
  })], 1), _vm._v(" "), _c('li', {
    staticClass: "columns-setting"
  }, [_c('span', [_vm._v("Page columns:")]), _c('br'), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Auto",
      "value": "Auto",
      "flat": "",
      "ripple": false,
      "prepend-icon": ""
    },
    model: {
      value: (_vm.ex8),
      callback: function($$v) {
        _vm.ex8 = $$v
      },
      expression: "ex8"
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Single",
      "value": "Single",
      "flat": "",
      "ripple": false,
      "prepend-icon": ""
    },
    model: {
      value: (_vm.ex8),
      callback: function($$v) {
        _vm.ex8 = $$v
      },
      expression: "ex8"
    }
  })], 1), _vm._v(" "), _c('li', {
    staticClass: "width-setting"
  }, [_c('span', [_vm._v("Page width:")]), _vm._v(" "), _c('p', {
    staticClass: "bold-font",
    domProps: {
      "innerHTML": _vm._s(_vm.value2 + '%' || null)
    }
  }), _vm._v(" "), _c('v-slider', {
    attrs: {
      "min": 50,
      "max": 90
    },
    model: {
      value: (_vm.value2),
      callback: function($$v) {
        _vm.value2 = $$v
      },
      expression: "value2"
    }
  })], 1), _vm._v(" "), _c('li', [_c('span', [_vm._v("Brightness:")]), _vm._v(" "), _c('p', {
    staticClass: "bold-font",
    domProps: {
      "innerHTML": _vm._s((_vm.value3 - 100) + '%' || null)
    }
  }), _vm._v(" "), _c('v-slider', {
    attrs: {
      "step": 1,
      "min": 0,
      "max": 200
    },
    model: {
      value: (_vm.value3),
      callback: function($$v) {
        _vm.value3 = $$v
      },
      expression: "value3"
    }
  })], 1), _vm._v(" "), _c('li', [_c('span', [_vm._v("Color mode:")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    attrs: {
      "id": "colors"
    }
  }, [_c('v-btn', {
    attrs: {
      "flat": "",
      "id": "white",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeClassWhite()
      }
    }
  }, [_vm._v("\n          White\n        ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "id": "black",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeClassBlack()
      }
    }
  }, [_vm._v("\n          Black\n        ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "id": "sepia",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeClassSepia()
      }
    }
  }, [_vm._v("\n          Sepia\n        ")])], 1)])])])
},staticRenderFns: []}

/***/ }),
/* 28 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrap",
    style: ({
      'filter': 'brightness(' + _vm.brightness + '%)',
      'height': _vm.height - 49 + 'px'
    })
  }, [_c('v-progress-linear', {
    model: {
      value: (_vm.progress),
      callback: function($$v) {
        _vm.progress = $$v
      },
      expression: "progress"
    }
  }), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "shortkey",
      rawName: "v-shortkey",
      value: (['arrowleft']),
      expression: "['arrowleft']"
    }],
    staticClass: "nav-btn left",
    style: ({
      width: (100 - _vm.widthSize) + '%'
    }),
    attrs: {
      "ripple": false
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.prev($event)
      },
      "shortkey": _vm.prev
    }
  }, [_c('v-icon', {
    style: ({
      'left': (_vm.widthSize / 3.5) + '%'
    })
  }, [_vm._v("ion-ios-arrow-left")])], 1), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "shortkey",
      rawName: "v-shortkey",
      value: (['arrowright']),
      expression: "['arrowright']"
    }],
    staticClass: "nav-btn right",
    style: ({
      width: (100 - _vm.widthSize) + '%'
    }),
    attrs: {
      "ripple": false
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.next($event)
      },
      "shortkey": _vm.next
    }
  }, [_c('v-icon', {
    style: ({
      'right': (_vm.widthSize / 3.5) + '%'
    })
  }, [_vm._v("ion-ios-arrow-right")])], 1), _vm._v(" "), _c('div', {
    staticClass: "book-content",
    style: ({
      'width': _vm.widthSize + '%',
      'background-color': _vm.currentColor,
      'height': _vm.height - 78 + 'px'
    }),
    on: {
      "mouseenter": _vm.over,
      "mouseleave": _vm.out
    }
  }, [(_vm.isMobile) ? _c('v-touch', {
    staticClass: "touch-swipe",
    class: {
      active: _vm.hiddenEl
    },
    on: {
      "swipeleft": _vm.next,
      "swiperight": _vm.prev,
      "tap": _vm.tapped
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    key: _vm.div,
    staticClass: "book-page",
    class: _vm.fontFamily,
    style: ({
      'font-size': _vm.fontSize + 'px',
      'columns': _vm.cols
    }),
    attrs: {
      "enable-resize-watcher": ""
    },
    on: {
      "tap": _vm.tappedIn,
      "swipe": _vm.tappedIn,
      "click": _vm.tappedIn
    }
  }, [_c('transition', {
    attrs: {
      "name": _vm.routeTransition,
      "mode": "out-in"
    }
  }, [_c('router-view', {
    key: _vm.$route.name,
    staticClass: "view"
  })], 1)], 1)], 1), _vm._v(" "), _c('footer', {
    class: _vm.fontFamily,
    style: ({
      'font-size': (_vm.fontSize - 5) + 'px'
    })
  }, [(_vm.brandReaderUrl) ? _c('div', [_c('v-btn', {
    staticClass: "HC-footer-button",
    attrs: {
      "flat": "",
      "ripple": false,
      "tag": "a",
      "href": _vm.brandReaderUrl,
      "target": "_blank"
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = false, _vm.info = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawerRight = false, _vm.otherBooks = false
      }
    }
  }, [_c('i', [_c('img', {
    attrs: {
      "src": _vm.brandLogoUrl
    }
  })])])], 1) : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('div', {
    staticClass: "foots"
  }, [_c('span', [_c('em', [_vm._v(_vm._s(this.$route.name))])]), _vm._v(" - page "), _c('span', [_c('em', [_vm._v(_vm._s(this.pageNumber))])]), _vm._v(" "), (this.totalPages > 1) ? _c('span', [_c('em', [_vm._v(_vm._s("/ " + this.totalPages))])]) : _vm._e()]), _vm._v(" "), _c('v-spacer')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(30);

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);
var bind = __webpack_require__(8);
var Axios = __webpack_require__(31);
var mergeConfig = __webpack_require__(14);
var defaults = __webpack_require__(11);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(mergeConfig(axios.defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__(15);
axios.CancelToken = __webpack_require__(44);
axios.isCancel = __webpack_require__(10);

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(45);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);
var buildURL = __webpack_require__(9);
var InterceptorManager = __webpack_require__(32);
var dispatchRequest = __webpack_require__(33);
var mergeConfig = __webpack_require__(14);

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = arguments[1] || {};
    config.url = arguments[0];
  } else {
    config = config || {};
  }

  config = mergeConfig(this.defaults, config);

  // Set config.method
  if (config.method) {
    config.method = config.method.toLowerCase();
  } else if (this.defaults.method) {
    config.method = this.defaults.method.toLowerCase();
  } else {
    config.method = 'get';
  }

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

Axios.prototype.getUri = function getUri(config) {
  config = mergeConfig(this.defaults, config);
  return buildURL(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);
var transformData = __webpack_require__(34);
var isCancel = __webpack_require__(10);
var defaults = __webpack_require__(11);

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__(13);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  if (!validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }

  error.request = request;
  error.response = response;
  error.isAxiosError = true;

  error.toJSON = function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code
    };
  };
  return error;
};


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isAbsoluteURL = __webpack_require__(39);
var combineURLs = __webpack_require__(40);

/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */
module.exports = function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
};


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
    (function standardBrowserEnv() {
      var msie = /(msie|trident)/i.test(navigator.userAgent);
      var urlParsingNode = document.createElement('a');
      var originURL;

      /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
      function resolveURL(url) {
        var href = url;

        if (msie) {
        // IE needs attribute set twice to normalize properties
          urlParsingNode.setAttribute('href', href);
          href = urlParsingNode.href;
        }

        urlParsingNode.setAttribute('href', href);

        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
          href: urlParsingNode.href,
          protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
          host: urlParsingNode.host,
          search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
          hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
          hostname: urlParsingNode.hostname,
          port: urlParsingNode.port,
          pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
            urlParsingNode.pathname :
            '/' + urlParsingNode.pathname
        };
      }

      originURL = resolveURL(window.location.href);

      /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
      return function isURLSameOrigin(requestURL) {
        var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
        return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
      };
    })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return function isURLSameOrigin() {
        return true;
      };
    })()
);


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
    (function standardBrowserEnv() {
      return {
        write: function write(name, value, expires, path, domain, secure) {
          var cookie = [];
          cookie.push(name + '=' + encodeURIComponent(value));

          if (utils.isNumber(expires)) {
            cookie.push('expires=' + new Date(expires).toGMTString());
          }

          if (utils.isString(path)) {
            cookie.push('path=' + path);
          }

          if (utils.isString(domain)) {
            cookie.push('domain=' + domain);
          }

          if (secure === true) {
            cookie.push('secure');
          }

          document.cookie = cookie.join('; ');
        },

        read: function read(name) {
          var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
          return (match ? decodeURIComponent(match[3]) : null);
        },

        remove: function remove(name) {
          this.write(name, '', Date.now() - 86400000);
        }
      };
    })() :

  // Non standard browser env (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return {
        write: function write() {},
        read: function read() { return null; },
        remove: function remove() {}
      };
    })()
);


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__(15);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),
/* 46 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', {
    attrs: {
      "toolbar": ""
    }
  }, [_c('v-dialog', {
    attrs: {
      "fullscreen": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.info = !_vm.info
      }
    },
    model: {
      value: (_vm.info),
      callback: function($$v) {
        _vm.info = $$v
      },
      expression: "info"
    }
  }, [_c('v-card', {
    staticClass: "infoDialog"
  }, [_c('div', {
    staticClass: "menuIns"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-navicon")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-ios-browsers-outline")])], 1), _vm._v(" "), _c('div', {
    staticClass: "menuInsTip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Contents")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Navigate to book chapters")])]), _vm._v(" "), _c('div', {
    staticClass: "menuInsTip2"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Related Books")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Other books you might like")])]), _vm._v(" "), _c('div', {
    staticClass: "socMenu"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-linkedin")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-facebook")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-twitter")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-tumblr")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-pinterest")])], 1), _vm._v(" "), _c('div', {
    staticClass: "socMenuMob"
  }, [_c('v-icon', [_vm._v("ion-android-share-alt")])], 1), _vm._v(" "), _c('div', {
    staticClass: "socMenuTip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Share Book")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Share book to your social network")])]), _vm._v(" "), _c('div', {
    staticClass: "resize-settings"
  }, [_c('v-icon', [_vm._v("ion-ios-gear-outline")])], 1), _vm._v(" "), _c('div', {
    staticClass: "resize-settings-tip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Settings button")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Change colors and fonts")])]), _vm._v(" "), _c('div', {
    staticClass: "left-button"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-ios-arrow-left")])], 1), _vm._v(" "), _c('div', {
    staticClass: "left-button-tip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Left/Previous")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Go to previous page or chapter in book view."), _c('br'), _vm._v("On touch screen swipe right.")])]), _vm._v(" "), _c('div', {
    staticClass: "right-button"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-ios-arrow-right")])], 1), _vm._v(" "), _c('div', {
    staticClass: "right-button-tip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Right/Next")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Go to next page or chapter in book view."), _c('br'), _vm._v("On touch screen swipe left.")])]), _vm._v(" "), _c('div', {
    staticClass: "buy-buttons"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-bag")])], 1), _vm._v(" "), _c('div', {
    staticClass: "buy-buttons-mob"
  }, [_c('v-icon', [_vm._v("ion-bag")])], 1), _vm._v(" "), _c('div', {
    staticClass: "buy-buttons-tip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Buy Book")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Click to stores where you can buy this book")])]), _vm._v(" "), _c('div', {
    staticClass: "headline"
  }, [_vm._v("Instructions")]), _vm._v(" "), _c('v-btn', {
    staticClass: "closeDialog",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.info = false
      }
    }
  }, [_vm._v("Close")])], 1)], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "menu",
    attrs: {
      "temporary": "",
      "hide-overlay": "",
      "clipped": "",
      "enable-resize-watcher": "",
      "disable-route-watcher": "",
      "touchless": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = !_vm.drawer
      }
    },
    model: {
      value: (_vm.drawer),
      callback: function($$v) {
        _vm.drawer = $$v
      },
      expression: "drawer"
    }
  }, [_c('v-list', _vm._l((_vm.items), function(item) {
    return _c('v-list-tile', {
      key: item.name,
      attrs: {
        "href": item.path,
        "to": item.path,
        "exact": "",
        "ripple": false,
        "width": "100%"
      }
    }, [_c('v-list-tile-action', [_c('img', {
      attrs: {
        "height": "55px",
        "alt": item.alt,
        "src": item.image
      }
    })]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
      attrs: {
        "active": ""
      }
    }, [_vm._v(_vm._s(item.name))])], 1)], 1)
  }), 1)], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "otherBooks",
    attrs: {
      "temporary": "",
      "hide-overlay": "",
      "clipped": "",
      "enable-resize-watcher": "",
      "disable-route-watcher": "",
      "touchless": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.otherBooks = !_vm.otherBooks
      }
    },
    model: {
      value: (_vm.otherBooks),
      callback: function($$v) {
        _vm.otherBooks = $$v
      },
      expression: "otherBooks"
    }
  }, [_c('v-list', [_c('h6', [_vm._v("Other books you might like:")]), _vm._v(" "), _vm._l((_vm.books), function(book) {
    return _c('v-list-tile', {
      key: book.title,
      attrs: {
        "href": book.url,
        "target": "_blank",
        "ripple": false,
        "width": "100%"
      }
    }, [_c('v-list-tile-action', [_c('img', {
      attrs: {
        "alt": book.alt,
        "src": book.img
      }
    })]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
      attrs: {
        "active": ""
      }
    }, [_vm._v(_vm._s(book.title))])], 1)], 1)
  })], 2)], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "settings-drawer",
    attrs: {
      "temporary": "",
      "hide-overlay": "",
      "clipped": "",
      "right": "",
      "enable-resize-watcher": "",
      "touchless": ""
    },
    model: {
      value: (_vm.drawerRight),
      callback: function($$v) {
        _vm.drawerRight = $$v
      },
      expression: "drawerRight"
    }
  }, [_c('v-list', [_c('settings')], 1)], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "mini-bar",
    attrs: {
      "mini-variant": "",
      "enable-resize-watcher": "",
      "touchless": ""
    },
    model: {
      value: (_vm.buyBar),
      callback: function($$v) {
        _vm.buyBar = $$v
      },
      expression: "buyBar"
    }
  }, [_c('v-list', {
    attrs: {
      "ripple": false
    }
  }, [_vm._v("Shop:\n      "), _vm._l((_vm.buys), function(buy) {
    return _c('v-list-tile', {
      key: buy.title,
      attrs: {
        "href": buy.url,
        "target": "_blank"
      },
      on: {
        "click": function($event) {
          return _vm.buyClick(buy.url)
        }
      }
    }, [_c('img', {
      attrs: {
        "alt": buy.alt,
        "src": buy.img
      }
    })])
  })], 2)], 1), _vm._v(" "), _c('v-toolbar', {
    staticClass: "main-menu",
    attrs: {
      "fixed": "",
      "persistent": ""
    }
  }, [_c('v-btn', {
    staticClass: "main-menu-button",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = !_vm.drawer, _vm.info = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawerRight = false, _vm.otherBooks = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-navicon")])], 1), _vm._v(" "), (_vm.books.length > 0) ? _c('v-btn', {
    key: _vm.booksChanged,
    staticClass: "otherBooks-button",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.otherBooks = !_vm.otherBooks, _vm.info = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawerRight = false, _vm.drawer = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-ios-browsers-outline")])], 1) : _vm._e(), _vm._v(" "), _c('v-toolbar', {
    staticClass: "desktop-social-btn",
    staticStyle: {
      "margin-left": "5%"
    }
  }, _vm._l((_vm.socials), function(social) {
    return _c('v-btn', {
      key: social.title,
      attrs: {
        "flat": "",
        "href": social.url,
        "target": "_blank",
        "ripple": false
      },
      on: {
        "click": function($event) {
          return _vm.shareClick(social.title)
        }
      }
    }, [_c('v-icon', [_vm._v(_vm._s(social.icon))])], 1)
  }), 1), _vm._v(" "), _c('v-btn', {
    staticClass: "mobile-buy-btn",
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.buyMenu = !_vm.buyMenu, _vm.info = false, _vm.drawer = false, _vm.socialMenu = false, _vm.drawerRight = false, _vm.otherBooks = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-bag")])], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "buy-menu",
    attrs: {
      "width": "100vw",
      "height": "auto",
      "hide-overlay": "",
      "temporary": "",
      "clipped": "",
      "disable-route-watcher": "",
      "touchless": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.buyMenu = !_vm.buyMenu
      }
    },
    model: {
      value: (_vm.buyMenu),
      callback: function($$v) {
        _vm.buyMenu = $$v
      },
      expression: "buyMenu"
    }
  }, [_c('v-list', [_c('span', [_vm._v("Purchase this book: ")]), _vm._v(" "), _vm._l((_vm.buys), function(buy) {
    return _c('v-list-tile', {
      key: buy.title,
      attrs: {
        "href": buy.url,
        "target": "_blank"
      },
      on: {
        "click": function($event) {
          return _vm.buyClick(buy.url)
        }
      }
    }, [_c('v-list-tile-action', [_c('img', {
      attrs: {
        "alt": buy.alt,
        "src": buy.img
      }
    })]), _vm._v(" "), _c('v-list-tile-title', {
      domProps: {
        "innerHTML": _vm._s(buy.title)
      }
    })], 1)
  })], 2)], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "mobile-social-btn",
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.socialMenu = !_vm.socialMenu, _vm.info = false, _vm.buyMenu = false, _vm.drawer = false, _vm.drawerRight = false, _vm.otherBooks = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-android-share-alt")])], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "social-menu",
    attrs: {
      "width": "100vw",
      "height": "auto",
      "hide-overlay": "",
      "temporary": "",
      "clipped": "",
      "disable-route-watcher": "",
      "persistent": "",
      "touchless": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.socialMenu = !_vm.socialMenu
      }
    },
    model: {
      value: (_vm.socialMenu),
      callback: function($$v) {
        _vm.socialMenu = $$v
      },
      expression: "socialMenu"
    }
  }, [_c('v-list', [_c('span', [_vm._v("Share this book: ")]), _vm._v(" "), _vm._l((_vm.socials), function(social) {
    return _c('v-list-tile', {
      key: social.title,
      attrs: {
        "href": social.url,
        "target": "_blank"
      },
      on: {
        "click": function($event) {
          return _vm.shareClick(social.title)
        }
      }
    }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v(_vm._s(social.icon))])], 1), _vm._v(" "), _c('v-list-tile-title', {
      domProps: {
        "innerHTML": _vm._s(social.title)
      }
    })], 1)
  })], 2)], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "info-btn",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.info = !_vm.info, _vm.drawer = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawerRight = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-ios-information-outline")])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "settings-button",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawerRight = !_vm.drawerRight, _vm.info = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawer = false, _vm.otherBooks = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-ios-gear-outline")])], 1)], 1), _vm._v(" "), _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('reader')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Reader__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Reader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Reader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_home__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_home__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_000_Cover__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_000_Cover___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_000_Cover__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_001_Halftitle__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_001_Halftitle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_001_Halftitle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_002_Titlepage__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_002_Titlepage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_002_Titlepage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_003_Copyright__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_003_Copyright___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_003_Copyright__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_004_Dedication__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_004_Dedication___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_004_Dedication__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_005_Contents__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_005_Contents___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_005_Contents__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_006_Preface__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_006_Preface___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_006_Preface__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_007_Introduction__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_007_Introduction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_007_Introduction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_008_Abbreviations__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_008_Abbreviations___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_008_Abbreviations__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_009_Part01__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_009_Part01___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_009_Part01__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_010_Chapter01__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_010_Chapter01___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_010_Chapter01__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_011_Chapter02__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_011_Chapter02___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_011_Chapter02__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_012_Chapter03__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_012_Chapter03___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_012_Chapter03__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_013_Chapter04__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_013_Chapter04___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__components_013_Chapter04__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_014_Chapter05__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_014_Chapter05___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__components_014_Chapter05__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_015_Chapter06__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_015_Chapter06___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__components_015_Chapter06__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_016_Chapter07__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_016_Chapter07___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__components_016_Chapter07__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_017_Chapter08__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_017_Chapter08___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__components_017_Chapter08__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_018_Part02__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_018_Part02___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__components_018_Part02__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_019_Chapter09__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_019_Chapter09___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__components_019_Chapter09__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_020_Chapter10__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_020_Chapter10___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__components_020_Chapter10__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_021_Chapter11__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_021_Chapter11___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__components_021_Chapter11__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_022_Chapter12__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_022_Chapter12___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__components_022_Chapter12__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_023_Chapter13__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_023_Chapter13___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__components_023_Chapter13__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_024_Chapter14__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_024_Chapter14___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__components_024_Chapter14__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_025_Chapter15__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_025_Chapter15___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__components_025_Chapter15__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_026_Chapter16__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_026_Chapter16___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30__components_026_Chapter16__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_027_Chapter17__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_027_Chapter17___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31__components_027_Chapter17__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_028_Chapter18__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_028_Chapter18___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32__components_028_Chapter18__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__components_029_Chapter19__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__components_029_Chapter19___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33__components_029_Chapter19__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__components_030_Chapter20__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__components_030_Chapter20___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34__components_030_Chapter20__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__components_031_Chapter21__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__components_031_Chapter21___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35__components_031_Chapter21__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__components_032_Part03__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__components_032_Part03___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_36__components_032_Part03__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__components_033_Chapter22__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__components_033_Chapter22___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_37__components_033_Chapter22__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__components_034_Chapter23__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__components_034_Chapter23___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_38__components_034_Chapter23__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__components_035_Chapter24__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__components_035_Chapter24___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_39__components_035_Chapter24__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__components_036_Part04__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__components_036_Part04___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_40__components_036_Part04__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__components_037_Chapter25__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__components_037_Chapter25___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_41__components_037_Chapter25__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__components_038_Chapter26__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__components_038_Chapter26___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_42__components_038_Chapter26__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__components_039_Chapter27__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__components_039_Chapter27___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_43__components_039_Chapter27__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__components_040_Chapter28__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__components_040_Chapter28___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_44__components_040_Chapter28__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__components_041_Chapter29__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__components_041_Chapter29___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_45__components_041_Chapter29__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__components_last__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__components_last___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_46__components_last__);
/*jshint esversion: 6 */

















































__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    "path": "/",
    "name": "home",
    "component": __WEBPACK_IMPORTED_MODULE_3__components_home___default.a
  }, {
    "path": "/005_Contents",
    "name": "005_Contents",
    "component": __WEBPACK_IMPORTED_MODULE_9__components_005_Contents___default.a
  }, {
    "path": "/006_Preface",
    "name": "006_Preface",
    "component": __WEBPACK_IMPORTED_MODULE_10__components_006_Preface___default.a
  }, {
    "path": "/007_Introduction",
    "name": "007_Introduction",
    "component": __WEBPACK_IMPORTED_MODULE_11__components_007_Introduction___default.a
  }, {
    "path": "/008_Abbreviations",
    "name": "008_Abbreviations",
    "component": __WEBPACK_IMPORTED_MODULE_12__components_008_Abbreviations___default.a
  }, {
    "path": "/009_Part01",
    "name": "009_Part01",
    "component": __WEBPACK_IMPORTED_MODULE_13__components_009_Part01___default.a
  }, {
    "path": "/010_Chapter01",
    "name": "010_Chapter01",
    "component": __WEBPACK_IMPORTED_MODULE_14__components_010_Chapter01___default.a
  }, {
    "path": "/011_Chapter02",
    "name": "011_Chapter02",
    "component": __WEBPACK_IMPORTED_MODULE_15__components_011_Chapter02___default.a
  }, {
    "path": "/012_Chapter03",
    "name": "012_Chapter03",
    "component": __WEBPACK_IMPORTED_MODULE_16__components_012_Chapter03___default.a
  }, {
    "path": "/last",
    "name": "last",
    "component": __WEBPACK_IMPORTED_MODULE_46__components_last___default.a
  }]
}));

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
  * vue-router v2.8.1
  * (c) 2017 Evan You
  * @license MIT
  */
/*  */

function assert (condition, message) {
  if (!condition) {
    throw new Error(("[vue-router] " + message))
  }
}

function warn (condition, message) {
  if (false) {
    typeof console !== 'undefined' && console.warn(("[vue-router] " + message));
  }
}

function isError (err) {
  return Object.prototype.toString.call(err).indexOf('Error') > -1
}

var View = {
  name: 'router-view',
  functional: true,
  props: {
    name: {
      type: String,
      default: 'default'
    }
  },
  render: function render (_, ref) {
    var props = ref.props;
    var children = ref.children;
    var parent = ref.parent;
    var data = ref.data;

    data.routerView = true;

    // directly use parent context's createElement() function
    // so that components rendered by router-view can resolve named slots
    var h = parent.$createElement;
    var name = props.name;
    var route = parent.$route;
    var cache = parent._routerViewCache || (parent._routerViewCache = {});

    // determine current view depth, also check to see if the tree
    // has been toggled inactive but kept-alive.
    var depth = 0;
    var inactive = false;
    while (parent && parent._routerRoot !== parent) {
      if (parent.$vnode && parent.$vnode.data.routerView) {
        depth++;
      }
      if (parent._inactive) {
        inactive = true;
      }
      parent = parent.$parent;
    }
    data.routerViewDepth = depth;

    // render previous view if the tree is inactive and kept-alive
    if (inactive) {
      return h(cache[name], data, children)
    }

    var matched = route.matched[depth];
    // render empty node if no matched route
    if (!matched) {
      cache[name] = null;
      return h()
    }

    var component = cache[name] = matched.components[name];

    // attach instance registration hook
    // this will be called in the instance's injected lifecycle hooks
    data.registerRouteInstance = function (vm, val) {
      // val could be undefined for unregistration
      var current = matched.instances[name];
      if (
        (val && current !== vm) ||
        (!val && current === vm)
      ) {
        matched.instances[name] = val;
      }
    }

    // also register instance in prepatch hook
    // in case the same component instance is reused across different routes
    ;(data.hook || (data.hook = {})).prepatch = function (_, vnode) {
      matched.instances[name] = vnode.componentInstance;
    };

    // resolve props
    var propsToPass = data.props = resolveProps(route, matched.props && matched.props[name]);
    if (propsToPass) {
      // clone to prevent mutation
      propsToPass = data.props = extend({}, propsToPass);
      // pass non-declared props as attrs
      var attrs = data.attrs = data.attrs || {};
      for (var key in propsToPass) {
        if (!component.props || !(key in component.props)) {
          attrs[key] = propsToPass[key];
          delete propsToPass[key];
        }
      }
    }

    return h(component, data, children)
  }
};

function resolveProps (route, config) {
  switch (typeof config) {
    case 'undefined':
      return
    case 'object':
      return config
    case 'function':
      return config(route)
    case 'boolean':
      return config ? route.params : undefined
    default:
      if (false) {
        warn(
          false,
          "props in \"" + (route.path) + "\" is a " + (typeof config) + ", " +
          "expecting an object, function or boolean."
        );
      }
  }
}

function extend (to, from) {
  for (var key in from) {
    to[key] = from[key];
  }
  return to
}

/*  */

var encodeReserveRE = /[!'()*]/g;
var encodeReserveReplacer = function (c) { return '%' + c.charCodeAt(0).toString(16); };
var commaRE = /%2C/g;

// fixed encodeURIComponent which is more conformant to RFC3986:
// - escapes [!'()*]
// - preserve commas
var encode = function (str) { return encodeURIComponent(str)
  .replace(encodeReserveRE, encodeReserveReplacer)
  .replace(commaRE, ','); };

var decode = decodeURIComponent;

function resolveQuery (
  query,
  extraQuery,
  _parseQuery
) {
  if ( extraQuery === void 0 ) extraQuery = {};

  var parse = _parseQuery || parseQuery;
  var parsedQuery;
  try {
    parsedQuery = parse(query || '');
  } catch (e) {
    "production" !== 'production' && warn(false, e.message);
    parsedQuery = {};
  }
  for (var key in extraQuery) {
    parsedQuery[key] = extraQuery[key];
  }
  return parsedQuery
}

function parseQuery (query) {
  var res = {};

  query = query.trim().replace(/^(\?|#|&)/, '');

  if (!query) {
    return res
  }

  query.split('&').forEach(function (param) {
    var parts = param.replace(/\+/g, ' ').split('=');
    var key = decode(parts.shift());
    var val = parts.length > 0
      ? decode(parts.join('='))
      : null;

    if (res[key] === undefined) {
      res[key] = val;
    } else if (Array.isArray(res[key])) {
      res[key].push(val);
    } else {
      res[key] = [res[key], val];
    }
  });

  return res
}

function stringifyQuery (obj) {
  var res = obj ? Object.keys(obj).map(function (key) {
    var val = obj[key];

    if (val === undefined) {
      return ''
    }

    if (val === null) {
      return encode(key)
    }

    if (Array.isArray(val)) {
      var result = [];
      val.forEach(function (val2) {
        if (val2 === undefined) {
          return
        }
        if (val2 === null) {
          result.push(encode(key));
        } else {
          result.push(encode(key) + '=' + encode(val2));
        }
      });
      return result.join('&')
    }

    return encode(key) + '=' + encode(val)
  }).filter(function (x) { return x.length > 0; }).join('&') : null;
  return res ? ("?" + res) : ''
}

/*  */


var trailingSlashRE = /\/?$/;

function createRoute (
  record,
  location,
  redirectedFrom,
  router
) {
  var stringifyQuery$$1 = router && router.options.stringifyQuery;

  var query = location.query || {};
  try {
    query = clone(query);
  } catch (e) {}

  var route = {
    name: location.name || (record && record.name),
    meta: (record && record.meta) || {},
    path: location.path || '/',
    hash: location.hash || '',
    query: query,
    params: location.params || {},
    fullPath: getFullPath(location, stringifyQuery$$1),
    matched: record ? formatMatch(record) : []
  };
  if (redirectedFrom) {
    route.redirectedFrom = getFullPath(redirectedFrom, stringifyQuery$$1);
  }
  return Object.freeze(route)
}

function clone (value) {
  if (Array.isArray(value)) {
    return value.map(clone)
  } else if (value && typeof value === 'object') {
    var res = {};
    for (var key in value) {
      res[key] = clone(value[key]);
    }
    return res
  } else {
    return value
  }
}

// the starting route that represents the initial state
var START = createRoute(null, {
  path: '/'
});

function formatMatch (record) {
  var res = [];
  while (record) {
    res.unshift(record);
    record = record.parent;
  }
  return res
}

function getFullPath (
  ref,
  _stringifyQuery
) {
  var path = ref.path;
  var query = ref.query; if ( query === void 0 ) query = {};
  var hash = ref.hash; if ( hash === void 0 ) hash = '';

  var stringify = _stringifyQuery || stringifyQuery;
  return (path || '/') + stringify(query) + hash
}

function isSameRoute (a, b) {
  if (b === START) {
    return a === b
  } else if (!b) {
    return false
  } else if (a.path && b.path) {
    return (
      a.path.replace(trailingSlashRE, '') === b.path.replace(trailingSlashRE, '') &&
      a.hash === b.hash &&
      isObjectEqual(a.query, b.query)
    )
  } else if (a.name && b.name) {
    return (
      a.name === b.name &&
      a.hash === b.hash &&
      isObjectEqual(a.query, b.query) &&
      isObjectEqual(a.params, b.params)
    )
  } else {
    return false
  }
}

function isObjectEqual (a, b) {
  if ( a === void 0 ) a = {};
  if ( b === void 0 ) b = {};

  // handle null value #1566
  if (!a || !b) { return a === b }
  var aKeys = Object.keys(a);
  var bKeys = Object.keys(b);
  if (aKeys.length !== bKeys.length) {
    return false
  }
  return aKeys.every(function (key) {
    var aVal = a[key];
    var bVal = b[key];
    // check nested equality
    if (typeof aVal === 'object' && typeof bVal === 'object') {
      return isObjectEqual(aVal, bVal)
    }
    return String(aVal) === String(bVal)
  })
}

function isIncludedRoute (current, target) {
  return (
    current.path.replace(trailingSlashRE, '/').indexOf(
      target.path.replace(trailingSlashRE, '/')
    ) === 0 &&
    (!target.hash || current.hash === target.hash) &&
    queryIncludes(current.query, target.query)
  )
}

function queryIncludes (current, target) {
  for (var key in target) {
    if (!(key in current)) {
      return false
    }
  }
  return true
}

/*  */

// work around weird flow bug
var toTypes = [String, Object];
var eventTypes = [String, Array];

var Link = {
  name: 'router-link',
  props: {
    to: {
      type: toTypes,
      required: true
    },
    tag: {
      type: String,
      default: 'a'
    },
    exact: Boolean,
    append: Boolean,
    replace: Boolean,
    activeClass: String,
    exactActiveClass: String,
    event: {
      type: eventTypes,
      default: 'click'
    }
  },
  render: function render (h) {
    var this$1 = this;

    var router = this.$router;
    var current = this.$route;
    var ref = router.resolve(this.to, current, this.append);
    var location = ref.location;
    var route = ref.route;
    var href = ref.href;

    var classes = {};
    var globalActiveClass = router.options.linkActiveClass;
    var globalExactActiveClass = router.options.linkExactActiveClass;
    // Support global empty active class
    var activeClassFallback = globalActiveClass == null
            ? 'router-link-active'
            : globalActiveClass;
    var exactActiveClassFallback = globalExactActiveClass == null
            ? 'router-link-exact-active'
            : globalExactActiveClass;
    var activeClass = this.activeClass == null
            ? activeClassFallback
            : this.activeClass;
    var exactActiveClass = this.exactActiveClass == null
            ? exactActiveClassFallback
            : this.exactActiveClass;
    var compareTarget = location.path
      ? createRoute(null, location, null, router)
      : route;

    classes[exactActiveClass] = isSameRoute(current, compareTarget);
    classes[activeClass] = this.exact
      ? classes[exactActiveClass]
      : isIncludedRoute(current, compareTarget);

    var handler = function (e) {
      if (guardEvent(e)) {
        if (this$1.replace) {
          router.replace(location);
        } else {
          router.push(location);
        }
      }
    };

    var on = { click: guardEvent };
    if (Array.isArray(this.event)) {
      this.event.forEach(function (e) { on[e] = handler; });
    } else {
      on[this.event] = handler;
    }

    var data = {
      class: classes
    };

    if (this.tag === 'a') {
      data.on = on;
      data.attrs = { href: href };
    } else {
      // find the first <a> child and apply listener and href
      var a = findAnchor(this.$slots.default);
      if (a) {
        // in case the <a> is a static node
        a.isStatic = false;
        var extend = _Vue.util.extend;
        var aData = a.data = extend({}, a.data);
        aData.on = on;
        var aAttrs = a.data.attrs = extend({}, a.data.attrs);
        aAttrs.href = href;
      } else {
        // doesn't have <a> child, apply listener to self
        data.on = on;
      }
    }

    return h(this.tag, data, this.$slots.default)
  }
};

function guardEvent (e) {
  // don't redirect with control keys
  if (e.metaKey || e.altKey || e.ctrlKey || e.shiftKey) { return }
  // don't redirect when preventDefault called
  if (e.defaultPrevented) { return }
  // don't redirect on right click
  if (e.button !== undefined && e.button !== 0) { return }
  // don't redirect if `target="_blank"`
  if (e.currentTarget && e.currentTarget.getAttribute) {
    var target = e.currentTarget.getAttribute('target');
    if (/\b_blank\b/i.test(target)) { return }
  }
  // this may be a Weex event which doesn't have this method
  if (e.preventDefault) {
    e.preventDefault();
  }
  return true
}

function findAnchor (children) {
  if (children) {
    var child;
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      if (child.tag === 'a') {
        return child
      }
      if (child.children && (child = findAnchor(child.children))) {
        return child
      }
    }
  }
}

var _Vue;

function install (Vue) {
  if (install.installed && _Vue === Vue) { return }
  install.installed = true;

  _Vue = Vue;

  var isDef = function (v) { return v !== undefined; };

  var registerInstance = function (vm, callVal) {
    var i = vm.$options._parentVnode;
    if (isDef(i) && isDef(i = i.data) && isDef(i = i.registerRouteInstance)) {
      i(vm, callVal);
    }
  };

  Vue.mixin({
    beforeCreate: function beforeCreate () {
      if (isDef(this.$options.router)) {
        this._routerRoot = this;
        this._router = this.$options.router;
        this._router.init(this);
        Vue.util.defineReactive(this, '_route', this._router.history.current);
      } else {
        this._routerRoot = (this.$parent && this.$parent._routerRoot) || this;
      }
      registerInstance(this, this);
    },
    destroyed: function destroyed () {
      registerInstance(this);
    }
  });

  Object.defineProperty(Vue.prototype, '$router', {
    get: function get () { return this._routerRoot._router }
  });

  Object.defineProperty(Vue.prototype, '$route', {
    get: function get () { return this._routerRoot._route }
  });

  Vue.component('router-view', View);
  Vue.component('router-link', Link);

  var strats = Vue.config.optionMergeStrategies;
  // use the same hook merging strategy for route hooks
  strats.beforeRouteEnter = strats.beforeRouteLeave = strats.beforeRouteUpdate = strats.created;
}

/*  */

var inBrowser = typeof window !== 'undefined';

/*  */

function resolvePath (
  relative,
  base,
  append
) {
  var firstChar = relative.charAt(0);
  if (firstChar === '/') {
    return relative
  }

  if (firstChar === '?' || firstChar === '#') {
    return base + relative
  }

  var stack = base.split('/');

  // remove trailing segment if:
  // - not appending
  // - appending to trailing slash (last segment is empty)
  if (!append || !stack[stack.length - 1]) {
    stack.pop();
  }

  // resolve relative path
  var segments = relative.replace(/^\//, '').split('/');
  for (var i = 0; i < segments.length; i++) {
    var segment = segments[i];
    if (segment === '..') {
      stack.pop();
    } else if (segment !== '.') {
      stack.push(segment);
    }
  }

  // ensure leading slash
  if (stack[0] !== '') {
    stack.unshift('');
  }

  return stack.join('/')
}

function parsePath (path) {
  var hash = '';
  var query = '';

  var hashIndex = path.indexOf('#');
  if (hashIndex >= 0) {
    hash = path.slice(hashIndex);
    path = path.slice(0, hashIndex);
  }

  var queryIndex = path.indexOf('?');
  if (queryIndex >= 0) {
    query = path.slice(queryIndex + 1);
    path = path.slice(0, queryIndex);
  }

  return {
    path: path,
    query: query,
    hash: hash
  }
}

function cleanPath (path) {
  return path.replace(/\/\//g, '/')
}

var isarray = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};

/**
 * Expose `pathToRegexp`.
 */
var pathToRegexp_1 = pathToRegexp;
var parse_1 = parse;
var compile_1 = compile;
var tokensToFunction_1 = tokensToFunction;
var tokensToRegExp_1 = tokensToRegExp;

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g');

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = [];
  var key = 0;
  var index = 0;
  var path = '';
  var defaultDelimiter = options && options.delimiter || '/';
  var res;

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0];
    var escaped = res[1];
    var offset = res.index;
    path += str.slice(index, offset);
    index = offset + m.length;

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1];
      continue
    }

    var next = str[index];
    var prefix = res[2];
    var name = res[3];
    var capture = res[4];
    var group = res[5];
    var modifier = res[6];
    var asterisk = res[7];

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path);
      path = '';
    }

    var partial = prefix != null && next != null && next !== prefix;
    var repeat = modifier === '+' || modifier === '*';
    var optional = modifier === '?' || modifier === '*';
    var delimiter = res[2] || defaultDelimiter;
    var pattern = capture || group;

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    });
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index);
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path);
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options))
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length);

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$');
    }
  }

  return function (obj, opts) {
    var path = '';
    var data = obj || {};
    var options = opts || {};
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent;

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i];

      if (typeof token === 'string') {
        path += token;

        continue
      }

      var value = data[token.name];
      var segment;

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix;
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j]);

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment;
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value);

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment;
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys;
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g);

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      });
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = [];

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source);
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options));

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options);
    keys = [];
  }

  options = options || {};

  var strict = options.strict;
  var end = options.end !== false;
  var route = '';

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i];

    if (typeof token === 'string') {
      route += escapeString(token);
    } else {
      var prefix = escapeString(token.prefix);
      var capture = '(?:' + token.pattern + ')';

      keys.push(token);

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*';
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?';
        } else {
          capture = prefix + '(' + capture + ')?';
        }
      } else {
        capture = prefix + '(' + capture + ')';
      }

      route += capture;
    }
  }

  var delimiter = escapeString(options.delimiter || '/');
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?';
  }

  if (end) {
    route += '$';
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)';
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options);
    keys = [];
  }

  options = options || {};

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}

pathToRegexp_1.parse = parse_1;
pathToRegexp_1.compile = compile_1;
pathToRegexp_1.tokensToFunction = tokensToFunction_1;
pathToRegexp_1.tokensToRegExp = tokensToRegExp_1;

/*  */

// $flow-disable-line
var regexpCompileCache = Object.create(null);

function fillParams (
  path,
  params,
  routeMsg
) {
  try {
    var filler =
      regexpCompileCache[path] ||
      (regexpCompileCache[path] = pathToRegexp_1.compile(path));
    return filler(params || {}, { pretty: true })
  } catch (e) {
    if (false) {
      warn(false, ("missing param for " + routeMsg + ": " + (e.message)));
    }
    return ''
  }
}

/*  */

function createRouteMap (
  routes,
  oldPathList,
  oldPathMap,
  oldNameMap
) {
  // the path list is used to control path matching priority
  var pathList = oldPathList || [];
  // $flow-disable-line
  var pathMap = oldPathMap || Object.create(null);
  // $flow-disable-line
  var nameMap = oldNameMap || Object.create(null);

  routes.forEach(function (route) {
    addRouteRecord(pathList, pathMap, nameMap, route);
  });

  // ensure wildcard routes are always at the end
  for (var i = 0, l = pathList.length; i < l; i++) {
    if (pathList[i] === '*') {
      pathList.push(pathList.splice(i, 1)[0]);
      l--;
      i--;
    }
  }

  return {
    pathList: pathList,
    pathMap: pathMap,
    nameMap: nameMap
  }
}

function addRouteRecord (
  pathList,
  pathMap,
  nameMap,
  route,
  parent,
  matchAs
) {
  var path = route.path;
  var name = route.name;
  if (false) {
    assert(path != null, "\"path\" is required in a route configuration.");
    assert(
      typeof route.component !== 'string',
      "route config \"component\" for path: " + (String(path || name)) + " cannot be a " +
      "string id. Use an actual component instead."
    );
  }

  var pathToRegexpOptions = route.pathToRegexpOptions || {};
  var normalizedPath = normalizePath(
    path,
    parent,
    pathToRegexpOptions.strict
  );

  if (typeof route.caseSensitive === 'boolean') {
    pathToRegexpOptions.sensitive = route.caseSensitive;
  }

  var record = {
    path: normalizedPath,
    regex: compileRouteRegex(normalizedPath, pathToRegexpOptions),
    components: route.components || { default: route.component },
    instances: {},
    name: name,
    parent: parent,
    matchAs: matchAs,
    redirect: route.redirect,
    beforeEnter: route.beforeEnter,
    meta: route.meta || {},
    props: route.props == null
      ? {}
      : route.components
        ? route.props
        : { default: route.props }
  };

  if (route.children) {
    // Warn if route is named, does not redirect and has a default child route.
    // If users navigate to this route by name, the default child will
    // not be rendered (GH Issue #629)
    if (false) {
      if (route.name && !route.redirect && route.children.some(function (child) { return /^\/?$/.test(child.path); })) {
        warn(
          false,
          "Named Route '" + (route.name) + "' has a default child route. " +
          "When navigating to this named route (:to=\"{name: '" + (route.name) + "'\"), " +
          "the default child route will not be rendered. Remove the name from " +
          "this route and use the name of the default child route for named " +
          "links instead."
        );
      }
    }
    route.children.forEach(function (child) {
      var childMatchAs = matchAs
        ? cleanPath((matchAs + "/" + (child.path)))
        : undefined;
      addRouteRecord(pathList, pathMap, nameMap, child, record, childMatchAs);
    });
  }

  if (route.alias !== undefined) {
    var aliases = Array.isArray(route.alias)
      ? route.alias
      : [route.alias];

    aliases.forEach(function (alias) {
      var aliasRoute = {
        path: alias,
        children: route.children
      };
      addRouteRecord(
        pathList,
        pathMap,
        nameMap,
        aliasRoute,
        parent,
        record.path || '/' // matchAs
      );
    });
  }

  if (!pathMap[record.path]) {
    pathList.push(record.path);
    pathMap[record.path] = record;
  }

  if (name) {
    if (!nameMap[name]) {
      nameMap[name] = record;
    } else if (false) {
      warn(
        false,
        "Duplicate named routes definition: " +
        "{ name: \"" + name + "\", path: \"" + (record.path) + "\" }"
      );
    }
  }
}

function compileRouteRegex (path, pathToRegexpOptions) {
  var regex = pathToRegexp_1(path, [], pathToRegexpOptions);
  if (false) {
    var keys = Object.create(null);
    regex.keys.forEach(function (key) {
      warn(!keys[key.name], ("Duplicate param keys in route with path: \"" + path + "\""));
      keys[key.name] = true;
    });
  }
  return regex
}

function normalizePath (path, parent, strict) {
  if (!strict) { path = path.replace(/\/$/, ''); }
  if (path[0] === '/') { return path }
  if (parent == null) { return path }
  return cleanPath(((parent.path) + "/" + path))
}

/*  */


function normalizeLocation (
  raw,
  current,
  append,
  router
) {
  var next = typeof raw === 'string' ? { path: raw } : raw;
  // named target
  if (next.name || next._normalized) {
    return next
  }

  // relative params
  if (!next.path && next.params && current) {
    next = assign({}, next);
    next._normalized = true;
    var params = assign(assign({}, current.params), next.params);
    if (current.name) {
      next.name = current.name;
      next.params = params;
    } else if (current.matched.length) {
      var rawPath = current.matched[current.matched.length - 1].path;
      next.path = fillParams(rawPath, params, ("path " + (current.path)));
    } else if (false) {
      warn(false, "relative params navigation requires a current route.");
    }
    return next
  }

  var parsedPath = parsePath(next.path || '');
  var basePath = (current && current.path) || '/';
  var path = parsedPath.path
    ? resolvePath(parsedPath.path, basePath, append || next.append)
    : basePath;

  var query = resolveQuery(
    parsedPath.query,
    next.query,
    router && router.options.parseQuery
  );

  var hash = next.hash || parsedPath.hash;
  if (hash && hash.charAt(0) !== '#') {
    hash = "#" + hash;
  }

  return {
    _normalized: true,
    path: path,
    query: query,
    hash: hash
  }
}

function assign (a, b) {
  for (var key in b) {
    a[key] = b[key];
  }
  return a
}

/*  */


function createMatcher (
  routes,
  router
) {
  var ref = createRouteMap(routes);
  var pathList = ref.pathList;
  var pathMap = ref.pathMap;
  var nameMap = ref.nameMap;

  function addRoutes (routes) {
    createRouteMap(routes, pathList, pathMap, nameMap);
  }

  function match (
    raw,
    currentRoute,
    redirectedFrom
  ) {
    var location = normalizeLocation(raw, currentRoute, false, router);
    var name = location.name;

    if (name) {
      var record = nameMap[name];
      if (false) {
        warn(record, ("Route with name '" + name + "' does not exist"));
      }
      if (!record) { return _createRoute(null, location) }
      var paramNames = record.regex.keys
        .filter(function (key) { return !key.optional; })
        .map(function (key) { return key.name; });

      if (typeof location.params !== 'object') {
        location.params = {};
      }

      if (currentRoute && typeof currentRoute.params === 'object') {
        for (var key in currentRoute.params) {
          if (!(key in location.params) && paramNames.indexOf(key) > -1) {
            location.params[key] = currentRoute.params[key];
          }
        }
      }

      if (record) {
        location.path = fillParams(record.path, location.params, ("named route \"" + name + "\""));
        return _createRoute(record, location, redirectedFrom)
      }
    } else if (location.path) {
      location.params = {};
      for (var i = 0; i < pathList.length; i++) {
        var path = pathList[i];
        var record$1 = pathMap[path];
        if (matchRoute(record$1.regex, location.path, location.params)) {
          return _createRoute(record$1, location, redirectedFrom)
        }
      }
    }
    // no match
    return _createRoute(null, location)
  }

  function redirect (
    record,
    location
  ) {
    var originalRedirect = record.redirect;
    var redirect = typeof originalRedirect === 'function'
        ? originalRedirect(createRoute(record, location, null, router))
        : originalRedirect;

    if (typeof redirect === 'string') {
      redirect = { path: redirect };
    }

    if (!redirect || typeof redirect !== 'object') {
      if (false) {
        warn(
          false, ("invalid redirect option: " + (JSON.stringify(redirect)))
        );
      }
      return _createRoute(null, location)
    }

    var re = redirect;
    var name = re.name;
    var path = re.path;
    var query = location.query;
    var hash = location.hash;
    var params = location.params;
    query = re.hasOwnProperty('query') ? re.query : query;
    hash = re.hasOwnProperty('hash') ? re.hash : hash;
    params = re.hasOwnProperty('params') ? re.params : params;

    if (name) {
      // resolved named direct
      var targetRecord = nameMap[name];
      if (false) {
        assert(targetRecord, ("redirect failed: named route \"" + name + "\" not found."));
      }
      return match({
        _normalized: true,
        name: name,
        query: query,
        hash: hash,
        params: params
      }, undefined, location)
    } else if (path) {
      // 1. resolve relative redirect
      var rawPath = resolveRecordPath(path, record);
      // 2. resolve params
      var resolvedPath = fillParams(rawPath, params, ("redirect route with path \"" + rawPath + "\""));
      // 3. rematch with existing query and hash
      return match({
        _normalized: true,
        path: resolvedPath,
        query: query,
        hash: hash
      }, undefined, location)
    } else {
      if (false) {
        warn(false, ("invalid redirect option: " + (JSON.stringify(redirect))));
      }
      return _createRoute(null, location)
    }
  }

  function alias (
    record,
    location,
    matchAs
  ) {
    var aliasedPath = fillParams(matchAs, location.params, ("aliased route with path \"" + matchAs + "\""));
    var aliasedMatch = match({
      _normalized: true,
      path: aliasedPath
    });
    if (aliasedMatch) {
      var matched = aliasedMatch.matched;
      var aliasedRecord = matched[matched.length - 1];
      location.params = aliasedMatch.params;
      return _createRoute(aliasedRecord, location)
    }
    return _createRoute(null, location)
  }

  function _createRoute (
    record,
    location,
    redirectedFrom
  ) {
    if (record && record.redirect) {
      return redirect(record, redirectedFrom || location)
    }
    if (record && record.matchAs) {
      return alias(record, location, record.matchAs)
    }
    return createRoute(record, location, redirectedFrom, router)
  }

  return {
    match: match,
    addRoutes: addRoutes
  }
}

function matchRoute (
  regex,
  path,
  params
) {
  var m = path.match(regex);

  if (!m) {
    return false
  } else if (!params) {
    return true
  }

  for (var i = 1, len = m.length; i < len; ++i) {
    var key = regex.keys[i - 1];
    var val = typeof m[i] === 'string' ? decodeURIComponent(m[i]) : m[i];
    if (key) {
      params[key.name] = val;
    }
  }

  return true
}

function resolveRecordPath (path, record) {
  return resolvePath(path, record.parent ? record.parent.path : '/', true)
}

/*  */


var positionStore = Object.create(null);

function setupScroll () {
  // Fix for #1585 for Firefox
  window.history.replaceState({ key: getStateKey() }, '');
  window.addEventListener('popstate', function (e) {
    saveScrollPosition();
    if (e.state && e.state.key) {
      setStateKey(e.state.key);
    }
  });
}

function handleScroll (
  router,
  to,
  from,
  isPop
) {
  if (!router.app) {
    return
  }

  var behavior = router.options.scrollBehavior;
  if (!behavior) {
    return
  }

  if (false) {
    assert(typeof behavior === 'function', "scrollBehavior must be a function");
  }

  // wait until re-render finishes before scrolling
  router.app.$nextTick(function () {
    var position = getScrollPosition();
    var shouldScroll = behavior(to, from, isPop ? position : null);

    if (!shouldScroll) {
      return
    }

    if (typeof shouldScroll.then === 'function') {
      shouldScroll.then(function (shouldScroll) {
        scrollToPosition((shouldScroll), position);
      }).catch(function (err) {
        if (false) {
          assert(false, err.toString());
        }
      });
    } else {
      scrollToPosition(shouldScroll, position);
    }
  });
}

function saveScrollPosition () {
  var key = getStateKey();
  if (key) {
    positionStore[key] = {
      x: window.pageXOffset,
      y: window.pageYOffset
    };
  }
}

function getScrollPosition () {
  var key = getStateKey();
  if (key) {
    return positionStore[key]
  }
}

function getElementPosition (el, offset) {
  var docEl = document.documentElement;
  var docRect = docEl.getBoundingClientRect();
  var elRect = el.getBoundingClientRect();
  return {
    x: elRect.left - docRect.left - offset.x,
    y: elRect.top - docRect.top - offset.y
  }
}

function isValidPosition (obj) {
  return isNumber(obj.x) || isNumber(obj.y)
}

function normalizePosition (obj) {
  return {
    x: isNumber(obj.x) ? obj.x : window.pageXOffset,
    y: isNumber(obj.y) ? obj.y : window.pageYOffset
  }
}

function normalizeOffset (obj) {
  return {
    x: isNumber(obj.x) ? obj.x : 0,
    y: isNumber(obj.y) ? obj.y : 0
  }
}

function isNumber (v) {
  return typeof v === 'number'
}

function scrollToPosition (shouldScroll, position) {
  var isObject = typeof shouldScroll === 'object';
  if (isObject && typeof shouldScroll.selector === 'string') {
    var el = document.querySelector(shouldScroll.selector);
    if (el) {
      var offset = shouldScroll.offset && typeof shouldScroll.offset === 'object' ? shouldScroll.offset : {};
      offset = normalizeOffset(offset);
      position = getElementPosition(el, offset);
    } else if (isValidPosition(shouldScroll)) {
      position = normalizePosition(shouldScroll);
    }
  } else if (isObject && isValidPosition(shouldScroll)) {
    position = normalizePosition(shouldScroll);
  }

  if (position) {
    window.scrollTo(position.x, position.y);
  }
}

/*  */

var supportsPushState = inBrowser && (function () {
  var ua = window.navigator.userAgent;

  if (
    (ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) &&
    ua.indexOf('Mobile Safari') !== -1 &&
    ua.indexOf('Chrome') === -1 &&
    ua.indexOf('Windows Phone') === -1
  ) {
    return false
  }

  return window.history && 'pushState' in window.history
})();

// use User Timing api (if present) for more accurate key precision
var Time = inBrowser && window.performance && window.performance.now
  ? window.performance
  : Date;

var _key = genKey();

function genKey () {
  return Time.now().toFixed(3)
}

function getStateKey () {
  return _key
}

function setStateKey (key) {
  _key = key;
}

function pushState (url, replace) {
  saveScrollPosition();
  // try...catch the pushState call to get around Safari
  // DOM Exception 18 where it limits to 100 pushState calls
  var history = window.history;
  try {
    if (replace) {
      history.replaceState({ key: _key }, '', url);
    } else {
      _key = genKey();
      history.pushState({ key: _key }, '', url);
    }
  } catch (e) {
    window.location[replace ? 'replace' : 'assign'](url);
  }
}

function replaceState (url) {
  pushState(url, true);
}

/*  */

function runQueue (queue, fn, cb) {
  var step = function (index) {
    if (index >= queue.length) {
      cb();
    } else {
      if (queue[index]) {
        fn(queue[index], function () {
          step(index + 1);
        });
      } else {
        step(index + 1);
      }
    }
  };
  step(0);
}

/*  */

function resolveAsyncComponents (matched) {
  return function (to, from, next) {
    var hasAsync = false;
    var pending = 0;
    var error = null;

    flatMapComponents(matched, function (def, _, match, key) {
      // if it's a function and doesn't have cid attached,
      // assume it's an async component resolve function.
      // we are not using Vue's default async resolving mechanism because
      // we want to halt the navigation until the incoming component has been
      // resolved.
      if (typeof def === 'function' && def.cid === undefined) {
        hasAsync = true;
        pending++;

        var resolve = once(function (resolvedDef) {
          if (isESModule(resolvedDef)) {
            resolvedDef = resolvedDef.default;
          }
          // save resolved on async factory in case it's used elsewhere
          def.resolved = typeof resolvedDef === 'function'
            ? resolvedDef
            : _Vue.extend(resolvedDef);
          match.components[key] = resolvedDef;
          pending--;
          if (pending <= 0) {
            next();
          }
        });

        var reject = once(function (reason) {
          var msg = "Failed to resolve async component " + key + ": " + reason;
          "production" !== 'production' && warn(false, msg);
          if (!error) {
            error = isError(reason)
              ? reason
              : new Error(msg);
            next(error);
          }
        });

        var res;
        try {
          res = def(resolve, reject);
        } catch (e) {
          reject(e);
        }
        if (res) {
          if (typeof res.then === 'function') {
            res.then(resolve, reject);
          } else {
            // new syntax in Vue 2.3
            var comp = res.component;
            if (comp && typeof comp.then === 'function') {
              comp.then(resolve, reject);
            }
          }
        }
      }
    });

    if (!hasAsync) { next(); }
  }
}

function flatMapComponents (
  matched,
  fn
) {
  return flatten(matched.map(function (m) {
    return Object.keys(m.components).map(function (key) { return fn(
      m.components[key],
      m.instances[key],
      m, key
    ); })
  }))
}

function flatten (arr) {
  return Array.prototype.concat.apply([], arr)
}

var hasSymbol =
  typeof Symbol === 'function' &&
  typeof Symbol.toStringTag === 'symbol';

function isESModule (obj) {
  return obj.__esModule || (hasSymbol && obj[Symbol.toStringTag] === 'Module')
}

// in Webpack 2, require.ensure now also returns a Promise
// so the resolve/reject functions may get called an extra time
// if the user uses an arrow function shorthand that happens to
// return that Promise.
function once (fn) {
  var called = false;
  return function () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    if (called) { return }
    called = true;
    return fn.apply(this, args)
  }
}

/*  */

var History = function History (router, base) {
  this.router = router;
  this.base = normalizeBase(base);
  // start with a route object that stands for "nowhere"
  this.current = START;
  this.pending = null;
  this.ready = false;
  this.readyCbs = [];
  this.readyErrorCbs = [];
  this.errorCbs = [];
};

History.prototype.listen = function listen (cb) {
  this.cb = cb;
};

History.prototype.onReady = function onReady (cb, errorCb) {
  if (this.ready) {
    cb();
  } else {
    this.readyCbs.push(cb);
    if (errorCb) {
      this.readyErrorCbs.push(errorCb);
    }
  }
};

History.prototype.onError = function onError (errorCb) {
  this.errorCbs.push(errorCb);
};

History.prototype.transitionTo = function transitionTo (location, onComplete, onAbort) {
    var this$1 = this;

  var route = this.router.match(location, this.current);
  this.confirmTransition(route, function () {
    this$1.updateRoute(route);
    onComplete && onComplete(route);
    this$1.ensureURL();

    // fire ready cbs once
    if (!this$1.ready) {
      this$1.ready = true;
      this$1.readyCbs.forEach(function (cb) { cb(route); });
    }
  }, function (err) {
    if (onAbort) {
      onAbort(err);
    }
    if (err && !this$1.ready) {
      this$1.ready = true;
      this$1.readyErrorCbs.forEach(function (cb) { cb(err); });
    }
  });
};

History.prototype.confirmTransition = function confirmTransition (route, onComplete, onAbort) {
    var this$1 = this;

  var current = this.current;
  var abort = function (err) {
    if (isError(err)) {
      if (this$1.errorCbs.length) {
        this$1.errorCbs.forEach(function (cb) { cb(err); });
      } else {
        warn(false, 'uncaught error during route navigation:');
        console.error(err);
      }
    }
    onAbort && onAbort(err);
  };
  if (
    isSameRoute(route, current) &&
    // in the case the route map has been dynamically appended to
    route.matched.length === current.matched.length
  ) {
    this.ensureURL();
    return abort()
  }

  var ref = resolveQueue(this.current.matched, route.matched);
    var updated = ref.updated;
    var deactivated = ref.deactivated;
    var activated = ref.activated;

  var queue = [].concat(
    // in-component leave guards
    extractLeaveGuards(deactivated),
    // global before hooks
    this.router.beforeHooks,
    // in-component update hooks
    extractUpdateHooks(updated),
    // in-config enter guards
    activated.map(function (m) { return m.beforeEnter; }),
    // async components
    resolveAsyncComponents(activated)
  );

  this.pending = route;
  var iterator = function (hook, next) {
    if (this$1.pending !== route) {
      return abort()
    }
    try {
      hook(route, current, function (to) {
        if (to === false || isError(to)) {
          // next(false) -> abort navigation, ensure current URL
          this$1.ensureURL(true);
          abort(to);
        } else if (
          typeof to === 'string' ||
          (typeof to === 'object' && (
            typeof to.path === 'string' ||
            typeof to.name === 'string'
          ))
        ) {
          // next('/') or next({ path: '/' }) -> redirect
          abort();
          if (typeof to === 'object' && to.replace) {
            this$1.replace(to);
          } else {
            this$1.push(to);
          }
        } else {
          // confirm transition and pass on the value
          next(to);
        }
      });
    } catch (e) {
      abort(e);
    }
  };

  runQueue(queue, iterator, function () {
    var postEnterCbs = [];
    var isValid = function () { return this$1.current === route; };
    // wait until async components are resolved before
    // extracting in-component enter guards
    var enterGuards = extractEnterGuards(activated, postEnterCbs, isValid);
    var queue = enterGuards.concat(this$1.router.resolveHooks);
    runQueue(queue, iterator, function () {
      if (this$1.pending !== route) {
        return abort()
      }
      this$1.pending = null;
      onComplete(route);
      if (this$1.router.app) {
        this$1.router.app.$nextTick(function () {
          postEnterCbs.forEach(function (cb) { cb(); });
        });
      }
    });
  });
};

History.prototype.updateRoute = function updateRoute (route) {
  var prev = this.current;
  this.current = route;
  this.cb && this.cb(route);
  this.router.afterHooks.forEach(function (hook) {
    hook && hook(route, prev);
  });
};

function normalizeBase (base) {
  if (!base) {
    if (inBrowser) {
      // respect <base> tag
      var baseEl = document.querySelector('base');
      base = (baseEl && baseEl.getAttribute('href')) || '/';
      // strip full URL origin
      base = base.replace(/^https?:\/\/[^\/]+/, '');
    } else {
      base = '/';
    }
  }
  // make sure there's the starting slash
  if (base.charAt(0) !== '/') {
    base = '/' + base;
  }
  // remove trailing slash
  return base.replace(/\/$/, '')
}

function resolveQueue (
  current,
  next
) {
  var i;
  var max = Math.max(current.length, next.length);
  for (i = 0; i < max; i++) {
    if (current[i] !== next[i]) {
      break
    }
  }
  return {
    updated: next.slice(0, i),
    activated: next.slice(i),
    deactivated: current.slice(i)
  }
}

function extractGuards (
  records,
  name,
  bind,
  reverse
) {
  var guards = flatMapComponents(records, function (def, instance, match, key) {
    var guard = extractGuard(def, name);
    if (guard) {
      return Array.isArray(guard)
        ? guard.map(function (guard) { return bind(guard, instance, match, key); })
        : bind(guard, instance, match, key)
    }
  });
  return flatten(reverse ? guards.reverse() : guards)
}

function extractGuard (
  def,
  key
) {
  if (typeof def !== 'function') {
    // extend now so that global mixins are applied.
    def = _Vue.extend(def);
  }
  return def.options[key]
}

function extractLeaveGuards (deactivated) {
  return extractGuards(deactivated, 'beforeRouteLeave', bindGuard, true)
}

function extractUpdateHooks (updated) {
  return extractGuards(updated, 'beforeRouteUpdate', bindGuard)
}

function bindGuard (guard, instance) {
  if (instance) {
    return function boundRouteGuard () {
      return guard.apply(instance, arguments)
    }
  }
}

function extractEnterGuards (
  activated,
  cbs,
  isValid
) {
  return extractGuards(activated, 'beforeRouteEnter', function (guard, _, match, key) {
    return bindEnterGuard(guard, match, key, cbs, isValid)
  })
}

function bindEnterGuard (
  guard,
  match,
  key,
  cbs,
  isValid
) {
  return function routeEnterGuard (to, from, next) {
    return guard(to, from, function (cb) {
      next(cb);
      if (typeof cb === 'function') {
        cbs.push(function () {
          // #750
          // if a router-view is wrapped with an out-in transition,
          // the instance may not have been registered at this time.
          // we will need to poll for registration until current route
          // is no longer valid.
          poll(cb, match.instances, key, isValid);
        });
      }
    })
  }
}

function poll (
  cb, // somehow flow cannot infer this is a function
  instances,
  key,
  isValid
) {
  if (instances[key]) {
    cb(instances[key]);
  } else if (isValid()) {
    setTimeout(function () {
      poll(cb, instances, key, isValid);
    }, 16);
  }
}

/*  */


var HTML5History = (function (History$$1) {
  function HTML5History (router, base) {
    var this$1 = this;

    History$$1.call(this, router, base);

    var expectScroll = router.options.scrollBehavior;

    if (expectScroll) {
      setupScroll();
    }

    var initLocation = getLocation(this.base);
    window.addEventListener('popstate', function (e) {
      var current = this$1.current;

      // Avoiding first `popstate` event dispatched in some browsers but first
      // history route not updated since async guard at the same time.
      var location = getLocation(this$1.base);
      if (this$1.current === START && location === initLocation) {
        return
      }

      this$1.transitionTo(location, function (route) {
        if (expectScroll) {
          handleScroll(router, route, current, true);
        }
      });
    });
  }

  if ( History$$1 ) HTML5History.__proto__ = History$$1;
  HTML5History.prototype = Object.create( History$$1 && History$$1.prototype );
  HTML5History.prototype.constructor = HTML5History;

  HTML5History.prototype.go = function go (n) {
    window.history.go(n);
  };

  HTML5History.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      pushState(cleanPath(this$1.base + route.fullPath));
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HTML5History.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      replaceState(cleanPath(this$1.base + route.fullPath));
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HTML5History.prototype.ensureURL = function ensureURL (push) {
    if (getLocation(this.base) !== this.current.fullPath) {
      var current = cleanPath(this.base + this.current.fullPath);
      push ? pushState(current) : replaceState(current);
    }
  };

  HTML5History.prototype.getCurrentLocation = function getCurrentLocation () {
    return getLocation(this.base)
  };

  return HTML5History;
}(History));

function getLocation (base) {
  var path = window.location.pathname;
  if (base && path.indexOf(base) === 0) {
    path = path.slice(base.length);
  }
  return (path || '/') + window.location.search + window.location.hash
}

/*  */


var HashHistory = (function (History$$1) {
  function HashHistory (router, base, fallback) {
    History$$1.call(this, router, base);
    // check history fallback deeplinking
    if (fallback && checkFallback(this.base)) {
      return
    }
    ensureSlash();
  }

  if ( History$$1 ) HashHistory.__proto__ = History$$1;
  HashHistory.prototype = Object.create( History$$1 && History$$1.prototype );
  HashHistory.prototype.constructor = HashHistory;

  // this is delayed until the app mounts
  // to avoid the hashchange listener being fired too early
  HashHistory.prototype.setupListeners = function setupListeners () {
    var this$1 = this;

    var router = this.router;
    var expectScroll = router.options.scrollBehavior;
    var supportsScroll = supportsPushState && expectScroll;

    if (supportsScroll) {
      setupScroll();
    }

    window.addEventListener(supportsPushState ? 'popstate' : 'hashchange', function () {
      var current = this$1.current;
      if (!ensureSlash()) {
        return
      }
      this$1.transitionTo(getHash(), function (route) {
        if (supportsScroll) {
          handleScroll(this$1.router, route, current, true);
        }
        if (!supportsPushState) {
          replaceHash(route.fullPath);
        }
      });
    });
  };

  HashHistory.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      pushHash(route.fullPath);
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HashHistory.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      replaceHash(route.fullPath);
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HashHistory.prototype.go = function go (n) {
    window.history.go(n);
  };

  HashHistory.prototype.ensureURL = function ensureURL (push) {
    var current = this.current.fullPath;
    if (getHash() !== current) {
      push ? pushHash(current) : replaceHash(current);
    }
  };

  HashHistory.prototype.getCurrentLocation = function getCurrentLocation () {
    return getHash()
  };

  return HashHistory;
}(History));

function checkFallback (base) {
  var location = getLocation(base);
  if (!/^\/#/.test(location)) {
    window.location.replace(
      cleanPath(base + '/#' + location)
    );
    return true
  }
}

function ensureSlash () {
  var path = getHash();
  if (path.charAt(0) === '/') {
    return true
  }
  replaceHash('/' + path);
  return false
}

function getHash () {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var index = href.indexOf('#');
  return index === -1 ? '' : href.slice(index + 1)
}

function getUrl (path) {
  var href = window.location.href;
  var i = href.indexOf('#');
  var base = i >= 0 ? href.slice(0, i) : href;
  return (base + "#" + path)
}

function pushHash (path) {
  if (supportsPushState) {
    pushState(getUrl(path));
  } else {
    window.location.hash = path;
  }
}

function replaceHash (path) {
  if (supportsPushState) {
    replaceState(getUrl(path));
  } else {
    window.location.replace(getUrl(path));
  }
}

/*  */


var AbstractHistory = (function (History$$1) {
  function AbstractHistory (router, base) {
    History$$1.call(this, router, base);
    this.stack = [];
    this.index = -1;
  }

  if ( History$$1 ) AbstractHistory.__proto__ = History$$1;
  AbstractHistory.prototype = Object.create( History$$1 && History$$1.prototype );
  AbstractHistory.prototype.constructor = AbstractHistory;

  AbstractHistory.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    this.transitionTo(location, function (route) {
      this$1.stack = this$1.stack.slice(0, this$1.index + 1).concat(route);
      this$1.index++;
      onComplete && onComplete(route);
    }, onAbort);
  };

  AbstractHistory.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    this.transitionTo(location, function (route) {
      this$1.stack = this$1.stack.slice(0, this$1.index).concat(route);
      onComplete && onComplete(route);
    }, onAbort);
  };

  AbstractHistory.prototype.go = function go (n) {
    var this$1 = this;

    var targetIndex = this.index + n;
    if (targetIndex < 0 || targetIndex >= this.stack.length) {
      return
    }
    var route = this.stack[targetIndex];
    this.confirmTransition(route, function () {
      this$1.index = targetIndex;
      this$1.updateRoute(route);
    });
  };

  AbstractHistory.prototype.getCurrentLocation = function getCurrentLocation () {
    var current = this.stack[this.stack.length - 1];
    return current ? current.fullPath : '/'
  };

  AbstractHistory.prototype.ensureURL = function ensureURL () {
    // noop
  };

  return AbstractHistory;
}(History));

/*  */

var VueRouter = function VueRouter (options) {
  if ( options === void 0 ) options = {};

  this.app = null;
  this.apps = [];
  this.options = options;
  this.beforeHooks = [];
  this.resolveHooks = [];
  this.afterHooks = [];
  this.matcher = createMatcher(options.routes || [], this);

  var mode = options.mode || 'hash';
  this.fallback = mode === 'history' && !supportsPushState && options.fallback !== false;
  if (this.fallback) {
    mode = 'hash';
  }
  if (!inBrowser) {
    mode = 'abstract';
  }
  this.mode = mode;

  switch (mode) {
    case 'history':
      this.history = new HTML5History(this, options.base);
      break
    case 'hash':
      this.history = new HashHistory(this, options.base, this.fallback);
      break
    case 'abstract':
      this.history = new AbstractHistory(this, options.base);
      break
    default:
      if (false) {
        assert(false, ("invalid mode: " + mode));
      }
  }
};

var prototypeAccessors = { currentRoute: { configurable: true } };

VueRouter.prototype.match = function match (
  raw,
  current,
  redirectedFrom
) {
  return this.matcher.match(raw, current, redirectedFrom)
};

prototypeAccessors.currentRoute.get = function () {
  return this.history && this.history.current
};

VueRouter.prototype.init = function init (app /* Vue component instance */) {
    var this$1 = this;

  "production" !== 'production' && assert(
    install.installed,
    "not installed. Make sure to call `Vue.use(VueRouter)` " +
    "before creating root instance."
  );

  this.apps.push(app);

  // main app already initialized.
  if (this.app) {
    return
  }

  this.app = app;

  var history = this.history;

  if (history instanceof HTML5History) {
    history.transitionTo(history.getCurrentLocation());
  } else if (history instanceof HashHistory) {
    var setupHashListener = function () {
      history.setupListeners();
    };
    history.transitionTo(
      history.getCurrentLocation(),
      setupHashListener,
      setupHashListener
    );
  }

  history.listen(function (route) {
    this$1.apps.forEach(function (app) {
      app._route = route;
    });
  });
};

VueRouter.prototype.beforeEach = function beforeEach (fn) {
  return registerHook(this.beforeHooks, fn)
};

VueRouter.prototype.beforeResolve = function beforeResolve (fn) {
  return registerHook(this.resolveHooks, fn)
};

VueRouter.prototype.afterEach = function afterEach (fn) {
  return registerHook(this.afterHooks, fn)
};

VueRouter.prototype.onReady = function onReady (cb, errorCb) {
  this.history.onReady(cb, errorCb);
};

VueRouter.prototype.onError = function onError (errorCb) {
  this.history.onError(errorCb);
};

VueRouter.prototype.push = function push (location, onComplete, onAbort) {
  this.history.push(location, onComplete, onAbort);
};

VueRouter.prototype.replace = function replace (location, onComplete, onAbort) {
  this.history.replace(location, onComplete, onAbort);
};

VueRouter.prototype.go = function go (n) {
  this.history.go(n);
};

VueRouter.prototype.back = function back () {
  this.go(-1);
};

VueRouter.prototype.forward = function forward () {
  this.go(1);
};

VueRouter.prototype.getMatchedComponents = function getMatchedComponents (to) {
  var route = to
    ? to.matched
      ? to
      : this.resolve(to).route
    : this.currentRoute;
  if (!route) {
    return []
  }
  return [].concat.apply([], route.matched.map(function (m) {
    return Object.keys(m.components).map(function (key) {
      return m.components[key]
    })
  }))
};

VueRouter.prototype.resolve = function resolve (
  to,
  current,
  append
) {
  var location = normalizeLocation(
    to,
    current || this.history.current,
    append,
    this
  );
  var route = this.match(location, current);
  var fullPath = route.redirectedFrom || route.fullPath;
  var base = this.history.base;
  var href = createHref(base, fullPath, this.mode);
  return {
    location: location,
    route: route,
    href: href,
    // for backwards compat
    normalizedTo: location,
    resolved: route
  }
};

VueRouter.prototype.addRoutes = function addRoutes (routes) {
  this.matcher.addRoutes(routes);
  if (this.history.current !== START) {
    this.history.transitionTo(this.history.getCurrentLocation());
  }
};

Object.defineProperties( VueRouter.prototype, prototypeAccessors );

function registerHook (list, fn) {
  list.push(fn);
  return function () {
    var i = list.indexOf(fn);
    if (i > -1) { list.splice(i, 1); }
  }
}

function createHref (base, fullPath, mode) {
  var path = mode === 'hash' ? '#' + fullPath : fullPath;
  return base ? cleanPath(base + '/' + path) : path
}

VueRouter.install = install;
VueRouter.version = '2.8.1';

if (inBrowser && window.Vue) {
  window.Vue.use(VueRouter);
}

/* harmony default export */ __webpack_exports__["a"] = (VueRouter);


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(50),
  /* template */
  __webpack_require__(51),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import Navigation from '@/components/Navigation'
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'home',
  data: function data() {
    return {};
  },

  components: {
    // 'navigation': Navigation
  }
});

/***/ }),
/* 51 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Tony Burke\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('BR'), _c('B', [_vm._v("Tony Burke")]), _vm._v(" is professor of humanities at York University. His academic interests include the study of Christian biographical literature of the second century (infancy gospels), children and the family in Roman antiquity, curses, and noncanonical Jewish and Christian writings.")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/StGuaV/tc-custom/9781467466844.jpg?1730408926764",
      "alt": "This image is the cover for the book New Testament Apocrypha, vol. 3"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("New Testament Apocrypha, vol. 3\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("An expansive compilation of New Testament apocrypha in English translation, featuring fascinating but heretofore unpublished texts. ")]), _c('br'), _vm._v(" "), _c('br'), _c('i', [_vm._v("New Testament Apocrypha, vol. 3")]), _vm._v(", continues to unearth the vast diversity of Christian Scripture outside of the traditional canon. This new collection encompasses a broad range of languages—Greek, Church Slavic, Old English, Coptic, and more—and spans centuries, from the formation of the canonical New Testament to the high Middle Ages.   "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" The selections here represent some of the least studied apocryphal texts, many of which have not previously received an English translation or a critical edition. Notable newly edited and translated selections include "), _c('i', [_vm._v("The Martyrdom of Zechariah, The Decapitation of John the Forerunner, The Birth of John, The Revelation about the Lord’s Prayer, ")]), _vm._v("and "), _c('i', [_vm._v("The Dialogue of Mary and Christ on the Departure of the Soul.")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" Each text is accompanied by a robust introduction, bibliography, and notes. Scholars of apocrypha, Scripture, and hagiography from a breadth of disciplines will find this an indispensable reference for their research and teaching."), _c('br'), _c('br'), _c('b', [_vm._v("Contributors:")])]), _c('p', [_vm._v(" Carson Bay, Mark Glen Bilby, Rick Brannan, Christian H. Bull, Slavomir Čéplö, Alexander D’Alisera, J. Gregory Given, Nathan J. Hardy, Brandon W. Hawk, Stephen C. E. Hopkins, Alexander Kocar, Brent Landau, Jacob A. Lollar, Christine Luckritz Marquis, Ivan Miroshnikov, Tobias Nicklas, Samuel Osborn, Stephen Pelle, Bradley Rice, Julia A. Snyder, Janet E. Spittler, James Toma, Péter Tóth, Sarah Veale, J. Edward Walters, Charles D. Wright, Lorne R. Zelyck ")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Wm. B. Eerdmans Publishing Co.\n   ")])])
}]}

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(53),
  /* template */
  __webpack_require__(54),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 54 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [
    [_c('div', {
      staticClass: "chapter"
    }, [_c('div', {
      staticClass: "inner_page"
    }, [
      [_vm._m(0)]
    ], 2)])]
  ], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(56),
  /* template */
  __webpack_require__(57),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 57 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [
    [_c('div', {
      staticClass: "chapter"
    }, [_c('div', {
      staticClass: "inner_page"
    }, [
      [_vm._m(0)]
    ], 2)])]
  ], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(59),
  /* template */
  __webpack_require__(60),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 60 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [
    [_c('div', {
      staticClass: "chapter"
    }, [_c('div', {
      staticClass: "inner_page"
    }, [
      [_vm._m(0)]
    ], 2)])]
  ], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(62),
  /* template */
  __webpack_require__(63),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 63 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [
    [_c('div', {
      staticClass: "chapter"
    }, [_c('div', {
      staticClass: "inner_page"
    }, [
      [_vm._m(0)]
    ], 2)])]
  ], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(65),
  /* template */
  __webpack_require__(66),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 66 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [
    [_c('div', {
      staticClass: "chapter"
    }, [_c('div', {
      staticClass: "inner_page"
    }, [
      [_vm._m(0)]
    ], 2)])]
  ], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(68),
  /* template */
  __webpack_require__(69),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 69 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ch-title"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "href": "#/006_Preface"
    }
  }, [_vm._v("Preface")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "href": "#/007_Introduction"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-aut"
  }, [_c('a', {
    attrs: {
      "href": "#/007_Introduction"
    }
  }, [_vm._v("Tony Burke")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Abbreviations"
    }
  }, [_vm._v("List of Abbreviations")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-part"
  }, [_c('a', {
    attrs: {
      "href": "#/009_Part01"
    }
  }, [_vm._v("I. GOSPELS AND RELATED TRADITIONS OF NEW TESTAMENT FIGURES")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter01"
    }
  }, [_vm._v("The Hospitality and Perfume of the Bandit")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-aut"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter01"
    }
  }, [_vm._v("Mark Glen Bilby")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "href": "#/011_Chapter02"
    }
  }, [_vm._v("The Gospel of the Twelve Apostles")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-aut"
  }, [_c('a', {
    attrs: {
      "href": "#/011_Chapter02"
    }
  }, [_vm._v("James Toma")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter03"
    }
  }, [_vm._v("The Dialogue between Jesus and the Devil")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-aut"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter03"
    }
  }, [_vm._v("Chance E. Bonar and Slavomír Čéplö")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Story of the Image of Edessa")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-aut"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Nathan J. Hardy")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Dream of the Rood")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-aut"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Alexander D’Alisera and Samuel Osborn")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Eremitic Life of Mary Magdalene")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-aut"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Brandon W. Hawk")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Martyrdom of Zechariah")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-aut"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tony Burke and Sarah Veale")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Decapitation of John the Forerunner")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-aut"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tony Burke")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-part"
  }, [_c('span', {
    attrs: {
      "href": "#/018_Part02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II. APOCRYPHAL ACTS AND RELATED TRADITIONS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/019_Chapter09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Acts of Andrew and Paul")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-aut"
  }, [_c('span', {
    attrs: {
      "href": "#/019_Chapter09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Christian H. Bull and Alexander Kocar")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/020_Chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Acts of Andrew and Philemon")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-aut"
  }, [_c('span', {
    attrs: {
      "href": "#/020_Chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ivan Miroshnikov")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/021_Chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Story of John Meeting Cerinthus")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-aut"
  }, [_c('span', {
    attrs: {
      "href": "#/021_Chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lorne R. Zelyck")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/022_Chapter12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Acts of John in Rome")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-aut"
  }, [_c('span', {
    attrs: {
      "href": "#/022_Chapter12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Janet E. Spittler")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/023_Chapter13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Acts of John by Prochorus")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-aut"
  }, [_c('span', {
    attrs: {
      "href": "#/023_Chapter13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Janet E. Spittler")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/024_Chapter14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Memorial of John")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-aut"
  }, [_c('span', {
    attrs: {
      "href": "#/024_Chapter14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rick Brannan")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/025_Chapter15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Martyrdom of Mark")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-aut"
  }, [_c('span', {
    attrs: {
      "href": "#/025_Chapter15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tobias Nicklas")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/026_Chapter16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The History of Paul")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-aut"
  }, [_c('span', {
    attrs: {
      "href": "#/026_Chapter16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jacob A. Lollar")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/027_Chapter17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Preaching of Simon Cephas in the City of Rome")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-aut"
  }, [_c('span', {
    attrs: {
      "href": "#/027_Chapter17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("J. Edward Walters")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/028_Chapter18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Disputation of Peter and Nero")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-aut"
  }, [_c('span', {
    attrs: {
      "href": "#/028_Chapter18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("J. Edward Walters")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/029_Chapter19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Acts of Christ and Peter in Rome")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-aut"
  }, [_c('span', {
    attrs: {
      "href": "#/029_Chapter19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Julia A. Snyder and Slavomír Čéplö")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/030_Chapter20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Passion of Peter and Paul")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-aut"
  }, [_c('span', {
    attrs: {
      "href": "#/030_Chapter20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Carson Bay")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/031_Chapter21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Preaching of Philip")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-aut"
  }, [_c('span', {
    attrs: {
      "href": "#/031_Chapter21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ivan Miroshnikov")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-part"
  }, [_c('span', {
    attrs: {
      "href": "#/032_Part03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III. EPISTLES")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/033_Chapter22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Correspondence of Ignatius with John the Evangelist and the Virgin Mary")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-aut"
  }, [_c('span', {
    attrs: {
      "href": "#/033_Chapter22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("J. Gregory Given")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/034_Chapter23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Epistle of James to Quadratus")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-aut"
  }, [_c('span', {
    attrs: {
      "href": "#/034_Chapter23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Brent Landau, Bradley Rice, and J. Edward Walters")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/035_Chapter24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Epistles of Longinus, Augustus, Ursinius, and Patrophilus")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-aut"
  }, [_c('span', {
    attrs: {
      "href": "#/035_Chapter24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tony Burke")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-part"
  }, [_c('span', {
    attrs: {
      "href": "#/036_Part04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV. APOCALYPSES")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/037_Chapter25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Revelation about the Lord’s Prayer")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-aut"
  }, [_c('span', {
    attrs: {
      "href": "#/037_Chapter25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Péter Tóth")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/038_Chapter26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Dialogue of Mary and Christ on the Departure of the Soul")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-aut"
  }, [_c('span', {
    attrs: {
      "href": "#/038_Chapter26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Christine Luckritz Marquis")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/039_Chapter27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Questions of John (Interrogatio Iohannis)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-aut"
  }, [_c('span', {
    attrs: {
      "href": "#/039_Chapter27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Stephen C. E. Hopkins")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/040_Chapter28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1 Revelation of Matthew about the End Times")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-aut"
  }, [_c('span', {
    attrs: {
      "href": "#/040_Chapter28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Stephen Pelle")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/041_Chapter29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2 Revelation of Matthew about the End Times")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-aut"
  }, [_c('span', {
    attrs: {
      "href": "#/041_Chapter29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Charles D. Wright and Stephen Pelle")])])])])
}]}

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(71),
  /* template */
  __webpack_require__(72),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 72 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ch-title"
  }, [_vm._v("Preface")]), _vm._v(" "), _c('p', {
    staticClass: "para0"
  }, [_vm._v("The second volume of "), _c('em', [_vm._v("MNTA")]), _vm._v(" was published in the summer of 2020. This third volume was submitted to the publisher a year later. The reason for this speed is that volume 2 had grown so large that five entries had to be removed; I was determined to do right by my contributors and get their work out as quickly as possible. I am thankful for their patience. And I am grateful to the other contributors for completing their work while also dealing with the personal and professional challenges of the Covid-19 pandemic. The pandemic also affected efforts to promote and celebrate volume 2. A review panel scheduled for the meeting of the Canadian Society for Patristic Studies had to be delayed until 2022 (I would like to thank Mona Tokarek LaFosse for planning the session and Ronald Charles and Sean Hannan for participating). A planned session for the annual meeting of the Society of Biblical Literature was transformed into a special issue of "), _c('em', [_vm._v("Ancient Jew Review")]), _vm._v(" (April 2021) featuring articles by four of the contributors to volume 2 (Brandon Hawk, Jonathan Holste, Christine Luckritz Marquis, and J. Edward Walters) and one from volume 3 (Julia Snyder). My thanks to Janet Spittler and Lily Vuong for planning the issue and to Erin Galgay Walsh for working with me to edit the pieces for publication. "), _c('em', [_vm._v("MNTA")]), _vm._v(" 2 also received attention from several podcasts: Benito Cereno and Chris Sims at the podcast "), _c('em', [_vm._v("Apocrypals")]), _vm._v(" devoted three episodes to discussing texts in the volume, Shirley Paulson interviewed me for the "), _c('em', [_vm._v("Early Christian Writings")]), _vm._v(" podcast, and James McGrath interviewed me for his "), _c('em', [_vm._v("Religion Prof")]), _vm._v(" podcast. Finally, Rick Brannan tweeted mini-summaries of each text (as he did for "), _c('em', [_vm._v("MNTA")]), _vm._v(" 1). I am grateful to everyone who engaged with the book, especially in a time when we all have far more pressing concerns.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The original list of texts to be included in the new volume changed a little since its announcement in volume 2. As frequently happens with multiauthor works, some promised contributions do not get completed and others must be found to fill their places. My thanks go to Carson Bay and Rick Brannan for joining the project late in its development and working quickly to meet our deadline.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("As with the other "), _c('em', [_vm._v("MNTA")]), _vm._v(" volumes, several of the contributors worked behind the scenes to assist each other, and the editor, in a variety of ways. I want to acknowledge their contributions and express my gratitude. Jacob Lollar assisted Carson Bay on the "), _c('em', [_vm._v("Passion of Peter and Paul")]), _vm._v(" and Rick Brannan (along with Janet Spittler) on the "), _c('em', [_vm._v("Memorial of John")]), _vm._v("; Ivan Miroshnikov assisted Janet Spittler on the Coptic tradition of the "), _c('em', [_vm._v("Acts of John by Prochorus")]), _vm._v("; James Walters consulted Jacob Lollar on the manuscript tradition of the "), _c('em', [_vm._v("History of Paul")]), _vm._v(", and Jacob took a close look at one of the difficult-to-read manuscripts of the "), _c('em', [_vm._v("Decapitation of John the Forerunner")]), _vm._v(" for me while he was in Paris; Nathan Hardy made some helpful changes to Tobias Nicklas’s translation of the "), _c('em', [_vm._v("Martyrdom of Mark")]), _vm._v("; Slavomír Čéplö checked information on Church Slavic traditions for several of the entries, and Janet Spittler read over my introduction and offered suggestions for improvement. As a team, we are grateful also to a number of non-contributors who shared their expertise: Stephen C. Carlson, David Eastman, Philip Michael Forness, Justin Howell, Jean-Daniel Kaestli, and Andrew Langford.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("To all the contributors, thank you so much for being a part of this project and for your patience with the near-endless requests for changes and clarifications. On a recent podcast Janet Spittler was asked what advice she would give students of early Christianity; she answered “make good friends.” What she meant was that these texts come in such a variety of languages that their study requires the collaboration of colleagues with different skills. But I think too that it is important to work with people who are gracious and supportive. Over the course of producing the three "), _c('em', [_vm._v("MNTA")]), _vm._v(" volumes, I have indeed made good friends.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("A special thank-you goes to Ryan Davis and the staff at Eerdmans, including Andrew Knapp, Jenny Hoffman, and their colleagues.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("And finally, no MNTA volume would be complete without a thank-you to my wife, Laura Cudworth, for her continual support.")])])])
}]}

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(74),
  /* template */
  __webpack_require__(75),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 75 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ch-title0"
  }, [_vm._v("Introduction")]), _vm._v(" "), _c('p', {
    staticClass: "ch-author"
  }, [_vm._v("by Tony Burke")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("When work began on the More New Testament Apocrypha project ("), _c('em', [_vm._v("MNTA")]), _vm._v("), there were no plans for a third volume. Our sister project, More Old Testament Pseudepigrapha ("), _c('em', [_vm._v("MOTP")]), _vm._v("), was contracted for two volumes and revealed the texts planned for volume 2 (still unpublished at this date) in a list appended to the end of the introduction to volume 1. Our publisher expected the same for "), _c('em', [_vm._v("MNTA")]), _vm._v(", but there are so many "), _c('em', [_vm._v("more")]), _vm._v(" apocryphal Christian texts to study that two volumes became three. And there are still even more texts that await publication.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("For readers new to the series, it is worthwhile to repeat its mandate. Both "), _c('em', [_vm._v("MOTP")]), _vm._v(" and "), _c('em', [_vm._v("MNTA")]), _vm._v(" publish English translations of apocryphal texts that have not appeared in previous English compendia or, in some cases, in any scholarly works, ever. Other texts are included that were previously published only once, over a century ago, but new manuscript discoveries have radically changed reconstructions of the texts and offer new insights into how they have been transmitted over time and space. And some additional texts appear either because their original publication is so obscure—buried in a little-known collection or a narrowly circulated journal—that republication in the series brings them back to scholars’ attention, or because they are discussed regularly in cognate disciplines, such as medieval studies or patristics, but not within the context of Christian apocrypha. Earlier English compendia, such as J. K. Elliott’s "), _c('em', [_vm._v("The Apocryphal New Testament")]), _vm._v(" and the English translation of Wilhelm Schneemelcher’s "), _c('em', [_vm._v("New Testament Apocrypha")]), _vm._v(", focus on a certain temporal period—the first three or four centuries, thereby defining apocrypha as texts that could have been included in the New Testament—or contain material that expands our understanding of the development of New Testament texts. But those who study Christian apocrypha today decry the idea that apocryphal texts are only useful for the study of the New Testament; instead they declare that apocrypha are worthy of study in and of themselves. The "), _c('em', [_vm._v("MNTA")]), _vm._v(" and "), _c('em', [_vm._v("MOTP")]), _vm._v(" series, therefore, expand the temporal limit past the fourth century. "), _c('em', [_vm._v("MOTP")]), _vm._v(" closes its canon at the advent of Islam, but "), _c('em', [_vm._v("MNTA")]), _vm._v(" has pushed beyond that limit with texts appearing, at least in their earliest known form, in the late medieval period (eleventh, twelfth centuries). Certainly the scope could be expanded even further to include texts created in the fourteenth century (such as the "), _c('em', [_vm._v("Gospel of Barnabas")]), _vm._v("), or the nineteenth (the "), _c('em', [_vm._v("Life of St. Issa")]), _vm._v("), or even the twenty-first (the "), _c('em', [_vm._v("Gospel of Jesus’ Wife")]), _vm._v("). But perhaps those texts are best left for another project in another time.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The introduction to "), _c('em', [_vm._v("MNTA")]), _vm._v(" 2 includes a list of texts to be included in the current volume. While most of those texts do appear here, five do not: the "), _c('em', [_vm._v("Book of the Rooster")]), _vm._v(", the "), _c('em', [_vm._v("Discovery of John the Baptist’s Head")]), _vm._v(", the "), _c('em', [_vm._v("Dream of Nero")]), _vm._v(", "), _c('em', [_vm._v("On the Star")]), _vm._v(" by Pseudo-Eusebius of Caesarea, and the "), _c('em', [_vm._v("Vision of Theophilus")]), _vm._v(". As often happens with multiauthor projects, some contributors are simply unable to complete their work owing to shifts in professional or personal commitments. For many of us, such commitments were complicated by the impact of the Covid-19 pandemic that began late in 2019. Fortunately for "), _c('em', [_vm._v("MNTA")]), _vm._v(", other contributors came forward to fill the spaces left behind, and the volume has not suffered with the texts’ absence. Of the twenty-nine texts included here, fifteen have not appeared previously in English, six of these not in any modern language at all, and five are based on the contributors’ own (as yet unpublished) critical editions. This last category includes the "), _c('em', [_vm._v("Martyrdom of Zechariah")]), _vm._v(", one of several interrelated Byzantine texts documenting the lives of John the Baptist and his parents. A description of the Church Slavic form of the text appeared in scholarship in 1904, but the Greek text, found in only two manuscripts, is still unpublished; an English translation based on these manuscripts, the first in any language, is presented here. Also included in the volume is the related text the "), _c('em', [_vm._v("Decapitation of John the Forerunner")]), _vm._v(", previously published from one Greek manuscript and in three Church Slavic forms, and here making its English debut in advance of a critical edition based on nine manuscripts. Rounding out the Baptist texts is the brief "), _c('em', [_vm._v("Birth of Holy John the Forerunner")]), _vm._v(", included as an appendix to the "), _c('em', [_vm._v("Decapitation of John")]), _vm._v("; an Arabic version was translated into French, but this is the first English translation of the Greek text, which is known from one unpublished manuscript. These join the "), _c('em', [_vm._v("Life and Martyrdom of John the Baptist")]), _vm._v(", which appeared in "), _c('em', [_vm._v("MNTA")]), _vm._v(" 1, alongside the "), _c('em', [_vm._v("Life of John the Baptist")]), _vm._v(" attributed to Serapion, available today in Arabic but likely composed in Coptic. Two more texts translated from the contributors’ own editions are the "), _c('em', [_vm._v("Revelation about the Lord’s Prayer")]), _vm._v(" and the "), _c('em', [_vm._v("Dialogue of Mary and Christ on the Departure of the Soul")]), _vm._v(". Both are examples of Byzantine "), _c('em', [_vm._v("erōtapokriseis")]), _vm._v(" (question-and-answer texts), a genre examined in "), _c('em', [_vm._v("MNTA")]), _vm._v(" 2 through a range of Johannine apocalyptica. As with the Johannine texts, these new examples of "), _c('em', [_vm._v("erōtapokriseis")]), _vm._v(" demonstrate how musings on such topics as the afterlife and the meaning of the Lord’s Prayer have become “apocryphized” in order to attract a wider audience to the works. Who better to explain the Lord’s Prayer than the Lord himself?")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Several texts from the projected list of contents appear here under different titles, demonstrating how quickly developments occur in the field. The original list includes only one text by the name of "), _c('em', [_vm._v("Revelation of Matthew about the End Times")]), _vm._v(", prepared for "), _c('em', [_vm._v("MNTA")]), _vm._v(" by Stephen Pelle on the basis of earlier work appearing in the journal "), _c('em', [_vm._v("Apocrypha")]), _vm._v(". But a second apocalypse attributed to Matthew came to the attention of Charles D. Wright, and he partnered with Pelle on its first translation into any modern language (which is based on their own forthcoming edition); the inclusion of both texts in the volume necessitated distinguishing them with the numbers “First” and “Second.” And there were other changes made to titles: the "), _c('em', [_vm._v("Acts of Mark")]), _vm._v(" became the more standard "), _c('em', [_vm._v("Martyrdom of Mark")]), _vm._v(" (despite the fact that the text contains more than a martyrdom), the "), _c('em', [_vm._v("Travels of Peter and Christ in Rome")]), _vm._v(" became the "), _c('em', [_vm._v("Acts of Christ and Peter in Rome")]), _vm._v(" (since the protagonists do little traveling in the text), and the "), _c('em', [_vm._v("Interrogatio Iohannis")]), _vm._v(", which has been published under several names, went from the "), _c('em', [_vm._v("Book of John")]), _vm._v(" to the more appropriate "), _c('em', [_vm._v("Questions of John")]), _vm._v(". It is difficult to change titles once texts become established, even when the titles previously assigned by scholars no longer fit their contents. The classic example of this problem is the "), _c('em', [_vm._v("Infancy Gospel of Thomas")]), _vm._v(". Though it has become clear that the text was not originally attributed to Thomas, the title continues to assert a pull on scholarship with attempts to connect the text to Thomas traditions, but abandoning the title at this late date causes more problems than it solves. Multiple works by the same or similar titles are also problematic. Notable in this case is the "), _c('em', [_vm._v("Passion of Peter and Paul")]), _vm._v(", an excerpt from "), _c('em', [_vm._v("On the Destruction of Jerusalem")]), _vm._v(" (also known as Pseudo-Hegesippus) translated into English here for the first time. It is easily confused with several other texts documenting the deaths of the two apostles, including the "), _c('em', [_vm._v("Passion of the Holy Apostles Peter and Paul")]), _vm._v(" attributed to Marcellus. While it is certainly a benefit to have more texts available to readers, the multiplicity of the variant forms complicates their study.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Also firmly established in the field are the divisions of the texts in the volume, reflecting the traditional genres of the New Testament writings: gospels, acts, epistles, and apocalypses. Recent discussions of genres in apocrypha have highlighted their fluidity. While the current volume continues to follow the divisions of its predecessors, many of the texts included here defy easy categorization. The "), _c('em', [_vm._v("Epistles of Longinus, Augustus, Ursinius, and Patrophilus")]), _vm._v(", for example, are a group of “testimonia” texts demonstrating knowledge of Jesus and his early followers by so-called pagan historians and philosophers. Only two of the testimonia are actually epistles, and though it seems they once had independent origins, it would be cumbersome to disperse them throughout the volume. Since they deal with events in the life of Jesus, the testimonia could be placed among the gospel texts, but it seemed best to follow the lead of the title that has been assigned to them in previous scholarship and include them under “Epistles.” A similar challenge presented itself in volume 2 with the "), _c('em', [_vm._v("Epistle of Pelagia")]), _vm._v(", which was placed among epistles even though its content is more appropriate for acts. Another text that combines genres is the "), _c('em', [_vm._v("Acts of Christ and Peter in Rome")]), _vm._v(", presented here in its first English translation, from Greek and Church Slavic. The text resembles apocryphal acts in that it presents tales of Peter after the ascension of Jesus, but it also has connections with infancy gospels in its portrayal of Christ, who is here disguised as a child, performing miracles in stories with parallels to the "), _c('em', [_vm._v("Infancy Gospel of Thomas")]), _vm._v(". The decision to place “Christ” in the title is intended as an indication that the text is a departure from other apocryphal acts where Jesus chiefly appears in the commission scenes and then departs, leaving the apostle to wander the world alone save for the occasional descent from the heavens to perform a miracle. Lastly, the "), _c('em', [_vm._v("Gospel of the Twelve Apostles")]), _vm._v(", making its first appearance in an English apocrypha compendium, begins with an account of the nativity, ministry, and resurrection of Jesus harmonized from the New Testament Gospels. The apocryphal content comes later. After a commissioning narrative, three visions (apocalypses) are revealed to John, James, and Peter. The unwieldy title originally assigned to the text—the "), _c('em', [_vm._v("Gospel of the Twelve and Apocalypses of Each of Them")]), _vm._v("—highlights its composite nature, but the choice was made to shorten the title and assign it to the corresponding category.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Several other texts in the volume are difficult to assign to any of the usual categories. The "), _c('em', [_vm._v("Dream of the Rood")]), _vm._v(" is a poem about Jesus’s passion but features few apocryphal traditions; still, it has interesting thematic connections with the "), _c('em', [_vm._v("Legend of the Holy Rood Tree")]), _vm._v(" featured in "), _c('em', [_vm._v("MNTA")]), _vm._v(" 2, as well as several “talking cross” texts, including the "), _c('em', [_vm._v("Gospel of Peter")]), _vm._v(" and the "), _c('em', [_vm._v("Berlin-Strasbourg Apocryphon")]), _vm._v(". Similarly, the "), _c('em', [_vm._v("Story of the Image of Edessa")]), _vm._v(" incorporates the apocryphal Abgar Correspondence but for the most part focuses on the transmission of the relic in subsequent centuries. No doubt the text is useful for the study of the correspondence, but it does strain the limits of the definition of apocrypha. Then there is the Story of John Meeting Cerinthus. Like the Story of John and the Robber and the Death of Judas (both from "), _c('em', [_vm._v("MNTA")]), _vm._v(" 1), this is an apocryphal tale of an apostle transmitted by an orthodox writer—in this case Irenaeus, but his account is copied by several later writers. Does its use by Irenaeus make the story historical rather than apocryphal? Irenaeus certainly thinks so. Consider too the "), _c('em', [_vm._v("Memorial of John")]), _vm._v(", which is an introduction to the Gospel of John found attached to the text in numerous manuscripts. The "), _c('em', [_vm._v("Memorial")]), _vm._v(" is of interest to scholars of Christian apocrypha because it features traditions deriving from the "), _c('em', [_vm._v("Acts of John by Prochorus")]), _vm._v(". Finally, it may seem strange to see epistles of Ignatius in an apocrypha collection, but the four short pieces of this correspondence included here are written to the apostle John and the Virgin Mary, who likely were long dead by Ignatius’s time. The epistles are found in the so-called Long Recension of the Ignatian corpus, and though they were considered genuine for centuries, they were declared “spurious” in the Renaissance and have been neglected in scholarship ever since. So that makes them twice apocryphal: letters falsely attributed to Ignatius and, in the case of Mary’s reply to Ignatius, a letter presented as a composition by a first-century Christian figure.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The remaining texts of the “Gospels” section of the volume hearken back to selections in previous volumes. The "), _c('em', [_vm._v("Hospitality and Perfume of the Bandit")]), _vm._v(" is yet another free-floating story of the good bandit crucified beside Jesus. This version is found in certain manuscripts of the "), _c('em', [_vm._v("Gospel of Pseudo-Matthew")]), _vm._v(", a text that began as a Latin translation of the "), _c('em', [_vm._v("Protevangelium of James")]), _vm._v(" but has been expanded in multiple ways over the centuries. The variants are so many that they do not always get noted by editors and translators. One of the goals of "), _c('em', [_vm._v("MNTA")]), _vm._v(" is to bring attention to these stories that may not be original to the text but deserve mention. The "), _c('em', [_vm._v("Dialogue of Jesus and the Devil")]), _vm._v(" has appeared previously in English but only in a translation from the Church Slavic text; here both the Greek and the Church Slavic versions are given attention. The dialogue genre has appeared previously in "), _c('em', [_vm._v("MNTA")]), _vm._v(" with the "), _c('em', [_vm._v("Dialogue of the Paralytic with Christ")]), _vm._v(" in volume 1 and, to some extent, with the Johannine apocalyptica from volume 2 in which John poses questions to Jesus or Abraham, or John responds to questions by James. Designating a dialogue as a gospel or apocalypse depends solely on whether its exchange takes place before or after Jesus’s resurrection; in this text, the dialogue is set uniquely amidst the temptation scene from early in the Gospels of Matthew and Luke. Finally, the "), _c('em', [_vm._v("Eremitic Life of Mary Magdalene")]), _vm._v(", translated here for the first time in any modern language, presents the Magdalene not as a penitent prostitute but as a cave-dwelling hermit; readers of "), _c('em', [_vm._v("MNTA")]), _vm._v(" 2 will remember that Jacob of Voragine’s account of Mary in the "), _c('em', [_vm._v("Golden Legend")]), _vm._v(" combines this "), _c('em', [_vm._v("vita eremetica")]), _vm._v(" tradition with the "), _c('em', [_vm._v("vita apostolica")]), _vm._v(" tradition exemplified in the "), _c('em', [_vm._v("Life of Mary Magdalene")]), _vm._v(" published in the earlier volume.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Much of "), _c('em', [_vm._v("MNTA")]), _vm._v(" 3 is devoted to apocryphal acts, a rich corpus of texts often passed over by readers and many scholars more interested in studying Jesus traditions found in apocryphal gospels. Even within the acts category, scholars’ attention has been fixed primarily on the five “great” apocryphal acts (Andrew, Peter, Paul, John, and Thomas), leaving later developments relatively unexplored, particularly the collection of Egyptian acts initially assembled in Coptic but available more plentifully in Arabic and Ethiopic translations. More Coptic witnesses have become available in recent decades, prompting scholars to examine this tradition anew, leading in some cases to opening up questions about the possibility of Coptic origins of the texts that have Greek counterparts, such as the "), _c('em', [_vm._v("Martyrdom of Mark")]), _vm._v(". Ivan Miroshnikov is at the forefront of this work and here has contributed translations of the full range of available Coptic witnesses to the "), _c('em', [_vm._v("Acts of Andrew and Philemon")]), _vm._v(" and the "), _c('em', [_vm._v("Preaching of Philip")]), _vm._v(". Another Coptic Andrew text included in the volume is the "), _c('em', [_vm._v("Acts of Andrew and Paul")]), _vm._v(". This text, extant in a single manuscript and no other ancient language, has previously appeared only in summary or as excerpts. Acts in Syriac, like the Coptic, have also suffered from neglect. A number of Syriac accounts of Peter appeared in "), _c('em', [_vm._v("MNTA")]), _vm._v(" 2 in translations by J. Edward Walters, who returns here with two more: the "), _c('em', [_vm._v("Preaching of Simon Cephas in the City of Rome")]), _vm._v(", which was published and translated more than a century ago but is represented here with notes on additional manuscripts, and the "), _c('em', [_vm._v("Disputation of Peter and Nero")]), _vm._v(", which until now was available in English only in a recent master’s thesis from Italy. The "), _c('em', [_vm._v("MNTA")]), _vm._v(" series’ first contribution to the body of Syriac Petrine acts is the "), _c('em', [_vm._v("History of Simon Cephas, the Chief of the Apostles")]), _vm._v(", which was included in volume 1. Readers may recall that the text appears in manuscripts together with the "), _c('em', [_vm._v("History of Paul")]), _vm._v(" as the first of a two-part story. With the publication of the "), _c('em', [_vm._v("History of Paul")]), _vm._v(" in "), _c('em', [_vm._v("MNTA")]), _vm._v(" 3, the entire story is now available to English readers for the first time. Another text found in Syriac (as well as Armenian) is the "), _c('em', [_vm._v("Epistle of James to Quadratus")]), _vm._v(", which has not appeared previously in English. The "), _c('em', [_vm._v("Epistle")]), _vm._v(" does not belong to the genre of apocryphal acts, but like the acts, it reveals something about the exploits of an early Christian leader—in this case James, the brother of Jesus—after the ascension.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The jewel of the crown in volume 3 is the "), _c('em', [_vm._v("Acts of John by Prochorus")]), _vm._v(", not just because it is such a lengthy text—occupying more than sixty pages—but more because an English translation of this text is long overdue. "), _c('em', [_vm._v("Prochorus")]), _vm._v(" is less well known to scholars than the early "), _c('em', [_vm._v("Acts of John")]), _vm._v(", which today is available only in fragmentary form—and much of the material used to reconstruct the "), _c('em', [_vm._v("Acts of John")]), _vm._v(" comes from manuscripts of "), _c('em', [_vm._v("Prochorus")]), _vm._v(". The impact of "), _c('em', [_vm._v("Prochorus")]), _vm._v(" is far more substantial than the earlier acts, with around 150 manuscripts available in Greek alone, as well as translations into Coptic, Arabic, Ethiopic, Armenian, and Old French. Stories from the text also appear in iconography, including a series of paintings still extant today in the Church of John on Patmos (where much of the action in the text takes place). Janet Spittler’s translation for "), _c('em', [_vm._v("MNTA")]), _vm._v(" 3 is a significant contribution to the study of this text. It makes a fine companion to Spittler’s new translation of the "), _c('em', [_vm._v("Acts of John in Rome")]), _vm._v(", which also incorporates material from the early acts and sometimes appears in manuscripts alongside "), _c('em', [_vm._v("Prochorus")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The "), _c('em', [_vm._v("Acts of John by Prochorus")]), _vm._v(" exemplifies the goals of the "), _c('em', [_vm._v("MNTA")]), _vm._v(" series: to make available in translation texts typically overlooked in previous English-language compendia, in part because they were composed after the formation of the Roman Catholic canon. "), _c('em', [_vm._v("Prochorus")]), _vm._v(" is one of the most well-attested apocryphal texts, with a manuscript base rivaling the "), _c('em', [_vm._v("Protevangelium of James")]), _vm._v(", the "), _c('em', [_vm._v("Gospel of Pseudo-Matthew")]), _vm._v(", and a handful of other texts. Yet it has received far less attention not only in the field of Christian apocrypha studies but also in such cognate disciplines as Eastern Orthodoxy and medieval hagiography. So-called later apocrypha had far greater impact on Christian piety than many of the texts composed in the early centuries, yet they are mostly unknown. For medieval and some modern Christians, discoveries of such texts as the "), _c('em', [_vm._v("Gospel of Thomas")]), _vm._v(" or the Coptic "), _c('em', [_vm._v("Revelation of Peter")]), _vm._v(" would be considered “more” Christian apocrypha—new texts to be added to a corpus of centuries-old and well-established lives of saints and liturgical readings. But scholarship works here in reverse, focusing on reconstructing and rediscovering what is old to the detriment of what became standard. Such an attraction to early texts is understandable. It presents us with windows into nascent Christianity when it was most diverse: a world of gnostics, archontics, Priscillianists, encratites, Ebionites, and Marcionites. But there is also plenty of diversity observable in later works, as Christians created new texts, or adapted old ones, to combat or support new heresies, to establish new festivals and holy sites, to encourage their fellow renunciants, and to bring comfort in times of anxiety by promising rewards to those who remain faithful. Earlier is not necessarily better. Each of the texts in these volumes offers readers more to discover, more to appreciate, and more to enjoy.")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_vm._v("Future Volumes of More New Testament Apocrypha")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("When "), _c('em', [_vm._v("MNTA")]), _vm._v(" 2 was submitted to the press, there were no guarantees made that the series would continue. But that volume had grown too large, so several texts were removed with the promise that they could be included in this now-completed third volume. Because of the success of the series to date, discussions have begun about producing even more volumes. No decisions have been made over what texts to include, but a preliminary “wish list” would comprise those that were planned for previous volumes but did not materialize, such as the "), _c('em', [_vm._v("Book of the Rolls")]), _vm._v(", the "), _c('em', [_vm._v("Infancy of the Savior")]), _vm._v(" (also known as the "), _c('em', [_vm._v("Arabic Infancy Gospel")]), _vm._v("), the "), _c('em', [_vm._v("Book of the Rooster")]), _vm._v(", the "), _c('em', [_vm._v("Dream of Nero")]), _vm._v(", and the "), _c('em', [_vm._v("Vision of Theophilus")]), _vm._v(". Scholars would benefit also from a comprehensive synopsis of the Greek, Latin, Syriac, and Arabic texts of the "), _c('em', [_vm._v("Pseudo-Clementine Romance")]), _vm._v(". And there are still several pseudo-apostolic memoirs, Coptic versions of apocryphal acts, and portions of the Latin "), _c('em', [_vm._v("Apostolic Histories")]), _vm._v(" collection that remain untranslated and understudied. Likely "), _c('em', [_vm._v("MNTA")]), _vm._v(" 4 will be some time in coming; in the meantime, readers can look forward to the long-awaited second volume in Christoph Markschies and Jens Schröter’s "), _c('em', [_vm._v("Antike christliche Apokryphen in deutscher Übersetzung")]), _vm._v(" series; Ivan Miroshnikov’s "), _c('em', [_vm._v("Parabiblica Coptica")]), _vm._v(", which includes several editions and studies of texts featured in "), _c('em', [_vm._v("MNTA")]), _vm._v("; and Hugo Lundhaug’s Storyworlds in Transition project, which plans to produce a volume of Coptic apocrypha in translation. Also worth watching is the Early Christian Apocrypha series published by the North American Society for the Study of Christian Apocryphal Literature (NASSCAL); upcoming volumes will feature the "), _c('em', [_vm._v("Preaching of Peter")]), _vm._v(" ("), _c('em', [_vm._v("Kerygma Petri")]), _vm._v("), the "), _c('em', [_vm._v("Doctrina Addai")]), _vm._v(", and the "), _c('em', [_vm._v("Life of Thecla")]), _vm._v(". The society also administers the open-access electronic resource e-Clavis: Christian Apocrypha (accessible at NASSCAL.com), which features summaries, bibliographies, and other resources on the full range of apocryphal literature.")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_vm._v("Note on Cyrillic Transliteration"), _c('br'), _vm._v("by Slavomír Čéplö")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("In this volume, the following transliteration scheme for Cyrillic is employed:")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/xviii.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/xx.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "indent-para-t"
  }, [_vm._v("This scheme is based on common standards (International Organization for Standardization, romanization of Russian [ISO/R] 9:1968, and the transliteration scheme used in Lunt’s grammar of Old Church Slavonic"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#footnote-000",
      "id": "footnote-000-backlink"
    }
  }, [_vm._v("1")])]), _vm._v(") with some modifications. These modifications were chosen as a compromise between readability, existing practices, and the ultimate goal of providing a transliteration that would allow full conversion back to original Cyrillic in the context of the mixing of various orthographies (Church Slavic, pre-reform Russian, modern Russian, Ukrainian, Bulgarian, etc.). The compromise is particularly evident in such choices as transcribing the "), _c('em', [_vm._v("yers")]), _vm._v(" as "), _c('span', {
    staticClass: "special-char-ital"
  }, [_vm._v("ǐ")]), _vm._v(" and "), _c('span', {
    staticClass: "special-char-ital"
  }, [_vm._v("ǔ")]), _vm._v(" where most standards prefer to use single and double quotes, respectively. Our solution is preferable considering modern orthographic practices and the needs of editing/typesetting software.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Personal and place names are the one exception where this transliteration scheme is not applied. In such cases, if a standardized (in whatever way) form in Latin script exists, it is used throughout. One example is Aleksandr Pypin, whose last name is written in pre-reform Russian Orthography as Пыпинъ and should thus be translated as "), _c('em', [_vm._v("Pypin")]), _c('span', {
    staticClass: "special-char-ital"
  }, [_vm._v("ǔ")]), _vm._v(". The "), _c('em', [_vm._v("yer")]), _vm._v("-less form Pypin, established in English-language literature, will be used throughout. For place names, the standard English name is used—that is, Moscow instead of Moskva, Saint Petersburg instead of "), _c('em', [_vm._v("Sankt Peterb")]), _c('span', {
    staticClass: "special-char-ital"
  }, [_vm._v("ǔ")]), _c('em', [_vm._v("rg")]), _c('span', {
    staticClass: "special-char-ital"
  }, [_vm._v("ǔ")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/foot.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-000-backlink",
      "id": "footnote-000"
    }
  }, [_vm._v("1")]), _vm._v(". Horace G. Lunt, "), _c('em', [_vm._v("Old Church Slavonic Grammar")]), _vm._v(", 7th ed. (Berlin: Mouton de Gruyter, 2001).")])])])
}]}

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(77),
  /* template */
  __webpack_require__(78),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 78 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ch-title"
  }, [_vm._v("Abbreviations")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Unless listed below, all abbreviations used in this volume are found in "), _c('em', [_vm._v("The SBL Handbook of Style")]), _vm._v(", 2nd ed. (Atlanta: SBL Press, 2014).")]), _vm._v(" "), _c('div', {
    staticClass: "inside"
  }, [_c('table', [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "td40"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("AG")])])]), _vm._v(" "), _c('td', {
    staticClass: "td55"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("The Apocryphal Gospels: Texts and Translations.")]), _vm._v(" Edited and translated by Bart Ehrman and Zlatko Pleše. Oxford: Oxford University Press, 2011.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td40"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("ANT")])])]), _vm._v(" "), _c('td', {
    staticClass: "td55"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("The Apocryphal New Testament: A Collection of Apocryphal Christian Literature in an English Translation")]), _vm._v(". Edited and translated by James K. Elliott. Rev. ed. Oxford: Clarendon, 2005.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td40"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("BHG")])])]), _vm._v(" "), _c('td', {
    staticClass: "td55"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Bibliotheca Hagiographica Graeca.")]), _vm._v(" Edited by François Halkin. 3rd ed. 3 vols. Subsidia Hagiographica 8/8a. Brussels: Société des Bollandistes, 1986.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td40"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("BHL")])])]), _vm._v(" "), _c('td', {
    staticClass: "td55"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Bibliotheca Hagiographica Latina Antiquae et Mediae Aetatis.")]), _vm._v(" 2 vols. Subsidia Hagiographica 6. Brussels: Société des Bollandistes, 1898–1901.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td40"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("BHO")])])]), _vm._v(" "), _c('td', {
    staticClass: "td55"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Bibliotheca Hagiographica Orientalis.")]), _vm._v(" Edited by Paul Peeters. Subsidia Hagiographica 10. Brussels: Société des Bollandistes, 1910.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td40"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("CANT")])])]), _vm._v(" "), _c('td', {
    staticClass: "td55"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Clavis apocryphorum Novi Testamenti")]), _vm._v(". Edited by Maurice Geerard. Corpus Christianorum. Turnhout: Brepols, 1992.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td40"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("CPC")])])]), _vm._v(" "), _c('td', {
    staticClass: "td55"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Clavis Patrum Copticorum")]), _vm._v(". Online at "), _c('a', {
    attrs: {
      "href": "http://cmcl.aai.uni-hamburg.de/",
      "target": "_blank"
    }
  }, [_vm._v("http://cmcl.aai.uni-hamburg.de/")]), _vm._v(".")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td40"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("DMLBS")])])]), _vm._v(" "), _c('td', {
    staticClass: "td55"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Dictionary of Medieval Latin from British Sources.")]), _vm._v(" Edited by Richard Ashdowne, David Howlett, and Ronald Latham. Oxford: Oxford University Press, 2018.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td40"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("EAC")])])]), _vm._v(" "), _c('td', {
    staticClass: "td55"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_vm._v("Écrits "), _c('em', [_vm._v("apocryphes chrétiens.")]), _vm._v(" Vol. 1 edited by François Bovon and Pierre Geoltrain. Bibliothèque de la Pléiade 442. Paris: Gallimard, 1997. Vol. 2 edited by Pierre Geoltrain and Jean-Daniel Kaestli. Bibliothèque de la Pléiade 443. Paris: Gallimard, 2005.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td40"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("HUAA")])])]), _vm._v(" "), _c('td', {
    staticClass: "td55"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Die handschriftliche")]), _vm._v(" Überlieferung "), _c('em', [_vm._v("der altslavischen Apokryphen")]), _vm._v(". 2 vols. Edited by Aurelio de Santos Otero. PTS 20 and 23. Berlin: de Gruyter, 1978, 1981.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td40"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_vm._v("Lampe")])]), _vm._v(" "), _c('td', {
    staticClass: "td55"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_vm._v("Lampe, G. W. H., ed. "), _c('em', [_vm._v("A Patristic Greek Lexicon.")]), _vm._v(" Oxford: Clarendon, 1961.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td40"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_vm._v("LSJ")])]), _vm._v(" "), _c('td', {
    staticClass: "td55"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_vm._v("Liddell, Henry George, Robert Scott, and Henry Stuart Jones, eds. "), _c('em', [_vm._v("A Greek-English Lexicon")]), _vm._v(". 9th ed. with revised supplement. Oxford: Clarendon, 1996.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td40"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("MNTA")])])]), _vm._v(" "), _c('td', {
    staticClass: "td55"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("New Testament Apocrypha: More Noncanonical Scriptures")]), _vm._v(". Vol. 1 edited by Tony Burke and Brent Landau. Vol. 2 edited by Tony Burke"), _c('em', [_vm._v(".")]), _vm._v(" Grand Rapids: Eerdmans, 2016, 2019.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td40"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_vm._v("P. Oxy.")])]), _vm._v(" "), _c('td', {
    staticClass: "td55"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("The Oxyrhynchus Papyri.")]), _vm._v(" Edited by B. P. Grenfell"), _c('em'), _vm._v(" et al."), _c('em'), _vm._v(" London: Egypt Exploration Society, 1898–.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td40"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_vm._v("TLG")])]), _vm._v(" "), _c('td', {
    staticClass: "td55"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_vm._v("Thesaurus Linguae Graecae")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td40"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Acts Andr. Bart.")])])]), _vm._v(" "), _c('td', {
    staticClass: "td55"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Acts of Andrew and Bartholomew")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td40"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Acts Andr. Paul")])])]), _vm._v(" "), _c('td', {
    staticClass: "td55"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Acts of Andrew and Paul")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td40"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Acts Andr. Phlm.")])])]), _vm._v(" "), _c('td', {
    staticClass: "td55"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Acts of Andrew and Philemon")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td40"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Acts Chr. Pet.")])])]), _vm._v(" "), _c('td', {
    staticClass: "td55"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Acts of Christ and Peter in Rome")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td40"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Acts John Proch.")])])]), _vm._v(" "), _c('td', {
    staticClass: "td55"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Acts of John by Prochorus")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td40"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Acts John Rome")])])]), _vm._v(" "), _c('td', {
    staticClass: "td55"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Acts of John in Rome")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td40"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Acts Matt. Priests")])])]), _vm._v(" "), _c('td', {
    staticClass: "td55"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Acts of Matthew in the City of the Priests")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td40"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Acts Ner. Ach.")])])]), _vm._v(" "), _c('td', {
    staticClass: "td55"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Acts of Nereus and Achilleus")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td40"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Acts Pet. Andr.")])])]), _vm._v(" "), _c('td', {
    staticClass: "td55"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Acts of Peter and Andrew")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td40"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Acts Pet. Paul")])])]), _vm._v(" "), _c('td', {
    staticClass: "td55"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Acts of the Holy Apostles Peter and Paul")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td40"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Acts Thad.")])])]), _vm._v(" "), _c('td', {
    staticClass: "td55"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Acts of Thaddaeus")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td40"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Acts Thom. Skin")])])]), _vm._v(" "), _c('td', {
    staticClass: "td55"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Acts of Thomas and His Wonderworking Skin")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td40"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Acts Tim.")])])]), _vm._v(" "), _c('td', {
    staticClass: "td55"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Acts of Timothy")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td40"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Acts Titus")])])]), _vm._v(" "), _c('td', {
    staticClass: "td55"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Acts of Titus")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td40"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_vm._v("Adso of Montieren-Der")])]), _vm._v(" "), _c('td', {
    staticClass: "td55"
  }, [_c('p', {
    staticClass: "ab-fm"
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td40"
  }, [_c('p', {
    staticClass: "ab-fm1"
  }, [_c('em', [_vm._v("De ortu")])])]), _vm._v(" "), _c('td', {
    staticClass: "td55"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("De ortu et tempore Antichristi")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td40"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Apoc. Anast.")])])]), _vm._v(" "), _c('td', {
    staticClass: "td55"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Apocalypse of Anastasia")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td40"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Apoc. Ps.-Ephrem")])])]), _vm._v(" "), _c('td', {
    staticClass: "td55"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Apocalypse of Pseudo-Ephrem")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td40"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Apoc. Ps.-Meth.")])])]), _vm._v(" "), _c('td', {
    staticClass: "td55"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Apocalypse of Pseudo-Methodius")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td40"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("1 Apocr. Apoc. John")])])]), _vm._v(" "), _c('td', {
    staticClass: "td55"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("1 Apocryphal Apocalypse of John")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td40"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("2 Apocr. Apoc. John")])])]), _vm._v(" "), _c('td', {
    staticClass: "td55"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("2 Apocryphal Apocalypse of John")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td40"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("3 Apocr. Apoc. John")])])]), _vm._v(" "), _c('td', {
    staticClass: "td55"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("3 Apocryphal Apocalypse of John")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td40"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Apos. Con.")])])]), _vm._v(" "), _c('td', {
    staticClass: "td55"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Apostolic Constitutions")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td40"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_vm._v("Athanasius")])]), _vm._v(" "), _c('td', {
    staticClass: "td55"
  }, [_c('p', {
    staticClass: "ab-fm"
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td40"
  }, [_c('p', {
    staticClass: "ab-fm1"
  }, [_c('em', [_vm._v("Quaest. ad Ant.")])])]), _vm._v(" "), _c('td', {
    staticClass: "td55"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Quaestiones ad Antiochem ducem")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td40"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Birth Bapt.")])])]), _vm._v(" "), _c('td', {
    staticClass: "td55"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Birth of Holy John the Forerunner")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td40"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Birth Sav.")])])]), _vm._v(" "), _c('td', {
    staticClass: "td55"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Book about the Birth of the Savior")]), _vm._v(" ("), _c('em', [_vm._v("Liber de Nativitate Salvatoris")]), _vm._v(")")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td40"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Bk. Bart.")])])]), _vm._v(" "), _c('td', {
    staticClass: "td55"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Book of Bartholomew")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td40"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Chron. Pasch.")])])]), _vm._v(" "), _c('td', {
    staticClass: "td55"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Chronicon Paschale")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td40"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Comm. Jn. Ev.")])])]), _vm._v(" "), _c('td', {
    staticClass: "td55"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Commentariolus de Ioannis evangelio")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td40"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_vm._v("Commodian")])]), _vm._v(" "), _c('td', {
    staticClass: "td55"
  }, [_c('p', {
    staticClass: "ab-fm"
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td40"
  }, [_c('p', {
    staticClass: "ab-fm1"
  }, [_c('em', [_vm._v("Instr.")])])]), _vm._v(" "), _c('td', {
    staticClass: "td55"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Instructiones")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td40"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Cosm. et Dam.")])])]), _vm._v(" "), _c('td', {
    staticClass: "td55"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Vitae et miracula sanctorum Cosmae et Damiani")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td40"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("7 Dan")])])]), _vm._v(" "), _c('td', {
    staticClass: "td55"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Seventh Vision of Dan")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td40"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Decap. Bapt.")])])]), _vm._v(" "), _c('td', {
    staticClass: "td55"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Decapitation of John the Baptist")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td40"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("DEH")])])]), _vm._v(" "), _c('td', {
    staticClass: "td55"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em'), _vm._v("Pseudo-Hegesippus, "), _c('em', [_vm._v("De Excidio Hierosolymitano")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td40"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Dial. Devil")])])]), _vm._v(" "), _c('td', {
    staticClass: "td55"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Dialogue of Jesus and the Devil")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td40"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Dial. Mary Chr.")])])]), _vm._v(" "), _c('td', {
    staticClass: "td55"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Dialogue of Mary and Christ on the Departure of the Soul")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td40"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Dial. Urs. Patr.")])])]), _vm._v(" "), _c('td', {
    staticClass: "td55"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Dialogue of Ursinius and Patrophilius")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td40"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_vm._v("Diodorus Siculus")])]), _vm._v(" "), _c('td', {
    staticClass: "td55"
  }, [_c('p', {
    staticClass: "ab-fm"
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td40"
  }, [_c('p', {
    staticClass: "ab-fm1"
  }, [_c('em', [_vm._v("Bib. hist.")])])]), _vm._v(" "), _c('td', {
    staticClass: "td55"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Bibliotheca historica")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td40"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Disp. Pet. Nero")])])]), _vm._v(" "), _c('td', {
    staticClass: "td55"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Disputation of Peter and Nero")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td40"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Doctr. Addai")])])]), _vm._v(" "), _c('td', {
    staticClass: "td55"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Doctrina Addai")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td40"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Dream Rood")])])]), _vm._v(" "), _c('td', {
    staticClass: "td55"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Dream of the Rood")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td40"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_vm._v("Egeria")])]), _vm._v(" "), _c('td', {
    staticClass: "td55"
  }, [_c('p', {
    staticClass: "ab-fm"
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td40"
  }, [_c('p', {
    staticClass: "ab-fm1"
  }, [_c('em', [_vm._v("Itin.")])])]), _vm._v(" "), _c('td', {
    staticClass: "td55"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Itinerarium")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td40"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Encom. Mary")])])]), _vm._v(" "), _c('td', {
    staticClass: "td55"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Encomium on Mary Magdalene")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td40"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Ep. Chr. Heav.")])])]), _vm._v(" "), _c('td', {
    staticClass: "td55"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Epistle of Christ from Heaven")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td40"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Ep. Herod Pil.")])])]), _vm._v(" "), _c('td', {
    staticClass: "td55"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Epistle of Herod to Pilate")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td40"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Ep. Ign. John Mary")])])]), _vm._v(" "), _c('td', {
    staticClass: "td55"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Correspondence of Ignatius with John the Evangelist and the Virgin Mary")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td40"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Ep. Jas. Quad.")])])]), _vm._v(" "), _c('td', {
    staticClass: "td55"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Epistle of James to Quadratus")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td40"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Ep. Long. Aug.")])])]), _vm._v(" "), _c('td', {
    staticClass: "td55"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Epistles of Longinus and Augustus")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td40"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Ep. Pil. Claud.")])])]), _vm._v(" "), _c('td', {
    staticClass: "td55"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Epistle of Pilate to Claudius")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td40"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Ep. Tim. Dion.")])])]), _vm._v(" "), _c('td', {
    staticClass: "td55"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Epistle of Pseudo-Dionysius the Areopagite to Timothy")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td40"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_vm._v("Ephrem")])]), _vm._v(" "), _c('td', {
    staticClass: "td55"
  }, [_c('p', {
    staticClass: "ab-fm"
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td40"
  }, [_c('p', {
    staticClass: "ab-fm1"
  }, [_c('em', [_vm._v("Hymn Nat.")])])]), _vm._v(" "), _c('td', {
    staticClass: "td55"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Hymns on the Nativity")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td40"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_vm._v("Epiphanius")])]), _vm._v(" "), _c('td', {
    staticClass: "td55"
  }, [_c('p', {
    staticClass: "ab-fm"
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td40"
  }, [_c('p', {
    staticClass: "ab-fm1"
  }, [_c('em', [_vm._v("De mens. et pond.")])])]), _vm._v(" "), _c('td', {
    staticClass: "td55"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("De mensuribus et ponderibus")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td40"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Erem. Life Magd.")])])]), _vm._v(" "), _c('td', {
    staticClass: "td55"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Eremitic Life of Mary Magdalene")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td40"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Gos. Jud.")])])]), _vm._v(" "), _c('td', {
    staticClass: "td55"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Gospel of Judas")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td40"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Gos. Twelve (Syr.)")])])]), _vm._v(" "), _c('td', {
    staticClass: "td55"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Gospel of the Twelve Apostles (Syriac)")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td40"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_vm._v("Gregory of Tours")])]), _vm._v(" "), _c('td', {
    staticClass: "td55"
  }, [_c('p', {
    staticClass: "ab-fm"
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td40"
  }, [_c('p', {
    staticClass: "ab-fm1"
  }, [_c('em', [_vm._v("Glor. mart")]), _vm._v(".")])]), _vm._v(" "), _c('td', {
    staticClass: "td55"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Liber in gloria martyrum")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td40"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Lib. de mir.")])])]), _vm._v(" "), _c('td', {
    staticClass: "td55"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Liber de miraculis Andreas Apostoli")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td40"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_vm._v("Gregory Referendarius")])]), _vm._v(" "), _c('td', {
    staticClass: "td55"
  }, [_c('p', {
    staticClass: "ab-fm"
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td40"
  }, [_c('p', {
    staticClass: "ab-fm1"
  }, [_c('em', [_vm._v("Hom. Im. Ed.")])])]), _vm._v(" "), _c('td', {
    staticClass: "td55"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Homily on the Image of Edessa")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td40"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_vm._v("Gregory the Great")])]), _vm._v(" "), _c('td', {
    staticClass: "td55"
  }, [_c('p', {
    staticClass: "ab-fm"
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td40"
  }, [_c('p', {
    staticClass: "ab-fm1"
  }, [_c('em', [_vm._v("Hom. in Euang.")])])]), _vm._v(" "), _c('td', {
    staticClass: "td55"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Homiliae in Euangelia")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td40"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Heal. Tib.")])])]), _vm._v(" "), _c('td', {
    staticClass: "td55"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Healing of Tiberius")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td40"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_vm._v("Heiric of Auxerre")])]), _vm._v(" "), _c('td', {
    staticClass: "td55"
  }, [_c('p', {
    staticClass: "ab-fm"
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td40"
  }, [_c('p', {
    staticClass: "ab-fm1"
  }, [_c('em', [_vm._v("Hom.")])])]), _vm._v(" "), _c('td', {
    staticClass: "td55"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Homiliae")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td40"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_vm._v("Herodian")])]), _vm._v(" "), _c('td', {
    staticClass: "td55"
  }, [_c('p', {
    staticClass: "ab-fm"
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td40"
  }, [_c('p', {
    staticClass: "ab-fm1"
  }, [_c('em', [_vm._v("Hist.")])])]), _vm._v(" "), _c('td', {
    staticClass: "td55"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("History of the Empire from the Death of Marcus")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td40"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_vm._v("Hippocrates")])]), _vm._v(" "), _c('td', {
    staticClass: "td55"
  }, [_c('p', {
    staticClass: "ab-fm"
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td40"
  }, [_c('p', {
    staticClass: "ab-fm1"
  }, [_c('em', [_vm._v("Aer.")])])]), _vm._v(" "), _c('td', {
    staticClass: "td55"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("De aeare acquis et locis")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td40"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Hist. John")])])]), _vm._v(" "), _c('td', {
    staticClass: "td55"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("(Syriac) History of John")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td40"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Hist. Paul")])])]), _vm._v(" "), _c('td', {
    staticClass: "td55"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("History of Paul")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td40"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Hist. Phil.")])])]), _vm._v(" "), _c('td', {
    staticClass: "td55"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("History of Philip")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td40"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Hist. Sim. Ceph.")])])]), _vm._v(" "), _c('td', {
    staticClass: "td55"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("History of Simon Cephas, the Chief of the Apostles")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td40"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Hist. Vir.")])])]), _vm._v(" "), _c('td', {
    staticClass: "td55"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("(East Syriac) History of the Virgin")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td40"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Hom. Life Jesus")])])]), _vm._v(" "), _c('td', {
    staticClass: "td55"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Homily on the Life of Jesus and His Love for the Apostles")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td40"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Hom.")]), _vm._v(" "), _c('em', [_vm._v("Pass. Res")]), _vm._v(".")])]), _vm._v(" "), _c('td', {
    staticClass: "td55"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Homily on the Passion and Resurrection")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td40"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Hosp. Dysmas")])])]), _vm._v(" "), _c('td', {
    staticClass: "td55"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Hospitality of Dysmas")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td40"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Hosp. Oint. Band.")])])]), _vm._v(" "), _c('td', {
    staticClass: "td55"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Hospitality and Ointment of the Bandit")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td40"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Hosp. Perf. Band.")])])]), _vm._v(" "), _c('td', {
    staticClass: "td55"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Hospitality and Perfume of the Bandit")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td40"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Invest. Abbat.")])])]), _vm._v(" "), _c('td', {
    staticClass: "td55"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Investiture of Abbaton")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td40"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Invest. Gab.")])])]), _vm._v(" "), _c('td', {
    staticClass: "td55"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Investiture of the Archangel Gabriel")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td40"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Invest. Mich.")])])]), _vm._v(" "), _c('td', {
    staticClass: "td55"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Investiture of the Archangel Michael")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td40"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Leg. Rood Tree")])])]), _vm._v(" "), _c('td', {
    staticClass: "td55"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Legend of the Holy Rood Tree")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td40"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_vm._v("Libanius")])]), _vm._v(" "), _c('td', {
    staticClass: "td55"
  }, [_c('p', {
    staticClass: "ab-fm"
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td40"
  }, [_c('p', {
    staticClass: "ab-fm1"
  }, [_c('em', [_vm._v("Or.")])])]), _vm._v(" "), _c('td', {
    staticClass: "td55"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Orationes")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td40"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Liber Requiei")])])]), _vm._v(" "), _c('td', {
    staticClass: "td55"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Liber Requiei Mariae")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td40"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Life Bapt. Serap.")])])]), _vm._v(" "), _c('td', {
    staticClass: "td55"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Life of John the Baptist")]), _vm._v(" by Serapion")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td40"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Life Mart. Bapt.")])])]), _vm._v(" "), _c('td', {
    staticClass: "td55"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Life and Martyrdom of John the Baptist")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td40"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Lin. Mart. Paul")])])]), _vm._v(" "), _c('td', {
    staticClass: "td55"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em'), _vm._v("Pseudo-Linus, "), _c('em', [_vm._v("Martyrdom of Blessed Paul the Apostle")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td40"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Lin. Mart. Pet.")])])]), _vm._v(" "), _c('td', {
    staticClass: "td55"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em'), _vm._v("Pseudo-Linus, "), _c('em', [_vm._v("Martyrdom of Blessed Peter the Apostle")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td40"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Mart. Mark")])])]), _vm._v(" "), _c('td', {
    staticClass: "td55"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Martyrdom of Mark")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td40"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Mart. Paul Head")])])]), _vm._v(" "), _c('td', {
    staticClass: "td55"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Martyrdom of Paul the Apostle and the Discovery of His Severed Head")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td40"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Mart. Phil. (Copt.)")])])]), _vm._v(" "), _c('td', {
    staticClass: "td55"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("(Coptic) Martyrdom of Philip")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td40"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Mart. Pil.")])])]), _vm._v(" "), _c('td', {
    staticClass: "td55"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Martyrdom of Pilate")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td40"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Mart. Zech.")])])]), _vm._v(" "), _c('td', {
    staticClass: "td55"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Martyrdom of Zechariah")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td40"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Mem. John")])])]), _vm._v(" "), _c('td', {
    staticClass: "td55"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Memorial of John")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td40"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Myst. John")])])]), _vm._v(" "), _c('td', {
    staticClass: "td55"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Mysteries of John")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td40"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_vm._v("Nicephorus Callistus")])]), _vm._v(" "), _c('td', {
    staticClass: "td55"
  }, [_c('p', {
    staticClass: "ab-fm"
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td40"
  }, [_c('p', {
    staticClass: "ab-fm1"
  }, [_c('em', [_vm._v("Hist. eccl.")])])]), _vm._v(" "), _c('td', {
    staticClass: "td55"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Historia ecclesiastica")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td40"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_vm._v("Oecumenicus")])]), _vm._v(" "), _c('td', {
    staticClass: "td55"
  }, [_c('p', {
    staticClass: "ab-fm"
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td40"
  }, [_c('p', {
    staticClass: "ab-fm1"
  }, [_c('em', [_vm._v("Comm. Apoc.")])])]), _vm._v(" "), _c('td', {
    staticClass: "td55"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Commentaria in Apocalypsi")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td40"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_vm._v("Palladius of Helenopolis")])]), _vm._v(" "), _c('td', {
    staticClass: "td55"
  }, [_c('p', {
    staticClass: "ab-fm"
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td40"
  }, [_c('p', {
    staticClass: "ab-fm1"
  }, [_c('em', [_vm._v("Hist. Laus.")])])]), _vm._v(" "), _c('td', {
    staticClass: "td55"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Historia Lausiaca")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td40"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Parad. Pil.")])])]), _vm._v(" "), _c('td', {
    staticClass: "td55"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Handing Over of Pilate")]), _vm._v(" ("), _c('em', [_vm._v("Paradosis Pilati")]), _vm._v(")")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td40"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Pass. Apost. Pet. Paul")])])]), _vm._v(" "), _c('td', {
    staticClass: "td55"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Passion of the Apostles Peter and Paul")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td40"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Pass. Holy Pet. Paul")])])]), _vm._v(" "), _c('td', {
    staticClass: "td55"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Passion of the Holy Apostles Peter and Paul (Pseudo-Marcellus)")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td40"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Pass. Paul")])])]), _vm._v(" "), _c('td', {
    staticClass: "td55"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em'), _vm._v("Pseudo-Abdias, "), _c('em', [_vm._v("Passion of Paul")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td40"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Pass. Pet.")])])]), _vm._v(" "), _c('td', {
    staticClass: "td55"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em'), _vm._v("Pseudo-Abdias, "), _c('em', [_vm._v("Passion of Peter")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td40"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Pass. Pet. Paul")])])]), _vm._v(" "), _c('td', {
    staticClass: "td55"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em'), _vm._v("Pseudo-Hegesippus, "), _c('em', [_vm._v("Passion of Peter and Paul")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td40"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_vm._v("Paulinus of Nola")])]), _vm._v(" "), _c('td', {
    staticClass: "td55"
  }, [_c('p', {
    staticClass: "ab-fm"
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td40"
  }, [_c('p', {
    staticClass: "ab-fm1"
  }, [_c('em', [_vm._v("Carm.")])])]), _vm._v(" "), _c('td', {
    staticClass: "td55"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Carmina")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td40"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_vm._v("Photius of Constantinople")])]), _vm._v(" "), _c('td', {
    staticClass: "td55"
  }, [_c('p', {
    staticClass: "ab-fm"
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td40"
  }, [_c('p', {
    staticClass: "ab-fm1"
  }, [_c('em', [_vm._v("Bib")]), _vm._v(".")])]), _vm._v(" "), _c('td', {
    staticClass: "td55"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Bibliotheca")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td40"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Pre. Bart.")])])]), _vm._v(" "), _c('td', {
    staticClass: "td55"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Preaching of Bartholomew")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td40"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Pre. Jas. Zeb.")])])]), _vm._v(" "), _c('td', {
    staticClass: "td55"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Preaching of James, Son of Zebedee")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td40"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Pre. Pet. Faust.")])])]), _vm._v(" "), _c('td', {
    staticClass: "td55"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Preaching of Peter to Faustus")]), _vm._v("[tab/]"), _c('em')])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td40"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Pre. Pet. Rome")])])]), _vm._v(" "), _c('td', {
    staticClass: "td55"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Preaching of Simon Cephas in the City of Rome")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td40"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Pre. Phil.")])])]), _vm._v(" "), _c('td', {
    staticClass: "td55"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Preaching of Philip")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td40"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_vm._v("Procopius")])]), _vm._v(" "), _c('td', {
    staticClass: "td55"
  }, [_c('p', {
    staticClass: "ab-fm"
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td40"
  }, [_c('p', {
    staticClass: "ab-fm1"
  }, [_c('em', [_vm._v("Wars")])])]), _vm._v(" "), _c('td', {
    staticClass: "td55"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("History of the Wars")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td40"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_vm._v("Prudentius")])]), _vm._v(" "), _c('td', {
    staticClass: "td55"
  }, [_c('p', {
    staticClass: "ab-fm"
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td40"
  }, [_c('p', {
    staticClass: "ab-fm1"
  }, [_c('em', [_vm._v("Perist.")])])]), _vm._v(" "), _c('td', {
    staticClass: "td55"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Peristephanon")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td40"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_vm._v("Pseudo-Clement")])]), _vm._v(" "), _c('td', {
    staticClass: "td55"
  }, [_c('p', {
    staticClass: "ab-fm"
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td40"
  }, [_c('p', {
    staticClass: "ab-fm1"
  }, [_c('em', [_vm._v("Hom.")])])]), _vm._v(" "), _c('td', {
    staticClass: "td55"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Homilies")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td40"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Rec.")])])]), _vm._v(" "), _c('td', {
    staticClass: "td55"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Recognitions")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td40"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_vm._v("Pseudo-Dionysius")])]), _vm._v(" "), _c('td', {
    staticClass: "td55"
  }, [_c('p', {
    staticClass: "ab-fm"
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td40"
  }, [_c('p', {
    staticClass: "ab-fm1"
  }, [_c('em', [_vm._v("Ep.")])])]), _vm._v(" "), _c('td', {
    staticClass: "td55"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Epistles")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td40"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_vm._v("Pseudo-Melito")])]), _vm._v(" "), _c('td', {
    staticClass: "td55"
  }, [_c('p', {
    staticClass: "ab-fm"
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td40"
  }, [_c('p', {
    staticClass: "ab-fm1"
  }, [_c('em', [_vm._v("Pass. John")])])]), _vm._v(" "), _c('td', {
    staticClass: "td55"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Passion of John")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td40"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_vm._v("Ptolemy")])]), _vm._v(" "), _c('td', {
    staticClass: "td55"
  }, [_c('p', {
    staticClass: "ab-fm"
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td40"
  }, [_c('p', {
    staticClass: "ab-fm1"
  }, [_c('em', [_vm._v("Geog.")])])]), _vm._v(" "), _c('td', {
    staticClass: "td55"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Geographia")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td40"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Quest. Bart.")])])]), _vm._v(" "), _c('td', {
    staticClass: "td55"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Questions of Bartholomew")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td40"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Quest. Jas.")])])]), _vm._v(" "), _c('td', {
    staticClass: "td55"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Questions of James to John")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td40"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Quest. John")])])]), _vm._v(" "), _c('td', {
    staticClass: "td55"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Questions of John")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td40"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Reb. Dimas")])])]), _vm._v(" "), _c('td', {
    staticClass: "td55"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Rebellion of Dimas")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td40"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Report Pil.")])])]), _vm._v(" "), _c('td', {
    staticClass: "td55"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Report of Pilate")]), _vm._v(" ("), _c('em', [_vm._v("Anaphora Pilati")]), _vm._v(")")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td40"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Rev. John Ant.")])])]), _vm._v(" "), _c('td', {
    staticClass: "td55"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Revelation of John about the Antichrist")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td40"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("1")]), _vm._v(" "), _c('em', [_vm._v("Rev. Matt. End")])])]), _vm._v(" "), _c('td', {
    staticClass: "td55"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("1")]), _vm._v(" "), _c('em', [_vm._v("Revelation of Matthew about the End Times")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td40"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("2")]), _vm._v(" "), _c('em', [_vm._v("Rev. Matt. End")])])]), _vm._v(" "), _c('td', {
    staticClass: "td55"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("2")]), _vm._v(" "), _c('em', [_vm._v("Revelation of Matthew about the End Times")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td40"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Rev. Prayer")])])]), _vm._v(" "), _c('td', {
    staticClass: "td55"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Revelation about the Lord’s Prayer")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td40"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("SGP")])])]), _vm._v(" "), _c('td', {
    staticClass: "td55"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Sayings of Greek Philosophers")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td40"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_vm._v("Solomon of Basra")])]), _vm._v(" "), _c('td', {
    staticClass: "td55"
  }, [_c('p', {
    staticClass: "ab-fm"
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td40"
  }, [_c('p', {
    staticClass: "ab-fm1"
  }, [_c('em', [_vm._v("Bk. Bee")])])]), _vm._v(" "), _c('td', {
    staticClass: "td55"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Book of the Bee")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td40"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Story Im. Ed.")])])]), _vm._v(" "), _c('td', {
    staticClass: "td55"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Story of the Image of Edessa")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td40"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Story Jos. Arim.")])])]), _vm._v(" "), _c('td', {
    staticClass: "td55"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Story of Joseph of Arimathea")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td40"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Teach. Apos.")])])]), _vm._v(" "), _c('td', {
    staticClass: "td55"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Teaching of the Apostles")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td40"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Testim. Urs.")])])]), _vm._v(" "), _c('td', {
    staticClass: "td55"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Testimony of Ursinius")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td40"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Tib. Sib.")])])]), _vm._v(" "), _c('td', {
    staticClass: "td55"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Tiburtine Sibyl")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td40"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Vis. Theo.")])])]), _vm._v(" "), _c('td', {
    staticClass: "td55"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Vision of Theophilus")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td40"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Xanth.")])])]), _vm._v(" "), _c('td', {
    staticClass: "td55"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_c('em', [_vm._v("Life and Conduct of the Holy Women Xanthippe, Polyxena, and Rebecca")])])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_vm._v("Sigla")]), _vm._v(" "), _c('div', {
    staticClass: "inside"
  }, [_c('table', [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "td40"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_vm._v("[text]")])]), _vm._v(" "), _c('td', {
    staticClass: "td55"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_vm._v("Square brackets indicate damaged, illegible, or missing text, whether restorable or unrecoverable.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td40"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_vm._v("(text)")])]), _vm._v(" "), _c('td', {
    staticClass: "td55"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_vm._v("Parentheses or round brackets indicate words added by the translator for clarity.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td40"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_vm._v("<text>")])]), _vm._v(" "), _c('td', {
    staticClass: "td55"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_vm._v("Pointed brackets indicate a correction or emendation made to a text by the translator.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td40"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_vm._v("{text}")])]), _vm._v(" "), _c('td', {
    staticClass: "td55"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_vm._v("Braces enclose dittographies (double writings) or other erroneous readings in a manuscript or text.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td40"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_vm._v("{…}")])]), _vm._v(" "), _c('td', {
    staticClass: "td55"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_vm._v("Braces containing three ellipsis points indicate that a textual tradition (i.e., involving more than one manuscript) has lost one or more words in transmission and that the original reading cannot be reconstructed with any confidence.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td40"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_vm._v("†…†")])]), _vm._v(" "), _c('td', {
    staticClass: "td55"
  }, [_c('p', {
    staticClass: "ab-fm"
  }, [_vm._v("Cruces containing three ellipsis points indicate that a reading in an individual manuscript cannot be reconstructed with any confidence.")])])])])])])])])
}]}

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(80),
  /* template */
  __webpack_require__(81),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 81 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "part-title"
  }, [_vm._v("I. Gospels and Related Traditions of New Testament Figures")])])])
}]}

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(83),
  /* template */
  __webpack_require__(84),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 84 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ch-title"
  }, [_vm._v("The Hospitality and Perfume of the Bandit")]), _vm._v(" "), _c('p', {
    staticClass: "ch-subtitle"
  }, [_vm._v("A translation and introduction")]), _vm._v(" "), _c('p', {
    staticClass: "ch-author"
  }, [_vm._v("by Mark Glen Bilby")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The "), _c('em', [_vm._v("Hospitality and Perfume of the Bandit")]), _vm._v(" ("), _c('em', [_vm._v("Hosp. Perf. Band.")]), _vm._v("; "), _c('em', [_vm._v("CANT")]), _vm._v(" 78.3) is a short story interpolated into at least two manuscripts of the "), _c('em', [_vm._v("Gospel of Pseudo-Matthew.")]), _vm._v(" The title is not found in either manuscript. It is instead proposed to accent this story’s distinctiveness vis-à-vis other apocryphal narratives about the “good bandit” (or "), _c('em', [_vm._v("bon larron")]), _vm._v(" or "), _c('em', [_vm._v("gute Schächer")]), _vm._v("). Though one of several medieval backstories about the repentant criminal of Luke 23:40–43, "), _c('em', [_vm._v("Hosp. Perf. Band.")]), _vm._v(" is unique in the way it connects the bandit’s hospitality shown to the Holy Family during their exile in Egypt to the conversion of Mary Magdalene and her anointing of the feet of Jesus.")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The interpolated story appears in certain manuscripts of "), _c('em', [_vm._v("Ps.-Mt.")]), _vm._v(" just after chapter"), _c('em'), _vm._v(" 17, which follows the Gospel of Matthew in relating Herod’s infanticidal command (Matt 2:16) and the angelic warning to Joseph to flee (2:13). The Holy Family encounter the bandit as they travel through the desert on their way to Egypt (v. 1). The bandit is under orders to kill any passersby as a condition for his own survival. The story next details the bandit’s internal dialogue as he puzzles over the dilemma between breaking his bandit gang’s murder pact and killing an old man, a mother, and an infant (2). The bandit finally decides to show them covert sanctuary in his own home. When he first addresses them, he inquires as to their plans, quickly offers them hospitality, and then guides them back to his house where he lives with his wife (3). As the bandit’s wife prepares to bathe their leprous son, the bandit insists instead that the infant Jesus be bathed first; their son’s subsequent bath in the leftover water results in his miraculous healing, leading the bandit to worship Jesus (4). The next day the bandit guides the family as far as a fountain, where Mary washes the garments of the infant Jesus, wringing from them into an alabaster jar a most precious and fragrant perfume, which she gives to the bandit as a reward for his hospitality (5). Later, when the bandit’s family falls into poverty, he sells the perfume at great cost to Mary Magdalene, who is reputed to be a connoisseuse of perfumes (6). When the Magdalene anoints herself with the perfume, it cleanses her body and soul; she uses it subsequently to anoint Jesus in preparation for his death, bringing the ointment’s journey full circle back to Jesus (7). The short story closes with a direct link between the hospitable desert bandit and the criminal who spoke to Jesus on the cross (Luke 23:39–43). "), _c('em', [_vm._v("Ps.-Mt.")]), _vm._v(" 18 then recommences the account of the Holy Family’s flight to Egypt with Jesus taming a cave of dragons.")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_vm._v("Manuscripts and Editions")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', [_vm._v("Hosp. Perf. Band.")]), _vm._v(" appears as an episode in manuscripts of "), _c('em', [_vm._v("Ps.-Mt.")]), _vm._v(", a highly popular and diffuse set of stories for which some two hundred manuscripts survive. Jan Gijsel’s exhaustive conspectus of manuscripts identifies several textual families of "), _c('em', [_vm._v("Ps.-Mt.")]), _vm._v(" and their earliest witnesses: A (9th cent.), P (9th cent.), Q (12th–13th cent.), and R (13th–14th cent.)."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-001",
      "id": "foot_001"
    }
  }, [_vm._v("1")])]), _vm._v(" Another tale of the good bandit, the "), _c('em', [_vm._v("Rebellion of Dimas")]), _vm._v(", appears in a single manuscript of the oldest branch (A"), _c('sup', [_vm._v("1")]), _vm._v("a);"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-002",
      "id": "foot_002"
    }
  }, [_vm._v("2")])]), _vm._v(" "), _c('em', [_vm._v("Hosp. Perf. Band.")]), _vm._v(" appears in two exemplars of the Q"), _c('sup', [_vm._v("3")]), _vm._v(" subfamily (14th–15th cent.):"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-003",
      "id": "foot_003"
    }
  }, [_vm._v("3")])]), _vm._v(" London, British Library, Harley 3199 (12th–14th/15th cent.; Gijsel’s Q"), _c('sup', [_vm._v("3")]), _vm._v("a"), _c('sup', [_vm._v("5")]), _vm._v(", here L); and Vatican, Biblioteca Apostolica Vaticana, Vat. lat. 6300 (15th and 17th cent.; Gijsel’s Q"), _c('sup', [_vm._v("3")]), _vm._v("a"), _c('sup', [_vm._v("7")]), _vm._v(", here V). The good bandit interpolations appear in fols. 104v–106r of the fourteenth- or early fifteenth-century portion of the Harley manuscript and in fols. 118r–119r of the fifteenth-century portion of the Vatican manuscript. In both manuscripts, the texts of "), _c('em', [_vm._v("Ps.-Mt.")]), _vm._v(" continue on to the "), _c('em', [_vm._v("pars altera")]), _vm._v(" (portions of the Latin translation of "), _c('em', [_vm._v("Inf. Gos. Thom.")]), _vm._v("). When Geerard in 1997 published his diplomatic edition of "), _c('em', [_vm._v("Hosp. Perf. Band.")]), _vm._v(", he knew the story only from the Harley manuscript."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-004",
      "id": "foot_004"
    }
  }, [_vm._v("4")])]), _vm._v(" Close study of the two manuscripts reveals that they both rely on an earlier textual tradition—that is, that V does not depend directly on L. The L manuscript is not only chronologically earlier than V but also more faithful textually to their common ancestor. Even across a relatively brief story, clear editorial tendencies emerge in V."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-005",
      "id": "foot_005"
    }
  }, [_vm._v("5")])])]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_vm._v("Literary and Theological Importance")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', [_vm._v("Hosp. Perf. Band.")]), _vm._v(" is one of at least five stories about the so-called good bandit that were interpolated into major apocryphal texts and compilations."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-006",
      "id": "foot_006"
    }
  }, [_vm._v("6")])])]), _vm._v(" "), _c('div', {
    staticClass: "num"
  }, [_c('p', {
    staticClass: "list-num"
  }, [_vm._v("1."), _c('span', {
    staticClass: "space1"
  }, [_c('em', [_vm._v("Reb. Dimas")]), _vm._v(" (= "), _c('em', [_vm._v("CANT")]), _vm._v(" 78.2, also found within "), _c('em', [_vm._v("Ps.-Mt.")]), _vm._v(","), _c('em'), _vm._v(" between chapters 19 and 20 in Namur, Seminary Library, Lat. 80, fols. 13v–15v and 17r–17v): a twelfth-century Latin story featuring the bandit as a procurator’s son and border guard who defies his father by allowing the Holy Family to escape Israel and flee to Egypt."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-007",
      "id": "foot_007"
    }
  }, [_vm._v("7")])])])]), _vm._v(" "), _c('p', {
    staticClass: "list-num"
  }, [_vm._v("2."), _c('span', {
    staticClass: "space1"
  }, [_c('em', [_vm._v("Hosp. Dysmas")]), _vm._v(" (= "), _c('em', [_vm._v("CANT")]), _vm._v(" 78.4, found within manuscripts of the M2 and M3 families of manuscripts of "), _c('em', [_vm._v("Acts of Pilate")]), _vm._v("): a late twelfth- to early fourteenth-century Byzantine Greek account of the Egyptian bandit showing hospitality to the Holy Family, resulting in the healing of his leprous child and his future blessing by Jesus on the cross."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-008",
      "id": "foot_008"
    }
  }, [_vm._v("8")])])])]), _vm._v(" "), _c('p', {
    staticClass: "list-num"
  }, [_vm._v("3."), _c('span', {
    staticClass: "space1"
  }, [_c('em', [_vm._v("Hosp. Oint. Band.")]), _vm._v(" (= "), _c('em', [_vm._v("CANT")]), _vm._v(" 78.1, found within the Arundel form of "), _c('em', [_vm._v("Book about the Birth of the Savior")]), _vm._v(" 111–25): a twelfth- to fourteenth-century Latin story describing how the hospitable Egyptian bandit received healing and wealth from the magical bathwater of Jesus."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-009",
      "id": "foot_009"
    }
  }, [_vm._v("9")])])])]), _vm._v(" "), _c('p', {
    staticClass: "list-num"
  }, [_vm._v("4."), _c('span', {
    staticClass: "space1"
  }, [_c('em', [_vm._v("Leabhar Breac")]), _vm._v(" 131–32 (Dublin, Royal Irish Academy, 23 P 16 [1230]): this famous ca. 1408–1411 manuscript features a brief story about the bandit as a child encountering the infant Jesus in Egypt, a story quite similar to that summarized in Aelred of Rievaulx’s "), _c('em', [_vm._v("De institutione inclusarum")]), _vm._v(" 30."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-010",
      "id": "foot_010"
    }
  }, [_vm._v("10")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Outside of these five interpolations, comparable legends also circulated in several other texts:")]), _vm._v(" "), _c('div', {
    staticClass: "num"
  }, [_c('p', {
    staticClass: "list-num"
  }, [_vm._v("5."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("The "), _c('em', [_vm._v("Narrative of Joseph of Arimathea")]), _vm._v(": a late fourth- to early fifth-century Greek narrative likely composed in Palestine that greatly expands the backstories of both bandits, blames the death of Jesus on the good bandit’s righteous theft of relics from the Jerusalem temple, narrates dialogues and correspondence between Jesus and Demas, and describes Demas as the cross-bearer ("), _c('em', [_vm._v("staurophylax")]), _vm._v(") who accompanies Jesus when he appears to Joseph of Arimathea."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-011",
      "id": "foot_011"
    }
  }, [_vm._v("11")])])])]), _vm._v(" "), _c('p', {
    staticClass: "list-num"
  }, [_vm._v("6."), _c('span', {
    staticClass: "space1"
  }, [_c('em', [_vm._v("CPG")]), _vm._v(" 4877 ("), _c('em', [_vm._v("De cruce et passione")]), _vm._v("): a fourth/fifth-century Palestinian or Syrian Greek sermon/story falsely attributed to John Chrysostom wherein the bandit is a gentile (indeed a relative of Pilate!) and has a vision in the desert leading to his conversion."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-012",
      "id": "foot_012"
    }
  }, [_vm._v("12")])])])]), _vm._v(" "), _c('p', {
    staticClass: "list-num"
  }, [_vm._v("7."), _c('span', {
    staticClass: "space1"
  }, [_c('em', [_vm._v("CPG")]), _vm._v(" 4145.22 ("), _c('em', [_vm._v("In sabbatum sanctum, in passionem domini nostri et latronem")]), _vm._v(") / 4162.3 ("), _c('em', [_vm._v("De satana et morte")]), _vm._v("): a fifth/sixth-century Palestinian sermon/story in Arabic and Georgian with many connections to "), _c('em', [_vm._v("CPG")]), _vm._v(" 4877, but here the bandit’s conversion stems from hearing Jesus preach."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-013",
      "id": "foot_013"
    }
  }, [_vm._v("13")])])])]), _vm._v(" "), _c('p', {
    staticClass: "list-num"
  }, [_vm._v("6."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("The "), _c('em', [_vm._v("Vision of Theophilus")]), _vm._v(": a sixth-century Coptic text featuring a story in which the good bandit (who is Egyptian) and the evil bandit (who is Jewish) steal the Holy Family’s clothes only later to repent and return them."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-014",
      "id": "foot_014"
    }
  }, [_vm._v("14")])])])]), _vm._v(" "), _c('p', {
    staticClass: "list-num"
  }, [_vm._v("7."), _c('span', {
    staticClass: "space1"
  }, [_c('em', [_vm._v("Homily on the Church of the Rock")]), _vm._v(" 31–32 (Coptic/Arabic; 17–18 in the Ethiopic recension): originally created around the sixth century, this story is highly similar to and in the same historical neighborhood as "), _c('em', [_vm._v("Vis. Theo")]), _vm._v("., except that it narrates the evil bandit stealing the infant Jesus along with the Holy Family’s clothes!"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-015",
      "id": "foot_015"
    }
  }, [_vm._v("15")])])])]), _vm._v(" "), _c('p', {
    staticClass: "list-num"
  }, [_vm._v("8."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("Syriac "), _c('em', [_vm._v("History of the Virgin")]), _vm._v(", and its retelling in "), _c('em', [_vm._v("(Arab.) Gos. Inf.")]), _vm._v(" 23: a ca. eighth-century text with a story of the good bandit (here called Titus) bribing the evil bandit (here Dumachus) to prevent the robbery of the Holy Family in Egypt."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-016",
      "id": "foot_016"
    }
  }, [_vm._v("16")])])])]), _vm._v(" "), _c('p', {
    staticClass: "list-num"
  }, [_vm._v("9."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("Arabic "), _c('em', [_vm._v("Apocryphal Gospel of John")]), _vm._v(" 10:1–4 and its translation in the Ethiopic "), _c('em', [_vm._v("Miracles of Jesus")]), _vm._v(" 7:1–4: an originally ca. tenth/eleventh-century story evidencing a selective combination of elements from "), _c('em', [_vm._v("Hist. Vir.")]), _vm._v(" and "), _c('em', [_vm._v("Vis. Theo.")]), _vm._v(", in which the Ethiopic version notably varies from its Arabic predecessor by adding a third bandit character due to a mistranslation."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-017",
      "id": "foot_017"
    }
  }, [_vm._v("17")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Among the nine legends detailed above, "), _c('em', [_vm._v("Hosp. Dysmas")]), _vm._v(" and "), _c('em', [_vm._v("Hosp. Oint. Band.")]), _vm._v(" show the closest similarities to "), _c('em', [_vm._v("Hosp. Perf. Band.")]), _vm._v(" All three of these short stories share three key elements: they focus on the bandit showing the Holy Family hospitality in his home, they note that he has a wife and a child (“little children” in "), _c('em', [_vm._v("Hosp. Oint. Band.")]), _vm._v(" at "), _c('em', [_vm._v("Birth Sav.")]), _vm._v(" 114), and they call attention to one or more miraculous healings resulting from a bath taken by Jesus."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-018",
      "id": "foot_018"
    }
  }, [_vm._v("18")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The Latin "), _c('em', [_vm._v("Hosp. Perf. Band.")]), _vm._v(" should be located literarily and historically just between the earlier Byzantine Greek "), _c('em', [_vm._v("Hosp. Dysmas")]), _vm._v(" and the later Latin "), _c('em', [_vm._v("Hosp. Oint. Band.")]), _vm._v(" From "), _c('em', [_vm._v("Hosp. Dysmas")]), _vm._v(", "), _c('em', [_vm._v("Hosp. Perf. Band.")]), _vm._v(" borrows the plot of the bandit exemplifying hospitality and having a leprous child healed by Jesus’s leftover bathwater. To "), _c('em', [_vm._v("Hosp. Oint. Band")]), _vm._v("., "), _c('em', [_vm._v("Hosp. Perf. Band.")]), _vm._v(" lends the idea of the bandit receiving a sacred, relic-like ointment of great financial benefit,"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-019",
      "id": "foot_019"
    }
  }, [_vm._v("19")])]), _vm._v(" as well as the parallel between dangerous bandits and dangerous dragons all being subdued by the infant Jesus."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-020",
      "id": "foot_020"
    }
  }, [_vm._v("20")])]), _vm._v(" The composition of "), _c('em', [_vm._v("Birth. Sav.")]), _vm._v(", drawing on "), _c('em', [_vm._v("Ps.-Mt.")]), _vm._v(" and other infancy traditions, goes back at least to the eighth century."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-021",
      "id": "foot_021"
    }
  }, [_vm._v("21")])]), _vm._v(" It was apparently sometime in the thirteenth or fourteenth century that the Arundel form of "), _c('em', [_vm._v("Birth. Sav.")]), _vm._v(" developed its story ("), _c('em', [_vm._v("Hosp. Oint. Band.")]), _vm._v(") based on the one newly interpolated into "), _c('em', [_vm._v("Ps.-Mt.")]), _vm._v(" ("), _c('em', [_vm._v("Hosp. Perf. Band.")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The appearance or omission of other themes evident among the legends of the good bandit further elucidates the unique combination of characteristics on display in "), _c('em', [_vm._v("Hosp. Perf. Band.")]), _vm._v(" Quite in keeping with the Byzantine Greek "), _c('em', [_vm._v("Hosp. Dysmas")]), _vm._v(" and most medieval Latin stories of the bandit, but quite apart from its Coptic and Ethiopic predecessors listed above, "), _c('em', [_vm._v("Hosp. Perf. Band.")]), _vm._v(" makes no mention of the bandit actually engaging in banditry, perhaps in an effort to elevate the cult of Dysmas. Like "), _c('em', [_vm._v("Hosp. Dysmas")]), _vm._v(" and earlier Eastern traditions such as "), _c('em', [_vm._v("(Arab.) Gos. Inf")]), _vm._v("., "), _c('em', [_vm._v("Hosp. Perf. Band.")]), _vm._v(" pictures the infant Jesus as a holy object and instrument with which Mary the Mother dispenses miracles. That said, "), _c('em', [_vm._v("Hosp. Perf. Band.")]), _vm._v(" does stand apart from "), _c('em', [_vm._v("Hosp. Dysmas")]), _vm._v(" and other earlier traditions in that no miraculous motivation, either from Jesus or Mary, is noted as the reason for his compassion. It is instead his own internal reflection and dialogue, his own weighing of various courses of actions, and his own sense of right and wrong that lead him to aid the family. The bandit in "), _c('em', [_vm._v("Hosp. Perf. Band.")]), _vm._v(" reflects morally—perhaps even philosophically—endeavoring to do what is right for its own sake. "), _c('em', [_vm._v("Hosp. Perf. Band.")]), _vm._v(" may share with "), _c('em', [_vm._v("Reb. Dimas")]), _vm._v(", "), _c('em', [_vm._v("Leabhar Breac")]), _vm._v(","), _c('em'), _vm._v(" and Aelred of Rievaulx’s "), _c('em', [_vm._v("De institutione inclusarum")]), _vm._v(" the theme of the bandit being a righteous rebel, but here it is rebellion not against his father but instead against his fellow bandits. Another somewhat similar feature between these texts is that "), _c('em', [_vm._v("Hosp. Perf. Band.")]), _vm._v(", like "), _c('em', [_vm._v("Reb. Dimas")]), _vm._v(" and "), _c('em', [_vm._v("Leabhar Breac")]), _vm._v(", locates the bandit’s encounter with the Holy Family en route"), _c('em'), _vm._v(" between Judea and Egypt.")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_vm._v("Original Language, Date, and Provenance")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The only two sources for "), _c('em', [_vm._v("Hosp. Perf. Band.")]), _vm._v(" are Latin manuscripts, and there is no reason to think the story’s original language was anything other than Latin. The earliest manuscript, L, was created in the fourteenth century, providing a firm "), _c('em', [_vm._v("terminus ad quem")]), _vm._v(". The two sources for "), _c('em', [_vm._v("Hosp. Oint. Band")]), _vm._v("., which appears to be an adaptation of "), _c('em', [_vm._v("Hosp. Perf. Band.")]), _vm._v(", also are dated to the fourteenth century. A late twelfth-century "), _c('em', [_vm._v("terminus post quem")]), _vm._v(" is reasonable on the basis of the dependence of "), _c('em', [_vm._v("Hosp. Perf. Band.")]), _vm._v(" on "), _c('em', [_vm._v("Hosp. Dysmas")]), _vm._v(", which may well have circulated around this time when the M2 recension of "), _c('em', [_vm._v("Acts Pil.")]), _vm._v(" first appeared in the manuscript record."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-022",
      "id": "foot_022"
    }
  }, [_vm._v("22")])]), _vm._v(" An interpolation during this time frame nicely fits broader trends in "), _c('em', [_vm._v("Ps.-Mt.")]), _vm._v(" manuscripts in France, most especially the addition of the “pars altera,” as for example in BnF Lat. 11867 (13th cent., Marmoutier). The theme of the bandit as a righteous rebel is certainly already well in evidence by the twelfth century in Aelred of Rievaulx’s "), _c('em', [_vm._v("De institutione inclusarum")]), _vm._v(", and "), _c('em', [_vm._v("Reb. Dimas")]), _vm._v(" and "), _c('em', [_vm._v("Leabhar Breac")]), _vm._v(" also attest to this theme around the same time. Still, while this thematic connection shows a certain historical proximity, it does not currently allow for firmer historical conclusions, given the lack of clear evidence of dependence in either direction between "), _c('em', [_vm._v("Hosp. Perf. Band.")]), _vm._v(" and these three texts.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("According to the British Library catalog record, the portion of L containing "), _c('em', [_vm._v("Ps.-Mt.")]), _vm._v(" (fols. 95r–126v) comes from “France or England,” and the remaining pages (fols. 2r–94v) are “probably” from France."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-023",
      "id": "foot_023"
    }
  }, [_vm._v("23")])]), _vm._v(" The French songs concluding the fifteenth-century portion of V suggest an original French provenance, even though that manuscript made its way to Rome and was supplemented with a speech given there at the Accademia degli Humoristi in 1616, as noted in the manuscript dedication. The preponderance of evidence points to an originally French provenance for the story.")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_vm._v("Translation")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("To date, "), _c('em', [_vm._v("Hosp. Perf. Band.")]), _vm._v(" has appeared only in Geerard’s Latin edition of L. This translation, the first in any modern language, is based on my forthcoming edition, the first collated critical edition using both manuscripts currently known. Erroneous readings by Geerard are indicated in the notes. The text is here divided into seven verses for ease of reading and citation.")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_vm._v("Sigla")]), _vm._v(" "), _c('div', {
    staticClass: "inside"
  }, [_c('table', [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "td10"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("G")])]), _vm._v(" "), _c('td', {
    staticClass: "td85"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Geerard, “Gute Schächer”")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td10"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("L")])]), _vm._v(" "), _c('td', {
    staticClass: "td85"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("London, British Library, Harley 3199")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td10"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("V")])]), _vm._v(" "), _c('td', {
    staticClass: "td85"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Vatican, Biblioteca Apostolica Vaticana, Vat. lat. 6300")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "bib-h1"
  }, [_vm._v("Bibliography")]), _vm._v(" "), _c('p', {
    staticClass: "bib-h2"
  }, [_vm._v("EDITIONS AND TRANSLATIONS")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Geerard, Maurice. “Gute Schächer: Ein neues unediertes Apokryphon.” Pages 85–89 in "), _c('em', [_vm._v("La spiritualité de l’univers byzantin dans le verbe et l’image.")]), _vm._v(" Edited by Kristoffel Demoen and Jeannine Vereecken. Instrumenta Patristica 30. Steenbrugis: In Abbatia S. Petri; Turnhout: Brepols, 1997. (Diplomatic edition based on L.)")]), _vm._v(" "), _c('p', {
    staticClass: "bib-h2"
  }, [_vm._v("STUDIES")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Bilby, Mark G. "), _c('em', [_vm._v("As the Bandit Will I Confess You: Luke 23, 39–43 in Early Christian Interpretation.")]), _vm._v(" Turnhout: Brepols; Strasbourg: University of Strasbourg, 2013. (Further bibliography may be found here.)")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Billiard, Carine. “Présentation et description du manuscrit 80 (Grand Séminaire Salzinnes-Namur).” 2 vols. Mémoire de licence en histoire, Louvain-la-Neuve, 1984.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Esbroeck, Michel van. “Une homélie inédite éphrémienne sur le bon larron en grec, géorgien et arabe.” "), _c('em', [_vm._v("AnBoll")]), _vm._v(" 101 (1983): 327–62.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Geerard, Maurice. “Le bon larron, un apocryphe inédit.” Pages 355–63 in "), _c('em', [_vm._v("Philologia Sacra: Biblische und patristische Studien für Hermann J. Frede und Walter Thiele zu ihrem siebzigsten Geburtstag")]), _vm._v(", Band 2, "), _c('em', [_vm._v("Apocryphen, Kirchenväter, Verschiedenes")]), _vm._v(". Edited by Roger Gryson. GLB 24.2. Freiburg: Herder, 1993.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Gijsel, Jan. "), _c('em', [_vm._v("Libri de nativitate Mariae: Pseudo-Matthaei Evangelium, textus et commentarius, Libellus de nativitate sanctae Mariae, textus et commentarius")]), _vm._v(". CCSA 9. Turnhout: Brepols, 1997.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Gounelle, Rémi. “Une légende apocryphe relatant la rencontre du bon larron et de la sainte famille en Égypte ("), _c('em', [_vm._v("BHG")]), _vm._v(" 2119y).” "), _c('em', [_vm._v("AnBoll")]), _vm._v(" 121 (2003): 241–72.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Kretzenbacher, Leopold. “St. Dismas, der rechte Schächter: Legenden, Kultstätten und Verehrungsformen in Innerösterreich.” "), _c('em', [_vm._v("Zeitschrift des Historischen Vereines für Steiermark")]), _vm._v(" 42 (1951): 119–39.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Philippart, Guy. “Le Pseudo-Matthieu au risque de la critique textuelle.” "), _c('em', [_vm._v("Scriptorium")]), _vm._v(" 38, no. 1 (1984): 121–31.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/foot.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_001",
      "id": "foot-001"
    }
  }, [_vm._v("1")]), _vm._v(". Gijsel, "), _c('em', [_vm._v("Libri de nativitate Mariae")]), _vm._v(", 71–97; additional manuscripts are listed in Gijsel, “Nouveaux témoins du pseudo-Matthieu,” "), _c('em', [_vm._v("Sacris erudiri")]), _vm._v(" 41 (2002): 273–300.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_002",
      "id": "foot-002"
    }
  }, [_vm._v("2")]), _vm._v(". Geerard, “Le bon larron, un apocryphe inédit,” 360. My translation of "), _c('em', [_vm._v("Reb. Dimas")]), _vm._v(" appears in "), _c('em', [_vm._v("MNTA")]), _vm._v(" 2:13–22.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_003",
      "id": "foot-003"
    }
  }, [_vm._v("3")]), _vm._v(". Gijsel, "), _c('em', [_vm._v("Libri de nativitate Mariae")]), _vm._v(", 163–65.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_004",
      "id": "foot-004"
    }
  }, [_vm._v("4")]), _vm._v(". Geerard, “Gute Schächer.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_005",
      "id": "foot-005"
    }
  }, [_vm._v("5")]), _vm._v(". My forthcoming critical edition provides full notes and corrects nine errors in Geerard’s diplomatic edition of L. V shows a tendency to make spelling corrections (e.g., line 13 "), _c('em', [_vm._v("possitis")]), _vm._v(" L : "), _c('em', [_vm._v("positis")]), _vm._v(" V; line 31 "), _c('em', [_vm._v("alabanstri")]), _vm._v(" L : "), _c('em', [_vm._v("alabastri")]), _vm._v(" V), grammar normalizations (e.g., lines 8–9 "), _c('em', [_vm._v("interficiam")]), _vm._v(" and "), _c('em', [_vm._v("interfecero")]), _vm._v(" L : "), _c('em', [_vm._v("interficio")]), _vm._v(" V), terminological standardizations (e.g., lines 22–23 "), _c('em', [_vm._v("infantem")]), _vm._v(" and "), _c('em', [_vm._v("filium")]), _vm._v(" L : "), _c('em', [_vm._v("infantulum")]), _vm._v(" V), and pious emendations (e.g., line 21 "), _c('em', [_vm._v("pulcer")]), _vm._v(" L : "), _c('em', [_vm._v("pulcrior")]), _vm._v(" V).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_006",
      "id": "foot-006"
    }
  }, [_vm._v("6")]), _vm._v(". For a comparable overview of the sources, see Bilby, "), _c('em', [_vm._v("MNTA")]), _vm._v(" 1:41–44. A correction should be noted here: that "), _c('em', [_vm._v("Hosp. Perf. Band.")]), _vm._v(" is not, like "), _c('em', [_vm._v("Reb. Dimas")]), _vm._v(", placed “immediately after the "), _c('em', [_vm._v("Ps.-Mt.")]), _vm._v(" account of the palm tree” (ibid., 43), but a few paragraphs before, between "), _c('em', [_vm._v("Ps.-Mt.")]), _vm._v(" 17 and 18. Thus the connection between the prostrating bandit and the bending date palm in "), _c('em', [_vm._v("Ps.-Mt.")]), _vm._v(" 20 apparent in "), _c('em', [_vm._v("Reb. Dimas")]), _vm._v(" may not be in mind in "), _c('em', [_vm._v("Hosp. Perf. Band")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_007",
      "id": "foot-007"
    }
  }, [_vm._v("7")]), _vm._v(". Introduction and translation by Bilby in "), _c('em', [_vm._v("MNTA")]), _vm._v(" 2:13–22.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_008",
      "id": "foot-008"
    }
  }, [_vm._v("8")]), _vm._v(". Introduction and translation by Bilby in "), _c('em', [_vm._v("MNTA")]), _vm._v(" 1:39–51.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_009",
      "id": "foot-009"
    }
  }, [_vm._v("9")]), _vm._v(". Text and translation in Ehrman and Pleše, "), _c('em', [_vm._v("AG")]), _vm._v(" 147–55.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_010",
      "id": "foot-010"
    }
  }, [_vm._v("10")]), _vm._v(". The Irish text and English translation appear in Martin McNamara et al., "), _c('em', [_vm._v("Apocrypha Hiberniae I. Evangelia Infantiae")]), _vm._v(", CCSA 13 (Turnhout: Brepols, 2001), 404–7; for the summation of the similar tale by Aelred of Rievaulx, see Anselm Hoste and Charles H. Talbot, eds., "), _c('em', [_vm._v("Aelredi Rievallensis Opera omnia 1: Opera ascetica")]), _vm._v(", CCCM 1 (Turnhout: Brepols, 1971), 664.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_011",
      "id": "foot-011"
    }
  }, [_vm._v("11")]), _vm._v(". The Greek text based on four manuscripts is found in Constantin Tischendorf, "), _c('em', [_vm._v("Evangelia Apocrypha")]), _vm._v(" (2nd ed.; Leipzig: Mendelssohn, 1876), 459–70, and an English translation by Ehrman and Pleše of the Tischendorf edition appears in "), _c('em', [_vm._v("AG")]), _vm._v(", 572–85. Rémi Gounelle is preparing a new critical edition of this text for CCSA.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_012",
      "id": "foot-012"
    }
  }, [_vm._v("12")]), _vm._v(". Introduction and edition in Michel van Esbroeck, “Une homélie inédite éphrémienne sur le bon larron en grec, géorgien et arabe,” "), _c('em', [_vm._v("AnBoll")]), _vm._v(" 101 (1983): 327–62.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_013",
      "id": "foot-013"
    }
  }, [_vm._v("13")]), _vm._v(". Also presented in van Esbroeck, “Une homélie inédite éphrémienne.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_014",
      "id": "foot-014"
    }
  }, [_vm._v("14")]), _vm._v(". Alphonse Mingana, “Woodbrook Studies 5: "), _c('em', [_vm._v("Vision of Theophilus")]), _vm._v(",” "), _c('em', [_vm._v("BJRL")]), _vm._v(" 13 (1929): 383–474 (repr. in "), _c('em', [_vm._v("Woodbrooke Studies: Christian Documents in Syriac, Arabic and Garshūni")]), _vm._v(","), _c('em'), _vm._v(" vol. 3 [Cambridge: Heffer & Sons, 1931], 1–92). For the story of the bandit, see pp. 19–20, 26–29.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_015",
      "id": "foot-015"
    }
  }, [_vm._v("15")]), _vm._v(". Anne Boud’hors and Ramez Boutros, "), _c('em', [_vm._v("L’homélie sur l’Église du Rocher")]), _vm._v(","), _c('em'), _vm._v(" PO 49.1 (Turnhout: Brepols, 2001), 38–47 (Coptic text and translation), 132–37 (Arabic text and translation). The Ethiopic text and translation appear in Gérard Colin, "), _c('em', [_vm._v("L’homélie sur l’Église du Rocher")]), _vm._v(","), _c('em'), _vm._v(" PO 49.2 (Turnhout: Brepols, 2001), 248–53.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_016",
      "id": "foot-016"
    }
  }, [_vm._v("16")]), _vm._v(". The relevant section is translated into English in Elliott, "), _c('em', [_vm._v("ANT")]), _vm._v(", 105. The precursor to "), _c('em', [_vm._v("(Arab.) Gos. Inf")]), _vm._v(", the Syriac "), _c('em', [_vm._v("Hist. Vir")]), _vm._v("., appears in Ernest A. W. Budge, "), _c('em', [_vm._v("The History of the Blessed Virgin Mary and the History of the Likeness of Christ")]), _vm._v(" (London: Luzac, 1899). For the story of the bandit, see pp. 59–60.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_017",
      "id": "foot-017"
    }
  }, [_vm._v("17")]), _vm._v(". For the Arabic "), _c('em', [_vm._v("(Apocr.) Gos. John")]), _vm._v(", the precursor to the "), _c('em', [_vm._v("Miracles of Jesus")]), _vm._v(", see the edition of Giovanni Galbiati, "), _c('em', [_vm._v("Iohannis Evangelium apocryphum arabice")]), _vm._v(" (Milan: In aedibus Mondadorianis, 1957), 52–55 (the page numbers apply to both the Arabic text and the Latin translation). For the text and translation of the Ethiopic "), _c('em', [_vm._v("Miracles of Jesus")]), _vm._v(", see Sylvain Grébaut, "), _c('em', [_vm._v("Les Miracles de Jésus")]), _vm._v(", PO 12.4 (Paris: Firmin-Didot, 1919), 618–23. The Ethiopic version introduces a number of significant errors and changes. Most notable for our purposes is the addition of the third bandit character (“Gamhour”) because of a mistranslation of the Arabic word for “multitude” ("), _c('em', [_vm._v("gamhur")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_018",
      "id": "foot-018"
    }
  }, [_vm._v("18")]), _vm._v(". Bilby, "), _c('em', [_vm._v("MNTA")]), _vm._v(" 1:43.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_019",
      "id": "foot-019"
    }
  }, [_vm._v("19")]), _vm._v(". "), _c('em', [_vm._v("Hosp. Oint. Band.")]), _vm._v(" ("), _c('em', [_vm._v("Birth Sav.")]), _vm._v(") 123–24.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_020",
      "id": "foot-020"
    }
  }, [_vm._v("20")]), _vm._v(". The parallel is explicit in "), _c('em', [_vm._v("Hosp. Oint. Band.")]), _vm._v(" ("), _c('em', [_vm._v("Birth Sav.")]), _vm._v(") 116; see Ehrman and Pleše, "), _c('em', [_vm._v("AG")]), _vm._v(", 148–49. It is implicit in "), _c('em', [_vm._v("Hosp. Perf. Band.")]), _vm._v(" in the placement of the bandit’s short story just before the episode of the cave of dragons ("), _c('em', [_vm._v("Ps.-Mt.")]), _vm._v(" 18).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_021",
      "id": "foot-021"
    }
  }, [_vm._v("21")]), _vm._v(". The earliest known manuscript is Montpellier, Bibliothèque de la Faculté de medicine, 55 (ca. 800) (= Gijsel Ja1 [M"), _c('sup', [_vm._v("1")]), _vm._v("]). See Gijsel, "), _c('em', [_vm._v("Libri de nativitate Mariae")]), _vm._v(", 213.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_022",
      "id": "foot-022"
    }
  }, [_vm._v("22")]), _vm._v(". Gounelle, “Une légende apocryphe,” 247–48; see also Bilby, "), _c('em', [_vm._v("MNTA")]), _vm._v(" 1:44–45.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_023",
      "id": "foot-023"
    }
  }, [_vm._v("23")]), _vm._v(". Online at "), _c('a', {
    attrs: {
      "href": "http://www.bl.uk/manuscripts/FullDisplay.aspx?ref=Harley_MS_3199",
      "target": "_blank"
    }
  }, [_vm._v("http://www.bl.uk/manuscripts/FullDisplay.aspx?ref=Harley_MS_3199")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "ch-titlep"
  }, [_vm._v("The Hospitality and Perfume of the Bandit")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("How Mary and Joseph fled to Egypt with Jesus and about the bandit whom they encountered in the desert."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-024",
      "id": "foot_024"
    }
  }, [_vm._v("a")])])]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_vm._v("Introduction")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('sup', [_vm._v("1")]), _vm._v("(17.3a) At the time when blessed Mary and Joseph headed through the desert, they encountered a bandit who was hiding in a forest. To him it had been commanded by the other bandits, if he encountered anyone, to kill him immediately and bring them the spoils taken"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-025",
      "id": "foot_025"
    }
  }, [_vm._v("b")])]), _vm._v(" from him. Otherwise, he could not live with them.")]), _vm._v(" "), _c('p', {
    staticClass: "sidenote"
  }, [_vm._v("Matt 2:14")]), _vm._v(" "), _c('p', {
    staticClass: "sidenote"
  }, [_c('em', [_vm._v("(Arab.) Gos. Inf.")]), _vm._v(" 23; "), _c('em', [_vm._v("Birth Sav.")]), _vm._v(" 111")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_vm._v("The bandit ponders his plan")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('sup', [_vm._v("2")]), _vm._v("(17.3b) When"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-026",
      "id": "foot_026"
    }
  }, [_vm._v("c")])]), _vm._v(" it happened that Joseph and the blessed Mary encountered him on the desert road, when that bandit saw them,"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-027",
      "id": "foot_027"
    }
  }, [_vm._v("d")])]), _vm._v(" he reflected intensively within himself and said,"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-028",
      "id": "foot_028"
    }
  }, [_vm._v("e")])]), _vm._v(" “O Lord God, what shall I do? I have sworn to kill all men whom I discover"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-029",
      "id": "foot_029"
    }
  }, [_vm._v("f")])]), _vm._v(" in this desert. If I forswear,"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-030",
      "id": "foot_030"
    }
  }, [_vm._v("g")])]), _vm._v(" it is wrong. If I kill this old man, what benefit is it to me? If I kill the boy’s mother and the boy, it is even worse. But"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-031",
      "id": "foot_031"
    }
  }, [_vm._v("h")])]), _vm._v(" what will I do? I will lead them covertly to my house, and I will show love toward them, because they will not find hospitality"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-032",
      "id": "foot_032"
    }
  }, [_vm._v("i")])]), _vm._v(" in a desert.”")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_vm._v("The bandit inquires and offers hospitality")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('sup', [_vm._v("3")]), _vm._v("(17.3c) And he said to them, “Brothers,"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-033",
      "id": "foot_033"
    }
  }, [_vm._v("j")])]), _vm._v(" why do you head through this desert with this lady and with"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-034",
      "id": "foot_034"
    }
  }, [_vm._v("k")])]), _vm._v(" this boy and with this family—in a place where you will not find a place or houses where you can rest with this infant and with your animals? Where are you going? Where are you headed?” Joseph responded to him and said, “Our journey is to Egypt.” The bandit responded to him, “My brothers,"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-035",
      "id": "foot_035"
    }
  }, [_vm._v("a")])]), _vm._v(" I ask,"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-036",
      "id": "foot_036"
    }
  }, [_vm._v("b")])]), _vm._v(" if it pleases you, to come with me to my hospitality at this late hour and be guests with me. For long is the road"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-037",
      "id": "foot_037"
    }
  }, [_vm._v("c")])]), _vm._v(" and harsh through this desert.” And they left with him and entered into a certain small house in which he"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-038",
      "id": "foot_038"
    }
  }, [_vm._v("d")])]), _vm._v(" and his wife was living."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-039",
      "id": "foot_039"
    }
  }, [_vm._v("e")])])]), _vm._v(" "), _c('p', {
    staticClass: "sidenote"
  }, [_c('em', [_vm._v("Hosp. Dysmas")]), _vm._v(" 3; "), _c('em', [_vm._v("Birth Sav.")]), _vm._v(" 117")]), _vm._v(" "), _c('p', {
    staticClass: "sidenote"
  }, [_c('em', [_vm._v("Hosp. Dysmas")]), _vm._v(" 4")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_vm._v("The healing of the bandit’s child")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('sup', [_vm._v("4")]), _vm._v("(17.3d) From this wife he had a little son, but"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-040",
      "id": "foot_040"
    }
  }, [_vm._v("f")])]), _vm._v(" he was quite leprous, indeed scabby. But since the hour for bathing his son had now approached, the bandit said to his wife, “Allow this infant to be bathed first, because he is beautiful,"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-041",
      "id": "foot_041"
    }
  }, [_vm._v("g")])]), _vm._v(" and you can bathe our infant afterward, because he is scabby and quite leprous.” But after the blessed Mary had bathed her son"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-042",
      "id": "foot_042"
    }
  }, [_vm._v("h")])]), _vm._v(" Jesus, as the bandit’s son was bathed in the same water, immediately he was totally cleansed from all filth and from every infirmity. And the bandit said to his wife, “Truly this is the Son of God.” And he fell prostrate on the ground and worshiped him.")]), _vm._v(" "), _c('p', {
    staticClass: "sidenote"
  }, [_c('em', [_vm._v("Hosp. Dysmas")]), _vm._v(" 5")]), _vm._v(" "), _c('p', {
    staticClass: "sidenote"
  }, [_c('em', [_vm._v("Birth Sav.")]), _vm._v(" 117")]), _vm._v(" "), _c('p', {
    staticClass: "sidenote"
  }, [_c('em', [_vm._v("(Arab.) Gos. Inf.")]), _vm._v(" 17–18, 27, 28, 31, 32, 33")]), _vm._v(" "), _c('p', {
    staticClass: "sidenote"
  }, [_vm._v("Matt 14:33; 27:54; Mark 15:39")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_vm._v("The bandit’s protection and Mary’s reward")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('sup', [_vm._v("5")]), _vm._v("(17.3e) As is proper, on the next day they rose up and left. And the bandit likewise went with them to show them the way and to help them until midday until they came to a certain fountain. But"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-043",
      "id": "foot_043"
    }
  }, [_vm._v("i")])]), _vm._v(" after they reached the fountain, they stayed there. And there the blessed Mary washed the little garments of her boy"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-044",
      "id": "foot_044"
    }
  }, [_vm._v("j")])]), _vm._v(" Jesus, and from the water she wrung from them she filled one vessel of alabaster. And immediately this water produced a precious and exceedingly fragrant perfume, whose aroma no one can narrate in the least. Afterward, the blessed Mary took this vessel and said to the bandit, “Brothers,"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-045",
      "id": "foot_045"
    }
  }, [_vm._v("k")])]), _vm._v(" take this vessel, because to us you exhibited great service. Though we do not have gold or silver to give you, I give you this great vessel because you are able to present what is inside it as if it were gold assayed in the market.”")]), _vm._v(" "), _c('p', {
    staticClass: "sidenote"
  }, [_c('em', [_vm._v("Hosp. Dysmas")]), _vm._v(" 8")]), _vm._v(" "), _c('p', {
    staticClass: "sidenote"
  }, [_c('em', [_vm._v("(Arab.) Gos. Inf.")]), _vm._v(" 24; "), _c('em', [_vm._v("Birth Sav.")]), _vm._v(" 117")]), _vm._v(" "), _c('p', {
    staticClass: "sidenote"
  }, [_vm._v("Mark 14:3 par.")]), _vm._v(" "), _c('p', {
    staticClass: "sidenote"
  }, [_vm._v("Acts 3:6")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_vm._v("The bandit sells the perfume to Mary Magdalene")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('sup', [_vm._v("6")]), _vm._v("(17.3f) Then"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-046",
      "id": "foot_046"
    }
  }, [_vm._v("l")])]), _vm._v(" the bandit received it from the hands of the blessed Mary and it served him on many occasions, such as when the time came that he and his wife fell into great and terrible poverty. Yet at that time, he was reminded of the word that the blessed Mary had spoken to him about the vessel that she had given him. Then he went and took it and carried it to a castle where Mary Magdalene was at"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-047",
      "id": "foot_047"
    }
  }, [_vm._v("a")])]), _vm._v(" that time making a living from sin. And he said, “There is in this country"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-048",
      "id": "foot_048"
    }
  }, [_vm._v("b")])]), _vm._v(" no other person who uses precious"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-049",
      "id": "foot_049"
    }
  }, [_vm._v("c")])]), _vm._v(" perfumes more than Mary Magdalene. I will go and I will sell it for as much as I can.” And he went to her and sold it"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-050",
      "id": "foot_050"
    }
  }, [_vm._v("d")])]), _vm._v(" for a lot of money.")]), _vm._v(" "), _c('p', {
    staticClass: "sidenote"
  }, [_c('em', [_vm._v("Birth Sav.")]), _vm._v(" 123–24")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_vm._v("Conclusion: The aftermath of the perfume in the Gospels")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('sup', [_vm._v("7")]), _vm._v("(17.3g) And immediately when Mary Magdalene anointed herself with"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-051",
      "id": "foot_051"
    }
  }, [_vm._v("e")])]), _vm._v(" the aforementioned perfume, all bodily pollution and desire for sinning left her."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-052",
      "id": "foot_052"
    }
  }, [_vm._v("f")])]), _vm._v(" What was left over she kept for later, until the time when she was converted and anointed the feet of the Lord and Savior at the time of the passion. And this was the bandit whom the Jews crucified with Jesus our Lord, the one who said, “"), _c('em', [_vm._v("Remember me")]), _vm._v(", Lord, "), _c('em', [_vm._v("when")]), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-053",
      "id": "foot_053"
    }
  }, [_vm._v("g")])]), _vm._v(" "), _c('em', [_vm._v("you come into your kingdom.")]), _vm._v("”")]), _vm._v(" "), _c('p', {
    staticClass: "sidenote"
  }, [_vm._v("Luke 8:2; Mark 16:9")]), _vm._v(" "), _c('p', {
    staticClass: "sidenote"
  }, [_vm._v("Mark 14:3–9 par.")]), _vm._v(" "), _c('p', {
    staticClass: "sidenote"
  }, [_vm._v("Luke 23:42; "), _c('em', [_vm._v("Hosp. Dysmas")]), _vm._v(" 9")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/foot.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_024",
      "id": "foot-024"
    }
  }, [_vm._v("a")]), _vm._v(". L starts the narrative on a new page and places this title in red at the top right of fol. 105v. The interpolation in V is seamlessly interwoven into "), _c('em', [_vm._v("Ps.-Mt.")]), _vm._v(" without title.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_025",
      "id": "foot-025"
    }
  }, [_vm._v("b")]), _vm._v(". V: “taken immediately.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_026",
      "id": "foot-026"
    }
  }, [_vm._v("c")]), _vm._v(". V: “Next.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_027",
      "id": "foot-027"
    }
  }, [_vm._v("d")]), _vm._v(". L lacks “them.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_028",
      "id": "foot-028"
    }
  }, [_vm._v("e")]), _vm._v(". V: “he thought intensively and said within himself.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_029",
      "id": "foot-029"
    }
  }, [_vm._v("f")]), _vm._v(". V: “I might discover.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_030",
      "id": "foot-030"
    }
  }, [_vm._v("g")]), _vm._v(". V: “swear by God.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_031",
      "id": "foot-031"
    }
  }, [_vm._v("h")]), _vm._v(". G omits “but” ("), _c('em', [_vm._v("sed")]), _vm._v("), present in L and V.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_032",
      "id": "foot-032"
    }
  }, [_vm._v("i")]), _vm._v(". V: “any other hospitality.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_033",
      "id": "foot-033"
    }
  }, [_vm._v("j")]), _vm._v(". G reads “brother” ("), _c('em', [_vm._v("frater")]), _vm._v("), but L and V have the plural ("), _c('em', [_vm._v("fratres")]), _vm._v("). The plural in this interpolation may foreshadow "), _c('em', [_vm._v("Ps.-Mt.")]), _vm._v(" 18, where “three male servants” and “one maidservant” are mentioned as traveling companions.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_034",
      "id": "foot-034"
    }
  }, [_vm._v("k")]), _vm._v(". V lacks “with.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_035",
      "id": "foot-035"
    }
  }, [_vm._v("a")]), _vm._v(". G again erroneously reads “brother.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_036",
      "id": "foot-036"
    }
  }, [_vm._v("b")]), _vm._v(". V: “ask you.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_037",
      "id": "foot-037"
    }
  }, [_vm._v("c")]), _vm._v(". V: “the road is long.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_038",
      "id": "foot-038"
    }
  }, [_vm._v("d")]), _vm._v(". V: “the bandit.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_039",
      "id": "foot-039"
    }
  }, [_vm._v("e")]), _vm._v(". V: “were living.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_040",
      "id": "foot-040"
    }
  }, [_vm._v("f")]), _vm._v(". V: “and.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_041",
      "id": "foot-041"
    }
  }, [_vm._v("g")]), _vm._v(". V: “more beautiful.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_042",
      "id": "foot-042"
    }
  }, [_vm._v("h")]), _vm._v(". V: “infant.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_043",
      "id": "foot-043"
    }
  }, [_vm._v("i")]), _vm._v(". V: “and.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_044",
      "id": "foot-044"
    }
  }, [_vm._v("j")]), _vm._v(". V: “son.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_045",
      "id": "foot-045"
    }
  }, [_vm._v("k")]), _vm._v(". V: “Brother.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_046",
      "id": "foot-046"
    }
  }, [_vm._v("l")]), _vm._v(". V: “Whereupon.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_047",
      "id": "foot-047"
    }
  }, [_vm._v("a")]), _vm._v(". V: “in.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_048",
      "id": "foot-048"
    }
  }, [_vm._v("b")]), _vm._v(". G reads “province” ("), _c('em', [_vm._v("prouincia")]), _vm._v("), but V and L have “country” ("), _c('em', [_vm._v("patria")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_049",
      "id": "foot-049"
    }
  }, [_vm._v("c")]), _vm._v(". V: “more precious.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_050",
      "id": "foot-050"
    }
  }, [_vm._v("d")]), _vm._v(". V: “the same perfume.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_051",
      "id": "foot-051"
    }
  }, [_vm._v("e")]), _vm._v(". V: “from.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_052",
      "id": "foot-052"
    }
  }, [_vm._v("f")]), _vm._v(". It should be noted that the woman in Luke 7:36–50 is not identified as Mary Magdalene.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_053",
      "id": "foot-053"
    }
  }, [_vm._v("g")]), _vm._v(". L: “as.”")])])])
}]}

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(86),
  /* template */
  __webpack_require__(87),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 87 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ch-title"
  }, [_vm._v("The Gospel of the Twelve Apostles")]), _vm._v(" "), _c('p', {
    staticClass: "ch-subtitle"
  }, [_vm._v("A new translation and introduction")]), _vm._v(" "), _c('p', {
    staticClass: "ch-author"
  }, [_vm._v("by James Toma")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The "), _c('em', [_vm._v("Gospel of the Twelve Holy Apostles Together with Each of Their Revelations")]), _vm._v(" ("), _c('em', [_vm._v("Gos. Twelve [Syr.]")]), _vm._v(") is a late seventh-century apocalyptic text in Syriac written in the context of early Islam during the second "), _c('em', [_vm._v("fitna")]), _vm._v(" (i.e., major civil war). The work is divided into four sections: the gospel itself, recounting the birth, life, and resurrection of Jesus, followed by three subsequent revelations—to Simeon Cephas (Peter), James son of Zebedee, and his brother John “the Little.” As a whole, "), _c('em', [_vm._v("Gos. Twelve")]), _vm._v(" is a reinforcement of the monophysite faith that attempts to affirm its supremacy (anti-Chalcedonian) and reproach apostates for converting to Islam. The significance of the work is that it shows the suffering and issues Syriac-speaking Christians (mainly the Western Syrians or Jacobite Church) experienced as their conquerors invaded their lands and levied burdensome taxes, leading many to eventually convert to Islam in order to flee persecution and the brutish forms of sustainability. The Syriac "), _c('em', [_vm._v("Gos. Twelve")]), _vm._v(" is to be distinguished from a “Gospel of the Twelve” known to Origen (in "), _c('em', [_vm._v("Hom. Luc.")]), _vm._v(" 1) and echoed in a number of later writers, as well as other texts by the same title thought to be in use by the Ebionites, Kukeans, and the Manicheans."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-001",
      "id": "foot_001"
    }
  }, [_vm._v("1")])]), _vm._v(" Eugène Revillout published a group of Coptic fragments under the title “Gospel of the Twelve,” but most of these fragments belong to a "), _c('em', [_vm._v("Homily on the Life of Jesus and His Love of the Apostles")]), _vm._v("."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-002",
      "id": "foot_002"
    }
  }, [_vm._v("2")])])]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', [_vm._v("Gos. Twelve")]), _vm._v(" survives in Estrangelo Syriac, though its title claims it was translated first from Hebrew into Greek and then into Syriac. Likely this is a fiction created to lend the work some antiquity. The gospel (chaps. 1–4) opens with a scene of the annunciation from the canonical gospels (Matt 1:18) and dates the event to “the year 309 of Alexander son of Philip” (Seleucid calendar). Then follows a recounting of the nativity of Jesus, the flight and return of the Holy Family from Egypt (1:2–11), Jesus’s ministerial activity (2:1–13), crucifixion (2:15–18), resurrection (2:18–23), and ascension (3:14). Two additional postresurrection appearances of Jesus are included. In the first, the apostles gather together and pray to God, requesting the ability to speak in different languages in order to spread the word of God “across the four quarters.” The apostles’ prayers are answered, and they are each able to understand different languages (chap. 3). The second appearance of Jesus takes place when the apostles have another request before they begin to evangelize, which is to be able to know what may occur in the end times (chap. 4). A voice commands them to go to the mountain of the transfiguration, and after a seven-day journey of prayer and fasting, they reach the mountain and three of the twelve apostles receive the apocalyptic revelations.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The first revelation, to Peter (chap. 5), deals with the church and its faithful who lose their favor by departing from traditional orthodox teachings. Peter sees a period “full of offenses and evils and sins and falsehood” (5:3) where the majority of people are “cunning, crafty, and perverse” (5:4) but only a minority call upon the name of Jesus and are believers (5:5). As time passes, belief and true teachings of orthodoxy will gradually decline, and many call out to God and want to perform miracles but will not be able to because of their little faith. A select few among them “understand his beloved Son and do not deny the Spirit” but face persecution and death for their beliefs (5:6–9). Those who remain will “trample on the faith and they will say perverse things and they will divide the Lord” (5:11). As a result, the Lord will deliver them into the hands of outside rulers who will pillage their lands and require tribute (5:14). Yet they will continue to blaspheme and sow division and corruption (5:18–23). Relief will come only once they reunite as “one true flock and church” (5:24).")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The second revelation is given to James, the son of Zebedee (chap. 6), and is concerned with the fate of Jerusalem. James sees the destruction of the temple and its city by “a man praised in name and fearsome in appearance” (6:4), likely Emperor Titus. The people of the city will be killed or banished because they “have not known the Son” (6:6–7). Another man (likely Constantine) will arise to restore Jerusalem and build sanctuaries to the Lord, but will die after completing the construction of a “great and renowned house” (6:9–12). His successor will bring peace to the world (6:13–14).")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The final and most elaborate revelation is of John the Little, son of Zebedee (chap. 7), who continues the story with a description of the wars in the East and the ascendancy of Islam. John is held in high esteem by the author, who describes a man in white on a horse coming to John and telling him that “more than your first fellows, you have known the mystery of the Savior” (7:2–4). The angel of God brings him scrolls and places a substance in his mouth that gives him prophetic abilities (7:6–9). John then describes a series of kingdoms that cohere with the cycle from Daniel. First comes a king of the north who “subdues all of the peoples by the marvelous sign that appeared to him in heaven” (7:13)—again, likely a reference to Constantine—and after him the rise of the kings of the Romans, who fall in battle to the Persians (7:16), who in turn are handed over to the Medes (7:20). A short time later, God will destroy the Medes (7:20) and then “suddenly [there] shall be fulfilled the prophecy of Daniel” (7:22) as a final empire rises: the kings of the south (i.e., the Arabs). They are described as a “hideous people, and their appearance and customs are like those of women”; a warrior (likely Muhammad) will rise from among them and they consider him a prophet (7:23), though others mock him and question his words (7:24). Under the direction of God, the kings of the south will reach world domination and overthrow Persia and Rome. These rulers will be wicked and cruel to all the people they rule over, imposing heavy and unbearable tribute, plundering booty, and taking many captives from among the people (7:25–33). But after “one great week and a half” (7:34, 36), God will turn away from the southern kings because of their immorality and abuse of Christians. He will bring them into severe division, as they “become two parties,” led by two kings, who battle one another for control (7:42–45). After a period, God will again raise up the kings of the north, who will unite the world against the southern kings, pushing them back to the place from where they came (7:46–48). There they will suffer from “evil times and plagues” and will no longer be able to wage war (7:51). After a small lacuna in the text, the revelation ends with the angel telling John to hand over his revelation to the other apostles (7:52).")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_vm._v("Manuscripts and Editions")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', [_vm._v("Gos. Twelve")]), _vm._v(" exists in a single manuscript: Cambridge Mass., Harvard Houghton Library, Syr. 93. fols. 47r–58r, dated paleographically to ca. 750. J. Rendel Harris announced the discovery of the text “amongst a pile of Syriac leaves which had arrived from the East” in a brief article for the "), _c('em', [_vm._v("Contemporary Review")]), _vm._v(" in 1899; the article includes also a preliminary translation of much of the text (chaps. 1–4 and 7)."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-003",
      "id": "foot_003"
    }
  }, [_vm._v("3")])]), _vm._v(" Harris restored the order of the pages to create an edition with detailed commentary and complete English translation in 1900."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-004",
      "id": "foot_004"
    }
  }, [_vm._v("4")])]), _vm._v(" Nothing more is known about the origins of the manuscript. The text is inserted in the midst of a collection of monophysite Syriac classics of the seventh century, many of which are "), _c('em', [_vm._v("er")]), _c('em', [_vm._v("ō")]), _c('em', [_vm._v("tapokriseis")]), _vm._v(", or “question-and-answer” texts, and is followed immediately by an excerpt from the "), _c('em', [_vm._v("Doctrina Addai")]), _vm._v(". Much of the manuscript is lost (the first two quires, a large portion of the middle, and the last several pages of quires 8 and 9–14), and some portions of the "), _c('em', [_vm._v("Gos. Twelve")]), _vm._v(" folios are damaged in the outer margin (at 4:13, 18–19; 7:23, 29–30, 35, 43–44, 52). A second hand in Serto script has made some emendations to the text and overwritten some of the faded words.")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_vm._v("Original Language, Date, and Provenance")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The title claims that "), _c('em', [_vm._v("Gos. Twelve")]), _vm._v(" was composed in Hebrew, from where it made its way to Greek and thereafter to Syriac. No Hebrew or Greek versions of the text exist, though there is mention made of a certain “Gospel of the Twelve” by Origen and scholars have speculated that the gospel that Epiphanius reports as being in use by the Ebionites also went by that name. However, Harris concludes that there is no reason to associate "), _c('em', [_vm._v("Gos. Twelve")]), _vm._v(" with this earlier gospel and offers evidence to suggest that "), _c('em', [_vm._v("Gos. Twelve")]), _vm._v(" is a Syriac composition."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-005",
      "id": "foot_005"
    }
  }, [_vm._v("5")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The dating of the text was first proposed by Harris, who claimed that the work was composed during the mid-eighth century and that the codex may even be the autograph copy."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-006",
      "id": "foot_006"
    }
  }, [_vm._v("6")])]), _vm._v(" His argument is based on a section within the work which says that “twelve renowned kings will rise up from them (i.e., the Arabs), as it is written in the Law, when God spoke to Abraham and said, ‘Behold! Concerning Ishmael your son I have heard you, and it (the south) will produce twelve princes with many others’ ” (7:27). Harris sees this as a reference to twelve caliphs who ruled after Muhammad, as mentioned in Bukhari, Hadith No. 7222. However, as Han J. W. Drijvers points out, the number twelve held symbolic meaning for both Judaism and Christianity, and this symbolism was carried into Islam as well."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-007",
      "id": "foot_007"
    }
  }, [_vm._v("7")])]), _vm._v(" Drijvers and others have settled on a date of composition before 705, the year of the death of "), _c('span', {
    staticClass: "chr"
  }, [_vm._v("ʿ")]), _vm._v("Abd al-Malik, the fifth Umayyad caliph."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-008",
      "id": "foot_008"
    }
  }, [_vm._v("8")])]), _vm._v(" The revelation of John the Little mentions heavy taxation and tribute imposed on Christians; Drijvers believes this may be due to the tax reforms and census issued during "), _c('span', {
    staticClass: "chr"
  }, [_vm._v("ʿ")]), _vm._v("Abd al-Malik’s period of consolidation and recovery after the end of the second civil war (692)."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-009",
      "id": "foot_009"
    }
  }, [_vm._v("9")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Likely the text originated in Edessa, the center of Syriac literature during the period."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-010",
      "id": "foot_010"
    }
  }, [_vm._v("10")])]), _vm._v(" The dating method used (“year 309 of Alexander” [1:2]) follows Syrian conventions, and most of the literature in the codex has links to Edessa, such as the "), _c('em', [_vm._v("Doctrina Addai")]), _vm._v(" and Jacob of Edessa’s theological responses (fols. 1r–45v). Thus, "), _c('em', [_vm._v("Gos. Twelve")]), _vm._v(" is a Syriac composition of Jacobite (West Syrian) origin, likely written in Edessa sometime during the late seventh or early eighth centuries.")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_vm._v("Historical and Literary Contexts")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', [_vm._v("Gos.")]), _vm._v(" "), _c('em', [_vm._v("Twelve")]), _vm._v(" offers insights on some of the earliest Christian encounters with Islam, several centuries prior to Muslim forces reaching mid-Europe. The Islamic conquests throughout the seventh century brought about permanent change to the political environment of the Near East and also of the Mediterranean. The effects that the new ideology had on the preexisting populations and various religious communities were dramatic and quite severe: poll taxes at unprecedented heights were levied onto non-Muslims (i.e., Christians, Jews, Mandaeans, and others), and properties were confiscated and looted, all of which motivated mass conversions to the new faith. The conquests begun under Muhammad were suspended once the third caliph of the Islamic state, "), _c('span', {
    staticClass: "chr"
  }, [_vm._v("ʿ")]), _vm._v("Uthman, was killed in 646. For the next five years, a period of civil war commenced that severely weakened the Muslims as two factions soon emerged: the followers of Ali (Shi"), _c('span', {
    staticClass: "chr"
  }, [_vm._v("ʿ")]), _vm._v("ites) and the supporters of Mu"), _c('span', {
    staticClass: "chr"
  }, [_vm._v("ʿ")]), _vm._v("awiya (Sunnis)."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-011",
      "id": "foot_011"
    }
  }, [_vm._v("11")])]), _vm._v(" After the civil wars came to a pause in 651, order was restored until the death of Mu"), _c('span', {
    staticClass: "chr"
  }, [_vm._v("ʿ")]), _vm._v("awiya and the succession of his son Yazid I in 680, who reignited the leadership contest. The tensions of the second civil war lasted much longer than the first. The Shi"), _c('span', {
    staticClass: "chr"
  }, [_vm._v("ʿ")]), _vm._v("ite leader Husayn, son of Ali, refused to recognize Yazid I. The second civil war came to an end in 692 once "), _c('span', {
    staticClass: "chr"
  }, [_vm._v("ʿ")]), _vm._v("Abd al-Malik, the fifth Umayyad caliph, squashed all his opponents and restored order to the Islamic empire."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-012",
      "id": "foot_012"
    }
  }, [_vm._v("12")])]), _vm._v(" Thereafter, tax reforms and military organization resumed with great intensity, having detrimental effects on the Christian populations along with other religious communities.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('span', {
    staticClass: "chr"
  }, [_vm._v("ʿ")]), _vm._v("Abd al-Malik also financed the construction of the Dome of the Rock, a mosque built on top of the Temple Mount, where the symbolic and holy Christian city of Jerusalem had received a renowned legacy due to Constantine’s construction of the Church of the Holy Sepulchre."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-013",
      "id": "foot_013"
    }
  }, [_vm._v("13")])]), _vm._v(" The city transformed into a largely Muslim-controlled location, with its mosque promoting Islam as the succeeding faith both to Judaism and to Christianity."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-014",
      "id": "foot_014"
    }
  }, [_vm._v("14")])]), _vm._v(" As Robert G. Hoyland writes, “Muslims could persuasively argue they were now God’s chosen people, since they reached world domination; however, this taunt strikes some nerve for the Syriac-Christians, who in turn had to react or respond to this problem: by presenting apostasy as all part of God’s plan.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-015",
      "id": "foot_015"
    }
  }, [_vm._v("15")])]), _vm._v(" In this environment, "), _c('em', [_vm._v("Gos.")]), _vm._v(" "), _c('em', [_vm._v("Twelve")]), _vm._v(" offers a narrative defending the monophysite Christian cause and faith for its community, while attempting to theologically explain the inconvenient and brutish conditions that Islam has brought on them. Many Christians soon began converting to Islam to alleviate their struggles, which "), _c('em', [_vm._v("Gos.")]), _vm._v(" "), _c('em', [_vm._v("Twelve")]), _vm._v(" describes as")]), _vm._v(" "), _c('p', {
    staticClass: "ex"
  }, [_vm._v("he who has will think in those days as though he had not, and he who builds and sells as though he had no gain.… The angel of wrath will descend and kindle evil among them […] between them and within them. They will be lifted up one [against] the other and make and become two parties (i.e., Shi"), _c('span', {
    staticClass: "chr"
  }, [_vm._v("ʿ")]), _vm._v("ites and Sunnis). Each of them will seek to call himself king and there will be war between them. There will be many killings by them and among them, and much blood will be shed among them at the fountain of the waters. (7:32, 43–45)")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Thus, Syrian Christians combated the forces of apostasy from within their communities by presenting a polemic that reproached recent apostates and also affirmed the primacy of the righteous and true monophysite doctrine of Christianity. In addition, the threat posed by Islam was addressed through conventions used in apocalyptic literature to find meaning in persecution.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('em', [_vm._v("Gos.")]), _vm._v(" "), _c('em', [_vm._v("Twelve")]), _vm._v(" was not the first attempt by Christians to counter the growing threat of Islam. Several apocalyptic texts from the seventh century are echoed in "), _c('em', [_vm._v("Gos.")]), _vm._v(" "), _c('em', [_vm._v("Twelve")]), _vm._v(": the "), _c('em', [_vm._v("Apocalypse of Pseudo-Ephrem")]), _vm._v(", Yo"), _c('span', {
    staticClass: "chr"
  }, [_vm._v("ḥ")]), _vm._v("annan (John) bar Penkaye’s "), _c('em', [_vm._v("Resh Melle")]), _vm._v(", and the "), _c('em', [_vm._v("Apocalypse of Pseudo-Methodius")]), _vm._v(". "), _c('em', [_vm._v("Apoc. Ps.-Ephrem")]), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-016",
      "id": "foot_016"
    }
  }, [_vm._v("16")])]), _vm._v(" is a pseudepigraphical and apocalyptic Syriac "), _c('em', [_vm._v("memra")]), _vm._v(" (i.e., symmetrical homily) attributed to Ephrem the Syrian. While the date of the text is contested, suggestions range between the late sixth and mid-seventh centuries;"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-017",
      "id": "foot_017"
    }
  }, [_vm._v("17")])]), _vm._v(" however, reflections of the environmental shifts of the Near East in the mid-seventh century place it close to the end of that range. In brief, "), _c('em', [_vm._v("Apoc. Ps.-Ephrem")]), _vm._v(" begins by proclaiming that the end times are approaching and that “the righteous ones will suffer indignities” and “the Assyrians will gain authority over the region of the Romans.” In this context, the text describes the Byzantine-Sassanian Wars of 602–629, which led to the destruction of the Church of the Holy Sepulchre and the True Cross being carried off to Ctesiphon."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-018",
      "id": "foot_018"
    }
  }, [_vm._v("18")])]), _vm._v(" After a reference to the attack on Ctesiphon in 623, "), _c('em', [_vm._v("Apoc. Ps.-Ephrem")]), _vm._v(" predicts that “a people will go forth from the desert, the son[s] of Hagar, Sarah’s maidservant” (61) and defeat both the Sassanian and the Roman armies."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-019",
      "id": "foot_019"
    }
  }, [_vm._v("19")])]), _vm._v(" Thereafter, the “descendants of Hagar” (i.e., Arabs) will soon begin to pillage and “exact tribute” from the Christians (65). This tragedy that prevails over Christendom is ordained by God in order to punish the Christians for going astray and falling into sin in the world. The Arabs eventually anger God, as they severely persecute the Christians, so he releases the hidden armies that Alexander the Great once pacified. In addition, the armies of Gog and Magog (Ezek 38–39) rise to power and defeat the sons of Hagar. After these events unfold, the antichrist appears, and judgment day transpires, leading to the destruction and end of the world. "), _c('em', [_vm._v("Apoc. Ps.-Ephrem")]), _vm._v(" appears to have been written during the divisions of the first civil war (646–651). It interprets Islam as a temporary force and assumes the conquerors will shortly pass.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('em', [_vm._v("Gos.")]), _vm._v(" "), _c('em', [_vm._v("Twelve")]), _vm._v(" and "), _c('em', [_vm._v("Apoc. Ps.-Ephrem")]), _vm._v(" share certain features that suggest the gospel was influenced by the apocalypse. First, "), _c('em', [_vm._v("Apoc. Ps.-Ephrem")]), _vm._v(" mentions the rise of the Arabs (raised by God in order to punish the Christians), which is a theme that is adopted by "), _c('em', [_vm._v("Gos.")]), _vm._v(" "), _c('em', [_vm._v("Twelve")]), _vm._v(", wherein John the Little’s revelation states that the south (the name given to the Arabs based on Daniel’s prophecy) “will prosper, and by the hoofs of the horses of their armies, they will trample down Persia and will subdue it and destroy Rome” (7:25). Another similarity between the two works is the rise and deliverance of a Western ruler who is sent by God to alleviate the persecution of Christians and defeat the Arabs. As Kenneth Baxter Wolf puts it: “One of the most desperate (and at the same time safest) ways to make sense out of the dramatic contraction of the Roman Empire first in the West and then in the East was to think apocalyptically, imagining that one day, at the end of history, a Roman emperor would emerge who would, once and for all, cast out that bona fide ‘Christian world empire’ that Constantine’s conversion had made seem inevitable.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-020",
      "id": "foot_020"
    }
  }, [_vm._v("20")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Yo"), _c('span', {
    staticClass: "chr"
  }, [_vm._v("ḥ")]), _vm._v("annan (John) bar Penkaye’s "), _c('em', [_vm._v("Resh Melle")]), _vm._v(" (Main Points) was composed in 687. It contains a history of Yo"), _c('span', {
    staticClass: "chr"
  }, [_vm._v("ḥ")]), _vm._v("annan’s vivid experiences during the first two civil wars but focuses on the events of the second."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-021",
      "id": "foot_021"
    }
  }, [_vm._v("21")])]), _vm._v(" The work offers a perspective on Mu"), _c('span', {
    staticClass: "chr"
  }, [_vm._v("ʿ")]), _vm._v("awiya’s reign before the succession of his son Yazid I and states the following: “Justice flourished in his time, and there was great peace in the regions under his control.… Once M"), _c('span', {
    staticClass: "chr"
  }, [_vm._v("ʿ")]), _vm._v("away had come to the throne, the peace throughout the world was such that we have never heard, either from our fathers or from our grandparents, or seen that there had ever been any like it.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-022",
      "id": "foot_022"
    }
  }, [_vm._v("22")])]), _vm._v(" However, the situation prior to Mu"), _c('span', {
    staticClass: "chr"
  }, [_vm._v("ʿ")]), _vm._v("awiya’s consolidation of power entailed highly decisive battles and events. The first of Mu"), _c('span', {
    staticClass: "chr"
  }, [_vm._v("ʿ")]), _vm._v("awiya’s rivals was Husayn, the son of Ali, who refused to recognize Yazid’s power. Husayn swiftly conducted his forces against Mu"), _c('span', {
    staticClass: "chr"
  }, [_vm._v("ʿ")]), _vm._v("awiya but perished in the Battle of Karbala (680). The Shi"), _c('span', {
    staticClass: "chr"
  }, [_vm._v("ʿ")]), _vm._v("ite leadership passed to Mukhtar, an associate of Ali, who was exiled to Mecca after Husayn’s death. While in Mecca, Mukhtar joined forces with "), _c('span', {
    staticClass: "chr"
  }, [_vm._v("ʿ")]), _vm._v("Abd Allah ibn Zubayr against Yazid. The two rebels would continue to be a problem for Yazid, and the next major revolts continued until their deaths. Many viewed Yazid as impious for killing Husayn, who was Muhammad’s grandson and son-in-law."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-023",
      "id": "foot_023"
    }
  }, [_vm._v("23")])]), _vm._v(" He lost much of his support from the Hijaz and other provinces, but once the revolts stirred up by Ibn Zubayr intensified, Yazid marched down to Medina and pillaged it during the Battle of Harar (683). In order to suppress resistance further, Mecca was then invaded, and the Kaaba was razed to the ground. In that same year, Yazid died and was succeeded by his son Mu"), _c('span', {
    staticClass: "chr"
  }, [_vm._v("ʿ")]), _vm._v("awiya II, though he died within the year (683). Ibn Zubayr declared himself caliph but was opposed by Marwan, a well-respected leader from the Umayyad family. The two eventually clashed, and the supporters of Ibn Zubayr were defeated at Marj Rahit. Marwan’s acceptance as caliph increased as he advanced his power in Syria and Palestine and also seized Egypt from Ibn Zubayr’s governor in 685. Marwan’s son, "), _c('span', {
    staticClass: "chr"
  }, [_vm._v("ʿ")]), _vm._v("Abd al-Malik, succeeded him and marked a secure base for the restoration of the Umayyad dynasty. Mukhtar was able to consolidate his own power once he defeated "), _c('span', {
    staticClass: "chr"
  }, [_vm._v("ʿ")]), _vm._v("Ubayd Allah ibn Zayid (the killer of Husayn’s cousin) near Mosul in the Battle of Khazir (686). Mukhtar’s control of Iraq and Kufa was challenged by Mus"), _c('span', {
    staticClass: "chr"
  }, [_vm._v("ʿ")]), _vm._v("ab ibn Zubayr (brother of Ibn Zubayr) as he attempted to take Kufa. Mukhtar’s forces were defeated at Madhar by Mus"), _c('span', {
    staticClass: "chr"
  }, [_vm._v("ʿ")]), _vm._v("ab’s forces; eventually they took Kufa and Mukhtar was killed in 687.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("By 687, when "), _c('em', [_vm._v("Resh Melle")]), _vm._v(" was composed, troubles arose in Syria, Hijaz, and Iraq, especially since major contestation among the Muslim leadership began waging large-scale interregional wars. To make matters more complex, the Christian stronghold of Nisibis had been taken by Mukhtar’s regiments. The internal divisions and civil unrest between Muslims soon became interpreted by Yo"), _c('span', {
    staticClass: "chr"
  }, [_vm._v("ḥ")]), _vm._v("annan and many of his contemporaries as a sign from God that the end of Arab rule was approaching."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-024",
      "id": "foot_024"
    }
  }, [_vm._v("24")])]), _vm._v(" Like "), _c('em', [_vm._v("Apoc. Ps.-Ephrem")]), _vm._v(", Yo"), _c('span', {
    staticClass: "chr"
  }, [_vm._v("ḥ")]), _vm._v("annan’s work views the Arabs as a temporary force sent to punish the Christians for their sins and provides further details on the corruption his own church was facing. The "), _c('em', [_vm._v("Resh Melle")]), _vm._v(" calls on his Christian community to repent and ask for forgiveness in order for God to save his people and deliver them from their oppressors.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('em', [_vm._v("Resh Melle")]), _vm._v(" and "), _c('em', [_vm._v("Gos. Twelve")]), _vm._v(" have much in common. First, they both mention a degenerating clergy. According to Simon’s revelation, “in the offices of the church there will be disturbers and slanderers and haters of each other, lovers of money and destroyers of order, and those who do not observe the commandments” (5:18). Another similarity includes the division among the Arabs as the cause for their eventual fall, which John the Little’s revelation expresses as God’s wrath being directed against the “kings of the south” (i.e., Arabs) by dividing them into two parties (7:44). The difference between the two works, however, is the manner in which the political presence of the Arabs is interpreted. For Yo"), _c('span', {
    staticClass: "chr"
  }, [_vm._v("ḥ")]), _vm._v("annan, the Arabs are viewed more closely to "), _c('em', [_vm._v("Apoc. Ps.-Ephrem")]), _vm._v(", who sees the conquerors as a temporary oppressor and as a force that will eventually vanish from the land, but not until Christians repent. However, "), _c('em', [_vm._v("Gos.")]), _vm._v(" "), _c('em', [_vm._v("Twelve")]), _vm._v(" acknowledges the conquerors as a presence that will not immediately pass, not until all Christians including Chalcedonian and Nestorian “heretics” acknowledge the supremacy and conform to the liturgical practices of the monophysite doctrine—when “there will be a flock and church and baptism, true and one” (5:25)."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-025",
      "id": "foot_025"
    }
  }, [_vm._v("25")])]), _vm._v(" Hence, the emphasis is placed not on the decline of the Arabs but on the need for Christians to repent and unite under monophysite Christianity.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('em', [_vm._v("Apoc. Ps.-Meth.")]), _vm._v(" was produced sometime during the end of the seventh century and became one of the most circulated apocalyptic texts of its time."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-026",
      "id": "foot_026"
    }
  }, [_vm._v("26")])]), _vm._v(" The established date for the work is sometime in 691/692, shortly after the restoration of the Umayyad authority in Mesopotamia and, as Han Drijvers notes, “when "), _c('span', {
    staticClass: "chr"
  }, [_vm._v("ʿ")]), _vm._v("Abd al-Malik’s tax reforms and census and the recent construction of the Dome of the Rock in Jerusalem caused mass conversions to Islam among the Monophysite population of northern Mesopotamia.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-027",
      "id": "foot_027"
    }
  }, [_vm._v("27")])]), _vm._v(" "), _c('em', [_vm._v("Apoc. Ps.-Meth.")]), _vm._v(" starts by dividing the world into seven ages, with the Arabs (“sons of Hagar”) appearing in the fifth age. The Arabs, as it prophesizes, will eventually gain power and oppress the Christians, and this occurs for their sins, which God ordains, though only until their oppressors become trampled by the Israelite judge Gideon. The work emphasizes Christian persecution and injustices, as the Christians become victims to enslavement for “ten weeks of the year.” However, in the final age of time (the seventh), a Western figure with features resembling both Alexander the Great and Emperor Constantine is raised by God, and the Danielic scheme of the four successive empires (interpreted as Macedonia, Rome, Byzantium, and Africa-Rome) is inserted into the narrative. Then doomsday occurs and the antichrist succeeds the final ruler. The final kingdom is Greek (via a connection between Alexander and Ethiopia), not Arab, since "), _c('em', [_vm._v("Apoc. Ps.-Meth.")]), _vm._v(" views the “Ishmaelite” conquerors as merely scourges sent forth by God in order to correct the behavior of Christians.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The composition of "), _c('em', [_vm._v("Apoc. Ps.-Meth.")]), _vm._v(" is closer to the time of "), _c('em', [_vm._v("Gos. Twelve")]), _vm._v(", so the similarities between these two works are of particular value. Both use Daniel’s prophecy (see "), _c('em', [_vm._v("Gos. Twelve")]), _vm._v(" 7:22) and include the motif of the emergence of a Western deliverer. In "), _c('em', [_vm._v("Gos.")]), _vm._v(" "), _c('em', [_vm._v("Twelve")]), _vm._v(", the deliverer is a man from the seed of Constantine (6:13) who leads the kings of the north against the “southern spirit,” forcing it to “return to the place from where it came” (7:48). In contrast to "), _c('em', [_vm._v("Apoc. Ps.-Meth.")]), _vm._v(", "), _c('em', [_vm._v("Gos. Twelve")]), _vm._v(" disregards references involved with the "), _c('em', [_vm._v("Alexander Romance")]), _vm._v(" and instead keeps true to the Christian emperor: Constantine the Great. The grand scheme for "), _c('em', [_vm._v("Apoc. Ps.-Meth.")]), _vm._v(" is that it views the Arab conquerors as soon to be defeated by the Byzantines, who will go to war with the Arabs in a period of schism and Islamic political instability. But soon after the text’s composition, "), _c('span', {
    staticClass: "chr"
  }, [_vm._v("ʿ")]), _vm._v("Abd al-Malik’s and Justinian II’s armies finally went to war in 692 and the Byzantine forces suffered a horrific loss in Armenia, “and this called for a different approach in religious terms.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-028",
      "id": "foot_028"
    }
  }, [_vm._v("28")])]), _vm._v(" This new approach was needed to reaffirm Christian hope, reinterpret the political situation, reproach apostates, and keep the current Christians from following in their footsteps.")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_vm._v("Theological Considerations")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Each of the revelations granted to the apostles focuses on a theme of concern for late antique Syrian Christians. Peter’s vision holds an anti-dyophysite character and is concerned with monophysite orthodoxy’s miserable state,"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-029",
      "id": "foot_029"
    }
  }, [_vm._v("29")])]), _vm._v(" James’s central theme involves the Holy City of Jerusalem as a Christian city,"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-030",
      "id": "foot_030"
    }
  }, [_vm._v("30")])]), _vm._v(" and John’s deals directly with the problems experienced by Christians living under Islamic dominance."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-031",
      "id": "foot_031"
    }
  }, [_vm._v("31")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The revelation to Peter mentions Christians who “divide our Lord” (5:11)—perhaps a direct attack against Nestorianism with its claim that Jesus had two natures."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-032",
      "id": "foot_032"
    }
  }, [_vm._v("32")])]), _vm._v(" The orthodox faith will witness severe persecution, Peter says, warning that “there will rise up against them bribed judges and also bribed deniers.… After these (things) will have happened, faith will cease from the world and truthfulness will come to an end” (5:8, 10). Those who hold to the correct doctrine are separated from the others and, though few in number, “ask and are heard, because their hearts speak the truth and know God, and they understand his beloved Son and do not deny the Spirit” (5:7). As the persecution continues, the dyophysites will return to monophysite orthodoxy, and all will become “a flock and church and baptism, true and one” (5:25). The tribulations facing the church will come to an end, and those that call on the Lord will live."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-033",
      "id": "foot_033"
    }
  }, [_vm._v("33")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The revelation of James is mainly concerned with Jerusalem and its symbolic relevance for Christianity. He begins with a description of the destruction of the Second Temple, a crisis that he blames on the Jews who “blasphemed against the name of our Lord Jesus” and “crucified and killed <him>” (6:3). James moves on to discuss a ruler that will arise: “he will establish his edicts, and settle it, and build in it consecrated and renowned sanctuaries to the Lord. They will come from the limits and ends of the world; and all those who hear the name of the Lord and know his praises will worship there the Holy Lord” (6:9–10). These venerations appear to be Constantine’s building programs in Jerusalem."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-034",
      "id": "foot_034"
    }
  }, [_vm._v("34")])]), _vm._v(" They will include the construction of yet another temple, “with gold of Ophir, and gemstones of Havilah. Its name and renown will go out and be renowned more than all the houses of the world” (6:12). Likely these are to be understood as the Church of the Holy Sepulchre and the showcasing of the True Cross."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-035",
      "id": "foot_035"
    }
  }, [_vm._v("35")])]), _vm._v(" In addition, the same ruler will die before the completion of the temple; however, James’s revelation reveals that “from his seed will rise a successor, and will burden the chief men with many evils” (6:13). This interest in sacred sites in Jerusalem may be a reaction to the construction of the Dome of the Rock under "), _c('span', {
    staticClass: "chr"
  }, [_vm._v("ʿ")]), _vm._v("Abd al-Malik. In doing so, “"), _c('span', {
    staticClass: "chr"
  }, [_vm._v("ʿ")]), _vm._v("Abd al-Malik was announcing that the religion of the conquerors was to be seen as the successor of both Judaism and Christianity.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-036",
      "id": "foot_036"
    }
  }, [_vm._v("36")])]), _vm._v(" James’s revelation is intended to bring hope to those who witness "), _c('span', {
    staticClass: "chr"
  }, [_vm._v("ʿ")]), _vm._v("Abd al-Malik’s project that Christianity will eventually win victory over the Arabs through the heir of Constantine who “will have great and mighty authority and the world will be governed in his days with great tranquility” (6:13)."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-037",
      "id": "foot_037"
    }
  }, [_vm._v("37")])]), _vm._v(" James’s vision at once denies the claims of both Jews and Muslims for supremacy over the Holy City.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The final revelation, of John the Little, delves into the current political environment of Islam and the prophecy of this empire’s decay. John interprets these events through Daniel’s account of the statue made from four minerals (Dan 2:31–45). Daniel’s interpretation of the monarch’s dream views each of the minerals as four distinct empires, usually identified as Babylon, Media, Persia, and Macedonia. The fourth, Daniel says, will “crush all of these kingdoms and bring them to an end, and it shall stand forever” (Dan. 2:44). This prophecy is adapted in "), _c('em', [_vm._v("Gos. Twelve")]), _vm._v(" to suit what is occurring in the author’s day. Here the first empire is the Romans, beginning with the reign of Constantine the Great (“a man who subdues all of the peoples by the marvelous sign that appeared to him in heaven” [7:13])."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-038",
      "id": "foot_038"
    }
  }, [_vm._v("38")])]), _vm._v(" His successors will commit cruel and evil acts before God, causing them to decline; they are succeeded by the Sassanian Persians (7:14–17). However, the Sassanians will also do evil and be short-lived, so God will raise the Medes, the third empire, who in due time also will be guilty of unruly behavior that causes them to fall (7:18–21). The final empire is the Arab Muslims,"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-039",
      "id": "foot_039"
    }
  }, [_vm._v("39")])]), _vm._v(" identified as the kings of the south, a phrase also used in Daniel, though to describe a Syrian king (see Dan 11:5). John’s revelation claims, “There will come from it a hideous people whose appearance and customs are like those of women. From among them will rise up a warrior, whom they call a prophet. And they will be brought into his hands” (7:22–23). The reference here to the final kingdom is in tune with the rise of Islam and its founder Muhammad."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-040",
      "id": "foot_040"
    }
  }, [_vm._v("40")])]), _vm._v(" Their dominance is said to last “one great week and a half” (7:34), which is ten and a half years."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-041",
      "id": "foot_041"
    }
  }, [_vm._v("41")])]), _vm._v(" Once the end of their rule approaches, the Muslims will be severely weakened through internal division and “become two parties” (7:44)—a reference to the conflict between Shi"), _c('span', {
    staticClass: "chr"
  }, [_vm._v("ʿ")]), _vm._v("ites and Sunnis. The weakening of the Muslim rulers will provide an opportunity for a man of the north to step forward and restore peace: “Then he will assemble with him all of the peoples of the world, and he will go out against him and destroy and ruin his armies and take captive their sons, daughters, and wives. And there will fall upon them a bitter and evil trembling. The Lord will cause the southern spirit to return to the place from where it came” (7:47–48). The rise of the final ruler who brings justice and peace to the world, however, does not require battle with the Muslims, since they will become weak through their own divisions. The eventual decay of the Muslims indicates that the author of "), _c('em', [_vm._v("Gos. Twelve")]), _vm._v(" views the conquerors as a temporary force and his role in writing is to demonstrate to his readers that their foe will soon fade away.")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_vm._v("Translation")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The following translation is based on Harvard Syr. 93 with an eye to the edition and translation by Harris and to direct examination of the codex. Chapter and verse divisions have been introduced.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-h1"
  }, [_vm._v("Bibliography")]), _vm._v(" "), _c('p', {
    staticClass: "bib-h2"
  }, [_vm._v("EDITIONS AND TRANSLATIONS")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Erbetta, Mario. "), _c('em', [_vm._v("Gli Apocrifi del nuovo Testamento")]), _vm._v(". 3 vols. in 4. Turin: Marietti, 1966–1981. (Italian translation in vol. 3, pp. 431–40).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Harris, J. Rendel. "), _c('em', [_vm._v("The Gospel of the Twelve Apostles together with the Apocalypses of each one of them.")]), _vm._v(" Cambridge: Cambridge University Press, 1900. ("), _c('em', [_vm._v("Editio princeps")]), _vm._v(", text pp. 1–21 [in Syriac numbering], translation pp. 25–39.)")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("———. “A New Gospel and Some New Apocalypses.” "), _c('em', [_vm._v("Contemporary Review")]), _vm._v(" 76 (1899): 802–18. (Includes preliminary translation of chaps. 1–4 and 7.)")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Penn, Michael Philip. "), _c('em', [_vm._v("When Christians First Met Muslims: A Sourcebook of the Earliest Syriac Writings on Islam.")]), _vm._v(" Oakland: University of California Press, 2015. (English translation of chap. 7, pp. 150–55.)")]), _vm._v(" "), _c('p', {
    staticClass: "bib-h2"
  }, [_vm._v("STUDIES")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Brock, Sebastian P. “Gospel of the Twelve Apostles.” In "), _c('em', [_vm._v("Gorgias Encyclopedic Dictionary of the Syriac Heritage: Electronic Edition")]), _vm._v(". Edited by Sebastian P. Brock, Aaron M. Butts, George A. Kiraz, and Lucas Van Rompay. Digital edition prepared by David Michelson, Ute Possekel, and Daniel L. Schwartz. Piscataway, NJ: Gorgias, 2011; online ed. Beth Mardutho, 2018. "), _c('a', {
    attrs: {
      "href": "https://gedsh.bethmardutho.org/Gospel-of-the-Twelve-Apostles",
      "target": "_blank"
    }
  }, [_vm._v("https://gedsh.bethmardutho.org/Gospel-of-the-Twelve-Apostles")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Donner, Fred McGraw. "), _c('em', [_vm._v("Muhammad and the Believers: At the Origins of Islam.")]), _vm._v(" Cambridge, MA: Belknap, 2012.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Drijvers, Han J. W. “Christians, Jews and Muslims in Northern Mesopotamia in Early Islamic Times. The Gospel of the Twelve Apostles and Related Texts.” Pages 67–74 in "), _c('em', [_vm._v("La Syrie de Byzance à l’Islam, VII")]), _c('sup', [_vm._v("e")]), _c('em', [_vm._v("–VIII")]), _c('sup', [_vm._v("e")]), _vm._v(" "), _c('em', [_vm._v("siècles: actes du Colloque international “De Byzance à l’islam,” Lyon, Maison de l’Orient méditerranéen, Paris, Institut du monde arabe, 11–15 septembre 1990.")]), _vm._v(" Edited by Pierre Canivet and Jean-Paul Rey-Coquais. Damas: Institut français de Damas, 1992.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("———. “The Gospel of the Twelve Apostles. A Syriac Apocalypse from the Early Islamic Period.” Pages 189–213 in "), _c('em', [_vm._v("The Byzantine and Early Islamic Near East")]), _vm._v(". Vol. 1, "), _c('em', [_vm._v("Problems in the Literary Source Material")]), _vm._v(". Edited by Averil Cameron and Lawrence I. Conrad. SLAEI 1. Princeton: Darwin, 1992.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Hoyland, Robert G. "), _c('em', [_vm._v("Seeing Islam as Others Saw It: A Survey and Evaluation of Christian, Jewish, and Zoroastrian Writings on Early Islam")]), _vm._v(". SLAEI 13. Princeton: Darwin, 1997.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Puech, Henri-Charles (rev. by Beate Blatz). “Other Gnostic Gospels and Related Literature.” Pages 354–413 in "), _c('em', [_vm._v("New Testament Apocrypha")]), _vm._v(". Vol. 1, "), _c('em', [_vm._v("Gospels and Related Writings")]), _vm._v(". Edited by Wilhelm Schneemelcher. Translated by R. McL. Wilson. Rev. ed. Louisville: Westminster John Knox, 1991.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Reinink, Gerrit J. “Early Christian Reactions to the Building of the Dome of the Rock in Jerusalem.” "), _c('em', [_vm._v("Khristianskij Vostok")]), _vm._v(" 2 (2001): 227–41.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("———. “From Apocalyptics to Apologetics: Early Syriac Reactions to Islam.” Pages 75–87 in "), _c('em', [_vm._v("Endzeiten: Eschatologie in den monotheistischen Weltreligionen")]), _vm._v(". Edited by Wolfram Brandes and Felicitas Schmieder. Millennium-Studien 16. Berlin: de Gruyter, 2008.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Thomas, David, and Barbara Roggema, eds. "), _c('em', [_vm._v("Christian-Muslim Relations: A Bibliographical History")]), _vm._v(". Vol. 1, "), _c('em', [_vm._v("600–900")]), _vm._v(". History of Christian-Muslim Relations 11. Leiden: Brill, 2009.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Wolf, Kenneth Baxter. “Back to the Future: Constantine and the Last Roman Emperor.” Pages 115–32 in "), _c('em', [_vm._v("The Life and Legacy of Constantine: Traditions through the Ages.")]), _vm._v(" Edited by Michael Shene Bjornlie. London: Routledge, 2017.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/foot.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_001",
      "id": "foot-001"
    }
  }, [_vm._v("1")]), _vm._v(". Surveyed in Puech and Blatz, “Other Gnostic Gospels,” 374–79.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_002",
      "id": "foot-002"
    }
  }, [_vm._v("2")]), _vm._v(". Eugène Revillout, "), _c('em', [_vm._v("Les apocryphes coptes.")]), _vm._v(" "), _c('em', [_vm._v("Première partie: Les Évangiles des douze apôtres et de saint Barthélemy")]), _vm._v(", PO 2/2 (Paris: Firmin Didot, 1904); introduction and translation by Timothy Pettipiece in "), _c('em', [_vm._v("MNTA")]), _vm._v(" 2:23–40.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_003",
      "id": "foot-003"
    }
  }, [_vm._v("3")]), _vm._v(". Harris, “New Gospel”; quotation from 804.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_004",
      "id": "foot-004"
    }
  }, [_vm._v("4")]), _vm._v(". Harris, "), _c('em', [_vm._v("Gospel of the Twelve Apostles")]), _vm._v(", 1–21 (in Syriac numbering; text), 25–39 (trans.).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_005",
      "id": "foot-005"
    }
  }, [_vm._v("5")]), _vm._v(". Harris, "), _c('em', [_vm._v("Gospel of the Twelve Apostles")]), _vm._v(", 11–13.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_006",
      "id": "foot-006"
    }
  }, [_vm._v("6")]), _vm._v(". Harris, "), _c('em', [_vm._v("Gospel of the Twelve Apostles")]), _vm._v(", 21–22.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_007",
      "id": "foot-007"
    }
  }, [_vm._v("7")]), _vm._v(". Drijvers, “Gospel of the Twelve Apostles,” 203–5.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_008",
      "id": "foot-008"
    }
  }, [_vm._v("8")]), _vm._v(". Drijvers, “Gospel of the Twelve Apostles,” 211; Drijvers, “Christians, Jews and Muslims,” 74; Reinink, “Early Christian Reactions,” 241; Wolf, “Back to the Future,” 120; and Penn, "), _c('em', [_vm._v("When Christians First Met Muslims")]), _vm._v(", 173.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_009",
      "id": "foot-009"
    }
  }, [_vm._v("9")]), _vm._v(". Drijvers, “Gospel of the Twelve Apostles,” 205.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_010",
      "id": "foot-010"
    }
  }, [_vm._v("10")]), _vm._v(". Drijvers, “Gospel of the Twelve Apostles,” 191.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_011",
      "id": "foot-011"
    }
  }, [_vm._v("11")]), _vm._v(". Donner, "), _c('em', [_vm._v("Muhammad and the Believers")]), _vm._v(", 157–58.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_012",
      "id": "foot-012"
    }
  }, [_vm._v("12")]), _vm._v(". Donner, "), _c('em', [_vm._v("Muhammad and the Believers")]), _vm._v(", 188.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_013",
      "id": "foot-013"
    }
  }, [_vm._v("13")]), _vm._v(". Reinink, “Early Christian Reactions,” 230.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_014",
      "id": "foot-014"
    }
  }, [_vm._v("14")]), _vm._v(". Drijvers, “Christians, Jews and Muslims,” 68.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_015",
      "id": "foot-015"
    }
  }, [_vm._v("15")]), _vm._v(". Hoyland, "), _c('em', [_vm._v("Seeing Islam")]), _vm._v(", 267.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_016",
      "id": "foot-016"
    }
  }, [_vm._v("16")]), _vm._v(". Edmund Beck, "), _c('em', [_vm._v("Des heiligen Ephraem des Syrers Sermones III")]), _vm._v(", CSCO 320 (Leuven: Secrétariat du Corpus SCO, 1972), 60–71 (text), 79–94 (Latin trans.). English translation in Penn, "), _c('em', [_vm._v("When Christians First Met Muslims")]), _vm._v(", 39–46. See also Jeffrey Thomas Wickes, “Time, Wickedness and Identity in Pseudo-Ephrem’s Homily on the End” (MA thesis, University of Notre Dame, 2007).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_017",
      "id": "foot-017"
    }
  }, [_vm._v("17")]), _vm._v(". Timothy Demy, “Pseudo-Ephraem,” in "), _c('em', [_vm._v("Dictionary of Premillennial Theology")]), _vm._v(", ed. Mal Couch (Grand Rapids: Kregel, 1996), 329.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_018",
      "id": "foot-018"
    }
  }, [_vm._v("18")]), _vm._v(". John F. Haldon, "), _c('em', [_vm._v("Byzantium in the Seventh Century: The Transformation of a Culture")]), _vm._v(","), _c('em'), _vm._v(" rev. ed. (Cambridge: Cambridge University Press, 1997), 42–44.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_019",
      "id": "foot-019"
    }
  }, [_vm._v("19")]), _vm._v(". Translation in Penn, "), _c('em', [_vm._v("When Christians First Met Muslims")]), _vm._v(", 39–46.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_020",
      "id": "foot-020"
    }
  }, [_vm._v("20")]), _vm._v(". Wolf, “Back to the Future,” 116.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_021",
      "id": "foot-021"
    }
  }, [_vm._v("21")]), _vm._v(". Partial edition and French translation by Alphonse Mingana, "), _c('em', [_vm._v("Sources Syriaques")]), _vm._v(", 3 vols. (Leipzig: Harrassowitz, 1907), 1:1–204. For further English translations and discussions, see Sebastian P. Brock, “North Mesopotamia in the Late Seventh Century: Book XV of John Bar Penkaye’s Riš Melle,” "), _c('em', [_vm._v("Jerusalem Studies in Arabic and Islam")]), _vm._v(" 9 (1987): 51–75; and Emmanuel Joseph Mar-Emmanuel, “The Book of Resh Melle by Yo"), _c('span', {
    staticClass: "chr"
  }, [_vm._v("ḥ")]), _vm._v("annan bar Pankaye: An Introduction to the Text and the Study of Its Literary Genres” (PhD diss., University of Toronto, 2015). Addai Scher published a short biography of Yo"), _c('span', {
    staticClass: "chr"
  }, [_vm._v("ḥ")]), _vm._v("annan and summary of "), _c('em', [_vm._v("Resh Melle")]), _vm._v(" in “Notice sur la vie et les œuvres de Yohannan bar Penkayê,” "), _c('em', [_vm._v("JA")]), _vm._v(" 10 (1907): 161–78.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_022",
      "id": "foot-022"
    }
  }, [_vm._v("22")]), _vm._v(". Translation from Brock, “North Mesopotamia,” 61.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_023",
      "id": "foot-023"
    }
  }, [_vm._v("23")]), _vm._v(". Donner, "), _c('em', [_vm._v("Muhammad and the Believers")]), _vm._v(", 164–65, 170–73.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_024",
      "id": "foot-024"
    }
  }, [_vm._v("24")]), _vm._v(". Drijvers, “Christians, Jews and Muslims,” 67–68.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_025",
      "id": "foot-025"
    }
  }, [_vm._v("25")]), _vm._v(". Drijvers, “Gospel of the Twelve Apostles,” 212.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_026",
      "id": "foot-026"
    }
  }, [_vm._v("26")]), _vm._v(". Edition in Gerritt J. Reinink, "), _c('em', [_vm._v("Die Syrische Apokalypse des Pseudo-Methodius")]), _vm._v(", 2 vols., CSCO 540–541, Scriptores Syri 220–221 (Leuven: Peeters, 1993); English trans. in Andrew Palmer, "), _c('em', [_vm._v("The Seventh Century in West-Syrian Chronicles")]), _vm._v(", Translated Texts for Historians 15 (Liverpool: Liverpool University Press, 1993), 237–40. On the date of the text, see Paul J. Alexander and Dorothy de F. Abrahamse, "), _c('em', [_vm._v("The Byzantine Apocalyptic Tradition")]), _vm._v(" (Berkeley: University of California Press, 1985), 25.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_027",
      "id": "foot-027"
    }
  }, [_vm._v("27")]), _vm._v(". Drijvers, “Christians, Jews and Muslims,” 69.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_028",
      "id": "foot-028"
    }
  }, [_vm._v("28")]), _vm._v(". Drijvers, “Christians, Jews and Muslims,” 70.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_029",
      "id": "foot-029"
    }
  }, [_vm._v("29")]), _vm._v(". Brock, “Gospel of the Twelve Apostles”; see also Drijvers, “Christians, Jews and Muslims,” 71.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_030",
      "id": "foot-030"
    }
  }, [_vm._v("30")]), _vm._v(". Wolf, “Back to the Future,” 120–21; see also Reinink, “Early Christian Reactions,” 240–41.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_031",
      "id": "foot-031"
    }
  }, [_vm._v("31")]), _vm._v(". Drijvers, “Gospel of the Twelve Apostles,” 199–208; Thomas and Roggema, "), _c('em', [_vm._v("Christian-Muslim Relations")]), _vm._v(", 223.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_032",
      "id": "foot-032"
    }
  }, [_vm._v("32")]), _vm._v(". Thomas and Roggema, "), _c('em', [_vm._v("Christian-Muslim Relations")]), _vm._v(", 223.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_033",
      "id": "foot-033"
    }
  }, [_vm._v("33")]), _vm._v(". Drijvers, “Christians, Jews and Muslims,” 71.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_034",
      "id": "foot-034"
    }
  }, [_vm._v("34")]), _vm._v(". Harris, "), _c('em', [_vm._v("Gospel of the Twelve Apostles")]), _vm._v(", 18.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_035",
      "id": "foot-035"
    }
  }, [_vm._v("35")]), _vm._v(". Reinink, “Early Christian Reactions,” 239.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_036",
      "id": "foot-036"
    }
  }, [_vm._v("36")]), _vm._v(". Reinink, “Early Christian Reactions,” 230; see also Thomas and Roggema, "), _c('em', [_vm._v("Christian-Muslim Relations")]), _vm._v(", 223.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_037",
      "id": "foot-037"
    }
  }, [_vm._v("37")]), _vm._v(". Thomas and Roggema, "), _c('em', [_vm._v("Christian-Muslim Relations")]), _vm._v(", 223.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_038",
      "id": "foot-038"
    }
  }, [_vm._v("38")]), _vm._v(". Harris, "), _c('em', [_vm._v("Gospel of the Twelve Apostles")]), _vm._v(", 18.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_039",
      "id": "foot-039"
    }
  }, [_vm._v("39")]), _vm._v(". Drijvers, “Christians, Jews and Muslims,” 72.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_040",
      "id": "foot-040"
    }
  }, [_vm._v("40")]), _vm._v(". Harris, "), _c('em', [_vm._v("Gospel of the Twelve Apostles")]), _vm._v(", 20.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_041",
      "id": "foot-041"
    }
  }, [_vm._v("41")]), _vm._v(". Drijvers, “Christians, Jews and Muslims,” 72.")]), _vm._v(" "), _c('p', {
    staticClass: "ch-titlep"
  }, [_vm._v("The Gospel of the Twelve Apostles")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The Gospel of the Twelve Holy Apostles and the Revelations for each one of them; translated from Hebrew to Greek and from Greek to Syriac.")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_vm._v("The birth and infancy of Jesus")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "chap-num"
  }, [_vm._v("1")]), _vm._v(" "), _c('sup', [_vm._v("1")]), _vm._v("The beginning of the gospel of Jesus Christ, the son of the living God, as it is said by the Holy Spirit, “I send an angel before his presence, who will prepare his way.” "), _c('sup', [_vm._v("2")]), _vm._v("It was the year 309 of Alexander son of Philip the Macedonian, in the reign of Tiberius Caesar, in the government of Herod, the ruler of the Jews, that the angel Gabriel, chief of the angels, by the command of God went down to Nazareth to a virgin named Mary, from the tribe of Judah, a son of Israel. She was engaged to Joseph the Just.")]), _vm._v(" "), _c('p', {
    staticClass: "sidenote"
  }, [_vm._v("Mark 1:2 par. [Mal 3:1]")]), _vm._v(" "), _c('p', {
    staticClass: "sidenote"
  }, [_vm._v("Luke 3:1")]), _vm._v(" "), _c('p', {
    staticClass: "sidenote"
  }, [_vm._v("Luke 1:26–27")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('sup', [_vm._v("3")]), _vm._v("He (the angel) appeared to her and said, “Behold! There will arise from you the one who spoke with our forefathers, and he will be the Savior to Israel. "), _c('sup', [_vm._v("4")]), _vm._v("And those who do not confess him will be destroyed, because his authority is in the highest heights, and his kingdom does not pass away.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('sup', [_vm._v("5")]), _vm._v("Then Mary was disturbed by this word and became very frightened. Mary answered and said, “How can it be as you said? For no man is known to me, and you are announcing a birth to me.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('sup', [_vm._v("6")]), _vm._v("The angel said to her, “Truly, because the God of greatness wills it, the Holy Spirit comes forth and the Lord dwells in you.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('sup', [_vm._v("7")]), _vm._v("Mary bowed and worshiped God and she said, “My Lord, may it be to me as your word.” "), _c('sup', [_vm._v("8")]), _vm._v("And Mary gave birth in Bethlehem of Judah and his name was called Jesus, the Savior and Ruler and God who is over all. "), _c('sup', [_vm._v("9")]), _vm._v("As the Holy Spirit said, through the mouth of the prophet David, “"), _c('em', [_vm._v("And all has been placed under his feet, all of the sheep and oxen, also the beasts of the field and the birds of the air, and the fish of the sea, whatever passes along the paths of the seas")]), _vm._v(".” "), _c('sup', [_vm._v("10")]), _vm._v("And all that is in heaven and all that is on earth were made subject to him, to this Jesus.")]), _vm._v(" "), _c('p', {
    staticClass: "sidenote"
  }, [_vm._v("Luke 1:28–36")]), _vm._v(" "), _c('p', {
    staticClass: "sidenote"
  }, [_vm._v("Matt 1:25")]), _vm._v(" "), _c('p', {
    staticClass: "sidenote"
  }, [_vm._v("Ps 8:6–8")]), _vm._v(" "), _c('p', {
    staticClass: "sidenote"
  }, [_vm._v("Heb 2:8")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('sup', [_vm._v("11")]), _vm._v("After a short period of eight months, he fled from Herod to Egypt, so that all that is written may be fulfilled. "), _c('sup', [_vm._v("12")]), _vm._v("After the death of Herod the angel appeared to Joseph and he returned the child to the land of Israel. And he grew and he attained full stature, as it is written by the four truthful evangelists and this preaching of the holy gospel.")]), _vm._v(" "), _c('p', {
    staticClass: "sidenote"
  }, [_vm._v("Matt 2:13–22")]), _vm._v(" "), _c('p', {
    staticClass: "sidenote"
  }, [_vm._v("Luke 2:40, 52")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_vm._v("The call of the disciples")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "chap-num"
  }, [_vm._v("2")]), _vm._v(" "), _c('sup', [_vm._v("1")]), _vm._v("He performed in the world mighty deeds and many miracles without number; many of them the recorders of the Holy Gospels omitted."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-042",
      "id": "foot_042"
    }
  }, [_vm._v("a")])]), _vm._v(" "), _c('sup', [_vm._v("2")]), _vm._v("He healed the ill, cleansed the lepers, raised the dead, opened blinded (eyes), strengthened the paralytics, satisfied the hungry, and he performed signs. "), _c('sup', [_vm._v("3")]), _vm._v("And he chose true disciples and twelve apostles, that they might be with him, whose names are these:")]), _vm._v(" "), _c('p', {
    staticClass: "sidenote"
  }, [_vm._v("Matt 10:8")]), _vm._v(" "), _c('p', {
    staticClass: "sidenote"
  }, [_vm._v("John 20:30; Acts 5:12; 2 Cor 12:12")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('sup', [_vm._v("4")]), _vm._v("Simon who is called Cephas, from the tribe of Reuben.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('sup', [_vm._v("5")]), _vm._v("James and John, the sons of Zebedee, from the tribe of Issachar.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('sup', [_vm._v("6")]), _vm._v("Andrew from the tribe of Zebulon, and Philip from the tribe of Joseph.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('sup', [_vm._v("7")]), _vm._v("Bartholomew from the tribe of Simon, and Matthew from the tribe of Naphtali.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('sup', [_vm._v("8")]), _vm._v("Thomas from the tribe of Benjamin; James the son of Alphaeus from the tribe of Levi.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('sup', [_vm._v("9")]), _vm._v("Thaddaeus from the tribe of Judah; Simeon the Canaanite from the tribe of Asher.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('sup', [_vm._v("10")]), _vm._v("And Judas, who betrayed him, from the tribe of Gad.")]), _vm._v(" "), _c('p', {
    staticClass: "sidenote"
  }, [_vm._v("Mark 3:13–18 par.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('sup', [_vm._v("11")]), _vm._v("These twelve are his disciples to whom he promised twelve thrones, on which they may judge Israel.")]), _vm._v(" "), _c('p', {
    staticClass: "sidenote"
  }, [_vm._v("Matt 19:28//Luke 22:30")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('sup', [_vm._v("12")]), _vm._v("And when our Lord performed all these miracles and taught the word of God in the synagogues, and in cities and in streets, it was evil in the eyes of the elders and scribes of the people. "), _c('sup', [_vm._v("13")]), _vm._v("They stirred up against him judges and those who held authority, until they brought against him accusations and testimonies through their envy so that they might destroy him, as all providence is written in the Holy Gospel of the four truthful Evangelists.")]), _vm._v(" "), _c('p', {
    staticClass: "sidenote"
  }, [_vm._v("Matt 9:35")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('sup', [_vm._v("14")]), _vm._v("And our Lord commanded them and said to them, that they should go out and evangelize in the four quarters of the world. And behold, we went out preaching, from the ends of the earth to the ends (of the same).")]), _vm._v(" "), _c('p', {
    staticClass: "sidenote"
  }, [_vm._v("Mark 16:15; Matt 28:19")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_vm._v("The crucifixion and resurrection of Jesus")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('sup', [_vm._v("15")]), _vm._v("But after this, the Jews worked treacherously against him, the chief priests and the elders and the scribes of the people with one of his disciples, whose name is Scariota. "), _c('sup', [_vm._v("16")]), _vm._v("He took money for his price and delivered him to them. And they delivered him to the judges and they judged him. "), _c('sup', [_vm._v("17")]), _vm._v("And they crucified him and he died, and was buried, and on the third day rose as it is written, <as> he said to his disciples while he was with them, before he was betrayed. "), _c('sup', [_vm._v("18")]), _vm._v("But Judas, after the death of the Righteous One, was separated and inherited a bitter death by evil strangling, through the mystery that our Lord revealed to Simon Cephas and to those holy women who were ministering to them before his death. "), _c('sup', [_vm._v("19")]), _vm._v("When he rose, they announced it to his apostles, and the disciples went according to the message that they had received from our Lord when he was with them and there they saw him. And there was one among them who doubted concerning his resurrection. "), _c('sup', [_vm._v("20")]), _vm._v("And the eleven apostles brought in, instead of Judas, Matthias, and he stands in his place and was with them and was considered an apostle.")]), _vm._v(" "), _c('p', {
    staticClass: "sidenote"
  }, [_vm._v("Mark 14:10–11 par.; John 13:2")]), _vm._v(" "), _c('p', {
    staticClass: "sidenote"
  }, [_vm._v("1 Cor 15:4")]), _vm._v(" "), _c('p', {
    staticClass: "sidenote"
  }, [_vm._v("Matt 27:5")]), _vm._v(" "), _c('p', {
    staticClass: "sidenote"
  }, [_vm._v("Luke 8:3")]), _vm._v(" "), _c('p', {
    staticClass: "sidenote"
  }, [_vm._v("Mark 16:7 par.")]), _vm._v(" "), _c('p', {
    staticClass: "sidenote"
  }, [_vm._v("John 20:24–29")]), _vm._v(" "), _c('p', {
    staticClass: "sidenote"
  }, [_vm._v("Acts 1:21–26")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('sup', [_vm._v("21")]), _vm._v("And he (Jesus) appeared to the eleven when they were in the upper room reclining,"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-043",
      "id": "foot_043"
    }
  }, [_vm._v("a")])]), _vm._v(" while full of anxieties about stumbling. He reproached them for their unbelief and complained about the hardness of their hearts. "), _c('sup', [_vm._v("22")]), _vm._v("At once, he commanded the preachers of justice and evangelists of truth that they should go out into the four quarters and preach the good news and baptize and say, “The kingdom of heaven has come near to you all, and all who believe and hear will live forever.” "), _c('sup', [_vm._v("23")]), _vm._v("And he said to them, “In my name they will cast out demons, and in new tongues, which they do not know nor understand, they will speak, and in my name if they drink deadly poison it will not harm them.”")]), _vm._v(" "), _c('p', {
    staticClass: "sidenote"
  }, [_vm._v("Mark 16:15–16; Matt 28:19–20")]), _vm._v(" "), _c('p', {
    staticClass: "sidenote"
  }, [_vm._v("Mark 1:15; Matt 4:17")]), _vm._v(" "), _c('p', {
    staticClass: "sidenote"
  }, [_vm._v("Mark 16:17")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_vm._v("The apostles are given the gift of tongues")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "chap-num"
  }, [_vm._v("3")]), _vm._v(" "), _c('sup', [_vm._v("1")]), _vm._v("After these words that his apostles heard from him, one of them said to him, “Behold! You are going away from us and are ascending to him who sent you, and to you was given all power in heaven and on earth, and you have commanded that we preach in new tongues.”")]), _vm._v(" "), _c('p', {
    staticClass: "sidenote"
  }, [_vm._v("Mark 9:37//Luke 9:48; 10:16; Matt 10:40")]), _vm._v(" "), _c('p', {
    staticClass: "sidenote"
  }, [_vm._v("Heb 2:8")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('sup', [_vm._v("2")]), _vm._v("After this <they prayed> this prayer and said,"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-044",
      "id": "foot_044"
    }
  }, [_vm._v("b")])]), _vm._v(" “We seek from you, our Lord and our God, not to deprive us of your grace, but establish us in your grace and enrich us in knowledge that is from you. "), _c('sup', [_vm._v("3")]), _vm._v("Confer onto us your Holy Spirit and give us mercies and compassion that is from you; and perfect in us the gift that is from you. "), _c('sup', [_vm._v("4")]), _vm._v("With those who truly call on your name, let no error approach us, and let not the devil pierce us with his destructive arrows. "), _c('sup', [_vm._v("5")]), _vm._v("Let us not taste of the poison of the cruel serpent, for this was the cause of the fall of our father Adam. "), _c('sup', [_vm._v("6")]), _vm._v("Instead, be to us the leader and the overseer, and the Lord and director and liberator and redeemer; and in all that is given to us from you in gratitude, let your grace be made perfect among us until the consummation of the world. "), _c('sup', [_vm._v("7")]), _vm._v("If our Lord enriches us according to his promises, we will speak in new tongues, through the Spirit that is from you. "), _c('sup', [_vm._v("8")]), _vm._v("And we will know what is the end of the world, because we are in the midst of offenses and scandals of the world. "), _c('sup', [_vm._v("9")]), _vm._v("Reveal and expound to us, our Lord: what is the manner of your coming, and what is the end and what scandals are in the world. Behold! For you are being taken up from us, and we do not know what we will say.”")]), _vm._v(" "), _c('p', {
    staticClass: "sidenote"
  }, [_vm._v("John 20:28")]), _vm._v(" "), _c('p', {
    staticClass: "sidenote"
  }, [_vm._v("Eph 6:16")]), _vm._v(" "), _c('p', {
    staticClass: "sidenote"
  }, [_vm._v("Gen 3:1–7")]), _vm._v(" "), _c('p', {
    staticClass: "sidenote"
  }, [_c('em', [_vm._v("Acts Thom")]), _vm._v(". 6:60–61")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('sup', [_vm._v("10")]), _vm._v("Jesus rebuked them and said, “What is all this little faith among you? Behold! I have given my promises to you and fulfilled your requests. You will speak in different tongues and nothing will be concealed from you. "), _c('sup', [_vm._v("11")]), _vm._v("And I put the Holy Spirit in you, and my truth I have fastened into your hearts, for the profit and salvation and invitation to the kingdom of heaven of those who read and hear and do your words. "), _c('sup', [_vm._v("12")]), _vm._v("It is not like other evangelists who speak of something they have seen and repeat what they have heard; you will speak, however, by the Spirit of my Father of things that are and things that are to come. "), _c('sup', [_vm._v("13")]), _vm._v("And those who believe and do will see new life in the kingdom of my Father in heaven.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('sup', [_vm._v("14")]), _vm._v("And immediately our Lord was taken up from his twelve (apostles), and their minds were fervent, like burning fire; and each one of them was given a tongue and grace. "), _c('sup', [_vm._v("15")]), _vm._v("Simon spoke with them in Hebrew, James in Latin, John in Greek, Andrew in Palestinian, Philip in Coptic, "), _c('sup', [_vm._v("16")]), _vm._v("Bartholomew in Elamite, Matthew in Parthian, Thomas in Indian, James son of Alphaeus in the tongue of Mesopotamia, which is beyond the river, "), _c('sup', [_vm._v("17")]), _vm._v("Thaddaeus in African, Simeon the Canaanite in Median, and Matthias in the tongue of Persia. "), _c('sup', [_vm._v("18")]), _vm._v("And they understood what things they were saying, each man the tongue of his fellow. "), _c('sup', [_vm._v("19")]), _vm._v("All those who heard them were amazed and in awe, and they said, “How have these barbarians and contemptible people suddenly become wise, and speakers of crafty things and revealers of secrets? Who has given them this, and how have they been trained? "), _c('sup', [_vm._v("20")]), _vm._v("For behold! We hear them speaking in new tongues, which they were not born with, and they preach repentance and are inviting men to the kingdom of God. "), _c('sup', [_vm._v("21")]), _vm._v("Were they not born among us and raised with us? And they were weak in understanding, and now we hear from them secrets and revelations that are of a tongue of men that men cannot speak. "), _c('sup', [_vm._v("22")]), _vm._v("For this cannot be without the finger of God, who has enriched them.”")]), _vm._v(" "), _c('p', {
    staticClass: "sidenote"
  }, [_vm._v("Acts 2:1–13")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_vm._v("The apostles ask for the gift of revelation")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "chap-num"
  }, [_vm._v("4")]), _vm._v(" "), _c('sup', [_vm._v("1")]), _vm._v("After this they taught and instructed the people as they were commanded by our Lord. They gathered"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-045",
      "id": "foot_045"
    }
  }, [_vm._v("a")])]), _vm._v(" in the upper room where they had been with Jesus, and they bowed down and worshiped God. "), _c('sup', [_vm._v("2")]), _vm._v("And all of them inquired as if one soul that they might be made perfect each one in the tongue of his fellow and its discourse, and after this, in one consent and agreement they might ask from God this gift that was promised to them, and that there might be a revelation to them concerning the end. "), _c('sup', [_vm._v("3")]), _vm._v("Simon Cephas and the eleven disciples bowed before God in the upper room, and they prayed and requested from God and said this prayer:"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-046",
      "id": "foot_046"
    }
  }, [_vm._v("b")])])]), _vm._v(" "), _c('p', {
    staticClass: "sidenote"
  }, [_vm._v("Acts 1:13")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('sup', [_vm._v("4")]), _vm._v("Lord God the Mighty, the Father and sender of our Lord Jesus Christ, he whom you sent as your only Son, to free us from evil and from error and to instruct us in the way of life, we call upon you, Lord, and from you we ask to be found worthy of the gifts promised to us by the holy mouth of our Lord. "), _c('sup', [_vm._v("5")]), _vm._v("And let us not be deprived of the grace and the mercies that have been granted to us by his promise; but come, Lord, and deem us worthy that all of us with one soul and with one mind may see your revelation, that great and marvelous (revelation) by which you are prepared to reveal to us concerning the things created; "), _c('sup', [_vm._v("6")]), _vm._v("and that we may understand the times before your coming—how they pass away and are no more; and who are the rulers of those (times) and their courses; and what men will come to see the future; "), _c('sup', [_vm._v("7")]), _vm._v("and who is he that will come and be the opponent and fight against the truth; and whether all men stray from you and cleave to error. "), _c('sup', [_vm._v("8")]), _vm._v("Yes, we ask, our God, reveal to us in mercies and compassion and show us. Our Lord, grant us our requests, in the knowledge and advantage of those who read and understand. "), _c('sup', [_vm._v("90")]), _vm._v("For behold! As to your word, we have hated the world and all that is in it, and we have left fathers and people and have cleaved to you. "), _c('sup', [_vm._v("10")]), _vm._v("You are the Savior of our people, and the beginning and the consummation and the guide and the governor of our lives; "), _c('sup', [_vm._v("11")]), _vm._v("your mercies are over the good and over the evil; and you are life and the life-giver; and you have the authority over the departure of all of us. "), _c('sup', [_vm._v("12")]), _vm._v("Reveal compassion to us, show us good, have pity on your servants, Merciful One, and permit us through your holy name to trample on the head of the bitter serpent, your enemy.")]), _vm._v(" "), _c('p', {
    staticClass: "sidenote"
  }, [_vm._v("John 1:14")]), _vm._v(" "), _c('p', {
    staticClass: "sidenote"
  }, [_vm._v("Mark 10:28 par.; Luke 5:11; Eph 5:31")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_vm._v("The apostles are sent to the Mount of Transfiguration")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('sup', [_vm._v("13")]), _vm._v("[When] they had finished their prayer, suddenly [the Lord] flashed lightning over them from heaven, and [the earth] was filled with a great light, such as men had not seen before, and such as they will not see again, except that (light) in which our Lord is to be revealed. "), _c('sup', [_vm._v("14")]), _vm._v("That light remained over them for three hours, that day being the Friday; and a mighty voice was heard from within the light that said, “Blessed and a blessing is he who came and who comes in the name of the Lord; blessed is the mystery of Salvation.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('sup', [_vm._v("15")]), _vm._v("Thus they heard (the voice) until that light faded from the upper room. And suddenly a voice sounded out to them and they heard it saying, “Go out to the mountain, to the place where Moses and Elias appeared to you. And there it will be spoken to you in spirit concerning the world and the end, and concerning the kingdom of God. And all of you will speak of it in the tongues of the Holy Fathers.”")]), _vm._v(" "), _c('p', {
    staticClass: "sidenote"
  }, [_vm._v("Mark 9:2–8 par.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('sup', [_vm._v("16")]), _vm._v("When the voice was silent, they fell upon their faces from their fear a great and long time. And with the tears from their eyes, the entire upper room was full of water. "), _c('sup', [_vm._v("17")]), _vm._v("Simon Cephas and his eleven fellows rose up, bound and summoned by the Holy Spirit, and they went where Jesus had directed them. "), _c('sup', [_vm._v("18")]), _vm._v("They were there fasting and praying for seven days [and did not eat anything]."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-047",
      "id": "foot_047"
    }
  }, [_vm._v("a")])]), _vm._v(" Suddenly there were set before them [tables] full of all good things, excellent things—[where] they came from only our Lord Jesus knows—from which he was nourished. "), _c('sup', [_vm._v("19")]), _vm._v("On the next [day], he flashed lightning over them like the light on the first (day), and made them fervent in spirit and in truth. And a voice came to them and said, “Speak out, speak out!” "), _c('sup', [_vm._v("20")]), _vm._v("And they began to glorify and praise and laud and exalt our Lord, [asking] from him that his gift [to them] might be completed.")]), _vm._v(" "), _c('p', {
    staticClass: "sidenote"
  }, [_vm._v("Acts 10:9–16")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_vm._v("The revelation of Simon Cephas")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "chap-num"
  }, [_vm._v("5")]), _vm._v(" "), _c('sup', [_vm._v("1")]), _vm._v("The revelation of Simon Cephas."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-048",
      "id": "foot_048"
    }
  }, [_vm._v("b")])]), _vm._v(" Simon was moved by the Spirit of God and his appearance and body were enlarged. He glorified and cried and said, “How great are your works, Lord, and all that you have done through wisdom. "), _c('sup', [_vm._v("2")]), _vm._v("For behold! I see the armies of God, which are thousands and uncountable,"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-049",
      "id": "foot_049"
    }
  }, [_vm._v("c")])]), _vm._v(" standing in heaven and praising the great throne of the Godhead exalted above all. "), _c('sup', [_vm._v("3")]), _vm._v("There was sent to me the great angel Michael to be a chronicler, and I received the Spirit in abundance. I saw the time after us, full of offenses and evils and sins and falsehood. "), _c('sup', [_vm._v("4")]), _vm._v("And men in that (time) will be cunning, crafty, and perverse; they do not know God nor understand the truth. "), _c('sup', [_vm._v("5")]), _vm._v("But a few of them understand their God because of his works, which they see daily, which are established in heaven and brought forth in the world, so that they may know our Lord, as though they did know, for this name alone calls upon those who are believers."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-050",
      "id": "foot_050"
    }
  }, [_vm._v("a")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('sup', [_vm._v("6")]), _vm._v("“And after a time they will seek to perform miracles in the name of our Lord Jesus, and they will not be able to because of their little faith. They will call and not be heard because they do not call on him with all their heart. "), _c('sup', [_vm._v("7")]), _vm._v("But those who are separated from them, few in number, ask and are heard, because their hearts speak the truth and know God, and they understand his beloved Son and do not deny the Spirit. In this way they perform signs and great works of power. "), _c('sup', [_vm._v("8")]), _vm._v("And these also in their wealth and in their faith are not suffered to live, for there will rise up against them bribed judges and also bribed deniers. "), _c('sup', [_vm._v("9")]), _vm._v("They will be judged and beaten because of the name of our Lord; and they will kill them by bitter and various deaths. Also, after they are killed, they will perform great works of power through their deaths.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('sup', [_vm._v("10")]), _vm._v("“After these (things) will have happened, faith will cease from the world and truthfulness"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-051",
      "id": "foot_051"
    }
  }, [_vm._v("b")])]), _vm._v(" will come to an end. And those who are named as being baptized in our Lord and as confessing in his name will be <more> miserable than anyone. "), _c('sup', [_vm._v("11")]), _vm._v("They will trample on the faith and they will say perverse things and they will divide our Lord. "), _c('sup', [_vm._v("12")]), _vm._v("Many in that time will be thought to be teachers, although the spirit of the Father does not speak in them, and they will divide our Lord. While he, the speaker of lies and father of falsehood and contention, who is Satan, will enter into them and disturb their minds. "), _c('sup', [_vm._v("13")]), _vm._v("And their faith will cease and it will come to pass that when they rise up and tear him apart,"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-052",
      "id": "foot_052"
    }
  }, [_vm._v("c")])]), _vm._v(" and when all people will say in his place that I fear God more and I confess correctly, they will seek our Lord and will not find him, and they will call to him and he will not answer them. "), _c('sup', [_vm._v("14")]), _vm._v("The Lord will deliver them to evil and to misery and to wrath and to pillage and to tribute, until they will request death upon themselves and will not find a savior. "), _c('sup', [_vm._v("15")]), _vm._v("They will be angry and blaspheme against God, and they will say, ‘Because we have more knowledge of God and because of this the more have evils followed our steps.’ "), _c('sup', [_vm._v("16")]), _vm._v("Few of those who will be dispersed in the countries who confess the Son in the way that is right for them to do, of these our Lord will satisfy their needs. "), _c('sup', [_vm._v("17")]), _vm._v("But those who do not believe in him and are called baptized, they will raise up a blessing to the heathens and envy them and will say, ‘Why are these things so? And why is it given to us as to them?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('sup', [_vm._v("18")]), _vm._v("“Also those who preach among them, on whom he called <in> the name of our Lord, in leadership over their brothers and in the offices of the church there will be disturbers and slanderers and haters of each other, lovers of money and destroyers of order, and those who do not observe the commandments. "), _c('sup', [_vm._v("19")]), _vm._v("But they will not love <their> flocks, and in their time men will appear as sheep but will be ravening wolves, and they will eat up the labor of the orphans and the food of the widows. "), _c('sup', [_vm._v("20")]), _vm._v("Every ruler will pervert justice and their eyes will be blinded by bribery, and they will love vainglory, and because of all the evils that are performed by them, they will call upon the Lord, and there will be none to answer them. "), _c('sup', [_vm._v("21")]), _vm._v("There will be no savior for them because of the many evils upon the world. They have corrupted their ways before the Father of Heaven and the destroyer will deliver them to ruin and misery and distress. "), _c('sup', [_vm._v("22")]), _vm._v("Wasps will rise up against them in the morning and the evening and will afflict them; and men will see their sons, their daughters, and their wives and their revenues plundered by their enemies. "), _c('sup', [_vm._v("23")]), _vm._v("There will be no one who speaks and no one who answers, because the Holy One wills (it), and the Lofty One talks with them, and from before him judgment will proceed. "), _c('sup', [_vm._v("24")]), _vm._v("They will bring upon them all of these evils, and lightning will flash upon them until they will return and become one true flock and one holy church. They will confess our Lord as we have received him, and we have believed in his Son, the Life-Giver and Savior of the worlds.")]), _vm._v(" "), _c('p', {
    staticClass: "sidenote"
  }, [_vm._v("1 Tim 3:3")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('sup', [_vm._v("25")]), _vm._v("“After this there will be a flock and church and baptism, true and one. And on that day, whosoever will call on the name of the Lord will live and whoever worships the Paraclete will be redeemed.”")]), _vm._v(" "), _c('p', {
    staticClass: "sidenote"
  }, [_vm._v("John 14:16, 26")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_vm._v("The revelation of James, son of Zebedee")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "chap-num"
  }, [_vm._v("6")]), _vm._v(" "), _c('sup', [_vm._v("1")]), _vm._v("The revelation of the apostle James."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-053",
      "id": "foot_053"
    }
  }, [_vm._v("a")])]), _vm._v(" The angel separated from Simeon and approached near to James. And he was shaken by the Spirit of God, and he wept and wailed and said, “Ah! Our Lord Jesus, this destruction that I see in this holy city! "), _c('sup', [_vm._v("2")]), _vm._v("For behold! From after a known time, the great and renowned house of the Lord will be ruined and the city of Jerusalem will be ruined."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-054",
      "id": "foot_054"
    }
  }, [_vm._v("b")])]), _vm._v(" It will be in uproar and become a house of corruption. "), _c('sup', [_vm._v("3")]), _vm._v("It will be delivered up to a people that do not know God and do not understand the truth, because of the unrighteousness of its inhabitants in there, because they blasphemed against the name of our Lord Jesus, and they crucified and killed <him>.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('sup', [_vm._v("4")]), _vm._v("Again the apostle James was astonished and said, “Behold! I see that there comes against her a man praised in name and fearsome in appearance, and who will ruin and tear down and destroy its inhabitants. "), _c('sup', [_vm._v("5")]), _vm._v("And there will be in it much starvation and wrath; and the God of Heaven will be angered with them. "), _c('sup', [_vm._v("6")]), _vm._v("The eyes of their hearts will be darkened and they will not see the sun. They will not understand the marvels of the Lord because they have not known his Son. "), _c('sup', [_vm._v("7")]), _vm._v("And because they did not seek prudence, they will be destroyed. He will banish its inhabitants and kill and destroy, and there will not be found in her any except those who weep.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('sup', [_vm._v("8")]), _vm._v("“After these (things) have happened to everyone in the city of the Lord, there will come up a man who oppresses them through war against his enemies, and in that war he will die."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-055",
      "id": "foot_055"
    }
  }, [_vm._v("c")])]), _vm._v(" "), _c('sup', [_vm._v("9")]), _vm._v("And there will rule over it another man, and he will establish his edicts, and settle it, and build in it consecrated and renowned sanctuaries to the Lord."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-056",
      "id": "foot_056"
    }
  }, [_vm._v("a")])]), _vm._v(" "), _c('sup', [_vm._v("10")]), _vm._v("They will come from the limits and ends of the world; and all those who hear the name of the Lord and know his praises will worship there the Holy Lord and offer their vows, incense, sacrifices, and oblations. "), _c('sup', [_vm._v("11")]), _vm._v("The Lord will establish there a sign that overcomes the wickedness of the unjust; no one will envy nor will harm come to them because another house of worship will be there, for peace is decreed to it by the Holy One of Israel. "), _c('sup', [_vm._v("12")]), _vm._v("There will be built in it a great and renowned house, at a great expense, with gold of Ophir and gemstones of Havilah. Its name will go out and be renowned more than all the houses of the world; they will say neither before (was it so) nor after will it be so. "), _c('sup', [_vm._v("13")]), _vm._v("That king who began to build it (the temple) will die on the completion of his building, and from his seed will rise a successor, and will burden the chief men with many evils. He will have great and mighty authority and the world will be governed in his days with great tranquility. "), _c('sup', [_vm._v("14")]), _vm._v("Because from God it has been spoken concerning him and his people through the mouth of the prophet Daniel: ‘And it will be that all who confess the name of the Lord will live.’ ”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-057",
      "id": "foot_057"
    }
  }, [_vm._v("b")])])]), _vm._v(" "), _c('p', {
    staticClass: "sidenote"
  }, [_vm._v("Joel 2:32")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_vm._v("The revelation of John, Son of Zebedee")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "chap-num"
  }, [_vm._v("7")]), _vm._v(" "), _c('sup', [_vm._v("1")]), _vm._v("The revelation of John the Little, the brother of James, who are the sons of Zebedee."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-058",
      "id": "foot_058"
    }
  }, [_vm._v("c")])]), _vm._v(" There was suddenly a great earthquake, and John, his brother and the sharer of the mystery"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-059",
      "id": "foot_059"
    }
  }, [_vm._v("d")])]), _vm._v(" of our Lord, fell on his face on the ground and with great trembling he worshiped God the Lord of all. "), _c('sup', [_vm._v("2")]), _vm._v("Our Lord sent to him a man in white clothing, riding a horse of fire, and his appearance was like lightning of fire. "), _c('sup', [_vm._v("3")]), _vm._v("He touched him and stood him up and said to him, “John, behold! You have been appointed by our Lord to preach the good news of salvation along with three servant of truth. "), _c('sup', [_vm._v("4")]), _vm._v("But you also will not be deprived of this gift, for the Spirit has been given to you, which you will receive in double measure, because more than your first fellows, you have known the mystery of our Savior.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('sup', [_vm._v("5")]), _vm._v("John was moved by the Holy Spirit and was made fervent and said, “Behold! I see heaven opened and saints who are in the highest heights, their appearance like lightning and glorifying God the creator of all. "), _c('sup', [_vm._v("6")]), _vm._v("I saw an angel that approached me from those who were near to him. And he brought scrolls written with the finger of truth, and inscribed on them were times and generations and iniquities, sins of men, and the evils that are to come on the earth. When I rose up, I was bewildered.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('sup', [_vm._v("7")]), _vm._v("“There was a voice of much dread that said, ‘Let the hidden mysteries from the beginning be revealed, in soul and in spirit.’ "), _c('sup', [_vm._v("8")]), _vm._v("And the angel of God that was sent <to me> touched me and said to me, ‘Open your mouth and receive.’ I opened my mouth and saw that he put something (in it) that resembled gemstones;"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-060",
      "id": "foot_060"
    }
  }, [_vm._v("e")])]), _vm._v(" it was white as snow and its flavor was very sweet. "), _c('sup', [_vm._v("9")]), _vm._v("I ate it and he said to me, ‘Behold! It is the day of salvation and the hour of deliverance. Speak, for the Lord has delighted in you! Speak, man, who has been given power over the mysteries of God! Speak with no dread, for it is the will of God that the things hidden will be expounded to you.’")]), _vm._v(" "), _c('p', {
    staticClass: "sidenote"
  }, [_vm._v("Exod 16:31; Num 11:7; "), _c('em', [_vm._v("Jos. Asen.")]), _vm._v(" 16")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('sup', [_vm._v("10")]), _vm._v("“I saw written on the scrolls what people will suffer in the end times. When I saw all these things that are past, I was not willing to speak of them, but <only> expound those things that are prepared to come. "), _c('sup', [_vm._v("11")]), _vm._v("And there was a voice that spoke in me, ‘Woe, woe to the men who are left to the generations <and> to the times that are prepared to come! "), _c('sup', [_vm._v("12")]), _vm._v("For there will rise up the kings of the north and they will become strong and shake the whole world. "), _c('sup', [_vm._v("13")]), _vm._v("There will be among them a man who subdues all the peoples by the marvelous sign that appeared to him in heaven."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-061",
      "id": "foot_061"
    }
  }, [_vm._v("a")])]), _vm._v(" And he will prosper and it will be well with him. "), _c('sup', [_vm._v("14")]), _vm._v("After him there will rise the kings of the Romans—insolent, evil, idol-worshiping, godless, accusers and plotters and hypocrites. "), _c('sup', [_vm._v("15")]), _vm._v("All the Roman people will fall into fornication and adultery, and they will love bribery and lasciviousness and an abundance of wine that they drink. "), _c('sup', [_vm._v("16")]), _vm._v("While their authority is over all the world, because of their evil sins and blasphemies against God, the Lord will send wrath upon them from heaven. Persia will prevail over them and expel and drive out this kingdom from the world because of exceeding impiety. "), _c('sup', [_vm._v("17")]), _vm._v("Kings will rise up among them, great and renowned and lovers of money, and they will take away governance from the earth. "), _c('sup', [_vm._v("18")]), _vm._v("One from them, because of love of money, will destroy many people, until commerce and trade will perish from the whole world. "), _c('sup', [_vm._v("19")]), _vm._v("And he will die by the son of his body;"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-062",
      "id": "foot_062"
    }
  }, [_vm._v("b")])]), _vm._v(" all the silver and gold that he has collected will not save him. "), _c('sup', [_vm._v("20")]), _vm._v("After this Persia will rule for a short time, and it also will be delivered over to Media. Because of their evil sins, the God of heaven will cease their rule and abolish their kingdom. They will be destroyed and cease to be.")]), _vm._v(" "), _c('p', {
    staticClass: "sidenote"
  }, [_vm._v("Dan 2:31–45")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_vm._v("The rise of the king of the south")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('sup', [_vm._v("21")]), _vm._v("“But there will be deniers of the truth and people who do not know God and defilers by lasciviousness—those who provoke God. "), _c('sup', [_vm._v("22")]), _vm._v("Then suddenly will be fulfilled the prophecy of Daniel the pure and desired, which he spoke, that God will send out a mighty spirit"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-063",
      "id": "foot_063"
    }
  }, [_vm._v("c")])]), _vm._v(" <from> the south. There will come from it a hideous people whose appearance and customs are like those of women. "), _c('sup', [_vm._v("23")]), _vm._v("From among them will rise up a warrior, whom they call a prophet."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-064",
      "id": "foot_064"
    }
  }, [_vm._v("d")])]), _vm._v(" And they will be brought into his hands […] the like of which has not been seen in the world"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-065",
      "id": "foot_065"
    }
  }, [_vm._v("e")])]), _vm._v(" nor anything resembling them. "), _c('sup', [_vm._v("24")]), _vm._v("All who hear <of them> will shake his head and mock and say, ‘Why does he speak this way?’ And God sees and disregards.")]), _vm._v(" "), _c('p', {
    staticClass: "sidenote"
  }, [_vm._v("Dan 11:5")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('sup', [_vm._v("25")]), _vm._v("“The south will prosper, and by the hoofs of the horses of their armies, they will trample down Persia and will subdue it and destroy Rome; there will not be found <any> who stand before them, because it has been ordained for them by the Holy One of Heaven. "), _c('sup', [_vm._v("26")]), _vm._v("It will be that every kingdom or people or place that hears the report of them will be scared and will tremble and be terrified at the report of this people, until it (the south) will subdue the whole world and will bring it under its control."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-066",
      "id": "foot_066"
    }
  }, [_vm._v("a")])]), _vm._v(" "), _c('sup', [_vm._v("27")]), _vm._v("And twelve renowned kings will rise up from them, as it is written in the Law, when God spoke with Abraham and said to him, ‘Behold! Concerning Ishmael your son I have heard you, and it (the south) will produce twelve princes with many others."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-067",
      "id": "foot_067"
    }
  }, [_vm._v("b")])]), _vm._v(" "), _c('sup', [_vm._v("28")]), _vm._v("The same people of the land of the south will lead captive a great captivity among all the peoples of the world and they will plunder a plundering. All the limits of the earth will do servitude and many lordships will be made subject to them."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-068",
      "id": "foot_068"
    }
  }, [_vm._v("c")])]), _vm._v(" "), _c('sup', [_vm._v("29")]), _vm._v("Their hand will be over all, and also those who are under their hand they will oppress with much tribute. And they will oppress and kill and destroy the [chiefs of the] limits [of the world]. "), _c('sup', [_vm._v("30")]), _vm._v("They will impose a tribute on […]"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-069",
      "id": "foot_069"
    }
  }, [_vm._v("d")])]), _vm._v(" hand, the kind of which has never been heard; until a man will come out from his house and will find [at] his door four creditors that require tribute. "), _c('sup', [_vm._v("31")]), _vm._v("Men will sell their sons and their daughters through necessity: and they will hate their lives and they will mourn and they will cry, and there is no voice nor speech, but ‘woe, woe.’ "), _c('sup', [_vm._v("32")]), _vm._v("They will be desirers of hateful desire and they will be transformed into bridegrooms and brides, but †… †"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-070",
      "id": "foot_070"
    }
  }, [_vm._v("e")])]), _vm._v(" they may fear some turning back from among them, because he who has will think in those days as though he had not, and he who builds and sells as though he had no gain. "), _c('sup', [_vm._v("33")]), _vm._v("All who take refuge with them will prosper among them, and they will enslave to them (people) renowned in race, and there will be hypocrites among them who do not know of God. They do not have regard for men, except for gluttons, fornicators, evildoers, and the wrathful.")]), _vm._v(" "), _c('p', {
    staticClass: "sidenote"
  }, [_vm._v("Gen 17:20")]), _vm._v(" "), _c('p', {
    staticClass: "sidenote"
  }, [_vm._v("Luke 18:2")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_vm._v("The defeat of the southern kingdom")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('sup', [_vm._v("34")]), _vm._v("“But woe, woe, to those men in that time. They will rule over the world"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-071",
      "id": "foot_071"
    }
  }, [_vm._v("f")])]), _vm._v(" for one great week and a half; and every king who will rise from among them will prevail and will be made strong, and will be more mighty than his fellow. "), _c('sup', [_vm._v("35")]), _vm._v("They will gather the gold of the world and will go down and stock them in the treasures of the earth from where it came, because their kingdom and their authority is from God […]"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-072",
      "id": "foot_072"
    }
  }, [_vm._v("g")])]), _vm._v(" "), _c('sup', [_vm._v("36")]), _vm._v("And it will be that after the week and a half there will be an earthquake on their account, and God will require the sins of creation at their hands, and the spirit of the south will be quiet. "), _c('sup', [_vm._v("37")]), _vm._v("God will bring his covenant with them to an end, and they will tremble and be frightened from every report that reaches them. The hands of all flesh will be upon them, as it was said by the hand of Moses, the slave of the Lord. "), _c('sup', [_vm._v("38")]), _vm._v("In the end of their times they will do evil to all flesh that is under their authority, and they will oppress and enslave and plunder. The men will see necessity and great oppression, and they will engage, together three and four of them, in uncleanness. "), _c('sup', [_vm._v("39")]), _vm._v("There is none who speaks and none who hears, except one who says, ‘Woe, woe! What has come in our generation!’ They will regard happy the dead of old times and will ask for death for themselves. And there is none who redeems and none who replies. "), _c('sup', [_vm._v("40")]), _vm._v("But how much more will they afflict all of those who confess in Christ our Lord? Because they will hate the name of the Lord until the end and will bring his covenant to an end. "), _c('sup', [_vm._v("41")]), _vm._v("Truth will not be found from among them; instead they will love only evil things and they will admire sin. They will do all that is hateful in the eyes of the Lord, and they will be called an unclean people. "), _c('sup', [_vm._v("42")]), _vm._v("After these (things) the Lord will be angered against them, as (he was) against Rome, Media, and Persia. Immediately the end will come upon them and suddenly the time <comes>. "), _c('sup', [_vm._v("43")]), _vm._v("In the end of the week and a half, God will incite desolation against them and the angel of wrath will descend and kindle evil among them […]"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-073",
      "id": "foot_073"
    }
  }, [_vm._v("a")])]), _vm._v(" between them and within them. "), _c('sup', [_vm._v("44")]), _vm._v("They will be lifted up one [against] the other and make and become two parties. Each of them will seek to call himself king and there will be war between them. "), _c('sup', [_vm._v("45")]), _vm._v("There will be many killings by them and among them, and much blood will be shed among them at the fountain of the waters, which is the place that was spoken of before in the Book of the Sibyl."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-074",
      "id": "foot_074"
    }
  }, [_vm._v("b")])])]), _vm._v(" "), _c('p', {
    staticClass: "sidenote"
  }, [_vm._v("Exod 16:3")]), _vm._v(" "), _c('p', {
    staticClass: "sidenote"
  }, [_vm._v("Judg 2:11; 3:7, 12; 4:1; 6:1; 10:6")]), _vm._v(" "), _c('p', {
    staticClass: "sidenote"
  }, [_c('em', [_vm._v("Sib. Or.")]), _vm._v(" 11:110")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('sup', [_vm._v("46")]), _vm._v("“When the (man of) the north hears this news, he will not boast and will say, ‘By my might and rule I have conquered.’ "), _c('sup', [_vm._v("47")]), _vm._v("Then he will assemble with him all the peoples of the world, and he will go out against him and destroy and ruin his armies and take captive their sons, daughters, and wives. And there will fall upon them a bitter and evil trembling. "), _c('sup', [_vm._v("48")]), _vm._v("The Lord will cause the southern spirit to return to the place from where it came, and will bring to an end his name and his renown. "), _c('sup', [_vm._v("49")]), _vm._v("And when they will enter the land from which they came, the enemy will not pursue them there, and they will not fear hunger and will not tremble. "), _c('sup', [_vm._v("50")]), _vm._v("It will be in that day that their reliance [will be] on silver that they obtained by cheating and by plunder and they have hidden in the place named Diglath."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-075",
      "id": "foot_075"
    }
  }, [_vm._v("c")])]), _vm._v(" "), _c('sup', [_vm._v("51")]), _vm._v("They will return and settle in the land from which they came and there God will stir up among them times of evil and plagues. They will be ruined without war, and up to all the generations of the world, there will not be one weapon <among them> and <no one who> stands up in battle.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('sup', [_vm._v("52")]), _vm._v("[…]"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-076",
      "id": "foot_076"
    }
  }, [_vm._v("a")])]), _vm._v(" the father commanded concerning them from heaven. John said these words and visions and revelations in truth. The angel who spoke to him departed from him, and a voice said, “Leave your portion"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-077",
      "id": "foot_077"
    }
  }, [_vm._v("b")])]), _vm._v(" to your fellows so that they may speak with you.”")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/foot.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_042",
      "id": "foot-042"
    }
  }, [_vm._v("a")]), _vm._v(". Harris reads: “the Holy Gospels have left [on record].”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_043",
      "id": "foot-043"
    }
  }, [_vm._v("a")]), _vm._v(". “In the upper room” is added in the margin by the second hand. Harris mistranslates as “at meat.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_044",
      "id": "foot-044"
    }
  }, [_vm._v("b")]), _vm._v(". The first hand has the singular, but the plural is added in red ink (and the entire sentence is written in red).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_045",
      "id": "foot-045"
    }
  }, [_vm._v("a")]), _vm._v(". “They gathered” is added by the second hand.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_046",
      "id": "foot-046"
    }
  }, [_vm._v("b")]), _vm._v(". “This prayer” is written in red ink.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_047",
      "id": "foot-047"
    }
  }, [_vm._v("a")]), _vm._v(". For the damaged portion, the second hand suggests “[and nothing] was sent to them.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_048",
      "id": "foot-048"
    }
  }, [_vm._v("b")]), _vm._v(". Title in red ink.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_049",
      "id": "foot-049"
    }
  }, [_vm._v("c")]), _vm._v(". Lit., “a thousand of a thousand and greatness without number.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_050",
      "id": "foot-050"
    }
  }, [_vm._v("a")]), _vm._v(". Perhaps the passive is intended: “for this name alone is called upon by those who are believers.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_051",
      "id": "foot-051"
    }
  }, [_vm._v("b")]), _vm._v(". Perhaps “orthodoxy.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_052",
      "id": "foot-052"
    }
  }, [_vm._v("c")]), _vm._v(". Harris translates as “tear it.” The meaning is unclear: does this refer to the separation of Christ (see “divide the Lord” in 5:12), or the separation of the community (5:7)?")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_053",
      "id": "foot-053"
    }
  }, [_vm._v("a")]), _vm._v(". Title in red ink.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_054",
      "id": "foot-054"
    }
  }, [_vm._v("b")]), _vm._v(". Perhaps a reference to the war under Hadrian; see Harris, "), _c('em', [_vm._v("Gospel of the Twelve Apostles")]), _vm._v(", 18.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_055",
      "id": "foot-055"
    }
  }, [_vm._v("c")]), _vm._v(". Likely Licinius; see Harris, "), _c('em', [_vm._v("Gospel of the Twelve Apostles")]), _vm._v(", 18.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_056",
      "id": "foot-056"
    }
  }, [_vm._v("a")]), _vm._v(". Likely Constantine the Great; see Harris, "), _c('em', [_vm._v("Gospel of the Twelve Apostles")]), _vm._v(", 18.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_057",
      "id": "foot-057"
    }
  }, [_vm._v("b")]), _vm._v(". The words of the prophet here seem to be from Joel, not Daniel.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_058",
      "id": "foot-058"
    }
  }, [_vm._v("c")]), _vm._v(". Title in red ink.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_059",
      "id": "foot-059"
    }
  }, [_vm._v("d")]), _vm._v(". Harris translates as “the initiate.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_060",
      "id": "foot-060"
    }
  }, [_vm._v("e")]), _vm._v(". Syr.: beryls.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_061",
      "id": "foot-061"
    }
  }, [_vm._v("a")]), _vm._v(". Likely Constantine the Great; see Harris, "), _c('em', [_vm._v("Gospel of the Twelve Apostles")]), _vm._v(", 18.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_062",
      "id": "foot-062"
    }
  }, [_vm._v("b")]), _vm._v(". Lit., “side.” This king may be Chosroes the Great, who was killed by his son Siroes; see Harris, "), _c('em', [_vm._v("Gospel of the Twelve Apostles")]), _vm._v(", 19.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_063",
      "id": "foot-063"
    }
  }, [_vm._v("c")]), _vm._v(". Harris translates as “wind.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_064",
      "id": "foot-064"
    }
  }, [_vm._v("d")]), _vm._v(". Likely intended to be Muhammad.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_065",
      "id": "foot-065"
    }
  }, [_vm._v("e")]), _vm._v(". Approximately eight letters are obscured by damage; “the like of which has not been seen in the world” is added by the second hand in the margin.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_066",
      "id": "foot-066"
    }
  }, [_vm._v("a")]), _vm._v(". Lit., “into his hands.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_067",
      "id": "foot-067"
    }
  }, [_vm._v("b")]), _vm._v(". Harris has “many other princesses”—an unlikely emendation given that “others” here is masculine.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_068",
      "id": "foot-068"
    }
  }, [_vm._v("c")]), _vm._v(". Lit., “it” (i.e., the south) but hereafter translated as “them.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_069",
      "id": "foot-069"
    }
  }, [_vm._v("d")]), _vm._v(". Short (four letters?) word lost to damage.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_070",
      "id": "foot-070"
    }
  }, [_vm._v("e")]), _vm._v(". The text is corrupt here and untranslatable.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_071",
      "id": "foot-071"
    }
  }, [_vm._v("f")]), _vm._v(". The manuscript, erroneously, has “the cave.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_072",
      "id": "foot-072"
    }
  }, [_vm._v("g")]), _vm._v(". Short (three letters?) word lost to damage.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_073",
      "id": "foot-073"
    }
  }, [_vm._v("a")]), _vm._v(". Short (four letters?) word lost to damage.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_074",
      "id": "foot-074"
    }
  }, [_vm._v("b")]), _vm._v(". The identification of the passage from "), _c('em', [_vm._v("Sib. Or.")]), _vm._v(" is not certain, though it does appear amid a section of the oracle that focuses on Persia, Rome, and Media.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_075",
      "id": "foot-075"
    }
  }, [_vm._v("c")]), _vm._v(". The Aramaic name for the Tigris River.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_076",
      "id": "foot-076"
    }
  }, [_vm._v("a")]), _vm._v(". Short (four letters?) word lost to damage. A note by the second hand reads, in part, “[…] in/on/by the word and does not know,” perhaps indicating that the writer cannot reconstruct the lost material.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_077",
      "id": "foot-077"
    }
  }, [_vm._v("b")]), _vm._v(". Or perhaps “page.”")])])])
}]}

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(89),
  /* template */
  __webpack_require__(90),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 90 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ch-title"
  }, [_vm._v("The Dialogue between Jesus and the Devil")]), _vm._v(" "), _c('p', {
    staticClass: "ch-subtitle"
  }, [_vm._v("A translation and introduction")]), _vm._v(" "), _c('p', {
    staticClass: "ch-author"
  }, [_vm._v("by Chance E. Bonar and Slavomír Čéplö")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The "), _c('em', [_vm._v("Dialogue between Jesus and the Devil")]), _vm._v(" ("), _c('em', [_vm._v("Dial. Devil")]), _vm._v("; "), _c('em', [_vm._v("CANT")]), _vm._v(" 84) is a narrative dialogue between Jesus and the devil that takes place amidst the temptation account of Matt 4:1–11 and Luke 4:1–13. In the Greek manuscripts, the text is known as the “Discourse of our Lord Jesus Christ regarding the dispute with the devil” and the “Narration of the dispute of the devil with our Lord Jesus Christ.” This apocryphal text has been given relatively little attention by scholars because of its general lack of translation into modern languages and the lack of a critical edition of all known Greek and Church Slavic manuscripts. "), _c('em', [_vm._v("Dial. Devil")]), _vm._v(" provides a glimpse into Byzantine dialogue traditions as well as the development of the character of Satan and the antichrist in the late ancient and early medieval Christian world."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-001",
      "id": "foot_001"
    }
  }, [_vm._v("1")])])]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The Greek version of "), _c('em', [_vm._v("Dial. Devil")]), _vm._v(" is available in two forms. Recension A, translated here, begins with Jesus and his disciples fasting for forty days on a mountain, mirroring both the transfiguration and the temptation narratives."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-002",
      "id": "foot_002"
    }
  }, [_vm._v("2")])]), _vm._v(" Soon after their arrival, the devil appears and questions Jesus regarding his purpose on earth. Jesus explains that he came down from heaven in order to kill the devil and release humanity from his stranglehold (chap. 1). Jesus then goes on to enumerate the devil’s accomplices and the necessity of being born as a human in order to assist humanity (chap. 2). The devil questions at what age repentance is still possible for humans, and Jesus elucidates what happens to repentant and unrepentant sinners in the afterlife (chap. 3). In response to this information, the devil summons a horde of demons in order to kill Jesus, but is stopped when Jesus transfigures and suspends the devil upside down by his feet in a heavenly cloud (chaps. 4–5). Once the devil agrees to end his war against humanity, Jesus releases him and the devil declares himself the antichrist. The devil explains to Jesus his plan to convince Annas and Caiaphas to kill him, but refutes the claim that he caused John the Baptist’s death (chap. 6). The narrative ends with Jesus transfiguring a second time in order to open a fissure in the earth. Jesus goes on to tell the devil about his fate—particularly how the devil will be reborn from a woman named Perdition and will go to a place called Gouze in Egypt, where he will eventually be killed by the Virgin Mary, Elijah, and Enoch (chap. 7).")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Greek recension B is missing its introduction because of a lost folio and so begins "), _c('em', [_vm._v("in medias res")]), _vm._v(" with Jesus recounting how repentant sinners will be taken by Michael and be enlightened once in paradise (chap. 1). Jesus goes on to explain how unrepentant sinners are handed over to Temeluchus and the demons for punishment in the outer darkness (chap. 2). Much like recension A, Jesus lists the accomplices of the devil—including those who stab their foster siblings with a knife—and traps the devil in a cloud (chaps. 3–4). In this recension, Jesus often responds to the devil’s questions with “O Satan, are you debating again?” Although the devil spits on Jesus while attempting to overpower him, Jesus refuses to use his healing spit or holy breath against the devil. They then debate which of them is shadow-like or less-than-human, until Jesus announces his intention to kill the devil and the devil responds by proclaiming how he caused John the Baptist’s death (chap. 5). Finally, Jesus splits open the earth and tells the devil how he will be tormented by angels until he is brought to the earth to go to Daphne in the land of Gouze. The devil is told he will be born from a woman named Eudokia and will reign for three years, during which time there will be an abundance of food in the first year, but not in the other two years. In this recension, the devil is told that he will be killed by Elijah, Enoch, the Virgin Mary, John the Baptist, and Jesus himself—primarily as punishment for causing the death of John the Baptist.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The Church Slavic text comes in multiple recensions, though the version translated here is from a manuscript at St. Catherine’s monastery on Mount Sinai (Slav. 34). In general, the Church Slavic versions present a shortened rendering of the narration found in the Greek recensions. For example, chapter 1 in the Church Slavic version contains only three short exchanges, omitting entirely the question of why Jesus came to earth himself instead of sending angels, which is central to the Greek recension. In chapter 2, however, the Church Slavic tradition takes its own distinct path: it does so first in the description of the devil’s accomplices, where it focuses on sins rather than sinners, and some recensions provide an expanded list (2:4). The most obvious deviations are several edits in 2:6 made to reflect Bogomil theology (in one manuscript the devil describes himself as older than Jesus, and in another he is older than everyone), but the rest of the chapter is also markedly different: where the Greek text has the devil refer to the creation of Adam, the Church Slavic has Jesus and the devil trade accusations of being a deceiver. In chapter 3, both traditions cover the same ground, except where the Greek puts Temeluchus in charge of leading repentant sinners to paradise; in Church Slavic this task falls to Michael. As for chapters 5 and 6, the starkest difference between the traditions is in the transformation of Jesus into his divine form and back, which is lacking in the Church Slavic tradition. The Church Slavic recensions also significantly shorten the devil’s speech in chapter 6, omitting his comparison to Jesus, and, unlike the Greek text (recension A), have him confess to causing the death of John the Baptist (as in Greek recension B). And finally, in chapter 7, the Church Slavic version of the conversation over the newly opened gap in the earth replaces Jesus’s reference to the slaves rolling a heavy stone with a description of the depth of the gap and completely omits the reference to the devil’s mother.")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_vm._v("Manuscripts and Editions")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The first edition of the Greek tradition of "), _c('em', [_vm._v("Dial. Devil")]), _vm._v(" was published by Athanasius Vassiliev in 1893; in it he provided both recensions A and B."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-003",
      "id": "foot_003"
    }
  }, [_vm._v("3")])]), _vm._v(" He made use of two manuscripts: Venice, Biblioteca Nazionale Marciana, gr. II. 42 (coll. 1123), fols. 255r–257r (12th cent.; = M) and Vienna, Österreichische Nationalbibliothek, hist. gr. 67 (Lambeck 33), fols. 18r–19v (13th cent.; = V). These same manuscripts were republished in 1955 by Robert Casey and Robert Thomson,"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-004",
      "id": "foot_004"
    }
  }, [_vm._v("4")])]), _vm._v(" who assigned them to recensions A (manuscript M) and B (V), along with English translations of two Church Slavic recensions published by Nikolaj Tichonravov in 1863."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-005",
      "id": "foot_005"
    }
  }, [_vm._v("5")])]), _vm._v(" Casey and Thomson reported also the existence of a potential third Greek manuscript of "), _c('em', [_vm._v("Dial. Devil")]), _vm._v(" in Jerusalem (Patriarchikē bibliothēkē, Panagios Taphos gr. 66, fols. 178r–182r [15th/16th cent.; = J, also of recension A]),"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-006",
      "id": "foot_006"
    }
  }, [_vm._v("6")])]), _vm._v(" first recognized by J. Rendel Harris in his 1889 book "), _c('em', [_vm._v("The Rest of the Words of Baruch")]), _vm._v(". While the focus of this book is "), _c('em', [_vm._v("4")]), _vm._v(" "), _c('em', [_vm._v("Baruch")]), _vm._v(" (known in Greek as the "), _c('em', [_vm._v("Paraleipomena Jeremiou")]), _vm._v("),"), _c('em'), _vm._v(" Rendel Harris narrates how he returned to Jerusalem to copy the entirety of this “dispute of the devil” (Ἀντιλογία τοῦ διαβόλου), but he seemingly never published it and, Casey and Thomson report, “his transcript has not been found among his papers.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-007",
      "id": "foot_007"
    }
  }, [_vm._v("7")])]), _vm._v(" Casey and Thomson note that the transmission of "), _c('em', [_vm._v("Dial. Devil")]), _vm._v(" in M"), _c('em'), _vm._v(" is complicated, since the codex has three identified scribes and the original parchment leaves of "), _c('em', [_vm._v("Dial. Devil")]), _vm._v(" are no longer extant. Rather, fol. 255 is parchment added by Scribe 2 and fols. 256–57 are paper added by Scribe 3."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-008",
      "id": "foot_008"
    }
  }, [_vm._v("8")])]), _vm._v(" While Casey and Thomson do not comment on whether this affects the dating of M, it is nevertheless worth noting that our extant copy in M is not original to the manuscript.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The Church Slavic"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-009",
      "id": "foot_009"
    }
  }, [_vm._v("9")])]), _vm._v(" manuscripts are more numerous and more complex than the Greek tradition. Aurelio de Santos Otero knew of fourteen Church Slavic manuscripts containing "), _c('em', [_vm._v("Dial. Devil")]), _vm._v("; Francis Thomson offered corrections to this list in his review of the volume."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-010",
      "id": "foot_010"
    }
  }, [_vm._v("10")])]), _vm._v(" Thomson added that no comparative study had yet been done (in the 1980s) between the Greek and Church Slavic redactions, and that several Russian codices not listed by de Santos Otero had "), _c('em', [_vm._v("Dial. Devil")]), _vm._v(" torn out because it was deemed apocryphal"), _c('em', [_vm._v(".")]), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-011",
      "id": "foot_011"
    }
  }, [_vm._v("11")])]), _c('em'), _vm._v(" Julian Petkov noted the existence of a fifteenth Church Slavic manuscript but failed to provide details."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-012",
      "id": "foot_012"
    }
  }, [_vm._v("12")])]), _vm._v(" Most recently, Anissava Miltenova has produced a list of eleven witnesses with at least some relation to the southern branch of the Church Slavic tradition of "), _c('em', [_vm._v("Dial. Devil")]), _vm._v(","), _c('em'), _vm._v(" some of which were unknown to both de Santos Otero and Petkov."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-013",
      "id": "foot_013"
    }
  }, [_vm._v("13")])]), _vm._v(" The full list of known manuscripts containing "), _c('em', [_vm._v("Dial. Devil")]), _vm._v(" is provided in the table below, where the manuscripts are ordered and assigned a capital letter siglum based on Miltenova’s list. In instances where Miltenova groups two or more manuscripts into a single entry, a number is added to the siglum on the basis of either the order given by Miltenova (e.g., J1 and J2) or that given in the source she cites (e.g., the K manuscripts). Manuscripts not on Miltenova’s list continue the numbering.")]), _vm._v(" "), _c('div', {
    staticClass: "top-left"
  }, [_c('div', {
    staticClass: "inside"
  }, [_c('table', [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "td10"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("A:")])]), _vm._v(" "), _c('td', {
    staticClass: "td85"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Mount Sinai, Monē tēs Hagias Aikaterinēs, Slav. 34, fols. 72r–77r (12th/13th cent.; = de Santos Otero 14)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td10"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("B:")])]), _vm._v(" "), _c('td', {
    staticClass: "td85"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Vienna, Österreichische Nationalbibliothek, Cod. Slav. 137, fols. 177r–178v (14th cent.; = de Santos Otero 10)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td10"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("C:")])]), _vm._v(" "), _c('td', {
    staticClass: "td85"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Nikojac monastery, near Bijelo Polje, Montenegro, 52, fols. 66r–71r (15th cent.) (unpublished)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td10"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("D:")])]), _vm._v(" "), _c('td', {
    staticClass: "td85"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Sofia, SS. Cyril and Methodius National Library, 433 (629), fols. 101r–105v (16th cent.; = de Santos Otero 9)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td10"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("E:")])]), _vm._v(" "), _c('td', {
    staticClass: "td85"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Vienna, Österreichische Nationalbibliothek, Cod. Slav. 149, fols. 113r–117v (16th cent.; = de Santos Otero 11) (unpublished)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td10"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("F:")])]), _vm._v(" "), _c('td', {
    staticClass: "td85"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Belgrade, Museum of Serbian Orthodox Church, 100, fols. 84r–87v (1628) (unpublished)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td10"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("G:")])]), _vm._v(" "), _c('td', {
    staticClass: "td85"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Sofia, SS. Cyril and Methodius National Library, 326 (509), fols. 41r–44r (17th/18th cent.; = de Santos Otero 8) (unpublished)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td10"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("H:")])]), _vm._v(" "), _c('td', {
    staticClass: "td85"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Belgrade, National Library of Serbia, 273, fols. 137v–143 (16th/17th cent.; = de Santos Otero 1)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td10"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("I:")])]), _vm._v(" "), _c('td', {
    staticClass: "td85"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Prague, National Museum, IX. H.16 (Šafařík Collection 19), fols. 227r–231r (1646)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td10"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("J1:")])]), _vm._v(" "), _c('td', {
    staticClass: "td85"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Kyibv, National Academy of Sciences, Institute for Literature, 4713, fols. 83–88 (16th/17th cent.)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td10"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("J2:")])]), _vm._v(" "), _c('td', {
    staticClass: "td85"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Saint Petersburg, National Library of Russia (F. 784), F. A. Tolstoj Collection, Otd. II, 229 (Q. XVII, 82), fols. 41–45 (1602; = de Santos Otero 3)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td10"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("K1:")])]), _vm._v(" "), _c('td', {
    staticClass: "td85"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Saint Petersburg, National Library of Russia (F. 67), Berčić Collection 5, fols. 62–64 (15th cent.; = de Santos Otero 2)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td10"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("K2:")])]), _vm._v(" "), _c('td', {
    staticClass: "td85"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Zagreb, Croatian Academy of Sciences and Arts, IV.a.48, fols. 93r–94v (15th cent.; = de Santos Otero 12)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td10"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("K3:")])]), _vm._v(" "), _c('td', {
    staticClass: "td85"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Zagreb, Croatian Academy of Sciences and Arts, Cod. glagoliticus VII a 30, fols. 1–3 (16th cent.)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td10"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("K4:")])]), _vm._v(" "), _c('td', {
    staticClass: "td85"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Oxford, Bodleian Library, M. S. Can. Lit. 414, fols. 50r–51v (15th. cent.)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td10"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("K5:")])]), _vm._v(" "), _c('td', {
    staticClass: "td85"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Zagreb, Croatian Academy of Sciences and Arts, Fragm. glagol. 80, several disjointed lines (14th cent.)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td10"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("L:")])]), _vm._v(" "), _c('td', {
    staticClass: "td85"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Lemberg (?), manuscript owned by Father Jaremec"), _c('span', {
    staticClass: "special-char"
  }, [_vm._v("ǐ")]), _vm._v("kij-Bîlachevič, fols. 87–91 (16th/17th cent.; = de Santos Otero 5)"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-014",
      "id": "foot_014"
    }
  }, [_vm._v("14")])])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td10"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("M:")])]), _vm._v(" "), _c('td', {
    staticClass: "td85"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Moscow, State Historical Museum, A. S. Uvarov Collection 66, folios not provided (18th cent.; = de Santos Otero 6)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td10"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("N:")])]), _vm._v(" "), _c('td', {
    staticClass: "td85"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Belgrade, National Library of Serbia, 760, fols. 61r–68v (16th cent.)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td10"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("O:")])]), _vm._v(" "), _c('td', {
    staticClass: "td85"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Cavtat (Croatia), Archive of Baltazar Bogišić, 2a, fols. 35r–38v (16th/17th cent.) (unpublished)")])])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Considering the popularity of the text—as evidenced by the many extant manuscripts, originating in virtually all corners of the Slavic-speaking world—it is no surprise that "), _c('em', [_vm._v("Dial. Devil")]), _vm._v(" has attracted the attention of Slavistics since the early days of modern study of Church Slavic apocrypha. The oldest scholarly work on "), _c('em', [_vm._v("Dial. Devil")]), _vm._v(" is—as is the case with many such works preserved in Church Slavic—Aleksandr Pypin’s collection of Old Russian apocrypha and pseudepigrapha,"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-015",
      "id": "foot_015"
    }
  }, [_vm._v("15")])]), _vm._v(" in which Pypin published an edition from a manuscript of Russian provenance (J2). A year later, Tichonravov re-edited the same text along with another one from a different Russian manuscript (M)."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-016",
      "id": "foot_016"
    }
  }, [_vm._v("16")])]), _vm._v(" These two versions form the core of the first group of Church Slavic recensions of "), _c('em', [_vm._v("Dial. Devil")]), _vm._v(", those of Eastern Slavic origin (henceforth group α), and are the only ones that have been translated into English."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-017",
      "id": "foot_017"
    }
  }, [_vm._v("17")])]), _vm._v(" The third member of group α is J1,"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-018",
      "id": "foot_018"
    }
  }, [_vm._v("18")])]), _vm._v(" which is related to the other two in both origin and language. Preserved in a manuscript owned by one father Teodor of Dub"), _c('span', {
    staticClass: "special-char"
  }, [_vm._v("ǐ")]), _vm._v("vec,"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-019",
      "id": "foot_019"
    }
  }, [_vm._v("19")])]), _vm._v(" it was edited and published by Ivan Franko."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-020",
      "id": "foot_020"
    }
  }, [_vm._v("20")])]), _vm._v(" Franko recognized the text’s obvious affinity with those published by Tichonravov, describing them as “belonging to the same type,” but noted obvious differences as well as some degree of Serbian influence."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-021",
      "id": "foot_021"
    }
  }, [_vm._v("21")])]), _vm._v(" The fourth and final member of this group is L, also published by Franko."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-022",
      "id": "foot_022"
    }
  }, [_vm._v("22")])]), _vm._v(" As Franko notes, however, this version is not related to M, J1, or J2; furthermore, it stands apart from the fellow members of group α linguistically: where the other three are written in more or less standard Church Slavic (modulo regional variation), the language of L is much closer to modern Slavic vernaculars (more specifically, Ukrainian) than to Church Slavic.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The second group of Church Slavic recensions (henceforth β) comprises manuscripts of clear South Slavic provenance (with the exception of Croatia, on which see below). These include our A (edited by Miltenova"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-023",
      "id": "foot_023"
    }
  }, [_vm._v("23")])]), _vm._v("), B (edited by Konstantin F. Radčenko and Jordan Ivanov"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-024",
      "id": "foot_024"
    }
  }, [_vm._v("24")])]), _vm._v("), D (edited by Ivanov and translated into modern Bulgarian by Petkanova"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-025",
      "id": "foot_025"
    }
  }, [_vm._v("25")])]), _vm._v("), H (edited by Stojan Novaković;"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-026",
      "id": "foot_026"
    }
  }, [_vm._v("26")])]), _vm._v(" the manuscript was destroyed in World War II), and I (edited by Georg Jiří Polívka"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-027",
      "id": "foot_027"
    }
  }, [_vm._v("27")])]), _vm._v("). Several unedited manuscripts belong here as well: C, E, F, and G, as well as two new discoveries noted by Miltenova (N and O)."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-028",
      "id": "foot_028"
    }
  }, [_vm._v("28")])]), _vm._v(" Of particular interest are two members of this group: A and B. A is primarily interesting because of its age, as it dates to the twelfth/thirteenth century and is thus the oldest Church Slavic witness of "), _c('em', [_vm._v("Dial. Devil")]), _vm._v(". This manuscript is the base text for the translation here. B, in contrast, is unique in some of its readings, particularly 2:6, which casts the text in a new light: the devil’s statement to Jesus “I am older than you” (where other recensions and the Greek text have “I am stronger than you”) hints at a dualistic understanding of the relationship between them, characteristic of Bogomil theology.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The third and final group of Slavic recensions (henceforth γ) is set apart by its written form and origin: this group contains five manuscripts from Croatia written in Croatian (square) Glagolitic script. The Croatian Glagolitic texts are typically considered to stand apart from the rest of the Church Slavic tradition for two reasons. First, Glagolitic was generally abandoned by the twelfth century in favor of the simpler Cyrillic script. The only exception is Croatia, where it experienced a revival in the thirteenth century and was in use well into the eighteenth century. Second, unlike the rest of the Slavic world where Church Slavic was used as the main written language and which belonged to the Byzantine rite, Croatia has always been a Catholic country. Consequently, the cultural and literary (not to mention linguistic) context of writings in Croatian Glagolitic is markedly different from those of, say, Bulgarian or Ukrainian provenance, since most texts preserved in Croatian Glagolitic are translations from Latin of liturgical texts, the Vulgate, legal codices, and lives of saints. That being said, Croatia was never completely cut off from Eastern Christianity and its literary production. Whether Croatian Glagolitic recensions of such popular works as the "), _c('em', [_vm._v("Physiologus")]), _vm._v(" are an example of that is doubtful; given that the oldest extant manuscripts date to the fifteenth century, it was probably made from Latin."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-029",
      "id": "foot_029"
    }
  }, [_vm._v("29")])]), _vm._v(" However, there is a tradition of Croatian Glagolitic apocryphal literature where, at least for a part of it, Greek is the most likely ultimate source of transmission. One prominent example is the "), _c('em', [_vm._v("Acts of Andrew and Matthias")]), _vm._v(", which is preserved in two Croatian Glagolitic manuscripts, one from the fifteenth century, the other from the sixteenth."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-030",
      "id": "foot_030"
    }
  }, [_vm._v("30")])]), _vm._v(" Neither is an original translation, but a reworking of an earlier translation into Church Slavic, most likely of Bulgarian provenance."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-031",
      "id": "foot_031"
    }
  }, [_vm._v("31")])]), _vm._v(" The Croatian Glagolitic recensions of "), _c('em', [_vm._v("Dial. Devil")]), _vm._v(" followed the same path as "), _c('em', [_vm._v("Acts Andr. Mth.")]), _vm._v(","), _c('em'), _vm._v(" with one distinction: "), _c('em', [_vm._v("Acts Andr. Mth.")]), _vm._v(" was a wildly popular work, as witnessed by the many Greek manuscripts and translations; "), _c('em', [_vm._v("Dial. Devil")]), _vm._v(" is only preserved in Greek and Church Slavic. It is therefore remarkable that no less than five recensions of "), _c('em', [_vm._v("Dial. Devil")]), _vm._v(" are preserved in the Croatian Glagolitic variety of Church Slavic.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The five manuscripts in the group γ were edited by Slavomir Sambunjak."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-032",
      "id": "foot_032"
    }
  }, [_vm._v("32")])]), _vm._v(" Sambunjak includes "), _c('em', [_vm._v("Dial. Devil")]), _vm._v(" in a larger collection of texts that fall under the umbrella of medieval debate poetry ("), _c('em', [_vm._v("Streitgedicht")]), _vm._v(") preserved in Croatian Glagolitic, such as the widely known and translated "), _c('em', [_vm._v("Visio Philiberti")]), _vm._v(" or the original Croatian composition "), _c('em', [_vm._v("Slovo meštra Polikarpa")]), _vm._v("."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-033",
      "id": "foot_033"
    }
  }, [_vm._v("33")])]), _vm._v(" The ubiquity of this genre might then explain the popularity of "), _c('em', [_vm._v("Dial. Devil")]), _vm._v(" in medieval Croatia. Sambunjak does, however, recognize the unique nature of "), _c('em', [_vm._v("Dial. Devil")]), _vm._v(" and, on the basis of the comparatively late dating of the Croatian Glagolitic manuscripts (none predates the fourteenth century), postulates that they were transcribed (and re-edited) from Church Slavic recensions originally composed in Cyrillic."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-034",
      "id": "foot_034"
    }
  }, [_vm._v("34")])]), _vm._v(" Of the five manuscripts (designated K1–K5), one (K5) is merely a fragment, containing bits of chapter 7; another (K1) is incomplete at the beginning. K1 is also remarkable for two more reasons: first, like L in group α and much more so than the other four Croatian Glagolitic recensions, its language shows the influence of the modern vernacular (more specifically, the čakavian dialects of Croatian); second, it agrees with the Bogomil version of 2:6 in recension B, with K1 having the devil say, “I am greater than your (angels) and older than everyone.” The remaining three witnesses are preserved complete: K2 and K3 can most likely be traced to a single archetype, while K4 deviates from them in a number of ways.")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_vm._v("Analysis of the Church Slavic Tradition")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Even a cursory look at the extant published Church Slavic recensions makes it obvious that the Church Slavic tradition of "), _c('em', [_vm._v("Dial. Devil")]), _vm._v(" is not a straightforward branch of the Greek one in the traditional view of textual criticism. Rather, the Church Slavic recensions are an extreme example of an open tradition where many (if not most) extant manuscripts contain versions of "), _c('em', [_vm._v("Dial. Devil")]), _vm._v(" that have obviously undergone significant editorial changes. As a result, there is not a single pair of extant published manuscripts—with the possible exception of K2 and K3—that can be traced to a single archetype. And while the manuscripts generally present the same narrative elements, they do not agree on even the simplest of details, such as ages or distances. For the purposes of our analysis, we will therefore consider each manuscript a separate recension and will refer to them as such.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The primary instances of editorial intervention are recensions M and L, which reveal their nature as re-edits even without a careful comparison of their contents with other traditions. M does so by combining a retelling of the temptation narrative from Matt 4:1–11 and Luke 4:1–13 with the narrative of "), _c('em', [_vm._v("Dial. Devil")]), _vm._v(" known from other recensions. L, in turn, is an obvious adaptation of (a version of) the Church Slavic text of "), _c('em', [_vm._v("Dial. Devil")]), _vm._v(" into a version of Church Slavic very close to the local vernacular—i.e., Ukrainian. In addition to that, the conclusion of L (7:12–16) is different from that of the rest of the tradition.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Both those modifications can also be observed in the Croatian Glagolitic recensions: K2, K3, and K4 add to the beginning of the narrative an episode where the devil in the form of a person tempts Jesus with avarice, worldly fame, and riches, but ultimately fails. Additionally, they all diverge from the rest of the tradition at 7:5 to provide a different ending: K4 concludes the text with a homiletic section listing occasions in the Bible where prayer and fasting (typically for forty days) saves someone, K1 ends abruptly with Jesus telling the devil to enter the abyss, and K2 and K3 describe Jesus’s and his disciples’ return to Jerusalem and admonish the readers to fast and pray. And as in L, all Croatian Glagolitic versions—save one—show clear signs of being adapted to local vernaculars. As Sambunjak notes,"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-035",
      "id": "foot_035"
    }
  }, [_vm._v("35")])]), _vm._v(" it is only the oldest Croatian Glagolitic recension, the fragmentary K5, that can be clearly described as written in what he terms the Church Slavic koine; the K2, K3, and K4 recensions gradually take on more and more characteristics of the spoken language of their environment—namely, the čakavian dialect of Croatian—with K1 being the closest to the Church Slavic norm, K3 the furthest away from it, K4 closer to K1, and K2 almost as colloquial as K3.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Comparing the content of individual recensions more closely reveals even more ways in which they have been rewritten and re-edited. Sometimes the edits are of a theological nature; one such instance is the aforementioned purported Bogomil edits in "), _c('em', [_vm._v("Dial. Devil")]), _vm._v(" 2:6 in B and K1 where the devil describes himself as older than Jesus (B) or older than everyone (K1). Another theological edit, which also illustrates the level of the disagreement between the recensions, can be found in 5:3–5. This section has Jesus asking, “Who cast the devil from heaven?” and his apostles respond. Not even such a simple chain of events is described in the same way in all Church Slavic recensions, as both the wording of the answer and the identity of the one providing it differ: Philip is the one who answers in B; Philip and Bartholomew in M; Peter in D, I, J1, and K1; John in L; John and Jacob in J1, K2, K3, and K4; “his disciples” in H; and the answer is given without an attribution in J2. Two manuscripts have two answers: In A, the first answer is given by John, the other by Peter. K1 even repeats the question twice: the first exchange has Thomas, Philip, Bartholomew, and John respond, “God is above all,” and in the second exchange, it is Peter who responds. The actual answer to Jesus’s question is much less varied: where B and D answer “your father,” H, J1, and M answer “you and your father,” and the remaining manuscripts reference all three persons in the Trinity in various wordings. Only I, however, does so with the standard formulation of “three persons, one God in three divine persons, Father and Son and the Holy Spirit.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("One of the most salient examples of the adaptation of the text to local language and environment is "), _c('em', [_vm._v("Dial. Devil")]), _vm._v(" 2:4: this verse includes a list of the devil’s works and, unsurprisingly for this tradition, the list is never the same in the recensions. Nevertheless, the different versions of the list contain more or less the same items, if in different order, divided into three major groups: the deadly sins, natural catastrophes, and war and conflict. The one recension that stands out is J2: where in the remaining recensions the list of the devil’s works consists of ten to fifteen items, J2 has twenty-three, including a number of peculiar ones, like “clapping” ("), _c('em', [_vm._v("pleskanîe")]), _vm._v(") and “wicked games” ("), _c('em', [_vm._v("igranîe nepodobnoe")]), _vm._v("). These terms describe folk festivals, especially those associated with rusalia, a spring festival that, after the Christianization of the Slavic world, became connected with the Pentecost. In Russia, these festivals often featured processions with loud music, dancing, and rituals dating back to the pre-Christian era; as a result, they were a frequent target of medieval Russian sermons admonishing pagan practices. One prominent example is the twelfth-century translation of the hagiography of Saint Niphon, bishop of Cyprus (4th cent.), compiled in Russia."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-036",
      "id": "foot_036"
    }
  }, [_vm._v("36")])]), _vm._v(" This translation features an entire section, not present in the original Greek, decrying these customs as “satisfying the needs of evil spirits,” where the word for “evil spirit” is "), _c('em', [_vm._v("běs")]), _c('span', {
    staticClass: "special-char-ital"
  }, [_vm._v("ǔ")]), _vm._v(", the same word that only J1, J2, L, and M (i.e., all East Slavic recensions) use to describe the devil’s army in "), _c('em', [_vm._v("Dial. Devil")]), _vm._v(" 4:1–2."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-037",
      "id": "foot_037"
    }
  }, [_vm._v("37")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("And finally, three Church Slavic recensions raise a question of local adaptation in terms of their "), _c('em', [_vm._v("Sitz im Leben")]), _vm._v(". K3, K4, and M all bear a title similar to that of prescribed liturgical readings: “Reading (on the) fifth Sunday of Lent” (K3), “Teaching for first Sunday of Lent after Matthew” (K4), and “For Great Friday, on the fasting and on the dispute between the Lord and the devil” (M). Would this then mean that the text, in one of its Greek or Church Slavic forms, was a part of the liturgy at least in some parts of the Slavic world? The homiletic additions at the end of K3 and K4 (and the same ending of K2) would certainly support this conclusion. Whether the cultural and religious milieu in which K2, K3, and K4 were produced—i.e., the Catholic liturgy—allows for this is a question that deserves a deeper study than can be offered here. Nevertheless, this differs from the incipits of the Greek manuscripts of "), _c('em', [_vm._v("Dial. Devil")]), _vm._v(","), _c('em'), _vm._v(" which"), _c('em'), _vm._v(" are transmitted in miscellany codices and simply describe the content of the text. A liturgical use of "), _c('em', [_vm._v("Dial. Devil")]), _vm._v("—albeit locally rather than universally in the medieval or early modern period—would challenge any strict division between “liturgical/homiletic” and “apocryphal” texts. As Péter Tóth has noted, Byzantine apocrypha and "), _c('em', [_vm._v("erōtapokriseis")]), _vm._v(" literature are often related and borrow from one another; for example, "), _c('em', [_vm._v("2 Apocryphal Apocalypse of John")]), _vm._v(" shares questions regarding the liturgy with "), _c('em', [_vm._v("Various Questions and Answers on Priests")]), _vm._v(" and Germanos of Constantinople’s "), _c('em', [_vm._v("Ecclesiastical History and Mystical Contemplation")]), _vm._v("."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-038",
      "id": "foot_038"
    }
  }, [_vm._v("38")])]), _vm._v(" Coptic texts such as the "), _c('em', [_vm._v("Investiture of the Archangel Michael")]), _vm._v(" similarly incorporate both apocryphal and liturgical elements so as to disturb any clear demarcation between the two. The same might be said of "), _c('em', [_vm._v("Dial. Devil")]), _vm._v("—namely, that it exists in the liminal space between Byzantine apocrypha and liturgical texts, while simultaneously utilizing dialogue and "), _c('em', [_vm._v("erōtapokriseis")]), _vm._v(" literature and traditions in more subtle ways.")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_vm._v("Theological Considerations")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', [_vm._v("Dial. Devil")]), _vm._v(" contributes to our understanding of Byzantine conceptions of the devil and the antichrist."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-039",
      "id": "foot_039"
    }
  }, [_vm._v("39")])]), _vm._v(" Unlike other portrayals of the antichrist as the devil’s son (e.g., Ps.-Hippolytus, "), _c('em', [_vm._v("Antichr.")]), _vm._v(" 15:1), here the antichrist is the devil incarnate."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-040",
      "id": "foot_040"
    }
  }, [_vm._v("40")])]), _vm._v(" The devil is accused of misleading Adam and chasing him out of paradise (2:3), as well as refusing to worship Adam when he was created (3:2) and attempting to spit on Jesus (6:2 in Greek B)."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-041",
      "id": "foot_041"
    }
  }, [_vm._v("41")])]), _vm._v(" "), _c('em', [_vm._v("Dial. Devil")]), _vm._v(" works within previous and concurrent traditions of the devil opposing Adam’s creation and jealously deceiving him and Eve. For example, the various recensions and translations of the "), _c('em', [_vm._v("Life of Adam and Eve")]), _vm._v(" present the devil as failing to worship Adam, being exiled from heaven, attempting to establish a throne in heaven, and misleading Eve as punishment against Adam (12:1–17:3)."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-042",
      "id": "foot_042"
    }
  }, [_vm._v("42")])]), _vm._v(" Similarly, the Qur"), _c('span', {
    staticClass: "special-char"
  }, [_vm._v("ʼ")]), _vm._v("an transmits a tradition in which Iblis fails to worship the created Adam, is cast out of heaven until judgment day, deceives Adam and Eve to eat from the tree of knowledge, and demands permission to mislead humanity."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-043",
      "id": "foot_043"
    }
  }, [_vm._v("43")])]), _vm._v(" The tradition occurs also in several interrelated Coptic apostolic memoirs."), _c('em'), _vm._v(" Here Jesus descends to save Adam and his children ("), _c('em', [_vm._v("Invest. Mich.")]), _vm._v(" 3:15; "), _c('em', [_vm._v("Invest. Abbat.")]), _vm._v(" 5:12–13), and the devil once more refuses to worship Adam; for his impertinence, he is thrown out of heaven ("), _c('em', [_vm._v("Invest. Mich.")]), _vm._v(" 3:29–38; "), _c('em', [_vm._v("Invest. Abbat.")]), _vm._v(" 6; "), _c('em', [_vm._v("Invest. Gab.")]), _vm._v(" 9:6–8)."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-044",
      "id": "foot_044"
    }
  }, [_vm._v("44")])]), _vm._v(" Similar narratives appear in Greek texts like the "), _c('em', [_vm._v("Apocalypse of Sedrach")]), _vm._v(" and "), _c('em', [_vm._v("Questions of Bartholomew.")]), _vm._v(" In the former text, Adam is placed in paradise but is deceived to eat by the devil (4:4–5), leading Sedrach to question why God would not kill the devil and end his torment of humanity."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-045",
      "id": "foot_045"
    }
  }, [_vm._v("45")])]), _vm._v(" Sedrach challenges God’s judgment and asks a question that "), _c('em', [_vm._v("Dial. Devil")]), _vm._v(" shares almost verbatim: “If someone lives eighty or ninety or a hundred years, and lives them in sin but in the end is converted and lives in repentance, for how many days of repentance do you forgive their sins?” (12:5), to which God answers three years. While "), _c('em', [_vm._v("Dial. Devil")]), _vm._v(" does not ask how long one needs to repent in order to be saved, it does"), _c('em'), _vm._v(" present the devil as having three years to reign on the earth in its final days (7:5), so perhaps those three years are meant to give humanity time to repent."), _c('em'), _vm._v(" In "), _c('em', [_vm._v("Quest. Bart.")]), _vm._v(","), _c('em'), _vm._v(" Beliar is trapped by Bartholomew and explains how God and Michael formed Adam as the image of God, as well as how the devil refused to worship such a creature since he himself was the first angel created (4:52–58). God then casts out Satan and six hundred angels, who are knocked unconscious for forty years before beginning their plot against Adam."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-046",
      "id": "foot_046"
    }
  }, [_vm._v("46")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('em', [_vm._v("Dial. Devil")]), _vm._v(" also presents a particular tradition regarding the death of the devil and his fate as ruler of the earth (7:6–9). As noted earlier, the devil is given three years to reign across the "), _c('em', [_vm._v("Dial. Devil")]), _vm._v(" recensions, which the text shares with "), _c('em', [_vm._v("1 Apocryphal Apocalypse of John")]), _vm._v(". This is perhaps a time period comparable to the “time, times, and half a time” of Daniel (7:25; 9:27; 12:7, 11–12; cf. Rev 11:2; 12:14; 13:5)—often interpreted as three and a half years—or the tradition of the "), _c('em', [_vm._v("Ascension of Isaiah")]), _vm._v(" in which Beliar reigns for three years, seven months, and twenty-seven days, after which time Jesus and his armies will drag Beliar to gehenna ("), _c('em', [_vm._v("Ascen. Isa.")]), _vm._v(" 4:12)."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-047",
      "id": "foot_047"
    }
  }, [_vm._v("47")])]), _vm._v(" As noted above, the time of the devil’s reign might also correlate to the amount of time that God allows for repentance in "), _c('em', [_vm._v("Apoc. Sedr.")]), _vm._v(" In any case, "), _c('em', [_vm._v("Dial. Devil")]), _vm._v(" draws on Jesus’s divine ability to shorten time (Ps 88:45; 89:4 LXX; Mark 13:20//Matt 24:22; "), _c('em', [_vm._v("1 Apocr. Apoc. John")]), _vm._v(" 8:2–3; "), _c('em', [_vm._v("Tib. Sib.")]), _vm._v(" 8:2), so that God will diminish the devil’s short reign on earth.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('em', [_vm._v("Dial. Devil")]), _vm._v(" also shares with "), _c('em', [_vm._v("1 Apocr. Apoc. John")]), _vm._v(" two other traditions: the slaughter of the devil by Enoch and Elijah, and the presence of Temeluchus as an agent of punishment (depending on the recension). Both texts seemingly draw on Rev 11:3–13, in which God grants two witnesses authority to prophesy for the three and a half years, who can spit fire at anyone who harms them, plague the earth, kill the beast who emerges from the bottomless pit, and themselves die in “the great city that is prophetically called Sodom and Egypt, where also their Lord was crucified” (Rev 11:8). While "), _c('em', [_vm._v("1 Apocr. Apoc. John")]), _vm._v(" 8:5 presents Enoch and Elijah accusing the devil and being killed by him on an altar (cf. "), _c('em', [_vm._v("Apoc. El.")]), _vm._v(" 5:32–35), various "), _c('em', [_vm._v("Dial. Devil")]), _vm._v(" recensions depict the Virgin Mary and John the Baptist, along with Enoch and Elijah, in killing the devil. Particularly in Greek B, John the Baptist is included in this list of murderers of the devil because he seemingly deserves justice or revenge for being beheaded by Herod at the devil’s instigation. Since the devil denies having tempted Herod in Greek A, there is no reason for John the Baptist to be involved. There is also a related tradition in the "), _c('em', [_vm._v("(Latin) Revelation of John about Antichrist")]), _vm._v(","), _c('em'), _vm._v(" in which the antichrist kills Enoch and Elijah and they lie dead on the street until they are resurrected and Michael arrives to slay the devil ("), _c('em', [_vm._v("Rev. John Ant.")]), _vm._v(" 5:1–5; cf. "), _c('em', [_vm._v("Apoc. Dan.")]), _vm._v(" 14; Ps.-Hippolytus, "), _c('em', [_vm._v("De consummatione mundi")]), _vm._v(" 21; "), _c('em', [_vm._v("Tib. Sib.")]), _vm._v(" 8:5–6)."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-048",
      "id": "foot_048"
    }
  }, [_vm._v("48")])]), _vm._v(" By the tenth century, Adso notes that former writers believed that either Jesus or Michael will kill the antichrist on the Mount of Olives—a tradition shared with some hadith regarding Jesus returning to kill Dajjal."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-049",
      "id": "foot_049"
    }
  }, [_vm._v("49")])]), _vm._v(" Seemingly, the tradition preserved in "), _c('em', [_vm._v("Dial. Devil")]), _vm._v(" follows Rev 11 regarding the two prophetic witnesses confronting the devil but does not continue with their own deaths; rather, they seem to be resurrected for this very purpose. "), _c('em', [_vm._v("1 Apocr. Apoc. John")]), _vm._v(" and "), _c('em', [_vm._v("Dial. Devil")]), _vm._v(" also share the character of Temeluchus, presented in the apocalypse (after 27:6 in manuscript E of the text)"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-050",
      "id": "foot_050"
    }
  }, [_vm._v("50")])]), _vm._v(" as the primary agent of punishment who commands the keepers of hell and gathers sinners to be melted; in "), _c('em', [_vm._v("Dial. Devil")]), _vm._v(" he is the mediator between the earth and hell for unrepentant souls (2:6). Such a number of similarities led Yavor Miltenov to suggest that "), _c('em', [_vm._v("Dial. Devil")]), _vm._v(" is textually dependent on "), _c('em', [_vm._v("1 Apocr. Apoc. John.")]), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-051",
      "id": "foot_051"
    }
  }, [_vm._v("51")])]), _vm._v(" However, Temeluchus appears elsewhere across apocryphal traditions, such as the Ethiopic "), _c('em', [_vm._v("Apocalypse of Peter")]), _vm._v(" 8, "), _c('em', [_vm._v("Meqabyan")]), _vm._v(" (Ethiopic "), _c('em', [_vm._v("Maccabees")]), _vm._v("), and the "), _c('em', [_vm._v("Apocalypse of Paul/Visio Pauli.")]), _vm._v(" In "), _c('em', [_vm._v("Apoc. Paul")]), _vm._v(","), _c('em'), _vm._v(" this figure is the one in charge of torments and casting sinners into the outer darkness (15, 18), who has a flaming pitchfork (34)."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-052",
      "id": "foot_052"
    }
  }, [_vm._v("52")])]), _vm._v(" While images of the devil and Temeluchus are sometimes conflated in modern conceptions of Satan, "), _c('em', [_vm._v("Dial. Devil")]), _vm._v(" treats the angelic tormenter as quite distinct from the devil.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("One of the most puzzling aspects of "), _c('em', [_vm._v("Dial. Devil")]), _vm._v(" is the location at which the devil is supposed to meet his fate. In Greek A, the devil must go to “Gouze, the land of the Egyptians” (6:4), after he is born from Perdition ("), _c('em', [_vm._v("Ap")]), _c('em', [_vm._v("ō")]), _c('em', [_vm._v("leia")]), _vm._v("; cf. 2 Thess 2:3) and completes his three-year reign, to be slaughtered. In Greek B, the devil is told to go to “the city of Daphne in the land of Gouze” in order to be sold in the meat market like a pickled fish,"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-053",
      "id": "foot_053"
    }
  }, [_vm._v("53")])]), _vm._v(" as well as to be born from the virgin Eudokia because he must be born of Injustice ("), _c('em', [_vm._v("Adikia")]), _vm._v("). The majority of the Church Slavic recensions omit this passage; only A, D, I, and J2 include the reference to the city, where A, D, and J2 refer to it as "), _c('em', [_vm._v("Chizi")]), _vm._v(", while I2 has "), _c('em', [_vm._v("Chižina")]), _vm._v(" (a word that could also mean “hut, shack,” so this may be a scribal error). The phonology of the Church Slavic equivalents, especially the initial consonant (the "), _c('em', [_vm._v("ch")]), _vm._v(" in Scottish "), _c('em', [_vm._v("loch")]), _vm._v("), which would not be obtained in Church Slavic from the Greek "), _c('em', [_vm._v("gamma")]), _vm._v(", offers the possibility that these recensions were made from a Greek original that contained a different name. Without any textual evidence, however, this remains a mere speculation.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("While the location of this city is unknown to Casey and Thomson,"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-054",
      "id": "foot_054"
    }
  }, [_vm._v("54")])]), _vm._v(" others argue that the site of Daphne (also known as Tahpanhes) on the northeastern side of the Delta is a candidate."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-055",
      "id": "foot_055"
    }
  }, [_vm._v("55")])]), _vm._v(" Klaus Berger recognized that a similar city name, Gouzeth, appears in the ninth-century "), _c('em', [_vm._v("Apocalypse of Daniel")]), _vm._v(","), _c('em'), _vm._v(" based on which Berger argues that both "), _c('em', [_vm._v("Apoc. Dan.")]), _vm._v(" and "), _c('em', [_vm._v("Dial. Devil")]), _vm._v(" are referring to Kush (Greek "), _c('em', [_vm._v("Chous")]), _vm._v("; "), _c('em', [_vm._v("Chouse")]), _vm._v(")."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-056",
      "id": "foot_056"
    }
  }, [_vm._v("56")])]), _vm._v(" Another possibility is that this name is tied to Chouseth, the daughter of the king of Ethiopia who is identified as the mother of Alexander the Great—and, later, the wife of Byzas, founder of Byzantium—in the "), _c('em', [_vm._v("Apocalypse of Ps.-Methodius")]), _vm._v("."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-057",
      "id": "foot_057"
    }
  }, [_vm._v("57")])]), _vm._v(" In either case, "), _c('em', [_vm._v("Dial. Devil")]), _vm._v(" might be following the antichrist tradition present in Ps.-Athanasius’s seventh-century "), _c('em', [_vm._v("Quaestiones ad Antiochem ducem")]), _vm._v(","), _c('em'), _vm._v(" a Byzantine collection of 137 questions and answers regarding Christianity’s relationship to Hellenism and Judaism. "), _c('em', [_vm._v("Quaest. ad Ant.")]), _vm._v(" 109 asks: “And is it true, that the Antichrist will emerge from Egypt?” (PG 28:664D–665), to which the answerer refutes such a fable and claims that the antichrist will come from Scythopolis. Even while denying that the antichrist is associated with Egypt, "), _c('em', [_vm._v("Quaest. ad Ant.")]), _vm._v(" preserves an early Byzantine tradition of such a story being told. As David Frankfurter notes, the “Land of Egypt oracle” is a long-standing Egyptian tradition continuing from the New Kingdom through late antiquity that imagines “the effects of kingship and ‘antikingship’ and articulate[s] the nature of Egypt as a sacred landscape whose fortunes responded to divine presence.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-058",
      "id": "foot_058"
    }
  }, [_vm._v("58")])]), _vm._v(" The aforementioned texts understand the land of Egypt as central to a Christianized apocalyptic scenario in which the antichrist will emerge in or be (re)born from Egypt and will be confronted there.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Finally, the name given to the mother of the devil in the Greek recensions is equally troubling. Greek A presents her clearly as Perdition, referring to the “son of perdition” appearing in both John 17:12 and 2 Thess 2:3. In the former, the clear referent is Judas Iscariot; in the latter, the figure is more obscurely referred to as the “man of lawlessness” who will be revealed and doomed to destruction in the day of the Lord. Greek A evidently took these passages literally, associated the “son of perdition” with the antichrist, and thus hypostatized the mother of the devil into the woman Perdition."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-059",
      "id": "foot_059"
    }
  }, [_vm._v("59")])]), _vm._v(" However, Greek B is more difficult to follow. This recension also hypostatizes a vice, Injustice, into the prophesied mother of the devil/antichrist. But the mother’s name is given as Eudokia, and the justification for her role as mother is “because you ought to be born from injustice.” This woman purchases the devil/antichrist as a fish and then bears him. This odd narrative is explained further in "), _c('em', [_vm._v("Apoc. Dan.")]), _vm._v(" 9:1–13,"), _c('em'), _vm._v(" in which the antichrist comes into a garidion fish in order to be caught by one of the twelve fishermen (i.e., the apostles) so as to win over Judas. The fish-antichrist is sold off at a market in Gouzeth by Judas for thirty silver pieces and is purchased by Injustice-Perdition, who becomes pregnant with the antichrist when she touches the head of the fish and carries him for three months. Thus, the antichrist mimics Christ by also"), _c('em'), _vm._v(" becoming incarnate of a virgin in this Byzantine tradition."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-060",
      "id": "foot_060"
    }
  }, [_vm._v("60")])]), _vm._v(" One might also look to Gregory of Nyssa’s comparison of the devil to a fish or dragon caught by a fishhook with the incarnate Christ as bait for evidence of the continuation of the devil-as-fish motif in late antiquity."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-061",
      "id": "foot_061"
    }
  }, [_vm._v("61")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("While Klaus Berger contends that this name change from Adikia to Eudokia in "), _c('em', [_vm._v("Dial. Devil")]), _vm._v(" is simply a scribal error, Jacques van der Vliet argues that it may be a reference to the fifth-century empress Eudokia, wife of Theodosius II, who was well known for siding with the anti-Chalcedonians at the Council of Chalcedon and may have been distrusted by monophysite leaders."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-062",
      "id": "foot_062"
    }
  }, [_vm._v("62")])]), _vm._v(" Beyond this, van der Vliet suggests that a fifth-century Palestinian monk copying "), _c('em', [_vm._v("Dial. Devil")]), _vm._v(" may have inserted this Eudokia pun to make the virgin of Daphne into the Byzantine empress, who is then fatally passionate about a fish and bears the antichrist. "), _c('em', [_vm._v("Apoc. Dan.")]), _vm._v(" combines these two traditions (albeit without Eudokia), so that the antichrist is born in Gouzeth from a virgin named Injustice ("), _c('em', [_vm._v("Adikia")]), _vm._v("), whose surname will be Perdition ("), _c('em', [_vm._v("Ap")]), _c('em', [_vm._v("ō")]), _c('em', [_vm._v("leia")]), _vm._v("; "), _c('em', [_vm._v("Apoc. Dan.")]), _vm._v(" 9:9–11). While van der Vliet’s suggestion is tantalizing, it seems more likely that the addition of Eudokia arose as a scribal error from Adikia.")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_vm._v("Date and Provenance")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Regarding the date of "), _c('em', [_vm._v("Dial. Devil")]), _vm._v(","), _c('em'), _vm._v(" it is difficult to narrow the time frame to anything more than a window of multiple centuries. The earliest known sources include the two Greek manuscripts from the Biblioteca Nazionale Marciana (12th cent.) and the Österreichische Nationalbibliothek (13th cent.), as well as a Church Slavic manuscript from St. Catherine’s Monastery (12th/13th cent.), thereby making the twelfth century the "), _c('em', [_vm._v("terminus ante quem.")]), _vm._v(" To our knowledge, "), _c('em', [_vm._v("Dial. Devil")]), _vm._v(" is not mentioned in any late ancient or early medieval commentaries or scholia, and so cannot be traced back further through such a citation. Little is known about the provenance of "), _c('em', [_vm._v("Dial. Devil.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Regarding a "), _c('em', [_vm._v("terminus post quem")]), _vm._v(","), _c('em'), _vm._v(" Radčenko argues that "), _c('em', [_vm._v("Dial. Devil")]), _vm._v(" is contaminated by the influences of the Bogomils, a tenth-century dualist sect emerging from the Balkans."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-063",
      "id": "foot_063"
    }
  }, [_vm._v("63")])]), _c('em'), _vm._v(" Émil Turdeanu, on the other hand, has suggested that it is unlikely that "), _c('em', [_vm._v("Dial. Devil")]), _vm._v(" originated among or was influenced by the Bogomils, in large part due to the text’s non-Bogomil characteristics—e.g., humanity as created by God, the cult of the Virgin, and respect for the prophets and John the Baptist."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-064",
      "id": "foot_064"
    }
  }, [_vm._v("64")])]), _vm._v(" Likewise, Vassiliev suggests potential Manichaean or Paulician influence, thereby placing "), _c('em', [_vm._v("Dial. Devil")]), _vm._v(" in a seventh- or eighth-century context."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-065",
      "id": "foot_065"
    }
  }, [_vm._v("65")])]), _vm._v(" The Greek version of "), _c('em', [_vm._v("Dial. Devil")]), _vm._v(" makes use of traditions present in other late ancient and Byzantine texts, such as the "), _c('em', [_vm._v("Tiburtine Sibyl")]), _vm._v(" (4th cent.), "), _c('em', [_vm._v("1 Apocr. Apoc. John")]), _vm._v(" (5th–8th cent.), and "), _c('em', [_vm._v("Apoc. Dan.")]), _vm._v(" (9th cent.), but it is unclear if any of these texts directly borrow material from one another or from other sources, as well as which direction the borrowing occurs for the more difficult texts to date. Establishing a time of composition is difficult also because of the lack of references to larger political events in late antiquity or to the rise of Islam (e.g., as one finds in "), _c('em', [_vm._v("Apoc. Ps.-Meth.")]), _vm._v(", "), _c('em', [_vm._v("Apoc. Ps.-Ephrem")]), _vm._v(", or "), _c('em', [_vm._v("Apoc. Dan.")]), _vm._v("). "), _c('em', [_vm._v("Dial. Devil")]), _vm._v(" participates in a tradition of the antichrist emerging from Egypt, as seen in the seventh-century "), _c('em', [_vm._v("Quaest. ad Ant.")]), _vm._v(","), _c('em'), _vm._v(" but does not make use of the narrative of Satan emerging from Bethsaida and Chorazin, nor of the antichrist being a Jew from the tribe of Dan, such as is preserved in Adso of Montier-en-Der’s tenth-century "), _c('em', [_vm._v("De ortu et tempore Antichristi")]), _vm._v("."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-066",
      "id": "foot_066"
    }
  }, [_vm._v("66")])])]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_vm._v("Translation")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Chance Bonar provides here a translation of the Greek Jerusalem manuscript (J) and Slavomír Čéplö the Church Slavic Sinai manuscript (A), translated here for the first time in any modern language. For the Greek text, variants from M and V are included in the footnotes. Chapter divisions proposed by Casey and Thomson are used with modifications. In light of the complexity of the Church Slavic tradition, providing a critical translation would not be possible; instead, the notes contain the most important deviations from the text of A and are provided to give the reader an overview of the development of the Church Slavic tradition.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-h1"
  }, [_vm._v("Bibliography")]), _vm._v(" "), _c('p', {
    staticClass: "bib-h2"
  }, [_vm._v("EDITIONS AND TRANSLATIONS")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Casey, Robert P., and Robert W. Thomson. “A Dialogue between Christ and the Devil.” "), _c('em', [_vm._v("JTS")]), _vm._v(" n.s. 6, no. 1 (1955): 49–65. (Editions of Greek M and V, pp. 50–55; translations of Church Slavic J2 and M, pp. 55–60.)")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Franko, Ivan. "), _c('em', [_vm._v("Apokrifi î legendy z ukraïns")]), _c('span', {
    staticClass: "special-char-ital"
  }, [_vm._v("ǐ")]), _c('em', [_vm._v("kich rukopisiv")]), _vm._v(". 5 vols. Lviv: Nakladom Naukovoho Tovaristva îmeni Ševčenka, 1898. (Editions of Church Slavic J1 and L, 2:196–203.)")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Ivanov, Jordan. "), _c('em', [_vm._v("Bogomilski knigi i legendi.")]), _vm._v(" Sofia: Pridvorna pečatnica, 1925. (Reprinting of Radčenko’s edition of Church Slavic B, pp. 249–53.) French translation by Monette Ribeyrol. "), _c('em', [_vm._v("Livres & Légendes Bogomiles")]), _vm._v(". Paris: G.-P. Maisonneuve et Larose, 1976.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Novaković, Stojan. “Apokrif o prepiranju Isusa Hrista sa djavolom.” "), _c('em', [_vm._v("Starine")]), _vm._v(" 16 (1884): 86–89. (Edition of Church Slavic H.)")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Petkanova, Donka. "), _c('em', [_vm._v("Stara b")]), _c('span', {
    staticClass: "special-char-ital"
  }, [_vm._v("ǎ")]), _c('em', [_vm._v("lgarska literatura. Apokrifi")]), _vm._v(". Sofia: B"), _c('span', {
    staticClass: "special-char"
  }, [_vm._v("ǎ")]), _vm._v("lgarski pisatel, 1981. (Translation of Church Slavic D, 173–76.)")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Polivka, Georg Jiří. “Opisi i izvodi iz nekoliko jugoslavenskih rukopisa u Pragu.” "), _c('em', [_vm._v("Starine")]), _vm._v(" 22 (1890): 200–203. (Edition of Church Slavic I.)")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Pypin, Alexander N. "), _c('em', [_vm._v("Ložnyja i otrečennyja knigi russkoj stariny")]), _vm._v(". Pamjatniki starinnoj russkoj literatury 3. Saint Petersburg: Tipografîja P. A. Kuliša, 1862. ("), _c('em', [_vm._v("Editio princeps")]), _vm._v(" based on Church Slavic J2, pp. 86–88.)")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Radčenko, Konstantin F. “Zametki o pergamennom sbornike No. 139 (137) XIV veka Venskoj Pridvornoj biblioteki.” "), _c('em', [_vm._v("IORJAS")]), _vm._v(" 12, no. 3 (1907): 196–98. (Edition of Church Slavic B.)")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Sambunjak, Slavomir. "), _c('em', [_vm._v("Jezik i stil hrvatskih glagoljskih prenja")]), _vm._v(". Split: Književni Krug, 2000. (Edition of the five Croatian Glagolitic manuscripts, pp. 228–37.)")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Strohal, Rudolf. "), _c('em', [_vm._v("Stare hrvatske apokrifne priče i legendi. Sabrao iz starih hrvatskih glagolskih rukopisa od 14–18 vijeka Rudolf Strohal")]), _vm._v(". Bjelovar: Tisak i naklada Lav. Weiss-a, 1917."), _c('em'), _vm._v(" (Edition of Church Slavic K2, pp. 54–56.)")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Tichonravov, Nikolai S. "), _c('em', [_vm._v("Pamjatniki otrečennoj russkoj literatury.")]), _vm._v(" 2 vols. Moscow: Obščestv. Pol"), _c('span', {
    staticClass: "special-char"
  }, [_vm._v("ǐ")]), _vm._v("za, 1863. (Edition of Church Slavic J2 and M, 2:282–88.)")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Vassiliev, Athanasius. "), _c('em', [_vm._v("Anecdota graeco-byzantina, pars prior.")]), _vm._v(" Moscow: Imperial University, 1893. ("), _c('em', [_vm._v("Editiones princeps")]), _vm._v(" of Greek M and V, pp. 4–10.)")]), _vm._v(" "), _c('p', {
    staticClass: "bib-h2"
  }, [_vm._v("STUDIES")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Berger, Klaus. "), _c('em', [_vm._v("Die griechische Daniel-Diegese: eine altkirchliche Apokalypse: Text, Übersetzung und Kommentar.")]), _vm._v(" Leiden: Brill, 1976.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Fuchs, Albert. "), _c('em', [_vm._v("Konkordanz zu Gespräch Jesu mit dem Teufel, Version A und B.")]), _vm._v(" Linz: Fuchs, 1983.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Geller, Florentina Badalanova. “"), _c('em', [_vm._v("The Sea of Tiberias")]), _vm._v(":"), _c('em'), _vm._v(" Between Apocryphal Literature and Oral Tradition.” Pages 13–157 in "), _c('em', [_vm._v("The Old Testament Apocrypha in the Slavonic Tradition.")]), _vm._v(" Edited by Lorenzo DiTommaso and Christfried Böttrich. TSAJ 140. Tübingen: Mohr Siebeck, 2011.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("———. “Slavonic Redactions of the Apocryphal "), _c('em', [_vm._v("Homily of John Chrysostom on How Archangel Michael Defeated Satanail")]), _vm._v(": Some Considerations.” Pages 96–131 in "), _c('em', [_vm._v("The Embroidered Bible: Studies in Biblical Apocrypha and Pseudepigrapha in Honour of Michael E. Stone")]), _vm._v(". Edited by Lorenzo DiTommaso, Matthias Henze, and William Adler. Leiden: Brill, 2018. (See esp. pp. 103–4, which include an excerpt from Sofia, Narodna Biblioteka, 433.)")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Harris, J. Rendel. "), _c('em', [_vm._v("The Rest of the Words of Baruch: A Christian Apocalypse of the Year 136 A. D.; The Text Revised with an Introduction.")]), _vm._v(" Cambridge: Cambridge University Press, 1889. (Detailed description of Greek J, but incomplete and using old folio numbering, pp. 27–29.)")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("McGinn, Bernard. "), _c('em', [_vm._v("Antichrist: Two Thousand Years of the Human Fascination with Evil")]), _vm._v(". New York: Columbia University Press, 2000.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Miltenov, Yavor. “Apocryphal Apocalypse of John the Theologian: Analysis of Intertextual Relations.” "), _c('em', [_vm._v("Palaeobulgarica")]), _vm._v(" 28, no. 3 (2004): 85–102.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Miltenova, Anissava. “Slavonic Apocrypha: New Discoveries, New Perusals: The Cases of the Dispute between Our Lord Jesus Christ and the Antichrist and the Story about Beautiful Joseph.” "), _c('em', [_vm._v("Scrinium")]), _vm._v(" 14, no. 1 (2018): 273–88. (Revised list of Church Slavic MSS, pp. 273–82.)")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("———. “Za Sinajskija prepis na ‘Prenie na Iisus Christos s djavola’ i negovija kontekst.” Pages 21–33 in "), _c('em', [_vm._v("“Slova i zolota vjaz")]), _c('span', {
    staticClass: "special-char-ital"
  }, [_vm._v("ǐ")]), _vm._v(" "), _c('em', [_vm._v("…” Sbornik statej pamjati Vjačeslava Michajloviča Zagrebina (1942–2004)")]), _vm._v(". Edited by Z. L. Levšina. Saint Petersburg: Izdatel"), _c('span', {
    staticClass: "special-char"
  }, [_vm._v("ǐ")]), _vm._v("stvo Rossijskaja nacional"), _c('span', {
    staticClass: "special-char"
  }, [_vm._v("ǐ")]), _vm._v("naja biblioteka, 2016.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Petkov, Julian. "), _c('em', [_vm._v("Altslavische Eschatologie: Texte und Studien zur apokalyptischen Literatur in kirchenslavischer Überlieferung.")]), _vm._v(" TANZ 59. Tübingen: Narr Francke Attempto, 2016.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Radčenko, Konstantin. “Etjudy po bogomil"), _c('span', {
    staticClass: "special-char"
  }, [_vm._v("ǐ")]), _vm._v("stvu.” Pages 29–38 in "), _c('em', [_vm._v("Izbornik Kievskij posvjaščennyj T. D. Florinskomu")]), _vm._v(". Kyiv: Tip. T. G. Mejnandera, P. A Barskogo, I. I. Čokolova i Kievo-Pečersk. lavry, 1904.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Rosenstiehl, Jean-Marc. “Armenian Witnesses of Three Eschatological Motifs.” Pages 254–82 in "), _c('em', [_vm._v("The Armenian Apocalyptic Tradition: A Comparative Perspective.")]), _vm._v(" Edited by Kevork B. Bardakjian and Sergio La Porta. Leiden: Brill, 2014.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Turdeanu, Émil. “Apocryphes bogomiles et apocryphes pseudo-bogomiles.” "), _c('em', [_vm._v("RHR")]), _vm._v(" 138 (1950): 22–52, 176–218.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Vliet, Jacques van der. “Une Vierge de Daphné: Notes sur un Thème Apocalyptique.” "), _c('em', [_vm._v("Byzantion")]), _vm._v(" 64, no. 2 (1994): 377–90.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/foot.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_001",
      "id": "foot-001"
    }
  }, [_vm._v("1")]), _vm._v(". See Averil Cameron, "), _c('em', [_vm._v("Dialoguing in Late Antiquity")]), _vm._v(" (Cambridge, MA: Center for Hellenic Studies, 2014), on how “these prose dialogues—literary discussions between two or more speakers on a specific question or group of related questions—are still neglected as a significant component of late antique Christian literature. This is still more the case for Byzantium, even though dialogues continued to be written in Greek for many centuries and were particularly favored by Byzantine intellectuals in some periods” (1). While this text was unknown in Anglo-American circles until recently, the dialogic form surrounding the characters of Jesus and the devil was well known in a nineteenth-century American schoolbook, "), _c('em', [_vm._v("A Dialogue between Christ, a Youth, and the Devil")]), _vm._v(" (Philadelphia: American Sunday-School Union, 1846).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_002",
      "id": "foot-002"
    }
  }, [_vm._v("2")]), _vm._v(". While the temptation of Christ is well known and used by early Christian writers, there are few narrative expansions or rereadings of this gospel scene. One other example may be found in the "), _c('em', [_vm._v("Book of Allogenes")]), _vm._v(" (Tchacos Codex, IV), in which Allogenes ascends Mount Tabor and is tempted by Satan twice before his transfiguration. See Madeleine Scopello, “The Temptation of Allogenes (Codex Tchacos, Tractate IV),” in "), _c('em', [_vm._v("Gnosticism, Platonism and the Late Ancient World: Essays in Honor of John D. Turner")]), _vm._v(","), _c('em'), _vm._v(" ed. Kevin Corrigan and Tuomas Rasimus, Nag Hammadi and Manichaean Studies 82 (Leiden: Brill, 2013), 117–37.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_003",
      "id": "foot-003"
    }
  }, [_vm._v("3")]), _vm._v(". Vassiliev, "), _c('em', [_vm._v("Anecdota graeco-byzantina")]), _vm._v(", 4–10.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_004",
      "id": "foot-004"
    }
  }, [_vm._v("4")]), _vm._v(". Casey and Thomson, “Dialogue,” 49–65.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_005",
      "id": "foot-005"
    }
  }, [_vm._v("5")]), _vm._v(". Tichonravov, "), _c('em', [_vm._v("Pamjatniki")]), _vm._v(","), _c('em'), _vm._v(" 2:282–88; see Casey and Thomson, “Dialogue,” 49.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_006",
      "id": "foot-006"
    }
  }, [_vm._v("6")]), _vm._v(". Before the addition of Arabic numerals to the manuscript, the Greek numbers for these folia read—as Rendel Harris recorded—from 182 ("), _c('span', {
    staticClass: "overline-3a"
  }, [_vm._v("ρπβ")]), _vm._v(") to 186 ("), _c('span', {
    staticClass: "overline-3a"
  }, [_vm._v("ρπς")]), _vm._v("). At some point in the twentieth century, these Greek numbers were struck through.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_007",
      "id": "foot-007"
    }
  }, [_vm._v("7")]), _vm._v(". Harris, "), _c('em', [_vm._v("Rest of the Words of Baruch")]), _vm._v(", 27–29; Casey and Thomson, “Dialogue,” 49. For more on this manuscript, see Albert Ehrhard, "), _c('em', [_vm._v("Überlieferung und Bestand der hagiographischen und homiletischen Literatur der griechischen Kirche von den Anfängen bis zum Ende des 16. Jahrhunderts")]), _vm._v(","), _c('em'), _vm._v(" TU 50–52, 3 vols. (Leipzig: Hinrichs, 1937–1952), 3:845; Athanasios Papadopoulos-Kérameus, "), _c('em', [_vm._v("Hierosolumitikē bibliothēkē ētoi katalogos tōn en tais bibliothēkais tou hagiōtatou apostolikou")]), _vm._v(", 3 vols. (1894; repr. Brussels: Culture et Civilization, 1963), 1:149–54.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_008",
      "id": "foot-008"
    }
  }, [_vm._v("8")]), _vm._v(". Casey and Thomson, “Dialogue,” 64.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_009",
      "id": "foot-009"
    }
  }, [_vm._v("9")]), _vm._v(". As the traditional terms “Slavonic” and “Slavic” are ambiguous, in what follows we will be referring to these recensions by their language of composition, which is Church Slavic.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_010",
      "id": "foot-010"
    }
  }, [_vm._v("10")]), _vm._v(". De Santos Otero, "), _c('em', [_vm._v("HUAA")]), _vm._v(", 2:156–60.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_011",
      "id": "foot-011"
    }
  }, [_vm._v("11")]), _vm._v(". Francis J. Thomson, “Apocrypha Slavica: II,” review of "), _c('em', [_vm._v("HUAA")]), _vm._v(" 2, by Aurelio de Santos Otero, "), _c('em', [_vm._v("Slavonic and East European Review")]), _vm._v(" 63.1 (1985): 79–98, esp. 88–89.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_012",
      "id": "foot-012"
    }
  }, [_vm._v("12")]), _vm._v(". Petkov, "), _c('em', [_vm._v("Altslavische Eschatologie")]), _vm._v(", 163–65.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_013",
      "id": "foot-013"
    }
  }, [_vm._v("13")]), _vm._v(". Miltenova, “Slavonic Apocrypha,” 276–77.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_014",
      "id": "foot-014"
    }
  }, [_vm._v("14")]), _vm._v(". Edition in Franko, "), _c('em', [_vm._v("Apokrifi î legendi")]), _vm._v(", 2:200–203.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_015",
      "id": "foot-015"
    }
  }, [_vm._v("15")]), _vm._v(". Pypin, "), _c('em', [_vm._v("Ložnyja")]), _vm._v(","), _c('em'), _vm._v(" 86–88.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_016",
      "id": "foot-016"
    }
  }, [_vm._v("16")]), _vm._v(". Tichonravov, "), _c('em', [_vm._v("Pamjatniki")]), _vm._v(", 2:285–88.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_017",
      "id": "foot-017"
    }
  }, [_vm._v("17")]), _vm._v(". Casey and Thomson, “Dialogue.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_018",
      "id": "foot-018"
    }
  }, [_vm._v("18")]), _vm._v(". Edition in Franko, "), _c('em', [_vm._v("Apokrifi î legendi")]), _vm._v(", 2:200–203.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_019",
      "id": "foot-019"
    }
  }, [_vm._v("19")]), _vm._v(". Probably Dubove, in today’s Tjačiv region of the Ukraine. The actual provenance of the manuscript is unclear.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_020",
      "id": "foot-020"
    }
  }, [_vm._v("20")]), _vm._v(". Franko, "), _c('em', [_vm._v("Apokrifi î legendi")]), _vm._v(", 2:196–200.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_021",
      "id": "foot-021"
    }
  }, [_vm._v("21")]), _vm._v(". Franko, "), _c('em', [_vm._v("Apokrifi î legendi")]), _vm._v(", 2:199.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_022",
      "id": "foot-022"
    }
  }, [_vm._v("22")]), _vm._v(". Franko, "), _c('em', [_vm._v("Apokrifi î legendi")]), _vm._v(", 2:200–203.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_023",
      "id": "foot-023"
    }
  }, [_vm._v("23")]), _vm._v(". Miltenova, “Za Sinajskija prepis,” 21–33.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_024",
      "id": "foot-024"
    }
  }, [_vm._v("24")]), _vm._v(". Radčenko, “Zametki,” 196–98; Ivanov, "), _c('em', [_vm._v("Bogomilski knigi i legendi")]), _vm._v(", 249–53.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_025",
      "id": "foot-025"
    }
  }, [_vm._v("25")]), _vm._v(". Edition in Ivanov, "), _c('em', [_vm._v("Bogomilski knigi i legendi")]), _vm._v(", 249–53; Petkanova, "), _c('em', [_vm._v("Stara b")]), _c('span', {
    staticClass: "special-char-ital"
  }, [_vm._v("ǎ")]), _c('em', [_vm._v("lgarska literatura")]), _vm._v(", 173–76.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_026",
      "id": "foot-026"
    }
  }, [_vm._v("26")]), _vm._v(". Novaković, “Apokrif,” 86–89.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_027",
      "id": "foot-027"
    }
  }, [_vm._v("27")]), _vm._v(". Polívka, “Opisi,” 200–203.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_028",
      "id": "foot-028"
    }
  }, [_vm._v("28")]), _vm._v(". Miltenova, “Slavonic Apocrypha,” 279–81.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_029",
      "id": "foot-029"
    }
  }, [_vm._v("29")]), _vm._v(". Nicolina Trunte, "), _c('em', [_vm._v("Slavenskïj ęzyk")]), _c('span', {
    staticClass: "special-char-ital"
  }, [_vm._v("ǔ")]), _c('em', [_vm._v(": Ein praktisches Lehrbuch des Kirchenslavischen in 30 Lektionen, zugleich eine Einführung in die slavische Philologie")]), _vm._v(","), _c('em'), _vm._v(" vol. 2, "), _c('em', [_vm._v("Mittel- und Neukirchenslavisch")]), _vm._v(" (Munich: Sagner, 2014), 38.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_030",
      "id": "foot-030"
    }
  }, [_vm._v("30")]), _vm._v(". Biserka Grabar, “Apokrifna djela apostolska u hrvatskoglagoljskoj literaturi. 1. Djela Andrije i mateja u gradu ljudoždera. 2. Djela apostola Petra i Andrije.” "), _c('em', [_vm._v("Radovi Staroslavenskog instituta")]), _vm._v(" 6 (1967): 109–208 at 119.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_031",
      "id": "foot-031"
    }
  }, [_vm._v("31")]), _vm._v(". Grabar, “Apokrifna djela apostolska,” 120–21.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_032",
      "id": "foot-032"
    }
  }, [_vm._v("32")]), _vm._v(". Sambunjak, "), _c('em', [_vm._v("Jezik")]), _vm._v(", 228–37. K2 appeared previously in Strohal, "), _c('em', [_vm._v("Stare hrvatske apokrifne")]), _vm._v(", 54–56.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_033",
      "id": "foot-033"
    }
  }, [_vm._v("33")]), _vm._v(". Marija-Ana Dürrigl and Stella Fatović-Ferencić, “Introducing Death: A 15th Century Croatian Glagolitic Literary Text,” "), _c('em', [_vm._v("Croatian Medical Journal")]), _vm._v(" 42 (2001): 683–88.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_034",
      "id": "foot-034"
    }
  }, [_vm._v("34")]), _vm._v(". Sambunjak, "), _c('em', [_vm._v("Jezik")]), _vm._v(", 15.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_035",
      "id": "foot-035"
    }
  }, [_vm._v("35")]), _vm._v(". Sambunjak, "), _c('em', [_vm._v("Jezik")]), _vm._v(", 92.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_036",
      "id": "foot-036"
    }
  }, [_vm._v("36")]), _vm._v(". Jiří Dynda, "), _c('em', [_vm._v("Slovanské pohanství ve středověkých ruských kázáních")]), _vm._v(" (Prague: Scriptorium, 2019), 345–56.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_037",
      "id": "foot-037"
    }
  }, [_vm._v("37")]), _vm._v(". Dynda, "), _c('em', [_vm._v("Slovanské")]), _vm._v(", 156–57.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_038",
      "id": "foot-038"
    }
  }, [_vm._v("38")]), _vm._v(". Péter Tóth, “New Wine in Old Wineskin: Byzantine Reuses of the Apocryphal Revelation Dialogue,” in "), _c('em', [_vm._v("Dialogues and Debates from Late Antiquity to Late Byzantium")]), _vm._v(", ed. Averil Cameron and Niels Gaul (New York: Routledge, 2017), 77–93.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_039",
      "id": "foot-039"
    }
  }, [_vm._v("39")]), _vm._v(". The following discussion focuses on the Greek version of the text; accordingly, the accompanying citations follow the numbering of the Greek text.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_040",
      "id": "foot-040"
    }
  }, [_vm._v("40")]), _vm._v(". See Wilhelm Bousset, "), _c('em', [_vm._v("The Antichrist Legend: A Chapter in Christian and Jewish Folklore")]), _vm._v(", trans. August Henry Keane (London: Hutchinson, 1896), 138–45, on the conflation (and patristic pushback against conflation) of the devil and the antichrist in early Christian literature, as well as how the antichrist will become incarnate as well. "), _c('em', [_vm._v("Dial. Devil")]), _vm._v(" thus stands in contrast to other late ancient texts, such as Oecumenius, "), _c('em', [_vm._v("Comm. Apoc.")]), _vm._v(" 8.3,"), _c('em'), _vm._v(" that take particular pains to distinguish the antichrist from the devil. On the prevalence of dialogical narratives regarding Satan’s role as an enemy of God, his desire for God’s throne, and his inevitable end, see Mohammad Zarasi, Abdollatif Ahmadi Ramchahi, and Iman Kanani, “Satan in Dialogue with God: A Comparative Study between Islam, Judaism, Christianity, and Zoroastrianism,” "), _c('em', [_vm._v("Al-Bayan")]), _vm._v(" 13 (2015): 197–222.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_041",
      "id": "foot-041"
    }
  }, [_vm._v("41")]), _vm._v(". For more on the devil’s association with spit and God’s association with breath, see Florentina Badalanova Geller, “"), _c('em', [_vm._v("The Sea of Tiberias:")]), _vm._v(" Between Apocryphal Literature and Oral Tradition,” in "), _c('em', [_vm._v("The Old Testament Apocrypha in the Slavonic Tradition")]), _vm._v(","), _c('em'), _vm._v(" ed. Lorenzo DiTommaso and Christfried Böttrich, Texts and Studies in Ancient Judaism 140 (Tübingen: Mohr Siebeck, 2011), 42–44. Geller notes that in later Russian redactions of "), _c('em', [_vm._v("Dial. Devil")]), _vm._v(", the narrative blends at certain points with a Church Slavic text known as the "), _c('em', [_vm._v("Sea of Tiberias.")]), _vm._v(" She argues that "), _c('em', [_vm._v("Dial. Devil")]), _vm._v(", "), _c('em', [_vm._v("Sea of Tiberias")]), _vm._v(","), _c('em'), _vm._v(" and "), _c('em', [_vm._v("3 Baruch")]), _vm._v(" all share an Ur-text that tie together their narrative of Satan’s refusal to worship Adam—a narrative present in Latin, Armenian, and Georgian recensions of the "), _c('em', [_vm._v("Life of Adam and Eve")]), _vm._v(" but not in Greek and Church Slavic recensions"), _c('em'), _vm._v(" (ibid., 81–84).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_042",
      "id": "foot-042"
    }
  }, [_vm._v("42")]), _vm._v(". It is worth noting that this tradition is extant in the Latin, Georgian, and Armenian versions of "), _c('em', [_vm._v("LAE")]), _vm._v(" but not in the Greek. See Gary A. Anderson and Michael E. Stone, eds., "), _c('em', [_vm._v("A Synopsis of the Books of Adam and Eve")]), _vm._v(", 2nd rev. ed., SBLEJL 17 (Atlanta: Scholars, 1999).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_043",
      "id": "foot-043"
    }
  }, [_vm._v("43")]), _vm._v(". Q 2:34–36; 7:11–22; 15:29–31; 17:61–64; 18:50; 20:116–22; 38:72–88. Also see "), _c('em', [_vm._v("Fī ta"), _c('span', {
    staticClass: "special-char-ital"
  }, [_vm._v("ṯ")]), _vm._v("lī"), _c('span', {
    staticClass: "special-char-ital"
  }, [_vm._v("ṯ")]), _vm._v(" Allāh al-wā"), _c('span', {
    staticClass: "chr"
  }, [_vm._v("ḥ")]), _vm._v("id")]), _vm._v(" (Sinai ar. 154) in Samir Khalil Samir, “The Earliest Arab Apology for Christianity (c. 750),” in "), _c('em', [_vm._v("Christian Arabic Apologetics During the Abbasid Period (750–1258)")]), _vm._v(", ed. Samir Khalil Samir and Jørgen S. Nielsen, Numen 63 (Leiden: Brill, 1994), 57–113. Much like the Qur’anic tradition, Eve is not mentioned in this recounting of Adam’s disobedience in the garden of Eden; rather, blame is placed upon the devil. See Mohammed Mahmoud, “The Story of Creation and Disobedience in the Quran: The Absence of Eve and the Centrality of Satan,” "), _c('em', [_vm._v("Alif: Journal of Comparative Poetics")]), _vm._v(" 19"), _c('em'), _vm._v(" (1999): 66–95.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_044",
      "id": "foot-044"
    }
  }, [_vm._v("44")]), _vm._v(". On these texts, see the translations by Alin Suciu ("), _c('em', [_vm._v("MNTA")]), _vm._v(" 1:526–45), Lance Jenott ("), _c('em', [_vm._v("MNTA")]), _vm._v(" 2:559–79), and Hugo Lundhaug ("), _c('em', [_vm._v("MNTA")]), _vm._v(" 2:499–522). Also see P. Bala"), _c('span', {
    staticClass: "special-char-ital"
  }, [_vm._v("ʾ")]), _vm._v("izah 27, a portion of a dialogue in Coptic between Jesus and the disciples regarding the fall of the devil. Edition and translation in Paul E. Kahle, "), _c('em', [_vm._v("Bala"), _c('span', {
    staticClass: "special-char-ital"
  }, [_vm._v("ʾ")]), _vm._v("izah: Coptic Texts from Deir El-Bala"), _c('span', {
    staticClass: "special-char-ital"
  }, [_vm._v("ʾ")]), _vm._v("izah in Upper Egypt")]), _vm._v(", 2 vols. (London: Oxford University Press, 1954), 1:403–4.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_045",
      "id": "foot-045"
    }
  }, [_vm._v("45")]), _vm._v(". For more, see Savas Agourides, “Apocalypse of Sedrach (Second to Fifth Century A. D.),” in "), _c('em', [_vm._v("The Old Testament Pseudepigrapha")]), _vm._v(","), _c('em'), _vm._v(" 2 vols., ed. James H. Charlesworth, ABRL (New York: Doubleday, 1983–1985), 1:604–13.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_046",
      "id": "foot-046"
    }
  }, [_vm._v("46")]), _vm._v(". Such traditions of Satan’s attempt to establish a throne and his jealousy of Adam also appear in other Latin and Church Slavic texts, such as the "), _c('em', [_vm._v("Homily of John Chrysostom on How Archangel Michael Defeated Satanail")]), _vm._v(", "), _c('em', [_vm._v("2 Enoch")]), _vm._v(", "), _c('em', [_vm._v("Quest. John")]), _vm._v(", "), _c('em', [_vm._v("3 Baruch")]), _vm._v(","), _c('em'), _vm._v(" and "), _c('em', [_vm._v("Legend of the Sea of Tiberias.")]), _vm._v(" See Geller, “Slavonic Redactions,” esp. 96–105.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_047",
      "id": "foot-047"
    }
  }, [_vm._v("47")]), _vm._v(". See Roger T. Beckwith, "), _c('em', [_vm._v("Calendar and Chronology, Jewish and Christian: Biblical, Intertestamental and Patristic Studies")]), _vm._v(" (Leiden: Brill, 1996), 297–309; Robert Hall, “Disjunction of Heavenly and Earthly Times in the "), _c('em', [_vm._v("Ascension of Isaiah")]), _vm._v(",” "), _c('em', [_vm._v("JSJ")]), _vm._v(" 35.1 (2004): 17–26. Also see Ps.-Hippolytus, "), _c('em', [_vm._v("Antichr.")]), _vm._v(" 43:2, on Enoch and Elijah proclaiming repentance to all the nations during these three and a half years.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_048",
      "id": "foot-048"
    }
  }, [_vm._v("48")]), _vm._v(". Also see Adso of Montier-en-Der’s "), _c('em', [_vm._v("De ortu et tempore Antichristi")]), _vm._v(" (in Bernard McGinn, ed., "), _c('em', [_vm._v("Apocalyptic Spirituality: Treatises and Letters of Lactantius, Adso of Moniet-en-Der, Joachim of Fiore, The Franciscan Spirituals, Savonarola")]), _vm._v(" [New York: Paulist, 1979], 94–96), where Enoch and Elijah return to earth and prepare the elect for battle for three and a half years before the antichrist kills them (cf. Rev 11:7). By the second century, Enoch and Elijah are associated with the antichrist as the prophetic figures that reveal his identity and false wonders; see "), _c('em', [_vm._v("Apoc. Pet.")]), _vm._v(" (Eth.) 2:7–13.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_049",
      "id": "foot-049"
    }
  }, [_vm._v("49")]), _vm._v(". See David Cook, “Early Islamic and Classical Sunni and Shi’ite Apocalyptic Movements,” in "), _c('em', [_vm._v("The Oxford Handbook of Millennialism")]), _vm._v(","), _c('em'), _vm._v(" ed. Catherine Wessinger (Oxford: Oxford University Press, 2011), 267–83 at 267–69. Also see the Old Nubian "), _c('em', [_vm._v("Attiri Book of Michael")]), _vm._v(" (P. Attiri 1–2) regarding Michael’s role in the resurrection and regarding the devil’s stand against the other angels; text and translation in Vincent W. J. van Gerven Oei et al., "), _c('em', [_vm._v("The Old Nubian Texts from Attiri")]), _vm._v(", Dotawo Monographs 1 (Santa Barbara: Punctum Books, 2016), 30–54.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_050",
      "id": "foot-050"
    }
  }, [_vm._v("50")]), _vm._v(". See the translation by Rick Brannan in "), _c('em', [_vm._v("MNTA")]), _vm._v(" 2:378–98.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_051",
      "id": "foot-051"
    }
  }, [_vm._v("51")]), _vm._v(". Miltenov, “Apocryphal Apocalypse of John,” 89–90.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_052",
      "id": "foot-052"
    }
  }, [_vm._v("52")]), _vm._v(". See Robert Casey, “The Apocalypse of Paul,” "), _c('em', [_vm._v("JTS")]), _vm._v(" 34 (1933): 1–32, esp. 11–12.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_053",
      "id": "foot-053"
    }
  }, [_vm._v("53")]), _vm._v(". For more on this reference to fish and the various types of fish it might be, see van der Vliet, “Une Vierge de Daphné,” esp. 380–82; Berger, "), _c('em', [_vm._v("Die griechische Daniel-Diegese")]), _vm._v(", 110; McGinn, "), _c('em', [_vm._v("Antichrist")]), _vm._v(","), _c('em'), _vm._v(" 95–96. Also see the much earlier reference to a virgin handling a fish in the Abercius Inscription. See Goffredo Zaccherinin, "), _c('em', [_vm._v("L’iscrizione di Abercio")]), _vm._v(" (Rome: dal Bessarione, 1898), 3–4.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_054",
      "id": "foot-054"
    }
  }, [_vm._v("54")]), _vm._v(". Casey and Thomson, “Dialogue,” 63.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_055",
      "id": "foot-055"
    }
  }, [_vm._v("55")]), _vm._v(". Van der Vliet, “Vierge de Daphné,” 383–85.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_056",
      "id": "foot-056"
    }
  }, [_vm._v("56")]), _vm._v(". Berger, "), _c('em', [_vm._v("Die griechische Daniel-Diegese")]), _vm._v(","), _c('em'), _vm._v(" 106–7.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_057",
      "id": "foot-057"
    }
  }, [_vm._v("57")]), _vm._v(". In "), _c('em', [_vm._v("Apoc. Ps.-Meth.")]), _vm._v(" 9:8–9 and 14:5,"), _c('em'), _vm._v(" the offspring of Chouseth are meant to be eternal and unconquerable Christian rulers until passing their reign to Christ at the appearance of the antichrist (cf. Ps 67:32).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_058",
      "id": "foot-058"
    }
  }, [_vm._v("58")]), _vm._v(". David Frankfurter, "), _c('em', [_vm._v("Christianizing Egypt: Syncretism and Local Worlds in Late Antiquity")]), _vm._v(" (Princeton, NJ: Princeton University Press, 2018), 212–18, quotation at 212.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_059",
      "id": "foot-059"
    }
  }, [_vm._v("59")]), _vm._v(". See van der Vliet, “Vierge de Daphné,” 387.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_060",
      "id": "foot-060"
    }
  }, [_vm._v("60")]), _vm._v(". See Bousset, "), _c('em', [_vm._v("Antichrist Legend")]), _vm._v(","), _c('em'), _vm._v(" 140–41; and Marco Rizzi, “L’ombra dell’anticristo nel cristianesimo orientale tra tarda antichità e prima età bizantina,” in "), _c('em', [_vm._v("Antichrist: Konstruktionen von Feindbildern")]), _vm._v(","), _c('em'), _vm._v(" ed. Wolfram Brandes and Felicitas Schmieder (Berlin: Akademie, 2010), 4–5, on Ps.-Hippolytus, "), _c('em', [_vm._v("De consummatione mundi")]), _vm._v(","), _c('em'), _vm._v(" which contains this tradition of the antichrist being born of a virgin. See also McGinn, "), _c('em', [_vm._v("Apocalyptic Spirituality")]), _vm._v(","), _c('em'), _vm._v(" 90–91, for Adso’s treatment of the antichrist’s virgin birth, which he suggests will take place in Babylon, after which the antichrist will be raised in Bethsaida and Corozain. As Alice Whealey notes, "), _c('em', [_vm._v("De consummatione mundi")]), _vm._v(" is a Byzantine redaction of the third-century Hippolytan "), _c('em', [_vm._v("Antichr.")]), _vm._v(" See Whealey, “"), _c('em', [_vm._v("De consummatione mundi")]), _vm._v(" of Pseudo-Hippolytus: Another Byzantine Apocalypse from the Early Islamic Period,” "), _c('em', [_vm._v("Byzantion")]), _vm._v(" 66 (1996): 461–69.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_061",
      "id": "foot-061"
    }
  }, [_vm._v("61")]), _vm._v(". See James H. Srawley, "), _c('em', [_vm._v("The Catechetical Oration of Gregory of Nyssa")]), _vm._v(" (Cambridge: Cambridge University Press, 1903), 92–93 (§24); Ernest Gebhardt, "), _c('em', [_vm._v("On the Three-Day Period between the Death and Resurrection of Christ")]), _vm._v(" (Leiden: Brill, 1967), 280–81; Nicholas P. Constas, “The Last Temptation of Satan: Divine Deception in Greek Patristic Interpretations of the Passion Narrative,” "), _c('em', [_vm._v("HTR")]), _vm._v(" 97.2 (2004): 139–63, esp. 143–49. Constas notes that, while modern scholarship generally abhors Gregory of Nyssa’s understanding of divine deception here, this motif is carried on by the likes of Athanasius, John Chrysostom, John of Damascus, and Maximus the Confessor, among others.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_062",
      "id": "foot-062"
    }
  }, [_vm._v("62")]), _vm._v(". See Berger, "), _c('em', [_vm._v("Die griechische Daniel-Diegese")]), _vm._v(","), _c('em'), _vm._v(" 105–6; van der Vliet, “Vierge de Daphné,” 388–90. However, we do have Procopius presenting Justinian as the antichrist in his "), _c('em', [_vm._v("Anecdota")]), _vm._v(","), _c('em'), _vm._v(" demonstrating that Christian figures were open to such interpretive, apocalyptic scrutiny. See McGinn, "), _c('em', [_vm._v("Antichrist")]), _vm._v(", 83–84.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_063",
      "id": "foot-063"
    }
  }, [_vm._v("63")]), _vm._v(". Radčenko, “Etjudy po bogomil"), _c('span', {
    staticClass: "special-char"
  }, [_vm._v("ǐ")]), _vm._v("stvu,” 38. For more on the Bogomils, see Steven Runciman, "), _c('em', [_vm._v("The Medieval Manichee: A Study of the Christian Dualist Heresy")]), _vm._v(" (Cambridge: Cambridge University Press, 1982), 63–93; Dimitri Obolensky, "), _c('em', [_vm._v("The Bogomils: A Study in Balkan Neo-Manichaeism")]), _vm._v(" (New York: AMS, 1978).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_064",
      "id": "foot-064"
    }
  }, [_vm._v("64")]), _vm._v(". Turdeanu, “Apocryphes bogomiles,” 194–99.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_065",
      "id": "foot-065"
    }
  }, [_vm._v("65")]), _vm._v(". Vassiliev, "), _c('em', [_vm._v("Anecdota graeco-byzantina")]), _vm._v(","), _c('em'), _vm._v(" vi.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_066",
      "id": "foot-066"
    }
  }, [_vm._v("66")]), _vm._v(". See Charles D. Wright, "), _c('em', [_vm._v("MNTA")]), _vm._v(" 1:486; McGinn, "), _c('em', [_vm._v("Antichrist")]), _vm._v(","), _c('em'), _vm._v(" 87–88, 100–103. For a translation of Adso’s treatise to Queen Gerberga, see McGinn, "), _c('em', [_vm._v("Apocalyptic Spirituality")]), _vm._v(", 89–96. Also see Ps.-Hippolytus, "), _c('em', [_vm._v("De consummatione mundi")]), _vm._v("; Ps.-Hippolytus, "), _c('em', [_vm._v("Antichr.")]), _vm._v(" 15:1; "), _c('em', [_vm._v("Apoc. Ps.-Meth.")]), _vm._v(" 14:1, 6; and "), _c('em', [_vm._v("Tib. Sib.")]), _vm._v(" 8:3 regarding the tradition of the antichrist being a Jew arising from the tribe of Dan (Gen 49:17). On the antichrist being born from a whore in Chorazin, also see "), _c('em', [_vm._v("2 Revelation of Matthew about the End Times")]), _vm._v(" in this volume.")]), _vm._v(" "), _c('p', {
    staticClass: "ch-titlep"
  }, [_vm._v("The Dialogue between Jesus and the Devil")]), _vm._v(" "), _c('div', {
    staticClass: "inside"
  }, [_c('table', [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "td50"
  }, [_c('p', {
    staticClass: "t-head"
  }, [_vm._v("GREEK")])]), _vm._v(" "), _c('td', {
    staticClass: "td45"
  }, [_c('p', {
    staticClass: "t-head"
  }, [_vm._v("CHURCH SLAVIC")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td50"
  }, [_c('p', {
    staticClass: "t-h1"
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('td', {
    staticClass: "td45"
  }, [_c('p', {
    staticClass: "para"
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td50"
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("Narration of the dispute of the devil with our Lord Jesus Christ."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-067",
      "id": "foot_067"
    }
  }, [_vm._v("a")])]), _vm._v(" Father bless.")])]), _vm._v(" "), _c('td', {
    staticClass: "td45"
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("On the dispute between the devil and our Lord. Bless, Lord Father.")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_vm._v("Dispute over Jesus’s origin")]), _vm._v(" "), _c('div', {
    staticClass: "inside"
  }, [_c('table', [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "td50"
  }, [_c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "chap-num"
  }, [_vm._v("1")]), _vm._v(" "), _c('sup', [_vm._v("1")]), _vm._v("When Jesus Christ, our Lord, came to the mountain with Peter, James, Andrew, and John"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-068",
      "id": "foot_068"
    }
  }, [_vm._v("b")])]), _vm._v(" and the rest of his holy"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-069",
      "id": "foot_069"
    }
  }, [_vm._v("c")])]), _vm._v(" disciples, "), _c('sup', [_vm._v("2")]), _vm._v("Jesus"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-070",
      "id": "foot_070"
    }
  }, [_vm._v("d")])]), _vm._v(" fasted for forty days. "), _c('sup', [_vm._v("3")]), _vm._v("The devil appeared before him and said to him, “Ι swear an oath with you in the name of mighty God, yes!, that you tell me the entire truth."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-071",
      "id": "foot_071"
    }
  }, [_vm._v("e")])]), _vm._v(" Where are you from?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('sup', [_vm._v("4")]), _vm._v("Jesus said to him, “I am from the eternal and immortal God.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('sup', [_vm._v("5")]), _vm._v("The devil said to him, “You say so."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-072",
      "id": "foot_072"
    }
  }, [_vm._v("f")])]), _vm._v(" Go to heaven and sit on your throne, so that the heavens which you fabricated"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-073",
      "id": "foot_073"
    }
  }, [_vm._v("g")])]), _vm._v(" and the earth, as you say, may be at rest in you. You have angels. Why did you not send them? Instead you, being God, came along such a path.”")])]), _vm._v(" "), _c('td', {
    staticClass: "td45"
  }, [_c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "chap-num"
  }, [_vm._v("1")]), _vm._v(" "), _c('sup', [_vm._v("1")]), _vm._v("When Jesus came to the Mount of Olives, he said to his disciples, “We will fast here for forty days to contend with the devil.” "), _c('sup', [_vm._v("2")]), _vm._v("The disciples then fasted with Jesus. "), _c('sup', [_vm._v("3")]), _vm._v("When the devil heard that Jesus was fasting against him, he was enraged"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-077",
      "id": "foot_077"
    }
  }, [_vm._v("a")])]), _vm._v(" and appeared before the Lord.")]), _vm._v(" "), _c('p', {
    staticClass: "sidenote"
  }, [_vm._v("Mark 9:2 par.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('sup', [_vm._v("4")]), _vm._v("And Jesus said, “I adjure you, devil, by the living God, to tell me: where are you from?”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-078",
      "id": "foot_078"
    }
  }, [_vm._v("b")])])]), _vm._v(" "), _c('p', {
    staticClass: "sidenote"
  }, [_vm._v("Matt 4:1–11//Luke 4:1–13")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td50"
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_c('sup', [_vm._v("6")]), _vm._v("The Lord said, “Why did I, being God, come down? "), _c('sup', [_vm._v("7")]), _vm._v("Listen. I came down from heaven on account of you and your angels and all your assistants."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-074",
      "id": "foot_074"
    }
  }, [_vm._v("a")])]), _vm._v(" "), _c('sup', [_vm._v("8")]), _vm._v("You fell from heaven"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-075",
      "id": "foot_075"
    }
  }, [_vm._v("b")])]), _vm._v(" and you were doing nothing good, but by conquering the human you became a joke, impure demons, and you misled humans in your error.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('sup', [_vm._v("9")]), _vm._v("The devil said, “Go to heaven and sit on your throne. Do not make yourself manifest to my angels, for they are dreadful angels. And if you show yourself to them, Ι will be able to slaughter you like one of the humans.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('sup', [_vm._v("10")]), _vm._v("And the Lord said, “I came down on account of you and your angels and your accomplices. "), _c('sup', [_vm._v("11")]), _vm._v("As I kill you and release the race of humans from your error and lay them aside in their former glory, "), _c('sup', [_vm._v("12")]), _vm._v("I will make them inheritors of my everlasting kingdom. "), _c('sup', [_vm._v("13")]), _vm._v("But I will send you and all your accomplices together into the flame of gehenna and the eternal fire.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-076",
      "id": "foot_076"
    }
  }, [_vm._v("c")])])]), _vm._v(" "), _c('p', {
    staticClass: "sidenote"
  }, [_vm._v("Mark 9:43; Matt 18:8; 25:46; Jas 3:6")])]), _vm._v(" "), _c('td', {
    staticClass: "td45"
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_c('sup', [_vm._v("5")]), _vm._v("The devil said, “And you, where are you from?” "), _c('sup', [_vm._v("6")]), _vm._v("Jesus said, “From the truest father and the heavenly forces.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('sup', [_vm._v("7")]), _vm._v("The devil said, “Are you worthy of the High One?”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-079",
      "id": "foot_079"
    }
  }, [_vm._v("c")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('sup', [_vm._v("8")]), _vm._v("Jesus said, “I am worthy of all heaven and earth.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-080",
      "id": "foot_080"
    }
  }, [_vm._v("d")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('sup', [_vm._v("9")]), _vm._v("And then the devil said, “Go to heaven and sit there on your holy throne, because the heaven is yours, but the earth is mine.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-081",
      "id": "foot_081"
    }
  }, [_vm._v("a")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('sup', [_vm._v("10")]), _vm._v("Jesus said, “The one who will vanquish you from the face of the earth has come.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('sup', [_vm._v("11")]), _vm._v("And then the devil said, “Go to heaven and sit there on your throne, because heaven is yours, but the earth is mine."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-082",
      "id": "foot_082"
    }
  }, [_vm._v("b")])]), _vm._v(" "), _c('sup', [_vm._v("12")]), _vm._v("And I will show you my angels and you will see how terrible my angels are. <They will destroy you>"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-083",
      "id": "foot_083"
    }
  }, [_vm._v("c")])]), _vm._v(" like a common human.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('sup', [_vm._v("13")]), _vm._v("Jesus said, “Woe to you, devil, and to your angels, because I came to earth for your angels and your accomplices.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-084",
      "id": "foot_084"
    }
  }, [_vm._v("d")])])])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_vm._v("On the accomplices")]), _vm._v(" "), _c('div', {
    staticClass: "inside"
  }, [_c('table', [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "td50"
  }, [_c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "chap-num"
  }, [_vm._v("2")]), _vm._v(" "), _c('sup', [_vm._v("1")]), _vm._v("The devil said, “And who are my accomplices?”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-085",
      "id": "foot_085"
    }
  }, [_vm._v("a")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('sup', [_vm._v("2")]), _vm._v("The Lord said, “These are your accomplices: murderers,"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-086",
      "id": "foot_086"
    }
  }, [_vm._v("b")])]), _vm._v(" thieves, slanderers, darkness, fire, hailstones, upheavals, horoscopes, cursing of siblings, evil, heresy, and sectarianism.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-087",
      "id": "foot_087"
    }
  }, [_vm._v("c")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('sup', [_vm._v("3")]), _vm._v("The devil said, “Since these works are mine, you speak accurately,"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-088",
      "id": "foot_088"
    }
  }, [_vm._v("d")])]), _vm._v(" but I am greater than you and have become superior and stronger"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-089",
      "id": "foot_089"
    }
  }, [_vm._v("e")])]), _vm._v(" than your angels.”")])]), _vm._v(" "), _c('td', {
    staticClass: "td45"
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_c('span', {
    staticClass: "chap-num"
  }, [_vm._v("2")]), _vm._v(" "), _c('sup', [_vm._v("1")]), _vm._v("The devil said, “Who are my accomplices?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('sup', [_vm._v("2")]), _vm._v("(Jesus said), “Those who do your works.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('sup', [_vm._v("3")]), _vm._v("The devil said, “What are my works?”")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td50"
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_c('sup', [_vm._v("4")]), _vm._v("The Lord said, “You are an apparition of the world. But because of this, I was born by a woman,"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-090",
      "id": "foot_090"
    }
  }, [_vm._v("f")])]), _vm._v(" so that I might correct the falling of the woman and the man,"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-091",
      "id": "foot_091"
    }
  }, [_vm._v("g")])]), _vm._v(" which I formed. "), _c('sup', [_vm._v("5")]), _vm._v("Therefore, I did not leave him behind until the third heaven, until he saw the face of my father in heaven and redeemed his good things.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('sup', [_vm._v("6")]), _vm._v("The devil said, “You made Adam and planted paradise and cast Adam into it. But I did not make him enter into paradise for a single day.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('sup', [_vm._v("7")]), _vm._v("And the Lord said, “You misled Adam and chased him out of paradise. But I will not abandon him beneath your laughter.”")]), _vm._v(" "), _c('p', {
    staticClass: "sidenote"
  }, [_vm._v("Gen 3:1–5")])]), _vm._v(" "), _c('td', {
    staticClass: "td45"
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_c('sup', [_vm._v("4")]), _vm._v("Jesus said, “Your works are strife, theft, adultery, envy, jealousy, fire, thunder, darkness, earthquake, conflicts among brothers, and war among kings.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-092",
      "id": "foot_092"
    }
  }, [_vm._v("a")])])]), _vm._v(" "), _c('p', {
    staticClass: "sidenote"
  }, [_c('em', [_vm._v("Quest. Bart.")]), _vm._v(" 4:37–38, 44")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('sup', [_vm._v("5")]), _vm._v("The devil said, “What you say is true, Jesus, for these are my works.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-093",
      "id": "foot_093"
    }
  }, [_vm._v("b")])]), _vm._v(" "), _c('sup', [_vm._v("6")]), _vm._v("The devil said, “I am more terrible than your angels.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-094",
      "id": "foot_094"
    }
  }, [_vm._v("c")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('sup', [_vm._v("7")]), _vm._v("Jesus said, “Woe to you, devil, because you are a deceiver.”")]), _vm._v(" "), _c('p', {
    staticClass: "sidenote"
  }, [_vm._v("Gal 4:4")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td50"
  }), _vm._v(" "), _c('td', {
    staticClass: "td45"
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_c('sup', [_vm._v("8")]), _vm._v("The devil said to Jesus, “Is it not you who is the deceiver because you were born of a woman?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('sup', [_vm._v("9")]), _vm._v("Jesus said, “You speak truly, devil, because I was born of a woman, so that the law is fulfilled"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-095",
      "id": "foot_095"
    }
  }, [_vm._v("d")])]), _vm._v(" due to which (God) created humans in his image so that he will not abandon them forever.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-096",
      "id": "foot_096"
    }
  }, [_vm._v("e")])])]), _vm._v(" "), _c('p', {
    staticClass: "sidenote"
  }, [_c('em', [_vm._v("Ascen. Isa.")]), _vm._v(" 10:23; 11:27")]), _vm._v(" "), _c('p', {
    staticClass: "sidenote"
  }, [_vm._v("Matt 5:17")]), _vm._v(" "), _c('p', {
    staticClass: "sidenote"
  }, [_vm._v("Gen 1:27")]), _vm._v(" "), _c('p', {
    staticClass: "sidenote"
  }, [_vm._v("Gen 2:7–8")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_vm._v("On repentant and unrepentant sinners")]), _vm._v(" "), _c('div', {
    staticClass: "inside"
  }, [_c('table', [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "td50"
  }, [_c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "chap-num"
  }, [_vm._v("3")]), _c('sup', [_vm._v("1")]), _vm._v("The devil said, “If a person ever sins and might renounce your glory and live by my intentions, and goes along my paths, what allotment does he have before you?”")])]), _vm._v(" "), _c('td', {
    staticClass: "td45"
  }, [_c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "chap-num"
  }, [_vm._v("3")]), _vm._v(" "), _c('sup', [_vm._v("1")]), _vm._v("The devil said, “If a person begins to sin against you and begins to do my works and rejects your favor and glory, what will you do to them?”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-101",
      "id": "foot_101"
    }
  }, [_vm._v("a")])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "inside"
  }, [_c('table', [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "td50"
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_c('sup', [_vm._v("2")]), _vm._v("And the Lord said, “If someone ever sins and might do your deeds and live by your intentions and renounces my glory, lives for one hundred and ninety years,"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-097",
      "id": "foot_097"
    }
  }, [_vm._v("a")])]), _vm._v(" and ends up repenting and follows my commandments"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-098",
      "id": "foot_098"
    }
  }, [_vm._v("b")])]), _vm._v("—"), _c('sup', [_vm._v("3")]), _vm._v("if he might befriend foreigners, guide the blind, attend to the dead in prayer and fasts, and through this might shout aloud, "), _c('sup', [_vm._v("4")]), _vm._v("and might say in his prayers, ‘God, be merciful upon me, a sinner,’ a good death comes to him and he receives forgiveness from his injustices. "), _c('sup', [_vm._v("5")]), _vm._v("But if he might not repent from the bad things that he does, especially at the age of fifty or sixty, his death comes as a sinner and I will hand him over to the angel Temeluchus,"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-099",
      "id": "foot_099"
    }
  }, [_vm._v("c")])]), _vm._v(" and I will lead him away to the river of fire, where you too will be gathered with your demons, O wicked devil.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-100",
      "id": "foot_100"
    }
  }, [_vm._v("a")])])]), _vm._v(" "), _c('p', {
    staticClass: "sidenote"
  }, [_c('em', [_vm._v("Apoc. Sedr.")]), _vm._v(" 12:5")]), _vm._v(" "), _c('p', {
    staticClass: "sidenote"
  }, [_c('em', [_vm._v("Apoc. Pet.")]), _vm._v(" 8 [Ethiopic]; "), _c('em', [_vm._v("Apoc. Paul")]), _vm._v(" 15, 18, 34, 40")])]), _vm._v(" "), _c('td', {
    staticClass: "td45"
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_c('sup', [_vm._v("2")]), _vm._v("Then Jesus said to him, “Listen to me, devil. If a person does your will and rejects my favor and glory, then they will live (fifty and) seven"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-102",
      "id": "foot_102"
    }
  }, [_vm._v("b")])]), _vm._v(" years from the moment they repent "), _c('sup', [_vm._v("3")]), _vm._v("by receiving strangers, having mercy on the poor, clothing the naked, comforting the afflicted, giving water to the thirsty, helping the lame to walk and burying the dead, doing deeds of mercy. "), _c('sup', [_vm._v("4")]), _vm._v("And (if) they say, ‘Lord, have mercy on me, beause I have sinned against you,’ I will send them such a blessed death. At that time, I will hand them over to the servants of archangel Michael who will accept them and lead them to paradise."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-103",
      "id": "foot_103"
    }
  }, [_vm._v("a")])]), _vm._v(" "), _c('sup', [_vm._v("5")]), _vm._v("Listen to me, devil: then if a person lives fifty and seven years and does not repent, does not have mercy on the poor, does not feed the hungry, does not give water to the thirsty, nor buries the dead, nor gives alms, nor does deeds of mercy, nor says ‘Lord, have mercy on me,’ I will send him such a hot and fiery death and a fierce angel.”")]), _vm._v(" "), _c('p', {
    staticClass: "sidenote"
  }, [_vm._v("Matt 25:31–46")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_vm._v("The devil summons his demons")]), _vm._v(" "), _c('div', {
    staticClass: "inside"
  }, [_c('table', [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "td50"
  }, [_c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "chap-num"
  }, [_vm._v("4")]), _vm._v(" "), _c('sup', [_vm._v("1")]), _vm._v("Then the crafty one became furious, went away from him, and departed into his own darkness. He summoned his forty-eight thousand demons.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('sup', [_vm._v("2")]), _vm._v("And he said to them, “Be strong and manly! For the great Christ came down to earth and if we kill him, the kingdom will be ours forever. "), _c('sup', [_vm._v("3")]), _vm._v("Οnly let us go before him, and I behind him. We will kill him like one of the humans. From the time when he created Adam, I was not willing to worship him and so he and his father hated me.”")])]), _vm._v(" "), _c('td', {
    staticClass: "td45"
  }, [_c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "chap-num"
  }, [_vm._v("4")]), _vm._v(" "), _c('sup', [_vm._v("1")]), _vm._v("The devil rose and became angry, turned away from God and went up a high mountain."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-105",
      "id": "foot_105"
    }
  }, [_vm._v("b")])]), _vm._v(" There he gathered the demons,"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-106",
      "id": "foot_106"
    }
  }, [_vm._v("c")])]), _vm._v(" darkness upon darkness, thousands upon thousands."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-107",
      "id": "foot_107"
    }
  }, [_vm._v("d")])])]), _vm._v(" "), _c('p', {
    staticClass: "sidenote"
  }, [_c('em', [_vm._v("Hist. Rech.")]), _vm._v(" 21:2")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('sup', [_vm._v("2")]), _vm._v("And he"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-108",
      "id": "foot_108"
    }
  }, [_vm._v("e")])]), _vm._v(" said to them, “My children,"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-109",
      "id": "foot_109"
    }
  }, [_vm._v("f")])]), _vm._v(" be strong and manly, because Christ the great enemy has come, so that when we vanquish him, it (will be) our honor and glory. "), _c('sup', [_vm._v("3")]), _vm._v("When his father created Adam, I did not want to kiss him, or bow to him, so his father cast me from heaven, because I did not want to have anything to do with him.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-110",
      "id": "foot_110"
    }
  }, [_vm._v("a")])])]), _vm._v(" "), _c('p', {
    staticClass: "sidenote"
  }, [_c('em', [_vm._v("LAE")]), _vm._v(" 14–15; "), _c('em', [_vm._v("Quest. Bart.")]), _vm._v(" 4:52–54")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td50"
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_c('sup', [_vm._v("4")]), _vm._v("As he was saying these things, the mass of demons and a cloud of dust were stirred up from their appearance for twenty stades. "), _c('sup', [_vm._v("5")]), _vm._v("The disciples of the Lord, after seeing the mountain, trembled. While springs sprung up and fish leapt out of the sea,"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-104",
      "id": "foot_104"
    }
  }, [_vm._v("a")])]), _vm._v(" they feared greatly and said to him, “Lord, we die seeing these things.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('sup', [_vm._v("6")]), _vm._v("The Lord said, “Do not fear. I will slaughter him with his demons.” While they were still saying these things, the mass of demons drew nearer by thirteen stades.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('sup', [_vm._v("7")]), _vm._v("Philip and Thomas said, “God of all, Son of the Father, cast the devil down from heaven. Even now he will save us from him.”")]), _vm._v(" "), _c('p', {
    staticClass: "sidenote"
  }, [_c('em', [_vm._v("Quest. Bart.")]), _vm._v(" 4:55; "), _c('em', [_vm._v("LAE")]), _vm._v(" 16:1")])]), _vm._v(" "), _c('td', {
    staticClass: "td45"
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_c('sup', [_vm._v("4")]), _vm._v("And he said to them,"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-111",
      "id": "foot_111"
    }
  }, [_vm._v("b")])]), _vm._v(" “Brothers, go before me, I will go after you.” And they went, and dust rose from their demonic strength.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('sup', [_vm._v("5")]), _vm._v("The Lord’s disciples saw (this) and they said to the Lord, “Mountains shake and the sea rises even without the wind.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-112",
      "id": "foot_112"
    }
  }, [_vm._v("c")])]), _vm._v(" "), _c('sup', [_vm._v("6")]), _vm._v("And the Lord’s disciples said, “We have seen the devil’s form and heard his voice and are gripped by fear of him.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('sup', [_vm._v("7")]), _vm._v("(The devil) came to (a distance of) ten fields.")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_vm._v("The devil trapped in a cloud")]), _vm._v(" "), _c('div', {
    staticClass: "inside"
  }, [_c('table', [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "td50"
  }, [_c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "chap-num"
  }, [_vm._v("5")]), _vm._v(" "), _c('sup', [_vm._v("1")]), _vm._v("Likewise, also Peter, being extremely cowardly, ran behind Jesus."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-113",
      "id": "foot_113"
    }
  }, [_vm._v("b")])]), _vm._v(" "), _c('sup', [_vm._v("2")]), _vm._v("And the Lord said, “Do not be cowardly until you have seen the glory of God.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-114",
      "id": "foot_114"
    }
  }, [_vm._v("c")])]), _vm._v(" "), _c('sup', [_vm._v("3")]), _vm._v("Then Jesus transformed into his divine glory and commanded a cloud from heaven to suspend the devil by his feet."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-115",
      "id": "foot_115"
    }
  }, [_vm._v("d")])])]), _vm._v(" "), _c('p', {
    staticClass: "sidenote"
  }, [_c('em', [_vm._v("Acts Thom. Skin")]), _vm._v(" 8:23;")]), _vm._v(" "), _c('p', {
    staticClass: "sidenote"
  }, [_c('em', [_vm._v("Acts Andr. Phlm.")]), _vm._v(" 4:10;")]), _vm._v(" "), _c('p', {
    staticClass: "sidenote"
  }, [_c('em', [_vm._v("Acts Pet. Andr.")]), _vm._v(" 10;")]), _vm._v(" "), _c('p', {
    staticClass: "sidenote"
  }, [_c('em', [_vm._v("Hist. Phil.")]), _vm._v(" 4:4")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('sup', [_vm._v("4")]), _vm._v("His demons cried out, saying, “Where will we flee to?” "), _c('sup', [_vm._v("5")]), _vm._v("And they said to one another,"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-116",
      "id": "foot_116"
    }
  }, [_vm._v("a")])]), _vm._v(" “Come, all! Let us flee into the abyss, since we will be safe.”")])]), _vm._v(" "), _c('td', {
    staticClass: "td45"
  }, [_c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "chap-num"
  }, [_vm._v("5")]), _vm._v(" "), _c('sup', [_vm._v("1")]), _vm._v("Peter was overcome by demonic dread and he ran (away) from Jesus to (a distance of) four fields. "), _c('sup', [_vm._v("2")]), _vm._v("Jesus said, “Peter, why are you doing this?” Peter repented, stood behind the Lord, and watched over his shoulder."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-124",
      "id": "foot_124"
    }
  }, [_vm._v("d")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('sup', [_vm._v("3")]), _vm._v("Jesus turned around and said, “Who cast the devil"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-125",
      "id": "foot_125"
    }
  }, [_vm._v("e")])]), _vm._v(" from heaven?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('sup', [_vm._v("4")]), _vm._v("John said, “You cast the devil from heaven, did you not?”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-126",
      "id": "foot_126"
    }
  }, [_vm._v("f")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('sup', [_vm._v("5")]), _vm._v("Peter"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-127",
      "id": "foot_127"
    }
  }, [_vm._v("g")])]), _vm._v(" also replied, “Lord, you cast the devil from heaven. Your only father and glory and favor of which there is no like forever. Amen.”")]), _vm._v(" "), _c('p', {
    staticClass: "sidenote"
  }, [_c('em', [_vm._v("Quest. Bart.")]), _vm._v(" 4:55;")]), _vm._v(" "), _c('p', {
    staticClass: "sidenote"
  }, [_c('em', [_vm._v("LAE")]), _vm._v(" 16:1")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td50"
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_c('sup', [_vm._v("6")]), _vm._v("And the devil, the foremost one himself,"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-117",
      "id": "foot_117"
    }
  }, [_vm._v("b")])]), _vm._v(" while suspended, was saying,"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-118",
      "id": "foot_118"
    }
  }, [_vm._v("c")])]), _vm._v(" “Lord, let me down from these circumstances and do not kill me at this time.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-119",
      "id": "foot_119"
    }
  }, [_vm._v("d")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('sup', [_vm._v("7")]), _vm._v("And the Lord said, “If I let you down, you must stop making war against the race of humans, my own creation.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-120",
      "id": "foot_120"
    }
  }, [_vm._v("e")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('sup', [_vm._v("8")]), _vm._v("And the devil said, “My Lord, let me down and I will be able to do this, so that however many put their trust in my abominable and polluted name"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-121",
      "id": "foot_121"
    }
  }, [_vm._v("f")])]), _vm._v(" and my race might put their trust in your holy"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-122",
      "id": "foot_122"
    }
  }, [_vm._v("g")])]), _vm._v(" name.” "), _c('sup', [_vm._v("9")]), _vm._v("And the Lord commanded him to come down like lightning and to stand himself before the feet of Jesus."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-123",
      "id": "foot_123"
    }
  }, [_vm._v("h")])])])]), _vm._v(" "), _c('td', {
    staticClass: "td45"
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_c('sup', [_vm._v("6")]), _vm._v("Then Jesus said, “I will command a cloud to come down from heaven like lightning, <take hold of>"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-128",
      "id": "foot_128"
    }
  }, [_vm._v("a")])]), _vm._v(" the devil and hang him upside down by the heel in the clouds in the skies.”")]), _vm._v(" "), _c('p', {
    staticClass: "sidenote"
  }, [_c('em', [_vm._v("Acts Thom. Skin")]), _vm._v(" 8:23;")]), _vm._v(" "), _c('p', {
    staticClass: "sidenote"
  }, [_c('em', [_vm._v("Acts Andr. Phlm.")]), _vm._v(" 4:10;")]), _vm._v(" "), _c('p', {
    staticClass: "sidenote"
  }, [_c('em', [_vm._v("Acts Pet. Andr.")]), _vm._v(" 10;")]), _vm._v(" "), _c('p', {
    staticClass: "sidenote"
  }, [_c('em', [_vm._v("Hist. Phil.")]), _vm._v(" 4:4")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('sup', [_vm._v("7")]), _vm._v("And he dispersed the devil’s forces like smoke. They ran into a cave and said, “What shall we poor wretches do, except run into a cave and into a hole, since they hanged our prince in the clouds in the skies.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-129",
      "id": "foot_129"
    }
  }, [_vm._v("b")])])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td50"
  }), _vm._v(" "), _c('td', {
    staticClass: "td45"
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_c('sup', [_vm._v("8")]), _vm._v("At that moment, the devil saw that Christ’s word has been fulfilled. The devil (also) saw that he himself was finished and he said, “Have mercy on me, Lord, and let me go to earth.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('sup', [_vm._v("9")]), _vm._v("Jesus said, “Well, devil, if I have mercy on you and let you go down on earth, what good will you do to this world?”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-130",
      "id": "foot_130"
    }
  }, [_vm._v("c")])])]), _vm._v(" "), _c('p', {
    staticClass: "sidenote"
  }, [_c('em', [_vm._v("Hist. Rech.")]), _vm._v(" 21:5–6")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('sup', [_vm._v("10")]), _vm._v("The devil said, “Have mercy on me, Lord, and let me go to earth so that if someone believes in my shameful name, I will make it so that everyone turns to you.” And he smiled at Jesus."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-131",
      "id": "foot_131"
    }
  }, [_vm._v("d")])]), _vm._v(" "), _c('sup', [_vm._v("11")]), _vm._v("Jesus told the cloud to release (the devil) and the devil fell down to earth like lightning."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-132",
      "id": "foot_132"
    }
  }, [_vm._v("e")])])]), _vm._v(" "), _c('p', {
    staticClass: "sidenote"
  }, [_vm._v("Luke 10:18")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_vm._v("On the Jews and John the Baptist")]), _vm._v(" "), _c('div', {
    staticClass: "inside"
  }, [_c('table', [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "td50"
  }, [_c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "chap-num"
  }, [_vm._v("6")]), _vm._v(" "), _c('sup', [_vm._v("1")]), _vm._v("Then Jesus changed into his human arrangement, just as he was born for our sake. And the devil, seeing that Jesus became like a human, took up a barb in his mouth and attempted to overpower Jesus. "), _c('sup', [_vm._v("2")]), _vm._v("And the Lord said, “Again, devil, you must suffer.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-133",
      "id": "foot_133"
    }
  }, [_vm._v("a")])])])]), _vm._v(" "), _c('td', {
    staticClass: "td45"
  }, [_c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "chap-num"
  }, [_vm._v("6")]), _vm._v(" "), _c('sup', [_vm._v("1")]), _vm._v("As the devil lay (on the ground), he filled his mouth with phlegm and raised himself, wanting to outsmart Jesus."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-143",
      "id": "foot_143"
    }
  }, [_vm._v("a")])]), _vm._v(" "), _c('sup', [_vm._v("2")]), _vm._v("Jesus said to him, “I will not breathe on you, nor spit on you, devil, because my spit is holy and the air I breath out of my mouth is the Holy Spirit.”")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td50"
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_c('sup', [_vm._v("3")]), _vm._v("And the devil said, “I will come to Annas and Caiaphas, the high priests,"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-134",
      "id": "foot_134"
    }
  }, [_vm._v("b")])]), _vm._v(" my own Jews, and I will make it so that they crucify you. I am not"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-135",
      "id": "foot_135"
    }
  }, [_vm._v("c")])]), _vm._v(" similar to the Almighty; you are his son. "), _c('sup', [_vm._v("4")]), _vm._v("But I am the terrifying Antichrist. You are the governing,"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-136",
      "id": "foot_136"
    }
  }, [_vm._v("d")])]), _vm._v(" heavenly king, and I am terrestrial since when you threw me out of heaven. So, why did you come to earth and interrogate us before the appointed time?"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-137",
      "id": "foot_137"
    }
  }, [_vm._v("e")])]), _vm._v(" "), _c('sup', [_vm._v("5")]), _vm._v("Ι did not cause John the Baptist to be killed unjustly"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-138",
      "id": "foot_138"
    }
  }, [_vm._v("a")])]), _vm._v(" by Herod and his head to be marched in procession and put on orchestral display by the woman."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-139",
      "id": "foot_139"
    }
  }, [_vm._v("b")])]), _vm._v(" And if I wished to do something, every power to do so is mine.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-140",
      "id": "foot_140"
    }
  }, [_vm._v("c")])])]), _vm._v(" "), _c('p', {
    staticClass: "sidenote"
  }, [_vm._v("John 18:13–14")])]), _vm._v(" "), _c('td', {
    staticClass: "td45"
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_c('sup', [_vm._v("3")]), _vm._v("The devil said, “If I do not fight you, I will not be equal to the High One."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-144",
      "id": "foot_144"
    }
  }, [_vm._v("b")])]), _vm._v(" I will enter the heart of Caiaphas"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-145",
      "id": "foot_145"
    }
  }, [_vm._v("c")])]), _vm._v(" so that he crucifies, tortures, and kills you.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-146",
      "id": "foot_146"
    }
  }, [_vm._v("d")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('sup', [_vm._v("4")]), _vm._v("Jesus said, “What you say is right, devil, because I will enter the hands of sinners, since the cross is made for me; they bow to it and spit on you.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-147",
      "id": "foot_147"
    }
  }, [_vm._v("e")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('sup', [_vm._v("5")]), _vm._v("(The devil said,) “I made it so that John (the Baptist) was beheaded before Herod the king.”")]), _vm._v(" "), _c('p', {
    staticClass: "sidenote"
  }, [_vm._v("Mark 6:17–27//Matt 14:3–10")]), _vm._v(" "), _c('p', {
    staticClass: "sidenote"
  }, [_vm._v("Mark 6:28//Matt 14:11")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td50"
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_c('sup', [_vm._v("6")]), _vm._v("And the Lord said, “John is not dead, but lives. But listen, wicked devil, you are able to reap thorny wine or to harvest barbed fruit.” "), _c('sup', [_vm._v("7")]), _vm._v("And the devil became silent, not responding at all. "), _c('sup', [_vm._v("8")]), _vm._v("And Jesus said to him, “Are you satisfied, devil? Do you have something more"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-141",
      "id": "foot_141"
    }
  }, [_vm._v("d")])]), _vm._v(" to say?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('sup', [_vm._v("9")]), _vm._v("And the devil said, “No, my Lord. I have nothing else to say,"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-142",
      "id": "foot_142"
    }
  }, [_vm._v("e")])]), _vm._v(" but I am bound by you. You will do nothing else evil against us.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('sup', [_vm._v("10")]), _vm._v("And the Lord said, “In what manner would I act wickedly against myself? I will display my lordship to you and I will hand you over for destruction.”")])]), _vm._v(" "), _c('td', {
    staticClass: "td45"
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_c('sup', [_vm._v("6")]), _vm._v("Jesus said, “John baptized me; he has not died, but he lives.”")]), _vm._v(" "), _c('p', {
    staticClass: "sidenote"
  }, [_vm._v("Mark 1:9–11 par.; John 1:29–34")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('sup', [_vm._v("7")]), _vm._v("The devil said, “Had I seen where you were born, I would go to that place, kill your mother, and break you.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('sup', [_vm._v("8")]), _vm._v("The Lord said,"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-148",
      "id": "foot_148"
    }
  }, [_vm._v("a")])]), _vm._v(" “Who can have wine in thorns or wheat in (a field of) thistle?”")]), _vm._v(" "), _c('p', {
    staticClass: "sidenote"
  }, [_vm._v("Matt 13:24–30")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('sup', [_vm._v("9")]), _vm._v("The devil did not answer anything."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-149",
      "id": "foot_149"
    }
  }, [_vm._v("b")])])])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_vm._v("On the devil’s destiny")]), _vm._v(" "), _c('div', {
    staticClass: "inside"
  }, [_c('table', [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "td50"
  }, [_c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "chap-num"
  }, [_vm._v("7")]), _vm._v(" "), _c('sup', [_vm._v("1")]), _vm._v("And again, Jesus transformed into his divine glory and commanded him with his power"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-150",
      "id": "foot_150"
    }
  }, [_vm._v("f")])]), _vm._v(" to be removed by thirteen stades, and he enclosed the earth with a seal and opened a gap"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-151",
      "id": "foot_151"
    }
  }, [_vm._v("g")])]), _vm._v(" about one hundred cubits long."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-152",
      "id": "foot_152"
    }
  }, [_vm._v("h")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('sup', [_vm._v("2")]), _vm._v("And the devil went away saying in a great voice, “O violence! Violence! Why are you doing this to me?”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-153",
      "id": "foot_153"
    }
  }, [_vm._v("a")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('sup', [_vm._v("3")]), _vm._v("And the Lord said,"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-154",
      "id": "foot_154"
    }
  }, [_vm._v("b")])]), _vm._v(" “For seventeen"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-155",
      "id": "foot_155"
    }
  }, [_vm._v("c")])]), _vm._v(" slaves rolled over a very large stone by their"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-156",
      "id": "foot_156"
    }
  }, [_vm._v("d")])]), _vm._v(" power, so that the stone was made to roll for twenty years. Do you want to go down there?”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-157",
      "id": "foot_157"
    }
  }, [_vm._v("e")])])]), _vm._v(" "), _c('p', {
    staticClass: "sidenote"
  }, [_c('em', [_vm._v("1 Apocr. Apoc. John")]), _vm._v(" 20:4")])]), _vm._v(" "), _c('td', {
    staticClass: "td45"
  }, [_c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "chap-num"
  }, [_vm._v("7")]), _vm._v(" "), _c('sup', [_vm._v("1")]), _vm._v("Jesus commanded the earth to open three hundred sixty and three fathoms wide, and all four corners of the earth shook.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('sup', [_vm._v("2")]), _vm._v("The devil looked around and said, “What is this, Lord?”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-165",
      "id": "foot_165"
    }
  }, [_vm._v("c")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('sup', [_vm._v("3")]), _vm._v("Jesus said, “Go out, devil, and see.”")]), _vm._v(" "), _c('p', {
    staticClass: "sidenote"
  }, [_vm._v("Rev 20:2–3")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td50"
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_c('sup', [_vm._v("4")]), _vm._v("The devil said, “Lord,"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-158",
      "id": "foot_158"
    }
  }, [_vm._v("a")])]), _vm._v(" what will happen after then?” "), _c('sup', [_vm._v("5")]), _vm._v("And the Lord said, “From that point on, you will come from the abyss and will be born from a woman, whose name is Perdition."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-159",
      "id": "foot_159"
    }
  }, [_vm._v("b")])]), _vm._v(" You will reign for three years and many will trust you.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-160",
      "id": "foot_160"
    }
  }, [_vm._v("c")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('sup', [_vm._v("6")]), _vm._v("And the devil said, “Lord, and what will happen then?”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-161",
      "id": "foot_161"
    }
  }, [_vm._v("d")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('sup', [_vm._v("7")]), _vm._v("<The Lord said,> I will make the year like a month, the month like a week, the week like a day, the day like an hour, and the house like a speck. These days will be shortened on account of my elect.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-162",
      "id": "foot_162"
    }
  }, [_vm._v("e")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('sup', [_vm._v("8")]), _vm._v("The devil said, “My Lord, and what will happen then?”")])]), _vm._v(" "), _c('td', {
    staticClass: "td45"
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_c('sup', [_vm._v("4")]), _vm._v("The devil said, “How deep is this hole?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('sup', [_vm._v("5")]), _vm._v("Jesus said, “If a four-year-old"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-166",
      "id": "foot_166"
    }
  }, [_vm._v("a")])]), _vm._v(" boy takes a stone that is as heavy as he can carry and throws it into the hole and it travels seven years until it reaches bottom, it will hit you, devil.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-167",
      "id": "foot_167"
    }
  }, [_vm._v("b")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('sup', [_vm._v("6")]), _vm._v("The devil said, “Lord, and what then?”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-168",
      "id": "foot_168"
    }
  }, [_vm._v("a")])]), _vm._v(" "), _c('sup', [_vm._v("7")]), _vm._v("Jesus said, “I will not destroy you, devil, because it is your destiny to rule for the three years before the end of time.”")]), _vm._v(" "), _c('p', {
    staticClass: "sidenote"
  }, [_vm._v("2 Thess 2:3; John 17:12; "), _c('em', [_vm._v("Tib. Sib.")]), _vm._v(" 8:1; "), _c('em', [_vm._v("Apoc. Dan.")]), _vm._v(" 9:10")]), _vm._v(" "), _c('p', {
    staticClass: "sidenote"
  }, [_vm._v("Ps.-Hippolytus, "), _c('em', [_vm._v("Antichr.")]), _vm._v(" 6:2")]), _vm._v(" "), _c('p', {
    staticClass: "sidenote"
  }, [_vm._v("Dan 7:25; 9:27; 12:7, 11–12; Rev 11:2; 12:14; 13:5; "), _c('em', [_vm._v("1 Apocr. Apoc. John")]), _vm._v(" 8:2; "), _c('em', [_vm._v("Ascen. Isa.")]), _vm._v(" 4:12")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td50"
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_c('sup', [_vm._v("9")]), _vm._v("And the Lord said, “From that point on, you will come to the place called Gouze, the land of the Egyptians. "), _c('sup', [_vm._v("10")]), _vm._v("My mother, the holy Theotokos, will come there and Elijah and Enoch and innumerable angels will kill you and you will be destroyed utterly in the eternal fire,"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-163",
      "id": "foot_163"
    }
  }, [_vm._v("a")])]), _vm._v(" "), _c('sup', [_vm._v("11")]), _vm._v("because it is fitting for there to be glory to my Father and the Holy Spirit forever. Amen.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-164",
      "id": "foot_164"
    }
  }, [_vm._v("b")])])]), _vm._v(" "), _c('p', {
    staticClass: "sidenote"
  }, [_c('em', [_vm._v("Quaest. ad Ant.")]), _vm._v(" 109; "), _c('em', [_vm._v("Apoc. Dan.")]), _vm._v(" 9:8")]), _vm._v(" "), _c('p', {
    staticClass: "sidenote"
  }, [_vm._v("Rev 11:3–13; "), _c('em', [_vm._v("1 Apocr. Apoc. John")]), _vm._v(" 8:5; "), _c('em', [_vm._v("Quest. Bart.")]), _vm._v(" 1:16; "), _c('em', [_vm._v("Tib. Sib.")]), _vm._v(" 8:5; "), _c('em', [_vm._v("Apoc. El.")]), _vm._v(" 5:32–35; "), _c('em', [_vm._v("Apoc. Dan.")]), _vm._v(" 14:2–3")])]), _vm._v(" "), _c('td', {
    staticClass: "td45"
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_c('sup', [_vm._v("8")]), _vm._v("Then the devil said, “And what then?”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-169",
      "id": "foot_169"
    }
  }, [_vm._v("b")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('sup', [_vm._v("9")]), _vm._v("Jesus said, “The first year, there will be much wine and rye. The second year, not a single bucket of rye will be found in the whole land.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('sup', [_vm._v("10")]), _vm._v("Then the devil said, “And what then?”")]), _vm._v(" "), _c('p', {
    staticClass: "sidenote"
  }, [_c('em', [_vm._v("1 Apocr. Apoc. John")]), _vm._v(" 8:3; "), _c('em', [_vm._v("Tib. Sib.")]), _vm._v(" 8:2")]), _vm._v(" "), _c('p', {
    staticClass: "sidenote"
  }, [_vm._v("Ps 88:45; 89:4 LXX; Mark 13:20//Matt 24:22")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('sup', [_vm._v("11")]), _vm._v("Jesus said, “I will make a year into a month, a month into a week, a week into a day, a day into an hour, and an hour into a second.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-170",
      "id": "foot_170"
    }
  }, [_vm._v("c")])])]), _vm._v(" "), _c('p', {
    staticClass: "sidenote"
  }, [_c('em', [_vm._v("1 Apocr. Apoc. John")]), _vm._v(" 8:3")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('sup', [_vm._v("12")]), _vm._v("The devil said, “Lord, and what then?”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-171",
      "id": "foot_171"
    }
  }, [_vm._v("d")])])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td50"
  }), _vm._v(" "), _c('td', {
    staticClass: "td45"
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_c('sup', [_vm._v("13")]), _vm._v("Jesus said, “I will roll up the skies like a book and light up the earth like a big fire. And I will arrange"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-172",
      "id": "foot_172"
    }
  }, [_vm._v("e")])]), _vm._v(" it so that the sea dries and it will be like stone."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-173",
      "id": "foot_173"
    }
  }, [_vm._v("f")])]), _vm._v(" "), _c('sup', [_vm._v("14")]), _vm._v("And they"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-174",
      "id": "foot_174"
    }
  }, [_vm._v("a")])]), _vm._v(" will come to the place that is called Chizi."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-175",
      "id": "foot_175"
    }
  }, [_vm._v("b")])]), _vm._v(" "), _c('sup', [_vm._v("15")]), _vm._v("My mother who gave birth to me and John who baptized me will come here, as will Elijah and Enoch, because they did not taste death; the two of them will destroy you, devil."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-176",
      "id": "foot_176"
    }
  }, [_vm._v("c")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('sup', [_vm._v("16")]), _vm._v("Glory and honor and veneration to our God, the Father, the Son, and the Holy Spirit, now and forever. Amen."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-177",
      "id": "foot_177"
    }
  }, [_vm._v("d")])])])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/foot.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_067",
      "id": "foot-067"
    }
  }, [_vm._v("a")]), _vm._v(". M has “Discourse of our Lord Jesus Christ regarding the dispute with the devil.” The title for V is lacking.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_068",
      "id": "foot-068"
    }
  }, [_vm._v("b")]), _vm._v(". M names Peter, Paul, and Andrew with Jesus.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_069",
      "id": "foot-069"
    }
  }, [_vm._v("c")]), _vm._v(". M lacks “holy.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_070",
      "id": "foot-070"
    }
  }, [_vm._v("d")]), _vm._v(". M has “the Lord.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_071",
      "id": "foot-071"
    }
  }, [_vm._v("e")]), _vm._v(". M lacks “entire.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_072",
      "id": "foot-072"
    }
  }, [_vm._v("f")]), _vm._v(". M adds “the devil said to him.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_073",
      "id": "foot-073"
    }
  }, [_vm._v("g")]), _vm._v(". M lacks “which you fabricated.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_074",
      "id": "foot-074"
    }
  }, [_vm._v("a")]), _vm._v(". M lacks “and all your assistants.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_075",
      "id": "foot-075"
    }
  }, [_vm._v("b")]), _vm._v(". M lacks “you fell.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_076",
      "id": "foot-076"
    }
  }, [_vm._v("c")]), _vm._v(". M lacks “As I kill you … and the eternal fire.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_077",
      "id": "foot-077"
    }
  }, [_vm._v("a")]), _vm._v(". V adds “and my wishes?”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_078",
      "id": "foot-078"
    }
  }, [_vm._v("b")]), _vm._v(". Μ adds “adulterers.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_079",
      "id": "foot-079"
    }
  }, [_vm._v("c")]), _vm._v(". The list in V contains “wheezing, sexual immoralities, false witnesses, gossip, proscription lists, sexual immorality, theft, murder, drunkenness, games, rattles, dancing, cithara music, remembrance of evil, stabbing one’s foster-sibling with a knife, separation of a married couple, jealousy toward one’s siblings and neighbors, and doing reverence but not toward God.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_080",
      "id": "foot-080"
    }
  }, [_vm._v("d")]), _vm._v(". M lacks “you speak accurately.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_081",
      "id": "foot-081"
    }
  }, [_vm._v("e")]), _vm._v(". M lacks “superior and stronger.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_082",
      "id": "foot-082"
    }
  }, [_vm._v("f")]), _vm._v(". M has “from a woman.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_083",
      "id": "foot-083"
    }
  }, [_vm._v("g")]), _vm._v(". For “correct the falling of the woman and the man ("), _c('em', [_vm._v("anthrōpon")]), _vm._v("),” M has “save the man ("), _c('em', [_vm._v("anthrōpon")]), _vm._v(").”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_084",
      "id": "foot-084"
    }
  }, [_vm._v("a")]), _vm._v(". M has “ninety.” For this sentence, V has a fragmentary line: “And again Jesus said, ‘If someone will seek and will live by your intentions and will renounce my glory until he is eighty years old and until the […].”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_085",
      "id": "foot-085"
    }
  }, [_vm._v("b")]), _vm._v(". M lacks “and follows my commandments.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_086",
      "id": "foot-086"
    }
  }, [_vm._v("c")]), _vm._v(". M has Melouch and J reads Melodox. Casey and Thomson argue that this name should be read as Temeluchus, and stems from "), _c('em', [_vm._v("tēmelougos")]), _vm._v(", “care-taking.” For this sentence, V has a fragmentary line: “[…] years and does not end up repenting, they will be handed over to the angel Temeluchus and they will carry them back into the outer darkness with the arch-evil demons and they will be punished.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_087",
      "id": "foot-087"
    }
  }, [_vm._v("a")]), _vm._v(". V adds “I will calculate it according to their error. I will seek them into the extremities and will never destroy them, because they are my creation.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_088",
      "id": "foot-088"
    }
  }, [_vm._v("a")]), _vm._v(". M lacks “of the sea.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_089",
      "id": "foot-089"
    }
  }, [_vm._v("b")]), _vm._v(". M lacks “Likewise, also Peter, being extremely cowardly, ran behind Jesus,” but includes “And Peter, being afraid of the devil … <the devil> wished to terrify Jesus” (ellipses and reconstruction provided by Casey and Thomson).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_090",
      "id": "foot-090"
    }
  }, [_vm._v("c")]), _vm._v(". M adds “it was written … and he stood at the feet of Jesus” (ellipses provided by Casey and Thomson).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_091",
      "id": "foot-091"
    }
  }, [_vm._v("d")]), _vm._v(". V lacks these two sentences and instead reads: “The devil said, ‘You are king in the heavens, but I am over this earth. You are Christ and I am the Antichrist.’ Jesus said, ‘O Satan, are you debating again?’ And our Lord Jesus Christ prayed and suspended the devil in a cloud from heaven by his feet and he covered him in smoke from the smoke of sulfur.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_092",
      "id": "foot-092"
    }
  }, [_vm._v("a")]), _vm._v(". M lacks “And they said to one another” but includes “but.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_093",
      "id": "foot-093"
    }
  }, [_vm._v("b")]), _vm._v(". M lacks “the devil, the foremost one himself” but includes “that one.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_094",
      "id": "foot-094"
    }
  }, [_vm._v("c")]), _vm._v(". M has “cried out, saying.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_095",
      "id": "foot-095"
    }
  }, [_vm._v("d")]), _vm._v(". V reads: “And the devil cried out in a great voice, saying, ‘Lord, get me out of this situation, and as many as have trusted in my abominable name, I will make them repent toward you.’ ”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_096",
      "id": "foot-096"
    }
  }, [_vm._v("e")]), _vm._v(". M lacks “my own creation.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_097",
      "id": "foot-097"
    }
  }, [_vm._v("f")]), _vm._v(". M lacks “my name.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_098",
      "id": "foot-098"
    }
  }, [_vm._v("g")]), _vm._v(". M lacks “holy.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_099",
      "id": "foot-099"
    }
  }, [_vm._v("h")]), _vm._v(". V reads: “And the Lord commanded him to be put down upon the earth and, as the devil was cast down like lightning upon the earth, hurling a great wheeze into his mouth, he rose up to overpower Jesus.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_100",
      "id": "foot-100"
    }
  }, [_vm._v("a")]), _vm._v(". Instead of this sentence, V has an expanded exchange similar to 6:1–2 in the Church Slavic text: “Jesus said to him, ‘O Satan, are you debating again? I will not spit on you or breathe upon you, for my spit is healing and is my power, while my all-holy breath comes from my mouth. Yes! My powers are great. Even if I do not make war against you, I will be king of the ages.’ The devil said, ‘On earth, you are Christ and I am the antichrist.’ And Jesus said, ‘You are a shadow.’ The devil said, ‘And you are a shadow who was born of a woman.’ Jesus said, ‘Truly I was born of a woman, and because of that I never abandon the race of humanity. I made them and never abandon them, but I will kill you.’ ”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_101",
      "id": "foot-101"
    }
  }, [_vm._v("b")]), _vm._v(". M reads “to the high priests.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_102",
      "id": "foot-102"
    }
  }, [_vm._v("c")]), _vm._v(". M lacks “not” and is emended to include “not” by Casey and Thomson.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_103",
      "id": "foot-103"
    }
  }, [_vm._v("d")]), _vm._v(". M lacks “governing.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_104",
      "id": "foot-104"
    }
  }, [_vm._v("e")]), _vm._v(". M lacks “So, why did you come to earth and interrogate us before the appointed time?”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_105",
      "id": "foot-105"
    }
  }, [_vm._v("a")]), _vm._v(". M lacks “unjustly.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_106",
      "id": "foot-106"
    }
  }, [_vm._v("b")]), _vm._v(". V contradicts the devil’s statement in M and J: “The devil said, ‘And I … by the high priest Caiaphas, as I caused John the Baptist to be beheaded by Herod the king and for his head to be given on a platter for the dancing of the little girl before Herod’ ” (ellipses provided by Casey and Thomson). Cf. Church Slavic 6:5.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_107",
      "id": "foot-107"
    }
  }, [_vm._v("c")]), _vm._v(". M lacks “And if I wished to do something, every power to do so is mine.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_108",
      "id": "foot-108"
    }
  }, [_vm._v("d")]), _vm._v(". M lacks “more.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_109",
      "id": "foot-109"
    }
  }, [_vm._v("e")]), _vm._v(". M finishes the chapter here.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_110",
      "id": "foot-110"
    }
  }, [_vm._v("f")]), _vm._v(". M lacks “with his power.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_111",
      "id": "foot-111"
    }
  }, [_vm._v("g")]), _vm._v(". M has “the earth.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_112",
      "id": "foot-112"
    }
  }, [_vm._v("h")]), _vm._v(". M adds “and he cast the devil down.” In lieu of 7:1 above, V reads: “Jesus said, ‘O Satan, are you debating again?’ And the Lord prayed from the third <heaven> and sealed the earth. The earth split down until the subterranean part of the abyss and he commanded that the devil be taken down there.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_113",
      "id": "foot-113"
    }
  }, [_vm._v("a")]), _vm._v(". M lacks “O violence! Violence! Why are you doing this to me?”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_114",
      "id": "foot-114"
    }
  }, [_vm._v("b")]), _vm._v(". M adds “ ‘Come down and you must see.’ And the devil said, ‘My Lord, how deep is it?’ ”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_115",
      "id": "foot-115"
    }
  }, [_vm._v("c")]), _vm._v(". M adds “years.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_116",
      "id": "foot-116"
    }
  }, [_vm._v("d")]), _vm._v(". M has “his.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_117",
      "id": "foot-117"
    }
  }, [_vm._v("e")]), _vm._v(". For v. 3, V reads: “Jesus said, ‘Where you are going, sixty-eight men will roll a stone by their own strength and for fifty years the stone will be falling, as a mustard seed, until it comes near to the place where you are.’ ”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_118",
      "id": "foot-118"
    }
  }, [_vm._v("a")]), _vm._v(". M has “my Lord.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_119",
      "id": "foot-119"
    }
  }, [_vm._v("b")]), _vm._v(". M lacks “from the abyss and will be born from a woman, whose name is Perdition.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_120",
      "id": "foot-120"
    }
  }, [_vm._v("c")]), _vm._v(". V reads: “Jesus said, ‘You will be there until the completion of the age, being beaten by twenty-four angels all night and day, but after the completion of the age, you will be brought out upon the earth and will go to the city of Daphne in the land of Gouze, being made similar to a pickled fish. A virgin woman by the name of Eudokia will bear you, because you ought to be born from injustice ("), _c('em', [_vm._v("Apoc. Dan.")]), _vm._v(" 9:1–13). After being born from her for three months, you will sit upon your throne on the earth and reign for three years.’ ”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_121",
      "id": "foot-121"
    }
  }, [_vm._v("d")]), _vm._v(". M lacks “what” and the explicit question format.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_122",
      "id": "foot-122"
    }
  }, [_vm._v("e")]), _vm._v(". It appears that v. 7 (“I will make … on account of my elect”) should be attributed to Jesus, but attribution is lacking from the manuscript. V reads: “And the devil said, ‘How long will I reign?’ Jesus said, ‘O Satan, do not rejoice that you will reign, but I am able to shift the years (as the book says) and will make three years into three months or three weeks, the weeks into days, the days into hours, the hours into specks.’ The devil said, ‘Lord, what will happen from that point?’ Jesus said, ‘Bread and much wine will emerge at that same year (cf. Irenaeus, "), _c('em', [_vm._v("Haer.")]), _vm._v(" 5.33.3–4; "), _c('em', [_vm._v("Apoc. Dan.")]), _vm._v(" 10:2–4) […] and during those two years there will be found to the four corners neither wine nor olives, except the morsel of bread and the half liter of olive oil of the barren woman’ ” ("), _c('em', [_vm._v("1 Apocr. Apoc. John")]), _vm._v(" 5; cf. "), _c('em', [_vm._v("Syr. Apoc. Dan.")]), _vm._v(" 18; 1 Kgs 17:12; 2 Kgs 4:2).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_123",
      "id": "foot-123"
    }
  }, [_vm._v("a")]), _vm._v(". M lacks “and you will depart into the eternal fire” but includes “abortion, evil devil.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_124",
      "id": "foot-124"
    }
  }, [_vm._v("b")]), _vm._v(". V reads: “ ‘I myself will come with Enoch and Elijah and John and with my mother the Virgin and with the holy John, the one who baptized me and of whom you said, “I caused him to be beheaded for a plaything of nobility to be given on a platter before Herod.” I will send him out for reproach and your destruction. They will convict you so that your name no longer appears in heaven nor on earth.’ […] because the great power of our Lord Jesus Christ, in whom is the glory and the power forever and ever. Amen.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_125",
      "id": "foot-125"
    }
  }, [_vm._v("a")]), _vm._v(". Lit.: “became angry with great anger.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_126",
      "id": "foot-126"
    }
  }, [_vm._v("b")]), _vm._v(". In K2–4, it is the devil who asks this question.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_127",
      "id": "foot-127"
    }
  }, [_vm._v("c")]), _vm._v(". BDHI and K2–4 have “Are you the son of the High One?” with Jesus replying “I am.” J2 LM lack the entire exchange (1:7–9).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_128",
      "id": "foot-128"
    }
  }, [_vm._v("d")]), _vm._v(". BD add “The devil said, ‘Your armies of angels cannot see you speaking in heaven and listening to you on earth. You have strong angels, why don’t you listen to them and come down to earth to us?” H adds “(Jesus said,) ‘The heavenly host could not see the face of God in them.’ ” I adds “And the devil said, ‘If you are the son of God, why have you come here?’ ” M adds “The devil said, ‘My angels appear, since your father cast me down from heaven.’ ”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_129",
      "id": "foot-129"
    }
  }, [_vm._v("a")]), _vm._v(". J1 begins with “If you are the son of the High One.” K2 and K3 add “so that my angels don’t find you and destroy you.” K4 adds “so that my angels don’t destroy you.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_130",
      "id": "foot-130"
    }
  }, [_vm._v("b")]), _vm._v(". K1 begins here.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_131",
      "id": "foot-131"
    }
  }, [_vm._v("c")]), _vm._v(". This phrase is missing from A and has been added on the basis of the readings in other manuscripts.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_132",
      "id": "foot-132"
    }
  }, [_vm._v("d")]), _vm._v(". The term this manuscript and most of the others use is "), _c('em', [_vm._v("s")]), _c('span', {
    staticClass: "special-char-ital"
  }, [_vm._v("ǐ")]), _c('em', [_vm._v("větnik")]), _c('span', {
    staticClass: "special-char-ital"
  }, [_vm._v("ǐ")]), _vm._v(", which is a variant of "), _c('em', [_vm._v("s")]), _c('span', {
    staticClass: "special-char-ital"
  }, [_vm._v("ǔ")]), _vm._v(" "), _c('em', [_vm._v("vět")]), _c('span', {
    staticClass: "special-char-ital"
  }, [_vm._v("ǐ")]), _c('em', [_vm._v("nik")]), _c('span', {
    staticClass: "special-char-ital"
  }, [_vm._v("ǔ")]), _vm._v(", a derivation of "), _c('em', [_vm._v("s")]), _c('span', {
    staticClass: "special-char-ital"
  }, [_vm._v("ǔ")]), _c('em', [_vm._v("vět")]), _c('span', {
    staticClass: "special-char-ital"
  }, [_vm._v("ǔ")]), _vm._v(", “council.” J2 and M use the term "), _c('em', [_vm._v("svetelnik")]), _c('span', {
    staticClass: "special-char-ital"
  }, [_vm._v("ǐ")]), _vm._v(" "), _c('em', [_vm._v("/ světil")]), _c('span', {
    staticClass: "special-char-ital"
  }, [_vm._v("ǐ")]), _c('em', [_vm._v("nik")]), _c('span', {
    staticClass: "special-char-ital"
  }, [_vm._v("ǐ")]), _vm._v(", respectively, which Casey and Thomson translate as “luminary.” This word derives from "), _c('em', [_vm._v("svět")]), _c('span', {
    staticClass: "special-char-ital"
  }, [_vm._v("ǔ")]), _vm._v(", “light” (note the spelling), and normally means “light source.” Considering the similarity of the two roots, the very much out-of-place term “luminary” can safely be considered a scribal error.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_133",
      "id": "foot-133"
    }
  }, [_vm._v("a")]), _vm._v(". The list changes in every recension, see the section “Analysis of the Church Slavic Tradition” above.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_134",
      "id": "foot-134"
    }
  }, [_vm._v("b")]), _vm._v(". M lacks 2:5–3:1 and a portion of 3:2, most likely as a result of scribal error.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_135",
      "id": "foot-135"
    }
  }, [_vm._v("c")]), _vm._v(". B has “I am greater than your angels and older than you.” D has “I am greater than your angels and stronger than you.” H and I have “I am stronger than you and my angels (are stronger) than your angels.” J1 J2 K3 and L have “I am stronger than you and more terrible than your angels.” K1 has “I am greater than your (angels) and older than everyone.” K2 and K4 have “I am stronger and more terrible than you and your angels.” M lacks the entire exchange.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_136",
      "id": "foot-136"
    }
  }, [_vm._v("d")]), _vm._v(". The manuscript has “does not end,” which is probably a scribal error: "), _c('em', [_vm._v("neskon")]), _c('span', {
    staticClass: "special-char-ital"
  }, [_vm._v("ǔ")]), _c('em', [_vm._v("čěet")]), _c('span', {
    staticClass: "special-char-ital"
  }, [_vm._v("ǐ")]), _vm._v(", “does not end,” for "), _c('em', [_vm._v("iskon")]), _c('span', {
    staticClass: "special-char-ital"
  }, [_vm._v("ǔ")]), _c('em', [_vm._v("čěet")]), _c('span', {
    staticClass: "special-char-ital"
  }, [_vm._v("ǐ")]), _vm._v(","), _c('em'), _vm._v(" “ends, is fulfilled.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_137",
      "id": "foot-137"
    }
  }, [_vm._v("e")]), _vm._v(". Most other recensions have a version of “… so that the word is fulfilled: ‘I created human beings in my image and I will not abandon them forever.’ ”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_138",
      "id": "foot-138"
    }
  }, [_vm._v("a")]), _vm._v(". BD lack this verse. I has “The devil said, ‘(Tell me) about the people, whom you are speaking of now, those you will never abandon; so if they sin against you and reject your glory and honor and do my will and works, what will you do to them?’ ” J has a formulation similar to that of I and adds “Jesus said to him, ‘Listen to me, devil: for (evil) ideas, I will condemn them to darkness; for (evil) works, I will deliver them to fire, because ideas come first and works are done after (them).’ The devil said, ‘If they act (according to) my ideas and reject your honor and glory, what will you do to them?’ ” L has “And if a person sins, doing my work and evil ideas, what happens to them?”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_139",
      "id": "foot-139"
    }
  }, [_vm._v("b")]), _vm._v(". “Fifty and” is restored on the basis of the parallel in 3:5. Different recensions give different numbers.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_140",
      "id": "foot-140"
    }
  }, [_vm._v("a")]), _vm._v(". H lacks this verse.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_141",
      "id": "foot-141"
    }
  }, [_vm._v("b")]), _vm._v(". In H, the mountain is the Mount of Olives. In M, there is no mountain.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_142",
      "id": "foot-142"
    }
  }, [_vm._v("c")]), _vm._v(". Here and in what follows, LM J1 and J2 use the term "), _c('em', [_vm._v("běs")]), _vm._v(", “evil spirit,” as opposed to "), _c('em', [_vm._v("dijavol")]), _c('span', {
    staticClass: "special-char-ital"
  }, [_vm._v("ǐ")]), _vm._v(", lit. “devil.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_143",
      "id": "foot-143"
    }
  }, [_vm._v("d")]), _vm._v(". For “darkness upon darkness, thousands upon thousands” (ADI and K2–4), B has “all his servants, four thousand,” H has “all his forces,” J2 has “darkness, evil spirits assembled.” K1 lacks this formulation. J1 and L have a different verse: J1 has “Having said that, Jesus went up a high mountain. Here Jesus saw great darkness which the devil had gathered, darkness upon darkness, thousands upon thousands.” L has “Our Lord Jesus Christ went up a high mountain together with his disciples. Jesus Christ saw from on high a great darkness of evil spirits which Satanael had collected, his servants, darkness upon darkness.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_144",
      "id": "foot-144"
    }
  }, [_vm._v("e")]), _vm._v(". L has “Satanael.” J1 has “Satan.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_145",
      "id": "foot-145"
    }
  }, [_vm._v("f")]), _vm._v(". K1 has “sons”; K2–4 have “brothers.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_146",
      "id": "foot-146"
    }
  }, [_vm._v("a")]), _vm._v(". H has lacks this verse. M adds before this verse “Go before me and I will go behind you. I will send you to Beelzebub, who is not afraid of great strength.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_147",
      "id": "foot-147"
    }
  }, [_vm._v("b")]), _vm._v(". J2 and K1–5 have “servants” here and in what follows.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_148",
      "id": "foot-148"
    }
  }, [_vm._v("c")]), _vm._v(". J1 J2 and L lack this verse.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_149",
      "id": "foot-149"
    }
  }, [_vm._v("d")]), _vm._v(". K1 adds “God asks, ‘Who cast the devil from heaven?’ Thomas and Philip and Bartholomew and John all said, ‘God is above all.’ A great number of angels came down from heaven with dust and angrily berated the devil.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_150",
      "id": "foot-150"
    }
  }, [_vm._v("e")]), _vm._v(". L has “Satan.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_151",
      "id": "foot-151"
    }
  }, [_vm._v("f")]), _vm._v(". Only A has this verse. J1 has “John and James said, ‘You, Lord.’ ”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_152",
      "id": "foot-152"
    }
  }, [_vm._v("g")]), _vm._v(". The manuscripts disagree on the identity of the respondent; see the section “Analysis of the Church Slavic Tradition” above.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_153",
      "id": "foot-153"
    }
  }, [_vm._v("a")]), _vm._v(". Restored on the basis of other recensions.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_154",
      "id": "foot-154"
    }
  }, [_vm._v("b")]), _vm._v(". B lacks this verse.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_155",
      "id": "foot-155"
    }
  }, [_vm._v("c")]), _vm._v(". B is damaged from here.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_156",
      "id": "foot-156"
    }
  }, [_vm._v("d")]), _vm._v(". HI J1–2 lack vv. 9–10.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_157",
      "id": "foot-157"
    }
  }, [_vm._v("e")]), _vm._v(". J2 lacks this verse.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_158",
      "id": "foot-158"
    }
  }, [_vm._v("a")]), _vm._v(". D adds “Jesus said, ‘Are you thinking of me, devil?’ The devil said, ‘You, too, spit on me and breathed on me!’ ” H adds “Jesus approached him and said to him, ‘Are you thinking the same, devil?’ ” I adds “Jesus said to him, ‘Do you hear the same, devil?’ ” J1 and L add “Jesus said, ‘Are you thinking I should spit on you?’ ” J2 and M add “Jesus said, ‘Are you thinking of grabbing me, devil?’ ”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_159",
      "id": "foot-159"
    }
  }, [_vm._v("b")]), _vm._v(". In M, Jesus says this sentence.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_160",
      "id": "foot-160"
    }
  }, [_vm._v("c")]), _vm._v(". K2–4 have “the hearts of the Jews.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_161",
      "id": "foot-161"
    }
  }, [_vm._v("d")]), _vm._v(". K1 has “If I do not fight you, I cannot oppose the High One. I will enter the hearts of the Jews so that they crucify you and kill you and I will oppose the High One.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_162",
      "id": "foot-162"
    }
  }, [_vm._v("e")]), _vm._v(". J1 lacks vv. 3–4.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_163",
      "id": "foot-163"
    }
  }, [_vm._v("a")]), _vm._v(". K1 adds here “You are lying, devil.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_164",
      "id": "foot-164"
    }
  }, [_vm._v("b")]), _vm._v(". M lacks this verse.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_165",
      "id": "foot-165"
    }
  }, [_vm._v("c")]), _vm._v(". H has “Jesus said to him, ‘See, devil, how big is the abyss in which you will reside, along with those who worship your name.’ ” I has “And Jesus said, ‘Do you see the large thing behind you?’ The devil looked around and saw behind him a great abyss. He was shocked and said, ‘What is this, Lord?’ ” M has “The devil looked around and saw the great abyss and said, ‘Lord, what is this? Do not destroy me!’ ”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_166",
      "id": "foot-166"
    }
  }, [_vm._v("a")]), _vm._v(". The text of A has “thirty-year-old,” which is clearly an error considering the fact that it uses the term "), _c('em', [_vm._v("junoša")]), _vm._v(", “boy,” and that the Cyrillic letter "), _c('em', [_vm._v("l")]), _vm._v(" (which stands for thirty) and the Cyrillic letter "), _c('em', [_vm._v("d")]), _vm._v(" (which stands for four) are easily confused. D and J1 have the same error; H has “three” and I has “four.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_167",
      "id": "foot-167"
    }
  }, [_vm._v("b")]), _vm._v(". From here, K4 has a different ending: “ ‘This is how deep the abyss is where you will reside, along with all your servants.’ The devil ran into the abyss, vanquished by the Lord. And Jesus and his disciples returned to Jerusalem to teach in the temple about the kingdom of God.” The recension then continues with homiletic material listing a number of occasions in the Bible where prayer and fasting (typically for forty days) saved someone. K2 also has a different ending from here: “ ‘This is how deep the abyss is where you are to go, together with all your servants.’ And so the devil went, defeated by the Lord. Jesus with his disciples returned to Jerusalem and taught in the temple. Do not marvel, brothers, that our Lord Jesus Christ let himself be tempted by the devil; that is why he came to the world (original: "), _c('em', [_vm._v("mir")]), _vm._v(") and for our sake allowed himself to die. You then remain in fast and prayer, so that you can join God’s elect saints for ever and ever. Amen.” K3 ends similarly: “The devil ran, humiliated and defeated by the Lord. Jesus with his disciples returned to Jerusalem and taught in the temple about the kingdom of God. Do not marvel, brothers, that our Lord Jesus Christ let himself be tempted by the devil and spoke to him, because this is why he came to the world (original: "), _c('em', [_vm._v("svet")]), _vm._v("), to rid us of him. Rather, brothers, remain in prayer and purity and love and alms, so that you will join God’s elect saints, so that after those good deeds we too defeat the devil and accept eternal life from God. May the Father, the Son, and the Holy Spirit lead us to it. Amen.” H and I add: “(This is) where you will reside, devil, here I will bind you with unbreakable bonds and put you down in the lowest (layers) of earth and you will reside here until the end of this age.” L also includes a reference to the devil being bound, this time with an unbreakable iron chain (see below).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_168",
      "id": "foot-168"
    }
  }, [_vm._v("a")]), _vm._v(". J2 and M lack vv. 3–6.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_169",
      "id": "foot-169"
    }
  }, [_vm._v("b")]), _vm._v(". I lacks vv. 7–8.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_170",
      "id": "foot-170"
    }
  }, [_vm._v("c")]), _vm._v(". Lit., “a mark, a stroke (of a pen).”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_171",
      "id": "foot-171"
    }
  }, [_vm._v("d")]), _vm._v(". M is damaged from here.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_172",
      "id": "foot-172"
    }
  }, [_vm._v("e")]), _vm._v(". Lit., “send.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_173",
      "id": "foot-173"
    }
  }, [_vm._v("f")]), _vm._v(". From here, K1 has a different ending: “And God said, ‘Go into the abyss, devil, and reside here until the judgment day, for your disbelief.’ Lord, have mercy on us and all the world. Amen.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_174",
      "id": "foot-174"
    }
  }, [_vm._v("a")]), _vm._v(". Singular, as the verbal form could refer to any gender.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_175",
      "id": "foot-175"
    }
  }, [_vm._v("b")]), _vm._v(". H and J1 lack this verse. D and J2 have “And I will come to the place that is called "), _c('em', [_vm._v("Chizi")]), _vm._v(".” I has “I will come to my place which is called "), _c('em', [_vm._v("Chižina")]), _vm._v(".”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_176",
      "id": "foot-176"
    }
  }, [_vm._v("c")]), _vm._v(". J1 has “Jesus said, ‘I will send Elijah and Enoch to contend with you and then your lies will come to light on the altar, as the prophet David says, ‘Then bulls will be offered on your altar’ (Ps 51:19). I will then come to the place where John baptized me and my mother gave birth to me and then I will vanquish you.’ ” The same passage is quoted in "), _c('em', [_vm._v("Apoc. Dan.")]), _vm._v(" 14:12.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_177",
      "id": "foot-177"
    }
  }, [_vm._v("d")]), _vm._v(". For vv. 13–16, L has wording that is substantially different from the majority tradition: “Jesus Christ said, ‘My heaven will devour the earth and the sea will dry up like stone; the earth will burn and people will rise from the dead. And I will condemn all tribes of the earth and you, Satan, I will condemn you and all people who do your works. Yours will be eternal torture and mine will be glory and honor and veneration for ever.’ Jesus then pushed the devil with his foot into the fiery abyss. After his resurrection, our Lord Jesus Christ went into this deepest abyss, took hold of the devil and bound him with an iron chain that cannot be sundered until the judgment day. Those who were there in the deepest hell beginning with Adam until Jesus’s resurrection, Jesus freed them all and led them out. Glory to his victory to all the world and all the Christian people; we celebrate the victory of our Lord Jesus Christ in the Holy Trinity, one Father, Son, and Holy Spirit, now and always and forever and ever. Amen.”")])])])
}]}

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(92),
  /* template */
  __webpack_require__(93),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 93 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(95),
  /* template */
  __webpack_require__(96),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 96 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(98),
  /* template */
  __webpack_require__(99),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 99 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(101),
  /* template */
  __webpack_require__(102),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 102 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(104),
  /* template */
  __webpack_require__(105),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 105 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(107),
  /* template */
  __webpack_require__(108),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 108 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(110),
  /* template */
  __webpack_require__(111),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 111 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(113),
  /* template */
  __webpack_require__(114),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 114 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(116),
  /* template */
  __webpack_require__(117),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 117 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(119),
  /* template */
  __webpack_require__(120),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 120 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(122),
  /* template */
  __webpack_require__(123),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 123 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(125),
  /* template */
  __webpack_require__(126),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 126 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(128),
  /* template */
  __webpack_require__(129),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 129 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(131),
  /* template */
  __webpack_require__(132),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 132 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(134),
  /* template */
  __webpack_require__(135),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 135 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(137),
  /* template */
  __webpack_require__(138),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 138 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(140),
  /* template */
  __webpack_require__(141),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 141 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(143),
  /* template */
  __webpack_require__(144),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 144 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(146),
  /* template */
  __webpack_require__(147),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 147 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(149),
  /* template */
  __webpack_require__(150),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 150 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(152),
  /* template */
  __webpack_require__(153),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 153 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(155),
  /* template */
  __webpack_require__(156),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 156 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(158),
  /* template */
  __webpack_require__(159),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 159 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(161),
  /* template */
  __webpack_require__(162),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 162 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(164),
  /* template */
  __webpack_require__(165),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 165 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(167),
  /* template */
  __webpack_require__(168),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 168 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(170),
  /* template */
  __webpack_require__(171),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 171 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(173),
  /* template */
  __webpack_require__(174),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 174 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(176),
  /* template */
  __webpack_require__(177),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 177 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(179),
  /* template */
  __webpack_require__(180),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 180 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', [_vm._v("Thank you for reading this sample. Here are other books you might like.")]), _c('div', [_c('div', {
    attrs: {
      "id": "textcafe-gallery-widget-container"
    }
  }), _vm._v(" "), _c('script', {
    attrs: {
      "type": "application/javascript"
    }
  }, [_vm._v("\n      TextCafeWidget.config({\n          'type':'related',\n          'id':'9781467466844',\n          'coverImageWidth': '30',\n          'hideDescriptions': true\n      });\n      var textCafeGalleryWidget = TextCafeWidget.widgets.galleryWidget.new({selector:'#textcafe-gallery-widget-container'});\n      textCafeGalleryWidget.render();\n    ")])])])
}]}

/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["Vuetify"] = factory();
	else
		root["Vuetify"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 29);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = createSimpleFunctional;
/* harmony export (immutable) */ __webpack_exports__["e"] = createSimpleTransition;
/* harmony export (immutable) */ __webpack_exports__["b"] = createJavaScriptTransition;
/* harmony export (immutable) */ __webpack_exports__["f"] = directiveConfig;
/* harmony export (immutable) */ __webpack_exports__["a"] = addOnceEventListener;
/* harmony export (immutable) */ __webpack_exports__["g"] = getObjectValueByPath;
/* harmony export (immutable) */ __webpack_exports__["c"] = createRange;
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function createSimpleFunctional(c) {
  var el = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'div';

  return {
    functional: true,

    render: function render(h, _ref) {
      var data = _ref.data,
          children = _ref.children;

      data.staticClass = (c + ' ' + (data.staticClass || '')).trim();

      return h(el, data, children);
    }
  };
}

function createSimpleTransition(name) {
  var origin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top center 0';
  var mode = arguments[2];

  return {
    functional: true,

    props: {
      origin: {
        type: String,
        default: origin
      }
    },

    render: function render(h, context) {
      context.data = context.data || {};
      context.data.props = { name: name };
      context.data.on = context.data.on || {};

      if (mode) context.data.props.mode = mode;

      context.data.on.beforeEnter = function (el) {
        el.style.transformOrigin = origin;
        el.style.webkitTransformOrigin = origin;
      };

      return h('transition', context.data, context.children);
    }
  };
}

function createJavaScriptTransition(name, functions) {
  var css = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var mode = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'in-out';

  return {
    functional: true,

    props: {
      css: {
        type: Boolean,
        default: css
      },
      mode: {
        type: String,
        default: mode
      }
    },

    render: function render(h, context) {
      var data = {
        props: _extends({}, context.props, {
          name: name
        }),
        on: functions
      };

      return h('transition', data, context.children);
    }
  };
}

function directiveConfig(binding) {
  var defaults = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return Object.assign({}, defaults, binding.modifiers, { value: binding.arg }, binding.value || {});
}

function addOnceEventListener(el, event, cb) {
  var once = function once() {
    cb();
    el.removeEventListener(event, once, false);
  };

  el.addEventListener(event, once, false);
}

function getObjectValueByPath(obj, path) {
  // credit: http://stackoverflow.com/questions/6491463/accessing-nested-javascript-objects-with-string-key#comment55278413_6491621
  if (!path || path.constructor !== String) return;
  path = path.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties
  path = path.replace(/^\./, ''); // strip a leading dot
  var a = path.split('.');
  for (var i = 0, n = a.length; i < n; ++i) {
    var k = a[i];
    if (obj instanceof Object && k in obj) {
      obj = obj[k];
    } else {
      return;
    }
  }
  return obj;
}

function createRange(length) {
  return [].concat(_toConsumableArray(Array.from({ length: length }, function (v, k) {
    return k;
  })));
}

/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    dark: Boolean,
    light: Boolean
  }
});

/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isActive: !!this.value
    };
  },


  props: {
    value: {
      required: false
    }
  },

  watch: {
    value: function value(val) {
      this.isActive = !!val;
    },
    isActive: function isActive(val) {
      !!val !== this.value && this.$emit('input', val);
    }
  }
});

/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_contextualable__ = __webpack_require__(8);



/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_contextualable__["a" /* default */]],

  props: {
    disabled: Boolean,
    fa: Boolean,
    mdi: Boolean,
    large: Boolean,
    left: Boolean,
    medium: Boolean,
    right: Boolean,
    xLarge: Boolean
  },

  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        _ref$children = _ref.children,
        children = _ref$children === undefined ? [] : _ref$children;

    if (props.fa || props.mdi) console.warn('The v-icon prop \'fa\' and \'mdi\' will be deprecated in the next release. Use \'fa\' or \'mdi\' prefix in icon name instead.');
    var iconName = '';
    var iconType = 'material-icons';

    if (children.length) {
      iconName = children.pop().text;
    } else if (data.domProps && data.domProps.textContent) {
      iconName = data.domProps.textContent;
      delete data.domProps.textContent;
    } else if (data.domProps && data.domProps.innerHTML) {
      iconName = data.domProps.innerHTML;
      delete data.domProps.innerHTML;
    }

    var thirdPartyIcon = iconName.indexOf('-') > -1;
    if (thirdPartyIcon) iconType = iconName.slice(0, iconName.indexOf('-'));

    // To keep things backwards compatible for now
    iconType = props.fa ? 'fa' : props.mdi ? 'mdi' : iconType;

    data.staticClass = (iconType + ' icon ' + (data.staticClass || '')).trim();
    data.attrs = data.attrs || {};

    var classes = {
      'icon--large': props.large,
      'icon--left': props.left,
      'icon--medium': props.medium,
      'icon--right': props.right,
      'icon--x-large': props.xLarge,
      'primary--text': props.primary,
      'secondary--text': props.secondary,
      'success--text': props.success,
      'info--text': props.info,
      'warning--text': props.warning,
      'error--text': props.error,
      'theme--dark': props.dark,
      'theme--light': props.light
    };

    var iconClasses = Object.keys(classes).filter(function (k) {
      return classes[k];
    }).join(' ');
    iconClasses && (data.staticClass += ' ' + iconClasses);

    // To keep things backwards compatible for now
    if (props.fa || props.mdi) {
      var comparison = props.fa ? 'fa' : 'mdi';

      if (iconName.indexOf(' ') > -1) data.staticClass += ' ' + comparison + '-' + iconName;else data.staticClass += ' ' + comparison + '-' + iconName.split(' ').join('-');
    }

    if (thirdPartyIcon) data.staticClass += ' ' + iconName;
    if (props.disabled) data.attrs.disabled = props.disabled;
    !(thirdPartyIcon || props.fa || props.mdi) && children.push(iconName);

    return h('i', data, children);
  }
});

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__badge__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__click_outside__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__resize__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ripple__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__scroll__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__tooltip__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__touch__ = __webpack_require__(81);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Badge", function() { return __WEBPACK_IMPORTED_MODULE_0__badge__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ClickOutside", function() { return __WEBPACK_IMPORTED_MODULE_1__click_outside__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Ripple", function() { return __WEBPACK_IMPORTED_MODULE_3__ripple__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Resize", function() { return __WEBPACK_IMPORTED_MODULE_2__resize__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Scroll", function() { return __WEBPACK_IMPORTED_MODULE_4__scroll__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Tooltip", function() { return __WEBPACK_IMPORTED_MODULE_5__tooltip__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Touch", function() { return __WEBPACK_IMPORTED_MODULE_6__touch__["a"]; });










/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_positionable__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_route_link__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_toggleable__ = __webpack_require__(2);






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-btn',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_route_link__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_positionable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_toggleable__["a" /* default */]],

  props: {
    activeClass: {
      type: String,
      default: 'btn--active'
    },
    block: Boolean,
    fab: Boolean,
    flat: Boolean,
    icon: Boolean,
    large: Boolean,
    loading: Boolean,
    outline: Boolean,
    ripple: {
      type: [Boolean, Object],
      default: true
    },
    round: Boolean,
    small: Boolean,
    tag: {
      type: String,
      default: 'button'
    },
    type: {
      type: String,
      default: 'button'
    }
  },

  computed: {
    classes: function classes() {
      return {
        'btn': true,
        'btn--absolute': this.absolute,
        'btn--active': this.isActive,
        'btn--block': this.block,
        'btn--bottom': this.bottom,
        'btn--disabled': this.disabled,
        'btn--flat': this.flat,
        'btn--floating': this.fab,
        'btn--fixed': this.fixed,
        'btn--hover': this.hover,
        'btn--icon': this.icon,
        'btn--large': this.large,
        'btn--left': this.left,
        'btn--loader': this.loading,
        'btn--outline': this.outline,
        'btn--raised': !this.flat,
        'btn--right': this.right,
        'btn--round': this.round,
        'btn--small': this.small,
        'btn--top': this.top,
        'theme--dark': this.dark,
        'theme--light': this.light,
        'primary': this.primary && !this.outline,
        'secondary': this.secondary && !this.outline,
        'success': this.success && !this.outline,
        'info': this.info && !this.outline,
        'warning': this.warning && !this.outline,
        'error': this.error && !this.outline,
        'primary--text': this.primary && (this.outline || this.flat),
        'secondary--text': this.secondary && (this.outline || this.flat),
        'success--text': this.success && (this.outline || this.flat),
        'info--text': this.info && (this.outline || this.flat),
        'warning--text': this.warning && (this.outline || this.flat),
        'error--text': this.error && (this.outline || this.flat)
      };
    }
  },

  methods: {
    // Prevent focus to match md spec
    click: function click(e) {
      !this.fab && e.detail && this.$el.blur();

      this.$emit('click', e);
    },
    genContent: function genContent() {
      return this.$createElement('div', { 'class': 'btn__content' }, [this.$slots.default]);
    },
    genLoader: function genLoader() {
      var children = [];

      if (!this.$slots.loader) {
        children.push(this.$createElement('v-progress-circular', {
          props: {
            indeterminate: true,
            size: 26
          }
        }));
      } else {
        children.push(this.$slots.loader);
      }

      return this.$createElement('span', { 'class': 'btn__loading' }, children);
    }
  },

  render: function render(h) {
    var _generateRouteLink = this.generateRouteLink(),
        tag = _generateRouteLink.tag,
        data = _generateRouteLink.data;

    var children = [this.genContent()];

    tag === 'button' && (data.attrs.type = this.type);
    this.loading && children.push(this.genLoader());

    return h(tag, data, children);
  }
});

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VCarouselTransition */
/* unused harmony export VCarouselReverseTransition */
/* unused harmony export VTabTransition */
/* unused harmony export VTabReverseTransition */
/* unused harmony export VMenuTransition */
/* unused harmony export VFabTransition */
/* unused harmony export VDialogTransition */
/* unused harmony export VDialogBottomTransition */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return VFadeTransition; });
/* unused harmony export VScaleTransition */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return VSlideXTransition; });
/* unused harmony export VSlideXReverseTransition */
/* unused harmony export VSlideYTransition */
/* unused harmony export VSlideYReverseTransition */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return VExpandTransition; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__expand_transition__ = __webpack_require__(71);




// Component specific transitions
var VCarouselTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('carousel-transition');
var VCarouselReverseTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('carousel-reverse-transition');
var VTabTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('tab-transition');
var VTabReverseTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('tab-reverse-transition');
var VMenuTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('menu-transition');
var VFabTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('fab-transition', 'center center', 'out-in');

// Generic transitions
var VDialogTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('dialog-transition');
var VDialogBottomTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('dialog-bottom-transition');
var VFadeTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('fade-transition');
var VScaleTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('scale-transition');
var VSlideXTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('slide-x-transition');
var VSlideXReverseTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('slide-x-reverse-transition');
var VSlideYTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('slide-y-transition');
var VSlideYReverseTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('slide-y-reverse-transition');

// JavaScript transitions
var VExpandTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["b" /* createJavaScriptTransition */])('expand-transition', __WEBPACK_IMPORTED_MODULE_1__expand_transition__["a" /* default */]);

/* harmony default export */ __webpack_exports__["d"] = ({
  VCarouselTransition: VCarouselTransition,
  VCarouselReverseTransition: VCarouselReverseTransition,
  VDialogTransition: VDialogTransition,
  VDialogBottomTransition: VDialogBottomTransition,
  VFabTransition: VFabTransition,
  VFadeTransition: VFadeTransition,
  VMenuTransition: VMenuTransition,
  VScaleTransition: VScaleTransition,
  VSlideXTransition: VSlideXTransition,
  VSlideXReverseTransition: VSlideXReverseTransition,
  VSlideYTransition: VSlideYTransition,
  VSlideYReverseTransition: VSlideYReverseTransition,
  VTabReverseTransition: VTabReverseTransition,
  VTabTransition: VTabTransition,
  VExpandTransition: VExpandTransition
});

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__themeable__ = __webpack_require__(1);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__themeable__["a" /* default */]],

  data: function data() {
    return {
      errorBucket: [],
      focused: false,
      tabFocused: false,
      lazyValue: this.value
    };
  },


  props: {
    appendIcon: String,
    appendIconCb: Function,
    disabled: Boolean,
    error: Boolean,
    errorMessages: {
      type: [String, Array],
      default: function _default() {
        return [];
      }
    },
    hint: String,
    hideDetails: Boolean,
    label: String,
    persistentHint: Boolean,
    placeholder: String,
    prependIcon: String,
    prependIconCb: Function,
    required: Boolean,
    rules: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    tabindex: {
      default: 0
    },
    value: {
      required: false
    }
  },

  computed: {
    hasError: function hasError() {
      return this.validations.length || this.error;
    },
    inputGroupClasses: function inputGroupClasses() {
      return Object.assign({
        'input-group': true,
        'input-group--focused': this.focused,
        'input-group--dirty': this.isDirty,
        'input-group--tab-focused': this.tabFocused,
        'input-group--disabled': this.disabled,
        'input-group--error': this.hasError,
        'input-group--append-icon': this.appendIcon,
        'input-group--prepend-icon': this.prependIcon,
        'input-group--required': this.required,
        'input-group--hide-details': this.hideDetails,
        'input-group--placeholder': !!this.placeholder,
        'theme--dark': this.dark,
        'theme--light': this.light
      }, this.classes);
    },
    isDirty: function isDirty() {
      return this.inputValue;
    },
    modifiers: function modifiers() {
      var modifiers = {
        lazy: false,
        number: false,
        trim: false
      };

      if (!this.$vnode.data.directives) {
        return modifiers;
      }

      var model = this.$vnode.data.directives.find(function (i) {
        return i.name === 'model';
      });

      if (!model) {
        return modifiers;
      }

      return Object.assign(modifiers, model.modifiers);
    },
    validations: function validations() {
      return (!Array.isArray(this.errorMessages) ? [this.errorMessages] : this.errorMessages).concat(this.errorBucket);
    }
  },

  watch: {
    rules: function rules() {
      this.validate();
    }
  },

  mounted: function mounted() {
    this.validate();
  },


  methods: {
    genLabel: function genLabel() {
      return this.$createElement('label', {
        attrs: {
          for: this.$attrs.id
        }
      }, this.$slots.label || this.label);
    },
    genMessages: function genMessages() {
      var _this = this;

      var messages = [];

      if ((this.hint && this.focused || this.hint && this.persistentHint) && this.validations.length === 0) {
        messages = [this.genHint()];
      } else if (this.validations.length) {
        messages = this.validations.map(function (i) {
          return _this.genError(i);
        });
      }

      return this.$createElement('transition-group', {
        'class': 'input-group__messages',
        props: {
          tag: 'div',
          name: 'slide-y-transition'
        }
      }, messages);
    },
    genHint: function genHint() {
      return this.$createElement('div', {
        'class': 'input-group__hint',
        key: this.hint,
        domProps: { innerHTML: this.hint }
      });
    },
    genError: function genError(error) {
      return this.$createElement('div', {
        'class': 'input-group__error',
        key: error
      }, error);
    },
    genIcon: function genIcon(type) {
      var _class;

      var icon = this[type + 'Icon'];
      var cb = this[type + 'IconCb'];
      var hasCallback = typeof cb === 'function';

      return this.$createElement('v-icon', {
        'class': (_class = {}, _defineProperty(_class, 'input-group__' + type + '-icon', true), _defineProperty(_class, 'input-group__icon-cb', hasCallback), _class),
        on: {
          click: function click(e) {
            hasCallback && cb(e);
          }
        }
      }, icon);
    },
    genInputGroup: function genInputGroup(input) {
      var _this2 = this;

      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var children = [];
      var wrapperChildren = [];
      var detailsChildren = [];

      data = Object.assign({}, {
        'class': this.inputGroupClasses,
        attrs: {
          tabindex: this.tabindex
        },
        on: {
          blur: function blur() {
            return _this2.tabFocused = false;
          },
          click: function click() {
            return _this2.tabFocused = false;
          },
          keyup: function keyup(e) {
            if ([9, 16].includes(e.keyCode)) {
              _this2.tabFocused = true;
            }
          },
          keydown: function keydown(e) {
            if (!_this2.toggle) return;

            if ([13, 32].includes(e.keyCode)) {
              e.preventDefault();
              _this2.toggle();
            }
          }
        }
      }, data);

      if (this.$slots.label || this.label) {
        children.push(this.genLabel());
      }

      wrapperChildren.push(input);

      if (this.prependIcon) {
        wrapperChildren.unshift(this.genIcon('prepend'));
      }

      if (this.appendIcon) {
        wrapperChildren.push(this.genIcon('append'));
      }

      children.push(this.$createElement('div', {
        'class': 'input-group__input'
      }, wrapperChildren));

      detailsChildren.push(this.genMessages());
      this.counter && detailsChildren.push(this.genCounter());

      children.push(this.$createElement('div', {
        'class': 'input-group__details'
      }, detailsChildren));

      return this.$createElement('div', data, children);
    },
    validate: function validate() {
      var _this3 = this;

      this.errorBucket = [];

      this.rules.forEach(function (rule) {
        var valid = typeof rule === 'function' ? rule(_this3.value) : rule;

        if (valid !== true) {
          _this3.errorBucket.push(valid);
        }
      });
    }
  }
});

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    primary: Boolean,
    secondary: Boolean,
    success: Boolean,
    info: Boolean,
    warning: Boolean,
    error: Boolean
  }
});

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    append: Boolean,
    disabled: Boolean,
    exact: Boolean,
    href: [String, Object],
    to: [String, Object],
    nuxt: Boolean,
    replace: Boolean,
    router: Boolean,
    ripple: {
      type: Boolean,
      default: true
    },
    tag: String
  },

  methods: {
    click: function click() {},
    generateRouteLink: function generateRouteLink() {
      var exact = this.exact;
      var tag = void 0;

      var data = {
        attrs: { disabled: this.disabled },
        class: this.classes,
        props: {},
        directives: [{
          name: 'ripple',
          value: this.ripple || false
        }],
        on: Object.assign({
          click: this.click
        }, this.$listeners || {})
      };

      if (typeof this.exact === 'undefined') {
        exact = this.to === '/' || this.to === Object(this.to) && this.to.path === '/';
      }

      if (this.to) {
        tag = this.nuxt ? 'nuxt-link' : 'router-link';
        data.props.to = this.to;
        data.props.exact = exact;
        data.props.activeClass = this.activeClass;
        data.props.append = this.append;
        data.props.replace = this.replace;
      } else {
        tag = this.href && 'a' || this.tag || 'a';

        if (tag === 'a') {
          data.attrs.href = this.href || 'javascript:;';
        }
      }

      return { tag: tag, data: data };
    }
  }
});

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isBooted: false
    };
  },


  watch: {
    isActive: function isActive() {
      this.isBooted = true;
    }
  },

  methods: {
    showLazyContent: function showLazyContent(content) {
      return this.lazy && this.isBooted || !this.lazy ? content : null;
    }
  }
});

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VListTileActionText */
/* unused harmony export VListTileAvatar */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return VListTileContent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return VListTileTitle; });
/* unused harmony export VListTileSubTitle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VList__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VListGroup__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VListTile__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__VListTileAction__ = __webpack_require__(21);







var VListTileActionText = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__action-text', 'span');
var VListTileAvatar = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__avatar', 'v-avatar');
var VListTileContent = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__content', 'div');
var VListTileTitle = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__title', 'div');
var VListTileSubTitle = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__sub-title', 'div');

/* harmony default export */ __webpack_exports__["c"] = ({
  VList: __WEBPACK_IMPORTED_MODULE_1__VList__["a" /* default */],
  VListTile: __WEBPACK_IMPORTED_MODULE_3__VListTile__["a" /* default */],
  VListGroup: __WEBPACK_IMPORTED_MODULE_2__VListGroup__["a" /* default */],
  VListTileAction: __WEBPACK_IMPORTED_MODULE_4__VListTileAction__["a" /* default */],
  VListTileActionText: VListTileActionText,
  VListTileAvatar: VListTileAvatar,
  VListTileContent: VListTileContent,
  VListTileTitle: VListTileTitle,
  VListTileSubTitle: VListTileSubTitle
});

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    absolute: Boolean,
    bottom: Boolean,
    fixed: Boolean,
    left: Boolean,
    right: Boolean,
    top: Boolean
  }
});

/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    flat: Boolean,
    height: {
      type: String,
      default: 'auto'
    },
    hover: Boolean,
    img: String,
    raised: Boolean,
    tile: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('card ' + (data.staticClass || '')).trim();
    data.style = data.style || {};
    data.style.height = props.height;

    if (props.dark) data.staticClass += ' theme--dark';
    if (props.flat) data.staticClass += ' card--flat';
    if (props.horizontal) data.staticClass += ' card--horizontal';
    if (props.hover) data.staticClass += ' card--hover';
    if (props.light) data.staticClass += ' theme--light';
    if (props.raised) data.staticClass += ' card--raised';
    if (props.tile) data.staticClass += ' card--tile';

    if (props.img) {
      data.style.background = 'url(' + props.img + ') center center / cover no-repeat';
    }

    return h('div', data, children);
  }
});

/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isSaving: false
    };
  },


  props: {
    actions: Boolean,
    autosave: Boolean,
    landscape: Boolean,
    noTitle: Boolean,
    scrollable: Boolean,
    value: {
      required: true
    },
    light: {
      type: Boolean,
      default: true
    },
    dark: Boolean
  },

  methods: {
    save: function save() {},
    cancel: function cancel() {},
    genSlot: function genSlot() {
      return this.$scopedSlots.default({
        save: this.save,
        cancel: this.cancel
      });
    }
  }
});

/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    contentClass: {
      default: ''
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.$vuetify.load(function () {
      if (_this._isDestroyed) return;

      var app = document.querySelector('[data-app]');

      if (!app) {
        return console.warn('Application is missing <v-app> component.');
      }

      app.insertBefore(_this.$refs.content, app.firstChild);
    });
  },
  beforeDestroy: function beforeDestroy() {
    if (!this.$refs.content) return;

    // IE11 Fix
    try {
      this.$refs.content.parentNode.removeChild(this.$refs.content);
    } catch (e) {}
  }
});

/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      overlay: null,
      overlayOffset: 0,
      overlayTransitionDuration: 500
    };
  },


  props: {
    hideOverlay: Boolean
  },

  beforeDestroy: function beforeDestroy() {
    this.removeOverlay();
  },


  methods: {
    genOverlay: function genOverlay() {
      var _this = this;

      if (!this.isActive || this.hideOverlay || this.isActive && this.overlay) return;

      this.overlay = document.createElement('div');
      this.overlay.className = 'overlay';
      this.overlay.onclick = function () {
        if (_this.permanent) return;else if (!_this.persistent) _this.isActive = false;else if (_this.isMobile) _this.isActive = false;
      };

      if (this.absolute) this.overlay.className += ' overlay--absolute';

      this.hideScroll();

      if (this.absolute) {
        // Required for IE11
        var parent = this.$el.parentNode;
        parent.insertBefore(this.overlay, parent.firstChild);
      } else {
        document.querySelector('[data-app]').appendChild(this.overlay);
      }

      this.overlay.clientHeight; // Force repaint
      requestAnimationFrame(function () {
        _this.overlay.className += ' overlay--active';
      });

      return true;
    },
    removeOverlay: function removeOverlay() {
      var _this2 = this;

      if (!this.overlay) {
        return this.showScroll();
      }

      this.overlay.classList.remove('overlay--active');

      setTimeout(function () {
        // IE11 Fix
        try {
          _this2.overlay.parentNode.removeChild(_this2.overlay);
          _this2.overlay = null;
          _this2.showScroll();
        } catch (e) {}
      }, this.overlayTransitionDuration);
    },
    hideScroll: function hideScroll() {
      // Check documentElement first for IE11
      // this.overlayOffset = document.documentElement &&
      //   document.documentElement.scrollTop ||
      //   document.body.scrollTop

      // document.body.style.top = `-${this.overlayOffset}px`
      // document.body.style.position = 'fixed'
      document.documentElement.style.overflow = 'hidden';
    },
    showScroll: function showScroll() {
      document.documentElement.removeAttribute('style');

      // if (!this.overlayOffset) return
      // document.body.scrollTop = this.overlayOffset
      // document.documentElement.scrollTop = this.overlayOffset
    }
  }
});

/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-list',

  provide: function provide() {
    return {
      listClick: this.listClick,
      listClose: this.listClose
    };
  },


  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  data: function data() {
    return {
      uid: null,
      groups: []
    };
  },


  props: {
    dense: Boolean,
    subheader: Boolean,
    threeLine: Boolean,
    twoLine: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'list': true,
        'list--two-line': this.twoLine,
        'list--dense': this.dense,
        'list--three-line': this.threeLine,
        'list--subheader': this.subheader,
        'theme--dark dark--bg': this.dark,
        'theme--light light--bg': this.light
      };
    }
  },

  watch: {
    uid: function uid() {
      var _this = this;

      this.$children.filter(function (i) {
        return i.$options._componentTag === 'v-list-group';
      }).forEach(function (i) {
        return i.toggle(_this.uid);
      });
    }
  },

  methods: {
    listClick: function listClick(uid, force) {
      if (force) {
        this.uid = uid;
      } else {
        this.uid = this.uid === uid ? null : uid;
      }
    },
    listClose: function listClose(uid) {
      if (this.uid === uid) {
        this.uid = null;
      }
    }
  },

  render: function render(h) {
    var data = {
      'class': this.classes,
      attrs: { 'data-uid': this._uid }
    };

    return h('ul', data, [this.$slots.default]);
  }
});

/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_route_link__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__directives__ = __webpack_require__(4);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-list-tile',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_route_link__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */]],

  directives: {
    Ripple: __WEBPACK_IMPORTED_MODULE_2__directives__["Ripple"]
  },

  inheritAttrs: false,

  props: {
    activeClass: {
      type: String,
      default: 'list__tile--active'
    },
    avatar: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'list__tile': true,
        'list__tile--avatar': this.avatar,
        'list__tile--disabled': this.disabled
      };
    }
  },

  render: function render(h) {
    var _generateRouteLink = this.generateRouteLink(),
        tag = _generateRouteLink.tag,
        data = _generateRouteLink.data;

    data.attrs = Object.assign({}, data.attrs, this.$attrs);

    return h('li', {
      attrs: {
        disabled: this.disabled
      }
    }, [h(tag, data, [this.$slots.default])]);
  }
});

/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function directive(e, el, binding, v) {
  var cb = function cb() {
    return true;
  };

  if (binding.value) cb = binding.value;

  if (v.context.isActive && e && e.target && e.target !== el && !el.contains(e.target) && cb(e)) {
    v.context.isActive = false;
  }
}

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: function bind(el, binding, v) {
    v.context.$vuetify.load(function () {
      var outside = document.querySelector('[data-app]');
      var click = function click(e) {
        return directive(e, el, binding, v);
      };
      outside.addEventListener('click', click, false);
      el._clickOutside = click;
    });
  },
  unbind: function unbind(el) {
    var outside = document.querySelector('[data-app]');
    outside && outside.removeEventListener('click', el._clickOutside, false);
  }
});

/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function style(el, value) {
  ['transform', 'webkitTransform'].forEach(function (i) {
    el.style[i] = value;
  });
}

var ripple = {
  show: function show(e, el, _ref) {
    var _ref$value = _ref.value,
        value = _ref$value === undefined ? {} : _ref$value;

    var container = document.createElement('span');
    var animation = document.createElement('span');

    container.appendChild(animation);
    container.className = 'ripple__container';

    if (value.class) {
      container.className += ' ' + value.class;
    }

    var size = el.clientWidth > el.clientHeight ? el.clientWidth : el.clientHeight;
    animation.className = 'ripple__animation';
    animation.style.width = size * (value.center ? 1 : 2) + 'px';
    animation.style.height = animation.style.width;

    el.appendChild(container);
    var computed = window.getComputedStyle(el);
    if (computed.position !== 'absolute' && computed.position !== 'fixed') el.style.position = 'relative';

    var offset = el.getBoundingClientRect();
    var x = value.center ? '50%' : e.clientX - offset.left + 'px';
    var y = value.center ? '50%' : e.clientY - offset.top + 'px';

    animation.classList.add('ripple__animation--enter');
    animation.classList.add('ripple__animation--visible');
    style(animation, 'translate(-50%, -50%) translate(' + x + ', ' + y + ') scale3d(0.01,0.01,0.01)');
    animation.dataset.activated = Date.now();

    setTimeout(function () {
      animation.classList.remove('ripple__animation--enter');
      style(animation, 'translate(-50%, -50%) translate(' + x + ', ' + y + ')  scale3d(0.99,0.99,0.99)');
    }, 0);
  },

  hide: function hide(el) {
    var ripples = el.getElementsByClassName('ripple__animation');

    if (ripples.length === 0) return;
    var animation = ripples[ripples.length - 1];
    var diff = Date.now() - Number(animation.dataset.activated);
    var delay = 400 - diff;

    delay = delay < 0 ? 0 : delay;

    setTimeout(function () {
      animation.classList.remove('ripple__animation--visible');

      setTimeout(function () {
        // Need to figure out a new way to do this
        try {
          if (ripples.length < 1) el.style.position = null;
          animation.parentNode && el.removeChild(animation.parentNode);
        } catch (e) {}
      }, 300);
    }, delay);
  }
};

function directive(el, binding, v) {
  if (binding.value === false) return;

  if ('ontouchstart' in window) {
    el.addEventListener('touchend', function () {
      return ripple.hide(el);
    }, false);
    el.addEventListener('touchcancel', function () {
      return ripple.hide(el);
    }, false);
  }

  el.addEventListener('mousedown', function (e) {
    return ripple.show(e, el, binding);
  }, false);
  el.addEventListener('mouseup', function () {
    return ripple.hide(el);
  }, false);
  el.addEventListener('mouseleave', function () {
    return ripple.hide(el);
  }, false);
}

function unbind(el, binding) {
  el.removeEventListener('touchstart', function (e) {
    return ripple.show(e, el, binding);
  }, false);
  el.removeEventListener('mousedown', function (e) {
    return ripple.show(e, el, binding);
  }, false);
  el.removeEventListener('touchend', function () {
    return ripple.hide(el);
  }, false);
  el.removeEventListener('touchcancel', function () {
    return ripple.hide(el);
  }, false);
  el.removeEventListener('mouseup', function () {
    return ripple.hide(el);
  }, false);
  el.removeEventListener('mouseleave', function () {
    return ripple.hide(el);
  }, false);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: directive,
  unbind: unbind
});

/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  name: 'list-tile-action',

  render: function render(h, _ref) {
    var data = _ref.data,
        children = _ref.children;

    data.staticClass = data.staticClass ? 'list__tile__action ' + (data.staticClass || '') : 'list__tile__action';
    if ((children || []).length > 1) data.staticClass += ' list__tile__action--stack';

    return h('div', data, children);
  }
});

/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_activator__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_detachable__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_generators__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_position__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_utils__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_toggleable__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_keyable__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__directives__ = __webpack_require__(4);










/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-menu',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_activator__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_detachable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_generators__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__mixins_keyable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_position__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_utils__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__mixins_toggleable__["a" /* default */]],

  directives: {
    ClickOutside: __WEBPACK_IMPORTED_MODULE_7__directives__["ClickOutside"]
  },

  data: function data() {
    return {
      autoIndex: null,
      dimensions: {
        activator: {
          top: 0, left: 0,
          bottom: 0, right: 0,
          width: 0, height: 0,
          offsetTop: 0, scrollHeight: 0
        },
        content: {
          top: 0, left: 0,
          bottom: 0, right: 0,
          width: 0, height: 0,
          offsetTop: 0, scrollHeight: 0
        },
        list: null,
        selected: null
      },
      direction: { vert: 'bottom', horiz: 'right' },
      isContentActive: false,
      isBooted: false,
      maxHeightAutoDefault: '200px',
      resizeTimeout: {},
      startIndex: 3,
      stopIndex: 0,
      tileLength: 0,
      window: {},
      absoluteX: 0,
      absoluteY: 0,
      hasJustFocused: false,
      focusedTimeout: {}
    };
  },


  props: {
    top: Boolean,
    left: Boolean,
    bottom: Boolean,
    right: Boolean,
    fullWidth: Boolean,
    auto: Boolean,
    offsetX: Boolean,
    offsetY: Boolean,
    disabled: Boolean,
    maxHeight: {
      default: 'auto'
    },
    nudgeTop: {
      type: Number,
      default: 0
    },
    nudgeBottom: {
      type: Number,
      default: 0
    },
    nudgeLeft: {
      type: Number,
      default: 0
    },
    nudgeRight: {
      type: Number,
      default: 0
    },
    nudgeWidth: {
      type: Number,
      default: 0
    },
    openOnClick: {
      type: Boolean,
      default: true
    },
    openOnHover: {
      type: Boolean,
      default: false
    },
    lazy: Boolean,
    closeOnClick: {
      type: Boolean,
      default: true
    },
    closeOnContentClick: {
      type: Boolean,
      default: true
    },
    activator: {
      default: null
    },
    origin: {
      type: String,
      default: 'top left'
    },
    transition: {
      type: String,
      default: 'menu-transition'
    },
    positionX: {
      type: Number,
      default: null
    },
    positionY: {
      type: Number,
      default: null
    },
    positionAbsolutely: {
      type: Boolean,
      default: false
    },
    maxWidth: [Number, String],
    minWidth: [Number, String]
  },

  computed: {
    calculatedMinWidth: function calculatedMinWidth() {
      var minWidth = parseInt(this.minWidth) || this.dimensions.activator.width + this.nudgeWidth + (this.auto ? 16 : 0);

      if (!this.maxWidth) return minWidth;

      var maxWidth = parseInt(this.maxWidth);

      return maxWidth < minWidth ? maxWidth : minWidth;
    },
    styles: function styles() {
      return {
        maxHeight: this.auto ? '200px' : isNaN(this.maxHeight) ? this.maxHeight : this.maxHeight + 'px',
        minWidth: this.calculatedMinWidth + 'px',
        maxWidth: parseInt(this.maxWidth) + 'px',
        top: this.calcTop() + 'px',
        left: this.calcLeft() + 'px'
      };
    },
    hasActivator: function hasActivator() {
      return !!this.$slots.activator || this.activator;
    }
  },

  watch: {
    activator: function activator(newActivator, oldActivator) {
      this.removeActivatorEvents(oldActivator);
      this.addActivatorEvents(newActivator);
    },
    disabled: function disabled(val) {
      val && this.deactivate();
    },
    hasJustFocused: function hasJustFocused(val) {
      var _this = this;

      if (!val) return;

      clearTimeout(this.focusedTimeout);
      this.focusedTimeout = setTimeout(function () {
        return _this.hasJustFocused = false;
      }, 550);
    },
    isActive: function isActive(val) {
      if (this.disabled) return;

      val && this.activate() || this.deactivate();
    },
    windowResizeHandler: function windowResizeHandler() {
      this.isBooted = false;
    }
  },

  mounted: function mounted() {
    window.addEventListener('resize', this.onResize, { passive: true });
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.onResize, { passive: true });
    window.removeEventListener('resize', this.windowResizeHandler);
  },


  methods: {
    activate: function activate() {
      if (typeof window === 'undefined') return;
      this.isBooted = true;
      this.getTiles();
      this.updateDimensions();
      requestAnimationFrame(this.startTransition);
      this.$emit('activate');
    },
    deactivate: function deactivate() {
      this.isContentActive = false;
      this.$emit('deactivate');
    },
    onResize: function onResize() {
      clearTimeout(this.resizeTimeout);
      if (!this.isActive) return;
      this.resizeTimeout = setTimeout(this.updateDimensions, 200);
    },
    startTransition: function startTransition() {
      var _this2 = this;

      requestAnimationFrame(function () {
        return _this2.isContentActive = true;
      });
      requestAnimationFrame(this.calculateScroll);
    }
  },

  render: function render(h) {
    var _this3 = this;

    var data = {
      'class': 'menu',
      style: {
        display: this.fullWidth ? 'block' : 'inline-block'
      },
      directives: [{
        name: 'click-outside',
        value: function value() {
          return _this3.closeOnClick;
        }
      }],
      on: {
        keydown: function keydown(e) {
          if (e.keyCode === 27) _this3.isActive = false;else _this3.changeListIndex(e);
        }
      }
    };

    return h('div', data, [this.genActivator(), this.genTransition()]);
  }
});

/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_transitions__ = __webpack_require__(6);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-progress-linear',

  components: {
    VFadeTransition: __WEBPACK_IMPORTED_MODULE_0__components_transitions__["b" /* VFadeTransition */],
    VSlideXTransition: __WEBPACK_IMPORTED_MODULE_0__components_transitions__["c" /* VSlideXTransition */]
  },

  props: {
    active: {
      type: Boolean,
      default: true
    },
    buffer: Boolean,
    bufferValue: Number,
    error: Boolean,
    height: {
      type: [Number, String],
      default: 7
    },
    indeterminate: Boolean,
    info: Boolean,
    secondary: Boolean,
    success: Boolean,
    query: Boolean,
    warning: Boolean,
    value: {
      type: [Number, String],
      default: 0
    },
    colorFront: {
      type: String,
      default: null
    },
    colorBack: {
      type: String,
      default: null
    }
  },

  computed: {
    classes: function classes() {
      return {
        'progress-linear--query': this.query,
        'progress-linear--secondary': this.secondary,
        'progress-linear--success': this.success,
        'progress-linear--info': this.info,
        'progress-linear--warning': this.warning,
        'progress-linear--error': this.error
      };
    },
    styles: function styles() {
      var styles = {};

      if (!this.active) {
        styles.height = 0;
      }

      if (this.buffer) {
        styles.width = this.bufferValue + '%';
      }

      return styles;
    },
    bufferStyles: function bufferStyles() {
      var styles = {};

      if (!this.active) {
        styles.height = 0;
      }

      return styles;
    }
  },

  methods: {
    genDeterminate: function genDeterminate(h) {
      return h('div', {
        ref: 'front',
        class: ['progress-linear__bar__determinate', this.colorFront],
        style: { width: this.value + '%' }
      });
    },
    genBar: function genBar(h, name) {
      return h('div', {
        class: ['progress-linear__bar__indeterminate', name, this.colorFront]
      });
    },
    genIndeterminate: function genIndeterminate(h) {
      return h('div', {
        ref: 'front',
        class: {
          'progress-linear__bar__indeterminate': true,
          'progress-linear__bar__indeterminate--active': this.active
        }
      }, [this.genBar(h, 'long'), this.genBar(h, 'short')]);
    }
  },

  render: function render(h) {
    var fade = h('v-fade-transition', [this.indeterminate && this.genIndeterminate(h)]);
    var slide = h('v-slide-x-transition', [!this.indeterminate && this.genDeterminate(h)]);

    var bar = h('div', { class: ['progress-linear__bar', this.colorBack], style: this.styles }, [fade, slide]);

    return h('div', {
      class: ['progress-linear', this.classes],
      style: { height: this.height + 'px' },
      on: this.$listeners
    }, [bar]);
  }
});

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_autocomplete__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_filterable__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_generators__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_input__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_cards_VCard__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_selection_controls_VCheckbox__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_icons_VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_lists_VList__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_lists_VListTile__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_lists_VListTileAction__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_lists__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_menus_VMenu__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__directives_click_outside__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__util_helpers__ = __webpack_require__(0);



















/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-select',

  components: {
    VCard: __WEBPACK_IMPORTED_MODULE_4__components_cards_VCard__["a" /* default */],
    VCheckbox: __WEBPACK_IMPORTED_MODULE_5__components_selection_controls_VCheckbox__["a" /* default */],
    VIcon: __WEBPACK_IMPORTED_MODULE_6__components_icons_VIcon__["a" /* default */],
    VList: __WEBPACK_IMPORTED_MODULE_7__components_lists_VList__["a" /* default */],
    VListTile: __WEBPACK_IMPORTED_MODULE_8__components_lists_VListTile__["a" /* default */],
    VListTileAction: __WEBPACK_IMPORTED_MODULE_9__components_lists_VListTileAction__["a" /* default */],
    VListTileContent: __WEBPACK_IMPORTED_MODULE_10__components_lists__["a" /* VListTileContent */],
    VListTileTitle: __WEBPACK_IMPORTED_MODULE_10__components_lists__["b" /* VListTileTitle */],
    VMenu: __WEBPACK_IMPORTED_MODULE_11__components_menus_VMenu__["a" /* default */]
  },

  directives: {
    clickOutside: __WEBPACK_IMPORTED_MODULE_12__directives_click_outside__["a" /* default */]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_autocomplete__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_input__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_filterable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_generators__["a" /* default */]],

  data: function data() {
    return {
      content: {},
      hasFocused: false,
      inputValue: this.multiple && !this.value ? [] : this.value,
      isBooted: false,
      lastItem: 20,
      isActive: false,
      searchInputValue: this.searchInput
    };
  },


  props: {
    appendIcon: {
      type: String,
      default: 'arrow_drop_down'
    },
    auto: Boolean,
    autocomplete: Boolean,
    bottom: Boolean,
    chips: Boolean,
    close: Boolean,
    debounce: {
      type: Number,
      default: 200
    },
    items: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    filter: Function,
    itemText: {
      type: String,
      default: 'text'
    },
    itemValue: {
      type: String,
      default: 'value'
    },
    itemDisabled: {
      type: String,
      default: 'disabled'
    },
    maxHeight: {
      type: [Number, String],
      default: 300
    },
    minWidth: {
      type: [Boolean, Number, String],
      default: false
    },
    multiple: Boolean,
    multiLine: Boolean,
    offset: Boolean,
    searchInput: null,
    singleLine: Boolean,
    top: Boolean,
    returnObject: Boolean,
    overflow: Boolean,
    segmented: Boolean,
    editable: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'input-group--text-field input-group--select': true,
        'input-group--auto': this.auto,
        'input-group--overflow': this.overflow,
        'input-group--segmented': this.segmented,
        'input-group--editable': this.editable,
        'input-group--autocomplete': this.autocomplete,
        'input-group--single-line': this.singleLine || this.isDropdown,
        'input-group--multi-line': this.multiLine,
        'input-group--chips': this.chips,
        'input-group--multiple': this.multiple
      };
    },
    computedContentClass: function computedContentClass() {
      var children = [this.auto ? 'menu__content--auto' : '', this.isDropdown ? 'menu__content--dropdown' : ''];

      return children.join(' ');
    },
    filteredItems: function filteredItems() {
      var items = this.autocomplete && this.searchValue ? this.filterSearch() : this.items;

      return !this.auto ? items.slice(0, this.lastItem) : items;
    },
    hasError: function hasError() {
      return this.validations.length || this.error || this.hasFocused && !this.focused && !this.isDirty && this.required;
    },
    isDirty: function isDirty() {
      return this.selectedItems.length;
    },
    isDropdown: function isDropdown() {
      return this.segmented || this.overflow || this.editable;
    },

    searchValue: {
      get: function get() {
        return this.searchInput || this.searchInputValue;
      },
      set: function set(val) {
        this.searchInputValue = val;
        this.$emit('update:searchInput', val);
      }
    },
    selectedItems: function selectedItems() {
      var _this = this;

      if (this.inputValue === null || typeof this.inputValue === 'undefined') return [];

      return this.items.filter(function (i) {
        if (!_this.multiple) {
          return _this.getValue(i) === _this.getValue(_this.inputValue);
        } else {
          // Always return Boolean
          return _this.inputValue.find(function (j) {
            return _this.getValue(j) === _this.getValue(i);
          }) !== undefined;
        }
      });
    }
  },

  watch: {
    inputValue: function inputValue(val) {
      this.$emit('input', val);
    },
    value: function value(val) {
      this.inputValue = val;
      this.validate();
      if (this.autocomplete || this.editable) {
        this.$nextTick(this.$refs.menu.updateDimensions);
      }
    },
    isActive: function isActive(val) {
      this.isBooted = true;
      this.lastItem += !val ? 20 : 0;

      if (!val) this.blur();else this.focus();
    },
    isBooted: function isBooted() {
      var _this2 = this;

      this.$nextTick(function () {
        if (_this2.content) {
          _this2.content.addEventListener('scroll', _this2.onScroll, false);
        }
      });
    },
    searchValue: function searchValue() {
      this.$refs.menu.listIndex = -1;
    }
  },

  mounted: function mounted() {
    var _this3 = this;

    this.$vuetify.load(function () {
      if (_this3._isDestroyed) return;

      _this3.content = _this3.$refs.menu.$refs.content;
    });
  },
  beforeDestroy: function beforeDestroy() {
    if (this.isBooted) {
      if (this.content) {
        this.content.removeEventListener('scroll', this.onScroll, false);
      }
    }
  },


  methods: {
    blur: function blur() {
      var _this4 = this;

      this.$nextTick(function () {
        _this4.focused = false;
        _this4.hasFocused = true;
        _this4.searchValue = null;
        _this4.$el.blur();
      });
    },
    focus: function focus() {
      var _this5 = this;

      this.focused = true;
      this.$refs.input && (this.autocomplete || this.editable) && this.$refs.input.focus();

      if (this.editable && this.inputValue !== null && typeof this.inputValue !== 'undefined') {
        this.$nextTick(function () {
          _this5.$refs.input.value = _this5.getValue(_this5.inputValue);
        });
      }
    },
    genLabel: function genLabel() {
      if (this.searchValue && !this.focused && this.isDirty) return null;

      var data = {};

      if (this.id) data.attrs = { for: this.id };

      return this.$createElement('label', data, this.label);
    },
    getPropertyFromItem: function getPropertyFromItem(item, field) {
      if (item !== Object(item)) return item;

      var value = Object(__WEBPACK_IMPORTED_MODULE_13__util_helpers__["g" /* getObjectValueByPath */])(item, field);

      return typeof value === 'undefined' ? item : value;
    },
    getText: function getText(item) {
      return this.getPropertyFromItem(item, this.itemText);
    },
    getValue: function getValue(item) {
      return this.getPropertyFromItem(item, this.itemValue);
    },
    onScroll: function onScroll() {
      var _this6 = this;

      if (!this.isActive) {
        requestAnimationFrame(function () {
          return _this6.content.scrollTop = 0;
        });
      } else {
        var showMoreItems = this.content.scrollHeight - (this.content.scrollTop + this.content.clientHeight) < 200;

        if (showMoreItems) {
          this.lastItem += 20;
        }
      }
    },
    selectItem: function selectItem(item) {
      var _this7 = this;

      if (!this.multiple) {
        this.inputValue = this.returnObject ? item : this.getValue(item);
      } else {
        var inputValue = this.inputValue.slice();
        var i = this.inputValue.findIndex(function (i) {
          return _this7.getValue(i) === _this7.getValue(item);
        });

        i !== -1 && inputValue.splice(i, 1) || inputValue.push(item);
        this.inputValue = inputValue.map(function (i) {
          return _this7.returnObject ? i : _this7.getValue(i);
        });
      }

      if (this.autocomplete || this.editable) {
        this.$nextTick(function () {
          _this7.searchValue = null;
          _this7.$refs.input && _this7.$refs.input.focus();
        });
      }

      this.$emit('change', this.inputValue);
    }
  },

  render: function render(h) {
    var _this8 = this;

    return this.genInputGroup([this.genSelectionsAndSearch(), this.genMenu()], {
      ref: 'activator',
      directives: [{
        name: 'click-outside',
        value: function value() {
          return _this8.isActive = false;
        }
      }],
      on: {
        keydown: this.onKeyDown // Located in mixins/autocomplete.js
      }
    });
  }
});

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    noDataText: {
      type: String,
      default: 'No data available'
    }
  }
});

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_selectable__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__directives_ripple__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_transitions__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_icons_VIcon__ = __webpack_require__(3);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-checkbox',

  components: {
    VFadeTransition: __WEBPACK_IMPORTED_MODULE_2__components_transitions__["b" /* VFadeTransition */],
    VIcon: __WEBPACK_IMPORTED_MODULE_3__components_icons_VIcon__["a" /* default */]
  },

  directives: {
    Ripple: __WEBPACK_IMPORTED_MODULE_1__directives_ripple__["a" /* default */]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_selectable__["a" /* default */]],

  data: function data() {
    return {
      inputIndeterminate: this.indeterminate
    };
  },


  props: {
    indeterminate: Boolean
  },

  computed: {
    classes: function classes() {
      return this.addColorClassChecks({
        'checkbox': true,
        'input-group--selection-controls': true,
        'input-group--active': this.isActive
      });
    },
    icon: function icon() {
      if (this.inputIndeterminate) {
        return 'indeterminate_check_box';
      } else if (this.isActive) {
        return 'check_box';
      } else {
        return 'check_box_outline_blank';
      }
    }
  },

  render: function render(h) {
    var transition = h('v-fade-transition', [h('v-icon', {
      'class': {
        'icon--checkbox': this.icon === 'check_box'
      },
      key: this.icon
    }, this.icon)]);

    var ripple = h('div', {
      'class': 'input-group--selection-controls__ripple',
      on: Object.assign({}, {
        click: this.toggle
      }, this.$listeners),
      directives: [{
        name: 'ripple',
        value: { center: true }
      }]
    });

    var data = {
      attrs: {
        role: 'checkbox',
        'aria-checked': this.inputIndeterminate && 'mixed' || this.isActive && 'true' || 'false',
        'aria-label': this.label
      }
    };

    return this.genInputGroup([transition, ripple], data);
  }
});

/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colorable__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__input__ = __webpack_require__(7);



/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_1__input__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__colorable__["a" /* default */]],

  model: {
    prop: 'inputValue',
    event: 'change'
  },

  props: {
    inputValue: null,
    falseValue: null,
    trueValue: null
  },

  computed: {
    isActive: function isActive() {
      if (Array.isArray(this.inputValue)) {
        return this.inputValue.indexOf(this.value) !== -1;
      }

      if (!this.trueValue || !this.falseValue) {
        return this.value ? this.value === this.inputValue : Boolean(this.inputValue);
      }

      return this.inputValue === this.trueValue;
    }
  },

  watch: {
    indeterminate: function indeterminate(val) {
      this.inputIndeterminate = val;
    }
  },

  methods: {
    genLabel: function genLabel() {
      return this.$createElement('label', {
        on: { click: this.toggle },
        attrs: {
          for: this.$attrs.id
        }
      }, this.$slots.label || this.label);
    },
    toggle: function toggle() {
      if (this.disabled) {
        return;
      }

      var input = this.inputValue;
      if (Array.isArray(input)) {
        input = input.slice();
        var i = input.indexOf(this.value);

        if (i === -1) {
          input.push(this.value);
        } else {
          input.splice(i, 1);
        }
      } else if (this.trueValue || this.falseValue) {
        input = input === this.trueValue ? this.falseValue : this.trueValue;
      } else if (this.value) {
        input = this.value === this.inputValue ? null : this.value;
      } else {
        input = !input;
      }

      this.$emit('change', input);
    }
  }
});

/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    color: String
  },
  methods: {
    addColorClassChecks: function addColorClassChecks(classes) {
      var parts = this.color ? this.color.trim().split(' ') : [''];
      var color = parts[0] + '--text';
      if (parts.length > 1) color += ' text--' + parts[1];
      classes[color] = !!this.color;
      return classes;
    }
  }
});

/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__package_json__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__package_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__package_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__directives__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_load__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_semver__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_semver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_semver__);
__webpack_require__(30);







function plugin(Vue) {
  Object.keys(__WEBPACK_IMPORTED_MODULE_1__components__["a" /* default */]).forEach(function (key) {
    Vue.component(key, __WEBPACK_IMPORTED_MODULE_1__components__["a" /* default */][key]);
  });

  Object.keys(__WEBPACK_IMPORTED_MODULE_2__directives__).forEach(function (key) {
    Vue.directive(key, __WEBPACK_IMPORTED_MODULE_2__directives__[key]);
  });

  Vue.prototype.$vuetify = {
    load: __WEBPACK_IMPORTED_MODULE_3__util_load__["a" /* default */]
  };
}

function checkVueVersion() {
  var vueDep = __WEBPACK_IMPORTED_MODULE_0__package_json__["devDependencies"].vue;
  if (!__WEBPACK_IMPORTED_MODULE_4_semver___default.a.satisfies(window.Vue.version, vueDep)) {
    console.warn('Vuetify requires Vue version ' + vueDep);
  }
}

if (typeof window !== 'undefined' && window.Vue) {
  if (window.Vue.version) {
    checkVueVersion();
  }
  window.Vue.use(plugin);
}

/* harmony default export */ __webpack_exports__["default"] = (plugin);

/***/ }),
/* 30 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 31 */
/***/ (function(module, exports) {

module.exports = {
	"name": "vuetify",
	"version": "0.14.10",
	"author": {
		"name": "John Leider",
		"email": "john.j.leider@gmail.com"
	},
	"license": "MIT",
	"homepage": "http://vuetifyjs.com",
	"main": "dist/vuetify.js",
	"types": "index.d.ts",
	"scripts": {
		"watch": "cross-env TARGET=dev webpack --config build/config.js --progress --hide-modules --watch",
		"dev": "cross-env NODE_ENV=development webpack-dev-server --config build/webpack.dev.config.js --open --hot",
		"build": "rimraf dist && cross-env NODE_ENV=production node build/build.js --progress --hide-modules",
		"debug-build": "node --inspect --debug-brk build/build.js",
		"test": "cross-env NODE_ENV=test jest --no-cache --verbose",
		"test-coverage": "cross-env NODE_ENV=test jest --no-cache --coverage --verbose",
		"lint": "eslint --ext .js,.vue src"
	},
	"description": "Vue.js 2 Semantic Component Framework",
	"devDependencies": {
		"autoprefixer": "^6.6.0",
		"avoriaz": "^3.2.0",
		"babel-cli": "^6.24.1",
		"babel-core": "^6.24.1",
		"babel-eslint": "^7.1.1",
		"babel-jest": "^20.0.3",
		"babel-loader": "^7.1.1",
		"babel-plugin-add-filehash": "^6.9.4",
		"babel-plugin-module-resolver": "^2.7.1",
		"babel-plugin-transform-async-to-generator": "^6.24.1",
		"babel-plugin-transform-runtime": "^6.23.0",
		"babel-preset-env": "^1.5.1",
		"babel-preset-es2015": "^6.24.1",
		"babel-preset-stage-2": "^6.24.1",
		"chalk": "^1.1.3",
		"chromedriver": "^2.21.2",
		"cross-env": "^3.1.3",
		"cross-spawn": "^4.0.2",
		"css-loader": "^0.23.1",
		"css-mqpacker": "^6.0.1",
		"cssnano": "^3.10.0",
		"eslint": "^3.7.1",
		"eslint-config-standard": "^6.1.0",
		"eslint-config-vue": "^2.0.2",
		"eslint-friendly-formatter": "^2.0.5",
		"eslint-loader": "^1.6.1",
		"eslint-plugin-html": "^1.3.0",
		"eslint-plugin-promise": "^3.4.0",
		"eslint-plugin-pug": "^1.0.0",
		"eslint-plugin-standard": "^3.0.1",
		"eslint-plugin-vue": "^2.1.0",
		"eventsource-polyfill": "^0.9.6",
		"extract-text-webpack-plugin": "^3.0.0",
		"friendly-errors-webpack-plugin": "^1.6.1",
		"function-bind": "^1.0.2",
		"jest": "^20.0.4",
		"jest-cli": "^20.0.4",
		"jest-css-modules": "^1.1.0",
		"jest-serializer-html": "^4.0.0",
		"jest-vue-preprocessor": "^0.2.0",
		"lolex": "^1.4.0",
		"nightwatch": "^0.9.8",
		"opn": "^4.0.2",
		"optimize-css-assets-webpack-plugin": "^2.0.0",
		"optimize-js-plugin": "^0.0.4",
		"ora": "^0.3.0",
		"phantomjs-prebuilt": "^2.1.3",
		"postcss-loader": "^1.2.1",
		"precss": "^1.4.0",
		"pug": "^2.0.0-beta3",
		"pug-loader": "^2.3.0",
		"ress": "^1.1.1",
		"rimraf": "^2.5.4",
		"selenium-server": "2.53.1",
		"semver": "^5.3.0",
		"serialize-javascript": "^1.3.0",
		"shelljs": "^0.7.4",
		"style-loader": "^0.13.1",
		"stylus": "^0.54.5",
		"stylus-loader": "^2.1.1",
		"uglifyjs-webpack-plugin": "^0.4.6",
		"vue": "^2.4.1",
		"vue-loader": "^10.1.0",
		"vue-router": "^2.7.0",
		"vue-server-renderer": "^2.4.1",
		"vue-template-compiler": "^2.4.1",
		"webpack": "^3.2.0",
		"webpack-bundle-size-analyzer": "^2.7.0",
		"webpack-dev-server": "^2.6.1",
		"webpack-merge": "^4.1.0"
	},
	"dependencies": {},
	"engines": {
		"node": ">= 4.0.0",
		"npm": ">= 3.0.0"
	},
	"jest": {
		"verbose": false,
		"roots": [
			"<rootDir>/src"
		],
		"moduleFileExtensions": [
			"js",
			"vue"
		],
		"moduleDirectories": [
			"node_modules"
		],
		"moduleNameMapper": {
			"src/(.*)": "<rootDir>/src/$1"
		},
		"transform": {
			".*\\.(vue)$": "<rootDir>/node_modules/jest-vue-preprocessor",
			"\\.(styl)$": "<rootDir>/node_modules/jest-css-modules",
			".*\\.(vue|js)$": "<rootDir>/node_modules/babel-jest"
		},
		"transformIgnorePatterns": [
			"node_modules/(?!vue-router)"
		],
		"snapshotSerializers": [
			"jest-serializer-html"
		]
	}
};

/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__alerts__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__app__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__avatars__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bottom_nav__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__breadcrumbs__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__buttons__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__cards__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__carousel__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__chips__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pickers__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__dialogs__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__dividers__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__expansion_panel__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__footer__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__grid__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__icons__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__lists__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__menus__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__navigation_drawer__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__toolbar__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__pagination__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__parallax__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__progress__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__selects__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__selection_controls__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__sliders__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__subheaders__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__steppers__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__tables__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__tabs__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__text_fields__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__transitions__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__snackbars__ = __webpack_require__(129);


































/* harmony default export */ __webpack_exports__["a"] = (Object.assign({}, __WEBPACK_IMPORTED_MODULE_0__alerts__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__app__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__avatars__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__bottom_nav__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__breadcrumbs__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__buttons__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__cards__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__carousel__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__chips__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9__pickers__["a" /* default */], __WEBPACK_IMPORTED_MODULE_10__dialogs__["a" /* default */], __WEBPACK_IMPORTED_MODULE_11__dividers__["a" /* default */], __WEBPACK_IMPORTED_MODULE_12__expansion_panel__["a" /* default */], __WEBPACK_IMPORTED_MODULE_13__footer__["a" /* default */], __WEBPACK_IMPORTED_MODULE_14__grid__["a" /* default */], __WEBPACK_IMPORTED_MODULE_15__icons__["a" /* default */], __WEBPACK_IMPORTED_MODULE_16__lists__["c" /* default */], __WEBPACK_IMPORTED_MODULE_17__menus__["a" /* default */], __WEBPACK_IMPORTED_MODULE_18__navigation_drawer__["a" /* default */], __WEBPACK_IMPORTED_MODULE_19__toolbar__["a" /* default */], __WEBPACK_IMPORTED_MODULE_20__pagination__["a" /* default */], __WEBPACK_IMPORTED_MODULE_21__parallax__["a" /* default */], __WEBPACK_IMPORTED_MODULE_22__progress__["a" /* default */], __WEBPACK_IMPORTED_MODULE_23__selects__["a" /* default */], __WEBPACK_IMPORTED_MODULE_24__selection_controls__["a" /* default */], __WEBPACK_IMPORTED_MODULE_25__sliders__["a" /* default */], __WEBPACK_IMPORTED_MODULE_26__subheaders__["a" /* default */], __WEBPACK_IMPORTED_MODULE_27__steppers__["a" /* default */], __WEBPACK_IMPORTED_MODULE_28__tables__["a" /* default */], __WEBPACK_IMPORTED_MODULE_29__tabs__["a" /* default */], __WEBPACK_IMPORTED_MODULE_30__text_fields__["a" /* default */], __WEBPACK_IMPORTED_MODULE_31__transitions__["d" /* default */], __WEBPACK_IMPORTED_MODULE_32__snackbars__["a" /* default */]));

/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VAlert__ = __webpack_require__(34);


/* harmony default export */ __webpack_exports__["a"] = ({
  VAlert: __WEBPACK_IMPORTED_MODULE_0__VAlert__["a" /* default */]
});

/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_transitionable__ = __webpack_require__(35);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-alert',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_transitionable__["a" /* default */]],

  props: {
    dismissible: Boolean,
    hideIcon: Boolean,
    icon: String
  },

  computed: {
    classes: function classes() {
      return {
        'alert': true,
        'alert--dismissible': this.dismissible,
        'error': this.error,
        'info': this.info,
        'primary': this.primary,
        'secondary': this.secondary,
        'success': this.success,
        'warning': this.warning
      };
    },
    mdIcon: function mdIcon() {
      switch (true) {
        case !!this.icon:
          return this.icon;
        case this.error:
          return 'warning';
        case this.info:
          return 'info';
        case this.success:
          return 'check_circle';
        case this.warning:
          return 'priority_high';
      }
    }
  },

  render: function render(h) {
    var _this = this;

    var children = [h('div', this.$slots.default)];

    if (!this.hideIcon && this.mdIcon) {
      children.unshift(h('v-icon', {
        'class': 'alert__icon'
      }, this.mdIcon));
    }

    if (this.dismissible) {
      var close = h('a', {
        'class': 'alert__dismissible',
        domProps: { href: 'javascript:;' },
        on: { click: function click() {
            return _this.$emit('input', false);
          } }
      }, [h('v-icon', {
        props: { right: true }
      }, 'cancel')]);

      children.push(close);
    }

    var alert = h('div', {
      'class': this.classes,
      directives: [{
        name: 'show',
        value: this.isActive
      }],
      on: this.$listeners
    }, children);

    if (!this.transition) return alert;

    return h('transition', {
      props: {
        name: this.transition,
        origin: this.origin,
        mode: this.mode
      }
    }, [alert]);
  }
});

/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    mode: String,
    origin: String,
    transition: String
  }
});

/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VApp__ = __webpack_require__(37);


/* harmony default export */ __webpack_exports__["a"] = ({
  VApp: __WEBPACK_IMPORTED_MODULE_0__VApp__["a" /* default */]
});

/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    fixedFooter: Boolean,
    footer: Boolean,
    id: {
      type: String,
      default: 'app'
    },
    toolbar: Boolean
  },

  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        children = _ref.children;

    data.staticClass = ('application ' + (data.staticClass || '')).trim();
    data.staticClass += ' application--' + (props.dark ? 'dark' : 'light');

    props.footer && (data.staticClass += ' application--footer');
    props.fixedFooter && (data.staticClass += ' application--footer-fixed');
    props.toolbar && (data.staticClass += ' application--toolbar');

    data.attrs = { 'data-app': true };
    data.domProps = { id: props.id };

    return h('div', data, children);
  }
});

/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VAvatar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


var VAvatar = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('avatar');

/* harmony default export */ __webpack_exports__["a"] = ({
  VAvatar: VAvatar
});

/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VBottomNav__ = __webpack_require__(40);


/* harmony default export */ __webpack_exports__["a"] = ({
  VBottomNav: __WEBPACK_IMPORTED_MODULE_0__VBottomNav__["a" /* default */]
});

/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  props: {
    absolute: Boolean,
    shift: Boolean,
    value: { required: false }
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('bottom-nav ' + (data.staticClass || '')).trim();

    if (props.absolute) data.staticClass += ' bottom-nav--absolute';
    if (props.shift) data.staticClass += ' bottom-nav--shift';
    if (props.value) data.staticClass += ' bottom-nav--active';

    return h('div', data, children);
  }
});

/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VBreadcrumbs__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VBreadcrumbsItem__ = __webpack_require__(43);



/* harmony default export */ __webpack_exports__["a"] = ({
  VBreadcrumbs: __WEBPACK_IMPORTED_MODULE_0__VBreadcrumbs__["a" /* default */],
  VBreadcrumbsItem: __WEBPACK_IMPORTED_MODULE_1__VBreadcrumbsItem__["a" /* default */]
});

/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-breadcrumbs',

  provide: function provide() {
    return {
      divider: this.divider
    };
  },


  props: {
    divider: {
      type: String,
      default: '/'
    },
    icons: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'breadcrumbs': true,
        'breadcrumbs--with-icons': this.icons
      };
    }
  },

  render: function render(h) {
    return h('ul', {
      'class': this.classes,
      props: { items: this.items }
    }, this.$slots.default);
  }
});

/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_route_link__ = __webpack_require__(9);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-breadcrumbs-item',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_route_link__["a" /* default */]],

  inject: ['divider'],

  props: {
    activeClass: {
      type: String,
      default: 'breadcrumbs__item--active'
    }
  },

  computed: {
    classes: function classes() {
      var classes = _defineProperty({
        'breadcrumbs__item': true
      }, this.activeClass, !this.disabled);

      return classes;
    }
  },

  render: function render(h) {
    var _generateRouteLink = this.generateRouteLink(),
        tag = _generateRouteLink.tag,
        data = _generateRouteLink.data;

    return h('li', {
      attrs: { 'data-divider': this.divider }
    }, [h(tag, data, this.$slots.default)]);
  }
});

/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VBtnToggle__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VSpeedDial__ = __webpack_require__(46);




/* harmony default export */ __webpack_exports__["a"] = ({
  VBtn: __WEBPACK_IMPORTED_MODULE_0__VBtn__["a" /* default */],
  VBtnToggle: __WEBPACK_IMPORTED_MODULE_1__VBtnToggle__["a" /* default */],
  VSpeedDial: __WEBPACK_IMPORTED_MODULE_2__VSpeedDial__["a" /* default */]
});

/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_buttons_VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_icons_VIcon__ = __webpack_require__(3);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-btn-toggle',

  model: {
    prop: 'inputValue',
    event: 'change'
  },

  props: {
    inputValue: {
      required: false
    },
    items: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    mandatory: Boolean,
    multiple: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'btn-toggle': true,
        'btn-toggle--selected': this.inputValue && (!this.multiple || this.inputValue.length)
      };
    }
  },

  methods: {
    isSelected: function isSelected(item) {
      if (!this.multiple) {
        return this.inputValue === item.value;
      }

      return this.inputValue.includes(item.value);
    },
    updateValue: function updateValue(item) {
      if (!this.multiple) {
        if (this.mandatory && this.inputValue === item.value) return;
        return this.$emit('change', this.inputValue === item.value ? null : item.value);
      }

      var items = this.inputValue.slice();

      var i = items.indexOf(item.value);
      if (i > -1) {
        items.length >= 1 && !this.mandatory && items.splice(i, 1);
      } else {
        items.push(item.value);
      }

      this.$emit('change', items);
    }
  },

  render: function render(h) {
    var _this = this;

    var buttons = this.items.map(function (item, index) {
      var children = [];

      item.text && children.push(h('span', item.text));
      item.icon && children.push(h(__WEBPACK_IMPORTED_MODULE_1__components_icons_VIcon__["a" /* default */], item.icon));

      return h(__WEBPACK_IMPORTED_MODULE_0__components_buttons_VBtn__["a" /* default */], {
        key: index,
        props: {
          flat: true
        },
        on: {
          click: function click(e) {
            e.stopPropagation();
            _this.updateValue(item);
          }
        },
        attrs: {
          'data-selected': _this.isSelected(item),
          'data-index': index,
          'data-only-child': _this.isSelected(item) && (!_this.multiple || _this.inputValue.length === 1)
        }
      }, children);
    });

    return h('div', { class: this.classes }, buttons);
  }
});

/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_toggleable__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_positionable__ = __webpack_require__(12);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-speed-dial',

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_positionable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__mixins_toggleable__["a" /* default */]],

  props: {
    direction: {
      type: String,
      default: 'top',
      validator: function validator(val) {
        return ['top', 'right', 'bottom', 'left'].includes(val);
      }
    },
    hover: Boolean,
    transition: {
      type: String,
      default: 'scale-transition'
    }
  },

  computed: {
    classes: function classes() {
      return _defineProperty({
        'speed-dial': true,
        'speed-dial--top': this.top,
        'speed-dial--right': this.right,
        'speed-dial--bottom': this.bottom,
        'speed-dial--left': this.left,
        'speed-dial--absolute': this.absolute,
        'speed-dial--fixed': this.fixed
      }, 'speed-dial--direction-' + this.direction, true);
    }
  },

  render: function render(h) {
    var _this = this;

    var children = [];
    var data = {
      'class': this.classes,
      directives: [{
        name: 'click-outside'
      }],
      on: {
        click: function click() {
          return _this.isActive = !_this.isActive;
        }
      }
    };

    if (this.hover) {
      data.on.mouseenter = function () {
        return _this.isActive = true;
      };
      data.on.mouseleave = function () {
        return _this.isActive = false;
      };
    }

    if (this.isActive) {
      children = (this.$slots.default || []).map(function (b, i) {
        b.key = i;

        return b;
      });
    }

    var list = h('transition-group', {
      'class': 'speed-dial__list',
      props: {
        name: this.transition,
        tag: 'div'
      }
    }, children);

    return h('div', data, [this.$slots.activator, list]);
  }
});

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VCard__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VCardMedia__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VCardTitle__ = __webpack_require__(49);





var VCardActions = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('card__actions');
var VCardText = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('card__text');

/* harmony default export */ __webpack_exports__["a"] = ({
  VCard: __WEBPACK_IMPORTED_MODULE_1__VCard__["a" /* default */],
  VCardActions: VCardActions,
  VCardMedia: __WEBPACK_IMPORTED_MODULE_2__VCardMedia__["a" /* default */],
  VCardText: VCardText,
  VCardTitle: __WEBPACK_IMPORTED_MODULE_3__VCardTitle__["a" /* default */]
});

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-card-media',

  props: {
    contain: Boolean,
    height: {
      type: [Number, String],
      default: 'auto'
    },
    src: {
      type: String
    }
  },

  render: function render(h) {
    var data = {
      'class': 'card__media',
      style: {
        height: !isNaN(this.height) ? this.height + 'px' : this.height
      },
      on: this.$listeners
    };

    var children = [];

    if (this.src) {
      children.push(h('div', {
        'class': 'card__media__background',
        style: {
          background: 'url(' + this.src + ') center center / ' + (this.contain ? 'contain' : 'cover') + ' no-repeat'
        }
      }));
    }

    children.push(h('div', {
      'class': 'card__media__content'
    }, this.$slots.default));

    return h('div', data, children);
  }
});

/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  props: {
    primaryTitle: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('card__title ' + (data.staticClass || '')).trim();

    if (props.primaryTitle) data.staticClass += ' card__title--primary';

    return h('div', data, children);
  }
});

/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VCarousel__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VCarouselItem__ = __webpack_require__(52);



/* harmony default export */ __webpack_exports__["a"] = ({
  VCarousel: __WEBPACK_IMPORTED_MODULE_0__VCarousel__["a" /* default */],
  VCarouselItem: __WEBPACK_IMPORTED_MODULE_1__VCarouselItem__["a" /* default */]
});

/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_bootable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_buttons_VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_icons_VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__ = __webpack_require__(1);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-carousel',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_bootable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__["a" /* default */]],

  data: function data() {
    return {
      current: null,
      items: [],
      slideInterval: {},
      reverse: false
    };
  },


  props: {
    cycle: {
      type: Boolean,
      default: true
    },
    icon: {
      type: String,
      default: 'fiber_manual_record'
    },
    interval: {
      type: Number,
      default: 6000
    },
    leftControlIcon: {
      type: [Boolean, String],
      default: 'chevron_left'
    },
    rightControlIcon: {
      type: [Boolean, String],
      default: 'chevron_right'
    }
  },

  computed: {
    defaultState: function defaultState() {
      return {
        current: null,
        reverse: false
      };
    }
  },

  watch: {
    current: function current() {
      var _this = this;

      // Evaluate items when current changes to account for
      // dynamic changing of children
      this.items = this.$children.filter(function (i) {
        return i.$el.classList && i.$el.classList.contains('carousel__item');
      });

      this.items.forEach(function (i) {
        return i.open(_this.items[_this.current]._uid, _this.reverse);
      });

      !this.isBooted && this.cycle && this.restartInterval();
      this.isBooted = true;
    },
    cycle: function cycle(val) {
      val && this.restartInterval() || clearInterval(this.slideInterval);
    }
  },

  mounted: function mounted() {
    this.init();
  },


  methods: {
    genControls: function genControls() {
      return this.$createElement('div', {
        staticClass: 'carousel__controls'
      }, this.genItems());
    },
    genIcon: function genIcon(direction, icon, fn) {
      if (!icon) return null;

      return this.$createElement('div', {
        staticClass: 'carousel__' + direction
      }, [this.$createElement(__WEBPACK_IMPORTED_MODULE_1__components_buttons_VBtn__["a" /* default */], {
        props: {
          icon: true,
          dark: this.dark || !this.light,
          light: this.light
        },
        on: { click: fn }
      }, [this.$createElement(__WEBPACK_IMPORTED_MODULE_2__components_icons_VIcon__["a" /* default */], icon)])]);
    },
    genItems: function genItems() {
      var _this2 = this;

      return this.items.map(function (item, index) {
        return _this2.$createElement(__WEBPACK_IMPORTED_MODULE_1__components_buttons_VBtn__["a" /* default */], {
          class: {
            'carousel__controls__item': true,
            'carousel__controls__item--active': index === _this2.current
          },
          props: {
            icon: true,
            dark: _this2.dark || !_this2.light,
            light: _this2.light
          },
          key: index,
          on: { click: _this2.select.bind(_this2, index) }
        }, [_this2.$createElement(__WEBPACK_IMPORTED_MODULE_2__components_icons_VIcon__["a" /* default */], _this2.icon)]);
      });
    },
    restartInterval: function restartInterval() {
      clearInterval(this.slideInterval);
      this.$nextTick(this.startInterval);
    },
    init: function init() {
      this.current = 0;
    },
    next: function next() {
      this.reverse = false;

      if (this.current + 1 === this.items.length) {
        return this.current = 0;
      }

      this.current++;
    },
    prev: function prev() {
      this.reverse = true;

      if (this.current - 1 < 0) {
        return this.current = this.items.length - 1;
      }

      this.current--;
    },
    select: function select(index) {
      this.reverse = index < this.current;
      this.current = index;
    },
    startInterval: function startInterval() {
      this.slideInterval = setInterval(this.next, this.interval);
    }
  },

  render: function render(h) {
    return h('div', {
      staticClass: 'carousel',
      directives: [{
        name: 'touch',
        value: {
          left: this.next,
          right: this.prev
        }
      }]
    }, [this.genIcon('left', this.leftControlIcon, this.prev), this.genIcon('right', this.rightControlIcon, this.next), this.genControls(), this.$slots.default]);
  }
});

/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-carousel-item',

  data: function data() {
    return {
      active: false,
      reverse: false
    };
  },


  props: {
    src: {
      type: String,
      required: true
    },

    transition: {
      type: String,
      default: 'tab-transition'
    },

    reverseTransition: {
      type: String,
      default: 'tab-reverse-transition'
    }
  },

  computed: {
    computedTransition: function computedTransition() {
      return this.reverse ? this.reverseTransition : this.transition;
    },
    styles: function styles() {
      return {
        backgroundImage: 'url(' + this.src + ')'
      };
    }
  },

  methods: {
    open: function open(id, reverse) {
      this.active = this._uid === id;
      this.reverse = reverse;
    }
  },

  render: function render(h) {
    var item = h('div', {
      class: {
        'carousel__item': true,
        'reverse': this.reverse
      },
      style: this.styles,
      on: this.$listeners,
      directives: [{
        name: 'show',
        value: this.active
      }]
    }, [this.$slots.default]);

    return h('transition', { props: { name: this.computedTransition } }, [item]);
  }
});

/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VChip__ = __webpack_require__(54);


/* harmony default export */ __webpack_exports__["a"] = ({
  VChip: __WEBPACK_IMPORTED_MODULE_0__VChip__["a" /* default */]
});

/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_toggleable__ = __webpack_require__(2);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-chip',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_toggleable__["a" /* default */]],

  props: {
    close: Boolean,
    label: Boolean,
    outline: Boolean,
    small: Boolean,
    value: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    classes: function classes() {
      return {
        'chip': true,
        'chip--label': this.label,
        'chip--outline': this.outline,
        'chip--small': this.small,
        'chip--removable': this.close
      };
    }
  },

  render: function render(h) {
    var _this = this;

    var children = [this.$slots.default];
    var data = {
      'class': this.classes,
      attrs: { tabindex: -1 },
      directives: [{
        name: 'show',
        value: this.isActive
      }],
      on: this.$listeners
    };

    if (this.close) {
      children.push(h('a', {
        'class': 'chip__close',
        domProps: { href: 'javascript:;' },
        on: {
          click: function click(e) {
            e.stopPropagation();

            _this.$emit('input', false);
          }
        }
      }, [h('v-icon', { props: { right: true } }, 'cancel')]));
    }

    return h('span', data, children);
  }
});

/***/ }),
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VDatePicker__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VTimePicker__ = __webpack_require__(61);



/* harmony default export */ __webpack_exports__["a"] = ({
  VDatePicker: __WEBPACK_IMPORTED_MODULE_0__VDatePicker__["a" /* default */],
  VTimePicker: __WEBPACK_IMPORTED_MODULE_1__VTimePicker__["a" /* default */]
});

/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_date_title__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_date_header__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_date_table__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_date_years__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_picker__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_helpers__ = __webpack_require__(0);







var defaultDateFormat = function defaultDateFormat(val) {
  return new Date(val).toISOString().substr(0, 10);
};

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-date-picker',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_date_title__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_date_header__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_date_table__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_date_years__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_picker__["a" /* default */]],

  data: function data() {
    return {
      tableDate: new Date(),
      originalDate: this.value,
      currentDay: null,
      currentMonth: null,
      currentYear: null,
      isSelected: false,
      isReversing: false,
      narrowDays: []
    };
  },


  props: {
    locale: {
      type: String,
      default: 'en-us'
    },
    dateFormat: {
      type: Function,
      default: defaultDateFormat
    },
    titleDateFormat: {
      type: Object,
      default: function _default() {
        return { weekday: 'short', month: 'short', day: 'numeric' };
      }
    },
    headerDateFormat: {
      type: Object,
      default: function _default() {
        return { month: 'long', year: 'numeric' };
      }
    },
    formattedValue: {
      required: false
    },
    allowedDates: {
      type: [Array, Object, Function],
      default: function _default() {
        return null;
      }
    },
    firstDayOfWeek: {
      type: [String, Number],
      default: 0
    },
    yearIcon: String
  },

  computed: {
    firstAllowedDate: function firstAllowedDate() {
      var date = new Date();
      date.setHours(12, 0, 0, 0);

      if (this.allowedDates) {
        var millisecondOffset = 1 * 24 * 60 * 60 * 1000;
        var valid = new Date(date);
        for (var i = 0; i < 31; i++) {
          if (this.isAllowed(valid)) return valid;

          valid.setTime(valid.getTime() + millisecondOffset);
        }
      }

      return date;
    },

    inputDate: {
      get: function get() {
        if (!this.value) return this.firstAllowedDate;
        if (this.value instanceof Date) return this.value;
        if (!isNaN(this.value) || typeof this.value === 'string' && this.value.indexOf(':') !== -1) return new Date(this.value);

        return new Date(this.value + 'T12:00:00');
      },
      set: function set(val) {
        this.$emit('input', val ? defaultDateFormat(val) : this.originalDate);
        this.$emit('update:formattedValue', val ? this.dateFormat(val) : this.dateFormat(this.originalDate));
      }
    },
    day: function day() {
      return this.inputDate.getDate();
    },
    month: function month() {
      return this.inputDate.getMonth();
    },
    year: function year() {
      return this.inputDate.getFullYear();
    },
    tableMonth: function tableMonth() {
      return this.tableDate.getMonth();
    },
    tableYear: function tableYear() {
      return this.tableDate.getFullYear();
    },
    computedTransition: function computedTransition() {
      return this.isReversing ? 'v-tab-reverse-transition' : 'v-tab-transition';
    }
  },

  watch: {
    isSelected: function isSelected(val) {
      var _this = this;

      val && this.$nextTick(function () {
        _this.$refs.years.scrollTop = _this.$refs.years.scrollHeight / 2 - 125;
      });
    },
    tableDate: function tableDate(val, prev) {
      this.isReversing = val < prev;
    },
    value: function value(val) {
      if (val) this.tableDate = this.inputDate;
    }
  },

  methods: {
    save: function save() {
      if (this.originalDate) {
        this.originalDate = this.value;
      } else {
        this.originalDate = this.inputDate;
      }

      if (this.$parent && this.$parent.isActive) this.$parent.isActive = false;
    },
    cancel: function cancel() {
      this.inputDate = this.originalDate;
      if (this.$parent && this.$parent.isActive) this.$parent.isActive = false;
    },
    isAllowed: function isAllowed(date) {
      if (!this.allowedDates) return true;

      if (Array.isArray(this.allowedDates)) {
        return !!this.allowedDates.find(function (allowedDate) {
          var d = new Date(allowedDate);
          d.setHours(12, 0, 0, 0);

          return d - date === 0;
        });
      } else if (this.allowedDates instanceof Function) {
        return this.allowedDates(date);
      } else if (this.allowedDates instanceof Object) {
        var min = new Date(this.allowedDates.min);
        min.setHours(12, 0, 0, 0);
        var max = new Date(this.allowedDates.max);
        max.setHours(12, 0, 0, 0);

        return date >= min && date <= max;
      }

      return true;
    }
  },

  created: function created() {
    var _this2 = this;

    var date = new Date();
    date.setDate(date.getDate() - date.getDay() + parseInt(this.firstDayOfWeek));

    Object(__WEBPACK_IMPORTED_MODULE_5__util_helpers__["c" /* createRange */])(7).forEach(function () {
      var narrow = date.toLocaleString(_this2.locale, { weekday: 'narrow' });
      _this2.narrowDays.push(narrow);

      date.setDate(date.getDate() + 1);
    });
  },
  mounted: function mounted() {
    this.currentDay = this.tableDate.getDate();
    this.currentMonth = this.tableDate.getMonth();
    this.currentYear = this.tableDate.getFullYear();
    this.tableDate = this.inputDate;
  },
  render: function render(h) {
    var children = [];

    !this.noTitle && children.push(this.genTitle());

    if (!this.isSelected) {
      var bodyChildren = [];

      bodyChildren.push(this.genHeader());
      bodyChildren.push(this.genTable());

      children.push(h('div', {
        'class': 'picker__body'
      }, bodyChildren));
    } else {
      children.push(this.genYears());
    }

    this.$scopedSlots.default && children.push(this.genSlot());

    return h('v-card', {
      'class': {
        'picker picker--date': true,
        'picker--landscape': this.landscape,
        'picker--dark': this.dark,
        'picker--light': this.light && !this.dark
      }
    }, children);
  }
});

/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genYearIcon: function genYearIcon() {
      return this.yearIcon ? this.$createElement('v-icon', {
        props: {
          dark: true
        }
      }, this.yearIcon) : null;
    },
    genTitle: function genTitle() {
      var _this = this;

      var date = new Date(this.year, this.month, this.day);
      date = date.toLocaleString(this.locale, this.titleDateFormat);

      if (this.landscape) {
        if (date.indexOf(',') > -1) date = date.replace(',', ',<br>');else if (date.indexOf(' ') > -1) date = date.replace(' ', '<br>');
      }

      var text = this.$createElement('transition', {
        props: {
          name: 'slide-x-transition',
          mode: 'out-in'
        }
      }, [this.$createElement('div', {
        domProps: { innerHTML: date },
        key: date
      })]);

      return this.$createElement('div', {
        'class': 'picker__title'
      }, [this.$createElement('div', {
        'class': {
          'picker--date__title-year': true,
          'active': this.isSelected
        },
        on: {
          click: function click(e) {
            e.stopPropagation();
            _this.isSelected = true;
          }
        }
      }, [this.year, this.genYearIcon()]), this.$createElement('div', {
        'class': {
          'picker--date__title-date': true,
          'active': !this.isSelected
        },
        on: {
          click: function click(e) {
            e.stopPropagation();
            _this.isSelected = false;
          }
        }
      }, [text])]);
    }
  }
});

/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genHeader: function genHeader() {
      return this.$createElement('div', {
        'class': 'picker--date__header'
      }, [this.genSelector()]);
    },
    genBtn: function genBtn(change, children) {
      var _this = this;

      return this.$createElement('v-btn', {
        props: {
          dark: this.dark,
          icon: true
        },
        nativeOn: {
          click: function click(e) {
            e.stopPropagation();
            _this.tableDate = new Date(_this.tableYear, change);
          }
        }
      }, children);
    },
    genSelector: function genSelector() {
      var date = new Date(this.tableYear, this.tableMonth);
      var header = this.$createElement('div', {
        'class': 'picker--date__header-selector-date'
      }, [this.$createElement(this.computedTransition, [this.$createElement('strong', {
        key: this.tableMonth
      }, date.toLocaleString(this.locale, this.headerDateFormat))])]);

      return this.$createElement('div', {
        'class': 'picker--date__header-selector'
      }, [this.genBtn(this.tableMonth - 1, [this.$createElement('v-icon', 'chevron_left')]), header, this.genBtn(this.tableMonth + 1, [this.$createElement('v-icon', 'chevron_right')])]);
    }
  }
});

/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    wheelScroll: function wheelScroll(e) {
      e.preventDefault();

      var month = this.tableMonth;

      if (e.deltaY < 0) month++;else month--;

      this.tableDate = new Date(this.tableYear, month);
    },
    touch: function touch(value) {
      this.tableDate = new Date(this.tableYear, this.tableMonth + value);
    },
    genTable: function genTable() {
      var _this = this;

      var children = [];
      var data = {
        'class': 'picker--date__table',
        directives: [{
          name: 'touch',
          value: {
            left: function left(e) {
              return e.offsetX < -15 && _this.touch(1);
            },
            right: function right(e) {
              return e.offsetX > 15 && _this.touch(-1);
            }
          }
        }]
      };

      if (this.scrollable) {
        data.on = { wheel: this.wheelScroll };
      }

      children.push(this.$createElement('table', {
        key: this.tableMonth
      }, [this.genTHead(), this.genTBody()]));

      return this.$createElement('div', data, [this.$createElement(this.computedTransition, children)]);
    },
    genTHead: function genTHead() {
      var _this2 = this;

      var days = this.narrowDays.map(function (day) {
        return _this2.$createElement('th', day);
      });
      return this.$createElement('thead', this.genTR(days));
    },
    genTBody: function genTBody() {
      var _this3 = this;

      var children = [];
      var rows = [];
      var length = new Date(this.tableYear, this.tableMonth + 1, 0).getDate();

      var day = new Date(this.tableYear, this.tableMonth).getDay() - parseInt(this.firstDayOfWeek);

      for (var i = 0; i < day; i++) {
        rows.push(this.$createElement('td'));
      }

      var _loop = function _loop(_i) {
        var date = new Date(_this3.tableYear, _this3.tableMonth, _i, 12, 0, 0, 0);
        rows.push(_this3.$createElement('td', [_this3.$createElement('button', {
          'class': {
            'btn btn--floating btn--small btn--flat': true,
            'btn--active': _this3.isActive(_i),
            'btn--current': _this3.isCurrent(_i),
            'btn--light': _this3.dark,
            'btn--disabled': !_this3.isAllowed(date)
          },
          attrs: {
            type: 'button'
          },
          domProps: {
            innerHTML: '<span class="btn__content">' + _i + '</span>'
          },
          on: {
            click: function click() {
              var day = _i < 10 ? '0' + _i : _i;
              var tableYear = _this3.tableYear;
              var tableMonth = _this3.tableMonth + 1;
              tableMonth = tableMonth < 10 ? '0' + tableMonth : tableMonth;

              _this3.inputDate = tableYear + '-' + tableMonth + '-' + day + 'T12:00:00';
              _this3.$nextTick(function () {
                return _this3.autosave && _this3.save();
              });
            }
          }
        })]));

        if (rows.length % 7 === 0) {
          children.push(_this3.genTR(rows));
          rows = [];
        }
      };

      for (var _i = 1; _i <= length; _i++) {
        _loop(_i);
      }

      if (rows.length) {
        children.push(this.genTR(rows));
      }

      children.length < 6 && children.push(this.genTR([this.$createElement('td', { domProps: { innerHTML: '&nbsp;' } })]));

      return this.$createElement('tbody', children);
    },
    genTR: function genTR() {
      var children = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return [this.$createElement('tr', data, children)];
    },
    isActive: function isActive(i) {
      return this.tableYear === this.year && this.tableMonth === this.month && this.day === i;
    },
    isCurrent: function isCurrent(i) {
      return this.currentYear === this.tableYear && this.currentMonth === this.tableMonth && this.currentDay === i;
    }
  }
});

/***/ }),
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genYears: function genYears() {
      return this.$createElement('ul', {
        'class': 'picker--date__years',
        ref: 'years'
      }, this.genYearItems());
    },
    genYearItems: function genYearItems() {
      var _this = this;

      var children = [];

      var _loop = function _loop(i, length) {
        children.push(_this.$createElement('li', {
          'class': {
            active: _this.year === i
          },
          on: {
            click: function click(e) {
              e.stopPropagation();

              var tableMonth = _this.tableMonth + 1;
              var day = _this.day;
              tableMonth = tableMonth < 10 ? '0' + tableMonth : tableMonth;
              day = day < 10 ? '0' + day : day;

              _this.inputDate = i + '-' + tableMonth + '-' + day;
              _this.isSelected = false;
            }
          }
        }, i));
      };

      for (var i = this.year + 100, length = this.year - 100; i > length; i--) {
        _loop(i, length);
      }
      return children;
    }
  }
});

/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_picker__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_time_title__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_time_body__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_helpers__ = __webpack_require__(0);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-time-picker',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_picker__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_time_body__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_time_title__["a" /* default */]],

  data: function data() {
    return {
      isDragging: false,
      rotate: 0,
      originalTime: this.value,
      period: 'am',
      selectingHour: true,
      ranges: {
        hours: Object(__WEBPACK_IMPORTED_MODULE_3__util_helpers__["c" /* createRange */])(24),
        minutes: Object(__WEBPACK_IMPORTED_MODULE_3__util_helpers__["c" /* createRange */])(60)
      }
    };
  },


  props: {
    format: {
      type: String,
      default: 'ampm',
      validator: function validator(val) {
        return ['ampm', '24hr'].includes(val);
      }
    },
    allowedHours: {
      type: [Array, Object, Function],
      default: function _default() {
        return null;
      }
    },
    allowedMinutes: {
      type: [Array, Object, Function],
      default: function _default() {
        return null;
      }
    }
  },

  computed: {
    is24hr: function is24hr() {
      return this.format !== 'ampm';
    },
    is24hrAfter12: function is24hrAfter12() {
      return this.selectingHour && this.is24hr && this.hour >= 12;
    },
    divider: function divider() {
      return this.selectingHour ? 12 : 60;
    },
    degrees: function degrees() {
      return this.degreesPerUnit * Math.PI / 180;
    },
    degreesPerUnit: function degreesPerUnit() {
      return 360 / this.divider;
    },

    inputTime: {
      get: function get() {
        if (this.value && !(this.value instanceof Date)) {
          if (!this.is24hr) {
            this.period = this.value.match(/pm/) ? 'pm' : 'am';
          }

          return this.value;
        }
        var value = new Date();

        if (this.value instanceof Date) {
          value = this.value;
        }

        var hour = value.getHours();
        var minute = value.getMinutes();
        var period = '';

        if (!this.is24hr) {
          hour = hour > 12 ? hour - 12 : hour;
          period = hour > 12 ? 'pm' : 'am';
        }

        period && (this.period = period);

        hour = this.firstAllowed('hour', hour);
        minute = this.firstAllowed('minute', minute);

        return hour + ':' + minute + period;
      },
      set: function set(val) {
        return this.$emit('input', val);
      }
    },
    timeArray: function timeArray() {
      return this.inputTime.replace(/(am|pm)/, '').split(':');
    },

    hour: {
      get: function get() {
        return parseInt(this.timeArray[0]);
      },
      set: function set(val) {
        if (!this.is24hr) {
          val = val > 12 ? val - 12 : val < 1 ? 12 : val;
        } else {
          val = val < 10 ? '0' + val : val > 23 ? '00' : val;
        }

        this.inputTime = val + ':' + this.minute + (!this.is24hr ? this.period : '');
      }
    },
    minute: {
      get: function get() {
        var minute = parseInt(this.timeArray[1]);

        return minute < 10 ? '0' + minute : minute > 59 ? '00' : minute;
      },
      set: function set(val) {
        val = val < 10 ? '0' + parseInt(val) : val > 59 ? '00' : val;
        var hour = this.hour;

        if (this.is24hr && hour < 10) {
          hour = '0' + hour;
        }

        this.inputTime = hour + ':' + val + (!this.is24hr ? this.period : '');
      }
    },
    clockHand: function clockHand() {
      if (this.selectingHour) return this.degreesPerUnit * this.hour;
      return this.degreesPerUnit * this.minute;
    },
    radius: function radius() {
      return this.clockSize / 2;
    },

    clockSize: {
      get: function get() {
        return this.size;
      },
      set: function set(val) {
        this.size = val;
      }
    },
    size: function size() {
      return this.landscape ? 250 : 280;
    }
  },

  watch: {
    period: function period(val) {
      var hour = !!this.allowedHours && this.selectingHour ? this.firstAllowed('hour', this.hour - 1) : this.hour;
      this.inputTime = hour + ':' + this.minute + val;
    },
    value: function value(val) {
      if (this.isSaving) {
        this.originalTime = this.inputTime;
        this.isSaving = false;
      }
    }
  },

  methods: {
    save: function save() {
      if (this.originalTime) {
        this.originalTime = this.value;
      } else {
        this.inputTime = this.inputTime;
        this.originalTime = this.inputTime;
      }

      if (this.$parent && this.$parent.isActive) this.$parent.isActive = false;
    },
    cancel: function cancel() {
      this.inputTime = this.originalTime;
      if (this.$parent && this.$parent.isActive) this.$parent.isActive = false;
    },
    isAllowed: function isAllowed(type, value) {
      var allowed = this['allowed' + (type.charAt(0).toUpperCase() + type.slice(1)) + 's'];

      if (!allowed) return true;

      if (Array.isArray(allowed)) {
        return !!allowed.find(function (v) {
          return v === value;
        });
      } else if (allowed instanceof Function) {
        return allowed(value);
      } else if (allowed === Object(allowed)) {
        var range = type === 'minute' ? this.ranges.minutes : this.ranges.hours;
        var mod = type === 'minute' ? 60 : 24;

        if (allowed.min === String(allowed.min)) {
          allowed.min = this.convert12to24hr(allowed.min);
        }

        if (allowed.max === String(allowed.max)) {
          allowed.max = this.convert12to24hr(allowed.max);
        }

        var steps = allowed.max - allowed.min;
        value = type === 'hour' && !this.is24hr && this.period === 'pm' ? value + 12 : value;

        for (var i = 0; i <= steps; i++) {
          var index = (allowed.min + i) % mod;
          if (range[index] === value) return true;
        }

        return false;
      }

      return true;
    },
    convert12to24hr: function convert12to24hr(input) {
      input = input.toLowerCase();
      var pm = input.indexOf('pm') !== -1;
      var hour = parseInt(input.slice(0, input.indexOf(pm ? 'pm' : 'am')));

      return pm ? hour + 12 : hour;
    },
    generateRange: function generateRange(type, start) {
      var range = type === 'hour' ? this.ranges.hours : this.ranges.minutes;
      var offset = 1;

      if (type === 'hour' && !this.is24hr) {
        range = range.slice(1, 13);
        offset = 0;
      }

      return range.slice(start + offset, range.length).concat(range.slice(0, start + offset));
    },
    firstAllowed: function firstAllowed(type, value) {
      var _this = this;

      var allowed = this['allowed' + (type.charAt(0).toUpperCase() + type.slice(1)) + 's'];

      if (!allowed) return value;

      var range = this.generateRange(type, value);

      var first = range.find(function (v) {
        return _this.isAllowed(type, v);
      });

      return first || value;
    }
  },

  render: function render(h) {
    var children = [this.genBody()];

    !this.noTitle && children.unshift(this.genTitle());
    this.$scopedSlots.default && children.push(this.genSlot());

    return h('v-card', {
      'class': {
        'picker picker--time': true,
        'picker--landscape': this.landscape,
        'picker--dark': this.dark,
        'picker--light': this.light && !this.dark,
        'picker--time--hours': this.selectingHour
      }
    }, children);
  }
});

/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genTitle: function genTitle() {
      var children = [this.genTime()];

      if (this.format === 'ampm') {
        children.push(this.genAMPM());
      }

      return this.$createElement('div', {
        'class': 'picker__title'
      }, children);
    },
    genTime: function genTime() {
      var _this = this;

      var hour = this.hour;

      if (this.is24hr && hour < 10) {
        hour = '0' + hour;
      }

      return this.$createElement('div', {
        'class': 'picker--time__title'
      }, [this.$createElement('span', {
        'class': { active: this.selectingHour },
        on: {
          click: function click() {
            return _this.selectingHour = true;
          }
        }
      }, hour), this.$createElement('span', {
        'class': { active: !this.selectingHour },
        on: {
          click: function click() {
            return _this.selectingHour = false;
          }
        }
      }, ':' + this.minute)]);
    },
    genAMPM: function genAMPM() {
      return this.$createElement('div', [this.genPeriod('am'), this.genPeriod('pm')]);
    },
    genPeriod: function genPeriod(period) {
      var _this2 = this;

      return this.$createElement('span', {
        'class': { active: this.period === period },
        on: { click: function click() {
            return _this2.period = period;
          } }
      }, period.toUpperCase());
    }
  }
});

/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      hasChanged: false
    };
  },

  methods: {
    genBody: function genBody() {
      var _this = this;

      var children = [this.genHand(this.selectingHour ? 'hour' : 'minute')];
      var data = {
        'class': 'picker--time__clock',
        on: {
          mousedown: this.onMouseDown,
          mouseup: this.onMouseUp,
          mouseleave: function mouseleave() {
            _this.isDragging && _this.onMouseUp();
          },
          touchstart: this.onMouseDown,
          touchend: this.onMouseUp,
          mousemove: this.onDragMove,
          touchmove: this.onDragMove
        },
        key: this.selectingHour ? 'hour' : 'minute',
        ref: 'clock'
      };

      this.selectingHour && children.push(this.genHours()) || children.push(this.genMinutes());

      if (this.scrollable) {
        data.on.wheel = function (e) {
          e.preventDefault();

          var diff = e.wheelDelta > 0 ? 1 : -1;
          var changing = _this.selectingHour ? 'changeHour' : 'changeMinute';

          _this[changing](diff);
        };
      }

      return this.$createElement('div', {
        'class': 'picker__body'
      }, [this.$createElement('v-fade-transition', {
        props: { mode: 'out-in' }
      }, [this.$createElement('div', data, children)])]);
    },
    genHand: function genHand(type) {
      var scale = this.is24hrAfter12 ? 'scaleY(0.6)' : '';
      return [this.$createElement('div', {
        'class': 'picker--time__clock-hand ' + type,
        style: {
          transform: 'rotate(' + this.clockHand + 'deg) ' + scale
        }
      })];
    },
    genHours: function genHours() {
      var hours = this.is24hr ? 24 : 12;
      var children = [];
      var start = 0;

      if (hours === 12) {
        hours++;
        start = 1;
      }

      for (var i = start; i < hours; i++) {
        children.push(this.$createElement('span', {
          'class': {
            'active': i === this.hour,
            'disabled': !this.isAllowed('hour', i)
          },
          style: this.getTransform(i),
          domProps: { innerHTML: '<span>' + i + '</span>' }
        }));
      }

      return children;
    },
    genMinutes: function genMinutes() {
      var children = [];

      for (var i = 0; i < 60; i = i + 5) {
        var num = i;

        if (num < 10) num = '0' + num;
        if (num === 60) num = '00';

        children.push(this.$createElement('span', {
          'class': {
            'active': num.toString() === this.minute.toString(),
            'disabled': !this.isAllowed('minute', i)
          },
          style: this.getTransform(i),
          domProps: { innerHTML: '<span>' + num + '</span>' }
        }));
      }

      return children;
    },
    getTransform: function getTransform(i) {
      var _getPosition = this.getPosition(i),
          x = _getPosition.x,
          y = _getPosition.y;

      return { transform: 'translate(' + x + 'px, ' + y + 'px)' };
    },
    getPosition: function getPosition(i) {
      var radiusPercentage = this.selectingHour && this.is24hr && i >= 12 ? 0.5 : 0.8;
      var r = this.radius * radiusPercentage;
      i = this.selectingHour && this.is24hr ? i % 12 : i;
      return {
        x: Math.round(Math.sin(i * this.degrees) * r),
        y: Math.round(-Math.cos(i * this.degrees) * r)
      };
    },
    changeHour: function changeHour(time) {
      var _this2 = this;

      var range = this.generateRange('hour', this.hour);

      time < 0 && (range = range.reverse().slice(1));
      this.hour = range.find(function (h) {
        return _this2.allowedHours ? _this2.isAllowed('hour', h) : true;
      });

      return true;
    },
    changeMinute: function changeMinute(time) {
      var _this3 = this;

      var current = Number(this.minute);
      var range = this.generateRange('minute', current);

      time < 0 && (range = range.reverse().slice(1));
      var minute = range.find(function (m) {
        return _this3.allowedMinutes ? _this3.isAllowed('minute', m) : true;
      });

      this.minute = minute < 10 ? '0' + minute : minute;

      return true;
    },
    onMouseDown: function onMouseDown(e) {
      e.preventDefault();

      this.isDragging = true;
      this.onDragMove(e);
    },
    onMouseUp: function onMouseUp() {
      this.isDragging = false;
      !this.selectingHour && this.autosave && this.save();
      if (this.hasChanged) {
        this.selectingHour = false;
        this.hasChanged = false;
      }
    },
    onDragMove: function onDragMove(e) {
      e.preventDefault();
      if (!this.isDragging && e.type !== 'click') return;

      var rect = this.$refs.clock.getBoundingClientRect();
      var center = { x: rect.width / 2, y: 0 - rect.width / 2 };
      var clientY = 'touches' in e ? e.touches[0].clientY : e.clientY;
      var clientX = 'touches' in e ? e.touches[0].clientX : e.clientX;
      var coords = {
        y: rect.top - clientY,
        x: clientX - rect.left
      };

      var selecting = this.selectingHour ? 'hour' : 'minute';
      var value = Math.round(this.angle(center, coords) / this.degreesPerUnit);

      if (this.selectingHour && this.is24hr) {
        var insideClick = this.euclidean(center, coords) / this.radius < 0.65;
        value = insideClick ? value + 12 : value;

        // Necessary to fix edge case when selecting left part of 0 and 12
        value = this.angle(center, coords) >= 345 ? (value + 12) % 24 : value;
      }

      if (this.isAllowed(selecting, value)) {
        this[selecting] = value;
        this.hasChanged = true;
      }
    },
    euclidean: function euclidean(p0, p1) {
      var dx = Math.abs(p1.x - p0.x);
      var dy = Math.abs(p1.y - p0.y);

      return Math.sqrt(dx * dx + dy * dy);
    },
    angle: function angle(center, p1) {
      var p0 = {
        x: center.x,
        y: center.y + Math.sqrt(Math.abs(p1.x - center.x) * Math.abs(p1.x - center.x) + Math.abs(p1.y - center.y) * Math.abs(p1.y - center.y))
      };

      var value = 2 * Math.atan2(p1.y - p0.y, p1.x - p0.x);
      return Math.abs(value * 180 / Math.PI);
    }
  }
});

/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VDialog__ = __webpack_require__(65);


/* harmony default export */ __webpack_exports__["a"] = ({
  VDialog: __WEBPACK_IMPORTED_MODULE_0__VDialog__["a" /* default */]
});

/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_bootable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_detachable__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_overlayable__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_toggleable__ = __webpack_require__(2);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-dialog',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_bootable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_detachable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_overlayable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_toggleable__["a" /* default */]],

  props: {
    disabled: Boolean,
    persistent: Boolean,
    fullscreen: Boolean,
    fullWidth: Boolean,
    lazy: Boolean,
    origin: {
      type: String,
      default: 'center center'
    },
    width: {
      type: [String, Number],
      default: 290
    },
    scrollable: Boolean,
    transition: {
      type: [String, Boolean],
      default: 'dialog-transition'
    }
  },

  computed: {
    classes: function classes() {
      return {
        'dialog': true,
        'dialog--active': this.isActive,
        'dialog--persistent': this.persistent,
        'dialog--fullscreen': this.fullscreen,
        'dialog--stacked-actions': this.stackedActions && !this.fullscreen,
        'dialog--scrollable': this.scrollable
      };
    }
  },

  watch: {
    isActive: function isActive(val) {
      if (val) {
        !this.fullscreen && !this.hideOverlay && this.genOverlay();
        this.fullscreen && this.hideScroll();
      } else {
        if (!this.fullscreen) this.removeOverlay();else this.showScroll();
      }
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.isBooted = this.isActive;
    this.$vuetify.load(function () {
      return _this.isActive && _this.genOverlay();
    });
  },


  methods: {
    closeConditional: function closeConditional(e) {
      // close dialog if !persistent and clicked outside
      return !this.persistent;
    }
  },

  render: function render(h) {
    var _this2 = this;

    var children = [];
    var data = {
      'class': this.classes,
      ref: 'dialog',
      directives: [{ name: 'click-outside', value: this.closeConditional }, { name: 'show', value: this.isActive }]
    };

    if (!this.fullscreen) {
      data.style = {
        width: isNaN(this.width) ? this.width : this.width + 'px'
      };
    }

    if (this.$slots.activator) {
      children.push(h('div', {
        'class': 'dialog__activator',
        on: {
          click: function click(e) {
            e.stopPropagation();
            if (!_this2.disabled) _this2.isActive = !_this2.isActive;
          }
        }
      }, [this.$slots.activator]));
    }

    var dialog = h('transition', {
      props: {
        name: this.transition || '', // If false, show nothing
        origin: this.origin
      }
    }, [h('div', data, this.showLazyContent(this.$slots.default))]);

    children.push(h('div', {
      'class': ('dialog__content ' + this.contentClass).trim(),
      ref: 'content'
    }, [dialog]));

    return h('div', {
      'class': 'dialog__container',
      style: {
        display: !this.$slots.activator && 'none' || this.fullWidth ? 'block' : 'inline-block'
      }
    }, children);
  }
});

/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VDivider__ = __webpack_require__(67);


/* harmony default export */ __webpack_exports__["a"] = ({
  VDivider: __WEBPACK_IMPORTED_MODULE_0__VDivider__["a" /* default */]
});

/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    inset: Boolean
  },

  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        children = _ref.children;

    data.staticClass = ('divider ' + (data.staticClass || '')).trim();

    if (props.dark) data.staticClass += ' theme--dark';
    if (props.inset) data.staticClass += ' divider--inset';
    if (props.light) data.staticClass += ' theme--light';

    return h('hr', data);
  }
});

/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VExpansionPanel__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VExpansionPanelContent__ = __webpack_require__(70);



/* harmony default export */ __webpack_exports__["a"] = ({
  VExpansionPanel: __WEBPACK_IMPORTED_MODULE_0__VExpansionPanel__["a" /* default */],
  VExpansionPanelContent: __WEBPACK_IMPORTED_MODULE_1__VExpansionPanelContent__["a" /* default */]
});

/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-expansion-panel',

  props: {
    expand: Boolean
  },

  computed: {
    params: function params() {
      return {
        expand: this.expand
      };
    }
  },

  render: function render(h) {
    return h('ul', {
      'class': 'expansion-panel'
    }, this.$slots.default);
  }
});

/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_transitions__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-expansion-panel-content',

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */]],

  data: function data() {
    return {
      height: 'auto'
    };
  },


  props: {
    ripple: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'expansion-panel__header': true,
        'expansion-panel__header--active': this.isActive
      };
    }
  },

  methods: {
    closeConditional: function closeConditional(e) {
      return this.$parent.$el.contains(e.target) && !this.$parent.expand && !this.$el.contains(e.target);
    },
    toggle: function toggle() {
      this.isActive = !this.isActive;
    },
    genHeader: function genHeader(h) {
      var _this = this;

      return h('div', {
        class: this.classes,
        directives: [{
          name: 'click-outside',
          value: this.closeConditional
        }, {
          name: 'ripple',
          value: this.ripple
        }],
        on: {
          click: function click() {
            _this.isActive = !_this.isActive;
          }
        }
      }, [this.$slots.header]);
    },
    genBody: function genBody(h) {
      return h('div', {
        ref: 'body',
        class: 'expansion-panel__body',
        directives: [{
          name: 'show',
          value: this.isActive
        }]
      }, [this.$slots.default]);
    }
  },

  render: function render(h) {
    var children = [];

    this.$slots.header && children.push(this.genHeader(h));
    children.push(h(__WEBPACK_IMPORTED_MODULE_0__components_transitions__["a" /* VExpandTransition */], [this.genBody(h)]));

    return h('li', children);
  }
});

/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


/* harmony default export */ __webpack_exports__["a"] = ({
  enter: function enter(el, done) {
    // Remove initial transition
    el.style.transition = 'none';
    Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["a" /* addOnceEventListener */])(el, 'transitionend', done);

    // Get height that is to be scrolled
    el.style.overflow = 'hidden';
    el.style.height = null;
    el.style.display = 'block';
    var height = el.clientHeight + 'px';
    el.style.height = 0;
    el.style.transition = null;

    setTimeout(function () {
      return el.style.height = height;
    }, 50);
  },
  afterEnter: function afterEnter(el) {
    el.style.height = 'auto';
    el.style.overflow = null;
  },
  leave: function leave(el, done) {
    // Remove initial transition
    el.style.transition = 'none';
    Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["a" /* addOnceEventListener */])(el, 'transitionend', done);

    // Set height before we transition to 0
    el.style.overflow = 'hidden';
    el.style.height = el.clientHeight + 'px';
    el.style.transition = null;

    setTimeout(function () {
      return el.style.height = 0;
    }, 50);
  }
});

/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VFooter__ = __webpack_require__(73);


/* harmony default export */ __webpack_exports__["a"] = ({
  VFooter: __WEBPACK_IMPORTED_MODULE_0__VFooter__["a" /* default */]
});

/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  props: {
    absolute: Boolean,
    fixed: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('footer ' + (data.staticClass || '')).trim();

    if (props.absolute) data.staticClass += ' footer--absolute';
    if (props.fixed) data.staticClass += ' footer--fixed';

    return h('footer', data, children);
  }
});

/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


var Grid = function Grid(name) {
  return {
    functional: true,

    props: {
      id: String
    },

    render: function render(h, _ref) {
      var props = _ref.props,
          data = _ref.data,
          children = _ref.children;

      data.staticClass = (name + ' ' + (data.staticClass || '')).trim();

      if (data.attrs) {
        data.staticClass += ' ' + Object.keys(data.attrs).join(' ');
        delete data.attrs;
      }

      if (props.id) {
        data.domProps = data.domProps || {};
        data.domProps.id = props.id;
      }

      return h('div', data, children);
    }
  };
};

var VContainer = Grid('container');
var VFlex = Grid('flex');
var VLayout = Grid('layout');
var VSpacer = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('spacer');

/* harmony default export */ __webpack_exports__["a"] = ({
  VContainer: VContainer,
  VFlex: VFlex,
  VLayout: VLayout,
  VSpacer: VSpacer
});

/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VIcon__ = __webpack_require__(3);


/* harmony default export */ __webpack_exports__["a"] = ({
  VIcon: __WEBPACK_IMPORTED_MODULE_0__VIcon__["a" /* default */]
});

/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_transitions__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-list-group',

  inject: ['listClick', 'listClose'],

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */]],

  data: function data() {
    return {
      isBooted: this.value
    };
  },


  props: {
    group: String,
    lazy: Boolean,
    noAction: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'list--group__header': true,
        'list--group__header--active': this.isActive,
        'list--group__header--no-action': this.noAction
      };
    }
  },

  watch: {
    isActive: function isActive() {
      this.isBooted = true;

      if (!this.isActive) {
        this.listClose(this._uid);
      }
    },
    $route: function $route(to) {
      var isActive = this.matchRoute(to.path);

      if (this.group) {
        if (isActive && this.isActive !== isActive) {
          this.listClick(this._uid);
        }
        this.isActive = isActive;
      }
    }
  },

  mounted: function mounted() {
    if (this.group) {
      this.isActive = this.matchRoute(this.$route.path);
    }

    if (this.isActive) {
      this.listClick(this._uid);
    }
  },


  methods: {
    click: function click() {
      var _this = this;

      if (!this.$refs.item.querySelector('.list__tile--disabled')) {
        requestAnimationFrame(function () {
          return _this.listClick(_this._uid);
        });
      }
    },
    toggle: function toggle(uid) {
      this.isActive = this._uid === uid;
    },
    matchRoute: function matchRoute(to) {
      if (!this.group) return false;
      return to.match(this.group) !== null;
    }
  },

  render: function render(h) {
    var group = h('ul', {
      'class': 'list list--group',
      directives: [{
        name: 'show',
        value: this.isActive
      }],
      ref: 'group'
    }, [this.lazy && !this.isBooted ? null : this.$slots.default]);

    var item = h('div', {
      'class': this.classes,
      on: Object.assign({}, { click: this.click }, this.$listeners),
      ref: 'item'
    }, [this.$slots.item]);

    var transition = h(__WEBPACK_IMPORTED_MODULE_0__components_transitions__["a" /* VExpandTransition */], [group]);

    return h('div', { 'class': 'list--group__container' }, [item, transition]);
  }
});

/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


function directive(el, binding) {
  var config = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["f" /* directiveConfig */])(binding, {
    icon: false,
    left: false,
    bottom: false,
    overlap: false,
    visible: true
  });

  if (!config.visible || binding.expression && !binding.value) {
    return unbind(el);
  }

  if (config.overlap) el.classList.add('badge--overlap');
  if (config.icon) el.classList.add('badge--icon');
  if (config.left) el.classList.add('badge--left');
  if (config.bottom) el.classList.add('badge--bottom');

  el.dataset.badge = config.value;
  el.classList.add('badge');
}

function unbind(el) {
  el.removeAttribute('data-badge');
  el.classList.remove('badge');
}

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: directive,
  updated: directive,
  componentUpdated: directive,
  unbind: unbind
});

/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function inserted(el, binding) {
  var debounce = function debounce(cb) {
    return setTimeout(cb, 50);
  };
  var onResize = function onResize() {
    clearTimeout(debounce);
    debounce(binding.value);
  };

  window.addEventListener('resize', onResize, { passive: true });
  el._onResize = onResize;
}

function unbind(el, binding) {
  window.removeEventListener('resize', el._onResize);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  inserted: inserted,
  unbind: unbind
});

/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function inserted(el, binding) {
  var callback = typeof binding.value === 'function' ? binding.value : binding.value.callback;
  var options = binding.value.options || { passive: true };
  var target = binding.value.target || window;
  if (target === 'undefined') return;

  if (target !== window) {
    target = document.querySelector(target);
  }

  target.addEventListener('scroll', callback, options);

  el._onScroll = {
    target: target,
    options: options
  };
}

function unbind(el, binding) {
  var _el$_onScroll = el._onScroll,
      target = _el$_onScroll.target,
      options = _el$_onScroll.options;


  target.removeEventListener('scroll', binding.callback, options);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  inserted: inserted,
  unbind: unbind
});

/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


function directive(el, binding) {
  var config = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["f" /* directiveConfig */])(binding, {
    top: true,
    visible: true
  });

  if (!config.visible || binding.expression && !binding.value) {
    return unbind(el);
  }

  unbind(el, binding, config);

  el.dataset.tooltip = config.html;
  el.dataset['tooltipLocation'] = config.value;
}

function unbind(el) {
  el.removeAttribute('data-tooltip');
  el.removeAttribute('data-tooltip-location');
}

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: directive,
  updated: directive,
  componentUpdated: directive,
  unbind: unbind
});

/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var touchstart = function touchstart(event, wrapper) {
  var touch = event.changedTouches[0];
  wrapper.touchstartX = touch.clientX;
  wrapper.touchstartY = touch.clientY;

  wrapper.start && wrapper.start(Object.assign(event, wrapper));
};

var touchend = function touchend(event, wrapper) {
  var touch = event.changedTouches[0];
  wrapper.touchendX = touch.clientX;
  wrapper.touchendY = touch.clientY;

  wrapper.end && wrapper.end(Object.assign(event, wrapper));

  handleGesture(wrapper);
};

var touchmove = function touchmove(event, wrapper) {
  var touch = event.changedTouches[0];
  wrapper.touchmoveX = touch.clientX;
  wrapper.touchmoveY = touch.clientY;

  wrapper.move && wrapper.move(Object.assign(event, wrapper));
};

var handleGesture = function handleGesture(wrapper) {
  var touchstartX = wrapper.touchstartX,
      touchendX = wrapper.touchendX,
      touchstartY = wrapper.touchstartY,
      touchendY = wrapper.touchendY;

  wrapper.offsetX = touchendX - touchstartX;
  wrapper.offsetY = touchendY - touchstartY;

  if (touchendX < touchstartX) {
    wrapper.left && wrapper.left(wrapper);
  }
  if (touchendX > touchstartX) {
    wrapper.right && wrapper.right(wrapper);
  }
  if (touchendY < touchstartY) {
    wrapper.up && wrapper.up(wrapper);
  }
  if (touchendY > touchstartY) {
    wrapper.down && wrapper.down(wrapper);
  }
};

function inserted(el, _ref) {
  var value = _ref.value;

  var wrapper = {
    touchstartX: 0,
    touchstartY: 0,
    touchendX: 0,
    touchendY: 0,
    touchmoveX: 0,
    touchmoveY: 0,
    offsetX: 0,
    offsetY: 0,
    left: value.left,
    right: value.right,
    up: value.up,
    down: value.down,
    start: value.start,
    move: value.move,
    end: value.end
  };

  var target = value.parent ? el.parentNode : el;
  var options = value.options || {};

  target.addEventListener('touchstart', function (e) {
    return touchstart(e, wrapper);
  }, options);
  target.addEventListener('touchend', function (e) {
    return touchend(e, wrapper);
  }, options);
  target.addEventListener('touchmove', function (e) {
    return touchmove(e, wrapper);
  }, options);
}

function unbind(el, _ref2) {
  var value = _ref2.value;

  var target = value.parent ? el.parentNode : el;

  if (!target) return;

  target.removeEventListener('touchstart', touchstart);
  target.removeEventListener('touchend', touchend);
  target.removeEventListener('touchmove', touchmove);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  inserted: inserted,
  unbind: unbind
});

/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VMenu_js__ = __webpack_require__(22);


/* harmony default export */ __webpack_exports__["a"] = ({
  VMenu: __WEBPACK_IMPORTED_MODULE_0__VMenu_js__["a" /* default */]
});

/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    getActivator: function getActivator() {
      if (this.activator) return this.activator;
      return this.$refs.activator.children ? this.$refs.activator.children[0] : this.$refs.activator;
    },
    activatorClickHandler: function activatorClickHandler(e) {
      if (this.disabled) return;else if (this.openOnClick && !this.isActive) {
        this.isActive = true;
        this.absoluteX = e.clientX;
        this.absoluteY = e.clientY;
      } else if (this.closeOnClick && this.isActive) this.isActive = false;
    },
    mouseEnterHandler: function mouseEnterHandler(e) {
      if (this.disabled || this.hasJustFocused) return;
      this.hasJustFocused = true;
      this.isActive = true;
    },
    mouseLeaveHandler: function mouseLeaveHandler(e) {
      if (this.isContentActive) return;
      this.isActive = false;
    },
    addActivatorEvents: function addActivatorEvents() {
      var activator = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (!activator) return;
      activator.addEventListener('click', this.activatorClickHandler);
    },
    removeActivatorEvents: function removeActivatorEvents() {
      var activator = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (!activator) return;
      activator.removeEventListener('click', this.activatorClickHandler);
    }
  }
});

/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genActivator: function genActivator() {
      if (!this.$slots.activator) return null;

      var options = {
        'class': {
          'menu__activator--active': this.hasJustFocused || this.isActive
        },
        staticClass: 'menu__activator',
        ref: 'activator',
        slot: 'activator',
        on: {}
      };

      if (this.openOnHover) {
        options.on['mouseenter'] = this.mouseEnterHandler;
        options.on['mouseleave'] = this.mouseLeaveHandler;
      } else if (this.openOnClick) {
        options.on['click'] = this.activatorClickHandler;
      }

      return this.$createElement('div', options, this.$slots.activator);
    },
    genTransition: function genTransition() {
      return this.$createElement('transition', {
        props: {
          name: this.transition,
          origin: this.origin
        }
      }, [this.genContent()]);
    },
    genContent: function genContent() {
      var _this = this;

      var booted = this.lazy && this.isBooted || !this.lazy;
      return this.$createElement('div', {
        'class': ('menu__content ' + this.contentClass).trim(),
        ref: 'content',
        style: this.styles,
        directives: [{
          name: 'show',
          value: this.isContentActive
        }],
        on: {
          click: function click(e) {
            e.stopPropagation();
            if (e.target.getAttribute('disabled')) return;
            if (_this.closeOnContentClick) _this.isActive = false;
          },
          mouseleave: function mouseleave(e) {
            _this.openOnHover && (_this.isActive = false);
          }
        }
      }, [booted ? this.$slots.default : null]);
    }
  }
});

/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    // Revisit this
    calculateScroll: function calculateScroll() {
      if (this.selectedIndex === null) return;

      var scrollTop = 0;

      if (this.selectedIndex >= this.stopIndex) {
        scrollTop = this.$refs.content.scrollHeight;
      } else if (this.selectedIndex > this.startIndex) {
        scrollTop = this.selectedIndex * 48 - 56;
      }

      this.$refs.content.scrollTop = scrollTop;
    },
    calcLeftAuto: function calcLeftAuto() {
      var a = this.dimensions.activator;

      return parseInt(a.left - 16);
    },
    calcTopAuto: function calcTopAuto() {
      if (!this.hasActivator) return this.calcTop(true);

      var selectedIndex = Array.from(this.tiles).findIndex(function (n) {
        return n.classList.contains('list__tile--active');
      });

      if (selectedIndex === -1) {
        this.selectedIndex = null;

        return this.calcTop(true);
      }

      this.selectedIndex = selectedIndex;
      var actingIndex = selectedIndex;

      var offsetPadding = 1;
      // #708 Stop index should vary by tile length
      this.stopIndex = this.tiles.length > 4 ? this.tiles.length - 4 : this.tiles.length;

      if (selectedIndex > this.startIndex && selectedIndex < this.stopIndex) {
        actingIndex = 2;
        offsetPadding = 41;
      } else if (selectedIndex >= this.stopIndex) {
        offsetPadding = 9;
        actingIndex = selectedIndex - this.stopIndex;
      }

      return this.calcTop(true) + offsetPadding - actingIndex * 48;
    },
    calcLeft: function calcLeft() {
      if (this.auto) return this.calcLeftAuto();

      var a = this.dimensions.activator;
      var c = this.dimensions.content;
      var left = this.left ? a.right - c.width : a.left;

      if (this.offsetX) left += this.left ? -a.width : a.width;
      if (this.nudgeLeft) left += this.nudgeLeft;
      if (this.nudgeRight) left -= this.nudgeRight;

      return this.calcXOverflow(left);
    },
    calcTop: function calcTop(force) {
      if (this.auto && !force) return this.calcTopAuto();

      var a = this.dimensions.activator;
      var c = this.dimensions.content;
      var top = this.top ? a.bottom - c.height : a.top;

      if (this.offsetY) top += this.top ? -a.height : a.height;
      if (this.nudgeTop) top -= this.nudgeTop;
      if (this.nudgeBottom) top += this.nudgeBottom;

      var defined = typeof window !== 'undefined';
      var pageYOffset = defined ? window.pageYOffset : 0;

      return this.calcYOverflow(top) + pageYOffset;
    },
    calcXOverflow: function calcXOverflow(left) {
      var hasWindow = typeof window !== 'undefined';
      var innerWidth = hasWindow ? window.innerWidth : 0;
      var maxWidth = Math.max(this.dimensions.content.width, this.calculatedMinWidth, parseInt(this.maxWidth) || 0);
      var totalWidth = left + maxWidth;
      var availableWidth = totalWidth - innerWidth;

      if ((!this.left || this.right) && availableWidth > 0) {
        left = innerWidth - maxWidth - (innerWidth > 1024 ? 30 : 12) // Account for scrollbar
        ;
      } else if (this.left && left < 0) left = 12;

      return left;
    },
    calcYOverflow: function calcYOverflow(top) {
      var totalHeight = top + this.dimensions.content.height;
      var defined = typeof window !== 'undefined';
      var innerHeight = defined ? window.innerHeight : 0;

      if (this.top && top < 0) top = 12;else if ((!this.top || this.bottom) && innerHeight < totalHeight) {
        top = innerHeight - this.dimensions.content.height;
      }

      return top < 12 ? 12 : top;
    },
    sneakPeek: function sneakPeek(cb) {
      var _this = this;

      requestAnimationFrame(function () {
        var el = _this.$refs.content;
        var currentDisplay = el.style.display;

        el.style.display = 'inline-block';
        cb();
        el.style.display = currentDisplay;
      });
    },
    absolutePosition: function absolutePosition() {
      return {
        offsetTop: 0,
        scrollHeight: 0,
        top: this.positionY || this.absoluteY,
        bottom: this.positionY || this.absoluteY,
        left: this.positionX || this.absoluteX,
        right: this.positionX || this.absoluteX,
        height: 0,
        width: 0
      };
    },
    updateDimensions: function updateDimensions() {
      var _this2 = this;

      this.sneakPeek(function () {
        _this2.dimensions = {
          activator: !_this2.hasActivator || _this2.positionAbsolutely ? _this2.absolutePosition() : _this2.measure(_this2.getActivator()),
          content: _this2.measure(_this2.$refs.content)
        };
      });
    }
  }
});

/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    measure: function measure(el, selector) {
      var getParent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      el = selector ? el.querySelector(selector) : el;

      if (!el) return null;

      var _el$getBoundingClient = el.getBoundingClientRect(),
          top = _el$getBoundingClient.top,
          bottom = _el$getBoundingClient.bottom,
          left = _el$getBoundingClient.left,
          right = _el$getBoundingClient.right,
          height = _el$getBoundingClient.height,
          width = _el$getBoundingClient.width;

      return {
        offsetTop: el.offsetTop,
        scrollHeight: el.scrollHeight,
        top: top, bottom: bottom, left: left, right: right, height: height, width: width
      };
    }
  }
});

/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      listIndex: -1,
      isUsingKeys: false,
      tiles: []
    };
  },

  watch: {
    isActive: function isActive(val) {
      if (!val) this.listIndex = -1;
    },
    listIndex: function listIndex(next, prev) {
      // For infinite scroll and autocomplete, re-evaluate children
      this.getTiles();

      if (next in this.tiles) {
        this.tiles[next].classList.add('list__tile--highlighted');
        this.$refs.content.scrollTop = next * 48;
      }

      prev in this.tiles && this.tiles[prev].classList.remove('list__tile--highlighted');
    }
  },

  methods: {
    changeListIndex: function changeListIndex(e) {
      [40, 38, 13].includes(e.keyCode) && e.preventDefault();
      e.keyCode === 32 && !this.isActive && e.preventDefault();

      if (this.listIndex === -1) this.setActiveListIndex();
      if ([27, 9].includes(e.keyCode)) return this.isActive = false;else if (!this.isActive && [13, 32].includes(e.keyCode)) {
        return this.isActive = true;
      }

      if (e.keyCode === 40 && this.listIndex < this.tiles.length - 1) {
        this.listIndex++;
      } else if (e.keyCode === 38 && this.listIndex > 0) {
        this.listIndex--;
      } else if (e.keyCode === 13 && this.listIndex !== -1) {
        this.tiles[this.listIndex].click();
      }
    },
    getTiles: function getTiles() {
      this.tiles = this.$refs.content.querySelectorAll('.list__tile');
    },
    setActiveListIndex: function setActiveListIndex() {
      var _this = this;

      this.tiles.forEach(function (t, i) {
        if (t.classList.contains('list__tile--active')) {
          _this.listIndex = i;
          return;
        }
      });
    }
  }
});

/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VNavigationDrawer__ = __webpack_require__(89);


/* harmony default export */ __webpack_exports__["a"] = ({
  VNavigationDrawer: __WEBPACK_IMPORTED_MODULE_0__VNavigationDrawer__["a" /* default */]
});

/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_overlayable__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__directives__ = __webpack_require__(4);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-navigation-drawer',

  directives: {
    Resize: __WEBPACK_IMPORTED_MODULE_2__directives__["Resize"]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_overlayable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_themeable__["a" /* default */]],

  data: function data() {
    return {
      isActive: this.value,
      isBooted: false,
      isMobile: false,
      touchArea: {
        left: 0,
        right: 0
      }
    };
  },


  props: {
    absolute: Boolean,
    clipped: Boolean,
    disableRouteWatcher: Boolean,
    enableResizeWatcher: Boolean,
    height: String,
    floating: Boolean,
    miniVariant: Boolean,
    mobileBreakPoint: {
      type: Number,
      default: 1024
    },
    permanent: Boolean,
    persistent: Boolean,
    right: Boolean,
    temporary: Boolean,
    touchless: Boolean,
    value: { required: false }
  },

  computed: {
    calculatedHeight: function calculatedHeight() {
      return this.height || '100%';
    },
    classes: function classes() {
      return {
        'navigation-drawer': true,
        'navigation-drawer--absolute': this.absolute,
        'navigation-drawer--clipped': this.clipped,
        'navigation-drawer--close': !this.isActive,
        'navigation-drawer--floating': this.floating,
        'navigation-drawer--is-booted': this.isBooted,
        'navigation-drawer--is-mobile': this.isMobile,
        'navigation-drawer--mini-variant': this.miniVariant,
        'navigation-drawer--open': this.isActive,
        'navigation-drawer--permanent': this.permanent,
        'navigation-drawer--persistent': this.persistent,
        'navigation-drawer--right': this.right,
        'navigation-drawer--temporary': this.temporary,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    },
    showOverlay: function showOverlay() {
      return !this.permanent && this.isActive && (this.temporary || this.isMobile);
    }
  },

  watch: {
    $route: function $route() {
      if (!this.disableRouteWatcher) {
        this.isActive = !this.closeConditional();
      }
    },
    isActive: function isActive(val) {
      this.$emit('input', val);
      this.showOverlay && val && this.genOverlay() || this.removeOverlay();
      this.$el.scrollTop = 0;
    },
    isMobile: function isMobile(val) {
      !val && this.removeOverlay();
    },
    permanent: function permanent(val) {
      this.$emit('input', val);
    },
    value: function value(val) {
      if (this.permanent) return;
      if (val !== this.isActive) this.isActive = val;
    }
  },

  mounted: function mounted() {
    this.$vuetify.load(this.init);
  },


  methods: {
    init: function init() {
      var _this = this;

      this.checkIfMobile();
      setTimeout(function () {
        return _this.isBooted = true;
      }, 0);

      if (this.permanent) this.isActive = true;else if (this.isMobile) this.isActive = false;else if (!this.value && (this.persistent || this.temporary)) this.isActive = false;
    },
    checkIfMobile: function checkIfMobile() {
      this.isMobile = window.innerWidth < parseInt(this.mobileBreakPoint);
    },
    closeConditional: function closeConditional() {
      return !this.permanent && (this.temporary || this.isMobile);
    },
    onResize: function onResize() {
      var _this2 = this;

      clearTimeout(this.resizeTimeout);

      if (!this.enableResizeWatcher || this.permanent || this.temporary) return;

      this.resizeTimeout = setTimeout(function () {
        _this2.checkIfMobile();
        _this2.isActive = !_this2.isMobile;
      }, 200);
    },
    swipeRight: function swipeRight(e) {
      if (this.isActive && !this.right) return;
      this.calculateTouchArea();

      if (Math.abs(e.touchendX - e.touchstartX) < 100) return;else if (!this.right && e.touchstartX <= this.touchArea.left) this.isActive = true;else if (this.right && this.isActive) this.isActive = false;
    },
    swipeLeft: function swipeLeft(e) {
      if (this.isActive && this.right) return;
      this.calculateTouchArea();

      if (Math.abs(e.touchendX - e.touchstartX) < 100) return;else if (this.right && e.touchstartX >= this.touchArea.right) this.isActive = true;else if (!this.right && this.isActive) this.isActive = false;
    },
    calculateTouchArea: function calculateTouchArea() {
      if (!this.$el.parentNode) return;
      var parentRect = this.$el.parentNode.getBoundingClientRect();

      this.touchArea = {
        left: parentRect.left + 50,
        right: parentRect.right - 50
      };
    },
    genDirectives: function genDirectives() {
      var directives = [{
        name: 'click-outside',
        value: this.closeConditional
      }, {
        name: 'resize',
        value: this.onResize
      }];

      !this.touchless && directives.push({
        name: 'touch',
        value: {
          parent: true,
          left: this.swipeLeft,
          right: this.swipeRight
        }
      });

      return directives;
    }
  },

  render: function render(h) {
    var _this3 = this;

    var data = {
      'class': this.classes,
      style: { height: this.calculatedHeight },
      directives: this.genDirectives(),
      on: Object.assign({}, {
        click: function click() {
          return _this3.$emit('update:miniVariant', false);
        }
      }, this.$listeners)
    };

    return h('aside', data, [this.$slots.default, h('div', { 'class': 'navigation-drawer__border' })]);
  }
});

/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VSystemBar__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VToolbar__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VToolbarSideIcon__ = __webpack_require__(93);






var VToolbarTitle = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('toolbar__title');
var VToolbarItems = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('toolbar__items');

/* harmony default export */ __webpack_exports__["a"] = ({
  VSystemBar: __WEBPACK_IMPORTED_MODULE_1__VSystemBar__["a" /* default */],
  VToolbar: __WEBPACK_IMPORTED_MODULE_2__VToolbar__["a" /* default */],
  VToolbarItems: VToolbarItems,
  VToolbarTitle: VToolbarTitle,
  VToolbarSideIcon: __WEBPACK_IMPORTED_MODULE_3__VToolbarSideIcon__["a" /* default */]
});

/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    lightsOut: Boolean,
    status: Boolean,
    window: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('system-bar ' + (data.staticClass || '')).trim();

    if (props.dark) data.staticClass += ' theme--dark';
    if (props.light) data.staticClass += ' theme--light';
    if (props.status) data.staticClass += ' system-bar--status';
    if (props.window) data.staticClass += ' system-bar--window';
    if (props.lightsOut) data.staticClass += ' system-bar--lights-out';

    return h('div', data, children);
  }
});

/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-toolbar',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  data: function data() {
    return {
      isExtended: false,
      isScrolling: false,
      marginTop: 0,
      previousScroll: null,
      target: null
    };
  },

  props: {
    absolute: Boolean,
    card: Boolean,
    dense: Boolean,
    extended: Boolean,
    fixed: Boolean,
    flat: Boolean,
    floating: Boolean,
    prominent: Boolean,
    scrollOffScreen: Boolean,
    scrollTarget: String,
    scrollThreshHold: {
      type: Number,
      default: 100
    }
  },

  computed: {
    classes: function classes() {
      return {
        'toolbar': true,
        'elevation-0': this.flat,
        'toolbar--absolute': this.absolute,
        'toolbar--card': this.card,
        'toolbar--dense': this.dense,
        'toolbar--fixed': this.fixed,
        'toolbar--floating': this.floating,
        'toolbar--prominent': this.prominent,
        'toolbar--extended': this.isExtended,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    },
    styles: function styles() {
      return {
        marginTop: this.marginTop
      };
    }
  },

  watch: {
    isScrolling: function isScrolling(val) {
      if (!val) this.marginTop = 0;else this.marginTop = -this.$refs.content.clientHeight - 6 + 'px';
    }
  },

  methods: {
    onScroll: function onScroll() {
      if (typeof window === 'undefined') return;

      if (!this.target) {
        this.target = this.scrollTarget ? document.querySelector(this.scrollTarget) : window;
      }

      var currentScroll = this.scrollTarget ? this.target.scrollTop : this.target.pageYOffset || document.documentElement.scrollTop;

      if (currentScroll < this.scrollThreshHold) return;

      if (this.previousScroll === null) {
        this.previousScroll = currentScroll;
      }

      this.isScrolling = this.previousScroll < currentScroll;

      this.previousScroll = currentScroll;
    }
  },

  render: function render(h) {
    this.isExtended = this.extended || !!this.$slots.extension;
    var children = [];
    var data = {
      'class': this.classes,
      style: this.styles,
      on: this.$listeners
    };

    if (this.scrollOffScreen) {
      data.directives = [{
        name: 'scroll',
        value: {
          callback: this.onScroll,
          target: this.scrollTarget
        }
      }];
    }

    children.push(h('div', {
      'class': 'toolbar__content',
      ref: 'content'
    }, this.$slots.default));

    if (this.isExtended) {
      children.push(h('div', {
        'class': 'toolbar__extension'
      }, this.$slots.extension));
    }

    return h('nav', data, children);
  }
});

/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_buttons_VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_icons_VIcon__ = __webpack_require__(3);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-toolbar-side-icon',

  functional: true,

  render: function render(h, _ref) {
    var slots = _ref.slots,
        listeners = _ref.listeners,
        props = _ref.props;

    var data = {
      staticClass: 'toolbar__side-icon',
      props: Object.assign(props, {
        icon: true
      }),
      on: listeners
    };

    var defaultSlot = slots().default;

    return h(__WEBPACK_IMPORTED_MODULE_0__components_buttons_VBtn__["a" /* default */], data, defaultSlot || [h(__WEBPACK_IMPORTED_MODULE_1__components_icons_VIcon__["a" /* default */], 'menu')]);
  }
});

/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VPagination__ = __webpack_require__(95);


/* harmony default export */ __webpack_exports__["a"] = ({
  VPagination: __WEBPACK_IMPORTED_MODULE_0__VPagination__["a" /* default */]
});

/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_icons_VIcon__ = __webpack_require__(3);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-pagination',

  props: {
    circle: Boolean,
    disabled: Boolean,
    length: {
      type: Number,
      default: 0,
      validator: function validator(val) {
        return val % 1 === 0;
      }
    },
    value: {
      type: Number,
      default: 0
    },
    prevIcon: {
      type: String,
      default: 'chevron_left'
    },
    nextIcon: {
      type: String,
      default: 'chevron_right'
    }
  },

  watch: {
    value: function value() {
      this.init();
    }
  },

  computed: {
    classes: function classes() {
      return {
        'pagination': true,
        'pagination--circle': this.circle,
        'pagination--disabled': this.disabled
      };
    },
    items: function items() {
      if (this.length <= 5) {
        return this.range(1, this.length);
      }

      var min = this.value - 3;
      min = min > 0 ? min : 1;

      var max = min + 6;
      max = max <= this.length ? max : this.length;

      if (max === this.length) {
        min = this.length - 6;
      }

      var range = this.range(min, max);

      if (this.value >= 4 && this.length > 6) {
        range.splice(0, 2, 1, '...');
      }

      if (this.value + 3 < this.length && this.length > 6) {
        range.splice(range.length - 2, 2, '...', this.length);
      }

      return range;
    }
  },

  mounted: function mounted() {
    this.$vuetify.load.call(this, this.init);
  },


  methods: {
    init: function init() {
      var _this = this;

      this.selected = null;

      // Change this
      setTimeout(function () {
        return _this.selected = _this.value;
      }, 100);
    },
    next: function next(e) {
      e.preventDefault();
      this.$emit('input', this.value + 1);
      this.$emit('next');
    },
    previous: function previous(e) {
      e.preventDefault();
      this.$emit('input', this.value - 1);
      this.$emit('previous');
    },
    range: function range(from, to) {
      var range = [];

      from = from > 0 ? from : 1;

      for (var i = from; i <= to; i++) {
        range.push(i);
      }

      return range;
    },
    genIcon: function genIcon(h, icon, disabled, fn) {
      return h('li', [h('a', {
        class: {
          'pagination__navigation': true,
          'pagination__navigation--disabled': disabled
        },
        attrs: { href: '#!' },
        on: { click: fn }
      }, [h(__WEBPACK_IMPORTED_MODULE_0__components_icons_VIcon__["a" /* default */], [icon])])]);
    },
    genItem: function genItem(h, i) {
      var _this2 = this;

      return h('a', {
        class: {
          'pagination__item': true,
          'pagination__item--active': i === this.value
        },
        attrs: { href: '#!' },
        on: {
          click: function click(e) {
            e.preventDefault();
            _this2.$emit('input', i);
          }
        }
      }, [i]);
    },
    genItems: function genItems(h) {
      var _this3 = this;

      return this.items.map(function (i) {
        return h('li', [isNaN(i) && h('span', { class: 'pagination__more' }, [i]) || _this3.genItem(h, i)]);
      });
    }
  },

  render: function render(h) {
    var children = [this.genIcon(h, this.prevIcon, this.value === 1, this.previous), this.genItems(h), this.genIcon(h, this.nextIcon, this.value === this.length, this.next)];

    return h('ul', { class: this.classes }, children);
  }
});

/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VParallax__ = __webpack_require__(97);


/* harmony default export */ __webpack_exports__["a"] = ({
  VParallax: __WEBPACK_IMPORTED_MODULE_0__VParallax__["a" /* default */]
});

/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_translatable__ = __webpack_require__(98);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-parallax',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_translatable__["a" /* default */]],

  props: {
    height: {
      type: [String, Number],
      default: 500
    },
    src: String
  },

  computed: {
    styles: function styles() {
      return {
        display: 'block',
        transform: 'translate3d(-50%, ' + this.parallax + 'px, 0)'
      };
    }
  },

  methods: {
    init: function init() {
      var _this = this;

      if (!this.$refs.img) return;

      if (this.$refs.img.complete) {
        this.translate();
        this.listeners();
      } else {
        this.$refs.img.addEventListener('load', function () {
          _this.translate();
          _this.listeners();
        }, false);
      }
    },
    objHeight: function objHeight() {
      return this.$refs.img.naturalHeight;
    },
    elOffsetTop: function elOffsetTop() {
      return this.$el.offsetTop;
    }
  },

  render: function render(h) {
    var container = h('div', {
      staticClass: 'parallax__image-container'
    }, [h('img', {
      staticClass: 'parallax__image',
      style: this.styles,
      attrs: {
        src: this.src
      },
      ref: 'img'
    })]);

    var content = h('div', {
      staticClass: 'parallax__content'
    }, this.$slots.default);

    return h('div', {
      staticClass: 'parallax',
      style: {
        height: parseInt(this.normalizedHeight) + 'px'
      },
      on: this.$listeners
    }, [container, content]);
  }
});

/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      parallax: null,
      parallaxDist: null,
      percentScrolled: null,
      scrollTop: null,
      windowHeight: null,
      windowBottom: null
    };
  },


  computed: {
    normalizedHeight: function normalizedHeight() {
      return Number(this.height.toString().replace(/(^[0-9]*$)/, '$1'));
    },
    imgHeight: function imgHeight() {
      return this.objHeight();
    }
  },

  mounted: function mounted() {
    this.$vuetify.load(this.init);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('scroll', this.translate, false);
    window.removeEventListener('resize', this.translate, false);
  },


  methods: {
    listeners: function listeners() {
      window.addEventListener('scroll', this.translate, false);
      window.addEventListener('resize', this.translate, false);
    },
    translate: function translate() {
      this.calcDimensions();

      this.percentScrolled = (this.windowBottom - this.elOffsetTop) / (this.normalizedHeight + this.windowHeight);

      this.parallax = Math.round(this.parallaxDist * this.percentScrolled);

      if (this.translated) {
        this.translated();
      }
    },
    calcDimensions: function calcDimensions() {
      var offset = this.$el.getBoundingClientRect();

      this.scrollTop = window.pageYOffset;
      this.parallaxDist = this.imgHeight - this.normalizedHeight;
      this.elOffsetTop = offset.top + this.scrollTop;
      this.windowHeight = window.innerHeight;
      this.windowBottom = this.scrollTop + this.windowHeight;
    }
  }
});

/***/ }),
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VProgressLinear__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VProgressCircular__ = __webpack_require__(100);



/* harmony default export */ __webpack_exports__["a"] = ({
  VProgressLinear: __WEBPACK_IMPORTED_MODULE_0__VProgressLinear__["a" /* default */],
  VProgressCircular: __WEBPACK_IMPORTED_MODULE_1__VProgressCircular__["a" /* default */]
});

/***/ }),
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _this = this;

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-progress-circular',

  props: {
    button: Boolean,

    fill: {
      type: String,
      default: function _default() {
        return _this.indeterminate ? 'none' : 'transparent';
      }
    },

    indeterminate: Boolean,

    rotate: {
      type: Number,
      default: 0
    },

    size: {
      type: [Number, String],
      default: 32
    },

    width: {
      type: Number,
      default: 4
    },

    value: {
      type: Number,
      default: 0
    }
  },

  computed: {
    calculatedSize: function calculatedSize() {
      var size = Number(this.size);

      if (this.button) {
        size += 8;
      }

      return size;
    },
    circumference: function circumference() {
      return 2 * Math.PI * this.radius;
    },
    classes: function classes() {
      return {
        'progress-circular': true,
        'progress-circular--indeterminate': this.indeterminate,
        'progress-circular--button': this.button
      };
    },
    cxy: function cxy() {
      return this.indeterminate && !this.button ? 50 : this.calculatedSize / 2;
    },
    normalizedValue: function normalizedValue() {
      if (this.value < 0) {
        return 0;
      }

      if (this.value > 100) {
        return 100;
      }

      return this.value;
    },
    radius: function radius() {
      return this.indeterminate && !this.button ? 20 : (this.calculatedSize - this.width) / 2;
    },
    strokeDashArray: function strokeDashArray() {
      return Math.round(this.circumference * 1000) / 1000;
    },
    strokeDashOffset: function strokeDashOffset() {
      return (100 - this.normalizedValue) / 100 * this.circumference + 'px';
    },
    styles: function styles() {
      return {
        height: this.calculatedSize + 'px',
        width: this.calculatedSize + 'px'
      };
    },
    svgSize: function svgSize() {
      return this.indeterminate ? false : this.calculatedSize;
    },
    svgStyles: function svgStyles() {
      return {
        transform: 'rotate(' + this.rotate + 'deg)'
      };
    },
    viewBox: function viewBox() {
      return this.indeterminate ? '25 25 50 50' : false;
    }
  },

  methods: {
    genCircle: function genCircle(h, name, offset) {
      return h('circle', {
        class: 'progress-circular__' + name,
        attrs: {
          fill: 'transparent',
          cx: this.cxy,
          cy: this.cxy,
          r: this.radius,
          'stroke-width': this.width,
          'stroke-dasharray': this.strokeDashArray,
          'stroke-dashoffset': offset
        }
      });
    },
    genSvg: function genSvg(h) {
      var children = [!this.indeterminate && this.genCircle(h, 'underlay', 0), this.genCircle(h, 'overlay', this.strokeDashOffset)];

      return h('svg', {
        style: this.svgStyles,
        attrs: {
          xmlns: 'http://www.w3.org/2000/svg',
          height: this.svgSize,
          width: this.svgSize,
          viewBox: this.viewBox
        }
      }, children);
    }
  },

  render: function render(h) {
    var info = h('div', { class: 'progress-circular__info' }, [this.$slots.default]);
    var svg = this.genSvg(h);

    return h('div', {
      class: this.classes,
      style: this.styles,
      on: this.$listeners
    }, [svg, info]);
  }
});

/*
<template lang="pug">
  div(
    class="progress-circular"
    v-bind:class="classes"
    v-bind:style="styles"
    v-on="$listeners"
  )
    svg(
      xmlns="http://www.w3.org/2000/svg"
      v-bind:height="svgSize"
      v-bind:width="svgSize"
      v-bind:viewBox="viewBox"
      v-bind:style="svgStyles"
    )
      circle(
        class="progress-circular__underlay"
        fill="transparent"
        v-bind:cx="cxy"
        v-bind:cy="cxy"
        v-bind:r="radius"
        v-bind:stroke-width="width"
        v-bind:stroke-dasharray="strokeDashArray"
        v-bind:stroke-dashoffset="0"
        v-if="!indeterminate"
      )
      circle(
        class="progress-circular__overlay"
        v-bind:fill="fill"
        v-bind:cx="cxy"
        v-bind:cy="cxy"
        v-bind:r="radius"
        v-bind:stroke-width="width"
        v-bind:stroke-dasharray="strokeDashArray"
        v-bind:stroke-dashoffset="strokeDashOffset"
      )
    div(class="progress-circular__info")
      slot
</template>
*/

/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VSelect__ = __webpack_require__(24);


/* harmony default export */ __webpack_exports__["a"] = ({
  VSelect: __WEBPACK_IMPORTED_MODULE_0__VSelect__["a" /* default */]
});

/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    filterSearch: function filterSearch() {
      var _this = this;

      return this.items.filter(function (i) {
        var text = _this.getText(i);
        if (typeof text !== 'string') return false;

        return text.toLowerCase().indexOf(_this.searchValue.toLowerCase()) !== -1;
      });
    },
    onKeyDown: function onKeyDown(e) {
      this.$refs.menu.changeListIndex(e);
    }
  }
});

/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genMenu: function genMenu() {
      var _this = this;

      var offsetY = this.autocomplete || this.offset || this.isDropdown;
      var data = {
        ref: 'menu',
        props: {
          activator: this.$refs.activator,
          auto: this.auto,
          closeOnClick: false,
          closeOnContentClick: !this.multiple,
          contentClass: this.computedContentClass,
          disabled: this.disabled,
          maxHeight: this.maxHeight,
          nudgeTop: this.isDropdown ? 22 : offsetY ? 38 : 0,
          offsetY: offsetY,
          value: this.isActive
        },
        on: { input: function input(val) {
            return _this.isActive = val;
          } }
      };

      this.minWidth && (data.props.minWidth = this.minWidth);

      return this.$createElement('v-menu', data, [this.genList()]);
    },
    genSelectionsAndSearch: function genSelectionsAndSearch() {
      var _this2 = this;

      var input = void 0;

      if (this.autocomplete || this.editable) {
        input = this.$createElement('input', {
          'class': 'input-group--select__autocomplete',
          domProps: { value: this.searchValue },
          on: { input: function input(e) {
              return _this2.searchValue = e.target.value;
            } },
          attrs: { tabindex: -1 },
          ref: 'input',
          key: 'input'
        });
      }

      var selections = this.isDirty && (!this.editable || this.editable && !this.focused) ? this.genSelections() : [];
      input && selections.push(input);
      var group = this.$createElement('div', selections);

      return this.$createElement('div', {
        'class': 'input-group__selections',
        style: { 'overflow': 'hidden' },
        ref: 'activator'
      }, [group]);
    },
    genSelections: function genSelections() {
      var _this3 = this;

      var children = [];
      var chips = this.chips;
      var slots = this.$scopedSlots.selection;
      var length = this.selectedItems.length;

      this.selectedItems.forEach(function (item, i) {
        if (slots) {
          children.push(_this3.genSlotSelection(item));
        } else if (chips) {
          children.push(_this3.genChipSelection(item));
        } else {
          children.push(_this3.genCommaSelection(item, i < length - 1));
        }
      });

      return children;
    },
    genSlotSelection: function genSlotSelection(item) {
      return this.$scopedSlots.selection({ parent: this, item: item });
    },
    genChipSelection: function genChipSelection(item) {
      var _this4 = this;

      return this.$createElement('v-chip', {
        'class': 'chip--select-multi',
        props: { close: true },
        on: {
          input: function input() {
            return _this4.selectItem(item);
          },
          click: function click(e) {
            return e.stopPropagation();
          }
        },
        key: this.getValue(item)
      }, this.getText(item));
    },
    genCommaSelection: function genCommaSelection(item, comma) {
      return this.$createElement('div', {
        'class': 'input-group__selections__comma',
        key: JSON.stringify(this.getValue(item)) // Item may be an object
      }, '' + this.getText(item) + (comma ? ', ' : ''));
    },
    genList: function genList() {
      var _this5 = this;

      var children = this.filteredItems.map(function (o) {
        if (o.header) return _this5.genHeader(o);
        if (o.divider) return _this5.genDivider(o);else return _this5.genTile(o);
      });

      if (!children.length) {
        children.push(this.genTile(this.noDataText, true));
      }

      return this.$createElement('v-card', [this.$createElement('v-list', {
        ref: 'list'
      }, children)]);
    },
    genHeader: function genHeader(item) {
      return this.$createElement('v-subheader', {
        props: item
      }, item.header);
    },
    genDivider: function genDivider(item) {
      return this.$createElement('v-divider', {
        props: item
      });
    },
    genTile: function genTile(item, disabled) {
      var _this6 = this;

      var active = this.selectedItems.indexOf(item) !== -1;

      if (typeof disabled === 'undefined') {
        disabled = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["g" /* getObjectValueByPath */])(item, this.itemDisabled);
      }

      var data = {
        on: { click: function click(e) {
            return _this6.selectItem(item);
          } },
        props: {
          avatar: item === Object(item) && 'avatar' in item,
          ripple: true,
          value: active
        }
      };

      if (disabled) {
        data.props.disabled = disabled;
      }

      if (this.$scopedSlots.item) {
        return this.$createElement('v-list-tile', data, [this.$scopedSlots.item({ parent: this, item: item })]);
      }

      return this.$createElement('v-list-tile', data, [this.genAction(item, active), this.genContent(item)]);
    },
    genAction: function genAction(item, active) {
      var _this7 = this;

      if (!this.multiple) return null;

      var data = {
        'class': {
          'list__tile__action--select-multi': this.multiple
        },
        on: {
          click: function click(e) {
            e.stopPropagation();
            _this7.selectItem(item);
          }
        }
      };

      return this.$createElement('v-list-tile-action', data, [this.$createElement('v-checkbox', { props: { inputValue: active } })]);
    },
    genContent: function genContent(item) {
      return this.$createElement('v-list-tile-content', [this.$createElement('v-list-tile-title', this.getText(item))]);
    }
  }
});

/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VCheckbox__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VRadio__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VSwitch__ = __webpack_require__(106);




/* harmony default export */ __webpack_exports__["a"] = ({
  VCheckbox: __WEBPACK_IMPORTED_MODULE_0__VCheckbox__["a" /* default */],
  VRadio: __WEBPACK_IMPORTED_MODULE_1__VRadio__["a" /* default */],
  VSwitch: __WEBPACK_IMPORTED_MODULE_2__VSwitch__["a" /* default */]
});

/***/ }),
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_input__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_colorable__ = __webpack_require__(28);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'radio',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_input__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_colorable__["a" /* default */]],

  model: {
    prop: 'inputValue',
    event: 'change'
  },

  props: {
    inputValue: [String, Number]
  },

  computed: {
    isActive: function isActive() {
      return this.inputValue === this.value;
    },
    classes: function classes() {
      return this.addColorClassChecks({
        'radio': true,
        'input-group--selection-controls': true,
        'input-group--active': this.isActive
      });
    },
    icon: function icon() {
      return this.isActive ? 'radio_button_checked' : 'radio_button_unchecked';
    }
  },

  methods: {
    genLabel: function genLabel() {
      return this.$createElement('label', {
        on: { click: this.toggle }
      }, this.label);
    },
    toggle: function toggle() {
      if (!this.disabled) {
        this.$emit('change', this.value);
      }
    }
  },

  render: function render(h) {
    var transition = h('v-fade-transition', {}, [h('v-icon', {
      'class': {
        'icon--radio': this.isActive
      },
      key: this.icon
    }, this.icon)]);

    var ripple = h('div', {
      'class': 'input-group--selection-controls__ripple',
      on: Object.assign({}, {
        click: this.toggle
      }, this.$listeners),
      directives: [{
        name: 'ripple',
        value: { center: true }
      }]
    });

    return this.genInputGroup([transition, ripple]);
  }
});

/***/ }),
/* 106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_selectable__ = __webpack_require__(27);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'switch',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_selectable__["a" /* default */]],

  computed: {
    classes: function classes() {
      return {
        'input-group--selection-controls switch': true
      };
    },
    rippleClasses: function rippleClasses() {
      return {
        'input-group--selection-controls__ripple': true,
        'input-group--selection-controls__ripple--active': this.isActive
      };
    },
    containerClasses: function containerClasses() {
      return this.addColorClassChecks({
        'input-group--selection-controls__container': true,
        'input-group--selection-controls__container--light': this.light,
        'input-group--selection-controls__container--disabled': this.disabled
      });
    },
    toggleClasses: function toggleClasses() {
      return {
        'input-group--selection-controls__toggle': true,
        'input-group--selection-controls__toggle--active': this.isActive
      };
    }
  },

  render: function render(h) {
    var ripple = h('div', {
      'class': this.rippleClasses,
      on: Object.assign({}, {
        click: this.toggle
      }, this.$listeners),
      directives: [{
        name: 'ripple',
        value: { center: true }
      }]
    });

    var container = h('div', {
      'class': this.containerClasses
    }, [h('div', { 'class': this.toggleClasses }), ripple]);

    return this.genInputGroup([container]);
  }
});

/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VSlider__ = __webpack_require__(108);


/* harmony default export */ __webpack_exports__["a"] = ({
  VSlider: __WEBPACK_IMPORTED_MODULE_0__VSlider__["a" /* default */]
});

/***/ }),
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_input__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_helpers__ = __webpack_require__(0);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-slider',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_input__["a" /* default */]],

  data: function data() {
    return {
      app: {},
      isActive: false,
      inputWidth: 0
    };
  },


  props: {
    inverted: Boolean,
    min: {
      type: [Number, String],
      default: 0
    },
    max: {
      type: [Number, String],
      default: 100
    },
    step: {
      type: [Number, String],
      default: null
    },
    thumbLabel: Boolean,
    value: [Number, String],
    vertical: Boolean,
    snap: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'input-group input-group--slider': true,
        'input-group--active': this.isActive,
        'input-group--dirty': this.inputWidth > 0,
        'input-group--disabled': this.disabled,
        'input-group--ticks': !this.disabled && this.step
      };
    },

    inputValue: {
      get: function get() {
        return this.value;
      },
      set: function set(val) {
        var min = this.min,
            max = this.max,
            step = this.step,
            snap = this.snap;

        val = val < min ? min : val > max ? max : val;
        if (Math.ceil(val) !== Math.ceil(this.lazyValue)) {
          this.inputWidth = this.calculateWidth(val);
        }

        var value = snap ? Math.round(val / step) * step : parseInt(val);
        this.lazyValue = value;

        if (value !== this.value) {
          this.$emit('input', value);
        }
      }
    },
    interval: function interval() {
      return 100 / (this.max - this.min) * this.step;
    },
    thumbContainerClasses: function thumbContainerClasses() {
      return {
        'slider__thumb-container': true,
        'slider__thumb-container--label': this.thumbLabel
      };
    },
    thumbStyles: function thumbStyles() {
      return {
        left: this.inputWidth + '%'
      };
    },
    tickContainerStyles: function tickContainerStyles() {
      return {
        transform: 'translate3d(0, -50%, 0)'
      };
    },
    trackStyles: function trackStyles() {
      var scaleX = this.calculateScale(1 - this.inputWidth / 100);
      var translateX = this.inputWidth < 1 && !this.isActive ? 8 + 'px' : 0;
      return {
        transform: 'scaleX(' + scaleX + ') translateX(' + translateX + ')'
      };
    },
    trackFillStyles: function trackFillStyles() {
      var inputWidth = this.inputWidth;
      var scaleX = this.calculateScale(inputWidth / 100);
      var translateX = inputWidth > 99 && !this.thumbLabel ? -8 + 'px' : 0;
      return {
        transform: 'scaleX(' + scaleX + ') translateX(' + translateX + ')'
      };
    },
    numTicks: function numTicks() {
      return parseInt((this.max - this.min) / this.step);
    }
  },

  watch: {
    value: function value() {
      this.inputValue = this.value;
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.inputValue = this.value;
    this.$nextTick(function () {
      _this.inputWidth = _this.calculateWidth(_this.inputValue);
    });

    // Without a v-app, iOS does not work with body selectors
    this.app = document.querySelector('[data-app]') || console.warn('The v-slider component requires the present of v-app or a non-body wrapping element with the [data-app] attribute.');
  },


  methods: {
    calculateWidth: function calculateWidth(val) {
      if (this.snap) {
        val = Math.round(val / this.step) * this.step;
      }

      val = (val - this.min) / (this.max - this.min) * 100;

      return val < 0.15 ? 0 : val;
    },
    calculateScale: function calculateScale(scale) {
      if (scale < 0.02 && !this.thumbLabel) {
        return 0;
      }

      return this.disabled ? scale - 0.015 : scale;
    },
    onMouseDown: function onMouseDown(e) {
      var options = { passive: true };
      this.isActive = true;

      if ('touches' in e) {
        this.app.addEventListener('touchmove', this.onMouseMove, options);
        Object(__WEBPACK_IMPORTED_MODULE_1__util_helpers__["a" /* addOnceEventListener */])(this.app, 'touchend', this.onMouseUp);
      } else {
        this.app.addEventListener('mousemove', this.onMouseMove, options);
        Object(__WEBPACK_IMPORTED_MODULE_1__util_helpers__["a" /* addOnceEventListener */])(this.app, 'mouseup', this.onMouseUp);
      }
    },
    onMouseUp: function onMouseUp() {
      var options = { passive: true };
      this.isActive = false;
      this.app.removeEventListener('touchmove', this.onMouseMove, options);
      this.app.removeEventListener('mousemove', this.onMouseMove, options);
    },
    onMouseMove: function onMouseMove(e) {
      var _$refs$track$getBound = this.$refs.track.getBoundingClientRect(),
          offsetLeft = _$refs$track$getBound.left,
          trackWidth = _$refs$track$getBound.width;

      var clientX = 'touches' in e ? e.touches[0].clientX : e.clientX;
      var left = (clientX - offsetLeft) / trackWidth * 100;

      left = left < 0 ? 0 : left > 100 ? 100 : left;

      this.inputValue = this.min + left / 100 * (this.max - this.min);
    },
    onKeyDown: function onKeyDown(e) {
      if (!e.keyCode === 37 && !e.keyCode === 39) return;

      var direction = e.keyCode === 37 && -1 || e.keyCode === 39 && 1 || 0;
      var multiplier = e.shiftKey && 3 || e.ctrlKey && 2 || 1;
      var amount = this.snap && this.step || 1;

      this.inputValue = this.inputValue + direction * amount * multiplier;
    },
    sliderMove: function sliderMove(e) {
      if (!this.isActive) {
        this.onMouseMove(e);
      }
    },
    genThumbLabel: function genThumbLabel(h) {
      return h('v-scale-transition', {
        props: { origin: 'bottom center' }
      }, [h('div', {
        'class': 'slider__thumb--label__container',
        directives: [{
          name: 'show',
          value: this.isActive
        }]
      }, [h('div', { 'class': 'slider__thumb--label' }, [h('span', {}, parseInt(this.inputValue))])])]);
    },
    genThumbContainer: function genThumbContainer(h) {
      var children = [];
      children.push(h('div', { 'class': 'slider__thumb' }));

      this.thumbLabel && children.push(this.genThumbLabel(h));

      return h('div', {
        'class': this.thumbContainerClasses,
        style: this.thumbStyles,
        on: {
          touchstart: this.onMouseDown,
          mousedown: this.onMouseDown
        },
        ref: 'thumb'
      }, children);
    },
    genSteps: function genSteps(h) {
      var _this2 = this;

      var ticks = Object(__WEBPACK_IMPORTED_MODULE_1__util_helpers__["c" /* createRange */])(this.numTicks + 1).map(function (i) {
        var span = h('span', {
          class: 'slider__tick',
          style: {
            left: i * (100 / _this2.numTicks) + '%'
          }
        });

        return span;
      });

      return h('div', {
        'class': 'slider__ticks-container',
        style: this.tickContainerStyles
      }, ticks);
    },
    genTrackContainer: function genTrackContainer(h) {
      var children = [h('div', {
        'class': 'slider__track',
        style: this.trackStyles
      }), h('div', {
        'class': 'slider__track-fill',
        style: this.trackFillStyles
      })];

      return h('div', {
        'class': 'slider__track__container',
        ref: 'track'
      }, children);
    }
  },

  render: function render(h) {
    var children = [];

    children.push(this.genTrackContainer(h));
    this.step && children.push(this.genSteps(h));
    children.push(this.genThumbContainer(h));

    var slider = h('div', { 'class': 'slider' }, children);

    return this.genInputGroup([slider], {
      attrs: {
        role: 'slider',
        tabindex: this.tabindex
      },
      on: Object.assign({}, {
        mouseup: this.sliderMove,
        keydown: this.onKeyDown
      }, this.$listeners),
      directives: [{
        name: 'click-outside'
      }]
    });
  }
});

/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VSubheader__ = __webpack_require__(110);


/* harmony default export */ __webpack_exports__["a"] = ({
  VSubheader: __WEBPACK_IMPORTED_MODULE_0__VSubheader__["a" /* default */]
});

/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    inset: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        children = _ref.children,
        props = _ref.props;

    data.staticClass = ('subheader ' + (data.staticClass || '')).trim();

    if (props.inset) data.staticClass += ' subheader--inset';
    if (props.light) data.staticClass += ' theme--light';
    if (props.dark) data.staticClass += ' theme--dark';

    return h('li', data, children);
  }
});

/***/ }),
/* 111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VStepper__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VStepperStep__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VStepperContent__ = __webpack_require__(114);





var VStepperHeader = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('stepper__header');

/* harmony default export */ __webpack_exports__["a"] = ({
  VStepper: __WEBPACK_IMPORTED_MODULE_1__VStepper__["a" /* default */],
  VStepperContent: __WEBPACK_IMPORTED_MODULE_3__VStepperContent__["a" /* default */],
  VStepperHeader: VStepperHeader,
  VStepperStep: __WEBPACK_IMPORTED_MODULE_2__VStepperStep__["a" /* default */]
});

/***/ }),
/* 112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-stepper',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  provide: function provide() {
    return {
      stepClick: this.stepClick
    };
  },
  data: function data() {
    return {
      inputValue: null,
      isBooted: false,
      steps: [],
      content: [],
      isReverse: false
    };
  },


  props: {
    nonLinear: Boolean,
    altLabels: Boolean,
    vertical: Boolean,
    value: [Number, String]
  },

  computed: {
    classes: function classes() {
      return {
        'stepper': true,
        'stepper--is-booted': this.isBooted,
        'stepper--vertical': this.vertical,
        'stepper--alt-labels': this.altLabels,
        'stepper--non-linear': this.nonLinear,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    }
  },

  watch: {
    inputValue: function inputValue(val, prev) {
      var _this = this;

      this.isReverse = Number(val) < Number(prev);
      this.steps.forEach(function (i) {
        return i.toggle(_this.inputValue);
      });
      this.content.forEach(function (i) {
        return i.toggle(_this.inputValue, _this.isReverse);
      });

      this.$emit('input', this.inputValue);
      prev && (this.isBooted = true);
    },
    value: function value() {
      this.inputValue = this.value;
    }
  },

  mounted: function mounted() {
    this.$vuetify.load(this.init);
  },


  methods: {
    init: function init() {
      var _this2 = this;

      this.$children.forEach(function (i) {
        if (i.$options._componentTag === 'v-stepper-step') {
          _this2.steps.push(i);
        } else if (i.$options._componentTag === 'v-stepper-content') {
          i.isVertical = _this2.vertical;
          _this2.content.push(i);
        }
      });

      this.inputValue = this.value || this.steps[0].step || 1;
    },
    stepClick: function stepClick(step) {
      this.inputValue = step;
    }
  },

  render: function render(h) {
    return h('div', {
      'class': this.classes
    }, this.$slots.default);
  }
});

/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-stepper-step',

  inject: ['stepClick'],

  data: function data() {
    return {
      isActive: false,
      isInactive: true
    };
  },


  props: {
    complete: Boolean,
    completeIcon: {
      type: String,
      default: 'check'
    },
    editIcon: {
      type: String,
      default: 'edit'
    },
    errorIcon: {
      type: String,
      default: 'warning'
    },
    editable: Boolean,
    rules: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    step: [Number, String]
  },

  computed: {
    classes: function classes() {
      return {
        'stepper__step': true,
        'stepper__step--active': this.isActive,
        'stepper__step--editable': this.editable,
        'stepper__step--inactive': this.isInactive,
        'stepper__step--error': this.hasError,
        'stepper__step--complete': this.complete
      };
    },
    hasError: function hasError() {
      return this.rules.some(function (i) {
        return i() !== true;
      });
    }
  },

  methods: {
    click: function click(e) {
      e.stopPropagation();

      if (this.editable) {
        this.stepClick(this.step);
      }
    },
    toggle: function toggle(step) {
      this.isActive = step.toString() === this.step.toString();
      this.isInactive = Number(step) < Number(this.step);
    }
  },

  render: function render(h) {
    var data = {
      'class': this.classes,
      directives: [{
        name: 'ripple',
        value: this.editable
      }],
      on: { click: this.click }
    };
    var stepContent = void 0;

    if (this.hasError) {
      stepContent = [h('v-icon', {}, this.errorIcon)];
    } else if (this.complete) {
      if (this.editable) {
        stepContent = [h('v-icon', {}, this.editIcon)];
      } else {
        stepContent = [h('v-icon', {}, this.completeIcon)];
      }
    } else {
      stepContent = this.step;
    }

    var step = h('span', { 'class': 'stepper__step__step' }, stepContent);
    var label = h('div', { 'class': 'stepper__label' }, this.$slots.default);

    return h('div', data, [step, label]);
  }
});

/***/ }),
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-stepper-content',

  data: function data() {
    return {
      height: 0,
      isActive: false,
      isReverse: false,
      isVertical: false
    };
  },


  props: {
    step: {
      type: [Number, String],
      required: true
    }
  },

  computed: {
    classes: function classes() {
      return {
        'stepper__content': true
      };
    },
    computedTransition: function computedTransition() {
      return this.isReverse ? 'v-tab-reverse-transition' : 'v-tab-transition';
    },
    styles: function styles() {
      if (!this.isVertical) return {};

      return {
        height: !isNaN(this.height) ? this.height + 'px' : this.height
      };
    },
    wrapperClasses: function wrapperClasses() {
      return {
        'stepper__wrapper': true
      };
    }
  },

  watch: {
    isActive: function isActive() {
      if (!this.isVertical) {
        return;
      }

      if (this.isActive) {
        this.enter();
      } else {
        this.leave();
      }
    }
  },

  mounted: function mounted() {
    this.$refs.wrapper.addEventListener('transitionend', this.onTransition, false);
  },
  beforeDestroy: function beforeDestroy() {
    this.$refs.wrapper.removeEventListener('transitionend', this.onTransition, false);
  },


  methods: {
    onTransition: function onTransition() {
      if (!this.isActive) return;

      this.height = 'auto';
    },
    enter: function enter() {
      var _this = this;

      var scrollHeight = 0;

      // Render bug with height
      setTimeout(function () {
        scrollHeight = _this.$refs.wrapper.scrollHeight;
      }, 0);

      this.height = 0;

      // Give the collapsing element time to collapse
      setTimeout(function () {
        return _this.height = scrollHeight || 'auto';
      }, 450);
    },
    leave: function leave() {
      var _this2 = this;

      this.height = this.$refs.wrapper.clientHeight;
      setTimeout(function () {
        return _this2.height = 0;
      }, 0);
    },
    toggle: function toggle(step, reverse) {
      this.isActive = step.toString() === this.step.toString();
      this.isReverse = reverse;
    }
  },

  render: function render(h) {
    var contentData = {
      'class': this.classes
    };
    var wrapperData = {
      'class': this.wrapperClasses,
      style: this.styles,
      ref: 'wrapper'
    };

    if (!this.isVertical) {
      contentData.directives = [{
        name: 'show',
        value: this.isActive
      }];
    }

    var wrapper = h('div', wrapperData, [this.$slots.default]);
    var content = h('div', contentData, [wrapper]);

    return h(this.computedTransition, {
      on: this.$listeners
    }, [content]);
  }
});

/***/ }),
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VTableOverflow */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VDataTable__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VEditDialog__ = __webpack_require__(121);




var VTableOverflow = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('table__overflow');

/* harmony default export */ __webpack_exports__["a"] = ({
  VDataTable: __WEBPACK_IMPORTED_MODULE_1__VDataTable__["a" /* default */],
  VEditDialog: __WEBPACK_IMPORTED_MODULE_2__VEditDialog__["a" /* default */],
  VTableOverflow: VTableOverflow
});

/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_head__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_body__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_foot__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_progress__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_filterable__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_buttons_VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_icons_VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_progress_VProgressLinear__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_selects_VSelect__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util_helpers__ = __webpack_require__(0);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };















/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-datatable',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_head__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_body__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_filterable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_foot__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_progress__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__mixins_themeable__["a" /* default */]],

  components: {
    VBtn: __WEBPACK_IMPORTED_MODULE_6__components_buttons_VBtn__["a" /* default */],
    VIcon: __WEBPACK_IMPORTED_MODULE_7__components_icons_VIcon__["a" /* default */],
    VProgressLinear: __WEBPACK_IMPORTED_MODULE_8__components_progress_VProgressLinear__["a" /* default */],
    VSelect: __WEBPACK_IMPORTED_MODULE_9__components_selects_VSelect__["a" /* default */],
    // Importing does not work properly
    'v-table-overflow': Object(__WEBPACK_IMPORTED_MODULE_10__util_helpers__["d" /* createSimpleFunctional */])('table__overflow')
  },

  data: function data() {
    return {
      all: false,
      searchLength: 0,
      defaultPagination: {
        page: 1,
        rowsPerPage: 5,
        descending: false,
        totalItems: 0
      }
    };
  },


  props: {
    headers: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    headerText: {
      type: String,
      default: 'text'
    },
    hideActions: Boolean,
    noResultsText: {
      type: String,
      default: 'No matching records found'
    },
    rowsPerPageItems: {
      type: Array,
      default: function _default() {
        return [5, 10, 25, { text: 'All', value: -1 }];
      }
    },
    rowsPerPageText: {
      type: String,
      default: 'Rows per page:'
    },
    selectAll: [Boolean, String],
    search: {
      required: false
    },
    filter: {
      type: Function,
      default: function _default(val, search) {
        return val !== null && ['undefined', 'boolean'].indexOf(typeof val === 'undefined' ? 'undefined' : _typeof(val)) === -1 && val.toString().toLowerCase().indexOf(search) !== -1;
      }
    },
    customFilter: {
      type: Function,
      default: function _default(items, search, filter) {
        search = search.toString().toLowerCase();
        return items.filter(function (i) {
          return Object.keys(i).some(function (j) {
            return filter(i[j], search);
          });
        });
      }
    },
    customSort: {
      type: Function,
      default: function _default(items, index, isDescending) {
        if (index === null) return items;

        return items.sort(function (a, b) {
          var sortA = Object(__WEBPACK_IMPORTED_MODULE_10__util_helpers__["g" /* getObjectValueByPath */])(a, index);
          var sortB = Object(__WEBPACK_IMPORTED_MODULE_10__util_helpers__["g" /* getObjectValueByPath */])(b, index);

          if (isDescending) {
            var _ref = [sortB, sortA];
            sortA = _ref[0];
            sortB = _ref[1];
          }

          // Check if both are numbers
          if (!isNaN(sortA) && !isNaN(sortB)) {
            return sortA - sortB;
          }

          // Check if both cannot be evaluated
          if (sortA === null && sortB === null) {
            return 0;
          }

          var _map = [sortA, sortB].map(function (s) {
            return (s || '').toString().toLocaleLowerCase();
          });

          var _map2 = _slicedToArray(_map, 2);

          sortA = _map2[0];
          sortB = _map2[1];


          if (sortA > sortB) return 1;
          if (sortA < sortB) return -1;

          return 0;
        });
      }
    },
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    items: {
      type: Array,
      required: true,
      default: function _default() {
        return [];
      }
    },
    totalItems: {
      type: Number,
      default: null
    },
    loading: {
      type: [Boolean, String],
      default: false
    },
    selectedKey: {
      type: String,
      default: 'id'
    },
    pagination: {
      type: Object,
      default: null
    }
  },

  computed: {
    classes: function classes() {
      return {
        'datatable table': true,
        'datatable--select-all': this.selectAll !== false,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    },
    computedPagination: function computedPagination() {
      return this.pagination || this.defaultPagination;
    },
    hasSelectAll: function hasSelectAll() {
      return this.selectAll !== undefined && this.selectAll !== false;
    },
    itemsLength: function itemsLength() {
      if (this.search) return this.searchLength;
      return this.totalItems || this.items.length;
    },
    indeterminate: function indeterminate() {
      return this.hasSelectAll && this.someItems && !this.everyItem;
    },
    everyItem: function everyItem() {
      var _this = this;

      return this.filteredItems.length && this.filteredItems.every(function (i) {
        return _this.isSelected(i);
      });
    },
    someItems: function someItems() {
      var _this2 = this;

      return this.filteredItems.some(function (i) {
        return _this2.isSelected(i);
      });
    },
    getPage: function getPage() {
      var rowsPerPage = this.computedPagination.rowsPerPage;


      return rowsPerPage === Object(rowsPerPage) ? rowsPerPage.value : rowsPerPage;
    },
    pageStart: function pageStart() {
      return this.getPage === -1 ? 0 : (this.computedPagination.page - 1) * this.getPage;
    },
    pageStop: function pageStop() {
      return this.getPage === -1 ? this.itemsLength : this.computedPagination.page * this.getPage;
    },
    filteredItems: function filteredItems() {
      if (this.totalItems) return this.items;

      var items = this.items.slice();
      var hasSearch = typeof this.search !== 'undefined' && this.search !== null;

      if (hasSearch) {
        items = this.customFilter(items, this.search, this.filter);
        this.searchLength = items.length;
      }

      items = this.customSort(items, this.computedPagination.sortBy, this.computedPagination.descending);

      return this.hideActions && !this.pagination ? items : items.slice(this.pageStart, this.pageStop);
    },
    selected: function selected() {
      var _this3 = this;

      var selected = {};
      this.value.forEach(function (i) {
        return selected[i[_this3.selectedKey]] = true;
      });
      return selected;
    }
  },

  watch: {
    indeterminate: function indeterminate(val) {
      if (val) this.all = true;
    },
    someItems: function someItems(val) {
      if (!val) this.all = false;
    },
    search: function search() {
      this.updatePagination({ page: 1 });
    },
    everyItem: function everyItem(val) {
      if (val) this.all = true;
    }
  },

  methods: {
    updatePagination: function updatePagination(val) {
      var pagination = this.pagination || this.defaultPagination;
      var updatedPagination = Object.assign({}, pagination, val);

      if (this.pagination) {
        this.$emit('update:pagination', updatedPagination);
      } else {
        this.defaultPagination = updatedPagination;
      }
    },
    isSelected: function isSelected(item) {
      return this.selected[item[this.selectedKey]];
    },
    sort: function sort(index) {
      var _computedPagination = this.computedPagination,
          sortBy = _computedPagination.sortBy,
          descending = _computedPagination.descending;

      if (sortBy === null) {
        this.updatePagination({ sortBy: index, descending: false });
      } else if (sortBy === index && !descending) {
        this.updatePagination({ descending: true });
      } else if (sortBy !== index) {
        this.updatePagination({ sortBy: index, descending: false });
      } else {
        this.updatePagination({ sortBy: null, descending: null });
      }
    },
    needsTR: function needsTR(row) {
      return row.length && row.find(function (c) {
        return c.tag === 'td';
      });
    },
    genTR: function genTR(children) {
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return this.$createElement('tr', data, children);
    },
    toggle: function toggle(value) {
      var _this4 = this;

      var selected = Object.assign({}, this.selected);
      this.filteredItems.forEach(function (i) {
        return selected[i[_this4.selectedKey]] = value;
      });

      this.$emit('input', this.items.filter(function (i) {
        return selected[i[_this4.selectedKey]];
      }));
    }
  },

  created: function created() {
    var firstSortable = this.headers.find(function (h) {
      return !('sortable' in h) || h.sortable;
    });

    this.defaultPagination.sortBy = firstSortable ? firstSortable.value : null;

    if (!this.rowsPerPageItems.length) {
      console.warn('The prop \'rows-per-page-items\' in v-data-table can not be empty.');
    } else {
      this.defaultPagination.rowsPerPage = this.rowsPerPageItems[0];
    }

    this.updatePagination(Object.assign({}, this.defaultPagination, this.pagination));
  },
  render: function render(h) {
    return h('v-table-overflow', {}, [h('table', {
      'class': this.classes
    }, [this.genTHead(), this.genTProgress(), this.genTBody(), this.genTFoot()])]);
  }
});

/***/ }),
/* 117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genTHead: function genTHead() {
      var _this = this;

      var children = [];

      if (this.$scopedSlots.headers) {
        var row = this.$scopedSlots.headers({
          headers: this.headers,
          indeterminate: this.indeterminate,
          all: this.all
        });

        children = this.needsTR(row) ? this.genTR(row) : row;
      } else {
        var _row = this.headers.map(function (o) {
          return _this.genHeader(o);
        });
        var checkbox = this.$createElement('v-checkbox', {
          props: {
            dark: this.dark,
            light: this.light,
            color: this.selectAll === true && '' || this.selectAll,
            hideDetails: true,
            inputValue: this.all,
            indeterminate: this.indeterminate
          },
          on: { change: this.toggle }
        });

        this.hasSelectAll && _row.unshift(this.$createElement('th', [checkbox]));

        children = this.genTR(_row);
      }

      return this.$createElement('thead', [children]);
    },
    genHeader: function genHeader(header) {
      var array = [this.$scopedSlots.headerCell ? this.$scopedSlots.headerCell({ header: header }) : header[this.headerText]];

      return this.$createElement.apply(this, ['th'].concat(_toConsumableArray(this.genHeaderData(header, array))));
    },
    genHeaderData: function genHeaderData(header, children) {
      var _this2 = this;

      var classes = ['column'];
      var data = {};
      var pagination = this.computedPagination;

      if ('sortable' in header && header.sortable || !('sortable' in header)) {
        data.on = { click: function click() {
            return _this2.sort(header.value);
          } };
        if (!('value' in header)) {
          console.warn('Data table headers must have a value property that corresponds to a value in the v-model array');
        }

        classes.push('sortable');
        var icon = this.$createElement('v-icon', 'arrow_upward');
        if (header.align && header.align === 'left') {
          children.push(icon);
        } else {
          children.unshift(icon);
        }

        var beingSorted = pagination.sortBy === header.value;
        if (beingSorted) {
          classes.push('active');
          classes.push(pagination.descending ? 'desc' : 'asc');
        }
      }

      classes.push('text-xs-' + (header.align || 'right'));
      data.class = classes;

      return [data, children];
    }
  }
});

/***/ }),
/* 118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genTBody: function genTBody() {
      var children = [];

      if (!this.itemsLength) {
        children.push(this.genEmptyBody(this.noDataText));
      } else if (!this.filteredItems.length) {
        children.push(this.genEmptyBody(this.noResultsText));
      } else {
        children.push(this.genFilteredItems());
      }

      return this.$createElement('tbody', children);
    },
    genFilteredItems: function genFilteredItems() {
      var _this = this;

      return this.filteredItems.map(function (item, index) {
        var props = { item: item, index: index };
        var key = _this.selectedKey;

        Object.defineProperty(props, 'selected', {
          get: function get() {
            return _this.selected[item[_this.selectedKey]];
          },
          set: function set(value) {
            var selected = _this.value.slice();
            if (value) selected.push(item);else selected = selected.filter(function (i) {
              return i[key] !== item[key];
            });

            _this.$emit('input', selected);
          }
        });

        var row = _this.$scopedSlots.items(props);

        return _this.needsTR(row) ? _this.genTR(row, {
          attrs: { active: _this.isSelected(item) }
        }) : row;
      });
    },
    genEmptyBody: function genEmptyBody(text) {
      return this.genTR([this.$createElement('td', {
        'class': 'text-xs-center',
        attrs: { colspan: '100%' }
      }, text)]);
    }
  }
});

/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genPrevIcon: function genPrevIcon() {
      var _this = this;

      return this.$createElement('v-btn', {
        props: {
          disabled: this.computedPagination.page === 1,
          icon: true,
          flat: true,
          dark: this.dark,
          light: this.light
        },
        on: {
          click: function click() {
            var page = _this.computedPagination.page;
            _this.updatePagination({ page: page - 1 });
          }
        }
      }, [this.$createElement('v-icon', 'chevron_left')]);
    },
    genNextIcon: function genNextIcon() {
      var _this2 = this;

      var pagination = this.computedPagination;
      var disabled = pagination.rowsPerPage < 0 || pagination.page * pagination.rowsPerPage >= this.itemsLength || this.pageStop < 0;

      return this.$createElement('v-btn', {
        props: {
          disabled: disabled,
          icon: true,
          flat: true,
          dark: this.dark,
          light: this.light
        },
        on: {
          click: function click() {
            var page = _this2.computedPagination.page;
            _this2.updatePagination({ page: page + 1 });
          }
        }
      }, [this.$createElement('v-icon', 'chevron_right')]);
    },
    genSelect: function genSelect() {
      var _this3 = this;

      return this.$createElement('div', {
        'class': 'datatable__actions__select'
      }, [this.rowsPerPageText, this.$createElement('v-select', {
        props: {
          items: this.rowsPerPageItems,
          value: this.computedPagination.rowsPerPage,
          hideDetails: true,
          auto: true,
          minWidth: '75px'
        },
        on: {
          input: function input(val) {
            _this3.updatePagination({
              page: 1,
              rowsPerPage: val
            });
          }
        }
      })]);
    },
    genPagination: function genPagination() {
      var pagination = '–';

      if (this.itemsLength) {
        var stop = this.itemsLength < this.pageStop || this.pageStop < 0 ? this.itemsLength : this.pageStop;

        pagination = this.$scopedSlots.pageText ? this.$scopedSlots.pageText({
          pageStart: this.pageStart + 1,
          pageStop: stop,
          itemsLength: this.itemsLength
        }) : this.pageStart + 1 + '-' + stop + ' of ' + this.itemsLength;
      }

      return this.$createElement('div', {
        'class': 'datatable__actions__pagination'
      }, [pagination]);
    },
    genActions: function genActions() {
      return [this.$createElement('div', {
        'class': 'datatable__actions'
      }, [this.genSelect(), this.genPagination(), this.genPrevIcon(), this.genNextIcon()])];
    },
    genTFoot: function genTFoot() {
      var children = [];

      if (this.$slots.footer) {
        var footer = this.$slots.footer;
        var row = this.needsTR(footer) ? this.genTR(footer) : footer;

        children.push(row);
      }

      if (!this.hideActions) {
        children.push(this.genTR([this.$createElement('td', {
          attrs: { colspan: '100%' }
        }, this.genActions())]));
      }

      if (!children.length) return null;
      return this.$createElement('tfoot', children);
    }
  }
});

/***/ }),
/* 120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      color: ''
    };
  },


  watch: {
    loading: function loading(val) {
      if (val) this.color = val;
    }
  },

  methods: {
    genTProgress: function genTProgress() {
      var loader = this.$createElement('v-progress-linear', {
        props: {
          primary: this.color === 'primary',
          secondary: this.color === 'secondary',
          success: this.color === 'success',
          info: this.color === 'info',
          warning: this.color === 'warning',
          error: this.color === 'error',
          indeterminate: true,
          height: 3,
          active: !!this.loading
        }
      });

      var col = this.$createElement('th', {
        class: 'column',
        attrs: {
          colspan: '100%'
        }
      }, [loader]);

      return this.$createElement('thead', {
        class: 'datatable__progress'
      }, [this.genTR([col])]);
    }
  }
});

/***/ }),
/* 121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-edit-dialog',

  data: function data() {
    return {
      isActive: false,
      isSaving: false
    };
  },


  props: {
    cancelText: {
      default: 'Cancel'
    },
    large: Boolean,
    lazy: Boolean,
    saveText: {
      default: 'Save'
    },
    transition: {
      type: String,
      default: 'slide-x-reverse-transition'
    }
  },

  watch: {
    isActive: function isActive(val) {
      val && this.$emit('open') && setTimeout(this.focus, 50); // Give DOM time to paint

      if (!val) {
        !this.isSaving && this.$emit('cancel');
        this.isSaving && this.$emit('close');
        this.isSaving = false;
      }
    }
  },

  methods: {
    cancel: function cancel() {
      this.isActive = false;
    },
    focus: function focus() {
      var input = this.$refs.content.querySelector('input');
      input && input.focus();
    },
    save: function save() {
      this.isSaving = true;
      this.isActive = false;
      this.$emit('save');
    },
    genButton: function genButton(fn, text) {
      return this.$createElement('v-btn', {
        props: {
          flat: true,
          primary: true,
          light: true
        },
        on: { click: fn }
      }, text);
    },
    genActions: function genActions() {
      return this.$createElement('div', {
        'class': 'small-dialog__actions',
        directives: [{
          name: 'show',
          value: this.large
        }]
      }, [this.genButton(this.cancel, this.cancelText), this.genButton(this.save, this.saveText)]);
    },
    genContent: function genContent() {
      var _this = this;

      return this.$createElement('div', {
        'class': 'small-dialog__content',
        on: {
          keydown: function keydown(e) {
            e.keyCode === 27 && _this.cancel();
            e.keyCode === 13 && _this.save();
          }
        },
        ref: 'content'
      }, [this.$slots.input]);
    }
  },

  render: function render(h) {
    var _this2 = this;

    return h('v-menu', {
      'class': 'small-dialog',
      props: {
        transition: this.transition,
        origin: 'top right',
        right: true,
        value: this.isActive,
        closeOnContentClick: false,
        lazy: this.lazy
      },
      on: {
        input: function input(val) {
          return _this2.isActive = val;
        }
      }
    }, [h('a', {
      domProps: { href: 'javascript:;' },
      slot: 'activator'
    }, this.$slots.default), this.genContent(), this.genActions()]);
  }
});

/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VTabs__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VTabsItem__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VTabsContent__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__VTabsBar__ = __webpack_require__(126);






var VTabsSlider = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('tabs__slider', 'li');

var VTabsItems = {
  name: 'v-tabs-items',

  render: function render(h) {
    return h('div', { 'class': { 'tabs__items': true } }, [this.$slots.default]);
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  VTabsItem: __WEBPACK_IMPORTED_MODULE_2__VTabsItem__["a" /* default */],
  VTabsItems: VTabsItems,
  VTabs: __WEBPACK_IMPORTED_MODULE_1__VTabs__["a" /* default */],
  VTabsContent: __WEBPACK_IMPORTED_MODULE_3__VTabsContent__["a" /* default */],
  VTabsBar: __WEBPACK_IMPORTED_MODULE_4__VTabsBar__["a" /* default */],
  VTabsSlider: VTabsSlider
});

/***/ }),
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__directives__ = __webpack_require__(4);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-tabs',

  directives: {
    Resize: __WEBPACK_IMPORTED_MODULE_1__directives__["Resize"]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  provide: function provide() {
    var _this = this;

    return {
      slider: this.slider,
      tabClick: this.tabClick,
      isScrollable: function isScrollable() {
        return _this.scrollable;
      },
      isMobile: function isMobile() {
        return _this.isMobile;
      }
    };
  },
  data: function data() {
    return {
      activators: [],
      activeIndex: null,
      isMobile: false,
      reverse: false,
      target: null,
      tabsSlider: null,
      targetEl: null,
      tabsContainer: null
    };
  },


  props: {
    centered: Boolean,
    fixed: Boolean,
    grow: Boolean,
    icons: Boolean,
    mobileBreakPoint: {
      type: [Number, String],
      default: 1024
    },
    value: String,
    scrollable: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    classes: function classes() {
      return {
        'tabs': true,
        'tabs--centered': this.centered,
        'tabs--fixed': this.fixed,
        'tabs--grow': this.grow,
        'tabs--icons': this.icons,
        'tabs--mobile': this.isMobile,
        'tabs--scroll-bars': this.scrollable,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    }
  },

  watch: {
    value: function value() {
      this.tabClick(this.value);
    },
    activeIndex: function activeIndex() {
      this.updateTabs();
      this.$emit('input', this.target);
      this.isBooted = true;
    }
  },

  mounted: function mounted() {
    var _this2 = this;

    this.$vuetify.load(function () {
      var activators = _this2.$slots.activators;

      if (!activators || !activators.length || !activators[0].componentInstance) return;

      var bar = activators[0].componentInstance.$children;
      // // This is a workaround to detect if link is active
      // // when being used as a router or nuxt link
      var i = bar.findIndex(function (t) {
        return t.$el.firstChild.classList.contains('tabs__item--active');
      });

      var tab = _this2.value || (bar[i !== -1 ? i : 0] || {}).action;

      tab && _this2.tabClick(tab) && _this2.onResize();
    });
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.resize, { passive: true });
  },


  methods: {
    onResize: function onResize() {
      this.isMobile = window.innerWidth < this.mobileBreakPoint;
      this.slider();
    },
    slider: function slider(el) {
      var _this3 = this;

      this.tabsSlider = this.tabsSlider || this.$el.querySelector('.tabs__slider');

      this.tabsContainer = this.tabsContainer || this.$el.querySelector('.tabs__container');

      if (!this.tabsSlider || !this.tabsContainer) return;

      this.targetEl = el || this.targetEl;

      if (!this.targetEl || !this.tabsContainer) return;

      // Gives DOM time to paint when
      // processing slider for
      // dynamic tabs
      this.$nextTick(function () {
        // #684 Calculate width as %
        var width = _this3.targetEl.scrollWidth / _this3.tabsContainer.clientWidth * 100;

        _this3.tabsSlider.style.width = width + '%';
        _this3.tabsSlider.style.left = _this3.targetEl.offsetLeft + 'px';
      });
    },
    tabClick: function tabClick(target) {
      var _this4 = this;

      var setActiveIndex = function setActiveIndex(index) {
        if (_this4.activeIndex === index) {
          // #762 update tabs display
          // In case tabs count got changed but activeIndex didn't
          _this4.updateTabs();
        } else {
          _this4.activeIndex = index;
        }
      };

      this.target = target;

      var content = this.$refs.content;
      if (!content) {
        setActiveIndex(target);
        return;
      }

      this.$nextTick(function () {
        var nextIndex = content.$children.findIndex(function (i) {
          return i.id === target;
        });
        _this4.reverse = nextIndex < _this4.activeIndex;
        setActiveIndex(nextIndex);
      });
    },
    updateTabs: function updateTabs() {
      var _this5 = this;

      var activators = this.$slots.activators;
      var content = this.$refs.content;

      if (!activators || !activators.length || activators.length && !activators[0].componentInstance) return;

      activators[0].componentInstance.$children.filter(function (i) {
        return i.$options._componentTag === 'v-tabs-item';
      }).forEach(function (i) {
        return i.toggle(_this5.target);
      });

      content && content.$children.forEach(function (i) {
        return i.toggle(_this5.target, _this5.reverse, _this5.isBooted);
      });
    }
  },

  render: function render(h) {
    var content = [];
    var slot = [];
    var iter = this.$slots.default || [];

    iter.forEach(function (c) {
      if (!c.componentOptions) slot.push(c);else if (c.componentOptions.tag === 'v-tabs-content') content.push(c);else slot.push(c);
    });

    var tabs = content.length ? h('v-tabs-items', {
      ref: 'content'
    }, content) : null;

    return h('div', {
      'class': this.classes,
      directives: [{
        name: 'resize',
        value: this.onResize
      }]
    }, [slot, this.$slots.activators, tabs]);
  }
});

/***/ }),
/* 124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_route_link__ = __webpack_require__(9);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-tabs-item',

  inject: ['slider', 'tabClick'],

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_route_link__["a" /* default */]],

  data: function data() {
    return {
      isActive: false
    };
  },


  props: {
    activeClass: {
      type: String,
      default: 'tabs__item--active'
    }
  },

  computed: {
    classes: function classes() {
      var classes = {
        'tabs__item': true,
        'tabs__item--disabled': this.disabled
      };

      classes[this.activeClass] = !this.to && this.isActive;

      return classes;
    },
    action: function action() {
      var to = this.to || this.href;

      if (!to || to === Object(to)) return this._uid;

      return to.replace('#', '');
    }
  },

  watch: {
    $route: function $route() {
      this.to && this.callSlider();
    }
  },

  mounted: function mounted() {
    this.callSlider();
  },


  methods: {
    callSlider: function callSlider() {
      var _this = this;

      setTimeout(function () {
        _this.$el.firstChild.classList.contains('tabs__item--active') && _this.slider(_this.$el);
      }, 0);
    },
    click: function click(e) {
      e.preventDefault();

      if (!this.to && !this.href) return;

      if (!this.to) {
        this.tabClick(this.action);
      }

      this.callSlider();
    },
    toggle: function toggle(action) {
      var _this2 = this;

      this.isActive = this.action === action;

      this.$nextTick(function () {
        _this2.isActive && _this2.slider(_this2.$el);
      });
    }
  },

  render: function render(h) {
    var _generateRouteLink = this.generateRouteLink(),
        tag = _generateRouteLink.tag,
        data = _generateRouteLink.data;

    return h('li', {
      'class': 'tabs__li'
    }, [h(tag, data, this.$slots.default)]);
  }
});

/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_bootable__ = __webpack_require__(10);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-tabs-content',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_bootable__["a" /* default */]],

  data: function data() {
    return {
      isActive: false,
      reverse: false
    };
  },


  props: {
    id: {
      type: String,
      required: true
    },
    lazy: Boolean,
    transition: {
      type: String,
      default: 'v-tab-transition'
    },
    reverseTransition: {
      type: String,
      default: 'v-tab-reverse-transition'
    }
  },

  computed: {
    computedTransition: function computedTransition() {
      return this.reverse ? this.reverseTransition : this.transition;
    }
  },

  methods: {
    toggle: function toggle(target, reverse, showTransition) {
      this.$el.style.transition = !showTransition ? 'none' : null;
      this.reverse = reverse;
      this.isActive = this.id === target;
    }
  },

  render: function render(h) {
    return h(this.computedTransition, {}, [h('div', {
      'class': 'tabs__content',
      domProps: { id: this.id },
      directives: [{
        name: 'show',
        value: this.isActive
      }],
      on: this.$listeners
    }, this.lazy && this.isBooted || !this.lazy ? this.$slots.default : null)]);
  }
});

/***/ }),
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_icons_VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__directives__ = __webpack_require__(4);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-tabs-bar',

  directives: {
    Resize: __WEBPACK_IMPORTED_MODULE_1__directives__["Resize"]
  },

  inject: ['isScrollable', 'isMobile'],

  data: function data() {
    return {
      isOverflowing: false,
      scrollOffset: 0,
      itemOffset: 0,
      startX: 0
    };
  },


  computed: {
    classes: function classes() {
      return {
        'tabs__bar': true
      };
    },
    containerClasses: function containerClasses() {
      return {
        'tabs__container': true
      };
    },
    wrapperClasses: function wrapperClasses() {
      return {
        'tabs__wrapper': true,
        'tabs__wrapper--scrollable': this.isScrollable(),
        'tabs__wrapper--overflow': this.isOverflowing
      };
    },
    containerStyles: function containerStyles() {
      return {
        'transform': 'translateX(' + -this.scrollOffset + 'px)'
      };
    },
    leftIconVisible: function leftIconVisible() {
      return !this.isMobile() && this.isScrollable() && this.isOverflowing && this.scrollOffset > 0;
    },
    rightIconVisible: function rightIconVisible() {
      if (this.isMobile() || !this.isScrollable() || !this.isOverflowing) return;

      // Check one scroll ahead to know the width of right-most item
      var container = this.$refs.container;
      var item = this.newOffsetRight(this.scrollOffset, this.itemOffset);
      var itemWidth = item && container.children[item.index].clientWidth || 0;
      var scrollOffset = this.scrollOffset + container.clientWidth;

      return container.scrollWidth - scrollOffset > itemWidth * 0.30;
    }
  },

  methods: {
    genContainer: function genContainer() {
      return this.$createElement('ul', {
        'class': this.containerClasses,
        'style': this.containerStyles,
        ref: 'container'
      }, this.$slots.default);
    },
    genIcon: function genIcon(direction) {
      var capitalize = direction.charAt(0).toUpperCase() + direction.slice(1);
      return this.$createElement(__WEBPACK_IMPORTED_MODULE_0__components_icons_VIcon__["a" /* default */], {
        props: _defineProperty({}, '' + direction, true),
        style: { display: 'inline-flex' },
        on: {
          click: this['scroll' + capitalize]
        }
      }, 'chevron_' + direction);
    },
    genWrapper: function genWrapper() {
      return this.$createElement('div', {
        class: this.wrapperClasses,
        directives: [{
          name: 'touch',
          value: {
            start: this.start,
            move: this.move,
            end: this.end
          }
        }]
      }, [this.genContainer()]);
    },
    start: function start(e) {
      this.startX = this.scrollOffset + e.touchstartX;
      this.$refs.container.style.transition = 'none';
    },
    move: function move(e) {
      var offset = this.startX - e.touchmoveX;
      this.scrollOffset = offset;
    },
    end: function end(e) {
      this.onResize();
      var container = this.$refs.container;
      var scrollWidth = container.scrollWidth - this.$el.clientWidth / 2;
      container.style.transition = null;

      if (this.scrollOffset < 0 || !this.isOverflowing) {
        this.scrollOffset = 0;
      } else if (this.scrollOffset >= scrollWidth) {
        var lastItem = container.children[container.children.length - 1];
        this.scrollOffset = scrollWidth - lastItem.clientWidth;
      }
    },
    scrollLeft: function scrollLeft() {
      var _newOffset = this.newOffset('Left'),
          offset = _newOffset.offset,
          index = _newOffset.index;

      this.scrollOffset = offset;
      this.itemOffset = index;
    },
    scrollRight: function scrollRight() {
      var _newOffset2 = this.newOffset('Right'),
          offset = _newOffset2.offset,
          index = _newOffset2.index;

      this.scrollOffset = offset;
      this.itemOffset = index;
    },
    onResize: function onResize() {
      if (this._isDestroyed) return;

      var container = this.$refs.container;
      this.isOverflowing = container.clientWidth < container.scrollWidth;
    },
    newOffset: function newOffset(direction) {
      return this['newOffset' + direction](this.scrollOffset, this.itemOffset);
    },
    newOffsetLeft: function newOffsetLeft(currentOffset, currentIndex) {
      var container = this.$refs.container;
      var items = container.children;
      var offset = 0;

      for (var index = currentIndex - 1; index >= 0; index--) {
        if (!items[index].classList.contains('tabs__slider')) {
          var newOffset = offset + items[index].clientWidth;
          if (newOffset >= container.clientWidth) {
            return { offset: currentOffset - offset, index: index + 1 };
          }
          offset = newOffset;
        }
      }

      return { offset: 0, index: 0 };
    },
    newOffsetRight: function newOffsetRight(currentOffset, currentIndex) {
      var container = this.$refs.container;
      var items = container.children;
      var offset = currentOffset;

      for (var index = currentIndex; index < items.length; index++) {
        if (!items[index].classList.contains('tabs__slider')) {
          var newOffset = offset + items[index].clientWidth;
          if (newOffset > currentOffset + container.clientWidth) {
            return { offset: offset, index: index };
          }
          offset = newOffset;
        }
      }

      return null;
    }
  },

  render: function render(h) {
    return h('div', {
      'class': this.classes,
      directives: [{
        name: 'resize',
        value: this.onResize
      }]
    }, [this.genWrapper(), this.leftIconVisible ? this.genIcon('left') : null, this.rightIconVisible ? this.genIcon('right') : null]);
  }
});

/***/ }),
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VTextField__ = __webpack_require__(128);


/* harmony default export */ __webpack_exports__["a"] = ({
  VTextField: __WEBPACK_IMPORTED_MODULE_0__VTextField__["a" /* default */]
});

/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_input__ = __webpack_require__(7);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-text-field',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_input__["a" /* default */]],

  inheritAttrs: false,

  data: function data() {
    return {
      hasFocused: false,
      inputHeight: null
    };
  },


  props: {
    autofocus: Boolean,
    autoGrow: Boolean,
    counter: Boolean,
    fullWidth: Boolean,
    max: [Number, String],
    min: [Number, String],
    multiLine: Boolean,
    placeholder: String,
    prefix: String,
    rows: {
      default: 5
    },
    singleLine: Boolean,
    solo: Boolean,
    suffix: String,
    textarea: Boolean,
    type: {
      type: String,
      default: 'text'
    }
  },

  computed: {
    classes: function classes() {
      return {
        'input-group--text-field': true,
        'input-group--single-line': this.singleLine,
        'input-group--solo': this.solo,
        'input-group--multi-line': this.multiLine,
        'input-group--full-width': this.fullWidth,
        'input-group--prefix': this.prefix,
        'input-group--suffix': this.suffix,
        'input-group--textarea': this.textarea
      };
    },
    hasError: function hasError() {
      return this.validations.length || this.errorMessages.length > 0 || !this.counterIsValid() || !this.validateIsValid() || this.error;
    },
    count: function count() {
      var inputLength = void 0;
      if (this.inputValue) inputLength = this.inputValue.toString().length;else inputLength = 0;
      var min = inputLength;

      if (this.counterMin !== 0 && inputLength < this.counterMin) {
        min = this.counterMin;
      }

      return min + ' / ' + this.counterMax;
    },
    counterMin: function counterMin() {
      var parsedMin = parseInt(this.min, 10);
      return isNaN(parsedMin) ? 0 : parsedMin;
    },
    counterMax: function counterMax() {
      var parsedMax = parseInt(this.max, 10);
      return isNaN(parsedMax) ? 25 : parsedMax;
    },

    inputValue: {
      get: function get() {
        return this.value;
      },
      set: function set(val) {
        if (this.modifiers.trim) {
          val = val.trim();
        }

        if (this.modifiers.number) {
          val = Number(val);
        }

        if (!this.modifiers.lazy) {
          this.$emit('input', val);
        }

        this.lazyValue = val;
      }
    },
    isDirty: function isDirty() {
      return this.lazyValue !== null && typeof this.lazyValue !== 'undefined' && this.lazyValue.toString().length > 0 || this.placeholder;
    }
  },

  watch: {
    focused: function focused(val) {
      this.hasFocused = true;
    },
    value: function value() {
      this.lazyValue = this.value;
      this.validate();
      this.multiLine && this.autoGrow && this.calculateInputHeight();
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.$vuetify.load(function () {
      _this.multiLine && _this.autoGrow && _this.calculateInputHeight();
      _this.autofocus && _this.focus();
    });
  },


  methods: {
    calculateInputHeight: function calculateInputHeight() {
      var _this2 = this;

      this.inputHeight = null;

      this.$nextTick(function () {
        var height = _this2.$refs.input.scrollHeight;
        var minHeight = _this2.rows * 24;
        var inputHeight = height < minHeight ? minHeight : height;
        _this2.inputHeight = inputHeight;
      });
    },
    onChange: function onChange(e) {
      this.lazyValue = e.target.value;
      this.$emit('change', this.lazyValue || null);
    },
    onInput: function onInput(e) {
      this.inputValue = e.target.value;
      this.multiLine && this.autoGrow && this.calculateInputHeight();
    },
    blur: function blur(e) {
      var _this3 = this;

      this.validate();
      this.$nextTick(function () {
        return _this3.focused = false;
      });
      this.$emit('blur', e);
    },
    focus: function focus(e) {
      this.focused = true;
      this.$refs.input.focus();
      this.$emit('focus', e);
    },
    genCounter: function genCounter() {
      return this.$createElement('div', {
        'class': {
          'input-group__counter': true,
          'input-group__counter--error': !this.counterIsValid()
        }
      }, this.count);
    },
    genInput: function genInput() {
      var tag = this.multiLine || this.textarea ? 'textarea' : 'input';

      var data = {
        style: {
          'height': this.inputHeight && this.inputHeight + 'px'
        },
        domProps: {
          autofocus: this.autofocus,
          disabled: this.disabled,
          required: this.required,
          value: this.lazyValue
        },
        attrs: _extends({}, this.$attrs, {
          tabindex: this.tabindex,
          'aria-label': !this.$attrs.id && this.label // Label `for` will be set if we have an id
        }),
        on: _extends({}, this.$listeners, {
          blur: this.blur,
          input: this.onInput,
          focus: this.focus
        }),
        ref: 'input'
      };

      if (this.placeholder) data.domProps.placeholder = this.placeholder;

      if (!this.counter) {
        if (![undefined, null].includes(this.max)) data.attrs.max = this.max;
        if (![undefined, null].includes(this.min)) data.attrs.min = this.min;
      }

      if (!this.textarea && !this.multiLine) {
        data.domProps.type = this.type;
      } else {
        data.domProps.rows = this.rows;
      }

      var children = [this.$createElement(tag, data)];

      this.prefix && children.unshift(this.genFix('prefix'));
      this.suffix && children.push(this.genFix('suffix'));

      return children;
    },
    genFix: function genFix(type) {
      return this.$createElement('span', {
        'class': 'input-group--text-field__' + type
      }, this[type]);
    },

    counterIsValid: function counterIsValid() {
      var val = this.inputValue && this.inputValue.toString() || '';

      return !this.counter || val.length >= this.counterMin && val.length <= this.counterMax;
    },
    validateIsValid: function validateIsValid() {
      return !this.required || this.required && this.isDirty || !this.hasFocused || this.hasFocused && this.focused;
    }
  },

  render: function render() {
    return this.genInputGroup(this.genInput(), { attrs: { tabindex: false } });
  }
});

/***/ }),
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VSnackbar__ = __webpack_require__(130);


/* harmony default export */ __webpack_exports__["a"] = ({
  VSnackbar: __WEBPACK_IMPORTED_MODULE_0__VSnackbar__["a" /* default */]
});

/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-snackbar',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */]],

  data: function data() {
    return {
      activeTimeout: {}
    };
  },


  props: {
    absolute: Boolean,
    bottom: Boolean,
    left: Boolean,
    multiLine: Boolean,
    right: Boolean,
    top: Boolean,
    timeout: {
      type: Number,
      default: 6000
    },
    vertical: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'snack': true,
        'snack--active': this.isActive,
        'snack--absolute': this.absolute,
        'snack--bottom': this.bottom || !this.top,
        'snack--left': this.left,
        'snack--multi-line': this.multiLine && !this.vertical,
        'snack--right': this.right,
        'snack--top': this.top,
        'snack--vertical': this.vertical,
        'primary': this.primary,
        'secondary': this.secondary,
        'success': this.success,
        'info': this.info,
        'warning': this.warning,
        'error': this.error
      };
    },
    computedTransition: function computedTransition() {
      return this.top ? 'v-slide-y-transition' : 'v-slide-y-reverse-transition';
    }
  },

  watch: {
    isActive: function isActive() {
      var _this = this;

      clearTimeout(this.activeTimeout);

      if (this.isActive && this.timeout) {
        this.activeTimeout = setTimeout(function () {
          _this.isActive = false;
        }, this.timeout);
      }
    }
  },

  render: function render(h) {
    var children = [];

    if (this.isActive) {
      children.push(h('div', {
        'class': 'snack__content'
      }, this.$slots.default));
    }

    return h('div', {
      'class': this.classes,
      on: this.$listeners
    }, [h(this.computedTransition, children)]);
  }
});

/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function load(cb) {
  var i = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

  if (document.readyState === 'complete') {
    return setTimeout(cb, 0);
  }

  if (document.readyState === 'interactive' && i <= 10) {
    return setTimeout(function () {
      return load(cb, i + 1);
    }, 200);
  }

  window.addEventListener('load', cb);
}

/* harmony default export */ __webpack_exports__["a"] = (load);

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {exports = module.exports = SemVer;

// The debug function is excluded entirely from the minified version.
/* nomin */ var debug;
/* nomin */ if (typeof process === 'object' &&
    /* nomin */ process.env &&
    /* nomin */ process.env.NODE_DEBUG &&
    /* nomin */ /\bsemver\b/i.test(process.env.NODE_DEBUG))
  /* nomin */ debug = function() {
    /* nomin */ var args = Array.prototype.slice.call(arguments, 0);
    /* nomin */ args.unshift('SEMVER');
    /* nomin */ console.log.apply(console, args);
    /* nomin */ };
/* nomin */ else
  /* nomin */ debug = function() {};

// Note: this is the semver.org version of the spec that it implements
// Not necessarily the package version of this code.
exports.SEMVER_SPEC_VERSION = '2.0.0';

var MAX_LENGTH = 256;
var MAX_SAFE_INTEGER = Number.MAX_SAFE_INTEGER || 9007199254740991;

// The actual regexps go on exports.re
var re = exports.re = [];
var src = exports.src = [];
var R = 0;

// The following Regular Expressions can be used for tokenizing,
// validating, and parsing SemVer version strings.

// ## Numeric Identifier
// A single `0`, or a non-zero digit followed by zero or more digits.

var NUMERICIDENTIFIER = R++;
src[NUMERICIDENTIFIER] = '0|[1-9]\\d*';
var NUMERICIDENTIFIERLOOSE = R++;
src[NUMERICIDENTIFIERLOOSE] = '[0-9]+';


// ## Non-numeric Identifier
// Zero or more digits, followed by a letter or hyphen, and then zero or
// more letters, digits, or hyphens.

var NONNUMERICIDENTIFIER = R++;
src[NONNUMERICIDENTIFIER] = '\\d*[a-zA-Z-][a-zA-Z0-9-]*';


// ## Main Version
// Three dot-separated numeric identifiers.

var MAINVERSION = R++;
src[MAINVERSION] = '(' + src[NUMERICIDENTIFIER] + ')\\.' +
                   '(' + src[NUMERICIDENTIFIER] + ')\\.' +
                   '(' + src[NUMERICIDENTIFIER] + ')';

var MAINVERSIONLOOSE = R++;
src[MAINVERSIONLOOSE] = '(' + src[NUMERICIDENTIFIERLOOSE] + ')\\.' +
                        '(' + src[NUMERICIDENTIFIERLOOSE] + ')\\.' +
                        '(' + src[NUMERICIDENTIFIERLOOSE] + ')';

// ## Pre-release Version Identifier
// A numeric identifier, or a non-numeric identifier.

var PRERELEASEIDENTIFIER = R++;
src[PRERELEASEIDENTIFIER] = '(?:' + src[NUMERICIDENTIFIER] +
                            '|' + src[NONNUMERICIDENTIFIER] + ')';

var PRERELEASEIDENTIFIERLOOSE = R++;
src[PRERELEASEIDENTIFIERLOOSE] = '(?:' + src[NUMERICIDENTIFIERLOOSE] +
                                 '|' + src[NONNUMERICIDENTIFIER] + ')';


// ## Pre-release Version
// Hyphen, followed by one or more dot-separated pre-release version
// identifiers.

var PRERELEASE = R++;
src[PRERELEASE] = '(?:-(' + src[PRERELEASEIDENTIFIER] +
                  '(?:\\.' + src[PRERELEASEIDENTIFIER] + ')*))';

var PRERELEASELOOSE = R++;
src[PRERELEASELOOSE] = '(?:-?(' + src[PRERELEASEIDENTIFIERLOOSE] +
                       '(?:\\.' + src[PRERELEASEIDENTIFIERLOOSE] + ')*))';

// ## Build Metadata Identifier
// Any combination of digits, letters, or hyphens.

var BUILDIDENTIFIER = R++;
src[BUILDIDENTIFIER] = '[0-9A-Za-z-]+';

// ## Build Metadata
// Plus sign, followed by one or more period-separated build metadata
// identifiers.

var BUILD = R++;
src[BUILD] = '(?:\\+(' + src[BUILDIDENTIFIER] +
             '(?:\\.' + src[BUILDIDENTIFIER] + ')*))';


// ## Full Version String
// A main version, followed optionally by a pre-release version and
// build metadata.

// Note that the only major, minor, patch, and pre-release sections of
// the version string are capturing groups.  The build metadata is not a
// capturing group, because it should not ever be used in version
// comparison.

var FULL = R++;
var FULLPLAIN = 'v?' + src[MAINVERSION] +
                src[PRERELEASE] + '?' +
                src[BUILD] + '?';

src[FULL] = '^' + FULLPLAIN + '$';

// like full, but allows v1.2.3 and =1.2.3, which people do sometimes.
// also, 1.0.0alpha1 (prerelease without the hyphen) which is pretty
// common in the npm registry.
var LOOSEPLAIN = '[v=\\s]*' + src[MAINVERSIONLOOSE] +
                 src[PRERELEASELOOSE] + '?' +
                 src[BUILD] + '?';

var LOOSE = R++;
src[LOOSE] = '^' + LOOSEPLAIN + '$';

var GTLT = R++;
src[GTLT] = '((?:<|>)?=?)';

// Something like "2.*" or "1.2.x".
// Note that "x.x" is a valid xRange identifer, meaning "any version"
// Only the first item is strictly required.
var XRANGEIDENTIFIERLOOSE = R++;
src[XRANGEIDENTIFIERLOOSE] = src[NUMERICIDENTIFIERLOOSE] + '|x|X|\\*';
var XRANGEIDENTIFIER = R++;
src[XRANGEIDENTIFIER] = src[NUMERICIDENTIFIER] + '|x|X|\\*';

var XRANGEPLAIN = R++;
src[XRANGEPLAIN] = '[v=\\s]*(' + src[XRANGEIDENTIFIER] + ')' +
                   '(?:\\.(' + src[XRANGEIDENTIFIER] + ')' +
                   '(?:\\.(' + src[XRANGEIDENTIFIER] + ')' +
                   '(?:' + src[PRERELEASE] + ')?' +
                   src[BUILD] + '?' +
                   ')?)?';

var XRANGEPLAINLOOSE = R++;
src[XRANGEPLAINLOOSE] = '[v=\\s]*(' + src[XRANGEIDENTIFIERLOOSE] + ')' +
                        '(?:\\.(' + src[XRANGEIDENTIFIERLOOSE] + ')' +
                        '(?:\\.(' + src[XRANGEIDENTIFIERLOOSE] + ')' +
                        '(?:' + src[PRERELEASELOOSE] + ')?' +
                        src[BUILD] + '?' +
                        ')?)?';

var XRANGE = R++;
src[XRANGE] = '^' + src[GTLT] + '\\s*' + src[XRANGEPLAIN] + '$';
var XRANGELOOSE = R++;
src[XRANGELOOSE] = '^' + src[GTLT] + '\\s*' + src[XRANGEPLAINLOOSE] + '$';

// Tilde ranges.
// Meaning is "reasonably at or greater than"
var LONETILDE = R++;
src[LONETILDE] = '(?:~>?)';

var TILDETRIM = R++;
src[TILDETRIM] = '(\\s*)' + src[LONETILDE] + '\\s+';
re[TILDETRIM] = new RegExp(src[TILDETRIM], 'g');
var tildeTrimReplace = '$1~';

var TILDE = R++;
src[TILDE] = '^' + src[LONETILDE] + src[XRANGEPLAIN] + '$';
var TILDELOOSE = R++;
src[TILDELOOSE] = '^' + src[LONETILDE] + src[XRANGEPLAINLOOSE] + '$';

// Caret ranges.
// Meaning is "at least and backwards compatible with"
var LONECARET = R++;
src[LONECARET] = '(?:\\^)';

var CARETTRIM = R++;
src[CARETTRIM] = '(\\s*)' + src[LONECARET] + '\\s+';
re[CARETTRIM] = new RegExp(src[CARETTRIM], 'g');
var caretTrimReplace = '$1^';

var CARET = R++;
src[CARET] = '^' + src[LONECARET] + src[XRANGEPLAIN] + '$';
var CARETLOOSE = R++;
src[CARETLOOSE] = '^' + src[LONECARET] + src[XRANGEPLAINLOOSE] + '$';

// A simple gt/lt/eq thing, or just "" to indicate "any version"
var COMPARATORLOOSE = R++;
src[COMPARATORLOOSE] = '^' + src[GTLT] + '\\s*(' + LOOSEPLAIN + ')$|^$';
var COMPARATOR = R++;
src[COMPARATOR] = '^' + src[GTLT] + '\\s*(' + FULLPLAIN + ')$|^$';


// An expression to strip any whitespace between the gtlt and the thing
// it modifies, so that `> 1.2.3` ==> `>1.2.3`
var COMPARATORTRIM = R++;
src[COMPARATORTRIM] = '(\\s*)' + src[GTLT] +
                      '\\s*(' + LOOSEPLAIN + '|' + src[XRANGEPLAIN] + ')';

// this one has to use the /g flag
re[COMPARATORTRIM] = new RegExp(src[COMPARATORTRIM], 'g');
var comparatorTrimReplace = '$1$2$3';


// Something like `1.2.3 - 1.2.4`
// Note that these all use the loose form, because they'll be
// checked against either the strict or loose comparator form
// later.
var HYPHENRANGE = R++;
src[HYPHENRANGE] = '^\\s*(' + src[XRANGEPLAIN] + ')' +
                   '\\s+-\\s+' +
                   '(' + src[XRANGEPLAIN] + ')' +
                   '\\s*$';

var HYPHENRANGELOOSE = R++;
src[HYPHENRANGELOOSE] = '^\\s*(' + src[XRANGEPLAINLOOSE] + ')' +
                        '\\s+-\\s+' +
                        '(' + src[XRANGEPLAINLOOSE] + ')' +
                        '\\s*$';

// Star ranges basically just allow anything at all.
var STAR = R++;
src[STAR] = '(<|>)?=?\\s*\\*';

// Compile to actual regexp objects.
// All are flag-free, unless they were created above with a flag.
for (var i = 0; i < R; i++) {
  debug(i, src[i]);
  if (!re[i])
    re[i] = new RegExp(src[i]);
}

exports.parse = parse;
function parse(version, loose) {
  if (version instanceof SemVer)
    return version;

  if (typeof version !== 'string')
    return null;

  if (version.length > MAX_LENGTH)
    return null;

  var r = loose ? re[LOOSE] : re[FULL];
  if (!r.test(version))
    return null;

  try {
    return new SemVer(version, loose);
  } catch (er) {
    return null;
  }
}

exports.valid = valid;
function valid(version, loose) {
  var v = parse(version, loose);
  return v ? v.version : null;
}


exports.clean = clean;
function clean(version, loose) {
  var s = parse(version.trim().replace(/^[=v]+/, ''), loose);
  return s ? s.version : null;
}

exports.SemVer = SemVer;

function SemVer(version, loose) {
  if (version instanceof SemVer) {
    if (version.loose === loose)
      return version;
    else
      version = version.version;
  } else if (typeof version !== 'string') {
    throw new TypeError('Invalid Version: ' + version);
  }

  if (version.length > MAX_LENGTH)
    throw new TypeError('version is longer than ' + MAX_LENGTH + ' characters')

  if (!(this instanceof SemVer))
    return new SemVer(version, loose);

  debug('SemVer', version, loose);
  this.loose = loose;
  var m = version.trim().match(loose ? re[LOOSE] : re[FULL]);

  if (!m)
    throw new TypeError('Invalid Version: ' + version);

  this.raw = version;

  // these are actually numbers
  this.major = +m[1];
  this.minor = +m[2];
  this.patch = +m[3];

  if (this.major > MAX_SAFE_INTEGER || this.major < 0)
    throw new TypeError('Invalid major version')

  if (this.minor > MAX_SAFE_INTEGER || this.minor < 0)
    throw new TypeError('Invalid minor version')

  if (this.patch > MAX_SAFE_INTEGER || this.patch < 0)
    throw new TypeError('Invalid patch version')

  // numberify any prerelease numeric ids
  if (!m[4])
    this.prerelease = [];
  else
    this.prerelease = m[4].split('.').map(function(id) {
      if (/^[0-9]+$/.test(id)) {
        var num = +id;
        if (num >= 0 && num < MAX_SAFE_INTEGER)
          return num;
      }
      return id;
    });

  this.build = m[5] ? m[5].split('.') : [];
  this.format();
}

SemVer.prototype.format = function() {
  this.version = this.major + '.' + this.minor + '.' + this.patch;
  if (this.prerelease.length)
    this.version += '-' + this.prerelease.join('.');
  return this.version;
};

SemVer.prototype.toString = function() {
  return this.version;
};

SemVer.prototype.compare = function(other) {
  debug('SemVer.compare', this.version, this.loose, other);
  if (!(other instanceof SemVer))
    other = new SemVer(other, this.loose);

  return this.compareMain(other) || this.comparePre(other);
};

SemVer.prototype.compareMain = function(other) {
  if (!(other instanceof SemVer))
    other = new SemVer(other, this.loose);

  return compareIdentifiers(this.major, other.major) ||
         compareIdentifiers(this.minor, other.minor) ||
         compareIdentifiers(this.patch, other.patch);
};

SemVer.prototype.comparePre = function(other) {
  if (!(other instanceof SemVer))
    other = new SemVer(other, this.loose);

  // NOT having a prerelease is > having one
  if (this.prerelease.length && !other.prerelease.length)
    return -1;
  else if (!this.prerelease.length && other.prerelease.length)
    return 1;
  else if (!this.prerelease.length && !other.prerelease.length)
    return 0;

  var i = 0;
  do {
    var a = this.prerelease[i];
    var b = other.prerelease[i];
    debug('prerelease compare', i, a, b);
    if (a === undefined && b === undefined)
      return 0;
    else if (b === undefined)
      return 1;
    else if (a === undefined)
      return -1;
    else if (a === b)
      continue;
    else
      return compareIdentifiers(a, b);
  } while (++i);
};

// preminor will bump the version up to the next minor release, and immediately
// down to pre-release. premajor and prepatch work the same way.
SemVer.prototype.inc = function(release, identifier) {
  switch (release) {
    case 'premajor':
      this.prerelease.length = 0;
      this.patch = 0;
      this.minor = 0;
      this.major++;
      this.inc('pre', identifier);
      break;
    case 'preminor':
      this.prerelease.length = 0;
      this.patch = 0;
      this.minor++;
      this.inc('pre', identifier);
      break;
    case 'prepatch':
      // If this is already a prerelease, it will bump to the next version
      // drop any prereleases that might already exist, since they are not
      // relevant at this point.
      this.prerelease.length = 0;
      this.inc('patch', identifier);
      this.inc('pre', identifier);
      break;
    // If the input is a non-prerelease version, this acts the same as
    // prepatch.
    case 'prerelease':
      if (this.prerelease.length === 0)
        this.inc('patch', identifier);
      this.inc('pre', identifier);
      break;

    case 'major':
      // If this is a pre-major version, bump up to the same major version.
      // Otherwise increment major.
      // 1.0.0-5 bumps to 1.0.0
      // 1.1.0 bumps to 2.0.0
      if (this.minor !== 0 || this.patch !== 0 || this.prerelease.length === 0)
        this.major++;
      this.minor = 0;
      this.patch = 0;
      this.prerelease = [];
      break;
    case 'minor':
      // If this is a pre-minor version, bump up to the same minor version.
      // Otherwise increment minor.
      // 1.2.0-5 bumps to 1.2.0
      // 1.2.1 bumps to 1.3.0
      if (this.patch !== 0 || this.prerelease.length === 0)
        this.minor++;
      this.patch = 0;
      this.prerelease = [];
      break;
    case 'patch':
      // If this is not a pre-release version, it will increment the patch.
      // If it is a pre-release it will bump up to the same patch version.
      // 1.2.0-5 patches to 1.2.0
      // 1.2.0 patches to 1.2.1
      if (this.prerelease.length === 0)
        this.patch++;
      this.prerelease = [];
      break;
    // This probably shouldn't be used publicly.
    // 1.0.0 "pre" would become 1.0.0-0 which is the wrong direction.
    case 'pre':
      if (this.prerelease.length === 0)
        this.prerelease = [0];
      else {
        var i = this.prerelease.length;
        while (--i >= 0) {
          if (typeof this.prerelease[i] === 'number') {
            this.prerelease[i]++;
            i = -2;
          }
        }
        if (i === -1) // didn't increment anything
          this.prerelease.push(0);
      }
      if (identifier) {
        // 1.2.0-beta.1 bumps to 1.2.0-beta.2,
        // 1.2.0-beta.fooblz or 1.2.0-beta bumps to 1.2.0-beta.0
        if (this.prerelease[0] === identifier) {
          if (isNaN(this.prerelease[1]))
            this.prerelease = [identifier, 0];
        } else
          this.prerelease = [identifier, 0];
      }
      break;

    default:
      throw new Error('invalid increment argument: ' + release);
  }
  this.format();
  this.raw = this.version;
  return this;
};

exports.inc = inc;
function inc(version, release, loose, identifier) {
  if (typeof(loose) === 'string') {
    identifier = loose;
    loose = undefined;
  }

  try {
    return new SemVer(version, loose).inc(release, identifier).version;
  } catch (er) {
    return null;
  }
}

exports.diff = diff;
function diff(version1, version2) {
  if (eq(version1, version2)) {
    return null;
  } else {
    var v1 = parse(version1);
    var v2 = parse(version2);
    if (v1.prerelease.length || v2.prerelease.length) {
      for (var key in v1) {
        if (key === 'major' || key === 'minor' || key === 'patch') {
          if (v1[key] !== v2[key]) {
            return 'pre'+key;
          }
        }
      }
      return 'prerelease';
    }
    for (var key in v1) {
      if (key === 'major' || key === 'minor' || key === 'patch') {
        if (v1[key] !== v2[key]) {
          return key;
        }
      }
    }
  }
}

exports.compareIdentifiers = compareIdentifiers;

var numeric = /^[0-9]+$/;
function compareIdentifiers(a, b) {
  var anum = numeric.test(a);
  var bnum = numeric.test(b);

  if (anum && bnum) {
    a = +a;
    b = +b;
  }

  return (anum && !bnum) ? -1 :
         (bnum && !anum) ? 1 :
         a < b ? -1 :
         a > b ? 1 :
         0;
}

exports.rcompareIdentifiers = rcompareIdentifiers;
function rcompareIdentifiers(a, b) {
  return compareIdentifiers(b, a);
}

exports.major = major;
function major(a, loose) {
  return new SemVer(a, loose).major;
}

exports.minor = minor;
function minor(a, loose) {
  return new SemVer(a, loose).minor;
}

exports.patch = patch;
function patch(a, loose) {
  return new SemVer(a, loose).patch;
}

exports.compare = compare;
function compare(a, b, loose) {
  return new SemVer(a, loose).compare(b);
}

exports.compareLoose = compareLoose;
function compareLoose(a, b) {
  return compare(a, b, true);
}

exports.rcompare = rcompare;
function rcompare(a, b, loose) {
  return compare(b, a, loose);
}

exports.sort = sort;
function sort(list, loose) {
  return list.sort(function(a, b) {
    return exports.compare(a, b, loose);
  });
}

exports.rsort = rsort;
function rsort(list, loose) {
  return list.sort(function(a, b) {
    return exports.rcompare(a, b, loose);
  });
}

exports.gt = gt;
function gt(a, b, loose) {
  return compare(a, b, loose) > 0;
}

exports.lt = lt;
function lt(a, b, loose) {
  return compare(a, b, loose) < 0;
}

exports.eq = eq;
function eq(a, b, loose) {
  return compare(a, b, loose) === 0;
}

exports.neq = neq;
function neq(a, b, loose) {
  return compare(a, b, loose) !== 0;
}

exports.gte = gte;
function gte(a, b, loose) {
  return compare(a, b, loose) >= 0;
}

exports.lte = lte;
function lte(a, b, loose) {
  return compare(a, b, loose) <= 0;
}

exports.cmp = cmp;
function cmp(a, op, b, loose) {
  var ret;
  switch (op) {
    case '===':
      if (typeof a === 'object') a = a.version;
      if (typeof b === 'object') b = b.version;
      ret = a === b;
      break;
    case '!==':
      if (typeof a === 'object') a = a.version;
      if (typeof b === 'object') b = b.version;
      ret = a !== b;
      break;
    case '': case '=': case '==': ret = eq(a, b, loose); break;
    case '!=': ret = neq(a, b, loose); break;
    case '>': ret = gt(a, b, loose); break;
    case '>=': ret = gte(a, b, loose); break;
    case '<': ret = lt(a, b, loose); break;
    case '<=': ret = lte(a, b, loose); break;
    default: throw new TypeError('Invalid operator: ' + op);
  }
  return ret;
}

exports.Comparator = Comparator;
function Comparator(comp, loose) {
  if (comp instanceof Comparator) {
    if (comp.loose === loose)
      return comp;
    else
      comp = comp.value;
  }

  if (!(this instanceof Comparator))
    return new Comparator(comp, loose);

  debug('comparator', comp, loose);
  this.loose = loose;
  this.parse(comp);

  if (this.semver === ANY)
    this.value = '';
  else
    this.value = this.operator + this.semver.version;

  debug('comp', this);
}

var ANY = {};
Comparator.prototype.parse = function(comp) {
  var r = this.loose ? re[COMPARATORLOOSE] : re[COMPARATOR];
  var m = comp.match(r);

  if (!m)
    throw new TypeError('Invalid comparator: ' + comp);

  this.operator = m[1];
  if (this.operator === '=')
    this.operator = '';

  // if it literally is just '>' or '' then allow anything.
  if (!m[2])
    this.semver = ANY;
  else
    this.semver = new SemVer(m[2], this.loose);
};

Comparator.prototype.toString = function() {
  return this.value;
};

Comparator.prototype.test = function(version) {
  debug('Comparator.test', version, this.loose);

  if (this.semver === ANY)
    return true;

  if (typeof version === 'string')
    version = new SemVer(version, this.loose);

  return cmp(version, this.operator, this.semver, this.loose);
};


exports.Range = Range;
function Range(range, loose) {
  if ((range instanceof Range) && range.loose === loose)
    return range;

  if (!(this instanceof Range))
    return new Range(range, loose);

  this.loose = loose;

  // First, split based on boolean or ||
  this.raw = range;
  this.set = range.split(/\s*\|\|\s*/).map(function(range) {
    return this.parseRange(range.trim());
  }, this).filter(function(c) {
    // throw out any that are not relevant for whatever reason
    return c.length;
  });

  if (!this.set.length) {
    throw new TypeError('Invalid SemVer Range: ' + range);
  }

  this.format();
}

Range.prototype.format = function() {
  this.range = this.set.map(function(comps) {
    return comps.join(' ').trim();
  }).join('||').trim();
  return this.range;
};

Range.prototype.toString = function() {
  return this.range;
};

Range.prototype.parseRange = function(range) {
  var loose = this.loose;
  range = range.trim();
  debug('range', range, loose);
  // `1.2.3 - 1.2.4` => `>=1.2.3 <=1.2.4`
  var hr = loose ? re[HYPHENRANGELOOSE] : re[HYPHENRANGE];
  range = range.replace(hr, hyphenReplace);
  debug('hyphen replace', range);
  // `> 1.2.3 < 1.2.5` => `>1.2.3 <1.2.5`
  range = range.replace(re[COMPARATORTRIM], comparatorTrimReplace);
  debug('comparator trim', range, re[COMPARATORTRIM]);

  // `~ 1.2.3` => `~1.2.3`
  range = range.replace(re[TILDETRIM], tildeTrimReplace);

  // `^ 1.2.3` => `^1.2.3`
  range = range.replace(re[CARETTRIM], caretTrimReplace);

  // normalize spaces
  range = range.split(/\s+/).join(' ');

  // At this point, the range is completely trimmed and
  // ready to be split into comparators.

  var compRe = loose ? re[COMPARATORLOOSE] : re[COMPARATOR];
  var set = range.split(' ').map(function(comp) {
    return parseComparator(comp, loose);
  }).join(' ').split(/\s+/);
  if (this.loose) {
    // in loose mode, throw out any that are not valid comparators
    set = set.filter(function(comp) {
      return !!comp.match(compRe);
    });
  }
  set = set.map(function(comp) {
    return new Comparator(comp, loose);
  });

  return set;
};

// Mostly just for testing and legacy API reasons
exports.toComparators = toComparators;
function toComparators(range, loose) {
  return new Range(range, loose).set.map(function(comp) {
    return comp.map(function(c) {
      return c.value;
    }).join(' ').trim().split(' ');
  });
}

// comprised of xranges, tildes, stars, and gtlt's at this point.
// already replaced the hyphen ranges
// turn into a set of JUST comparators.
function parseComparator(comp, loose) {
  debug('comp', comp);
  comp = replaceCarets(comp, loose);
  debug('caret', comp);
  comp = replaceTildes(comp, loose);
  debug('tildes', comp);
  comp = replaceXRanges(comp, loose);
  debug('xrange', comp);
  comp = replaceStars(comp, loose);
  debug('stars', comp);
  return comp;
}

function isX(id) {
  return !id || id.toLowerCase() === 'x' || id === '*';
}

// ~, ~> --> * (any, kinda silly)
// ~2, ~2.x, ~2.x.x, ~>2, ~>2.x ~>2.x.x --> >=2.0.0 <3.0.0
// ~2.0, ~2.0.x, ~>2.0, ~>2.0.x --> >=2.0.0 <2.1.0
// ~1.2, ~1.2.x, ~>1.2, ~>1.2.x --> >=1.2.0 <1.3.0
// ~1.2.3, ~>1.2.3 --> >=1.2.3 <1.3.0
// ~1.2.0, ~>1.2.0 --> >=1.2.0 <1.3.0
function replaceTildes(comp, loose) {
  return comp.trim().split(/\s+/).map(function(comp) {
    return replaceTilde(comp, loose);
  }).join(' ');
}

function replaceTilde(comp, loose) {
  var r = loose ? re[TILDELOOSE] : re[TILDE];
  return comp.replace(r, function(_, M, m, p, pr) {
    debug('tilde', comp, _, M, m, p, pr);
    var ret;

    if (isX(M))
      ret = '';
    else if (isX(m))
      ret = '>=' + M + '.0.0 <' + (+M + 1) + '.0.0';
    else if (isX(p))
      // ~1.2 == >=1.2.0 <1.3.0
      ret = '>=' + M + '.' + m + '.0 <' + M + '.' + (+m + 1) + '.0';
    else if (pr) {
      debug('replaceTilde pr', pr);
      if (pr.charAt(0) !== '-')
        pr = '-' + pr;
      ret = '>=' + M + '.' + m + '.' + p + pr +
            ' <' + M + '.' + (+m + 1) + '.0';
    } else
      // ~1.2.3 == >=1.2.3 <1.3.0
      ret = '>=' + M + '.' + m + '.' + p +
            ' <' + M + '.' + (+m + 1) + '.0';

    debug('tilde return', ret);
    return ret;
  });
}

// ^ --> * (any, kinda silly)
// ^2, ^2.x, ^2.x.x --> >=2.0.0 <3.0.0
// ^2.0, ^2.0.x --> >=2.0.0 <3.0.0
// ^1.2, ^1.2.x --> >=1.2.0 <2.0.0
// ^1.2.3 --> >=1.2.3 <2.0.0
// ^1.2.0 --> >=1.2.0 <2.0.0
function replaceCarets(comp, loose) {
  return comp.trim().split(/\s+/).map(function(comp) {
    return replaceCaret(comp, loose);
  }).join(' ');
}

function replaceCaret(comp, loose) {
  debug('caret', comp, loose);
  var r = loose ? re[CARETLOOSE] : re[CARET];
  return comp.replace(r, function(_, M, m, p, pr) {
    debug('caret', comp, _, M, m, p, pr);
    var ret;

    if (isX(M))
      ret = '';
    else if (isX(m))
      ret = '>=' + M + '.0.0 <' + (+M + 1) + '.0.0';
    else if (isX(p)) {
      if (M === '0')
        ret = '>=' + M + '.' + m + '.0 <' + M + '.' + (+m + 1) + '.0';
      else
        ret = '>=' + M + '.' + m + '.0 <' + (+M + 1) + '.0.0';
    } else if (pr) {
      debug('replaceCaret pr', pr);
      if (pr.charAt(0) !== '-')
        pr = '-' + pr;
      if (M === '0') {
        if (m === '0')
          ret = '>=' + M + '.' + m + '.' + p + pr +
                ' <' + M + '.' + m + '.' + (+p + 1);
        else
          ret = '>=' + M + '.' + m + '.' + p + pr +
                ' <' + M + '.' + (+m + 1) + '.0';
      } else
        ret = '>=' + M + '.' + m + '.' + p + pr +
              ' <' + (+M + 1) + '.0.0';
    } else {
      debug('no pr');
      if (M === '0') {
        if (m === '0')
          ret = '>=' + M + '.' + m + '.' + p +
                ' <' + M + '.' + m + '.' + (+p + 1);
        else
          ret = '>=' + M + '.' + m + '.' + p +
                ' <' + M + '.' + (+m + 1) + '.0';
      } else
        ret = '>=' + M + '.' + m + '.' + p +
              ' <' + (+M + 1) + '.0.0';
    }

    debug('caret return', ret);
    return ret;
  });
}

function replaceXRanges(comp, loose) {
  debug('replaceXRanges', comp, loose);
  return comp.split(/\s+/).map(function(comp) {
    return replaceXRange(comp, loose);
  }).join(' ');
}

function replaceXRange(comp, loose) {
  comp = comp.trim();
  var r = loose ? re[XRANGELOOSE] : re[XRANGE];
  return comp.replace(r, function(ret, gtlt, M, m, p, pr) {
    debug('xRange', comp, ret, gtlt, M, m, p, pr);
    var xM = isX(M);
    var xm = xM || isX(m);
    var xp = xm || isX(p);
    var anyX = xp;

    if (gtlt === '=' && anyX)
      gtlt = '';

    if (xM) {
      if (gtlt === '>' || gtlt === '<') {
        // nothing is allowed
        ret = '<0.0.0';
      } else {
        // nothing is forbidden
        ret = '*';
      }
    } else if (gtlt && anyX) {
      // replace X with 0
      if (xm)
        m = 0;
      if (xp)
        p = 0;

      if (gtlt === '>') {
        // >1 => >=2.0.0
        // >1.2 => >=1.3.0
        // >1.2.3 => >= 1.2.4
        gtlt = '>=';
        if (xm) {
          M = +M + 1;
          m = 0;
          p = 0;
        } else if (xp) {
          m = +m + 1;
          p = 0;
        }
      } else if (gtlt === '<=') {
        // <=0.7.x is actually <0.8.0, since any 0.7.x should
        // pass.  Similarly, <=7.x is actually <8.0.0, etc.
        gtlt = '<';
        if (xm)
          M = +M + 1;
        else
          m = +m + 1;
      }

      ret = gtlt + M + '.' + m + '.' + p;
    } else if (xm) {
      ret = '>=' + M + '.0.0 <' + (+M + 1) + '.0.0';
    } else if (xp) {
      ret = '>=' + M + '.' + m + '.0 <' + M + '.' + (+m + 1) + '.0';
    }

    debug('xRange return', ret);

    return ret;
  });
}

// Because * is AND-ed with everything else in the comparator,
// and '' means "any version", just remove the *s entirely.
function replaceStars(comp, loose) {
  debug('replaceStars', comp, loose);
  // Looseness is ignored here.  star is always as loose as it gets!
  return comp.trim().replace(re[STAR], '');
}

// This function is passed to string.replace(re[HYPHENRANGE])
// M, m, patch, prerelease, build
// 1.2 - 3.4.5 => >=1.2.0 <=3.4.5
// 1.2.3 - 3.4 => >=1.2.0 <3.5.0 Any 3.4.x will do
// 1.2 - 3.4 => >=1.2.0 <3.5.0
function hyphenReplace($0,
                       from, fM, fm, fp, fpr, fb,
                       to, tM, tm, tp, tpr, tb) {

  if (isX(fM))
    from = '';
  else if (isX(fm))
    from = '>=' + fM + '.0.0';
  else if (isX(fp))
    from = '>=' + fM + '.' + fm + '.0';
  else
    from = '>=' + from;

  if (isX(tM))
    to = '';
  else if (isX(tm))
    to = '<' + (+tM + 1) + '.0.0';
  else if (isX(tp))
    to = '<' + tM + '.' + (+tm + 1) + '.0';
  else if (tpr)
    to = '<=' + tM + '.' + tm + '.' + tp + '-' + tpr;
  else
    to = '<=' + to;

  return (from + ' ' + to).trim();
}


// if ANY of the sets match ALL of its comparators, then pass
Range.prototype.test = function(version) {
  if (!version)
    return false;

  if (typeof version === 'string')
    version = new SemVer(version, this.loose);

  for (var i = 0; i < this.set.length; i++) {
    if (testSet(this.set[i], version))
      return true;
  }
  return false;
};

function testSet(set, version) {
  for (var i = 0; i < set.length; i++) {
    if (!set[i].test(version))
      return false;
  }

  if (version.prerelease.length) {
    // Find the set of versions that are allowed to have prereleases
    // For example, ^1.2.3-pr.1 desugars to >=1.2.3-pr.1 <2.0.0
    // That should allow `1.2.3-pr.2` to pass.
    // However, `1.2.4-alpha.notready` should NOT be allowed,
    // even though it's within the range set by the comparators.
    for (var i = 0; i < set.length; i++) {
      debug(set[i].semver);
      if (set[i].semver === ANY)
        continue;

      if (set[i].semver.prerelease.length > 0) {
        var allowed = set[i].semver;
        if (allowed.major === version.major &&
            allowed.minor === version.minor &&
            allowed.patch === version.patch)
          return true;
      }
    }

    // Version has a -pre, but it's not one of the ones we like.
    return false;
  }

  return true;
}

exports.satisfies = satisfies;
function satisfies(version, range, loose) {
  try {
    range = new Range(range, loose);
  } catch (er) {
    return false;
  }
  return range.test(version);
}

exports.maxSatisfying = maxSatisfying;
function maxSatisfying(versions, range, loose) {
  return versions.filter(function(version) {
    return satisfies(version, range, loose);
  }).sort(function(a, b) {
    return rcompare(a, b, loose);
  })[0] || null;
}

exports.minSatisfying = minSatisfying;
function minSatisfying(versions, range, loose) {
  return versions.filter(function(version) {
    return satisfies(version, range, loose);
  }).sort(function(a, b) {
    return compare(a, b, loose);
  })[0] || null;
}

exports.validRange = validRange;
function validRange(range, loose) {
  try {
    // Return '*' instead of '' so that truthiness works.
    // This will throw if it's invalid anyway
    return new Range(range, loose).range || '*';
  } catch (er) {
    return null;
  }
}

// Determine if version is less than all the versions possible in the range
exports.ltr = ltr;
function ltr(version, range, loose) {
  return outside(version, range, '<', loose);
}

// Determine if version is greater than all the versions possible in the range.
exports.gtr = gtr;
function gtr(version, range, loose) {
  return outside(version, range, '>', loose);
}

exports.outside = outside;
function outside(version, range, hilo, loose) {
  version = new SemVer(version, loose);
  range = new Range(range, loose);

  var gtfn, ltefn, ltfn, comp, ecomp;
  switch (hilo) {
    case '>':
      gtfn = gt;
      ltefn = lte;
      ltfn = lt;
      comp = '>';
      ecomp = '>=';
      break;
    case '<':
      gtfn = lt;
      ltefn = gte;
      ltfn = gt;
      comp = '<';
      ecomp = '<=';
      break;
    default:
      throw new TypeError('Must provide a hilo val of "<" or ">"');
  }

  // If it satisifes the range it is not outside
  if (satisfies(version, range, loose)) {
    return false;
  }

  // From now on, variable terms are as if we're in "gtr" mode.
  // but note that everything is flipped for the "ltr" function.

  for (var i = 0; i < range.set.length; ++i) {
    var comparators = range.set[i];

    var high = null;
    var low = null;

    comparators.forEach(function(comparator) {
      if (comparator.semver === ANY) {
        comparator = new Comparator('>=0.0.0')
      }
      high = high || comparator;
      low = low || comparator;
      if (gtfn(comparator.semver, high.semver, loose)) {
        high = comparator;
      } else if (ltfn(comparator.semver, low.semver, loose)) {
        low = comparator;
      }
    });

    // If the edge version comparator has a operator then our version
    // isn't outside it
    if (high.operator === comp || high.operator === ecomp) {
      return false;
    }

    // If the lowest version comparator has an operator and our version
    // is less than it then it isn't higher than the range
    if ((!low.operator || low.operator === comp) &&
        ltefn(version, low.semver)) {
      return false;
    } else if (low.operator === ecomp && ltfn(version, low.semver)) {
      return false;
    }
  }
  return true;
}

exports.prerelease = prerelease;
function prerelease(version, loose) {
  var parsed = parse(version, loose);
  return (parsed && parsed.prerelease.length) ? parsed.prerelease : null;
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(133)))

/***/ }),
/* 133 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ })
/******/ ]);
});
//# sourceMappingURL=vuetify.js.map

/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define("VueShortkey",[],t):"object"==typeof exports?exports.VueShortkey=t():e.VueShortkey=t()}("undefined"!=typeof self?self:this,function(){return function(e){function t(r){if(n[r])return n[r].exports;var o=n[r]={i:r,l:!1,exports:{}};return e[r].call(o.exports,o,o.exports,t),o.l=!0,o.exports}var n={};return t.m=e,t.c=n,t.d=function(e,n,r){t.o(e,n)||Object.defineProperty(e,n,{configurable:!1,enumerable:!0,get:r})},t.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(n,"a",n),n},t.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},t.p="../dist/",t(t.s=0)}([function(e,t,n){"use strict";(function(r){function o(e){if(Array.isArray(e)){for(var t=0,n=Array(e.length);t<e.length;t++)n[t]=e[t];return n}return Array.from(e)}var c;n(2),n(3);var u={},i={},a=[],l=[],s=!1,f=function(e){return e="string"==typeof e?JSON.parse(e.replace(/\'/gi,'"')):e,e instanceof Array?{"":e}:e},p=function(e,t,n,r){var o=!0===n.modifiers.push,c=!0===n.modifiers.avoid,u=!0==!n.modifiers.focus,i=!0===n.modifiers.once;c?(a=a.filter(function(e){return!e===t}),a.push(t)):v({b:e,push:o,once:i,focus:u,el:r.elm})},y=function(e,t){for(var n in e){var r=u.encodeKey(e[n]),o=i[r].el.indexOf(t);i[r].el.length>1&&o>-1?i[r].el.splice(o,1):delete i[r]}};u.install=function(e,t){l=[].concat(o(t&&t.prevent?t.prevent:[])),e.directive("shortkey",{bind:function(e,t,n){var r=f(t.value);p(r,e,t,n)},update:function(e,t,n){var r=f(t.oldValue);y(r,e);var o=f(t.value);p(o,e,t,n)},unbind:function(e,t){var n=f(t.value);y(n,e)}})},u.decodeKey=function(e){return d(e)},u.encodeKey=function(e){var t={};t.shiftKey=e.includes("shift"),t.ctrlKey=e.includes("ctrl"),t.metaKey=e.includes("meta"),t.altKey=e.includes("alt");var n=d(t);return n+=e.filter(function(e){return!["shift","ctrl","meta","alt"].includes(e)}).join("")};var d=function(e){var t="";return("Shift"===e.key||e.shiftKey)&&(t+="shift"),("Control"===e.key||e.ctrlKey)&&(t+="ctrl"),("Meta"===e.key||e.metaKey)&&(t+="meta"),("Alt"===e.key||e.altKey)&&(t+="alt"),"ArrowUp"===e.key&&(t+="arrowup"),"ArrowLeft"===e.key&&(t+="arrowleft"),"ArrowRight"===e.key&&(t+="arrowright"),"ArrowDown"===e.key&&(t+="arrowdown"),"AltGraph"===e.key&&(t+="altgraph"),"Escape"===e.key&&(t+="esc"),"Enter"===e.key&&(t+="enter"),"Tab"===e.key&&(t+="tab")," "===e.key&&(t+="space"),"PageUp"===e.key&&(t+="pageup"),"PageDown"===e.key&&(t+="pagedown"),"Home"===e.key&&(t+="home"),"End"===e.key&&(t+="end"),"Delete"===e.key&&(t+="del"),"Backspace"===e.key&&(t+="backspace"),"Insert"===e.key&&(t+="insert"),"NumLock"===e.key&&(t+="numlock"),"CapsLock"===e.key&&(t+="capslock"),"Pause"===e.key&&(t+="pause"),"ContextMenu"===e.key&&(t+="contextmenu"),"ScrollLock"===e.key&&(t+="scrolllock"),"BrowserHome"===e.key&&(t+="browserhome"),"MediaSelect"===e.key&&(t+="mediaselect"),(e.key&&" "!==e.key&&1===e.key.length||/F\d{1,2}|\//g.test(e.key))&&(t+=e.key.toLowerCase()),t},h=function(e){var t=new CustomEvent("shortkey",{bubbles:!1});i[e].key&&(t.srcKey=i[e].key);var n=i[e].el;n[n.length-1].dispatchEvent(t)};u.keyDown=function(e){(!i[e].once&&!i[e].push||i[e].push&&!s)&&h(e)},r&&Object({NODE_ENV:"production"})&&function(){document.addEventListener("keydown",function(e){var t=u.decodeKey(e);if(m(t))if(e.preventDefault(),e.stopPropagation(),i[t].focus)u.keyDown(t),s=!0;else if(!s){var n=i[t].el;n[n.length-1].focus(),s=!0}},!0),document.addEventListener("keyup",function(e){var t=u.decodeKey(e);m(t)&&(e.preventDefault(),e.stopPropagation(),(i[t].once||i[t].push)&&h(t)),s=!1},!0)}();var v=function(e){var t=e.b,n=e.push,r=e.once,o=e.focus,c=e.el;for(var a in t){var l=u.encodeKey(t[a]),s=i[l]&&i[l].el?i[l].el:[];s.push(c),i[l]={push:n,once:r,focus:o,key:a,el:s}}},m=function(e){var t=!!a.find(function(e){return e===document.activeElement}),n=!!l.find(function(e){return document.activeElement&&document.activeElement.matches(e)});return!!i[e]&&!(t||n)};void 0!==e&&e.exports?e.exports=u:void 0!==(c=function(){return u}.call(t,n,t,e))&&(e.exports=c)}).call(t,n(1))},function(e,t){function n(){throw new Error("setTimeout has not been defined")}function r(){throw new Error("clearTimeout has not been defined")}function o(e){if(s===setTimeout)return setTimeout(e,0);if((s===n||!s)&&setTimeout)return s=setTimeout,setTimeout(e,0);try{return s(e,0)}catch(t){try{return s.call(null,e,0)}catch(t){return s.call(this,e,0)}}}function c(e){if(f===clearTimeout)return clearTimeout(e);if((f===r||!f)&&clearTimeout)return f=clearTimeout,clearTimeout(e);try{return f(e)}catch(t){try{return f.call(null,e)}catch(t){return f.call(this,e)}}}function u(){h&&y&&(h=!1,y.length?d=y.concat(d):v=-1,d.length&&i())}function i(){if(!h){var e=o(u);h=!0;for(var t=d.length;t;){for(y=d,d=[];++v<t;)y&&y[v].run();v=-1,t=d.length}y=null,h=!1,c(e)}}function a(e,t){this.fun=e,this.array=t}function l(){}var s,f,p=e.exports={};!function(){try{s="function"==typeof setTimeout?setTimeout:n}catch(e){s=n}try{f="function"==typeof clearTimeout?clearTimeout:r}catch(e){f=r}}();var y,d=[],h=!1,v=-1;p.nextTick=function(e){var t=new Array(arguments.length-1);if(arguments.length>1)for(var n=1;n<arguments.length;n++)t[n-1]=arguments[n];d.push(new a(e,t)),1!==d.length||h||o(i)},a.prototype.run=function(){this.fun.apply(null,this.array)},p.title="browser",p.browser=!0,p.env={},p.argv=[],p.version="",p.versions={},p.on=l,p.addListener=l,p.once=l,p.off=l,p.removeListener=l,p.removeAllListeners=l,p.emit=l,p.prependListener=l,p.prependOnceListener=l,p.listeners=function(e){return[]},p.binding=function(e){throw new Error("process.binding is not supported")},p.cwd=function(){return"/"},p.chdir=function(e){throw new Error("process.chdir is not supported")},p.umask=function(){return 0}},function(e,t){Element.prototype.matches||(Element.prototype.matches=Element.prototype.matchesSelector||Element.prototype.msMatchesSelector||Element.prototype.webkitMatchesSelector)},function(e,t){!function(){if("undefined"!=typeof window)try{var e=new window.CustomEvent("test",{cancelable:!0});if(e.preventDefault(),!0!==e.defaultPrevented)throw new Error("Could not prevent default")}catch(e){var t=function(e,t){var n,r;return t=t||{},t.bubbles=!!t.bubbles,t.cancelable=!!t.cancelable,n=document.createEvent("CustomEvent"),n.initCustomEvent(e,t.bubbles,t.cancelable,t.detail),r=n.preventDefault,n.preventDefault=function(){r.call(this);try{Object.defineProperty(this,"defaultPrevented",{get:function(){return!0}})}catch(e){this.defaultPrevented=!0}},n};t.prototype=window.Event.prototype,window.CustomEvent=t}}()}])});
//# sourceMappingURL=index.js.map

/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

(function (global, factory) {
   true ? factory(__webpack_require__(184)) :
  typeof define === 'function' && define.amd ? define(['hammerjs'], factory) :
  (factory(global.Hammer));
}(this, (function (Hammer) { 'use strict';

Hammer = 'default' in Hammer ? Hammer['default'] : Hammer;

function assign(target) {
  var sources = [], len = arguments.length - 1;
  while ( len-- > 0 ) sources[ len ] = arguments[ len + 1 ];
  for (var i = 0; i < sources.length; i++) {
    var source = sources[i];
    var keys = Object.keys(source);
    for (var i$1 = 0; i$1 < keys.length; i$1++) {
      var key = keys[i$1];
      target[key] = source[key];
    }
  }
  return target
}
function createProp() {
  return {
    type: Object,
    default: function() { return {} }
  }
}
function capitalize (str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
}
var directions = ['up', 'down', 'left', 'right', 'horizontal', 'vertical', 'all'];
function guardDirections (options) {
  var dir = options.direction;
  if (typeof dir === 'string') {
    var hammerDirection = 'DIRECTION_' + dir.toUpperCase();
    if (directions.indexOf(dir) > -1 && Hammer.hasOwnProperty(hammerDirection)) {
      options.direction = Hammer[hammerDirection];
    } else {
      console.warn('[vue-touch] invalid direction: ' + dir);
    }
  }
  return options
}
var config = {
};
var customEvents = {
};
var gestures = [
  'pan','panstart','panmove','panend','pancancel','panleft','panright','panup','pandown',
  'pinch','pinchstart','pinchmove','pinchend','pinchcancel','pinchin','pinchout',
  'press','pressup',
  'rotate','rotatestart','rotatemove','rotateend','rotatecancel',
  'swipe','swipeleft','swiperight','swipeup','swipedown',
  'tap'
];
var gestureMap = {
  pan: 'pan',
  panstart: 'pan',
  panmove: 'pan',
  panend: 'pan',
  pancancel: 'pan',
  panleft: 'pan',
  panright: 'pan',
  panup: 'pan',
  pandown: 'pan',
  pinch: 'pinch',
  pinchstart: 'pinch',
  pinchmove: 'pinch',
  pinchend: 'pinch',
  pinchcancel: 'pinch',
  pinchin: 'pinch',
  pinchout: 'pinch',
  press: 'press',
  pressup: 'press',
  rotate: 'rotate',
  rotatestart: 'rotate',
  rotatemove: 'rotate',
  rotateend: 'rotate',
  rotatecancel: 'rotate',
  swipe: 'swipe',
  swipeleft: 'swipe',
  swiperight: 'swipe',
  swipeup: 'swipe',
  swipedown: 'swipe',
  tap: 'tap'
};

var Component = {
  props: {
    options: createProp(),
    tapOptions: createProp(),
    panOptions: createProp(),
    pinchOptions: createProp(),
    pressOptions: createProp(),
    rotateOptions: createProp(),
    swipeOptions: createProp(),
    tag: { type: String, default: 'div' },
    enabled: {
      default: true,
      type: [Boolean, Object],
    }
  },
  mounted: function mounted() {
    if (!this.$isServer) {
      this.hammer = new Hammer.Manager(this.$el, this.options);
      this.recognizers = {};
      this.setupBuiltinRecognizers();
      this.setupCustomRecognizers();
      this.updateEnabled(this.enabled);
    }
  },
  destroyed: function destroyed() {
    if (!this.$isServer) {
      this.hammer.destroy();
    }
  },
  watch: {
    enabled: {
      deep: true,
      handler: function handler() {
        var args = [], len = arguments.length;
        while ( len-- ) args[ len ] = arguments[ len ];
        (ref = this).updateEnabled.apply(ref, args);
        var ref;
      }
    }
  },
  methods: {
    setupBuiltinRecognizers: function setupBuiltinRecognizers()  {
      var this$1 = this;
      for (var i = 0; i < gestures.length; i++) {
        var gesture = gestures[i];
        if (this$1._events[gesture]) {
          var mainGesture = gestureMap[gesture];
          var options = assign({}, (config[mainGesture] || {}), this$1[(mainGesture + "Options")]);
          this$1.addRecognizer(mainGesture, options);
          this$1.addEvent(gesture);
        }
      }
    },
    setupCustomRecognizers: function setupCustomRecognizers() {
      var this$1 = this;
      var gestures$$1 = Object.keys(customEvents);
      for (var i = 0; i < gestures$$1.length; i++) {
        var gesture = gestures$$1[i];
        if (this$1._events[gesture]) {
          var opts = customEvents[gesture];
          var localCustomOpts = this$1[(gesture + "Options")] || {};
          var options = assign({}, opts, localCustomOpts);
          this$1.addRecognizer(gesture, options, {mainGesture: options.type});
          this$1.addEvent(gesture);
        }
      }
    },
    addRecognizer: function addRecognizer(gesture, options, ref) {
      if ( ref === void 0 ) ref = {};
      var mainGesture = ref.mainGesture;
      if (!this.recognizers[gesture]) {
        var recognizer = new Hammer[capitalize(mainGesture || gesture)](guardDirections(options));
        this.recognizers[gesture] = recognizer;
        this.hammer.add(recognizer);
        recognizer.recognizeWith(this.hammer.recognizers);
      }
    },
    addEvent: function addEvent(gesture) {
      var this$1 = this;
      this.hammer.on(gesture, function (e) { return this$1.$emit(gesture, e); });
    },
    updateEnabled: function updateEnabled(newVal, oldVal) {
      var this$1 = this;
      if (newVal === true) {
        this.enableAll();
      } else if (newVal === false) {
        this.disableAll();
      } else if (typeof newVal === 'object') {
        var keys = Object.keys(newVal);
        for (var i = 0; i < keys.length; i++) {
          var event = keys[i];
          if (this$1.recognizers[event]) {
            newVal[event]
              ? this$1.enable(event)
              : this$1.disable(event);
          }
        }
      }
    },
    enable: function enable(r) {
      var recognizer = this.recognizers[r];
      if (!recognizer.options.enable) {
        recognizer.set({ enable: true });
      }
    },
    disable: function disable(r) {
      var recognizer = this.recognizers[r];
      if (recognizer.options.enable) {
        recognizer.set({ enable: false });
      }
    },
    toggle: function toggle(r) {
      var recognizer = this.recognizers[r];
      if (recognizer) {
        recognizer.options.enable
          ? this.disable(r)
          : this.enable(r);
      }
    },
    enableAll: function enableAll(r) {
      this.toggleAll({ enable: true });
    },
    disableAll: function disableAll(r) {
      this.toggleAll({ enable: false });
    },
    toggleAll: function toggleAll(ref) {
      var this$1 = this;
      var enable = ref.enable;
      var keys = Object.keys(this.recognizers);
      for (var i = 0; i < keys.length; i++) {
        var r = this$1.recognizers[keys[i]];
        if (r.options.enable !== enable) {
          r.set({ enable: enable });
        }
      }
    },
    isEnabled: function isEnabled(r) {
      return this.recognizers[r] && this.recognizers[r].options.enable
    }
  },
  render: function render(h) {
    return h(this.tag, {}, this.$slots.default)
  }
};

var installed = false;
var vueTouch = { config: config, customEvents: customEvents };
vueTouch.install = function install(Vue, opts) {
  if ( opts === void 0 ) opts = {};
  var name = opts.name || 'v-touch';
  Vue.component(name, assign(Component, { name: name }));
  installed = true;
}.bind(vueTouch);
vueTouch.registerCustomEvent = function registerCustomEvent(event, options) {
  if ( options === void 0 ) options = {};
  if (installed) {
    console.warn(("\n      [vue-touch]: Custom Event '" + event + "' couldn't be added to vue-touch.\n      Custom Events have to be registered before installing the plugin.\n      "));
    return
  }
  options.event = event;
  customEvents[event] = options;
  Component.props[(event + "Options")] = {
    type: Object,
    default: function default$1() { return {} }
  };
}.bind(vueTouch);
vueTouch.component = Component;
if (true) {
  module.exports = vueTouch;
} else if (typeof define == "function" && define.amd) {
  define([], function(){ return vueTouch });
} else if (typeof window !== 'undefined' && window.Vue) {
  window.VueTouch = vueTouch;
  Vue.use(vueTouch);
}

})));
//# sourceMappingURL=vue-touch.js.map


/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*! Hammer.JS - v2.0.7 - 2016-04-22
 * http://hammerjs.github.io/
 *
 * Copyright (c) 2016 Jorik Tangelder;
 * Licensed under the MIT license */
(function(window, document, exportName, undefined) {
  'use strict';

var VENDOR_PREFIXES = ['', 'webkit', 'Moz', 'MS', 'ms', 'o'];
var TEST_ELEMENT = document.createElement('div');

var TYPE_FUNCTION = 'function';

var round = Math.round;
var abs = Math.abs;
var now = Date.now;

/**
 * set a timeout with a given scope
 * @param {Function} fn
 * @param {Number} timeout
 * @param {Object} context
 * @returns {number}
 */
function setTimeoutContext(fn, timeout, context) {
    return setTimeout(bindFn(fn, context), timeout);
}

/**
 * if the argument is an array, we want to execute the fn on each entry
 * if it aint an array we don't want to do a thing.
 * this is used by all the methods that accept a single and array argument.
 * @param {*|Array} arg
 * @param {String} fn
 * @param {Object} [context]
 * @returns {Boolean}
 */
function invokeArrayArg(arg, fn, context) {
    if (Array.isArray(arg)) {
        each(arg, context[fn], context);
        return true;
    }
    return false;
}

/**
 * walk objects and arrays
 * @param {Object} obj
 * @param {Function} iterator
 * @param {Object} context
 */
function each(obj, iterator, context) {
    var i;

    if (!obj) {
        return;
    }

    if (obj.forEach) {
        obj.forEach(iterator, context);
    } else if (obj.length !== undefined) {
        i = 0;
        while (i < obj.length) {
            iterator.call(context, obj[i], i, obj);
            i++;
        }
    } else {
        for (i in obj) {
            obj.hasOwnProperty(i) && iterator.call(context, obj[i], i, obj);
        }
    }
}

/**
 * wrap a method with a deprecation warning and stack trace
 * @param {Function} method
 * @param {String} name
 * @param {String} message
 * @returns {Function} A new function wrapping the supplied method.
 */
function deprecate(method, name, message) {
    var deprecationMessage = 'DEPRECATED METHOD: ' + name + '\n' + message + ' AT \n';
    return function() {
        var e = new Error('get-stack-trace');
        var stack = e && e.stack ? e.stack.replace(/^[^\(]+?[\n$]/gm, '')
            .replace(/^\s+at\s+/gm, '')
            .replace(/^Object.<anonymous>\s*\(/gm, '{anonymous}()@') : 'Unknown Stack Trace';

        var log = window.console && (window.console.warn || window.console.log);
        if (log) {
            log.call(window.console, deprecationMessage, stack);
        }
        return method.apply(this, arguments);
    };
}

/**
 * extend object.
 * means that properties in dest will be overwritten by the ones in src.
 * @param {Object} target
 * @param {...Object} objects_to_assign
 * @returns {Object} target
 */
var assign;
if (typeof Object.assign !== 'function') {
    assign = function assign(target) {
        if (target === undefined || target === null) {
            throw new TypeError('Cannot convert undefined or null to object');
        }

        var output = Object(target);
        for (var index = 1; index < arguments.length; index++) {
            var source = arguments[index];
            if (source !== undefined && source !== null) {
                for (var nextKey in source) {
                    if (source.hasOwnProperty(nextKey)) {
                        output[nextKey] = source[nextKey];
                    }
                }
            }
        }
        return output;
    };
} else {
    assign = Object.assign;
}

/**
 * extend object.
 * means that properties in dest will be overwritten by the ones in src.
 * @param {Object} dest
 * @param {Object} src
 * @param {Boolean} [merge=false]
 * @returns {Object} dest
 */
var extend = deprecate(function extend(dest, src, merge) {
    var keys = Object.keys(src);
    var i = 0;
    while (i < keys.length) {
        if (!merge || (merge && dest[keys[i]] === undefined)) {
            dest[keys[i]] = src[keys[i]];
        }
        i++;
    }
    return dest;
}, 'extend', 'Use `assign`.');

/**
 * merge the values from src in the dest.
 * means that properties that exist in dest will not be overwritten by src
 * @param {Object} dest
 * @param {Object} src
 * @returns {Object} dest
 */
var merge = deprecate(function merge(dest, src) {
    return extend(dest, src, true);
}, 'merge', 'Use `assign`.');

/**
 * simple class inheritance
 * @param {Function} child
 * @param {Function} base
 * @param {Object} [properties]
 */
function inherit(child, base, properties) {
    var baseP = base.prototype,
        childP;

    childP = child.prototype = Object.create(baseP);
    childP.constructor = child;
    childP._super = baseP;

    if (properties) {
        assign(childP, properties);
    }
}

/**
 * simple function bind
 * @param {Function} fn
 * @param {Object} context
 * @returns {Function}
 */
function bindFn(fn, context) {
    return function boundFn() {
        return fn.apply(context, arguments);
    };
}

/**
 * let a boolean value also be a function that must return a boolean
 * this first item in args will be used as the context
 * @param {Boolean|Function} val
 * @param {Array} [args]
 * @returns {Boolean}
 */
function boolOrFn(val, args) {
    if (typeof val == TYPE_FUNCTION) {
        return val.apply(args ? args[0] || undefined : undefined, args);
    }
    return val;
}

/**
 * use the val2 when val1 is undefined
 * @param {*} val1
 * @param {*} val2
 * @returns {*}
 */
function ifUndefined(val1, val2) {
    return (val1 === undefined) ? val2 : val1;
}

/**
 * addEventListener with multiple events at once
 * @param {EventTarget} target
 * @param {String} types
 * @param {Function} handler
 */
function addEventListeners(target, types, handler) {
    each(splitStr(types), function(type) {
        target.addEventListener(type, handler, false);
    });
}

/**
 * removeEventListener with multiple events at once
 * @param {EventTarget} target
 * @param {String} types
 * @param {Function} handler
 */
function removeEventListeners(target, types, handler) {
    each(splitStr(types), function(type) {
        target.removeEventListener(type, handler, false);
    });
}

/**
 * find if a node is in the given parent
 * @method hasParent
 * @param {HTMLElement} node
 * @param {HTMLElement} parent
 * @return {Boolean} found
 */
function hasParent(node, parent) {
    while (node) {
        if (node == parent) {
            return true;
        }
        node = node.parentNode;
    }
    return false;
}

/**
 * small indexOf wrapper
 * @param {String} str
 * @param {String} find
 * @returns {Boolean} found
 */
function inStr(str, find) {
    return str.indexOf(find) > -1;
}

/**
 * split string on whitespace
 * @param {String} str
 * @returns {Array} words
 */
function splitStr(str) {
    return str.trim().split(/\s+/g);
}

/**
 * find if a array contains the object using indexOf or a simple polyFill
 * @param {Array} src
 * @param {String} find
 * @param {String} [findByKey]
 * @return {Boolean|Number} false when not found, or the index
 */
function inArray(src, find, findByKey) {
    if (src.indexOf && !findByKey) {
        return src.indexOf(find);
    } else {
        var i = 0;
        while (i < src.length) {
            if ((findByKey && src[i][findByKey] == find) || (!findByKey && src[i] === find)) {
                return i;
            }
            i++;
        }
        return -1;
    }
}

/**
 * convert array-like objects to real arrays
 * @param {Object} obj
 * @returns {Array}
 */
function toArray(obj) {
    return Array.prototype.slice.call(obj, 0);
}

/**
 * unique array with objects based on a key (like 'id') or just by the array's value
 * @param {Array} src [{id:1},{id:2},{id:1}]
 * @param {String} [key]
 * @param {Boolean} [sort=False]
 * @returns {Array} [{id:1},{id:2}]
 */
function uniqueArray(src, key, sort) {
    var results = [];
    var values = [];
    var i = 0;

    while (i < src.length) {
        var val = key ? src[i][key] : src[i];
        if (inArray(values, val) < 0) {
            results.push(src[i]);
        }
        values[i] = val;
        i++;
    }

    if (sort) {
        if (!key) {
            results = results.sort();
        } else {
            results = results.sort(function sortUniqueArray(a, b) {
                return a[key] > b[key];
            });
        }
    }

    return results;
}

/**
 * get the prefixed property
 * @param {Object} obj
 * @param {String} property
 * @returns {String|Undefined} prefixed
 */
function prefixed(obj, property) {
    var prefix, prop;
    var camelProp = property[0].toUpperCase() + property.slice(1);

    var i = 0;
    while (i < VENDOR_PREFIXES.length) {
        prefix = VENDOR_PREFIXES[i];
        prop = (prefix) ? prefix + camelProp : property;

        if (prop in obj) {
            return prop;
        }
        i++;
    }
    return undefined;
}

/**
 * get a unique id
 * @returns {number} uniqueId
 */
var _uniqueId = 1;
function uniqueId() {
    return _uniqueId++;
}

/**
 * get the window object of an element
 * @param {HTMLElement} element
 * @returns {DocumentView|Window}
 */
function getWindowForElement(element) {
    var doc = element.ownerDocument || element;
    return (doc.defaultView || doc.parentWindow || window);
}

var MOBILE_REGEX = /mobile|tablet|ip(ad|hone|od)|android/i;

var SUPPORT_TOUCH = ('ontouchstart' in window);
var SUPPORT_POINTER_EVENTS = prefixed(window, 'PointerEvent') !== undefined;
var SUPPORT_ONLY_TOUCH = SUPPORT_TOUCH && MOBILE_REGEX.test(navigator.userAgent);

var INPUT_TYPE_TOUCH = 'touch';
var INPUT_TYPE_PEN = 'pen';
var INPUT_TYPE_MOUSE = 'mouse';
var INPUT_TYPE_KINECT = 'kinect';

var COMPUTE_INTERVAL = 25;

var INPUT_START = 1;
var INPUT_MOVE = 2;
var INPUT_END = 4;
var INPUT_CANCEL = 8;

var DIRECTION_NONE = 1;
var DIRECTION_LEFT = 2;
var DIRECTION_RIGHT = 4;
var DIRECTION_UP = 8;
var DIRECTION_DOWN = 16;

var DIRECTION_HORIZONTAL = DIRECTION_LEFT | DIRECTION_RIGHT;
var DIRECTION_VERTICAL = DIRECTION_UP | DIRECTION_DOWN;
var DIRECTION_ALL = DIRECTION_HORIZONTAL | DIRECTION_VERTICAL;

var PROPS_XY = ['x', 'y'];
var PROPS_CLIENT_XY = ['clientX', 'clientY'];

/**
 * create new input type manager
 * @param {Manager} manager
 * @param {Function} callback
 * @returns {Input}
 * @constructor
 */
function Input(manager, callback) {
    var self = this;
    this.manager = manager;
    this.callback = callback;
    this.element = manager.element;
    this.target = manager.options.inputTarget;

    // smaller wrapper around the handler, for the scope and the enabled state of the manager,
    // so when disabled the input events are completely bypassed.
    this.domHandler = function(ev) {
        if (boolOrFn(manager.options.enable, [manager])) {
            self.handler(ev);
        }
    };

    this.init();

}

Input.prototype = {
    /**
     * should handle the inputEvent data and trigger the callback
     * @virtual
     */
    handler: function() { },

    /**
     * bind the events
     */
    init: function() {
        this.evEl && addEventListeners(this.element, this.evEl, this.domHandler);
        this.evTarget && addEventListeners(this.target, this.evTarget, this.domHandler);
        this.evWin && addEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
    },

    /**
     * unbind the events
     */
    destroy: function() {
        this.evEl && removeEventListeners(this.element, this.evEl, this.domHandler);
        this.evTarget && removeEventListeners(this.target, this.evTarget, this.domHandler);
        this.evWin && removeEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
    }
};

/**
 * create new input type manager
 * called by the Manager constructor
 * @param {Hammer} manager
 * @returns {Input}
 */
function createInputInstance(manager) {
    var Type;
    var inputClass = manager.options.inputClass;

    if (inputClass) {
        Type = inputClass;
    } else if (SUPPORT_POINTER_EVENTS) {
        Type = PointerEventInput;
    } else if (SUPPORT_ONLY_TOUCH) {
        Type = TouchInput;
    } else if (!SUPPORT_TOUCH) {
        Type = MouseInput;
    } else {
        Type = TouchMouseInput;
    }
    return new (Type)(manager, inputHandler);
}

/**
 * handle input events
 * @param {Manager} manager
 * @param {String} eventType
 * @param {Object} input
 */
function inputHandler(manager, eventType, input) {
    var pointersLen = input.pointers.length;
    var changedPointersLen = input.changedPointers.length;
    var isFirst = (eventType & INPUT_START && (pointersLen - changedPointersLen === 0));
    var isFinal = (eventType & (INPUT_END | INPUT_CANCEL) && (pointersLen - changedPointersLen === 0));

    input.isFirst = !!isFirst;
    input.isFinal = !!isFinal;

    if (isFirst) {
        manager.session = {};
    }

    // source event is the normalized value of the domEvents
    // like 'touchstart, mouseup, pointerdown'
    input.eventType = eventType;

    // compute scale, rotation etc
    computeInputData(manager, input);

    // emit secret event
    manager.emit('hammer.input', input);

    manager.recognize(input);
    manager.session.prevInput = input;
}

/**
 * extend the data with some usable properties like scale, rotate, velocity etc
 * @param {Object} manager
 * @param {Object} input
 */
function computeInputData(manager, input) {
    var session = manager.session;
    var pointers = input.pointers;
    var pointersLength = pointers.length;

    // store the first input to calculate the distance and direction
    if (!session.firstInput) {
        session.firstInput = simpleCloneInputData(input);
    }

    // to compute scale and rotation we need to store the multiple touches
    if (pointersLength > 1 && !session.firstMultiple) {
        session.firstMultiple = simpleCloneInputData(input);
    } else if (pointersLength === 1) {
        session.firstMultiple = false;
    }

    var firstInput = session.firstInput;
    var firstMultiple = session.firstMultiple;
    var offsetCenter = firstMultiple ? firstMultiple.center : firstInput.center;

    var center = input.center = getCenter(pointers);
    input.timeStamp = now();
    input.deltaTime = input.timeStamp - firstInput.timeStamp;

    input.angle = getAngle(offsetCenter, center);
    input.distance = getDistance(offsetCenter, center);

    computeDeltaXY(session, input);
    input.offsetDirection = getDirection(input.deltaX, input.deltaY);

    var overallVelocity = getVelocity(input.deltaTime, input.deltaX, input.deltaY);
    input.overallVelocityX = overallVelocity.x;
    input.overallVelocityY = overallVelocity.y;
    input.overallVelocity = (abs(overallVelocity.x) > abs(overallVelocity.y)) ? overallVelocity.x : overallVelocity.y;

    input.scale = firstMultiple ? getScale(firstMultiple.pointers, pointers) : 1;
    input.rotation = firstMultiple ? getRotation(firstMultiple.pointers, pointers) : 0;

    input.maxPointers = !session.prevInput ? input.pointers.length : ((input.pointers.length >
        session.prevInput.maxPointers) ? input.pointers.length : session.prevInput.maxPointers);

    computeIntervalInputData(session, input);

    // find the correct target
    var target = manager.element;
    if (hasParent(input.srcEvent.target, target)) {
        target = input.srcEvent.target;
    }
    input.target = target;
}

function computeDeltaXY(session, input) {
    var center = input.center;
    var offset = session.offsetDelta || {};
    var prevDelta = session.prevDelta || {};
    var prevInput = session.prevInput || {};

    if (input.eventType === INPUT_START || prevInput.eventType === INPUT_END) {
        prevDelta = session.prevDelta = {
            x: prevInput.deltaX || 0,
            y: prevInput.deltaY || 0
        };

        offset = session.offsetDelta = {
            x: center.x,
            y: center.y
        };
    }

    input.deltaX = prevDelta.x + (center.x - offset.x);
    input.deltaY = prevDelta.y + (center.y - offset.y);
}

/**
 * velocity is calculated every x ms
 * @param {Object} session
 * @param {Object} input
 */
function computeIntervalInputData(session, input) {
    var last = session.lastInterval || input,
        deltaTime = input.timeStamp - last.timeStamp,
        velocity, velocityX, velocityY, direction;

    if (input.eventType != INPUT_CANCEL && (deltaTime > COMPUTE_INTERVAL || last.velocity === undefined)) {
        var deltaX = input.deltaX - last.deltaX;
        var deltaY = input.deltaY - last.deltaY;

        var v = getVelocity(deltaTime, deltaX, deltaY);
        velocityX = v.x;
        velocityY = v.y;
        velocity = (abs(v.x) > abs(v.y)) ? v.x : v.y;
        direction = getDirection(deltaX, deltaY);

        session.lastInterval = input;
    } else {
        // use latest velocity info if it doesn't overtake a minimum period
        velocity = last.velocity;
        velocityX = last.velocityX;
        velocityY = last.velocityY;
        direction = last.direction;
    }

    input.velocity = velocity;
    input.velocityX = velocityX;
    input.velocityY = velocityY;
    input.direction = direction;
}

/**
 * create a simple clone from the input used for storage of firstInput and firstMultiple
 * @param {Object} input
 * @returns {Object} clonedInputData
 */
function simpleCloneInputData(input) {
    // make a simple copy of the pointers because we will get a reference if we don't
    // we only need clientXY for the calculations
    var pointers = [];
    var i = 0;
    while (i < input.pointers.length) {
        pointers[i] = {
            clientX: round(input.pointers[i].clientX),
            clientY: round(input.pointers[i].clientY)
        };
        i++;
    }

    return {
        timeStamp: now(),
        pointers: pointers,
        center: getCenter(pointers),
        deltaX: input.deltaX,
        deltaY: input.deltaY
    };
}

/**
 * get the center of all the pointers
 * @param {Array} pointers
 * @return {Object} center contains `x` and `y` properties
 */
function getCenter(pointers) {
    var pointersLength = pointers.length;

    // no need to loop when only one touch
    if (pointersLength === 1) {
        return {
            x: round(pointers[0].clientX),
            y: round(pointers[0].clientY)
        };
    }

    var x = 0, y = 0, i = 0;
    while (i < pointersLength) {
        x += pointers[i].clientX;
        y += pointers[i].clientY;
        i++;
    }

    return {
        x: round(x / pointersLength),
        y: round(y / pointersLength)
    };
}

/**
 * calculate the velocity between two points. unit is in px per ms.
 * @param {Number} deltaTime
 * @param {Number} x
 * @param {Number} y
 * @return {Object} velocity `x` and `y`
 */
function getVelocity(deltaTime, x, y) {
    return {
        x: x / deltaTime || 0,
        y: y / deltaTime || 0
    };
}

/**
 * get the direction between two points
 * @param {Number} x
 * @param {Number} y
 * @return {Number} direction
 */
function getDirection(x, y) {
    if (x === y) {
        return DIRECTION_NONE;
    }

    if (abs(x) >= abs(y)) {
        return x < 0 ? DIRECTION_LEFT : DIRECTION_RIGHT;
    }
    return y < 0 ? DIRECTION_UP : DIRECTION_DOWN;
}

/**
 * calculate the absolute distance between two points
 * @param {Object} p1 {x, y}
 * @param {Object} p2 {x, y}
 * @param {Array} [props] containing x and y keys
 * @return {Number} distance
 */
function getDistance(p1, p2, props) {
    if (!props) {
        props = PROPS_XY;
    }
    var x = p2[props[0]] - p1[props[0]],
        y = p2[props[1]] - p1[props[1]];

    return Math.sqrt((x * x) + (y * y));
}

/**
 * calculate the angle between two coordinates
 * @param {Object} p1
 * @param {Object} p2
 * @param {Array} [props] containing x and y keys
 * @return {Number} angle
 */
function getAngle(p1, p2, props) {
    if (!props) {
        props = PROPS_XY;
    }
    var x = p2[props[0]] - p1[props[0]],
        y = p2[props[1]] - p1[props[1]];
    return Math.atan2(y, x) * 180 / Math.PI;
}

/**
 * calculate the rotation degrees between two pointersets
 * @param {Array} start array of pointers
 * @param {Array} end array of pointers
 * @return {Number} rotation
 */
function getRotation(start, end) {
    return getAngle(end[1], end[0], PROPS_CLIENT_XY) + getAngle(start[1], start[0], PROPS_CLIENT_XY);
}

/**
 * calculate the scale factor between two pointersets
 * no scale is 1, and goes down to 0 when pinched together, and bigger when pinched out
 * @param {Array} start array of pointers
 * @param {Array} end array of pointers
 * @return {Number} scale
 */
function getScale(start, end) {
    return getDistance(end[0], end[1], PROPS_CLIENT_XY) / getDistance(start[0], start[1], PROPS_CLIENT_XY);
}

var MOUSE_INPUT_MAP = {
    mousedown: INPUT_START,
    mousemove: INPUT_MOVE,
    mouseup: INPUT_END
};

var MOUSE_ELEMENT_EVENTS = 'mousedown';
var MOUSE_WINDOW_EVENTS = 'mousemove mouseup';

/**
 * Mouse events input
 * @constructor
 * @extends Input
 */
function MouseInput() {
    this.evEl = MOUSE_ELEMENT_EVENTS;
    this.evWin = MOUSE_WINDOW_EVENTS;

    this.pressed = false; // mousedown state

    Input.apply(this, arguments);
}

inherit(MouseInput, Input, {
    /**
     * handle mouse events
     * @param {Object} ev
     */
    handler: function MEhandler(ev) {
        var eventType = MOUSE_INPUT_MAP[ev.type];

        // on start we want to have the left mouse button down
        if (eventType & INPUT_START && ev.button === 0) {
            this.pressed = true;
        }

        if (eventType & INPUT_MOVE && ev.which !== 1) {
            eventType = INPUT_END;
        }

        // mouse must be down
        if (!this.pressed) {
            return;
        }

        if (eventType & INPUT_END) {
            this.pressed = false;
        }

        this.callback(this.manager, eventType, {
            pointers: [ev],
            changedPointers: [ev],
            pointerType: INPUT_TYPE_MOUSE,
            srcEvent: ev
        });
    }
});

var POINTER_INPUT_MAP = {
    pointerdown: INPUT_START,
    pointermove: INPUT_MOVE,
    pointerup: INPUT_END,
    pointercancel: INPUT_CANCEL,
    pointerout: INPUT_CANCEL
};

// in IE10 the pointer types is defined as an enum
var IE10_POINTER_TYPE_ENUM = {
    2: INPUT_TYPE_TOUCH,
    3: INPUT_TYPE_PEN,
    4: INPUT_TYPE_MOUSE,
    5: INPUT_TYPE_KINECT // see https://twitter.com/jacobrossi/status/480596438489890816
};

var POINTER_ELEMENT_EVENTS = 'pointerdown';
var POINTER_WINDOW_EVENTS = 'pointermove pointerup pointercancel';

// IE10 has prefixed support, and case-sensitive
if (window.MSPointerEvent && !window.PointerEvent) {
    POINTER_ELEMENT_EVENTS = 'MSPointerDown';
    POINTER_WINDOW_EVENTS = 'MSPointerMove MSPointerUp MSPointerCancel';
}

/**
 * Pointer events input
 * @constructor
 * @extends Input
 */
function PointerEventInput() {
    this.evEl = POINTER_ELEMENT_EVENTS;
    this.evWin = POINTER_WINDOW_EVENTS;

    Input.apply(this, arguments);

    this.store = (this.manager.session.pointerEvents = []);
}

inherit(PointerEventInput, Input, {
    /**
     * handle mouse events
     * @param {Object} ev
     */
    handler: function PEhandler(ev) {
        var store = this.store;
        var removePointer = false;

        var eventTypeNormalized = ev.type.toLowerCase().replace('ms', '');
        var eventType = POINTER_INPUT_MAP[eventTypeNormalized];
        var pointerType = IE10_POINTER_TYPE_ENUM[ev.pointerType] || ev.pointerType;

        var isTouch = (pointerType == INPUT_TYPE_TOUCH);

        // get index of the event in the store
        var storeIndex = inArray(store, ev.pointerId, 'pointerId');

        // start and mouse must be down
        if (eventType & INPUT_START && (ev.button === 0 || isTouch)) {
            if (storeIndex < 0) {
                store.push(ev);
                storeIndex = store.length - 1;
            }
        } else if (eventType & (INPUT_END | INPUT_CANCEL)) {
            removePointer = true;
        }

        // it not found, so the pointer hasn't been down (so it's probably a hover)
        if (storeIndex < 0) {
            return;
        }

        // update the event in the store
        store[storeIndex] = ev;

        this.callback(this.manager, eventType, {
            pointers: store,
            changedPointers: [ev],
            pointerType: pointerType,
            srcEvent: ev
        });

        if (removePointer) {
            // remove from the store
            store.splice(storeIndex, 1);
        }
    }
});

var SINGLE_TOUCH_INPUT_MAP = {
    touchstart: INPUT_START,
    touchmove: INPUT_MOVE,
    touchend: INPUT_END,
    touchcancel: INPUT_CANCEL
};

var SINGLE_TOUCH_TARGET_EVENTS = 'touchstart';
var SINGLE_TOUCH_WINDOW_EVENTS = 'touchstart touchmove touchend touchcancel';

/**
 * Touch events input
 * @constructor
 * @extends Input
 */
function SingleTouchInput() {
    this.evTarget = SINGLE_TOUCH_TARGET_EVENTS;
    this.evWin = SINGLE_TOUCH_WINDOW_EVENTS;
    this.started = false;

    Input.apply(this, arguments);
}

inherit(SingleTouchInput, Input, {
    handler: function TEhandler(ev) {
        var type = SINGLE_TOUCH_INPUT_MAP[ev.type];

        // should we handle the touch events?
        if (type === INPUT_START) {
            this.started = true;
        }

        if (!this.started) {
            return;
        }

        var touches = normalizeSingleTouches.call(this, ev, type);

        // when done, reset the started state
        if (type & (INPUT_END | INPUT_CANCEL) && touches[0].length - touches[1].length === 0) {
            this.started = false;
        }

        this.callback(this.manager, type, {
            pointers: touches[0],
            changedPointers: touches[1],
            pointerType: INPUT_TYPE_TOUCH,
            srcEvent: ev
        });
    }
});

/**
 * @this {TouchInput}
 * @param {Object} ev
 * @param {Number} type flag
 * @returns {undefined|Array} [all, changed]
 */
function normalizeSingleTouches(ev, type) {
    var all = toArray(ev.touches);
    var changed = toArray(ev.changedTouches);

    if (type & (INPUT_END | INPUT_CANCEL)) {
        all = uniqueArray(all.concat(changed), 'identifier', true);
    }

    return [all, changed];
}

var TOUCH_INPUT_MAP = {
    touchstart: INPUT_START,
    touchmove: INPUT_MOVE,
    touchend: INPUT_END,
    touchcancel: INPUT_CANCEL
};

var TOUCH_TARGET_EVENTS = 'touchstart touchmove touchend touchcancel';

/**
 * Multi-user touch events input
 * @constructor
 * @extends Input
 */
function TouchInput() {
    this.evTarget = TOUCH_TARGET_EVENTS;
    this.targetIds = {};

    Input.apply(this, arguments);
}

inherit(TouchInput, Input, {
    handler: function MTEhandler(ev) {
        var type = TOUCH_INPUT_MAP[ev.type];
        var touches = getTouches.call(this, ev, type);
        if (!touches) {
            return;
        }

        this.callback(this.manager, type, {
            pointers: touches[0],
            changedPointers: touches[1],
            pointerType: INPUT_TYPE_TOUCH,
            srcEvent: ev
        });
    }
});

/**
 * @this {TouchInput}
 * @param {Object} ev
 * @param {Number} type flag
 * @returns {undefined|Array} [all, changed]
 */
function getTouches(ev, type) {
    var allTouches = toArray(ev.touches);
    var targetIds = this.targetIds;

    // when there is only one touch, the process can be simplified
    if (type & (INPUT_START | INPUT_MOVE) && allTouches.length === 1) {
        targetIds[allTouches[0].identifier] = true;
        return [allTouches, allTouches];
    }

    var i,
        targetTouches,
        changedTouches = toArray(ev.changedTouches),
        changedTargetTouches = [],
        target = this.target;

    // get target touches from touches
    targetTouches = allTouches.filter(function(touch) {
        return hasParent(touch.target, target);
    });

    // collect touches
    if (type === INPUT_START) {
        i = 0;
        while (i < targetTouches.length) {
            targetIds[targetTouches[i].identifier] = true;
            i++;
        }
    }

    // filter changed touches to only contain touches that exist in the collected target ids
    i = 0;
    while (i < changedTouches.length) {
        if (targetIds[changedTouches[i].identifier]) {
            changedTargetTouches.push(changedTouches[i]);
        }

        // cleanup removed touches
        if (type & (INPUT_END | INPUT_CANCEL)) {
            delete targetIds[changedTouches[i].identifier];
        }
        i++;
    }

    if (!changedTargetTouches.length) {
        return;
    }

    return [
        // merge targetTouches with changedTargetTouches so it contains ALL touches, including 'end' and 'cancel'
        uniqueArray(targetTouches.concat(changedTargetTouches), 'identifier', true),
        changedTargetTouches
    ];
}

/**
 * Combined touch and mouse input
 *
 * Touch has a higher priority then mouse, and while touching no mouse events are allowed.
 * This because touch devices also emit mouse events while doing a touch.
 *
 * @constructor
 * @extends Input
 */

var DEDUP_TIMEOUT = 2500;
var DEDUP_DISTANCE = 25;

function TouchMouseInput() {
    Input.apply(this, arguments);

    var handler = bindFn(this.handler, this);
    this.touch = new TouchInput(this.manager, handler);
    this.mouse = new MouseInput(this.manager, handler);

    this.primaryTouch = null;
    this.lastTouches = [];
}

inherit(TouchMouseInput, Input, {
    /**
     * handle mouse and touch events
     * @param {Hammer} manager
     * @param {String} inputEvent
     * @param {Object} inputData
     */
    handler: function TMEhandler(manager, inputEvent, inputData) {
        var isTouch = (inputData.pointerType == INPUT_TYPE_TOUCH),
            isMouse = (inputData.pointerType == INPUT_TYPE_MOUSE);

        if (isMouse && inputData.sourceCapabilities && inputData.sourceCapabilities.firesTouchEvents) {
            return;
        }

        // when we're in a touch event, record touches to  de-dupe synthetic mouse event
        if (isTouch) {
            recordTouches.call(this, inputEvent, inputData);
        } else if (isMouse && isSyntheticEvent.call(this, inputData)) {
            return;
        }

        this.callback(manager, inputEvent, inputData);
    },

    /**
     * remove the event listeners
     */
    destroy: function destroy() {
        this.touch.destroy();
        this.mouse.destroy();
    }
});

function recordTouches(eventType, eventData) {
    if (eventType & INPUT_START) {
        this.primaryTouch = eventData.changedPointers[0].identifier;
        setLastTouch.call(this, eventData);
    } else if (eventType & (INPUT_END | INPUT_CANCEL)) {
        setLastTouch.call(this, eventData);
    }
}

function setLastTouch(eventData) {
    var touch = eventData.changedPointers[0];

    if (touch.identifier === this.primaryTouch) {
        var lastTouch = {x: touch.clientX, y: touch.clientY};
        this.lastTouches.push(lastTouch);
        var lts = this.lastTouches;
        var removeLastTouch = function() {
            var i = lts.indexOf(lastTouch);
            if (i > -1) {
                lts.splice(i, 1);
            }
        };
        setTimeout(removeLastTouch, DEDUP_TIMEOUT);
    }
}

function isSyntheticEvent(eventData) {
    var x = eventData.srcEvent.clientX, y = eventData.srcEvent.clientY;
    for (var i = 0; i < this.lastTouches.length; i++) {
        var t = this.lastTouches[i];
        var dx = Math.abs(x - t.x), dy = Math.abs(y - t.y);
        if (dx <= DEDUP_DISTANCE && dy <= DEDUP_DISTANCE) {
            return true;
        }
    }
    return false;
}

var PREFIXED_TOUCH_ACTION = prefixed(TEST_ELEMENT.style, 'touchAction');
var NATIVE_TOUCH_ACTION = PREFIXED_TOUCH_ACTION !== undefined;

// magical touchAction value
var TOUCH_ACTION_COMPUTE = 'compute';
var TOUCH_ACTION_AUTO = 'auto';
var TOUCH_ACTION_MANIPULATION = 'manipulation'; // not implemented
var TOUCH_ACTION_NONE = 'none';
var TOUCH_ACTION_PAN_X = 'pan-x';
var TOUCH_ACTION_PAN_Y = 'pan-y';
var TOUCH_ACTION_MAP = getTouchActionProps();

/**
 * Touch Action
 * sets the touchAction property or uses the js alternative
 * @param {Manager} manager
 * @param {String} value
 * @constructor
 */
function TouchAction(manager, value) {
    this.manager = manager;
    this.set(value);
}

TouchAction.prototype = {
    /**
     * set the touchAction value on the element or enable the polyfill
     * @param {String} value
     */
    set: function(value) {
        // find out the touch-action by the event handlers
        if (value == TOUCH_ACTION_COMPUTE) {
            value = this.compute();
        }

        if (NATIVE_TOUCH_ACTION && this.manager.element.style && TOUCH_ACTION_MAP[value]) {
            this.manager.element.style[PREFIXED_TOUCH_ACTION] = value;
        }
        this.actions = value.toLowerCase().trim();
    },

    /**
     * just re-set the touchAction value
     */
    update: function() {
        this.set(this.manager.options.touchAction);
    },

    /**
     * compute the value for the touchAction property based on the recognizer's settings
     * @returns {String} value
     */
    compute: function() {
        var actions = [];
        each(this.manager.recognizers, function(recognizer) {
            if (boolOrFn(recognizer.options.enable, [recognizer])) {
                actions = actions.concat(recognizer.getTouchAction());
            }
        });
        return cleanTouchActions(actions.join(' '));
    },

    /**
     * this method is called on each input cycle and provides the preventing of the browser behavior
     * @param {Object} input
     */
    preventDefaults: function(input) {
        var srcEvent = input.srcEvent;
        var direction = input.offsetDirection;

        // if the touch action did prevented once this session
        if (this.manager.session.prevented) {
            srcEvent.preventDefault();
            return;
        }

        var actions = this.actions;
        var hasNone = inStr(actions, TOUCH_ACTION_NONE) && !TOUCH_ACTION_MAP[TOUCH_ACTION_NONE];
        var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_Y];
        var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_X];

        if (hasNone) {
            //do not prevent defaults if this is a tap gesture

            var isTapPointer = input.pointers.length === 1;
            var isTapMovement = input.distance < 2;
            var isTapTouchTime = input.deltaTime < 250;

            if (isTapPointer && isTapMovement && isTapTouchTime) {
                return;
            }
        }

        if (hasPanX && hasPanY) {
            // `pan-x pan-y` means browser handles all scrolling/panning, do not prevent
            return;
        }

        if (hasNone ||
            (hasPanY && direction & DIRECTION_HORIZONTAL) ||
            (hasPanX && direction & DIRECTION_VERTICAL)) {
            return this.preventSrc(srcEvent);
        }
    },

    /**
     * call preventDefault to prevent the browser's default behavior (scrolling in most cases)
     * @param {Object} srcEvent
     */
    preventSrc: function(srcEvent) {
        this.manager.session.prevented = true;
        srcEvent.preventDefault();
    }
};

/**
 * when the touchActions are collected they are not a valid value, so we need to clean things up. *
 * @param {String} actions
 * @returns {*}
 */
function cleanTouchActions(actions) {
    // none
    if (inStr(actions, TOUCH_ACTION_NONE)) {
        return TOUCH_ACTION_NONE;
    }

    var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X);
    var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y);

    // if both pan-x and pan-y are set (different recognizers
    // for different directions, e.g. horizontal pan but vertical swipe?)
    // we need none (as otherwise with pan-x pan-y combined none of these
    // recognizers will work, since the browser would handle all panning
    if (hasPanX && hasPanY) {
        return TOUCH_ACTION_NONE;
    }

    // pan-x OR pan-y
    if (hasPanX || hasPanY) {
        return hasPanX ? TOUCH_ACTION_PAN_X : TOUCH_ACTION_PAN_Y;
    }

    // manipulation
    if (inStr(actions, TOUCH_ACTION_MANIPULATION)) {
        return TOUCH_ACTION_MANIPULATION;
    }

    return TOUCH_ACTION_AUTO;
}

function getTouchActionProps() {
    if (!NATIVE_TOUCH_ACTION) {
        return false;
    }
    var touchMap = {};
    var cssSupports = window.CSS && window.CSS.supports;
    ['auto', 'manipulation', 'pan-y', 'pan-x', 'pan-x pan-y', 'none'].forEach(function(val) {

        // If css.supports is not supported but there is native touch-action assume it supports
        // all values. This is the case for IE 10 and 11.
        touchMap[val] = cssSupports ? window.CSS.supports('touch-action', val) : true;
    });
    return touchMap;
}

/**
 * Recognizer flow explained; *
 * All recognizers have the initial state of POSSIBLE when a input session starts.
 * The definition of a input session is from the first input until the last input, with all it's movement in it. *
 * Example session for mouse-input: mousedown -> mousemove -> mouseup
 *
 * On each recognizing cycle (see Manager.recognize) the .recognize() method is executed
 * which determines with state it should be.
 *
 * If the recognizer has the state FAILED, CANCELLED or RECOGNIZED (equals ENDED), it is reset to
 * POSSIBLE to give it another change on the next cycle.
 *
 *               Possible
 *                  |
 *            +-----+---------------+
 *            |                     |
 *      +-----+-----+               |
 *      |           |               |
 *   Failed      Cancelled          |
 *                          +-------+------+
 *                          |              |
 *                      Recognized       Began
 *                                         |
 *                                      Changed
 *                                         |
 *                                  Ended/Recognized
 */
var STATE_POSSIBLE = 1;
var STATE_BEGAN = 2;
var STATE_CHANGED = 4;
var STATE_ENDED = 8;
var STATE_RECOGNIZED = STATE_ENDED;
var STATE_CANCELLED = 16;
var STATE_FAILED = 32;

/**
 * Recognizer
 * Every recognizer needs to extend from this class.
 * @constructor
 * @param {Object} options
 */
function Recognizer(options) {
    this.options = assign({}, this.defaults, options || {});

    this.id = uniqueId();

    this.manager = null;

    // default is enable true
    this.options.enable = ifUndefined(this.options.enable, true);

    this.state = STATE_POSSIBLE;

    this.simultaneous = {};
    this.requireFail = [];
}

Recognizer.prototype = {
    /**
     * @virtual
     * @type {Object}
     */
    defaults: {},

    /**
     * set options
     * @param {Object} options
     * @return {Recognizer}
     */
    set: function(options) {
        assign(this.options, options);

        // also update the touchAction, in case something changed about the directions/enabled state
        this.manager && this.manager.touchAction.update();
        return this;
    },

    /**
     * recognize simultaneous with an other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    recognizeWith: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'recognizeWith', this)) {
            return this;
        }

        var simultaneous = this.simultaneous;
        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        if (!simultaneous[otherRecognizer.id]) {
            simultaneous[otherRecognizer.id] = otherRecognizer;
            otherRecognizer.recognizeWith(this);
        }
        return this;
    },

    /**
     * drop the simultaneous link. it doesnt remove the link on the other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    dropRecognizeWith: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'dropRecognizeWith', this)) {
            return this;
        }

        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        delete this.simultaneous[otherRecognizer.id];
        return this;
    },

    /**
     * recognizer can only run when an other is failing
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    requireFailure: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'requireFailure', this)) {
            return this;
        }

        var requireFail = this.requireFail;
        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        if (inArray(requireFail, otherRecognizer) === -1) {
            requireFail.push(otherRecognizer);
            otherRecognizer.requireFailure(this);
        }
        return this;
    },

    /**
     * drop the requireFailure link. it does not remove the link on the other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    dropRequireFailure: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'dropRequireFailure', this)) {
            return this;
        }

        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        var index = inArray(this.requireFail, otherRecognizer);
        if (index > -1) {
            this.requireFail.splice(index, 1);
        }
        return this;
    },

    /**
     * has require failures boolean
     * @returns {boolean}
     */
    hasRequireFailures: function() {
        return this.requireFail.length > 0;
    },

    /**
     * if the recognizer can recognize simultaneous with an other recognizer
     * @param {Recognizer} otherRecognizer
     * @returns {Boolean}
     */
    canRecognizeWith: function(otherRecognizer) {
        return !!this.simultaneous[otherRecognizer.id];
    },

    /**
     * You should use `tryEmit` instead of `emit` directly to check
     * that all the needed recognizers has failed before emitting.
     * @param {Object} input
     */
    emit: function(input) {
        var self = this;
        var state = this.state;

        function emit(event) {
            self.manager.emit(event, input);
        }

        // 'panstart' and 'panmove'
        if (state < STATE_ENDED) {
            emit(self.options.event + stateStr(state));
        }

        emit(self.options.event); // simple 'eventName' events

        if (input.additionalEvent) { // additional event(panleft, panright, pinchin, pinchout...)
            emit(input.additionalEvent);
        }

        // panend and pancancel
        if (state >= STATE_ENDED) {
            emit(self.options.event + stateStr(state));
        }
    },

    /**
     * Check that all the require failure recognizers has failed,
     * if true, it emits a gesture event,
     * otherwise, setup the state to FAILED.
     * @param {Object} input
     */
    tryEmit: function(input) {
        if (this.canEmit()) {
            return this.emit(input);
        }
        // it's failing anyway
        this.state = STATE_FAILED;
    },

    /**
     * can we emit?
     * @returns {boolean}
     */
    canEmit: function() {
        var i = 0;
        while (i < this.requireFail.length) {
            if (!(this.requireFail[i].state & (STATE_FAILED | STATE_POSSIBLE))) {
                return false;
            }
            i++;
        }
        return true;
    },

    /**
     * update the recognizer
     * @param {Object} inputData
     */
    recognize: function(inputData) {
        // make a new copy of the inputData
        // so we can change the inputData without messing up the other recognizers
        var inputDataClone = assign({}, inputData);

        // is is enabled and allow recognizing?
        if (!boolOrFn(this.options.enable, [this, inputDataClone])) {
            this.reset();
            this.state = STATE_FAILED;
            return;
        }

        // reset when we've reached the end
        if (this.state & (STATE_RECOGNIZED | STATE_CANCELLED | STATE_FAILED)) {
            this.state = STATE_POSSIBLE;
        }

        this.state = this.process(inputDataClone);

        // the recognizer has recognized a gesture
        // so trigger an event
        if (this.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED | STATE_CANCELLED)) {
            this.tryEmit(inputDataClone);
        }
    },

    /**
     * return the state of the recognizer
     * the actual recognizing happens in this method
     * @virtual
     * @param {Object} inputData
     * @returns {Const} STATE
     */
    process: function(inputData) { }, // jshint ignore:line

    /**
     * return the preferred touch-action
     * @virtual
     * @returns {Array}
     */
    getTouchAction: function() { },

    /**
     * called when the gesture isn't allowed to recognize
     * like when another is being recognized or it is disabled
     * @virtual
     */
    reset: function() { }
};

/**
 * get a usable string, used as event postfix
 * @param {Const} state
 * @returns {String} state
 */
function stateStr(state) {
    if (state & STATE_CANCELLED) {
        return 'cancel';
    } else if (state & STATE_ENDED) {
        return 'end';
    } else if (state & STATE_CHANGED) {
        return 'move';
    } else if (state & STATE_BEGAN) {
        return 'start';
    }
    return '';
}

/**
 * direction cons to string
 * @param {Const} direction
 * @returns {String}
 */
function directionStr(direction) {
    if (direction == DIRECTION_DOWN) {
        return 'down';
    } else if (direction == DIRECTION_UP) {
        return 'up';
    } else if (direction == DIRECTION_LEFT) {
        return 'left';
    } else if (direction == DIRECTION_RIGHT) {
        return 'right';
    }
    return '';
}

/**
 * get a recognizer by name if it is bound to a manager
 * @param {Recognizer|String} otherRecognizer
 * @param {Recognizer} recognizer
 * @returns {Recognizer}
 */
function getRecognizerByNameIfManager(otherRecognizer, recognizer) {
    var manager = recognizer.manager;
    if (manager) {
        return manager.get(otherRecognizer);
    }
    return otherRecognizer;
}

/**
 * This recognizer is just used as a base for the simple attribute recognizers.
 * @constructor
 * @extends Recognizer
 */
function AttrRecognizer() {
    Recognizer.apply(this, arguments);
}

inherit(AttrRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof AttrRecognizer
     */
    defaults: {
        /**
         * @type {Number}
         * @default 1
         */
        pointers: 1
    },

    /**
     * Used to check if it the recognizer receives valid input, like input.distance > 10.
     * @memberof AttrRecognizer
     * @param {Object} input
     * @returns {Boolean} recognized
     */
    attrTest: function(input) {
        var optionPointers = this.options.pointers;
        return optionPointers === 0 || input.pointers.length === optionPointers;
    },

    /**
     * Process the input and return the state for the recognizer
     * @memberof AttrRecognizer
     * @param {Object} input
     * @returns {*} State
     */
    process: function(input) {
        var state = this.state;
        var eventType = input.eventType;

        var isRecognized = state & (STATE_BEGAN | STATE_CHANGED);
        var isValid = this.attrTest(input);

        // on cancel input and we've recognized before, return STATE_CANCELLED
        if (isRecognized && (eventType & INPUT_CANCEL || !isValid)) {
            return state | STATE_CANCELLED;
        } else if (isRecognized || isValid) {
            if (eventType & INPUT_END) {
                return state | STATE_ENDED;
            } else if (!(state & STATE_BEGAN)) {
                return STATE_BEGAN;
            }
            return state | STATE_CHANGED;
        }
        return STATE_FAILED;
    }
});

/**
 * Pan
 * Recognized when the pointer is down and moved in the allowed direction.
 * @constructor
 * @extends AttrRecognizer
 */
function PanRecognizer() {
    AttrRecognizer.apply(this, arguments);

    this.pX = null;
    this.pY = null;
}

inherit(PanRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof PanRecognizer
     */
    defaults: {
        event: 'pan',
        threshold: 10,
        pointers: 1,
        direction: DIRECTION_ALL
    },

    getTouchAction: function() {
        var direction = this.options.direction;
        var actions = [];
        if (direction & DIRECTION_HORIZONTAL) {
            actions.push(TOUCH_ACTION_PAN_Y);
        }
        if (direction & DIRECTION_VERTICAL) {
            actions.push(TOUCH_ACTION_PAN_X);
        }
        return actions;
    },

    directionTest: function(input) {
        var options = this.options;
        var hasMoved = true;
        var distance = input.distance;
        var direction = input.direction;
        var x = input.deltaX;
        var y = input.deltaY;

        // lock to axis?
        if (!(direction & options.direction)) {
            if (options.direction & DIRECTION_HORIZONTAL) {
                direction = (x === 0) ? DIRECTION_NONE : (x < 0) ? DIRECTION_LEFT : DIRECTION_RIGHT;
                hasMoved = x != this.pX;
                distance = Math.abs(input.deltaX);
            } else {
                direction = (y === 0) ? DIRECTION_NONE : (y < 0) ? DIRECTION_UP : DIRECTION_DOWN;
                hasMoved = y != this.pY;
                distance = Math.abs(input.deltaY);
            }
        }
        input.direction = direction;
        return hasMoved && distance > options.threshold && direction & options.direction;
    },

    attrTest: function(input) {
        return AttrRecognizer.prototype.attrTest.call(this, input) &&
            (this.state & STATE_BEGAN || (!(this.state & STATE_BEGAN) && this.directionTest(input)));
    },

    emit: function(input) {

        this.pX = input.deltaX;
        this.pY = input.deltaY;

        var direction = directionStr(input.direction);

        if (direction) {
            input.additionalEvent = this.options.event + direction;
        }
        this._super.emit.call(this, input);
    }
});

/**
 * Pinch
 * Recognized when two or more pointers are moving toward (zoom-in) or away from each other (zoom-out).
 * @constructor
 * @extends AttrRecognizer
 */
function PinchRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(PinchRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof PinchRecognizer
     */
    defaults: {
        event: 'pinch',
        threshold: 0,
        pointers: 2
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_NONE];
    },

    attrTest: function(input) {
        return this._super.attrTest.call(this, input) &&
            (Math.abs(input.scale - 1) > this.options.threshold || this.state & STATE_BEGAN);
    },

    emit: function(input) {
        if (input.scale !== 1) {
            var inOut = input.scale < 1 ? 'in' : 'out';
            input.additionalEvent = this.options.event + inOut;
        }
        this._super.emit.call(this, input);
    }
});

/**
 * Press
 * Recognized when the pointer is down for x ms without any movement.
 * @constructor
 * @extends Recognizer
 */
function PressRecognizer() {
    Recognizer.apply(this, arguments);

    this._timer = null;
    this._input = null;
}

inherit(PressRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof PressRecognizer
     */
    defaults: {
        event: 'press',
        pointers: 1,
        time: 251, // minimal time of the pointer to be pressed
        threshold: 9 // a minimal movement is ok, but keep it low
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_AUTO];
    },

    process: function(input) {
        var options = this.options;
        var validPointers = input.pointers.length === options.pointers;
        var validMovement = input.distance < options.threshold;
        var validTime = input.deltaTime > options.time;

        this._input = input;

        // we only allow little movement
        // and we've reached an end event, so a tap is possible
        if (!validMovement || !validPointers || (input.eventType & (INPUT_END | INPUT_CANCEL) && !validTime)) {
            this.reset();
        } else if (input.eventType & INPUT_START) {
            this.reset();
            this._timer = setTimeoutContext(function() {
                this.state = STATE_RECOGNIZED;
                this.tryEmit();
            }, options.time, this);
        } else if (input.eventType & INPUT_END) {
            return STATE_RECOGNIZED;
        }
        return STATE_FAILED;
    },

    reset: function() {
        clearTimeout(this._timer);
    },

    emit: function(input) {
        if (this.state !== STATE_RECOGNIZED) {
            return;
        }

        if (input && (input.eventType & INPUT_END)) {
            this.manager.emit(this.options.event + 'up', input);
        } else {
            this._input.timeStamp = now();
            this.manager.emit(this.options.event, this._input);
        }
    }
});

/**
 * Rotate
 * Recognized when two or more pointer are moving in a circular motion.
 * @constructor
 * @extends AttrRecognizer
 */
function RotateRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(RotateRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof RotateRecognizer
     */
    defaults: {
        event: 'rotate',
        threshold: 0,
        pointers: 2
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_NONE];
    },

    attrTest: function(input) {
        return this._super.attrTest.call(this, input) &&
            (Math.abs(input.rotation) > this.options.threshold || this.state & STATE_BEGAN);
    }
});

/**
 * Swipe
 * Recognized when the pointer is moving fast (velocity), with enough distance in the allowed direction.
 * @constructor
 * @extends AttrRecognizer
 */
function SwipeRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(SwipeRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof SwipeRecognizer
     */
    defaults: {
        event: 'swipe',
        threshold: 10,
        velocity: 0.3,
        direction: DIRECTION_HORIZONTAL | DIRECTION_VERTICAL,
        pointers: 1
    },

    getTouchAction: function() {
        return PanRecognizer.prototype.getTouchAction.call(this);
    },

    attrTest: function(input) {
        var direction = this.options.direction;
        var velocity;

        if (direction & (DIRECTION_HORIZONTAL | DIRECTION_VERTICAL)) {
            velocity = input.overallVelocity;
        } else if (direction & DIRECTION_HORIZONTAL) {
            velocity = input.overallVelocityX;
        } else if (direction & DIRECTION_VERTICAL) {
            velocity = input.overallVelocityY;
        }

        return this._super.attrTest.call(this, input) &&
            direction & input.offsetDirection &&
            input.distance > this.options.threshold &&
            input.maxPointers == this.options.pointers &&
            abs(velocity) > this.options.velocity && input.eventType & INPUT_END;
    },

    emit: function(input) {
        var direction = directionStr(input.offsetDirection);
        if (direction) {
            this.manager.emit(this.options.event + direction, input);
        }

        this.manager.emit(this.options.event, input);
    }
});

/**
 * A tap is ecognized when the pointer is doing a small tap/click. Multiple taps are recognized if they occur
 * between the given interval and position. The delay option can be used to recognize multi-taps without firing
 * a single tap.
 *
 * The eventData from the emitted event contains the property `tapCount`, which contains the amount of
 * multi-taps being recognized.
 * @constructor
 * @extends Recognizer
 */
function TapRecognizer() {
    Recognizer.apply(this, arguments);

    // previous time and center,
    // used for tap counting
    this.pTime = false;
    this.pCenter = false;

    this._timer = null;
    this._input = null;
    this.count = 0;
}

inherit(TapRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof PinchRecognizer
     */
    defaults: {
        event: 'tap',
        pointers: 1,
        taps: 1,
        interval: 300, // max time between the multi-tap taps
        time: 250, // max time of the pointer to be down (like finger on the screen)
        threshold: 9, // a minimal movement is ok, but keep it low
        posThreshold: 10 // a multi-tap can be a bit off the initial position
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_MANIPULATION];
    },

    process: function(input) {
        var options = this.options;

        var validPointers = input.pointers.length === options.pointers;
        var validMovement = input.distance < options.threshold;
        var validTouchTime = input.deltaTime < options.time;

        this.reset();

        if ((input.eventType & INPUT_START) && (this.count === 0)) {
            return this.failTimeout();
        }

        // we only allow little movement
        // and we've reached an end event, so a tap is possible
        if (validMovement && validTouchTime && validPointers) {
            if (input.eventType != INPUT_END) {
                return this.failTimeout();
            }

            var validInterval = this.pTime ? (input.timeStamp - this.pTime < options.interval) : true;
            var validMultiTap = !this.pCenter || getDistance(this.pCenter, input.center) < options.posThreshold;

            this.pTime = input.timeStamp;
            this.pCenter = input.center;

            if (!validMultiTap || !validInterval) {
                this.count = 1;
            } else {
                this.count += 1;
            }

            this._input = input;

            // if tap count matches we have recognized it,
            // else it has began recognizing...
            var tapCount = this.count % options.taps;
            if (tapCount === 0) {
                // no failing requirements, immediately trigger the tap event
                // or wait as long as the multitap interval to trigger
                if (!this.hasRequireFailures()) {
                    return STATE_RECOGNIZED;
                } else {
                    this._timer = setTimeoutContext(function() {
                        this.state = STATE_RECOGNIZED;
                        this.tryEmit();
                    }, options.interval, this);
                    return STATE_BEGAN;
                }
            }
        }
        return STATE_FAILED;
    },

    failTimeout: function() {
        this._timer = setTimeoutContext(function() {
            this.state = STATE_FAILED;
        }, this.options.interval, this);
        return STATE_FAILED;
    },

    reset: function() {
        clearTimeout(this._timer);
    },

    emit: function() {
        if (this.state == STATE_RECOGNIZED) {
            this._input.tapCount = this.count;
            this.manager.emit(this.options.event, this._input);
        }
    }
});

/**
 * Simple way to create a manager with a default set of recognizers.
 * @param {HTMLElement} element
 * @param {Object} [options]
 * @constructor
 */
function Hammer(element, options) {
    options = options || {};
    options.recognizers = ifUndefined(options.recognizers, Hammer.defaults.preset);
    return new Manager(element, options);
}

/**
 * @const {string}
 */
Hammer.VERSION = '2.0.7';

/**
 * default settings
 * @namespace
 */
Hammer.defaults = {
    /**
     * set if DOM events are being triggered.
     * But this is slower and unused by simple implementations, so disabled by default.
     * @type {Boolean}
     * @default false
     */
    domEvents: false,

    /**
     * The value for the touchAction property/fallback.
     * When set to `compute` it will magically set the correct value based on the added recognizers.
     * @type {String}
     * @default compute
     */
    touchAction: TOUCH_ACTION_COMPUTE,

    /**
     * @type {Boolean}
     * @default true
     */
    enable: true,

    /**
     * EXPERIMENTAL FEATURE -- can be removed/changed
     * Change the parent input target element.
     * If Null, then it is being set the to main element.
     * @type {Null|EventTarget}
     * @default null
     */
    inputTarget: null,

    /**
     * force an input class
     * @type {Null|Function}
     * @default null
     */
    inputClass: null,

    /**
     * Default recognizer setup when calling `Hammer()`
     * When creating a new Manager these will be skipped.
     * @type {Array}
     */
    preset: [
        // RecognizerClass, options, [recognizeWith, ...], [requireFailure, ...]
        [RotateRecognizer, {enable: false}],
        [PinchRecognizer, {enable: false}, ['rotate']],
        [SwipeRecognizer, {direction: DIRECTION_HORIZONTAL}],
        [PanRecognizer, {direction: DIRECTION_HORIZONTAL}, ['swipe']],
        [TapRecognizer],
        [TapRecognizer, {event: 'doubletap', taps: 2}, ['tap']],
        [PressRecognizer]
    ],

    /**
     * Some CSS properties can be used to improve the working of Hammer.
     * Add them to this method and they will be set when creating a new Manager.
     * @namespace
     */
    cssProps: {
        /**
         * Disables text selection to improve the dragging gesture. Mainly for desktop browsers.
         * @type {String}
         * @default 'none'
         */
        userSelect: 'none',

        /**
         * Disable the Windows Phone grippers when pressing an element.
         * @type {String}
         * @default 'none'
         */
        touchSelect: 'none',

        /**
         * Disables the default callout shown when you touch and hold a touch target.
         * On iOS, when you touch and hold a touch target such as a link, Safari displays
         * a callout containing information about the link. This property allows you to disable that callout.
         * @type {String}
         * @default 'none'
         */
        touchCallout: 'none',

        /**
         * Specifies whether zooming is enabled. Used by IE10>
         * @type {String}
         * @default 'none'
         */
        contentZooming: 'none',

        /**
         * Specifies that an entire element should be draggable instead of its contents. Mainly for desktop browsers.
         * @type {String}
         * @default 'none'
         */
        userDrag: 'none',

        /**
         * Overrides the highlight color shown when the user taps a link or a JavaScript
         * clickable element in iOS. This property obeys the alpha value, if specified.
         * @type {String}
         * @default 'rgba(0,0,0,0)'
         */
        tapHighlightColor: 'rgba(0,0,0,0)'
    }
};

var STOP = 1;
var FORCED_STOP = 2;

/**
 * Manager
 * @param {HTMLElement} element
 * @param {Object} [options]
 * @constructor
 */
function Manager(element, options) {
    this.options = assign({}, Hammer.defaults, options || {});

    this.options.inputTarget = this.options.inputTarget || element;

    this.handlers = {};
    this.session = {};
    this.recognizers = [];
    this.oldCssProps = {};

    this.element = element;
    this.input = createInputInstance(this);
    this.touchAction = new TouchAction(this, this.options.touchAction);

    toggleCssProps(this, true);

    each(this.options.recognizers, function(item) {
        var recognizer = this.add(new (item[0])(item[1]));
        item[2] && recognizer.recognizeWith(item[2]);
        item[3] && recognizer.requireFailure(item[3]);
    }, this);
}

Manager.prototype = {
    /**
     * set options
     * @param {Object} options
     * @returns {Manager}
     */
    set: function(options) {
        assign(this.options, options);

        // Options that need a little more setup
        if (options.touchAction) {
            this.touchAction.update();
        }
        if (options.inputTarget) {
            // Clean up existing event listeners and reinitialize
            this.input.destroy();
            this.input.target = options.inputTarget;
            this.input.init();
        }
        return this;
    },

    /**
     * stop recognizing for this session.
     * This session will be discarded, when a new [input]start event is fired.
     * When forced, the recognizer cycle is stopped immediately.
     * @param {Boolean} [force]
     */
    stop: function(force) {
        this.session.stopped = force ? FORCED_STOP : STOP;
    },

    /**
     * run the recognizers!
     * called by the inputHandler function on every movement of the pointers (touches)
     * it walks through all the recognizers and tries to detect the gesture that is being made
     * @param {Object} inputData
     */
    recognize: function(inputData) {
        var session = this.session;
        if (session.stopped) {
            return;
        }

        // run the touch-action polyfill
        this.touchAction.preventDefaults(inputData);

        var recognizer;
        var recognizers = this.recognizers;

        // this holds the recognizer that is being recognized.
        // so the recognizer's state needs to be BEGAN, CHANGED, ENDED or RECOGNIZED
        // if no recognizer is detecting a thing, it is set to `null`
        var curRecognizer = session.curRecognizer;

        // reset when the last recognizer is recognized
        // or when we're in a new session
        if (!curRecognizer || (curRecognizer && curRecognizer.state & STATE_RECOGNIZED)) {
            curRecognizer = session.curRecognizer = null;
        }

        var i = 0;
        while (i < recognizers.length) {
            recognizer = recognizers[i];

            // find out if we are allowed try to recognize the input for this one.
            // 1.   allow if the session is NOT forced stopped (see the .stop() method)
            // 2.   allow if we still haven't recognized a gesture in this session, or the this recognizer is the one
            //      that is being recognized.
            // 3.   allow if the recognizer is allowed to run simultaneous with the current recognized recognizer.
            //      this can be setup with the `recognizeWith()` method on the recognizer.
            if (session.stopped !== FORCED_STOP && ( // 1
                    !curRecognizer || recognizer == curRecognizer || // 2
                    recognizer.canRecognizeWith(curRecognizer))) { // 3
                recognizer.recognize(inputData);
            } else {
                recognizer.reset();
            }

            // if the recognizer has been recognizing the input as a valid gesture, we want to store this one as the
            // current active recognizer. but only if we don't already have an active recognizer
            if (!curRecognizer && recognizer.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED)) {
                curRecognizer = session.curRecognizer = recognizer;
            }
            i++;
        }
    },

    /**
     * get a recognizer by its event name.
     * @param {Recognizer|String} recognizer
     * @returns {Recognizer|Null}
     */
    get: function(recognizer) {
        if (recognizer instanceof Recognizer) {
            return recognizer;
        }

        var recognizers = this.recognizers;
        for (var i = 0; i < recognizers.length; i++) {
            if (recognizers[i].options.event == recognizer) {
                return recognizers[i];
            }
        }
        return null;
    },

    /**
     * add a recognizer to the manager
     * existing recognizers with the same event name will be removed
     * @param {Recognizer} recognizer
     * @returns {Recognizer|Manager}
     */
    add: function(recognizer) {
        if (invokeArrayArg(recognizer, 'add', this)) {
            return this;
        }

        // remove existing
        var existing = this.get(recognizer.options.event);
        if (existing) {
            this.remove(existing);
        }

        this.recognizers.push(recognizer);
        recognizer.manager = this;

        this.touchAction.update();
        return recognizer;
    },

    /**
     * remove a recognizer by name or instance
     * @param {Recognizer|String} recognizer
     * @returns {Manager}
     */
    remove: function(recognizer) {
        if (invokeArrayArg(recognizer, 'remove', this)) {
            return this;
        }

        recognizer = this.get(recognizer);

        // let's make sure this recognizer exists
        if (recognizer) {
            var recognizers = this.recognizers;
            var index = inArray(recognizers, recognizer);

            if (index !== -1) {
                recognizers.splice(index, 1);
                this.touchAction.update();
            }
        }

        return this;
    },

    /**
     * bind event
     * @param {String} events
     * @param {Function} handler
     * @returns {EventEmitter} this
     */
    on: function(events, handler) {
        if (events === undefined) {
            return;
        }
        if (handler === undefined) {
            return;
        }

        var handlers = this.handlers;
        each(splitStr(events), function(event) {
            handlers[event] = handlers[event] || [];
            handlers[event].push(handler);
        });
        return this;
    },

    /**
     * unbind event, leave emit blank to remove all handlers
     * @param {String} events
     * @param {Function} [handler]
     * @returns {EventEmitter} this
     */
    off: function(events, handler) {
        if (events === undefined) {
            return;
        }

        var handlers = this.handlers;
        each(splitStr(events), function(event) {
            if (!handler) {
                delete handlers[event];
            } else {
                handlers[event] && handlers[event].splice(inArray(handlers[event], handler), 1);
            }
        });
        return this;
    },

    /**
     * emit event to the listeners
     * @param {String} event
     * @param {Object} data
     */
    emit: function(event, data) {
        // we also want to trigger dom events
        if (this.options.domEvents) {
            triggerDomEvent(event, data);
        }

        // no handlers, so skip it all
        var handlers = this.handlers[event] && this.handlers[event].slice();
        if (!handlers || !handlers.length) {
            return;
        }

        data.type = event;
        data.preventDefault = function() {
            data.srcEvent.preventDefault();
        };

        var i = 0;
        while (i < handlers.length) {
            handlers[i](data);
            i++;
        }
    },

    /**
     * destroy the manager and unbinds all events
     * it doesn't unbind dom events, that is the user own responsibility
     */
    destroy: function() {
        this.element && toggleCssProps(this, false);

        this.handlers = {};
        this.session = {};
        this.input.destroy();
        this.element = null;
    }
};

/**
 * add/remove the css properties as defined in manager.options.cssProps
 * @param {Manager} manager
 * @param {Boolean} add
 */
function toggleCssProps(manager, add) {
    var element = manager.element;
    if (!element.style) {
        return;
    }
    var prop;
    each(manager.options.cssProps, function(value, name) {
        prop = prefixed(element.style, name);
        if (add) {
            manager.oldCssProps[prop] = element.style[prop];
            element.style[prop] = value;
        } else {
            element.style[prop] = manager.oldCssProps[prop] || '';
        }
    });
    if (!add) {
        manager.oldCssProps = {};
    }
}

/**
 * trigger dom event
 * @param {String} event
 * @param {Object} data
 */
function triggerDomEvent(event, data) {
    var gestureEvent = document.createEvent('Event');
    gestureEvent.initEvent(event, true, true);
    gestureEvent.gesture = data;
    data.target.dispatchEvent(gestureEvent);
}

assign(Hammer, {
    INPUT_START: INPUT_START,
    INPUT_MOVE: INPUT_MOVE,
    INPUT_END: INPUT_END,
    INPUT_CANCEL: INPUT_CANCEL,

    STATE_POSSIBLE: STATE_POSSIBLE,
    STATE_BEGAN: STATE_BEGAN,
    STATE_CHANGED: STATE_CHANGED,
    STATE_ENDED: STATE_ENDED,
    STATE_RECOGNIZED: STATE_RECOGNIZED,
    STATE_CANCELLED: STATE_CANCELLED,
    STATE_FAILED: STATE_FAILED,

    DIRECTION_NONE: DIRECTION_NONE,
    DIRECTION_LEFT: DIRECTION_LEFT,
    DIRECTION_RIGHT: DIRECTION_RIGHT,
    DIRECTION_UP: DIRECTION_UP,
    DIRECTION_DOWN: DIRECTION_DOWN,
    DIRECTION_HORIZONTAL: DIRECTION_HORIZONTAL,
    DIRECTION_VERTICAL: DIRECTION_VERTICAL,
    DIRECTION_ALL: DIRECTION_ALL,

    Manager: Manager,
    Input: Input,
    TouchAction: TouchAction,

    TouchInput: TouchInput,
    MouseInput: MouseInput,
    PointerEventInput: PointerEventInput,
    TouchMouseInput: TouchMouseInput,
    SingleTouchInput: SingleTouchInput,

    Recognizer: Recognizer,
    AttrRecognizer: AttrRecognizer,
    Tap: TapRecognizer,
    Pan: PanRecognizer,
    Swipe: SwipeRecognizer,
    Pinch: PinchRecognizer,
    Rotate: RotateRecognizer,
    Press: PressRecognizer,

    on: addEventListeners,
    off: removeEventListeners,
    each: each,
    merge: merge,
    extend: extend,
    assign: assign,
    inherit: inherit,
    bindFn: bindFn,
    prefixed: prefixed
});

// this prevents errors when Hammer is loaded in the presence of an AMD
//  style loader but by script tag, not by the loader.
var freeGlobal = (typeof window !== 'undefined' ? window : (typeof self !== 'undefined' ? self : {})); // jshint ignore:line
freeGlobal.Hammer = Hammer;

if (true) {
    !(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
        return Hammer;
    }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
} else if (typeof module != 'undefined' && module.exports) {
    module.exports = Hammer;
} else {
    window[exportName] = Hammer;
}

})(window, document, 'Hammer');


/***/ }),
/* 185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Url */
/* unused harmony export Http */
/* unused harmony export Resource */
/*!
 * vue-resource v1.5.1
 * https://github.com/pagekit/vue-resource
 * Released under the MIT License.
 */

/**
 * Promises/A+ polyfill v1.1.4 (https://github.com/bramstein/promis)
 */

var RESOLVED = 0;
var REJECTED = 1;
var PENDING = 2;

function Promise$1(executor) {

    this.state = PENDING;
    this.value = undefined;
    this.deferred = [];

    var promise = this;

    try {
        executor(function (x) {
            promise.resolve(x);
        }, function (r) {
            promise.reject(r);
        });
    } catch (e) {
        promise.reject(e);
    }
}

Promise$1.reject = function (r) {
    return new Promise$1(function (resolve, reject) {
        reject(r);
    });
};

Promise$1.resolve = function (x) {
    return new Promise$1(function (resolve, reject) {
        resolve(x);
    });
};

Promise$1.all = function all(iterable) {
    return new Promise$1(function (resolve, reject) {
        var count = 0, result = [];

        if (iterable.length === 0) {
            resolve(result);
        }

        function resolver(i) {
            return function (x) {
                result[i] = x;
                count += 1;

                if (count === iterable.length) {
                    resolve(result);
                }
            };
        }

        for (var i = 0; i < iterable.length; i += 1) {
            Promise$1.resolve(iterable[i]).then(resolver(i), reject);
        }
    });
};

Promise$1.race = function race(iterable) {
    return new Promise$1(function (resolve, reject) {
        for (var i = 0; i < iterable.length; i += 1) {
            Promise$1.resolve(iterable[i]).then(resolve, reject);
        }
    });
};

var p = Promise$1.prototype;

p.resolve = function resolve(x) {
    var promise = this;

    if (promise.state === PENDING) {
        if (x === promise) {
            throw new TypeError('Promise settled with itself.');
        }

        var called = false;

        try {
            var then = x && x['then'];

            if (x !== null && typeof x === 'object' && typeof then === 'function') {
                then.call(x, function (x) {
                    if (!called) {
                        promise.resolve(x);
                    }
                    called = true;

                }, function (r) {
                    if (!called) {
                        promise.reject(r);
                    }
                    called = true;
                });
                return;
            }
        } catch (e) {
            if (!called) {
                promise.reject(e);
            }
            return;
        }

        promise.state = RESOLVED;
        promise.value = x;
        promise.notify();
    }
};

p.reject = function reject(reason) {
    var promise = this;

    if (promise.state === PENDING) {
        if (reason === promise) {
            throw new TypeError('Promise settled with itself.');
        }

        promise.state = REJECTED;
        promise.value = reason;
        promise.notify();
    }
};

p.notify = function notify() {
    var promise = this;

    nextTick(function () {
        if (promise.state !== PENDING) {
            while (promise.deferred.length) {
                var deferred = promise.deferred.shift(),
                    onResolved = deferred[0],
                    onRejected = deferred[1],
                    resolve = deferred[2],
                    reject = deferred[3];

                try {
                    if (promise.state === RESOLVED) {
                        if (typeof onResolved === 'function') {
                            resolve(onResolved.call(undefined, promise.value));
                        } else {
                            resolve(promise.value);
                        }
                    } else if (promise.state === REJECTED) {
                        if (typeof onRejected === 'function') {
                            resolve(onRejected.call(undefined, promise.value));
                        } else {
                            reject(promise.value);
                        }
                    }
                } catch (e) {
                    reject(e);
                }
            }
        }
    });
};

p.then = function then(onResolved, onRejected) {
    var promise = this;

    return new Promise$1(function (resolve, reject) {
        promise.deferred.push([onResolved, onRejected, resolve, reject]);
        promise.notify();
    });
};

p.catch = function (onRejected) {
    return this.then(undefined, onRejected);
};

/**
 * Promise adapter.
 */

if (typeof Promise === 'undefined') {
    window.Promise = Promise$1;
}

function PromiseObj(executor, context) {

    if (executor instanceof Promise) {
        this.promise = executor;
    } else {
        this.promise = new Promise(executor.bind(context));
    }

    this.context = context;
}

PromiseObj.all = function (iterable, context) {
    return new PromiseObj(Promise.all(iterable), context);
};

PromiseObj.resolve = function (value, context) {
    return new PromiseObj(Promise.resolve(value), context);
};

PromiseObj.reject = function (reason, context) {
    return new PromiseObj(Promise.reject(reason), context);
};

PromiseObj.race = function (iterable, context) {
    return new PromiseObj(Promise.race(iterable), context);
};

var p$1 = PromiseObj.prototype;

p$1.bind = function (context) {
    this.context = context;
    return this;
};

p$1.then = function (fulfilled, rejected) {

    if (fulfilled && fulfilled.bind && this.context) {
        fulfilled = fulfilled.bind(this.context);
    }

    if (rejected && rejected.bind && this.context) {
        rejected = rejected.bind(this.context);
    }

    return new PromiseObj(this.promise.then(fulfilled, rejected), this.context);
};

p$1.catch = function (rejected) {

    if (rejected && rejected.bind && this.context) {
        rejected = rejected.bind(this.context);
    }

    return new PromiseObj(this.promise.catch(rejected), this.context);
};

p$1.finally = function (callback) {

    return this.then(function (value) {
        callback.call(this);
        return value;
    }, function (reason) {
        callback.call(this);
        return Promise.reject(reason);
    }
    );
};

/**
 * Utility functions.
 */

var ref = {};
var hasOwnProperty = ref.hasOwnProperty;
var ref$1 = [];
var slice = ref$1.slice;
var debug = false, ntick;

var inBrowser = typeof window !== 'undefined';

function Util (ref) {
    var config = ref.config;
    var nextTick = ref.nextTick;

    ntick = nextTick;
    debug = config.debug || !config.silent;
}

function warn(msg) {
    if (typeof console !== 'undefined' && debug) {
        console.warn('[VueResource warn]: ' + msg);
    }
}

function error(msg) {
    if (typeof console !== 'undefined') {
        console.error(msg);
    }
}

function nextTick(cb, ctx) {
    return ntick(cb, ctx);
}

function trim(str) {
    return str ? str.replace(/^\s*|\s*$/g, '') : '';
}

function trimEnd(str, chars) {

    if (str && chars === undefined) {
        return str.replace(/\s+$/, '');
    }

    if (!str || !chars) {
        return str;
    }

    return str.replace(new RegExp(("[" + chars + "]+$")), '');
}

function toLower(str) {
    return str ? str.toLowerCase() : '';
}

function toUpper(str) {
    return str ? str.toUpperCase() : '';
}

var isArray = Array.isArray;

function isString(val) {
    return typeof val === 'string';
}

function isFunction(val) {
    return typeof val === 'function';
}

function isObject(obj) {
    return obj !== null && typeof obj === 'object';
}

function isPlainObject(obj) {
    return isObject(obj) && Object.getPrototypeOf(obj) == Object.prototype;
}

function isBlob(obj) {
    return typeof Blob !== 'undefined' && obj instanceof Blob;
}

function isFormData(obj) {
    return typeof FormData !== 'undefined' && obj instanceof FormData;
}

function when(value, fulfilled, rejected) {

    var promise = PromiseObj.resolve(value);

    if (arguments.length < 2) {
        return promise;
    }

    return promise.then(fulfilled, rejected);
}

function options(fn, obj, opts) {

    opts = opts || {};

    if (isFunction(opts)) {
        opts = opts.call(obj);
    }

    return merge(fn.bind({$vm: obj, $options: opts}), fn, {$options: opts});
}

function each(obj, iterator) {

    var i, key;

    if (isArray(obj)) {
        for (i = 0; i < obj.length; i++) {
            iterator.call(obj[i], obj[i], i);
        }
    } else if (isObject(obj)) {
        for (key in obj) {
            if (hasOwnProperty.call(obj, key)) {
                iterator.call(obj[key], obj[key], key);
            }
        }
    }

    return obj;
}

var assign = Object.assign || _assign;

function merge(target) {

    var args = slice.call(arguments, 1);

    args.forEach(function (source) {
        _merge(target, source, true);
    });

    return target;
}

function defaults(target) {

    var args = slice.call(arguments, 1);

    args.forEach(function (source) {

        for (var key in source) {
            if (target[key] === undefined) {
                target[key] = source[key];
            }
        }

    });

    return target;
}

function _assign(target) {

    var args = slice.call(arguments, 1);

    args.forEach(function (source) {
        _merge(target, source);
    });

    return target;
}

function _merge(target, source, deep) {
    for (var key in source) {
        if (deep && (isPlainObject(source[key]) || isArray(source[key]))) {
            if (isPlainObject(source[key]) && !isPlainObject(target[key])) {
                target[key] = {};
            }
            if (isArray(source[key]) && !isArray(target[key])) {
                target[key] = [];
            }
            _merge(target[key], source[key], deep);
        } else if (source[key] !== undefined) {
            target[key] = source[key];
        }
    }
}

/**
 * Root Prefix Transform.
 */

function root (options$$1, next) {

    var url = next(options$$1);

    if (isString(options$$1.root) && !/^(https?:)?\//.test(url)) {
        url = trimEnd(options$$1.root, '/') + '/' + url;
    }

    return url;
}

/**
 * Query Parameter Transform.
 */

function query (options$$1, next) {

    var urlParams = Object.keys(Url.options.params), query = {}, url = next(options$$1);

    each(options$$1.params, function (value, key) {
        if (urlParams.indexOf(key) === -1) {
            query[key] = value;
        }
    });

    query = Url.params(query);

    if (query) {
        url += (url.indexOf('?') == -1 ? '?' : '&') + query;
    }

    return url;
}

/**
 * URL Template v2.0.6 (https://github.com/bramstein/url-template)
 */

function expand(url, params, variables) {

    var tmpl = parse(url), expanded = tmpl.expand(params);

    if (variables) {
        variables.push.apply(variables, tmpl.vars);
    }

    return expanded;
}

function parse(template) {

    var operators = ['+', '#', '.', '/', ';', '?', '&'], variables = [];

    return {
        vars: variables,
        expand: function expand(context) {
            return template.replace(/\{([^{}]+)\}|([^{}]+)/g, function (_, expression, literal) {
                if (expression) {

                    var operator = null, values = [];

                    if (operators.indexOf(expression.charAt(0)) !== -1) {
                        operator = expression.charAt(0);
                        expression = expression.substr(1);
                    }

                    expression.split(/,/g).forEach(function (variable) {
                        var tmp = /([^:*]*)(?::(\d+)|(\*))?/.exec(variable);
                        values.push.apply(values, getValues(context, operator, tmp[1], tmp[2] || tmp[3]));
                        variables.push(tmp[1]);
                    });

                    if (operator && operator !== '+') {

                        var separator = ',';

                        if (operator === '?') {
                            separator = '&';
                        } else if (operator !== '#') {
                            separator = operator;
                        }

                        return (values.length !== 0 ? operator : '') + values.join(separator);
                    } else {
                        return values.join(',');
                    }

                } else {
                    return encodeReserved(literal);
                }
            });
        }
    };
}

function getValues(context, operator, key, modifier) {

    var value = context[key], result = [];

    if (isDefined(value) && value !== '') {
        if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
            value = value.toString();

            if (modifier && modifier !== '*') {
                value = value.substring(0, parseInt(modifier, 10));
            }

            result.push(encodeValue(operator, value, isKeyOperator(operator) ? key : null));
        } else {
            if (modifier === '*') {
                if (Array.isArray(value)) {
                    value.filter(isDefined).forEach(function (value) {
                        result.push(encodeValue(operator, value, isKeyOperator(operator) ? key : null));
                    });
                } else {
                    Object.keys(value).forEach(function (k) {
                        if (isDefined(value[k])) {
                            result.push(encodeValue(operator, value[k], k));
                        }
                    });
                }
            } else {
                var tmp = [];

                if (Array.isArray(value)) {
                    value.filter(isDefined).forEach(function (value) {
                        tmp.push(encodeValue(operator, value));
                    });
                } else {
                    Object.keys(value).forEach(function (k) {
                        if (isDefined(value[k])) {
                            tmp.push(encodeURIComponent(k));
                            tmp.push(encodeValue(operator, value[k].toString()));
                        }
                    });
                }

                if (isKeyOperator(operator)) {
                    result.push(encodeURIComponent(key) + '=' + tmp.join(','));
                } else if (tmp.length !== 0) {
                    result.push(tmp.join(','));
                }
            }
        }
    } else {
        if (operator === ';') {
            result.push(encodeURIComponent(key));
        } else if (value === '' && (operator === '&' || operator === '?')) {
            result.push(encodeURIComponent(key) + '=');
        } else if (value === '') {
            result.push('');
        }
    }

    return result;
}

function isDefined(value) {
    return value !== undefined && value !== null;
}

function isKeyOperator(operator) {
    return operator === ';' || operator === '&' || operator === '?';
}

function encodeValue(operator, value, key) {

    value = (operator === '+' || operator === '#') ? encodeReserved(value) : encodeURIComponent(value);

    if (key) {
        return encodeURIComponent(key) + '=' + value;
    } else {
        return value;
    }
}

function encodeReserved(str) {
    return str.split(/(%[0-9A-Fa-f]{2})/g).map(function (part) {
        if (!/%[0-9A-Fa-f]/.test(part)) {
            part = encodeURI(part);
        }
        return part;
    }).join('');
}

/**
 * URL Template (RFC 6570) Transform.
 */

function template (options) {

    var variables = [], url = expand(options.url, options.params, variables);

    variables.forEach(function (key) {
        delete options.params[key];
    });

    return url;
}

/**
 * Service for URL templating.
 */

function Url(url, params) {

    var self = this || {}, options$$1 = url, transform;

    if (isString(url)) {
        options$$1 = {url: url, params: params};
    }

    options$$1 = merge({}, Url.options, self.$options, options$$1);

    Url.transforms.forEach(function (handler) {

        if (isString(handler)) {
            handler = Url.transform[handler];
        }

        if (isFunction(handler)) {
            transform = factory(handler, transform, self.$vm);
        }

    });

    return transform(options$$1);
}

/**
 * Url options.
 */

Url.options = {
    url: '',
    root: null,
    params: {}
};

/**
 * Url transforms.
 */

Url.transform = {template: template, query: query, root: root};
Url.transforms = ['template', 'query', 'root'];

/**
 * Encodes a Url parameter string.
 *
 * @param {Object} obj
 */

Url.params = function (obj) {

    var params = [], escape = encodeURIComponent;

    params.add = function (key, value) {

        if (isFunction(value)) {
            value = value();
        }

        if (value === null) {
            value = '';
        }

        this.push(escape(key) + '=' + escape(value));
    };

    serialize(params, obj);

    return params.join('&').replace(/%20/g, '+');
};

/**
 * Parse a URL and return its components.
 *
 * @param {String} url
 */

Url.parse = function (url) {

    var el = document.createElement('a');

    if (document.documentMode) {
        el.href = url;
        url = el.href;
    }

    el.href = url;

    return {
        href: el.href,
        protocol: el.protocol ? el.protocol.replace(/:$/, '') : '',
        port: el.port,
        host: el.host,
        hostname: el.hostname,
        pathname: el.pathname.charAt(0) === '/' ? el.pathname : '/' + el.pathname,
        search: el.search ? el.search.replace(/^\?/, '') : '',
        hash: el.hash ? el.hash.replace(/^#/, '') : ''
    };
};

function factory(handler, next, vm) {
    return function (options$$1) {
        return handler.call(vm, options$$1, next);
    };
}

function serialize(params, obj, scope) {

    var array = isArray(obj), plain = isPlainObject(obj), hash;

    each(obj, function (value, key) {

        hash = isObject(value) || isArray(value);

        if (scope) {
            key = scope + '[' + (plain || hash ? key : '') + ']';
        }

        if (!scope && array) {
            params.add(value.name, value.value);
        } else if (hash) {
            serialize(params, value, key);
        } else {
            params.add(key, value);
        }
    });
}

/**
 * XDomain client (Internet Explorer).
 */

function xdrClient (request) {
    return new PromiseObj(function (resolve) {

        var xdr = new XDomainRequest(), handler = function (ref) {
                var type = ref.type;


                var status = 0;

                if (type === 'load') {
                    status = 200;
                } else if (type === 'error') {
                    status = 500;
                }

                resolve(request.respondWith(xdr.responseText, {status: status}));
            };

        request.abort = function () { return xdr.abort(); };

        xdr.open(request.method, request.getUrl());

        if (request.timeout) {
            xdr.timeout = request.timeout;
        }

        xdr.onload = handler;
        xdr.onabort = handler;
        xdr.onerror = handler;
        xdr.ontimeout = handler;
        xdr.onprogress = function () {};
        xdr.send(request.getBody());
    });
}

/**
 * CORS Interceptor.
 */

var SUPPORTS_CORS = inBrowser && 'withCredentials' in new XMLHttpRequest();

function cors (request) {

    if (inBrowser) {

        var orgUrl = Url.parse(location.href);
        var reqUrl = Url.parse(request.getUrl());

        if (reqUrl.protocol !== orgUrl.protocol || reqUrl.host !== orgUrl.host) {

            request.crossOrigin = true;
            request.emulateHTTP = false;

            if (!SUPPORTS_CORS) {
                request.client = xdrClient;
            }
        }
    }

}

/**
 * Form data Interceptor.
 */

function form (request) {

    if (isFormData(request.body)) {
        request.headers.delete('Content-Type');
    } else if (isObject(request.body) && request.emulateJSON) {
        request.body = Url.params(request.body);
        request.headers.set('Content-Type', 'application/x-www-form-urlencoded');
    }

}

/**
 * JSON Interceptor.
 */

function json (request) {

    var type = request.headers.get('Content-Type') || '';

    if (isObject(request.body) && type.indexOf('application/json') === 0) {
        request.body = JSON.stringify(request.body);
    }

    return function (response) {

        return response.bodyText ? when(response.text(), function (text) {

            var type = response.headers.get('Content-Type') || '';

            if (type.indexOf('application/json') === 0 || isJson(text)) {

                try {
                    response.body = JSON.parse(text);
                } catch (e) {
                    response.body = null;
                }

            } else {
                response.body = text;
            }

            return response;

        }) : response;

    };
}

function isJson(str) {

    var start = str.match(/^\s*(\[|\{)/);
    var end = {'[': /]\s*$/, '{': /}\s*$/};

    return start && end[start[1]].test(str);
}

/**
 * JSONP client (Browser).
 */

function jsonpClient (request) {
    return new PromiseObj(function (resolve) {

        var name = request.jsonp || 'callback', callback = request.jsonpCallback || '_jsonp' + Math.random().toString(36).substr(2), body = null, handler, script;

        handler = function (ref) {
            var type = ref.type;


            var status = 0;

            if (type === 'load' && body !== null) {
                status = 200;
            } else if (type === 'error') {
                status = 500;
            }

            if (status && window[callback]) {
                delete window[callback];
                document.body.removeChild(script);
            }

            resolve(request.respondWith(body, {status: status}));
        };

        window[callback] = function (result) {
            body = JSON.stringify(result);
        };

        request.abort = function () {
            handler({type: 'abort'});
        };

        request.params[name] = callback;

        if (request.timeout) {
            setTimeout(request.abort, request.timeout);
        }

        script = document.createElement('script');
        script.src = request.getUrl();
        script.type = 'text/javascript';
        script.async = true;
        script.onload = handler;
        script.onerror = handler;

        document.body.appendChild(script);
    });
}

/**
 * JSONP Interceptor.
 */

function jsonp (request) {

    if (request.method == 'JSONP') {
        request.client = jsonpClient;
    }

}

/**
 * Before Interceptor.
 */

function before (request) {

    if (isFunction(request.before)) {
        request.before.call(this, request);
    }

}

/**
 * HTTP method override Interceptor.
 */

function method (request) {

    if (request.emulateHTTP && /^(PUT|PATCH|DELETE)$/i.test(request.method)) {
        request.headers.set('X-HTTP-Method-Override', request.method);
        request.method = 'POST';
    }

}

/**
 * Header Interceptor.
 */

function header (request) {

    var headers = assign({}, Http.headers.common,
        !request.crossOrigin ? Http.headers.custom : {},
        Http.headers[toLower(request.method)]
    );

    each(headers, function (value, name) {
        if (!request.headers.has(name)) {
            request.headers.set(name, value);
        }
    });

}

/**
 * XMLHttp client (Browser).
 */

function xhrClient (request) {
    return new PromiseObj(function (resolve) {

        var xhr = new XMLHttpRequest(), handler = function (event) {

                var response = request.respondWith(
                'response' in xhr ? xhr.response : xhr.responseText, {
                    status: xhr.status === 1223 ? 204 : xhr.status, // IE9 status bug
                    statusText: xhr.status === 1223 ? 'No Content' : trim(xhr.statusText)
                });

                each(trim(xhr.getAllResponseHeaders()).split('\n'), function (row) {
                    response.headers.append(row.slice(0, row.indexOf(':')), row.slice(row.indexOf(':') + 1));
                });

                resolve(response);
            };

        request.abort = function () { return xhr.abort(); };

        xhr.open(request.method, request.getUrl(), true);

        if (request.timeout) {
            xhr.timeout = request.timeout;
        }

        if (request.responseType && 'responseType' in xhr) {
            xhr.responseType = request.responseType;
        }

        if (request.withCredentials || request.credentials) {
            xhr.withCredentials = true;
        }

        if (!request.crossOrigin) {
            request.headers.set('X-Requested-With', 'XMLHttpRequest');
        }

        // deprecated use downloadProgress
        if (isFunction(request.progress) && request.method === 'GET') {
            xhr.addEventListener('progress', request.progress);
        }

        if (isFunction(request.downloadProgress)) {
            xhr.addEventListener('progress', request.downloadProgress);
        }

        // deprecated use uploadProgress
        if (isFunction(request.progress) && /^(POST|PUT)$/i.test(request.method)) {
            xhr.upload.addEventListener('progress', request.progress);
        }

        if (isFunction(request.uploadProgress) && xhr.upload) {
            xhr.upload.addEventListener('progress', request.uploadProgress);
        }

        request.headers.forEach(function (value, name) {
            xhr.setRequestHeader(name, value);
        });

        xhr.onload = handler;
        xhr.onabort = handler;
        xhr.onerror = handler;
        xhr.ontimeout = handler;
        xhr.send(request.getBody());
    });
}

/**
 * Http client (Node).
 */

function nodeClient (request) {

    var client = __webpack_require__(186);

    return new PromiseObj(function (resolve) {

        var url = request.getUrl();
        var body = request.getBody();
        var method = request.method;
        var headers = {}, handler;

        request.headers.forEach(function (value, name) {
            headers[name] = value;
        });

        client(url, {body: body, method: method, headers: headers}).then(handler = function (resp) {

            var response = request.respondWith(resp.body, {
                status: resp.statusCode,
                statusText: trim(resp.statusMessage)
            });

            each(resp.headers, function (value, name) {
                response.headers.set(name, value);
            });

            resolve(response);

        }, function (error$$1) { return handler(error$$1.response); });
    });
}

/**
 * Base client.
 */

function Client (context) {

    var reqHandlers = [sendRequest], resHandlers = [];

    if (!isObject(context)) {
        context = null;
    }

    function Client(request) {
        while (reqHandlers.length) {

            var handler = reqHandlers.pop();

            if (isFunction(handler)) {

                var response = (void 0), next = (void 0);

                response = handler.call(context, request, function (val) { return next = val; }) || next;

                if (isObject(response)) {
                    return new PromiseObj(function (resolve, reject) {

                        resHandlers.forEach(function (handler) {
                            response = when(response, function (response) {
                                return handler.call(context, response) || response;
                            }, reject);
                        });

                        when(response, resolve, reject);

                    }, context);
                }

                if (isFunction(response)) {
                    resHandlers.unshift(response);
                }

            } else {
                warn(("Invalid interceptor of type " + (typeof handler) + ", must be a function"));
            }
        }
    }

    Client.use = function (handler) {
        reqHandlers.push(handler);
    };

    return Client;
}

function sendRequest(request) {

    var client = request.client || (inBrowser ? xhrClient : nodeClient);

    return client(request);
}

/**
 * HTTP Headers.
 */

var Headers = function Headers(headers) {
    var this$1 = this;


    this.map = {};

    each(headers, function (value, name) { return this$1.append(name, value); });
};

Headers.prototype.has = function has (name) {
    return getName(this.map, name) !== null;
};

Headers.prototype.get = function get (name) {

    var list = this.map[getName(this.map, name)];

    return list ? list.join() : null;
};

Headers.prototype.getAll = function getAll (name) {
    return this.map[getName(this.map, name)] || [];
};

Headers.prototype.set = function set (name, value) {
    this.map[normalizeName(getName(this.map, name) || name)] = [trim(value)];
};

Headers.prototype.append = function append (name, value) {

    var list = this.map[getName(this.map, name)];

    if (list) {
        list.push(trim(value));
    } else {
        this.set(name, value);
    }
};

Headers.prototype.delete = function delete$1 (name) {
    delete this.map[getName(this.map, name)];
};

Headers.prototype.deleteAll = function deleteAll () {
    this.map = {};
};

Headers.prototype.forEach = function forEach (callback, thisArg) {
        var this$1 = this;

    each(this.map, function (list, name) {
        each(list, function (value) { return callback.call(thisArg, value, name, this$1); });
    });
};

function getName(map, name) {
    return Object.keys(map).reduce(function (prev, curr) {
        return toLower(name) === toLower(curr) ? curr : prev;
    }, null);
}

function normalizeName(name) {

    if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name)) {
        throw new TypeError('Invalid character in header field name');
    }

    return trim(name);
}

/**
 * HTTP Response.
 */

var Response = function Response(body, ref) {
    var url = ref.url;
    var headers = ref.headers;
    var status = ref.status;
    var statusText = ref.statusText;


    this.url = url;
    this.ok = status >= 200 && status < 300;
    this.status = status || 0;
    this.statusText = statusText || '';
    this.headers = new Headers(headers);
    this.body = body;

    if (isString(body)) {

        this.bodyText = body;

    } else if (isBlob(body)) {

        this.bodyBlob = body;

        if (isBlobText(body)) {
            this.bodyText = blobText(body);
        }
    }
};

Response.prototype.blob = function blob () {
    return when(this.bodyBlob);
};

Response.prototype.text = function text () {
    return when(this.bodyText);
};

Response.prototype.json = function json () {
    return when(this.text(), function (text) { return JSON.parse(text); });
};

Object.defineProperty(Response.prototype, 'data', {

    get: function get() {
        return this.body;
    },

    set: function set(body) {
        this.body = body;
    }

});

function blobText(body) {
    return new PromiseObj(function (resolve) {

        var reader = new FileReader();

        reader.readAsText(body);
        reader.onload = function () {
            resolve(reader.result);
        };

    });
}

function isBlobText(body) {
    return body.type.indexOf('text') === 0 || body.type.indexOf('json') !== -1;
}

/**
 * HTTP Request.
 */

var Request = function Request(options$$1) {

    this.body = null;
    this.params = {};

    assign(this, options$$1, {
        method: toUpper(options$$1.method || 'GET')
    });

    if (!(this.headers instanceof Headers)) {
        this.headers = new Headers(this.headers);
    }
};

Request.prototype.getUrl = function getUrl () {
    return Url(this);
};

Request.prototype.getBody = function getBody () {
    return this.body;
};

Request.prototype.respondWith = function respondWith (body, options$$1) {
    return new Response(body, assign(options$$1 || {}, {url: this.getUrl()}));
};

/**
 * Service for sending network requests.
 */

var COMMON_HEADERS = {'Accept': 'application/json, text/plain, */*'};
var JSON_CONTENT_TYPE = {'Content-Type': 'application/json;charset=utf-8'};

function Http(options$$1) {

    var self = this || {}, client = Client(self.$vm);

    defaults(options$$1 || {}, self.$options, Http.options);

    Http.interceptors.forEach(function (handler) {

        if (isString(handler)) {
            handler = Http.interceptor[handler];
        }

        if (isFunction(handler)) {
            client.use(handler);
        }

    });

    return client(new Request(options$$1)).then(function (response) {

        return response.ok ? response : PromiseObj.reject(response);

    }, function (response) {

        if (response instanceof Error) {
            error(response);
        }

        return PromiseObj.reject(response);
    });
}

Http.options = {};

Http.headers = {
    put: JSON_CONTENT_TYPE,
    post: JSON_CONTENT_TYPE,
    patch: JSON_CONTENT_TYPE,
    delete: JSON_CONTENT_TYPE,
    common: COMMON_HEADERS,
    custom: {}
};

Http.interceptor = {before: before, method: method, jsonp: jsonp, json: json, form: form, header: header, cors: cors};
Http.interceptors = ['before', 'method', 'jsonp', 'json', 'form', 'header', 'cors'];

['get', 'delete', 'head', 'jsonp'].forEach(function (method$$1) {

    Http[method$$1] = function (url, options$$1) {
        return this(assign(options$$1 || {}, {url: url, method: method$$1}));
    };

});

['post', 'put', 'patch'].forEach(function (method$$1) {

    Http[method$$1] = function (url, body, options$$1) {
        return this(assign(options$$1 || {}, {url: url, method: method$$1, body: body}));
    };

});

/**
 * Service for interacting with RESTful services.
 */

function Resource(url, params, actions, options$$1) {

    var self = this || {}, resource = {};

    actions = assign({},
        Resource.actions,
        actions
    );

    each(actions, function (action, name) {

        action = merge({url: url, params: assign({}, params)}, options$$1, action);

        resource[name] = function () {
            return (self.$http || Http)(opts(action, arguments));
        };
    });

    return resource;
}

function opts(action, args) {

    var options$$1 = assign({}, action), params = {}, body;

    switch (args.length) {

        case 2:

            params = args[0];
            body = args[1];

            break;

        case 1:

            if (/^(POST|PUT|PATCH)$/i.test(options$$1.method)) {
                body = args[0];
            } else {
                params = args[0];
            }

            break;

        case 0:

            break;

        default:

            throw 'Expected up to 2 arguments [params, body], got ' + args.length + ' arguments';
    }

    options$$1.body = body;
    options$$1.params = assign({}, options$$1.params, params);

    return options$$1;
}

Resource.actions = {

    get: {method: 'GET'},
    save: {method: 'POST'},
    query: {method: 'GET'},
    update: {method: 'PUT'},
    remove: {method: 'DELETE'},
    delete: {method: 'DELETE'}

};

/**
 * Install plugin.
 */

function plugin(Vue) {

    if (plugin.installed) {
        return;
    }

    Util(Vue);

    Vue.url = Url;
    Vue.http = Http;
    Vue.resource = Resource;
    Vue.Promise = PromiseObj;

    Object.defineProperties(Vue.prototype, {

        $url: {
            get: function get() {
                return options(Vue.url, this, this.$options.url);
            }
        },

        $http: {
            get: function get() {
                return options(Vue.http, this, this.$options.http);
            }
        },

        $resource: {
            get: function get() {
                return Vue.resource.bind(this);
            }
        },

        $promise: {
            get: function get() {
                var this$1 = this;

                return function (executor) { return new Vue.Promise(executor, this$1); };
            }
        }

    });
}

if (typeof window !== 'undefined' && window.Vue) {
    window.Vue.use(plugin);
}

/* harmony default export */ __webpack_exports__["a"] = (plugin);



/***/ }),
/* 186 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,n){if(true)module.exports=n();else if("function"==typeof define&&define.amd)define([],n);else{var t=n();for(var r in t)("object"==typeof exports?exports:e)[r]=t[r]}}("undefined"!=typeof self?self:this,(function(){return function(e){var n={};function t(r){if(n[r])return n[r].exports;var o=n[r]={i:r,l:!1,exports:{}};return e[r].call(o.exports,o,o.exports,t),o.l=!0,o.exports}return t.m=e,t.c=n,t.d=function(e,n,r){t.o(e,n)||Object.defineProperty(e,n,{enumerable:!0,get:r})},t.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})},t.t=function(e,n){if(1&n&&(e=t(e)),8&n)return e;if(4&n&&"object"==typeof e&&e&&e.__esModule)return e;var r=Object.create(null);if(t.r(r),Object.defineProperty(r,"default",{enumerable:!0,value:e}),2&n&&"string"!=typeof e)for(var o in e)t.d(r,o,function(n){return e[n]}.bind(null,o));return r},t.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(n,"a",n),n},t.o=function(e,n){return Object.prototype.hasOwnProperty.call(e,n)},t.p="",t(t.s=0)}([function(e,n,t){"use strict";function r(e,n){var t=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);n&&(r=r.filter((function(n){return Object.getOwnPropertyDescriptor(e,n).enumerable}))),t.push.apply(t,r)}return t}function o(e){for(var n=1;n<arguments.length;n++){var t=null!=arguments[n]?arguments[n]:{};n%2?r(t,!0).forEach((function(n){i(e,n,t[n])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(t)):r(t).forEach((function(n){Object.defineProperty(e,n,Object.getOwnPropertyDescriptor(t,n))}))}return e}function i(e,n,t){return n in e?Object.defineProperty(e,n,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[n]=t,e}t.r(n);var c={$vue:null,id:null,router:null,fields:{},customIdFields:{},ignoreRoutes:[],linkers:[],commands:{},disabled:!1,customResourceURL:null,set:[],require:[],ecommerce:{enabled:!1,options:null,enhanced:!1},autoTracking:{screenview:!1,shouldRouterUpdate:null,skipSamePath:!1,exception:!1,exceptionLogs:!0,page:!0,transformQueryString:!0,pageviewOnLoad:!0,pageviewTemplate:null,untracked:!0,prependBase:!0},debug:{enabled:!1,trace:!1,sendHitTask:!0},batch:{enabled:!1,delay:500,amount:2},checkDuplicatedScript:!1,disableScriptLoader:!1,beforeFirstHit:s,ready:s,untracked:[]},a=o({},c);function u(e){!function e(n,t){return Object.keys(t).forEach((function(r){var o=n[r]&&Object.prototype.toString.call(n[r]);"[object Object]"!==o&&"[object Array]"!==o?n[r]=t[r]:e(n[r],t[r])})),n}(a,e)}function f(){return a.id?[].concat(a.id):[]}var l=a;function s(){}var p=function(e){console.warn("[vue-analytics] ".concat(e))};function d(e,n){return new Promise((function(t,r){var o=document.head||document.getElementsByTagName("head")[0],i=document.createElement("script");if(i.async=!0,i.src=e,i.charset="utf-8",n){var c=document.createElement("link");c.href=n,c.rel="preconnect",o.appendChild(c)}o.appendChild(i),i.onload=t,i.onerror=r}))}function y(e){return e.name||e.replace(/-/gi,"")}function b(e,n){if(f().length>1){var t=y(n);return"".concat(t,".").concat(e)}return e}var m,v=function(e){if(e.then)return e;if("function"==typeof e){var n=e();return n.then?n:Promise.resolve(n)}return Promise.resolve(e)};function g(e){return function(e){if(Array.isArray(e)){for(var n=0,t=new Array(e.length);n<e.length;n++)t[n]=e[n];return t}}(e)||function(e){if(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e))return Array.from(e)}(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance")}()}var h=[];function w(e){for(var n=arguments.length,t=new Array(n>1?n-1:0),r=1;r<n;r++)t[r-1]=arguments[r];"undefined"!=typeof window&&f().forEach((function(n){var r,o={m:b(e,n),a:t};window.ga?l.batch.enabled?(h.push(o),m||(m=setInterval((function(){h.length?h.splice(0,l.batch.amount).forEach((function(e){var n;(n=window).ga.apply(n,[e.m].concat(g(e.a)))})):(clearInterval(m),m=null)}),l.batch.delay))):(r=window).ga.apply(r,[b(e,n)].concat(t)):l.untracked.push(o)}))}function O(e){return(O="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function j(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];"object"!==O(n[0])||n[0].constructor!==Object?w("set",n[0],n[1]):w("set",n[0])}function P(e,n){var t=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);n&&(r=r.filter((function(n){return Object.getOwnPropertyDescriptor(e,n).enumerable}))),t.push.apply(t,r)}return t}function S(e,n,t){return n in e?Object.defineProperty(e,n,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[n]=t,e}function k(){if(window.ga||!l.debug.enabled){if(window.ga){var e=f();l.debug.enabled&&(window.ga_debug={trace:l.debug.trace}),e.forEach((function(n){var t=y(n),r=l.customIdFields[n]||{},o=e.length>1?function(e){for(var n=1;n<arguments.length;n++){var t=null!=arguments[n]?arguments[n]:{};n%2?P(t,!0).forEach((function(n){S(e,n,t[n])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(t)):P(t).forEach((function(n){Object.defineProperty(e,n,Object.getOwnPropertyDescriptor(t,n))}))}return e}({},l.fields,{},r,{name:t}):l.fields;window.ga("create",n.id||n,"auto",o)})),l.beforeFirstHit();var n=l.ecommerce;if(n.enabled){var t=n.enhanced?"ec":"ecommerce";n.options?w("require",t,n.options):w("require",t)}l.linkers.length>0&&(w("require","linker"),w("linker:autoLink",l.linkers)),l.debug.sendHitTask||j("sendHitTask",null)}}else p("Google Analytics has probably been blocked.")}var E=function(){2!=arguments.length?w("require",arguments.length<=0?void 0:arguments[0]):w("require",arguments.length<=0?void 0:arguments[0],arguments.length<=1?void 0:arguments[1])};function A(e){return(A="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}var x=function(){var e;l.set.forEach((function(e){var n=e.field,t=e.value;if(void 0===n||void 0===t)throw new Error('[vue-analytics] Wrong configuration in the plugin options.\nThe "set" array requires each item to have a "field" and a "value" property.');j(n,t)})),e=["ec","ecommerce"],l.require.forEach((function(n){if(-1!==e.indexOf(n)||-1!==e.indexOf(n.name))throw new Error("[vue-analytics] The ecommerce features are built-in in the plugin. \nFollow the ecommerce instructions available in the documentation.");if("string"!=typeof n&&"object"!==A(n))throw new Error('[vue-analytics] Wrong configuration in the plugin options. \nThe "require" array requires each item to be a string or to have a "name" and an "options" property.');var t=n.name||n;n.options?E(t,n.options):E(t)}))};function T(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];var r=n[0];if(1===n.length&&"string"==typeof r)return w("send","screenview",{screenName:r});w.apply(void 0,["send","screenview"].concat(n))}function D(e){return(D="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function q(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];var r;n.length&&!n[0]||(n.length&&n[0].currentRoute&&(r=n[0].currentRoute),n.length&&function(e){return e.query&&e.params}(n[0])&&(r=n[0]),r?R(r):(j("page","object"===D(n[0])?n[0].page:n[0]),w.apply(void 0,["send","pageview"].concat(n))))}function R(e){if(![(n=e).name,n.path].filter(Boolean).find((function(e){return-1!==l.ignoreRoutes.indexOf(e)}))){var n,t=l.autoTracking,r=e.meta.analytics,o=(void 0===r?{}:r).pageviewTemplate||t.pageviewTemplate;if(t.screenview&&!e.name)throw new Error("[vue-analytics] Route name is mandatory when using screenview.");if(t.screenview)T(e.name);else if(o)q(o(e));else{var i=l.router,c=l.autoTracking,a=c.transformQueryString,u=c.prependBase,f=function(e){var n=Object.keys(e).reduce((function(n,t,r,o){var i=r===o.length-1,c=e[t];return null==c?n:n+="".concat(t,"=").concat(c).concat(i?"":"&")}),"");return""!==n?"?".concat(n):""}(e.query),s=i&&i.options.base,p=u&&s,d=e.path+(a?f:"");q(d=p?function(e,n){var t=n.split("/"),r=e.split("/");return""===t[0]&&"/"===e[e.length-1]&&t.shift(),r.join("/")+t.join("/")}(s,d):d)}}}function I(e){return function(e){if(Array.isArray(e)){for(var n=0,t=new Array(e.length);n<e.length;n++)t[n]=e[n];return t}}(e)||function(e){if(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e))return Array.from(e)}(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance")}()}var L=function(){var e=!(arguments.length>0&&void 0!==arguments[0])||arguments[0];"undefined"!=typeof window&&f().forEach((function(n){window["ga-disable-".concat(n)]=e}))},_=function(){if("undefined"!=typeof document&&"undefined"!=typeof window){if(l.id){var e,n,t=[v(l.id),v(l.disabled)];if(e=l.checkDuplicatedScript,n=l.disableScriptLoader,[Boolean(window&&window.ga),e&&!(Array.prototype.slice.call(document.getElementsByTagName("script")).filter((function(e){return-1!==e.src.indexOf("analytics")||-1!==e.src.indexOf("gtag")})).length>0),!n].some(Boolean)){var r="https://www.google-analytics.com",o=l.debug.enabled?"analytics_debug":"analytics",i=l.customResourceURL?d(l.customResourceURL):d("".concat(r,"/").concat(o,".js"),r);t.push(i.catch((function(){p("An error occured! Please check your connection or disable your AD blocker")})))}return Promise.all(t).then((function(e){var n,t,r;u({id:e[0],disabled:e[1]}),L(l.disabled),k(),x(),l.untracked.forEach((function(e){w.apply(void 0,[e.m].concat(I(e.a)))})),n=l.router,t=l.autoTracking,r=l.$vue,t.page&&n&&n.onReady((function(){t.pageviewOnLoad&&n.history.ready&&R(n.currentRoute),n.afterEach((function(e,o){var i=t.skipSamePath,c=t.shouldRouterUpdate;i&&e.path===o.path||("function"!=typeof c||c(e,o))&&r.nextTick().then((function(){R(n.currentRoute)}))}))})),l.ready()})).catch((function(e){l.debug.enabled&&p(e.message)}))}p('Missing the "id" parameter. Add at least one tracking domain ID')}};var B=function(e){var n=arguments.length>1&&void 0!==arguments[1]&&arguments[1];w("send","exception",{exDescription:e,exFatal:n})},H=function(e){if(l.autoTracking.exception){window.addEventListener("error",(function(e){B(e.message)}));var n=e.config.errorHandler;e.config.errorHandler=function(e,t,r){B(e.message),l.autoTracking.exceptionLogs&&console.error(e),"function"==typeof n&&n.call(void 0,e,t,r)}}},F=B;function M(e,n){var t=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);n&&(r=r.filter((function(n){return Object.getOwnPropertyDescriptor(e,n).enumerable}))),t.push.apply(t,r)}return t}function U(e,n,t){return n in e?Object.defineProperty(e,n,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[n]=t,e}var $=function(e){return"".concat(l.ecommerce.enhanced?"ec":"ecommerce",":").concat(e)},C=["addItem","addTransaction","addProduct","addImpression","setAction","addPromo","send"].reduce((function(e,n){return function(e){for(var n=1;n<arguments.length;n++){var t=null!=arguments[n]?arguments[n]:{};n%2?M(t,!0).forEach((function(n){U(e,n,t[n])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(t)):M(t).forEach((function(n){Object.defineProperty(e,n,Object.getOwnPropertyDescriptor(t,n))}))}return e}({},e,U({},n,(function(){for(var e=arguments.length,t=new Array(e),r=0;r<e;r++)t[r]=arguments[r];w.apply(void 0,[$(n)].concat(t))})))}),{}),N={event:function(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];w.apply(void 0,["send","event"].concat(n))},exception:F,page:q,query:w,require:E,set:j,social:function(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];w.apply(void 0,["send","social"].concat(n))},time:function(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];w.apply(void 0,["send","timing"].concat(n))},screenview:T,ecommerce:C,disable:function(){return L(!0)},enable:function(){return L(!1)},commands:l.commands},Q={inserted:function(e,n,t){var r=Object.keys(n.modifiers);0===r.length&&r.push("click"),r.forEach((function(r){e.addEventListener(r,(function(){var e="string"==typeof n.value?l.commands[n.value]:n.value;if(!e)throw new Error("[vue-analytics] The value passed to v-ga is not defined in the commands list.");e.apply(t.context)}))}))}};function W(e){return function(e){if(Array.isArray(e)){for(var n=0,t=new Array(e.length);n<e.length;n++)t[n]=e[n];return t}}(e)||function(e){if(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e))return Array.from(e)}(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance")}()}function G(e,n){return function(e){if(Array.isArray(e))return e}(e)||function(e,n){if(!(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e)))return;var t=[],r=!0,o=!1,i=void 0;try{for(var c,a=e[Symbol.iterator]();!(r=(c=a.next()).done)&&(t.push(c.value),!n||t.length!==n);r=!0);}catch(e){o=!0,i=e}finally{try{r||null==a.return||a.return()}finally{if(o)throw i}}return t}(e,n)||function(){throw new TypeError("Invalid attempt to destructure non-iterable instance")}()}function z(e,n){var t=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);n&&(r=r.filter((function(n){return Object.getOwnPropertyDescriptor(e,n).enumerable}))),t.push.apply(t,r)}return t}function J(e,n,t){return n in e?Object.defineProperty(e,n,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[n]=t,e}function K(e){u(function(e){for(var n=1;n<arguments.length;n++){var t=null!=arguments[n]?arguments[n]:{};n%2?z(t,!0).forEach((function(n){J(e,n,t[n])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(t)):z(t).forEach((function(n){Object.defineProperty(e,n,Object.getOwnPropertyDescriptor(t,n))}))}return e}({},arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},{$vue:e})),e.directive("ga",Q),e.prototype.$ga=e.$ga=N,H(e),_()}t.d(n,"default",(function(){return K})),t.d(n,"analyticsMiddleware",(function(){return V})),t.d(n,"onAnalyticsReady",(function(){return X})),t.d(n,"event",(function(){return Y})),t.d(n,"ecommerce",(function(){return Z})),t.d(n,"set",(function(){return ee})),t.d(n,"page",(function(){return ne})),t.d(n,"query",(function(){return te})),t.d(n,"screenview",(function(){return re})),t.d(n,"time",(function(){return oe})),t.d(n,"require",(function(){return ie})),t.d(n,"exception",(function(){return ce})),t.d(n,"social",(function(){return ae}));var V=function(e){e.subscribe((function(e){var n=e.payload;if(n&&n.meta&&n.meta.analytics){var t=n.meta.analytics;if(!Array.isArray(t))throw new Error('The "analytics" property needs to be an array');t.forEach((function(e){var n,t,r=e.shift(),o=e;if(r.includes(":")){var i=G(r.split(":"),2);r=i[0],n=i[1]}if(!(r in N))throw new Error('[vue-analytics:vuex] The type "'.concat(r,"\" doesn't exist."));if(n&&!(n in N[r]))throw new Error('[vue-analytics:vuex] The type "'.concat(r,'" has not method "').concat(n,'".'));if("ecommerce"===r&&!n)throw new Error('[vue-analytics:vuex] The type "'.concat(r,'" needs to call a method. Check documentation.'));n?(t=N[r])[n].apply(t,W(o)):N[r].apply(N,W(o))}))}}))},X=function(){return new Promise((function(e,n){var t=setInterval((function(){"undefined"!=typeof window&&window.ga&&(e(),clearInterval(t))}),10)}))},Y=N.event,Z=N.ecommerce,ee=N.set,ne=N.page,te=N.query,re=N.screenview,oe=N.time,ie=N.require,ce=N.exception,ae=N.social}])}));

/***/ })
],[16]);


// WEBPACK FOOTER //
// js/app.f0e7b1faf2203210d586.js